// Generated by purs bundle 0.14.1
var PS = {};
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["AppAction"] = $PS["AppAction"] || {};
  var exports = $PS["AppAction"];
  var Initialize = (function () {
      function Initialize() {

      };
      Initialize.value = new Initialize();
      return Initialize;
  })();
  var Finalize = (function () {
      function Finalize() {

      };
      Finalize.value = new Finalize();
      return Finalize;
  })();
  var HeartbeatTick = (function () {
      function HeartbeatTick() {

      };
      HeartbeatTick.value = new HeartbeatTick();
      return HeartbeatTick;
  })();
  var StartNewGame = (function () {
      function StartNewGame() {

      };
      StartNewGame.value = new StartNewGame();
      return StartNewGame;
  })();
  var WritePlayerIndex = (function () {
      function WritePlayerIndex(value0) {
          this.value0 = value0;
      };
      WritePlayerIndex.create = function (value0) {
          return new WritePlayerIndex(value0);
      };
      return WritePlayerIndex;
  })();
  var WritePlayerCount = (function () {
      function WritePlayerCount(value0) {
          this.value0 = value0;
      };
      WritePlayerCount.create = function (value0) {
          return new WritePlayerCount(value0);
      };
      return WritePlayerCount;
  })();
  var LoadGameRequest = (function () {
      function LoadGameRequest() {

      };
      LoadGameRequest.value = new LoadGameRequest();
      return LoadGameRequest;
  })();
  var ToggleMenu = (function () {
      function ToggleMenu() {

      };
      ToggleMenu.value = new ToggleMenu();
      return ToggleMenu;
  })();
  var ToggleLongGame = (function () {
      function ToggleLongGame() {

      };
      ToggleLongGame.value = new ToggleLongGame();
      return ToggleLongGame;
  })();
  var RandomizeKingdom = (function () {
      function RandomizeKingdom() {

      };
      RandomizeKingdom.value = new RandomizeKingdom();
      return RandomizeKingdom;
  })();
  var ChooseKingdom = (function () {
      function ChooseKingdom(value0) {
          this.value0 = value0;
      };
      ChooseKingdom.create = function (value0) {
          return new ChooseKingdom(value0);
      };
      return ChooseKingdom;
  })();
  var WriteServerUrl = (function () {
      function WriteServerUrl(value0) {
          this.value0 = value0;
      };
      WriteServerUrl.create = function (value0) {
          return new WriteServerUrl(value0);
      };
      return WriteServerUrl;
  })();
  var WriteUsername = (function () {
      function WriteUsername(value0) {
          this.value0 = value0;
      };
      WriteUsername.create = function (value0) {
          return new WriteUsername(value0);
      };
      return WriteUsername;
  })();
  var Write = (function () {
      function Write(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Write.create = function (value0) {
          return function (value1) {
              return new Write(value0, value1);
          };
      };
      return Write;
  })();
  var SendMessage = (function () {
      function SendMessage() {

      };
      SendMessage.value = new SendMessage();
      return SendMessage;
  })();
  var ReceiveRemoteMessage = (function () {
      function ReceiveRemoteMessage(value0) {
          this.value0 = value0;
      };
      ReceiveRemoteMessage.create = function (value0) {
          return new ReceiveRemoteMessage(value0);
      };
      return ReceiveRemoteMessage;
  })();
  var HandleGameEvent = (function () {
      function HandleGameEvent(value0) {
          this.value0 = value0;
      };
      HandleGameEvent.create = function (value0) {
          return new HandleGameEvent(value0);
      };
      return HandleGameEvent;
  })();
  var DoNothing = (function () {
      function DoNothing() {

      };
      DoNothing.value = new DoNothing();
      return DoNothing;
  })();
  exports["Initialize"] = Initialize;
  exports["Finalize"] = Finalize;
  exports["HeartbeatTick"] = HeartbeatTick;
  exports["StartNewGame"] = StartNewGame;
  exports["WritePlayerIndex"] = WritePlayerIndex;
  exports["WritePlayerCount"] = WritePlayerCount;
  exports["LoadGameRequest"] = LoadGameRequest;
  exports["ToggleMenu"] = ToggleMenu;
  exports["ToggleLongGame"] = ToggleLongGame;
  exports["RandomizeKingdom"] = RandomizeKingdom;
  exports["ChooseKingdom"] = ChooseKingdom;
  exports["WriteServerUrl"] = WriteServerUrl;
  exports["WriteUsername"] = WriteUsername;
  exports["Write"] = Write;
  exports["SendMessage"] = SendMessage;
  exports["ReceiveRemoteMessage"] = ReceiveRemoteMessage;
  exports["HandleGameEvent"] = HandleGameEvent;
  exports["DoNothing"] = DoNothing;
})(PS);
(function(exports) {
  "use strict";

  exports.arrayMap = function (f) {
    return function (arr) {
      var l = arr.length;
      var result = new Array(l);
      for (var i = 0; i < l; i++) {
        result[i] = f(arr[i]);
      }
      return result;
    };
  };
})(PS["Data.Functor"] = PS["Data.Functor"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Semigroupoid"] = $PS["Control.Semigroupoid"] || {};
  var exports = $PS["Control.Semigroupoid"];
  var Semigroupoid = function (compose) {
      this.compose = compose;
  };
  var semigroupoidFn = new Semigroupoid(function (f) {
      return function (g) {
          return function (x) {
              return f(g(x));
          };
      };
  });
  var compose = function (dict) {
      return dict.compose;
  };
  var composeFlipped = function (dictSemigroupoid) {
      return function (f) {
          return function (g) {
              return compose(dictSemigroupoid)(g)(f);
          };
      };
  };
  exports["compose"] = compose;
  exports["composeFlipped"] = composeFlipped;
  exports["semigroupoidFn"] = semigroupoidFn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Function"] = $PS["Data.Function"] || {};
  var exports = $PS["Data.Function"];
  var flip = function (f) {
      return function (b) {
          return function (a) {
              return f(a)(b);
          };
      };
  };
  var $$const = function (a) {
      return function (v) {
          return a;
      };
  };
  exports["flip"] = flip;
  exports["const"] = $$const;
})(PS);
(function(exports) {
  "use strict";

  exports.unit = {};
})(PS["Data.Unit"] = PS["Data.Unit"] || {});
(function(exports) {
  "use strict";

  exports.showIntImpl = function (n) {
    return n.toString();
  };

  exports.showStringImpl = function (s) {
    var l = s.length;
    return "\"" + s.replace(
      /[\0-\x1F\x7F"\\]/g, // eslint-disable-line no-control-regex
      function (c, i) {
        switch (c) {
          case "\"":
          case "\\":
            return "\\" + c;
          case "\x07": return "\\a";
          case "\b": return "\\b";
          case "\f": return "\\f";
          case "\n": return "\\n";
          case "\r": return "\\r";
          case "\t": return "\\t";
          case "\v": return "\\v";
        }
        var k = i + 1;
        var empty = k < l && s[k] >= "0" && s[k] <= "9" ? "\\&" : "";
        return "\\" + c.charCodeAt(0).toString(10) + empty;
      }
    ) + "\"";
  };

  exports.showArrayImpl = function (f) {
    return function (xs) {
      var ss = [];
      for (var i = 0, l = xs.length; i < l; i++) {
        ss[i] = f(xs[i]);
      }
      return "[" + ss.join(",") + "]";
    };
  };

  exports.cons = function (head) {
    return function (tail) {
      return [head].concat(tail);
    };
  };

  exports.join = function (separator) {
    return function (xs) {
      return xs.join(separator);
    };
  };
})(PS["Data.Show"] = PS["Data.Show"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Symbol"] = $PS["Data.Symbol"] || {};
  var exports = $PS["Data.Symbol"];                  
  var SProxy = (function () {
      function SProxy() {

      };
      SProxy.value = new SProxy();
      return SProxy;
  })();
  var IsSymbol = function (reflectSymbol) {
      this.reflectSymbol = reflectSymbol;
  };
  var reflectSymbol = function (dict) {
      return dict.reflectSymbol;
  };
  exports["IsSymbol"] = IsSymbol;
  exports["reflectSymbol"] = reflectSymbol;
  exports["SProxy"] = SProxy;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeGet = function (label) {
    return function (rec) {
      return rec[label];
    };
  };

  exports.unsafeSet = function (label) {
    return function (value) {
      return function (rec) {
        var copy = {};
        for (var key in rec) {
          if ({}.hasOwnProperty.call(rec, key)) {
            copy[key] = rec[key];
          }
        }
        copy[label] = value;
        return copy;
      };
    };
  };
})(PS["Record.Unsafe"] = PS["Record.Unsafe"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Record.Unsafe"] = $PS["Record.Unsafe"] || {};
  var exports = $PS["Record.Unsafe"];
  var $foreign = $PS["Record.Unsafe"];
  exports["unsafeGet"] = $foreign.unsafeGet;
  exports["unsafeSet"] = $foreign.unsafeSet;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Type.Proxy"] = $PS["Type.Proxy"] || {};
  var exports = $PS["Type.Proxy"];
  var $$Proxy = (function () {
      function $$Proxy() {

      };
      $$Proxy.value = new $$Proxy();
      return $$Proxy;
  })();
  exports["Proxy"] = $$Proxy;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Show"] = $PS["Data.Show"] || {};
  var exports = $PS["Data.Show"];
  var $foreign = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Record_Unsafe = $PS["Record.Unsafe"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var ShowRecordFields = function (showRecordFields) {
      this.showRecordFields = showRecordFields;
  };
  var Show = function (show) {
      this.show = show;
  };
  var showString = new Show($foreign.showStringImpl);
  var showRecordFieldsNil = new ShowRecordFields(function (v) {
      return function (v1) {
          return [  ];
      };
  });
  var showRecordFields = function (dict) {
      return dict.showRecordFields;
  };
  var showRecord = function (dictRowToList) {
      return function (dictShowRecordFields) {
          return new Show(function (record) {
              var v = showRecordFields(dictShowRecordFields)(Type_Proxy["Proxy"].value)(record);
              if (v.length === 0) {
                  return "{}";
              };
              return $foreign.join(" ")([ "{", $foreign.join(", ")(v), "}" ]);
          });
      };
  };                                                 
  var showInt = new Show($foreign.showIntImpl);  
  var showBoolean = new Show(function (v) {
      if (v) {
          return "true";
      };
      if (!v) {
          return "false";
      };
      throw new Error("Failed pattern match at Data.Show (line 20, column 1 - line 22, column 23): " + [ v.constructor.name ]);
  });
  var show = function (dict) {
      return dict.show;
  };
  var showArray = function (dictShow) {
      return new Show($foreign.showArrayImpl(show(dictShow)));
  };
  var showRecordFieldsCons = function (dictIsSymbol) {
      return function (dictShowRecordFields) {
          return function (dictShow) {
              return new ShowRecordFields(function (v) {
                  return function (record) {
                      var tail = showRecordFields(dictShowRecordFields)(Type_Proxy["Proxy"].value)(record);
                      var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                      var focus = Record_Unsafe.unsafeGet(key)(record);
                      return $foreign.cons($foreign.join(": ")([ key, show(dictShow)(focus) ]))(tail);
                  };
              });
          };
      };
  };
  exports["Show"] = Show;
  exports["show"] = show;
  exports["showBoolean"] = showBoolean;
  exports["showInt"] = showInt;
  exports["showString"] = showString;
  exports["showArray"] = showArray;
  exports["showRecord"] = showRecord;
  exports["showRecordFieldsNil"] = showRecordFieldsNil;
  exports["showRecordFieldsCons"] = showRecordFieldsCons;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Unit"] = $PS["Data.Unit"] || {};
  var exports = $PS["Data.Unit"];
  var $foreign = $PS["Data.Unit"];
  var Data_Show = $PS["Data.Show"];                
  var showUnit = new Data_Show.Show(function (v) {
      return "unit";
  });
  exports["showUnit"] = showUnit;
  exports["unit"] = $foreign.unit;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Functor"] = $PS["Data.Functor"] || {};
  var exports = $PS["Data.Functor"];
  var $foreign = $PS["Data.Functor"];
  var Control_Semigroupoid = $PS["Control.Semigroupoid"];
  var Data_Function = $PS["Data.Function"];
  var Data_Unit = $PS["Data.Unit"];                  
  var Functor = function (map) {
      this.map = map;
  };
  var map = function (dict) {
      return dict.map;
  };
  var mapFlipped = function (dictFunctor) {
      return function (fa) {
          return function (f) {
              return map(dictFunctor)(f)(fa);
          };
      };
  };
  var $$void = function (dictFunctor) {
      return map(dictFunctor)(Data_Function["const"](Data_Unit.unit));
  };
  var voidLeft = function (dictFunctor) {
      return function (f) {
          return function (x) {
              return map(dictFunctor)(Data_Function["const"](x))(f);
          };
      };
  };
  var voidRight = function (dictFunctor) {
      return function (x) {
          return map(dictFunctor)(Data_Function["const"](x));
      };
  }; 
  var functorFn = new Functor(Control_Semigroupoid.compose(Control_Semigroupoid.semigroupoidFn));
  var functorArray = new Functor($foreign.arrayMap);
  exports["Functor"] = Functor;
  exports["map"] = map;
  exports["mapFlipped"] = mapFlipped;
  exports["void"] = $$void;
  exports["voidRight"] = voidRight;
  exports["voidLeft"] = voidLeft;
  exports["functorFn"] = functorFn;
  exports["functorArray"] = functorArray;
})(PS);
(function(exports) {
  // This Source Code Form is subject to the terms of the Mozilla Public
  // License, v. 2.0. If a copy of the MPL was not distributed with this
  // file, You can obtain one at http://mozilla.org/MPL/2.0/.

  "use strict";

  /** @constructor */
  function MapNode(datamap, nodemap, content) {
      this.datamap = datamap;
      this.nodemap = nodemap;
      this.content = content;
  }

  MapNode.prototype.lookup = function lookup(Nothing, Just, keyEquals, key, keyHash, shift) {
      var bit = mask(keyHash, shift);
      if ((this.datamap & bit) !== 0) {
          var i = index(this.datamap, bit);
          if (keyEquals(key)(this.content[i * 2]))
              return new Just(this.content[i * 2 + 1]);
          return Nothing;
      }
      if ((this.nodemap & bit) !== 0) {
          return this.content[this.content.length - 1 - index(this.nodemap, bit)].lookup(Nothing, Just, keyEquals, key, keyHash, shift + 5);
      }
      return Nothing;
  }

  function remove2insert1Mut(a, removeIndex, insertIndex, v1) {
      for (var i = removeIndex; i < insertIndex; i++) a[i] = a[i+2];
      a[i++] = v1;
      for (; i < a.length - 1; i++) a[i] = a[i+1];
      a.length = a.length - 1;
  }

  MapNode.prototype.insertMut = function insertMut(keyEquals, hashFunction, key, keyHash, value, shift) {
      var bit = mask(keyHash, shift);
      var i = index(this.datamap, bit);
      if ((this.datamap & bit) !== 0) {
          var k = this.content[i * 2];
          if (keyEquals(k)(key)) {
              this.content[i*2+1] = value;
          } else {
              var newNode = binaryNode(k, hashFunction(k), this.content[i*2+1], key, keyHash, value, shift + 5);
              this.datamap = this.datamap ^ bit;
              this.nodemap = this.nodemap | bit;
              remove2insert1Mut(this.content, i*2, this.content.length - index(this.nodemap, bit) - 2, newNode);
          }
      } else if ((this.nodemap & bit) !== 0) {
          var n = this.content.length - 1 - index(this.nodemap, bit);
          this.content[n].insertMut(keyEquals, hashFunction, key, keyHash, value, shift + 5);
      } else {
          this.datamap = this.datamap | bit;
          this.content.splice(i*2, 0, key, value);
      }
  }

  MapNode.prototype.insert = function insert(keyEquals, hashFunction, key, keyHash, value, shift) {
      var bit = mask(keyHash, shift);
      var i = index(this.datamap, bit);
      if ((this.datamap & bit) !== 0) {
          var k = this.content[i * 2];
          if (keyEquals(k)(key))
              return new MapNode(this.datamap, this.nodemap, overwriteTwoElements(this.content, i*2, key, value));
          var newNode = binaryNode(k, hashFunction(k), this.content[i*2+1], key, keyHash, value, shift + 5);
          return new MapNode(this.datamap ^ bit, this.nodemap | bit, remove2insert1(this.content, i * 2, this.content.length - index(this.nodemap, bit) - 2, newNode));
      }
      if ((this.nodemap & bit) !== 0) {
          var n = this.content.length - 1 - index(this.nodemap, bit);
          return new MapNode(this.datamap, this.nodemap,
                             copyAndOverwriteOrExtend1(this.content, n,
                                              this.content[n].insert(keyEquals, hashFunction, key, keyHash, value, shift + 5)));
      }
      return new MapNode(this.datamap | bit, this.nodemap, insert2(this.content, i*2, key, value));
  }

  MapNode.prototype.insertWith = function insertWith(keyEquals, hashFunction, f, key, keyHash, value, shift) {
      var bit = mask(keyHash, shift);
      var i = index(this.datamap, bit);
      if ((this.datamap & bit) !== 0) {
          var k = this.content[i * 2];
          if (keyEquals(k)(key))
              return new MapNode(this.datamap, this.nodemap, overwriteTwoElements(this.content, i*2, key, f(this.content[i*2+1])(value)));
          var newNode = binaryNode(k, hashFunction(k), this.content[i*2+1], key, keyHash, value, shift + 5);
          return new MapNode(this.datamap ^ bit, this.nodemap | bit, remove2insert1(this.content, i * 2, this.content.length - index(this.nodemap, bit) - 2, newNode));
      }
      if ((this.nodemap & bit) !== 0) {
          var n = this.content.length - 1 - index(this.nodemap, bit);
          return new MapNode(this.datamap, this.nodemap,
                             copyAndOverwriteOrExtend1(this.content, n,
                                              this.content[n].insertWith(keyEquals, hashFunction, f, key, keyHash, value, shift + 5)));
      }
      return new MapNode(this.datamap | bit, this.nodemap, insert2(this.content, i*2, key, value));
  }

  MapNode.prototype.delet = function delet(keyEquals, key, keyHash, shift) {
      var bit = mask(keyHash, shift);
      if ((this.datamap & bit) !== 0) {
          var dataIndex = index(this.datamap, bit);
          if (keyEquals(this.content[dataIndex*2])(key)) {
              if (this.nodemap === 0 && this.content.length === 2) return empty;
              return new MapNode(this.datamap ^ bit, this.nodemap, remove2(this.content, dataIndex * 2));
          }
          return this;
      }
      if ((this.nodemap & bit) !== 0) {
          var nodeIndex = index(this.nodemap,bit);
          var recNode = this.content[this.content.length - 1 - nodeIndex];
          var recRes = recNode.delet(keyEquals, key, keyHash, shift + 5);
          if (recNode === recRes) return this;
          if (recRes.isSingleton()) {
              if (this.content.length === 1) {
                  recRes.datamap = this.nodemap;
                  return recRes;
              }
              return new MapNode(this.datamap | bit, this.nodemap ^ bit,
                                 insert2remove1(this.content, 2 * index(this.datamap, bit), recRes.content[0], recRes.content[1], this.content.length - 1 - nodeIndex));
          }
          return new MapNode(this.datamap, this.nodemap, copyAndOverwriteOrExtend1(this.content, this.content.length - 1 - nodeIndex, recRes));
      }
      return this;
  }

  MapNode.prototype.toArrayBy = function (f, res) {
      for (var i = 0; i < popCount(this.datamap) * 2;) {
          var k = this.content[i++];
          var v = this.content[i++];
          res.push(f(k)(v));
      }
      for (; i < this.content.length; i++)
          this.content[i].toArrayBy(f, res);
  }

  MapNode.prototype.isSingleton = function () {
      return this.nodemap === 0 && this.content.length === 2;
  }

  MapNode.prototype.eq = function(kf, vf, that) {
      if (this === that) return true;
      if (this.constructor !== that.constructor || this.nodemap !== that.nodemap || this.datamap !== that.datamap) return false;
      for (var i = 0; i < popCount(this.datamap) * 2;) {
          if (kf(this.content[i])(that.content[i])) i++; else return false;
          if (vf(this.content[i])(that.content[i])) i++; else return false;
      }
      for (; i < this.content.length; i++)
          if (!this.content[i].eq(kf, vf, that.content[i])) return false;
      return true;
  }

  MapNode.prototype.hash = function (vhash) {
      var h = this.datamap;
      for (var i = 0; i < popCount(this.datamap); i++)
          h = (h * 31 + vhash(this.content[i * 2 + 1])) | 0;
      for (var j = 0; j < popCount(this.nodemap); j++)
          h = (h * 31 + this.content[this.content.length - j - 1].hash(vhash)) | 0;
      return h;
  }

  MapNode.prototype.size = function () {
      var res = popCount(this.datamap);
      for (var i = res * 2; i < this.content.length; i++) res += this.content[i].size();
      return res;
  }

  MapNode.prototype.imap = function (f) {
      var newContent = this.content.slice();
      for (var i = 0; i < popCount(this.datamap) * 2;) {
          var k = this.content[i++];
          var v = this.content[i++];
          newContent[i-2] = k;
          newContent[i-1] = f(k)(v);
      }
      for (; i < this.content.length; i++)
          newContent[i] = this.content[i].imap(f);
      return new MapNode(this.datamap, this.nodemap, newContent);
  }

  MapNode.prototype.ifoldMap = function (m, mappend, f) {
      for (var i = 0; i < popCount(this.datamap) * 2;) {
          var k = this.content[i++];
          var v = this.content[i++];
          m = mappend(m)(f(k)(v));
      }
      for (; i < this.content.length; i++)
          m = this.content[i].ifoldMap(m, mappend, f);
      return m;
  }

  function lowestBit(n) { return n & -n; }

  function mergeState(bit, thisnode, thisdata, thatnode, thatdata) {
      /* Returns one of these constants:

       const NONE_NONE = 0;
       const NODE_NONE = 1;
       const DATA_NONE = 2;
       const NONE_NODE = 4;
       const NONE_DATA = 8;
       const DATA_NODE = DATA_NONE | NONE_NODE;
       const NODE_DATA = NODE_NONE | NONE_DATA;
       const DATA_DATA = DATA_NONE | NONE_DATA;
       const NODE_NODE = NODE_NONE | NONE_NODE;

       I would love to declare them in the file, but purs compile
       complains about `const` and purs bundle removes variables.
    */  

      var state = 0;
      state |= (bit & thisnode) !== 0 ? 1 : 0;
      state |= (bit & thisdata) !== 0 ? 2 : 0;
      state |= (bit & thatnode) !== 0 ? 4 : 0;
      state |= (bit & thatdata) !== 0 ? 8 : 0;
      return state;
  }

  MapNode.prototype.unionWith = function (eq, hash, f, that, shift) {
      if (this.constructor !== that.constructor)
          throw "Trying to union a MapNode with something else";

      // I'd rather declare these locally in the branches, but purs
      // compile complains about `const`.
      var thisDataIndex, thatDataIndex, thisNodeIndex, thatNodeIndex;

      var datamap = 0;
      var nodemap = 0;
      var data = [];
      var nodes = [];

      // Conceptually, we go through all of the 32 bits in the result
      // and then handle the (in/notin + left/right + data/node)
      // combinations. With this clever trick, we get to skip the 0 bits.
      var skipmap = this.datamap | this.nodemap | that.datamap | that.nodemap;
      while (skipmap !== 0) {
          var bit = lowestBit(skipmap);
          skipmap &= ~bit;

          switch (mergeState(bit, this.nodemap, this.datamap, that.nodemap, that.datamap)) {
          case 1 /* NODE_NONE */:
              thisNodeIndex = index(this.nodemap, bit);
              nodemap |= bit;
              nodes.push(this.content[this.content.length - thisNodeIndex - 1]);
              break;
          case 2 /* DATA_NONE */:
              thisDataIndex = index(this.datamap, bit);
              datamap |= bit;
              data.push(this.content[thisDataIndex * 2], this.content[thisDataIndex * 2 + 1]);
              break;
          case 4 /* NONE_NODE */:
              thatNodeIndex = index(that.nodemap, bit);
              nodemap |= bit;
              nodes.push(that.content[that.content.length - thatNodeIndex - 1]);
              break;
          case 5 /* NODE_NODE */:
              thisNodeIndex = index(this.nodemap, bit);
              thatNodeIndex = index(that.nodemap, bit);
              nodemap |= bit;
              nodes.push(
                  this.content[this.content.length - thisNodeIndex - 1].
                       unionWith(eq, hash, f, that.content[that.content.length - thatNodeIndex - 1], shift + 5));
              break;
          case 6 /* DATA_NODE */:
              thisDataIndex = index(this.datamap, bit);
              thatNodeIndex = index(that.nodemap, bit);
              var k = this.content[thisDataIndex * 2];
              var v = this.content[thisDataIndex * 2 + 1];
              var hk = hash(k);
              var flippedF = function (a) { return function (b) { return f(b)(a); }; };
              nodemap |= bit;
              nodes.push(that.content[that.content.length - thatNodeIndex - 1].insertWith(eq, hash, flippedF, k, hk, v, shift + 5));
              break;
          case 8 /* NONE_DATA */:
              thatDataIndex = index(that.datamap, bit);
              datamap |= bit;
              data.push(that.content[thatDataIndex * 2], that.content[thatDataIndex * 2 + 1]);
              break;
          case 9 /* NODE_DATA */:
              thatDataIndex = index(that.datamap, bit);
              thisNodeIndex = index(this.nodemap, bit);
              var k = that.content[thatDataIndex * 2];
              var v = that.content[thatDataIndex * 2 + 1];
              var hk = hash(k);
              nodemap |= bit;
              nodes.push(this.content[this.content.length - thisNodeIndex - 1].insertWith(eq, hash, f, k, hk, v, shift + 5));
              break;
          case 10 /* DATA_DATA */:
              thisDataIndex = index(this.datamap, bit);
              thatDataIndex = index(that.datamap, bit);
              if (eq(this.content[thisDataIndex * 2])(that.content[thatDataIndex * 2])) {
                  // equal, merge with f
                  datamap |= bit;
                  data.push(this.content[thisDataIndex * 2], f(this.content[thisDataIndex * 2 + 1])(that.content[thatDataIndex * 2 + 1]));
              } else {
                  // key hashes equal at this level, merge into node
                  nodemap |= bit;
                  nodes.push(binaryNode(
                      this.content[thisDataIndex * 2],
                      hash(this.content[thisDataIndex * 2]),
                      this.content[thisDataIndex*2+1],
                      that.content[thatDataIndex * 2],
                      hash(that.content[thatDataIndex * 2]),
                      that.content[thatDataIndex*2+1],
                      shift + 5));
              }
              break;
          }
      }
      return new MapNode(datamap, nodemap, data.concat(nodes.reverse()));
  }

  MapNode.prototype.intersectionWith = function (Nothing, Just, eq, hash, f, that, shift) {
      if (this.constructor !== that.constructor)
          throw "Trying to intersect a MapNode with something else";

      // I'd rather declare these locally in the branches, but purs
      // compile complains about `const`.
      var thisDataIndex, thatDataIndex, thisNodeIndex, thatNodeIndex;

      var datamap = 0;
      var nodemap = 0;
      var data = [];
      var nodes = [];

      // Conceptually, we go through all of the 32 bits in the result
      // and then handle the (in/notin + left/right + data/node)
      // combinations. With this clever trick, we get to skip the 0 bits.
      var skipmap = (this.datamap | this.nodemap) & (that.datamap | that.nodemap);
      while (skipmap !== 0) {
          var bit = lowestBit(skipmap);
          skipmap &= ~bit;

          switch (mergeState(bit, this.nodemap, this.datamap, that.nodemap, that.datamap)) {
          case 5 /* NODE_NODE */:
              thisNodeIndex = index(this.nodemap, bit);
              thatNodeIndex = index(that.nodemap, bit);
              var recRes = this.content[this.content.length - thisNodeIndex - 1].
                   intersectionWith(Nothing, Just, eq, hash, f, that.content[that.content.length - thatNodeIndex - 1], shift + 5);
              if (isEmpty(recRes)) continue;
              if (recRes.isSingleton()) {
                  datamap |= bit;
                  data.push(recRes.content[0], recRes.content[1]);
              } else {
                  nodemap |= bit;
                  nodes.push(recRes);
              }
              break;
          case 6 /* DATA_NODE */:
              thisDataIndex = index(this.datamap, bit);
              thatNodeIndex = index(that.nodemap, bit);
              var k = this.content[thisDataIndex * 2];
              var v = this.content[thisDataIndex * 2 + 1];
              var hk = hash(k);
              var res = that.content[that.content.length - thatNodeIndex - 1].lookup(Nothing, Just, eq, k, hk, shift + 5);
              if (res !== Nothing) {
                  datamap |= bit;
                  data.push(k, f(v)(res.value0));
              }
              break;
          case 9 /* NODE_DATA */:
              thatDataIndex = index(that.datamap, bit);
              thisNodeIndex = index(this.nodemap, bit);
              var k = that.content[thatDataIndex * 2];
              var v = that.content[thatDataIndex * 2 + 1];
              var hk = hash(k);
              var res = this.content[this.content.length - thisNodeIndex - 1].lookup(Nothing, Just, eq, k, hk, shift + 5);
              if (res !== Nothing) {
                  datamap |= bit;
                  data.push(k, f(res.value0)(v));
              }
              break;
          case 10 /* DATA_DATA */:
              thisDataIndex = index(this.datamap, bit);
              thatDataIndex = index(that.datamap, bit);
              if (eq(this.content[thisDataIndex * 2])(that.content[thatDataIndex * 2])) {
                  datamap |= bit;
                  data.push(this.content[thisDataIndex * 2], f(this.content[thisDataIndex * 2 + 1])(that.content[thatDataIndex * 2 + 1]));
              }
              break;
          }
      }
      return new MapNode(datamap, nodemap, data.concat(nodes.reverse()));
  }

  MapNode.prototype.filterWithKey = function filterWithKey(f) {
      var datamap = 0;
      var nodemap = 0;
      var data = [];
      var nodes = [];
      var skipmap = this.datamap | this.nodemap;
      while (skipmap !== 0) {
          var bit = lowestBit(skipmap);
          skipmap &= ~bit;
          if ((this.datamap & bit) !== 0) {
              var dataIndex = index(this.datamap, bit);
              var k = this.content[dataIndex * 2];
              var v = this.content[dataIndex * 2 + 1];
              if (f(k)(v)) {
                  datamap |= bit;
                  data.push(k, v);
              }
          } else { // assert (this.nodemap & bit) !== 0
              var nodeIndex = index(this.nodemap, bit);
              var node = this.content[this.content.length - nodeIndex - 1].filterWithKey(f);
              if (isEmpty(node)) continue;
              if (node.isSingleton()) {
                  datamap |= bit;
                  data.push(node.content[0], node.content[1]);
              } else {
                  nodemap |= bit;
                  nodes.push(node);
              }
          }
      }
      return new MapNode(datamap, nodemap, data.concat(nodes.reverse()));
  }

  // This builds an n-ary curried function that takes all values and all
  // subnodes as arguments and places them in a copy of the hashmap
  // preserving the keys, datamap, and nodemap. Basically, a (Hashmap k
  // v) with s key-value pairs and t nodes turns into a function:
  //
  // k_0 -> .. -> k_s -> HashMap_0 k v -> .. -> HashMap_t k v -> HashMap k v
  //
  // Indices here are to be understood as count.
  //
  // The main use for this is the as the partial hashmap constructor in
  // place of the hole in this concept of an implementation of
  // traverseWithKey:
  //
  // pure ?here <*> f k1 v1 <*> f k2 v2 <*> traverseWithKey f n1 <*> traverseWithKey f n2
  MapNode.prototype.travHelper = function () {
      // TODO could have two helpers that basically switch mode from
      // setting values to setting nodes. That way branches would be
      // more predictable. Because the value branch is essentially
      // unpredictable.
      function go(vi, vm, ni, nm, copy) {
          if (vi < vm)
              return function (v) {
                  return go(vi + 1, vm, ni, nm, function () { var res = copy();
                                                              res.content[vi * 2 + 1] = v;
                                                              return res;
                                                            });
              }
          if (ni < nm)
              return function (n) {
                  return go(vi, vm, ni+1, nm, function () { var res = copy();
                                                            // order of parameters must match stored order
                                                            res.content[vm*2 + ni] = n;
                                                            return res;
                                                          });
              }
          return copy();
      }
      var vm = popCount(this.datamap);
      var self = this;
      return go(0, vm, 0, this.content.length - vm * 2, function () { return new MapNode(self.datamap, self.nodemap, self.content.slice()); });
  }

  MapNode.prototype.ifoldMap = function (m, mappend, f) {
      for (var i = 0; i < popCount(this.datamap) * 2;) {
          var k = this.content[i++];
          var v = this.content[i++];
          m = mappend(m)(f(k)(v));
      }
      for (; i < this.content.length; i++)
          m = this.content[i].ifoldMap(m, mappend, f);
      return m;
  }

  MapNode.prototype.itraverse = function (pure, apply, f) {
      var m = pure(this.travHelper());
      for (var i = 0; i < popCount(this.datamap) * 2;) {
          var k = this.content[i++];
          var v = this.content[i++];
          m = apply(m)(f(k)(v));
      }
      for (; i < this.content.length; i++)
          m = apply(m)(this.content[i].itraverse(pure, apply, f));
      return m;
  }

  /** @constructor */
  function Collision(keys, values) {
      this.keys = keys;
      this.values = values;
  }

  Collision.prototype.lookup = function collisionLookup(Nothing, Just, keyEquals, key, keyHash, shift) {
      for (var i = 0; i < this.keys.length; i++)
          if (keyEquals(key)(this.keys[i]))
              return new Just(this.values[i]);
      return Nothing;
  };

  Collision.prototype.insert = function collisionInsert(keyEquals, hashFunction, key, keyHash, value, shift) {
      var i = 0;
      for (; i < this.keys.length; i++)
          if (keyEquals(key)(this.keys[i]))
              break;
      return new Collision(copyAndOverwriteOrExtend1(this.keys, i, key),
                           copyAndOverwriteOrExtend1(this.values, i, value));
  };

  Collision.prototype.insertMut = function collisionInsertMut(keyEquals, hashFunction, key, keyHash, value, shift) {
      var i = 0;
      for (; i < this.keys.length; i++)
          if (keyEquals(key)(this.keys[i]))
              break;
      // i may be *after* the last element, if the key is not already in the map
      this.keys[i] = key;
      this.values[i] = value;
  };

  Collision.prototype.insertWith = function collisionInsert(keyEquals, hashFunction, f, key, keyHash, value, shift) {
      var i = 0;
      for (; i < this.keys.length; i++)
          if (keyEquals(key)(this.keys[i]))
              return new Collision(copyAndOverwriteOrExtend1(this.keys, i, key),
                                   copyAndOverwriteOrExtend1(this.values, i, f(this.values[i])(value)));
      return new Collision(copyAndOverwriteOrExtend1(this.keys, i, key),
                           copyAndOverwriteOrExtend1(this.values, i, value));
  };

  Collision.prototype.delet = function collisionDelete(keyEquals, key, keyHash, shift) {
      var i = 0;
      for (; i < this.keys.length; i++)
          if (keyEquals(key)(this.keys[i]))
              break;
      if (i === this.keys.length) return this;
      if (this.keys.length === 2)
          return new MapNode(1 << (keyHash & 31), 0, [this.keys[1 - i], this.values[1 - i]]);
      return new Collision(remove1(this.keys, i), remove1(this.values, i));
  }

  Collision.prototype.toArrayBy = function (f, res) {
      for (var i = 0; i < this.keys.length; i++)
          res.push(f(this.keys[i])(this.values[i]));
  }

  Collision.prototype.isSingleton = function () { return false; }

  Collision.prototype.eq = function(kf, vf, that) {
      if (this.constructor !== that.constructor || this.keys.length !== that.keys.length) return false;
      outer:
      for (var i = 0; i < this.keys.length; i++) {
          for (var j = 0; j < that.keys.length; j++) {
              if (kf(this.keys[i])(that.keys[j])) {
                  if (vf(this.values[i])(that.values[j]))
                      continue outer;
                  else
                      return false;
              }
          }
      }
      return true;
  }

  Collision.prototype.hash = function (vhash) {
      // We ignore keys because they have all the same hash anyways
      // (we're in a collision node!)
      var h = 0;
      // We use just + here, not multiply&add, because order in
      // collision nodes is undefined. A commutative combining operation
      // allows us to simply ignore the order.
      for (var i = 0; i < this.values.length; i++)
          h += vhash(this.values[i]);
      return h;
  }

  Collision.prototype.size = function () {
      return this.keys.length;
  }

  Collision.prototype.imap = function (f) {
      var newValues = this.values.slice();
      for (var i = 0; i < this.values.length; i++)
          newValues[i] = f(this.keys[i])(this.values[i]);
      return new Collision(this.keys, newValues);
  }

  Collision.prototype.ifoldMap = function (m, mappend, f) {
      for (var i = 0; i < this.keys.length; i++)
          m = mappend(m)(f(this.keys[i])(this.values[i]));
      return m;
  }

  Collision.prototype.travHelper = function () {
      function go(i, m, copy) {
          if (i < m)
              return function (v) {
                  return go(i + 1, m, function () { var res = copy();
                                                    res.values[i] = v;
                                                    return res;
                                                  });
              }
          return copy();
      }
      var self = this;
      return go(0, this.keys.length, function () { return new Collision(self.keys, self.values.slice()); });
  }

  Collision.prototype.itraverse = function (pure, apply, f) {
      var m = pure(this.travHelper());
      for (var i = 0; i < this.keys.length; i++)
          m = apply(m)(f(this.keys[i])(this.values[i]));
      return m;
  }

  Collision.prototype.unionWith = function (eq, hash, f, that, shift) {
      if (that.constructor !== Collision)
          throw "Trying to union a Collision with something else";
      var keys = [];
      var values = [];
      var added = Array(that.keys.length).fill(false);
      outer:
      for (var i = 0; i < this.keys.length; i++) {
          for (var j = 0; j < that.keys.length; j++) {
              if (eq(this.keys[i])(that.keys[j])) {
                  keys.push(this.keys[i]);
                  values.push(f(this.values[i])(that.values[j]));
                  added[j] = true;
                  continue outer;
              }
          }
          keys.push(this.keys[i]);
          values.push(this.values[i]);
          added[j] = true;
      }
      for (var k = 0; k < that.keys.length; k++) {
          if (!added[k]) {
              keys.push(that.keys[k]);
              values.push(that.values[k]);
          }
      }
      return new Collision(keys, values);
  }

  Collision.prototype.intersectionWith = function (Nothing, Just, eq, hash, f, that, shift) {
      if (that.constructor !== Collision)
          throw "Trying to intersect a Collision with something else";
      var keys = [];
      var values = [];
      outer:
      for (var i = 0; i < this.keys.length; i++) {
          for (var j = 0; j < that.keys.length; j++) {
              if (eq(this.keys[i])(that.keys[j])) {
                  keys.push(this.keys[i]);
                  values.push(f(this.values[i])(that.values[j]));
                  continue outer;
              }
          }
      }
      if (keys.length === 0)
          return empty;
      // This is a bit dodgy. We return a fake MapNode (wrong datamap
      // (WHICH CANNOT BE 0, OTHERWISE isEmpty THINKS IT'S EMPTY!) and
      // nodemap), but it's okay, because we will immediately
      // deconstruct it in the MapNode.intersectionWith.
      if (keys.length === 1)
          return new MapNode(1, 0, [keys[0], values[0]]);
      return new Collision(keys, values);
  }

  Collision.prototype.filterWithKey = function collisionFilterWithKey(f) {
      var keys = [];
      var values = [];
      for (var i = 0; i < this.keys.length; i++) {
          var k = this.keys[i];
          var v = this.values[i];
          if (f(k)(v)) {
              keys.push(k);
              values.push(v);
          }
      }
      if (keys.length === 0) return empty;
      // This is a bit dodgy. We return a fake MapNode (wrong datamap
      // (WHICH CANNOT BE 0, OTHERWISE isEmpty THINKS IT'S EMPTY!) and
      // nodemap), but it's okay, because we will immediately
      // deconstruct it in MapNode's filterWithKey.
      if (keys.length === 1) return new MapNode(1, 0, [keys[0], values[0]]);
      return new Collision(keys, values);
  }

  function mask(keyHash, shift) {
      return 1 << ((keyHash >>> shift) & 31);
  }

  function index(map, bit) {
      return popCount(map & (bit - 1));
  }

  function popCount (n) {
      n = n - ((n >> 1) & 0x55555555);
      n = (n & 0x33333333) + ((n >> 2) & 0x33333333);
      return ((n + (n >> 4) & 0xF0F0F0F) * 0x1010101) >> 24;
  }

  function binaryNode(k1, kh1, v1, k2, kh2, v2, s) {
      if (s >= 32) return new Collision([k1, k2], [v1, v2]);

      var b1 = (kh1 >>> s) & 31;
      var b2 = (kh2 >>> s) & 31;

      if (b1 !== b2) return new MapNode((1 << b1) | (1 << b2), 0, (b1 >>> 0) < (b2 >>> 0) ? [k1, v1, k2, v2] : [k2, v2, k1, v1]);

      return new MapNode(0, 1 << b1, [binaryNode(k1, kh1, v1, k2, kh2, v2, s + 5)]);
  }

  function overwriteTwoElements(a, index, v1, v2) {
      var res = a.slice();
      res[index] = v1;
      res[index+1] = v2;
      return res;
  }

  // TODO benchmark some alternative implementations (manual copy, slice
  // left + copy?, slice both + concat?, ...)
  function remove2(a, index) {
      var res = a.slice();
      res.splice(index, 2);
      return res;
  }

  // I think this is always called with a node index? Therefore, the
  // left will often be larger than the right. Does that help?
  function remove1(a, index) {
      var res = a.slice();
      res.splice(index, 1);
      return res;
  }

  // Make a copy while overwriting the element at index, or adding one element if index == a.length
  function copyAndOverwriteOrExtend1(a, index, v) {
      var res = a.slice();
      res[index] = v;
      return res;
  }

  function remove2insert1(a, removeIndex, insertIndex, v1) {
      var res = new Array(a.length - 1);
      for (var i = 0; i < removeIndex; i++) res[i] = a[i];
      for (; i < insertIndex; i++) res[i] = a[i+2];
      res[i++] = v1;
      for (; i < res.length; i++) res[i] = a[i+1];
      return res;
  }

  function insert2(a, index, v1, v2) {
      var res = new Array(a.length + 2);
      for (var i = 0; i < index; i++) res[i] = a[i];
      res[i++] = v1;
      res[i++] = v2;
      for (; i < res.length; i++) res[i] = a[i - 2];
      return res;
  }

  function insert2remove1(a, insertIndex, v1, v2, removeIndex) {
      var res = new Array(a.length + 1);
      for (var i = 0; i < insertIndex; i++) res[i] = a[i];
      res[i++] = v1;
      res[i++] = v2;
      for (; i < removeIndex + 2; i++) res[i] = a[i-2];
      for (; i < res.length; i++) res[i] = a[i-1];
      return res;
  }

  var empty = new MapNode(0,0,[]);

  exports.empty = empty;

  exports.lookupPurs = function (Nothing, Just, keyEquals, key, keyHash) {
      return function (m) {
          return m.lookup(Nothing, Just, keyEquals, key, keyHash, 0);
      };
  };

  exports.insertPurs = function (keyEquals, hashFunction) {
      return function (key) {
          return function (value) {
              return function (m) {
                  return m.insert(keyEquals, hashFunction, key, hashFunction(key), value, 0);
              };
          };
      };
  };

  exports.deletePurs = function (keyEquals, key, keyHash) {
      return function (m) {
          return m.delet(keyEquals, key, keyHash, 0);
      };
  };

  function isEmpty (m) {
      return m.datamap === 0 && m.nodemap === 0;
  }                         

  exports.size = function (m) { return m.size(); }

  exports.filterWithKey = function (f) {
      return function (m) {
          return m.filterWithKey(f);
      };
  };
})(PS["Data.HashMap"] = PS["Data.HashMap"] || {});
(function(exports) {
  "use strict";

  var refEq = function (r1) {
    return function (r2) {
      return r1 === r2;
    };
  };

  exports.eqBooleanImpl = refEq;
  exports.eqIntImpl = refEq;   
  exports.eqCharImpl = refEq;
  exports.eqStringImpl = refEq;

  exports.eqArrayImpl = function (f) {
    return function (xs) {
      return function (ys) {
        if (xs.length !== ys.length) return false;
        for (var i = 0; i < xs.length; i++) {
          if (!f(xs[i])(ys[i])) return false;
        }
        return true;
      };
    };
  };
})(PS["Data.Eq"] = PS["Data.Eq"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Eq"] = $PS["Data.Eq"] || {};
  var exports = $PS["Data.Eq"];
  var $foreign = $PS["Data.Eq"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Record_Unsafe = $PS["Record.Unsafe"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var EqRecord = function (eqRecord) {
      this.eqRecord = eqRecord;
  };
  var Eq = function (eq) {
      this.eq = eq;
  }; 
  var eqUnit = new Eq(function (v) {
      return function (v1) {
          return true;
      };
  });
  var eqString = new Eq($foreign.eqStringImpl);
  var eqRowNil = new EqRecord(function (v) {
      return function (v1) {
          return function (v2) {
              return true;
          };
      };
  });
  var eqRecord = function (dict) {
      return dict.eqRecord;
  };
  var eqRec = function (dictRowToList) {
      return function (dictEqRecord) {
          return new Eq(eqRecord(dictEqRecord)(Type_Proxy["Proxy"].value));
      };
  };                                           
  var eqInt = new Eq($foreign.eqIntImpl);
  var eqChar = new Eq($foreign.eqCharImpl);
  var eqBoolean = new Eq($foreign.eqBooleanImpl);
  var eq = function (dict) {
      return dict.eq;
  };
  var eqArray = function (dictEq) {
      return new Eq($foreign.eqArrayImpl(eq(dictEq)));
  }; 
  var eqRowCons = function (dictEqRecord) {
      return function (dictCons) {
          return function (dictIsSymbol) {
              return function (dictEq) {
                  return new EqRecord(function (v) {
                      return function (ra) {
                          return function (rb) {
                              var tail = eqRecord(dictEqRecord)(Type_Proxy["Proxy"].value)(ra)(rb);
                              var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                              var get = Record_Unsafe.unsafeGet(key);
                              return eq(dictEq)(get(ra))(get(rb)) && tail;
                          };
                      };
                  });
              };
          };
      };
  };
  var notEq = function (dictEq) {
      return function (x) {
          return function (y) {
              return eq(eqBoolean)(eq(dictEq)(x)(y))(false);
          };
      };
  };
  exports["Eq"] = Eq;
  exports["eq"] = eq;
  exports["notEq"] = notEq;
  exports["eqBoolean"] = eqBoolean;
  exports["eqInt"] = eqInt;
  exports["eqChar"] = eqChar;
  exports["eqString"] = eqString;
  exports["eqUnit"] = eqUnit;
  exports["eqArray"] = eqArray;
  exports["eqRec"] = eqRec;
  exports["eqRowNil"] = eqRowNil;
  exports["eqRowCons"] = eqRowCons;
})(PS);
(function(exports) {
  // This Source Code Form is subject to the terms of the Mozilla Public
  // License, v. 2.0. If a copy of the MPL was not distributed with this
  // file, You can obtain one at http://mozilla.org/MPL/2.0/.

  "use strict";

  exports.hashString = function (s) {
      var h = 0;
      for (var i = 0; i < s.length; i++) {
          h = (31 * h + s.charCodeAt(i)) | 0;
      }
      return h;
  };
})(PS["Data.Hashable"] = PS["Data.Hashable"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Hashable"] = $PS["Data.Hashable"] || {};
  var exports = $PS["Data.Hashable"];
  var $foreign = $PS["Data.Hashable"];
  var Data_Eq = $PS["Data.Eq"];
  var Hashable = function (Eq0, hash) {
      this.Eq0 = Eq0;
      this.hash = hash;
  }; 
  var hashableString = new Hashable(function () {
      return Data_Eq.eqString;
  }, $foreign.hashString);
  var hash = function (dict) {
      return dict.hash;
  };
  exports["hash"] = hash;
  exports["hashableString"] = hashableString;
})(PS);
(function(exports) {
  "use strict";

  exports.arrayApply = function (fs) {
    return function (xs) {
      var l = fs.length;
      var k = xs.length;
      var result = new Array(l*k);
      var n = 0;
      for (var i = 0; i < l; i++) {
        var f = fs[i];
        for (var j = 0; j < k; j++) {
          result[n++] = f(xs[j]);
        }
      }
      return result;
    };
  };
})(PS["Control.Apply"] = PS["Control.Apply"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Category"] = $PS["Control.Category"] || {};
  var exports = $PS["Control.Category"];
  var Control_Semigroupoid = $PS["Control.Semigroupoid"];                
  var Category = function (Semigroupoid0, identity) {
      this.Semigroupoid0 = Semigroupoid0;
      this.identity = identity;
  };
  var identity = function (dict) {
      return dict.identity;
  };
  var categoryFn = new Category(function () {
      return Control_Semigroupoid.semigroupoidFn;
  }, function (x) {
      return x;
  });
  exports["identity"] = identity;
  exports["categoryFn"] = categoryFn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Apply"] = $PS["Control.Apply"] || {};
  var exports = $PS["Control.Apply"];
  var $foreign = $PS["Control.Apply"];
  var Control_Category = $PS["Control.Category"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];            
  var Apply = function (Functor0, apply) {
      this.Functor0 = Functor0;
      this.apply = apply;
  }; 
  var applyArray = new Apply(function () {
      return Data_Functor.functorArray;
  }, $foreign.arrayApply);
  var apply = function (dict) {
      return dict.apply;
  };
  var applySecond = function (dictApply) {
      return function (a) {
          return function (b) {
              return apply(dictApply)(Data_Functor.map(dictApply.Functor0())(Data_Function["const"](Control_Category.identity(Control_Category.categoryFn)))(a))(b);
          };
      };
  };
  exports["Apply"] = Apply;
  exports["apply"] = apply;
  exports["applySecond"] = applySecond;
  exports["applyArray"] = applyArray;
})(PS);
(function(exports) {
  "use strict";

  exports.arrayBind = function (arr) {
    return function (f) {
      var result = [];
      for (var i = 0, l = arr.length; i < l; i++) {
        Array.prototype.push.apply(result, f(arr[i]));
      }
      return result;
    };
  };
})(PS["Control.Bind"] = PS["Control.Bind"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Bind"] = $PS["Control.Bind"] || {};
  var exports = $PS["Control.Bind"];
  var $foreign = $PS["Control.Bind"];
  var Control_Apply = $PS["Control.Apply"];
  var Data_Function = $PS["Data.Function"];          
  var Bind = function (Apply0, bind) {
      this.Apply0 = Apply0;
      this.bind = bind;
  };
  var Discard = function (discard) {
      this.discard = discard;
  };
  var discard = function (dict) {
      return dict.discard;
  }; 
  var bindArray = new Bind(function () {
      return Control_Apply.applyArray;
  }, $foreign.arrayBind);
  var bind = function (dict) {
      return dict.bind;
  };
  var bindFlipped = function (dictBind) {
      return Data_Function.flip(bind(dictBind));
  };
  var composeKleisliFlipped = function (dictBind) {
      return function (f) {
          return function (g) {
              return function (a) {
                  return bindFlipped(dictBind)(f)(g(a));
              };
          };
      };
  };
  var composeKleisli = function (dictBind) {
      return function (f) {
          return function (g) {
              return function (a) {
                  return bind(dictBind)(f(a))(g);
              };
          };
      };
  }; 
  var discardUnit = new Discard(function (dictBind) {
      return bind(dictBind);
  });
  exports["Bind"] = Bind;
  exports["bind"] = bind;
  exports["bindFlipped"] = bindFlipped;
  exports["discard"] = discard;
  exports["composeKleisli"] = composeKleisli;
  exports["composeKleisliFlipped"] = composeKleisliFlipped;
  exports["bindArray"] = bindArray;
  exports["discardUnit"] = discardUnit;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Maybe"] = $PS["Data.Maybe"] || {};
  var exports = $PS["Data.Maybe"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Show = $PS["Data.Show"];                
  var Nothing = (function () {
      function Nothing() {

      };
      Nothing.value = new Nothing();
      return Nothing;
  })();
  var Just = (function () {
      function Just(value0) {
          this.value0 = value0;
      };
      Just.create = function (value0) {
          return new Just(value0);
      };
      return Just;
  })();
  var showMaybe = function (dictShow) {
      return new Data_Show.Show(function (v) {
          if (v instanceof Just) {
              return "(Just " + (Data_Show.show(dictShow)(v.value0) + ")");
          };
          if (v instanceof Nothing) {
              return "Nothing";
          };
          throw new Error("Failed pattern match at Data.Maybe (line 216, column 1 - line 218, column 28): " + [ v.constructor.name ]);
      });
  };
  var maybe = function (v) {
      return function (v1) {
          return function (v2) {
              if (v2 instanceof Nothing) {
                  return v;
              };
              if (v2 instanceof Just) {
                  return v1(v2.value0);
              };
              throw new Error("Failed pattern match at Data.Maybe (line 230, column 1 - line 230, column 51): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
          };
      };
  };
  var isNothing = maybe(true)(Data_Function["const"](false));
  var isJust = maybe(false)(Data_Function["const"](true));
  var functorMaybe = new Data_Functor.Functor(function (v) {
      return function (v1) {
          if (v1 instanceof Just) {
              return new Just(v(v1.value0));
          };
          return Nothing.value;
      };
  });
  var fromMaybe = function (a) {
      return maybe(a)(Control_Category.identity(Control_Category.categoryFn));
  };
  var fromJust = function (dictPartial) {
      return function (v) {
          if (v instanceof Just) {
              return v.value0;
          };
          throw new Error("Failed pattern match at Data.Maybe (line 281, column 1 - line 281, column 46): " + [ v.constructor.name ]);
      };
  }; 
  var eqMaybe = function (dictEq) {
      return new Data_Eq.Eq(function (x) {
          return function (y) {
              if (x instanceof Nothing && y instanceof Nothing) {
                  return true;
              };
              if (x instanceof Just && y instanceof Just) {
                  return Data_Eq.eq(dictEq)(x.value0)(y.value0);
              };
              return false;
          };
      });
  };
  var applyMaybe = new Control_Apply.Apply(function () {
      return functorMaybe;
  }, function (v) {
      return function (v1) {
          if (v instanceof Just) {
              return Data_Functor.map(functorMaybe)(v.value0)(v1);
          };
          if (v instanceof Nothing) {
              return Nothing.value;
          };
          throw new Error("Failed pattern match at Data.Maybe (line 68, column 1 - line 70, column 30): " + [ v.constructor.name, v1.constructor.name ]);
      };
  });
  var bindMaybe = new Control_Bind.Bind(function () {
      return applyMaybe;
  }, function (v) {
      return function (v1) {
          if (v instanceof Just) {
              return v1(v.value0);
          };
          if (v instanceof Nothing) {
              return Nothing.value;
          };
          throw new Error("Failed pattern match at Data.Maybe (line 126, column 1 - line 128, column 28): " + [ v.constructor.name, v1.constructor.name ]);
      };
  });
  exports["Nothing"] = Nothing;
  exports["Just"] = Just;
  exports["maybe"] = maybe;
  exports["fromMaybe"] = fromMaybe;
  exports["isJust"] = isJust;
  exports["isNothing"] = isNothing;
  exports["fromJust"] = fromJust;
  exports["functorMaybe"] = functorMaybe;
  exports["bindMaybe"] = bindMaybe;
  exports["eqMaybe"] = eqMaybe;
  exports["showMaybe"] = showMaybe;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.HashMap"] = $PS["Data.HashMap"] || {};
  var exports = $PS["Data.HashMap"];
  var $foreign = $PS["Data.HashMap"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Function = $PS["Data.Function"];
  var Data_Hashable = $PS["Data.Hashable"];
  var Data_Maybe = $PS["Data.Maybe"];
  var lookup = function (dictHashable) {
      return function (k) {
          return $foreign.lookupPurs(Data_Maybe.Nothing.value, Data_Maybe.Just.create, Data_Eq.eq(dictHashable.Eq0()), k, Data_Hashable.hash(dictHashable)(k));
      };
  };
  var insert = function (dictHashable) {
      return $foreign.insertPurs(Data_Eq.eq(dictHashable.Eq0()), Data_Hashable.hash(dictHashable));
  };
  var filter = function (f) {
      return $foreign.filterWithKey(Data_Function["const"](f));
  };
  var $$delete = function (dictHashable) {
      return function (k) {
          return $foreign.deletePurs(Data_Eq.eq(dictHashable.Eq0()), k, Data_Hashable.hash(dictHashable)(k));
      };
  };
  exports["lookup"] = lookup;
  exports["insert"] = insert;
  exports["delete"] = $$delete;
  exports["filter"] = filter;
  exports["empty"] = $foreign.empty;
  exports["size"] = $foreign.size;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Profunctor"] = $PS["Data.Profunctor"] || {};
  var exports = $PS["Data.Profunctor"];
  var Control_Category = $PS["Control.Category"];        
  var Profunctor = function (dimap) {
      this.dimap = dimap;
  };
  var profunctorFn = new Profunctor(function (a2b) {
      return function (c2d) {
          return function (b2c) {
              return function ($9) {
                  return c2d(b2c(a2b($9)));
              };
          };
      };
  });
  var dimap = function (dict) {
      return dict.dimap;
  };
  var rmap = function (dictProfunctor) {
      return function (b2c) {
          return dimap(dictProfunctor)(Control_Category.identity(Control_Category.categoryFn))(b2c);
      };
  };
  exports["dimap"] = dimap;
  exports["Profunctor"] = Profunctor;
  exports["rmap"] = rmap;
  exports["profunctorFn"] = profunctorFn;
})(PS);
(function(exports) {
  "use strict";

  var unsafeCompareImpl = function (lt) {
    return function (eq) {
      return function (gt) {
        return function (x) {
          return function (y) {
            return x < y ? lt : x === y ? eq : gt;
          };
        };
      };
    };
  };                                         
  exports.ordIntImpl = unsafeCompareImpl;   
  exports.ordStringImpl = unsafeCompareImpl;
  exports.ordCharImpl = unsafeCompareImpl;
})(PS["Data.Ord"] = PS["Data.Ord"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Ordering"] = $PS["Data.Ordering"] || {};
  var exports = $PS["Data.Ordering"];
  var Data_Eq = $PS["Data.Eq"];                    
  var LT = (function () {
      function LT() {

      };
      LT.value = new LT();
      return LT;
  })();
  var GT = (function () {
      function GT() {

      };
      GT.value = new GT();
      return GT;
  })();
  var EQ = (function () {
      function EQ() {

      };
      EQ.value = new EQ();
      return EQ;
  })();
  var eqOrdering = new Data_Eq.Eq(function (v) {
      return function (v1) {
          if (v instanceof LT && v1 instanceof LT) {
              return true;
          };
          if (v instanceof GT && v1 instanceof GT) {
              return true;
          };
          if (v instanceof EQ && v1 instanceof EQ) {
              return true;
          };
          return false;
      };
  });
  exports["LT"] = LT;
  exports["GT"] = GT;
  exports["EQ"] = EQ;
  exports["eqOrdering"] = eqOrdering;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Ord"] = $PS["Data.Ord"] || {};
  var exports = $PS["Data.Ord"];
  var $foreign = $PS["Data.Ord"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ordering = $PS["Data.Ordering"];
  var Ord = function (Eq0, compare) {
      this.Eq0 = Eq0;
      this.compare = compare;
  }; 
  var ordString = new Ord(function () {
      return Data_Eq.eqString;
  }, $foreign.ordStringImpl(Data_Ordering.LT.value)(Data_Ordering.EQ.value)(Data_Ordering.GT.value));
  var ordInt = new Ord(function () {
      return Data_Eq.eqInt;
  }, $foreign.ordIntImpl(Data_Ordering.LT.value)(Data_Ordering.EQ.value)(Data_Ordering.GT.value));
  var ordChar = new Ord(function () {
      return Data_Eq.eqChar;
  }, $foreign.ordCharImpl(Data_Ordering.LT.value)(Data_Ordering.EQ.value)(Data_Ordering.GT.value));
  var compare = function (dict) {
      return dict.compare;
  };
  var comparing = function (dictOrd) {
      return function (f) {
          return function (x) {
              return function (y) {
                  return compare(dictOrd)(f(x))(f(y));
              };
          };
      };
  };
  var greaterThan = function (dictOrd) {
      return function (a1) {
          return function (a2) {
              var v = compare(dictOrd)(a1)(a2);
              if (v instanceof Data_Ordering.GT) {
                  return true;
              };
              return false;
          };
      };
  };
  var lessThan = function (dictOrd) {
      return function (a1) {
          return function (a2) {
              var v = compare(dictOrd)(a1)(a2);
              if (v instanceof Data_Ordering.LT) {
                  return true;
              };
              return false;
          };
      };
  };
  var lessThanOrEq = function (dictOrd) {
      return function (a1) {
          return function (a2) {
              var v = compare(dictOrd)(a1)(a2);
              if (v instanceof Data_Ordering.GT) {
                  return false;
              };
              return true;
          };
      };
  };
  var max = function (dictOrd) {
      return function (x) {
          return function (y) {
              var v = compare(dictOrd)(x)(y);
              if (v instanceof Data_Ordering.LT) {
                  return y;
              };
              if (v instanceof Data_Ordering.EQ) {
                  return x;
              };
              if (v instanceof Data_Ordering.GT) {
                  return x;
              };
              throw new Error("Failed pattern match at Data.Ord (line 176, column 3 - line 179, column 12): " + [ v.constructor.name ]);
          };
      };
  };
  var min = function (dictOrd) {
      return function (x) {
          return function (y) {
              var v = compare(dictOrd)(x)(y);
              if (v instanceof Data_Ordering.LT) {
                  return x;
              };
              if (v instanceof Data_Ordering.EQ) {
                  return x;
              };
              if (v instanceof Data_Ordering.GT) {
                  return y;
              };
              throw new Error("Failed pattern match at Data.Ord (line 167, column 3 - line 170, column 12): " + [ v.constructor.name ]);
          };
      };
  };
  exports["Ord"] = Ord;
  exports["compare"] = compare;
  exports["lessThan"] = lessThan;
  exports["lessThanOrEq"] = lessThanOrEq;
  exports["greaterThan"] = greaterThan;
  exports["comparing"] = comparing;
  exports["min"] = min;
  exports["max"] = max;
  exports["ordInt"] = ordInt;
  exports["ordString"] = ordString;
  exports["ordChar"] = ordChar;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Tuple"] = $PS["Data.Tuple"] || {};
  var exports = $PS["Data.Tuple"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];        
  var Tuple = (function () {
      function Tuple(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Tuple.create = function (value0) {
          return function (value1) {
              return new Tuple(value0, value1);
          };
      };
      return Tuple;
  })();
  var snd = function (v) {
      return v.value1;
  }; 
  var functorTuple = new Data_Functor.Functor(function (f) {
      return function (m) {
          return new Tuple(m.value0, f(m.value1));
      };
  });                                                                                                   
  var fst = function (v) {
      return v.value0;
  }; 
  var eqTuple = function (dictEq) {
      return function (dictEq1) {
          return new Data_Eq.Eq(function (x) {
              return function (y) {
                  return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(dictEq1)(x.value1)(y.value1);
              };
          });
      };
  };
  var ordTuple = function (dictOrd) {
      return function (dictOrd1) {
          return new Data_Ord.Ord(function () {
              return eqTuple(dictOrd.Eq0())(dictOrd1.Eq0());
          }, function (x) {
              return function (y) {
                  var v = Data_Ord.compare(dictOrd)(x.value0)(y.value0);
                  if (v instanceof Data_Ordering.LT) {
                      return Data_Ordering.LT.value;
                  };
                  if (v instanceof Data_Ordering.GT) {
                      return Data_Ordering.GT.value;
                  };
                  return Data_Ord.compare(dictOrd1)(x.value1)(y.value1);
              };
          });
      };
  };
  exports["Tuple"] = Tuple;
  exports["fst"] = fst;
  exports["snd"] = snd;
  exports["ordTuple"] = ordTuple;
  exports["functorTuple"] = functorTuple;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Profunctor.Strong"] = $PS["Data.Profunctor.Strong"] || {};
  var exports = $PS["Data.Profunctor.Strong"];
  var Control_Category = $PS["Control.Category"];
  var Control_Semigroupoid = $PS["Control.Semigroupoid"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Strong = function (Profunctor0, first, second) {
      this.Profunctor0 = Profunctor0;
      this.first = first;
      this.second = second;
  };
  var strongFn = new Strong(function () {
      return Data_Profunctor.profunctorFn;
  }, function (a2b) {
      return function (v) {
          return new Data_Tuple.Tuple(a2b(v.value0), v.value1);
      };
  }, Data_Functor.map(Data_Tuple.functorTuple));
  var second = function (dict) {
      return dict.second;
  };
  var first = function (dict) {
      return dict.first;
  };
  var splitStrong = function (dictCategory) {
      return function (dictStrong) {
          return function (l) {
              return function (r) {
                  return Control_Semigroupoid.composeFlipped(dictCategory.Semigroupoid0())(first(dictStrong)(l))(second(dictStrong)(r));
              };
          };
      };
  };
  var fanout = function (dictCategory) {
      return function (dictStrong) {
          return function (l) {
              return function (r) {
                  var split = Data_Profunctor.dimap(dictStrong.Profunctor0())(Control_Category.identity(Control_Category.categoryFn))(function (a) {
                      return new Data_Tuple.Tuple(a, a);
                  })(Control_Category.identity(dictCategory));
                  return Control_Semigroupoid.composeFlipped(dictCategory.Semigroupoid0())(split)(splitStrong(dictCategory)(dictStrong)(l)(r));
              };
          };
      };
  };
  exports["first"] = first;
  exports["second"] = second;
  exports["Strong"] = Strong;
  exports["fanout"] = fanout;
  exports["strongFn"] = strongFn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Lens"] = $PS["Data.Lens.Lens"] || {};
  var exports = $PS["Data.Lens.Lens"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Tuple = $PS["Data.Tuple"];
  var lens$prime = function (to) {
      return function (dictStrong) {
          return function (pab) {
              return Data_Profunctor.dimap(dictStrong.Profunctor0())(to)(function (v) {
                  return v.value1(v.value0);
              })(Data_Profunctor_Strong.first(dictStrong)(pab));
          };
      };
  };
  var lens = function (get) {
      return function (set) {
          return function (dictStrong) {
              return lens$prime(function (s) {
                  return new Data_Tuple.Tuple(get(s), function (b) {
                      return set(s)(b);
                  });
              })(dictStrong);
          };
      };
  };
  exports["lens"] = lens;
  exports["lens'"] = lens$prime;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeUnionFn = function(r1, r2) {
    var copy = {};
    for (var k1 in r2) {
      if ({}.hasOwnProperty.call(r2, k1)) {
        copy[k1] = r2[k1];
      }
    }
    for (var k2 in r1) {
      if ({}.hasOwnProperty.call(r1, k2)) {
        copy[k2] = r1[k2];
      }
    }
    return copy;
  };
})(PS["Record.Unsafe.Union"] = PS["Record.Unsafe.Union"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Record.Unsafe.Union"] = $PS["Record.Unsafe.Union"] || {};
  var exports = $PS["Record.Unsafe.Union"];
  var $foreign = $PS["Record.Unsafe.Union"];
  exports["unsafeUnionFn"] = $foreign.unsafeUnionFn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Record"] = $PS["Record"] || {};
  var exports = $PS["Record"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Record_Unsafe = $PS["Record.Unsafe"];
  var Record_Unsafe_Union = $PS["Record.Unsafe.Union"];
  var set = function (dictIsSymbol) {
      return function (dictCons) {
          return function (dictCons1) {
              return function (l) {
                  return function (b) {
                      return function (r) {
                          return Record_Unsafe.unsafeSet(Data_Symbol.reflectSymbol(dictIsSymbol)(l))(b)(r);
                      };
                  };
              };
          };
      };
  };
  var merge = function (dictUnion) {
      return function (dictNub) {
          return function (l) {
              return function (r) {
                  return Record_Unsafe_Union.unsafeUnionFn(l, r);
              };
          };
      };
  };
  var insert = function (dictIsSymbol) {
      return function (dictLacks) {
          return function (dictCons) {
              return function (l) {
                  return function (a) {
                      return function (r) {
                          return Record_Unsafe.unsafeSet(Data_Symbol.reflectSymbol(dictIsSymbol)(l))(a)(r);
                      };
                  };
              };
          };
      };
  };
  var get = function (dictIsSymbol) {
      return function (dictCons) {
          return function (l) {
              return function (r) {
                  return Record_Unsafe.unsafeGet(Data_Symbol.reflectSymbol(dictIsSymbol)(l))(r);
              };
          };
      };
  };
  exports["get"] = get;
  exports["set"] = set;
  exports["insert"] = insert;
  exports["merge"] = merge;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Record"] = $PS["Data.Lens.Record"] || {};
  var exports = $PS["Data.Lens.Record"];
  var Data_Function = $PS["Data.Function"];
  var Data_Lens_Lens = $PS["Data.Lens.Lens"];
  var Record = $PS["Record"];                
  var prop = function (dictIsSymbol) {
      return function (dictCons) {
          return function (dictCons1) {
              return function (l) {
                  return function (dictStrong) {
                      return Data_Lens_Lens.lens(Record.get(dictIsSymbol)()(l))(Data_Function.flip(Record.set(dictIsSymbol)()()(l)))(dictStrong);
                  };
              };
          };
      };
  };
  exports["prop"] = prop;
})(PS);
(function(exports) {
  "use strict";

  exports.intSub = function (x) {
    return function (y) {
      /* jshint bitwise: false */
      return x - y | 0;
    };
  };
})(PS["Data.Ring"] = PS["Data.Ring"] || {});
(function(exports) {
  "use strict";

  exports.intAdd = function (x) {
    return function (y) {
      /* jshint bitwise: false */
      return x + y | 0;
    };
  };

  exports.intMul = function (x) {
    return function (y) {
      /* jshint bitwise: false */
      return x * y | 0;
    };
  };

  exports.numAdd = function (n1) {
    return function (n2) {
      return n1 + n2;
    };
  };

  exports.numMul = function (n1) {
    return function (n2) {
      return n1 * n2;
    };
  };
})(PS["Data.Semiring"] = PS["Data.Semiring"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Semiring"] = $PS["Data.Semiring"] || {};
  var exports = $PS["Data.Semiring"];
  var $foreign = $PS["Data.Semiring"];
  var Semiring = function (add, mul, one, zero) {
      this.add = add;
      this.mul = mul;
      this.one = one;
      this.zero = zero;
  };
  var zero = function (dict) {
      return dict.zero;
  };                                                       
  var semiringNumber = new Semiring($foreign.numAdd, $foreign.numMul, 1.0, 0.0);
  var semiringInt = new Semiring($foreign.intAdd, $foreign.intMul, 1, 0);
  var one = function (dict) {
      return dict.one;
  };
  var mul = function (dict) {
      return dict.mul;
  };
  var add = function (dict) {
      return dict.add;
  };
  exports["add"] = add;
  exports["zero"] = zero;
  exports["mul"] = mul;
  exports["one"] = one;
  exports["semiringInt"] = semiringInt;
  exports["semiringNumber"] = semiringNumber;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Ring"] = $PS["Data.Ring"] || {};
  var exports = $PS["Data.Ring"];
  var $foreign = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Ring = function (Semiring0, sub) {
      this.Semiring0 = Semiring0;
      this.sub = sub;
  };
  var sub = function (dict) {
      return dict.sub;
  };                  
  var ringInt = new Ring(function () {
      return Data_Semiring.semiringInt;
  }, $foreign.intSub);
  var negate = function (dictRing) {
      return function (a) {
          return sub(dictRing)(Data_Semiring.zero(dictRing.Semiring0()))(a);
      };
  };
  exports["sub"] = sub;
  exports["negate"] = negate;
  exports["ringInt"] = ringInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Setter"] = $PS["Data.Lens.Setter"] || {};
  var exports = $PS["Data.Lens.Setter"];
  var Data_Function = $PS["Data.Function"];
  var Data_Ring = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];          
  var over = function (l) {
      return l;
  };
  var set = function (l) {
      return function (b) {
          return over(l)(Data_Function["const"](b));
      };
  };
  var subOver = function (dictRing) {
      return function (p) {
          var $26 = over(p);
          var $27 = Data_Function.flip(Data_Ring.sub(dictRing));
          return function ($28) {
              return $26($27($28));
          };
      };
  };
  var addOver = function (dictSemiring) {
      return function (p) {
          var $64 = over(p);
          var $65 = Data_Semiring.add(dictSemiring);
          return function ($66) {
              return $64($65($66));
          };
      };
  };
  exports["over"] = over;
  exports["set"] = set;
  exports["addOver"] = addOver;
  exports["subOver"] = subOver;
})(PS);
(function(exports) {
  /* eslint-disable no-eq-null, eqeqeq */
  "use strict";

  function id(x) {
    return x;
  }

  exports.fromBoolean = id;
  exports.fromNumber = id;
  exports.fromString = id;
  exports.fromArray = id;
  exports.fromObject = id;

  exports.jsonNull = null;

  exports.stringify = function (j) {
    return JSON.stringify(j);
  };

  function isArray(a) {
    return Object.prototype.toString.call(a) === "[object Array]";
  }

  exports._caseJson = function (isNull, isBool, isNum, isStr, isArr, isObj, j) {
    if (j == null) return isNull();
    else if (typeof j === "boolean") return isBool(j);
    else if (typeof j === "number") return isNum(j);
    else if (typeof j === "string") return isStr(j);
    else if (Object.prototype.toString.call(j) === "[object Array]")
      return isArr(j);
    else return isObj(j);
  };

  exports._compare = function _compare(EQ, GT, LT, a, b) {
    if (a == null) {
      if (b == null) return EQ;
      else return LT;
    } else if (typeof a === "boolean") {
      if (typeof b === "boolean") {
        // boolean / boolean
        if (a === b) return EQ;
        else if (a === false) return LT;
        else return GT;
      } else if (b == null) return GT;
      else return LT;
    } else if (typeof a === "number") {
      if (typeof b === "number") {
        if (a === b) return EQ;
        else if (a < b) return LT;
        else return GT;
      } else if (b == null) return GT;
      else if (typeof b === "boolean") return GT;
      else return LT;
    } else if (typeof a === "string") {
      if (typeof b === "string") {
        if (a === b) return EQ;
        else if (a < b) return LT;
        else return GT;
      } else if (b == null) return GT;
      else if (typeof b === "boolean") return GT;
      else if (typeof b === "number") return GT;
      else return LT;
    } else if (isArray(a)) {
      if (isArray(b)) {
        for (var i = 0; i < Math.min(a.length, b.length); i++) {
          var ca = _compare(EQ, GT, LT, a[i], b[i]);
          if (ca !== EQ) return ca;
        }
        if (a.length === b.length) return EQ;
        else if (a.length < b.length) return LT;
        else return GT;
      } else if (b == null) return GT;
      else if (typeof b === "boolean") return GT;
      else if (typeof b === "number") return GT;
      else if (typeof b === "string") return GT;
      else return LT;
    } else {
      if (b == null) return GT;
      else if (typeof b === "boolean") return GT;
      else if (typeof b === "number") return GT;
      else if (typeof b === "string") return GT;
      else if (isArray(b)) return GT;
      else {
        var akeys = Object.keys(a);
        var bkeys = Object.keys(b);
        if (akeys.length < bkeys.length) return LT;
        else if (akeys.length > bkeys.length) return GT;
        var keys = akeys.concat(bkeys).sort();
        for (var j = 0; j < keys.length; j++) {
          var k = keys[j];
          if (a[k] === undefined) return LT;
          else if (b[k] === undefined) return GT;
          var ck = _compare(EQ, GT, LT, a[k], b[k]);
          if (ck !== EQ) return ck;
        }
        return EQ;
      }
    }
  };
})(PS["Data.Argonaut.Core"] = PS["Data.Argonaut.Core"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Core"] = $PS["Data.Argonaut.Core"] || {};
  var exports = $PS["Data.Argonaut.Core"];
  var $foreign = $PS["Data.Argonaut.Core"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Function = $PS["Data.Function"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];                  
  var verbJsonType = function (def) {
      return function (f) {
          return function (g) {
              return g(def)(f);
          };
      };
  };
  var toJsonType = verbJsonType(Data_Maybe.Nothing.value)(Data_Maybe.Just.create);
  var isJsonType = verbJsonType(false)(Data_Function["const"](true));
  var ordJson = new Data_Ord.Ord(function () {
      return eqJson;
  }, function (a) {
      return function (b) {
          return $foreign["_compare"](Data_Ordering.EQ.value, Data_Ordering.GT.value, Data_Ordering.LT.value, a, b);
      };
  });
  var eqJson = new Data_Eq.Eq(function (j1) {
      return function (j2) {
          return Data_Eq.eq(Data_Ordering.eqOrdering)(Data_Ord.compare(ordJson)(j1)(j2))(Data_Ordering.EQ.value);
      };
  });
  var caseJsonString = function (d) {
      return function (f) {
          return function (j) {
              return $foreign["_caseJson"](Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), f, Data_Function["const"](d), Data_Function["const"](d), j);
          };
      };
  };                                        
  var toString = toJsonType(caseJsonString);
  var caseJsonObject = function (d) {
      return function (f) {
          return function (j) {
              return $foreign["_caseJson"](Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), f, j);
          };
      };
  };                                        
  var toObject = toJsonType(caseJsonObject);
  var caseJsonNumber = function (d) {
      return function (f) {
          return function (j) {
              return $foreign["_caseJson"](Data_Function["const"](d), Data_Function["const"](d), f, Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), j);
          };
      };
  };                                        
  var caseJsonNull = function (d) {
      return function (f) {
          return function (j) {
              return $foreign["_caseJson"](f, Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), j);
          };
      };
  };
  var isNull = isJsonType(caseJsonNull);
  var caseJsonBoolean = function (d) {
      return function (f) {
          return function (j) {
              return $foreign["_caseJson"](Data_Function["const"](d), f, Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), j);
          };
      };
  };                                          
  var caseJsonArray = function (d) {
      return function (f) {
          return function (j) {
              return $foreign["_caseJson"](Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), Data_Function["const"](d), f, Data_Function["const"](d), j);
          };
      };
  };                                      
  var toArray = toJsonType(caseJsonArray);
  exports["caseJsonNull"] = caseJsonNull;
  exports["caseJsonBoolean"] = caseJsonBoolean;
  exports["caseJsonNumber"] = caseJsonNumber;
  exports["caseJsonString"] = caseJsonString;
  exports["isNull"] = isNull;
  exports["toString"] = toString;
  exports["toArray"] = toArray;
  exports["toObject"] = toObject;
  exports["eqJson"] = eqJson;
  exports["fromBoolean"] = $foreign.fromBoolean;
  exports["fromNumber"] = $foreign.fromNumber;
  exports["fromString"] = $foreign.fromString;
  exports["fromArray"] = $foreign.fromArray;
  exports["fromObject"] = $foreign.fromObject;
  exports["jsonNull"] = $foreign.jsonNull;
  exports["stringify"] = $foreign.stringify;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Applicative"] = $PS["Control.Applicative"] || {};
  var exports = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Data_Unit = $PS["Data.Unit"];                  
  var Applicative = function (Apply0, pure) {
      this.Apply0 = Apply0;
      this.pure = pure;
  };
  var pure = function (dict) {
      return dict.pure;
  };
  var unless = function (dictApplicative) {
      return function (v) {
          return function (v1) {
              if (!v) {
                  return v1;
              };
              if (v) {
                  return pure(dictApplicative)(Data_Unit.unit);
              };
              throw new Error("Failed pattern match at Control.Applicative (line 66, column 1 - line 66, column 65): " + [ v.constructor.name, v1.constructor.name ]);
          };
      };
  };
  var when = function (dictApplicative) {
      return function (v) {
          return function (v1) {
              if (v) {
                  return v1;
              };
              if (!v) {
                  return pure(dictApplicative)(Data_Unit.unit);
              };
              throw new Error("Failed pattern match at Control.Applicative (line 61, column 1 - line 61, column 63): " + [ v.constructor.name, v1.constructor.name ]);
          };
      };
  };
  var liftA1 = function (dictApplicative) {
      return function (f) {
          return function (a) {
              return Control_Apply.apply(dictApplicative.Apply0())(pure(dictApplicative)(f))(a);
          };
      };
  }; 
  var applicativeArray = new Applicative(function () {
      return Control_Apply.applyArray;
  }, function (x) {
      return [ x ];
  });
  exports["Applicative"] = Applicative;
  exports["pure"] = pure;
  exports["liftA1"] = liftA1;
  exports["unless"] = unless;
  exports["when"] = when;
  exports["applicativeArray"] = applicativeArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Decode.Error"] = $PS["Data.Argonaut.Decode.Error"] || {};
  var exports = $PS["Data.Argonaut.Decode.Error"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Show = $PS["Data.Show"];                
  var TypeMismatch = (function () {
      function TypeMismatch(value0) {
          this.value0 = value0;
      };
      TypeMismatch.create = function (value0) {
          return new TypeMismatch(value0);
      };
      return TypeMismatch;
  })();
  var UnexpectedValue = (function () {
      function UnexpectedValue(value0) {
          this.value0 = value0;
      };
      UnexpectedValue.create = function (value0) {
          return new UnexpectedValue(value0);
      };
      return UnexpectedValue;
  })();
  var AtIndex = (function () {
      function AtIndex(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      AtIndex.create = function (value0) {
          return function (value1) {
              return new AtIndex(value0, value1);
          };
      };
      return AtIndex;
  })();
  var AtKey = (function () {
      function AtKey(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      AtKey.create = function (value0) {
          return function (value1) {
              return new AtKey(value0, value1);
          };
      };
      return AtKey;
  })();
  var Named = (function () {
      function Named(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Named.create = function (value0) {
          return function (value1) {
              return new Named(value0, value1);
          };
      };
      return Named;
  })();
  var MissingValue = (function () {
      function MissingValue() {

      };
      MissingValue.value = new MissingValue();
      return MissingValue;
  })();
  var showJsonDecodeError = new Data_Show.Show(function (v) {
      if (v instanceof TypeMismatch) {
          return "(TypeMismatch " + (Data_Show.show(Data_Show.showString)(v.value0) + ")");
      };
      if (v instanceof UnexpectedValue) {
          return "(UnexpectedValue " + (Data_Argonaut_Core.stringify(v.value0) + ")");
      };
      if (v instanceof AtIndex) {
          return "(AtIndex " + (Data_Show.show(Data_Show.showInt)(v.value0) + (" " + (Data_Show.show(showJsonDecodeError)(v.value1) + ")")));
      };
      if (v instanceof AtKey) {
          return "(AtKey " + (Data_Show.show(Data_Show.showString)(v.value0) + (" " + (Data_Show.show(showJsonDecodeError)(v.value1) + ")")));
      };
      if (v instanceof Named) {
          return "(Named " + (Data_Show.show(Data_Show.showString)(v.value0) + (" " + (Data_Show.show(showJsonDecodeError)(v.value1) + ")")));
      };
      if (v instanceof MissingValue) {
          return "MissingValue";
      };
      throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 24, column 10 - line 30, column 35): " + [ v.constructor.name ]);
  });
  exports["TypeMismatch"] = TypeMismatch;
  exports["UnexpectedValue"] = UnexpectedValue;
  exports["AtIndex"] = AtIndex;
  exports["AtKey"] = AtKey;
  exports["Named"] = Named;
  exports["MissingValue"] = MissingValue;
  exports["showJsonDecodeError"] = showJsonDecodeError;
})(PS);
(function(exports) {
  "use strict";

  //------------------------------------------------------------------------------
  // Array creation --------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.range = function (start) {
    return function (end) {
      var step = start > end ? -1 : 1;
      var result = new Array(step * (end - start) + 1);
      var i = start, n = 0;
      while (i !== end) {
        result[n++] = i;
        i += step;
      }
      result[n] = i;
      return result;
    };
  };

  var replicateFill = function (count) {
    return function (value) {
      if (count < 1) {
        return [];
      }
      var result = new Array(count);
      return result.fill(value);
    };
  };

  var replicatePolyfill = function (count) {
    return function (value) {
      var result = [];
      var n = 0;
      for (var i = 0; i < count; i++) {
        result[n++] = value;
      }
      return result;
    };
  };

  // In browsers that have Array.prototype.fill we use it, as it's faster.
  exports.replicate = typeof Array.prototype.fill === "function" ? replicateFill : replicatePolyfill;

  //------------------------------------------------------------------------------
  // Array size ------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.length = function (xs) {
    return xs.length;
  };

  //------------------------------------------------------------------------------
  // Non-indexed reads -----------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.unconsImpl = function (empty) {
    return function (next) {
      return function (xs) {
        return xs.length === 0 ? empty({}) : next(xs[0])(xs.slice(1));
      };
    };
  };

  //------------------------------------------------------------------------------
  // Indexed operations ----------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.indexImpl = function (just) {
    return function (nothing) {
      return function (xs) {
        return function (i) {
          return i < 0 || i >= xs.length ? nothing :  just(xs[i]);
        };
      };
    };
  };

  exports.findIndexImpl = function (just) {
    return function (nothing) {
      return function (f) {
        return function (xs) {
          for (var i = 0, l = xs.length; i < l; i++) {
            if (f(xs[i])) return just(i);
          }
          return nothing;
        };
      };
    };
  };

  exports._deleteAt = function (just) {
    return function (nothing) {
      return function (i) {
        return function (l) {
          if (i < 0 || i >= l.length) return nothing;
          var l1 = l.slice();
          l1.splice(i, 1);
          return just(l1);
        };
      };
    };
  };

  exports._updateAt = function (just) {
    return function (nothing) {
      return function (i) {
        return function (a) {
          return function (l) {
            if (i < 0 || i >= l.length) return nothing;
            var l1 = l.slice();
            l1[i] = a;
            return just(l1);
          };
        };
      };
    };
  };

  //------------------------------------------------------------------------------
  // Transformations -------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.reverse = function (l) {
    return l.slice().reverse();
  };

  exports.filter = function (f) {
    return function (xs) {
      return xs.filter(f);
    };
  };

  //------------------------------------------------------------------------------
  // Sorting ---------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.sortByImpl = (function () {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
      var mid;
      var i;
      var j;
      var k;
      var x;
      var y;
      var c;

      mid = from + ((to - from) >> 1);
      if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
      if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);

      i = from;
      j = mid;
      k = from;
      while (i < mid && j < to) {
        x = xs2[i];
        y = xs2[j];
        c = fromOrdering(compare(x)(y));
        if (c > 0) {
          xs1[k++] = y;
          ++j;
        }
        else {
          xs1[k++] = x;
          ++i;
        }
      }
      while (i < mid) {
        xs1[k++] = xs2[i++];
      }
      while (j < to) {
        xs1[k++] = xs2[j++];
      }
    }

    return function (compare) {
      return function (fromOrdering) {
        return function (xs) {
          var out;

          if (xs.length < 2) return xs;

          out = xs.slice(0);
          mergeFromTo(compare, fromOrdering, out, xs.slice(0), 0, xs.length);

          return out;
        };
      };
    };
  })();

  //------------------------------------------------------------------------------
  // Subarrays -------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.slice = function (s) {
    return function (e) {
      return function (l) {
        return l.slice(s, e);
      };
    };
  };

  //------------------------------------------------------------------------------
  // Zipping ---------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.zipWith = function (f) {
    return function (xs) {
      return function (ys) {
        var l = xs.length < ys.length ? xs.length : ys.length;
        var result = new Array(l);
        for (var i = 0; i < l; i++) {
          result[i] = f(xs[i])(ys[i]);
        }
        return result;
      };
    };
  };

  exports.all = function (p) {
    return function (xs) {
      var len = xs.length;
      for (var i = 0; i < len; i++) {
        if (!p(xs[i])) return false;
      }
      return true;
    };
  };

  //------------------------------------------------------------------------------
  // Partial ---------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.unsafeIndexImpl = function (xs) {
    return function (n) {
      return xs[n];
    };
  };
})(PS["Data.Array"] = PS["Data.Array"] || {});
(function(exports) {
  "use strict";

  exports.map_ = function (f) {
    return function (a) {
      return function () {
        return f(a());
      };
    };
  };

  exports.pure_ = function (a) {
    return function () {
      return a;
    };
  };

  exports.bind_ = function (a) {
    return function (f) {
      return function () {
        return f(a())();
      };
    };
  };

  exports.foreach = function (as) {
    return function (f) {
      return function () {
        for (var i = 0, l = as.length; i < l; i++) {
          f(as[i])();
        }
      };
    };
  };
})(PS["Control.Monad.ST.Internal"] = PS["Control.Monad.ST.Internal"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad"] = $PS["Control.Monad"] || {};
  var exports = $PS["Control.Monad"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];                
  var Monad = function (Applicative0, Bind1) {
      this.Applicative0 = Applicative0;
      this.Bind1 = Bind1;
  };
  var unlessM = function (dictMonad) {
      return function (mb) {
          return function (m) {
              return Control_Bind.bind(dictMonad.Bind1())(mb)(function (b) {
                  return Control_Applicative.unless(dictMonad.Applicative0())(b)(m);
              });
          };
      };
  };
  var ap = function (dictMonad) {
      return function (f) {
          return function (a) {
              return Control_Bind.bind(dictMonad.Bind1())(f)(function (f$prime) {
                  return Control_Bind.bind(dictMonad.Bind1())(a)(function (a$prime) {
                      return Control_Applicative.pure(dictMonad.Applicative0())(f$prime(a$prime));
                  });
              });
          };
      };
  };
  exports["Monad"] = Monad;
  exports["unlessM"] = unlessM;
  exports["ap"] = ap;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.ST.Internal"] = $PS["Control.Monad.ST.Internal"] || {};
  var exports = $PS["Control.Monad.ST.Internal"];
  var $foreign = $PS["Control.Monad.ST.Internal"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Data_Functor = $PS["Data.Functor"];
  var functorST = new Data_Functor.Functor($foreign.map_);
  var monadST = new Control_Monad.Monad(function () {
      return applicativeST;
  }, function () {
      return bindST;
  });
  var bindST = new Control_Bind.Bind(function () {
      return applyST;
  }, $foreign.bind_);
  var applyST = new Control_Apply.Apply(function () {
      return functorST;
  }, Control_Monad.ap(monadST));
  var applicativeST = new Control_Applicative.Applicative(function () {
      return applyST;
  }, $foreign.pure_);
  exports["functorST"] = functorST;
  exports["applicativeST"] = applicativeST;
  exports["foreach"] = $foreign.foreach;
})(PS);
(function(exports) {
  "use strict";

  exports.pushAll = function (as) {
    return function (xs) {
      return function () {
        return xs.push.apply(xs, as);
      };
    };
  };

  exports.unsafeFreeze = function (xs) {
    return function () {
      return xs;
    };
  };

  exports.unsafeThaw = function (xs) {
    return function () {
      return xs;
    };
  };

  function copyImpl(xs) {
    return function () {
      return xs.slice();
    };
  }
})(PS["Data.Array.ST"] = PS["Data.Array.ST"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Array.ST"] = $PS["Data.Array.ST"] || {};
  var exports = $PS["Data.Array.ST"];
  var $foreign = $PS["Data.Array.ST"];
  var push = function (a) {
      return $foreign.pushAll([ a ]);
  };
  exports["push"] = push;
  exports["unsafeFreeze"] = $foreign.unsafeFreeze;
  exports["unsafeThaw"] = $foreign.unsafeThaw;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Boolean"] = $PS["Data.Boolean"] || {};
  var exports = $PS["Data.Boolean"];
  var otherwise = true;
  exports["otherwise"] = otherwise;
})(PS);
(function(exports) {
  "use strict";

  exports.foldrArray = function (f) {
    return function (init) {
      return function (xs) {
        var acc = init;
        var len = xs.length;
        for (var i = len - 1; i >= 0; i--) {
          acc = f(xs[i])(acc);
        }
        return acc;
      };
    };
  };

  exports.foldlArray = function (f) {
    return function (init) {
      return function (xs) {
        var acc = init;
        var len = xs.length;
        for (var i = 0; i < len; i++) {
          acc = f(acc)(xs[i]);
        }
        return acc;
      };
    };
  };
})(PS["Data.Foldable"] = PS["Data.Foldable"] || {});
(function(exports) {
  "use strict";

  exports.boolConj = function (b1) {
    return function (b2) {
      return b1 && b2;
    };
  };

  exports.boolDisj = function (b1) {
    return function (b2) {
      return b1 || b2;
    };
  };

  exports.boolNot = function (b) {
    return !b;
  };
})(PS["Data.HeytingAlgebra"] = PS["Data.HeytingAlgebra"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.HeytingAlgebra"] = $PS["Data.HeytingAlgebra"] || {};
  var exports = $PS["Data.HeytingAlgebra"];
  var $foreign = $PS["Data.HeytingAlgebra"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Record_Unsafe = $PS["Record.Unsafe"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var HeytingAlgebraRecord = function (conjRecord, disjRecord, ffRecord, impliesRecord, notRecord, ttRecord) {
      this.conjRecord = conjRecord;
      this.disjRecord = disjRecord;
      this.ffRecord = ffRecord;
      this.impliesRecord = impliesRecord;
      this.notRecord = notRecord;
      this.ttRecord = ttRecord;
  };
  var HeytingAlgebra = function (conj, disj, ff, implies, not, tt) {
      this.conj = conj;
      this.disj = disj;
      this.ff = ff;
      this.implies = implies;
      this.not = not;
      this.tt = tt;
  };
  var ttRecord = function (dict) {
      return dict.ttRecord;
  };
  var tt = function (dict) {
      return dict.tt;
  };
  var notRecord = function (dict) {
      return dict.notRecord;
  };
  var not = function (dict) {
      return dict.not;
  };
  var impliesRecord = function (dict) {
      return dict.impliesRecord;
  };
  var implies = function (dict) {
      return dict.implies;
  };                 
  var heytingAlgebraRecordNil = new HeytingAlgebraRecord(function (v) {
      return function (v1) {
          return function (v2) {
              return {};
          };
      };
  }, function (v) {
      return function (v1) {
          return function (v2) {
              return {};
          };
      };
  }, function (v) {
      return function (v1) {
          return {};
      };
  }, function (v) {
      return function (v1) {
          return function (v2) {
              return {};
          };
      };
  }, function (v) {
      return function (v1) {
          return {};
      };
  }, function (v) {
      return function (v1) {
          return {};
      };
  });                           
  var ffRecord = function (dict) {
      return dict.ffRecord;
  };
  var ff = function (dict) {
      return dict.ff;
  };
  var disjRecord = function (dict) {
      return dict.disjRecord;
  };
  var disj = function (dict) {
      return dict.disj;
  };
  var heytingAlgebraBoolean = new HeytingAlgebra($foreign.boolConj, $foreign.boolDisj, false, function (a) {
      return function (b) {
          return disj(heytingAlgebraBoolean)(not(heytingAlgebraBoolean)(a))(b);
      };
  }, $foreign.boolNot, true);
  var conjRecord = function (dict) {
      return dict.conjRecord;
  };
  var heytingAlgebraRecord = function (dictRowToList) {
      return function (dictHeytingAlgebraRecord) {
          return new HeytingAlgebra(conjRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value), disjRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value), ffRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value), impliesRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value), notRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value), ttRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value));
      };
  };
  var conj = function (dict) {
      return dict.conj;
  };
  var heytingAlgebraFunction = function (dictHeytingAlgebra) {
      return new HeytingAlgebra(function (f) {
          return function (g) {
              return function (a) {
                  return conj(dictHeytingAlgebra)(f(a))(g(a));
              };
          };
      }, function (f) {
          return function (g) {
              return function (a) {
                  return disj(dictHeytingAlgebra)(f(a))(g(a));
              };
          };
      }, function (v) {
          return ff(dictHeytingAlgebra);
      }, function (f) {
          return function (g) {
              return function (a) {
                  return implies(dictHeytingAlgebra)(f(a))(g(a));
              };
          };
      }, function (f) {
          return function (a) {
              return not(dictHeytingAlgebra)(f(a));
          };
      }, function (v) {
          return tt(dictHeytingAlgebra);
      });
  };
  var heytingAlgebraRecordCons = function (dictIsSymbol) {
      return function (dictCons) {
          return function (dictHeytingAlgebraRecord) {
              return function (dictHeytingAlgebra) {
                  return new HeytingAlgebraRecord(function (v) {
                      return function (ra) {
                          return function (rb) {
                              var tail = conjRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(ra)(rb);
                              var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                              var insert = Record_Unsafe.unsafeSet(key);
                              var get = Record_Unsafe.unsafeGet(key);
                              return insert(conj(dictHeytingAlgebra)(get(ra))(get(rb)))(tail);
                          };
                      };
                  }, function (v) {
                      return function (ra) {
                          return function (rb) {
                              var tail = disjRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(ra)(rb);
                              var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                              var insert = Record_Unsafe.unsafeSet(key);
                              var get = Record_Unsafe.unsafeGet(key);
                              return insert(disj(dictHeytingAlgebra)(get(ra))(get(rb)))(tail);
                          };
                      };
                  }, function (v) {
                      return function (row) {
                          var tail = ffRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(row);
                          var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                          var insert = Record_Unsafe.unsafeSet(key);
                          return insert(ff(dictHeytingAlgebra))(tail);
                      };
                  }, function (v) {
                      return function (ra) {
                          return function (rb) {
                              var tail = impliesRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(ra)(rb);
                              var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                              var insert = Record_Unsafe.unsafeSet(key);
                              var get = Record_Unsafe.unsafeGet(key);
                              return insert(implies(dictHeytingAlgebra)(get(ra))(get(rb)))(tail);
                          };
                      };
                  }, function (v) {
                      return function (row) {
                          var tail = notRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(row);
                          var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                          var insert = Record_Unsafe.unsafeSet(key);
                          var get = Record_Unsafe.unsafeGet(key);
                          return insert(not(dictHeytingAlgebra)(get(row)))(tail);
                      };
                  }, function (v) {
                      return function (row) {
                          var tail = ttRecord(dictHeytingAlgebraRecord)(Type_Proxy["Proxy"].value)(row);
                          var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                          var insert = Record_Unsafe.unsafeSet(key);
                          return insert(tt(dictHeytingAlgebra))(tail);
                      };
                  });
              };
          };
      };
  };
  exports["HeytingAlgebra"] = HeytingAlgebra;
  exports["tt"] = tt;
  exports["ff"] = ff;
  exports["conj"] = conj;
  exports["disj"] = disj;
  exports["not"] = not;
  exports["heytingAlgebraBoolean"] = heytingAlgebraBoolean;
  exports["heytingAlgebraFunction"] = heytingAlgebraFunction;
  exports["heytingAlgebraRecord"] = heytingAlgebraRecord;
  exports["heytingAlgebraRecordNil"] = heytingAlgebraRecordNil;
  exports["heytingAlgebraRecordCons"] = heytingAlgebraRecordCons;
})(PS);
(function(exports) {
  "use strict";

  exports.concatString = function (s1) {
    return function (s2) {
      return s1 + s2;
    };
  };

  exports.concatArray = function (xs) {
    return function (ys) {
      if (xs.length === 0) return ys;
      if (ys.length === 0) return xs;
      return xs.concat(ys);
    };
  };
})(PS["Data.Semigroup"] = PS["Data.Semigroup"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Semigroup"] = $PS["Data.Semigroup"] || {};
  var exports = $PS["Data.Semigroup"];
  var $foreign = $PS["Data.Semigroup"];
  var Semigroup = function (append) {
      this.append = append;
  }; 
  var semigroupString = new Semigroup($foreign.concatString);
  var semigroupArray = new Semigroup($foreign.concatArray);
  var append = function (dict) {
      return dict.append;
  };
  var semigroupFn = function (dictSemigroup) {
      return new Semigroup(function (f) {
          return function (g) {
              return function (x) {
                  return append(dictSemigroup)(f(x))(g(x));
              };
          };
      });
  };
  exports["Semigroup"] = Semigroup;
  exports["append"] = append;
  exports["semigroupString"] = semigroupString;
  exports["semigroupFn"] = semigroupFn;
  exports["semigroupArray"] = semigroupArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Monoid"] = $PS["Data.Monoid"] || {};
  var exports = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Monoid = function (Semigroup0, mempty) {
      this.Semigroup0 = Semigroup0;
      this.mempty = mempty;
  };                 
  var monoidString = new Monoid(function () {
      return Data_Semigroup.semigroupString;
  }, "");                    
  var monoidArray = new Monoid(function () {
      return Data_Semigroup.semigroupArray;
  }, [  ]);
  var mempty = function (dict) {
      return dict.mempty;
  };
  var monoidFn = function (dictMonoid) {
      return new Monoid(function () {
          return Data_Semigroup.semigroupFn(dictMonoid.Semigroup0());
      }, function (v) {
          return mempty(dictMonoid);
      });
  };
  exports["Monoid"] = Monoid;
  exports["mempty"] = mempty;
  exports["monoidFn"] = monoidFn;
  exports["monoidString"] = monoidString;
  exports["monoidArray"] = monoidArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Monoid.Disj"] = $PS["Data.Monoid.Disj"] || {};
  var exports = $PS["Data.Monoid.Disj"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];      
  var Disj = function (x) {
      return x;
  };
  var semigroupDisj = function (dictHeytingAlgebra) {
      return new Data_Semigroup.Semigroup(function (v) {
          return function (v1) {
              return Data_HeytingAlgebra.disj(dictHeytingAlgebra)(v)(v1);
          };
      });
  };
  var monoidDisj = function (dictHeytingAlgebra) {
      return new Data_Monoid.Monoid(function () {
          return semigroupDisj(dictHeytingAlgebra);
      }, Data_HeytingAlgebra.ff(dictHeytingAlgebra));
  };
  exports["Disj"] = Disj;
  exports["monoidDisj"] = monoidDisj;
})(PS);
(function(exports) {
  "use strict";

  // module Unsafe.Coerce

  exports.unsafeCoerce = function (x) {
    return x;
  };
})(PS["Unsafe.Coerce"] = PS["Unsafe.Coerce"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Unsafe.Coerce"] = $PS["Unsafe.Coerce"] || {};
  var exports = $PS["Unsafe.Coerce"];
  var $foreign = $PS["Unsafe.Coerce"];
  exports["unsafeCoerce"] = $foreign.unsafeCoerce;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Safe.Coerce"] = $PS["Safe.Coerce"] || {};
  var exports = $PS["Safe.Coerce"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var coerce = function (dictCoercible) {
      return Unsafe_Coerce.unsafeCoerce;
  };
  exports["coerce"] = coerce;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Newtype"] = $PS["Data.Newtype"] || {};
  var exports = $PS["Data.Newtype"];
  var Safe_Coerce = $PS["Safe.Coerce"];
  var wrap = function (dictNewtype) {
      return Safe_Coerce.coerce();
  };
  var unwrap = function (dictNewtype) {
      return Safe_Coerce.coerce();
  };
  var under = function (dictNewtype) {
      return function (dictNewtype1) {
          return function (v) {
              return Safe_Coerce.coerce();
          };
      };
  };
  var over = function (dictNewtype) {
      return function (dictNewtype1) {
          return function (v) {
              return Safe_Coerce.coerce();
          };
      };
  };
  var alaF = function (dictCoercible) {
      return function (dictCoercible1) {
          return function (dictNewtype) {
              return function (dictNewtype1) {
                  return function (v) {
                      return Safe_Coerce.coerce();
                  };
              };
          };
      };
  };
  exports["wrap"] = wrap;
  exports["unwrap"] = unwrap;
  exports["alaF"] = alaF;
  exports["over"] = over;
  exports["under"] = under;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Foldable"] = $PS["Data.Foldable"] || {};
  var exports = $PS["Data.Foldable"];
  var $foreign = $PS["Data.Foldable"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Function = $PS["Data.Function"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Monoid_Disj = $PS["Data.Monoid.Disj"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Unit = $PS["Data.Unit"];                
  var Foldable = function (foldMap, foldl, foldr) {
      this.foldMap = foldMap;
      this.foldl = foldl;
      this.foldr = foldr;
  };
  var foldr = function (dict) {
      return dict.foldr;
  };
  var $$null = function (dictFoldable) {
      return foldr(dictFoldable)(function (v) {
          return function (v1) {
              return false;
          };
      })(true);
  };
  var traverse_ = function (dictApplicative) {
      return function (dictFoldable) {
          return function (f) {
              return foldr(dictFoldable)((function () {
                  var $313 = Control_Apply.applySecond(dictApplicative.Apply0());
                  return function ($314) {
                      return $313(f($314));
                  };
              })())(Control_Applicative.pure(dictApplicative)(Data_Unit.unit));
          };
      };
  };
  var for_ = function (dictApplicative) {
      return function (dictFoldable) {
          return Data_Function.flip(traverse_(dictApplicative)(dictFoldable));
      };
  };
  var foldl = function (dict) {
      return dict.foldl;
  };
  var intercalate = function (dictFoldable) {
      return function (dictMonoid) {
          return function (sep) {
              return function (xs) {
                  var go = function (v) {
                      return function (x) {
                          if (v.init) {
                              return {
                                  init: false,
                                  acc: x
                              };
                          };
                          return {
                              init: false,
                              acc: Data_Semigroup.append(dictMonoid.Semigroup0())(v.acc)(Data_Semigroup.append(dictMonoid.Semigroup0())(sep)(x))
                          };
                      };
                  };
                  return (foldl(dictFoldable)(go)({
                      init: true,
                      acc: Data_Monoid.mempty(dictMonoid)
                  })(xs)).acc;
              };
          };
      };
  };
  var length = function (dictFoldable) {
      return function (dictSemiring) {
          return foldl(dictFoldable)(function (c) {
              return function (v) {
                  return Data_Semiring.add(dictSemiring)(Data_Semiring.one(dictSemiring))(c);
              };
          })(Data_Semiring.zero(dictSemiring));
      };
  };
  var maximumBy = function (dictFoldable) {
      return function (cmp) {
          var max$prime = function (v) {
              return function (v1) {
                  if (v instanceof Data_Maybe.Nothing) {
                      return new Data_Maybe.Just(v1);
                  };
                  if (v instanceof Data_Maybe.Just) {
                      return new Data_Maybe.Just((function () {
                          var $162 = Data_Eq.eq(Data_Ordering.eqOrdering)(cmp(v.value0)(v1))(Data_Ordering.GT.value);
                          if ($162) {
                              return v.value0;
                          };
                          return v1;
                      })());
                  };
                  throw new Error("Failed pattern match at Data.Foldable (line 441, column 3 - line 441, column 27): " + [ v.constructor.name, v1.constructor.name ]);
              };
          };
          return foldl(dictFoldable)(max$prime)(Data_Maybe.Nothing.value);
      };
  };
  var maximum = function (dictOrd) {
      return function (dictFoldable) {
          return maximumBy(dictFoldable)(Data_Ord.compare(dictOrd));
      };
  };
  var sum = function (dictFoldable) {
      return function (dictSemiring) {
          return foldl(dictFoldable)(Data_Semiring.add(dictSemiring))(Data_Semiring.zero(dictSemiring));
      };
  }; 
  var foldableMaybe = new Foldable(function (dictMonoid) {
      return function (v) {
          return function (v1) {
              if (v1 instanceof Data_Maybe.Nothing) {
                  return Data_Monoid.mempty(dictMonoid);
              };
              if (v1 instanceof Data_Maybe.Just) {
                  return v(v1.value0);
              };
              throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [ v.constructor.name, v1.constructor.name ]);
          };
      };
  }, function (v) {
      return function (z) {
          return function (v1) {
              if (v1 instanceof Data_Maybe.Nothing) {
                  return z;
              };
              if (v1 instanceof Data_Maybe.Just) {
                  return v(z)(v1.value0);
              };
              throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [ v.constructor.name, z.constructor.name, v1.constructor.name ]);
          };
      };
  }, function (v) {
      return function (z) {
          return function (v1) {
              if (v1 instanceof Data_Maybe.Nothing) {
                  return z;
              };
              if (v1 instanceof Data_Maybe.Just) {
                  return v(v1.value0)(z);
              };
              throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [ v.constructor.name, z.constructor.name, v1.constructor.name ]);
          };
      };
  });
  var foldMapDefaultR = function (dictFoldable) {
      return function (dictMonoid) {
          return function (f) {
              return foldr(dictFoldable)(function (x) {
                  return function (acc) {
                      return Data_Semigroup.append(dictMonoid.Semigroup0())(f(x))(acc);
                  };
              })(Data_Monoid.mempty(dictMonoid));
          };
      };
  };
  var foldableArray = new Foldable(function (dictMonoid) {
      return foldMapDefaultR(foldableArray)(dictMonoid);
  }, $foreign.foldlArray, $foreign.foldrArray);
  var foldMap = function (dict) {
      return dict.foldMap;
  };
  var foldM = function (dictFoldable) {
      return function (dictMonad) {
          return function (f) {
              return function (b0) {
                  return foldl(dictFoldable)(function (b) {
                      return function (a) {
                          return Control_Bind.bind(dictMonad.Bind1())(b)(Data_Function.flip(f)(a));
                      };
                  })(Control_Applicative.pure(dictMonad.Applicative0())(b0));
              };
          };
      };
  };
  var find = function (dictFoldable) {
      return function (p) {
          var go = function (v) {
              return function (v1) {
                  if (v instanceof Data_Maybe.Nothing && p(v1)) {
                      return new Data_Maybe.Just(v1);
                  };
                  return v;
              };
          };
          return foldl(dictFoldable)(go)(Data_Maybe.Nothing.value);
      };
  };
  var any = function (dictFoldable) {
      return function (dictHeytingAlgebra) {
          return Data_Newtype.alaF()()()()(Data_Monoid_Disj.Disj)(foldMap(dictFoldable)(Data_Monoid_Disj.monoidDisj(dictHeytingAlgebra)));
      };
  };
  var elem = function (dictFoldable) {
      return function (dictEq) {
          var $323 = any(dictFoldable)(Data_HeytingAlgebra.heytingAlgebraBoolean);
          var $324 = Data_Eq.eq(dictEq);
          return function ($325) {
              return $323($324($325));
          };
      };
  };
  var notElem = function (dictFoldable) {
      return function (dictEq) {
          return function (x) {
              var $326 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
              var $327 = elem(dictFoldable)(dictEq)(x);
              return function ($328) {
                  return $326($327($328));
              };
          };
      };
  };
  exports["Foldable"] = Foldable;
  exports["foldr"] = foldr;
  exports["foldl"] = foldl;
  exports["foldMap"] = foldMap;
  exports["foldM"] = foldM;
  exports["traverse_"] = traverse_;
  exports["for_"] = for_;
  exports["intercalate"] = intercalate;
  exports["any"] = any;
  exports["sum"] = sum;
  exports["elem"] = elem;
  exports["notElem"] = notElem;
  exports["find"] = find;
  exports["maximum"] = maximum;
  exports["maximumBy"] = maximumBy;
  exports["null"] = $$null;
  exports["length"] = length;
  exports["foldableArray"] = foldableArray;
  exports["foldableMaybe"] = foldableMaybe;
})(PS);
(function(exports) {
  "use strict";

  exports.unfoldrArrayImpl = function (isNothing) {
    return function (fromJust) {
      return function (fst) {
        return function (snd) {
          return function (f) {
            return function (b) {
              var result = [];
              var value = b;
              while (true) { // eslint-disable-line no-constant-condition
                var maybe = f(value);
                if (isNothing(maybe)) return result;
                var tuple = fromJust(maybe);
                result.push(fst(tuple));
                value = snd(tuple);
              }
            };
          };
        };
      };
    };
  };
})(PS["Data.Unfoldable"] = PS["Data.Unfoldable"] || {});
(function(exports) {
  "use strict";

  // jshint maxparams: 3

  exports.traverseArrayImpl = (function () {
    function array1(a) {
      return [a];
    }

    function array2(a) {
      return function (b) {
        return [a, b];
      };
    }

    function array3(a) {
      return function (b) {
        return function (c) {
          return [a, b, c];
        };
      };
    }

    function concat2(xs) {
      return function (ys) {
        return xs.concat(ys);
      };
    }

    return function (apply) {
      return function (map) {
        return function (pure) {
          return function (f) {
            return function (array) {
              function go(bot, top) {
                switch (top - bot) {
                case 0: return pure([]);
                case 1: return map(array1)(f(array[bot]));
                case 2: return apply(map(array2)(f(array[bot])))(f(array[bot + 1]));
                case 3: return apply(apply(map(array3)(f(array[bot])))(f(array[bot + 1])))(f(array[bot + 2]));
                default:
                  // This slightly tricky pivot selection aims to produce two
                  // even-length partitions where possible.
                  var pivot = bot + Math.floor((top - bot) / 4) * 2;
                  return apply(map(concat2)(go(bot, pivot)))(go(pivot, top));
                }
              }
              return go(0, array.length);
            };
          };
        };
      };
    };
  })();
})(PS["Data.Traversable"] = PS["Data.Traversable"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Traversable"] = $PS["Data.Traversable"] || {};
  var exports = $PS["Data.Traversable"];
  var $foreign = $PS["Data.Traversable"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Category = $PS["Control.Category"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];            
  var Traversable = function (Foldable1, Functor0, sequence, traverse) {
      this.Foldable1 = Foldable1;
      this.Functor0 = Functor0;
      this.sequence = sequence;
      this.traverse = traverse;
  };
  var traverse = function (dict) {
      return dict.traverse;
  }; 
  var sequenceDefault = function (dictTraversable) {
      return function (dictApplicative) {
          return traverse(dictTraversable)(dictApplicative)(Control_Category.identity(Control_Category.categoryFn));
      };
  };
  var traversableArray = new Traversable(function () {
      return Data_Foldable.foldableArray;
  }, function () {
      return Data_Functor.functorArray;
  }, function (dictApplicative) {
      return sequenceDefault(traversableArray)(dictApplicative);
  }, function (dictApplicative) {
      return $foreign.traverseArrayImpl(Control_Apply.apply(dictApplicative.Apply0()))(Data_Functor.map((dictApplicative.Apply0()).Functor0()))(Control_Applicative.pure(dictApplicative));
  });
  var sequence = function (dict) {
      return dict.sequence;
  };
  exports["traverse"] = traverse;
  exports["sequence"] = sequence;
  exports["traversableArray"] = traversableArray;
})(PS);
(function(exports) {
  "use strict";

  exports.unfoldr1ArrayImpl = function (isNothing) {
    return function (fromJust) {
      return function (fst) {
        return function (snd) {
          return function (f) {
            return function (b) {
              var result = [];
              var value = b;
              while (true) { // eslint-disable-line no-constant-condition
                var tuple = f(value);
                result.push(fst(tuple));
                var maybe = snd(tuple);
                if (isNothing(maybe)) return result;
                value = fromJust(maybe);
              }
            };
          };
        };
      };
    };
  };
})(PS["Data.Unfoldable1"] = PS["Data.Unfoldable1"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Unfoldable1"] = $PS["Data.Unfoldable1"] || {};
  var exports = $PS["Data.Unfoldable1"];
  var $foreign = $PS["Data.Unfoldable1"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Unfoldable1 = function (unfoldr1) {
      this.unfoldr1 = unfoldr1;
  }; 
  var unfoldable1Array = new Unfoldable1($foreign.unfoldr1ArrayImpl(Data_Maybe.isNothing)(Data_Maybe.fromJust())(Data_Tuple.fst)(Data_Tuple.snd));
  exports["Unfoldable1"] = Unfoldable1;
  exports["unfoldable1Array"] = unfoldable1Array;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Unfoldable"] = $PS["Data.Unfoldable"] || {};
  var exports = $PS["Data.Unfoldable"];
  var $foreign = $PS["Data.Unfoldable"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unfoldable1 = $PS["Data.Unfoldable1"];  
  var Unfoldable = function (Unfoldable10, unfoldr) {
      this.Unfoldable10 = Unfoldable10;
      this.unfoldr = unfoldr;
  };
  var unfoldr = function (dict) {
      return dict.unfoldr;
  }; 
  var unfoldableArray = new Unfoldable(function () {
      return Data_Unfoldable1.unfoldable1Array;
  }, $foreign.unfoldrArrayImpl(Data_Maybe.isNothing)(Data_Maybe.fromJust())(Data_Tuple.fst)(Data_Tuple.snd));
  var replicate = function (dictUnfoldable) {
      return function (n) {
          return function (v) {
              var step = function (i) {
                  var $7 = i <= 0;
                  if ($7) {
                      return Data_Maybe.Nothing.value;
                  };
                  return new Data_Maybe.Just(new Data_Tuple.Tuple(v, i - 1 | 0));
              };
              return unfoldr(dictUnfoldable)(step)(n);
          };
      };
  };
  var replicateA = function (dictApplicative) {
      return function (dictUnfoldable) {
          return function (dictTraversable) {
              return function (n) {
                  return function (m) {
                      return Data_Traversable.sequence(dictTraversable)(dictApplicative)(replicate(dictUnfoldable)(n)(m));
                  };
              };
          };
      };
  };
  exports["Unfoldable"] = Unfoldable;
  exports["unfoldr"] = unfoldr;
  exports["replicateA"] = replicateA;
  exports["unfoldableArray"] = unfoldableArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Array"] = $PS["Data.Array"] || {};
  var exports = $PS["Data.Array"];
  var $foreign = $PS["Data.Array"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_ST_Internal = $PS["Control.Monad.ST.Internal"];
  var Data_Array_ST = $PS["Data.Array.ST"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];
  var updateAt = $foreign["_updateAt"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var unsafeIndex = function (dictPartial) {
      return $foreign.unsafeIndexImpl;
  };
  var uncons = $foreign.unconsImpl(Data_Function["const"](Data_Maybe.Nothing.value))(function (x) {
      return function (xs) {
          return new Data_Maybe.Just({
              head: x,
              tail: xs
          });
      };
  });
  var toUnfoldable = function (dictUnfoldable) {
      return function (xs) {
          var len = $foreign.length(xs);
          var f = function (i) {
              if (i < len) {
                  return new Data_Maybe.Just(new Data_Tuple.Tuple(unsafeIndex()(xs)(i), i + 1 | 0));
              };
              if (Data_Boolean.otherwise) {
                  return Data_Maybe.Nothing.value;
              };
              throw new Error("Failed pattern match at Data.Array (line 158, column 3 - line 160, column 26): " + [ i.constructor.name ]);
          };
          return Data_Unfoldable.unfoldr(dictUnfoldable)(f)(0);
      };
  };
  var take = function (n) {
      return function (xs) {
          var $67 = n < 1;
          if ($67) {
              return [  ];
          };
          return $foreign.slice(0)(n)(xs);
      };
  };
  var tail = $foreign.unconsImpl(Data_Function["const"](Data_Maybe.Nothing.value))(function (v) {
      return function (xs) {
          return new Data_Maybe.Just(xs);
      };
  });
  var sortBy = function (comp) {
      return $foreign.sortByImpl(comp)(function (v) {
          if (v instanceof Data_Ordering.GT) {
              return 1;
          };
          if (v instanceof Data_Ordering.EQ) {
              return 0;
          };
          if (v instanceof Data_Ordering.LT) {
              return -1 | 0;
          };
          throw new Error("Failed pattern match at Data.Array (line 831, column 31 - line 834, column 11): " + [ v.constructor.name ]);
      });
  };
  var sortWith = function (dictOrd) {
      return function (f) {
          return sortBy(Data_Ord.comparing(dictOrd)(f));
      };
  };
  var singleton = function (a) {
      return [ a ];
  };
  var $$null = function (xs) {
      return $foreign.length(xs) === 0;
  };
  var mapWithIndex = function (f) {
      return function (xs) {
          return $foreign.zipWith(f)($foreign.range(0)($foreign.length(xs) - 1 | 0))(xs);
      };
  };
  var intercalate = function (dictMonoid) {
      return Data_Foldable.intercalate(Data_Foldable.foldableArray)(dictMonoid);
  };
  var index = $foreign.indexImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var last = function (xs) {
      return index(xs)($foreign.length(xs) - 1 | 0);
  };
  var span = function (p) {
      return function (arr) {
          var go = function ($copy_i) {
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(i) {
                  var v = index(arr)(i);
                  if (v instanceof Data_Maybe.Just) {
                      var $74 = p(v.value0);
                      if ($74) {
                          $copy_i = i + 1 | 0;
                          return;
                      };
                      $tco_done = true;
                      return new Data_Maybe.Just(i);
                  };
                  if (v instanceof Data_Maybe.Nothing) {
                      $tco_done = true;
                      return Data_Maybe.Nothing.value;
                  };
                  throw new Error("Failed pattern match at Data.Array (line 966, column 5 - line 968, column 25): " + [ v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($copy_i);
              };
              return $tco_result;
          };
          var breakIndex = go(0);
          if (breakIndex instanceof Data_Maybe.Just && breakIndex.value0 === 0) {
              return {
                  init: [  ],
                  rest: arr
              };
          };
          if (breakIndex instanceof Data_Maybe.Just) {
              return {
                  init: $foreign.slice(0)(breakIndex.value0)(arr),
                  rest: $foreign.slice(breakIndex.value0)($foreign.length(arr))(arr)
              };
          };
          if (breakIndex instanceof Data_Maybe.Nothing) {
              return {
                  init: arr,
                  rest: [  ]
              };
          };
          throw new Error("Failed pattern match at Data.Array (line 953, column 3 - line 959, column 30): " + [ breakIndex.constructor.name ]);
      };
  };
  var head = function (xs) {
      return index(xs)(0);
  };
  var nubBy = function (comp) {
      return function (xs) {
          var indexedAndSorted = sortBy(function (x) {
              return function (y) {
                  return comp(Data_Tuple.snd(x))(Data_Tuple.snd(y));
              };
          })(mapWithIndex(Data_Tuple.Tuple.create)(xs));
          var v = head(indexedAndSorted);
          if (v instanceof Data_Maybe.Nothing) {
              return [  ];
          };
          if (v instanceof Data_Maybe.Just) {
              return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(sortWith(Data_Ord.ordInt)(Data_Tuple.fst)((function __do() {
                  var result = Data_Array_ST.unsafeThaw(singleton(v.value0))();
                  Control_Monad_ST_Internal.foreach(indexedAndSorted)(function (v1) {
                      return function __do() {
                          var lst = Data_Functor.map(Control_Monad_ST_Internal.functorST)((function () {
                              var $102 = (function (dictPartial) {
                                  var $104 = Data_Maybe.fromJust();
                                  return function ($105) {
                                      return $104(last($105));
                                  };
                              })();
                              return function ($103) {
                                  return Data_Tuple.snd($102($103));
                              };
                          })())(Data_Array_ST.unsafeFreeze(result))();
                          return Control_Applicative.when(Control_Monad_ST_Internal.applicativeST)(Data_Eq.notEq(Data_Ordering.eqOrdering)(comp(lst)(v1.value1))(Data_Ordering.EQ.value))(Data_Functor["void"](Control_Monad_ST_Internal.functorST)(Data_Array_ST.push(v1)(result)))();
                      };
                  })();
                  return Data_Array_ST.unsafeFreeze(result)();
              })()));
          };
          throw new Error("Failed pattern match at Data.Array (line 1050, column 17 - line 1058, column 29): " + [ v.constructor.name ]);
      };
  };
  var nub = function (dictOrd) {
      return nubBy(Data_Ord.compare(dictOrd));
  };
  var foldr = Data_Foldable.foldr(Data_Foldable.foldableArray);
  var findIndex = $foreign.findIndexImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var find = function (f) {
      return function (xs) {
          return Data_Functor.map(Data_Maybe.functorMaybe)(unsafeIndex()(xs))(findIndex(f)(xs));
      };
  };
  var elemIndex = function (dictEq) {
      return function (x) {
          return findIndex(function (v) {
              return Data_Eq.eq(dictEq)(v)(x);
          });
      };
  };
  var elem = function (dictEq) {
      return function (a) {
          return function (arr) {
              return Data_Maybe.isJust(elemIndex(dictEq)(a)(arr));
          };
      };
  };
  var drop = function (n) {
      return function (xs) {
          var $89 = n < 1;
          if ($89) {
              return xs;
          };
          return $foreign.slice(n)($foreign.length(xs))(xs);
      };
  };
  var deleteAt = $foreign["_deleteAt"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var deleteBy = function (v) {
      return function (v1) {
          return function (v2) {
              if (v2.length === 0) {
                  return [  ];
              };
              return Data_Maybe.maybe(v2)(function (i) {
                  return Data_Maybe.fromJust()(deleteAt(i)(v2));
              })(findIndex(v(v1))(v2));
          };
      };
  };
  var cons = function (x) {
      return function (xs) {
          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ x ])(xs);
      };
  };
  var concatMap = Data_Function.flip(Control_Bind.bind(Control_Bind.bindArray));
  var mapMaybe = function (f) {
      return concatMap((function () {
          var $109 = Data_Maybe.maybe([  ])(singleton);
          return function ($110) {
              return $109(f($110));
          };
      })());
  };
  var catMaybes = mapMaybe(Control_Category.identity(Control_Category.categoryFn));
  exports["toUnfoldable"] = toUnfoldable;
  exports["null"] = $$null;
  exports["cons"] = cons;
  exports["head"] = head;
  exports["tail"] = tail;
  exports["uncons"] = uncons;
  exports["index"] = index;
  exports["elem"] = elem;
  exports["find"] = find;
  exports["findIndex"] = findIndex;
  exports["deleteAt"] = deleteAt;
  exports["updateAt"] = updateAt;
  exports["concatMap"] = concatMap;
  exports["catMaybes"] = catMaybes;
  exports["mapWithIndex"] = mapWithIndex;
  exports["foldr"] = foldr;
  exports["intercalate"] = intercalate;
  exports["take"] = take;
  exports["drop"] = drop;
  exports["span"] = span;
  exports["nub"] = nub;
  exports["deleteBy"] = deleteBy;
  exports["replicate"] = $foreign.replicate;
  exports["length"] = $foreign.length;
  exports["reverse"] = $foreign.reverse;
  exports["filter"] = $foreign.filter;
  exports["all"] = $foreign.all;
})(PS);
(function(exports) {
  "use strict";

  exports.mapWithIndexArray = function (f) {
    return function (xs) {
      var l = xs.length;
      var result = Array(l);
      for (var i = 0; i < l; i++) {
        result[i] = f(i)(xs[i]);
      }
      return result;
    };
  };
})(PS["Data.FunctorWithIndex"] = PS["Data.FunctorWithIndex"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.FunctorWithIndex"] = $PS["Data.FunctorWithIndex"] || {};
  var exports = $PS["Data.FunctorWithIndex"];
  var $foreign = $PS["Data.FunctorWithIndex"];
  var Data_Functor = $PS["Data.Functor"];          
  var FunctorWithIndex = function (Functor0, mapWithIndex) {
      this.Functor0 = Functor0;
      this.mapWithIndex = mapWithIndex;
  };
  var mapWithIndex = function (dict) {
      return dict.mapWithIndex;
  };
  var functorWithIndexArray = new FunctorWithIndex(function () {
      return Data_Functor.functorArray;
  }, $foreign.mapWithIndexArray);
  exports["mapWithIndex"] = mapWithIndex;
  exports["functorWithIndexArray"] = functorWithIndexArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Array.NonEmpty.Internal"] = $PS["Data.Array.NonEmpty.Internal"] || {};
  var exports = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Show = $PS["Data.Show"];
  var Data_Traversable = $PS["Data.Traversable"];                
  var NonEmptyArray = function (x) {
      return x;
  };                                                                                          
  var traversableNonEmptyArray = Data_Traversable.traversableArray;
  var showNonEmptyArray = function (dictShow) {
      return new Data_Show.Show(function (v) {
          return "(NonEmptyArray " + (Data_Show.show(Data_Show.showArray(dictShow))(v) + ")");
      });
  };                                                
  var functorWithIndexNonEmptyArray = Data_FunctorWithIndex.functorWithIndexArray;
  var functorNonEmptyArray = Data_Functor.functorArray;                              
  var foldableNonEmptyArray = Data_Foldable.foldableArray;
  exports["NonEmptyArray"] = NonEmptyArray;
  exports["showNonEmptyArray"] = showNonEmptyArray;
  exports["functorNonEmptyArray"] = functorNonEmptyArray;
  exports["functorWithIndexNonEmptyArray"] = functorWithIndexNonEmptyArray;
  exports["foldableNonEmptyArray"] = foldableNonEmptyArray;
  exports["traversableNonEmptyArray"] = traversableNonEmptyArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Plus"] = $PS["Control.Plus"] || {};
  var exports = $PS["Control.Plus"];                     
  var Plus = function (Alt0, empty) {
      this.Alt0 = Alt0;
      this.empty = empty;
  };       
  var empty = function (dict) {
      return dict.empty;
  };
  exports["Plus"] = Plus;
  exports["empty"] = empty;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.NonEmpty"] = $PS["Data.NonEmpty"] || {};
  var exports = $PS["Data.NonEmpty"];
  var Control_Plus = $PS["Control.Plus"];
  var Data_Functor = $PS["Data.Functor"];                        
  var NonEmpty = (function () {
      function NonEmpty(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      NonEmpty.create = function (value0) {
          return function (value1) {
              return new NonEmpty(value0, value1);
          };
      };
      return NonEmpty;
  })();
  var singleton = function (dictPlus) {
      return function (a) {
          return new NonEmpty(a, Control_Plus.empty(dictPlus));
      };
  };
  var functorNonEmpty = function (dictFunctor) {
      return new Data_Functor.Functor(function (f) {
          return function (m) {
              return new NonEmpty(f(m.value0), Data_Functor.map(dictFunctor)(f)(m.value1));
          };
      });
  };
  exports["NonEmpty"] = NonEmpty;
  exports["singleton"] = singleton;
  exports["functorNonEmpty"] = functorNonEmpty;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Array.NonEmpty"] = $PS["Data.Array.NonEmpty"] || {};
  var exports = $PS["Data.Array.NonEmpty"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var Data_Ord = $PS["Data.Ord"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var unsafeFromArrayF = Unsafe_Coerce.unsafeCoerce;
  var unsafeFromArray = Data_Array_NonEmpty_Internal.NonEmptyArray;
  var toArray = function (v) {
      return v;
  };   
  var updateAt = function (i) {
      return function (x) {
          var $56 = Data_Array.updateAt(i)(x);
          return function ($57) {
              return unsafeFromArrayF($56(toArray($57)));
          };
      };
  };
  var replicate = function (i) {
      return function (x) {
          return unsafeFromArray(Data_Array.replicate(Data_Ord.max(Data_Ord.ordInt)(1)(i))(x));
      };
  };
  var cons$prime = function (x) {
      return function (xs) {
          return unsafeFromArray(Data_Array.cons(x)(xs));
      };
  };
  var fromNonEmpty = function (v) {
      return cons$prime(v.value0)(v.value1);
  };
  var adaptMaybe = function (f) {
      var $75 = Data_Maybe.fromJust();
      return function ($76) {
          return $75(f(toArray($76)));
      };
  };
  var head = adaptMaybe(Data_Array.head);
  var tail = adaptMaybe(Data_Array.tail);
  var uncons = adaptMaybe(Data_Array.uncons);
  var toNonEmpty = function ($77) {
      return (function (v) {
          return new Data_NonEmpty.NonEmpty(v.head, v.tail);
      })(uncons($77));
  };                                         
  var adaptAny = function (f) {
      return function ($78) {
          return f(toArray($78));
      };
  };
  var index = adaptAny(Data_Array.index);
  var span = function (f) {
      return adaptAny(Data_Array.span(f));
  };
  var unsafeAdapt = function (f) {
      var $79 = adaptAny(f);
      return function ($80) {
          return unsafeFromArray($79($80));
      };
  };
  var cons = function (x) {
      return unsafeAdapt(Data_Array.cons(x));
  };
  var mapWithIndex = function (f) {
      return unsafeAdapt(Data_Array.mapWithIndex(f));
  };
  exports["fromNonEmpty"] = fromNonEmpty;
  exports["toArray"] = toArray;
  exports["toNonEmpty"] = toNonEmpty;
  exports["replicate"] = replicate;
  exports["cons'"] = cons$prime;
  exports["uncons"] = uncons;
  exports["index"] = index;
  exports["updateAt"] = updateAt;
  exports["mapWithIndex"] = mapWithIndex;
  exports["span"] = span;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Alt"] = $PS["Control.Alt"] || {};
  var exports = $PS["Control.Alt"];                          
  var Alt = function (Functor0, alt) {
      this.Functor0 = Functor0;
      this.alt = alt;
  };                                                       
  var alt = function (dict) {
      return dict.alt;
  };
  exports["Alt"] = Alt;
  exports["alt"] = alt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Either"] = $PS["Data.Either"] || {};
  var exports = $PS["Data.Either"];
  var Control_Alt = $PS["Control.Alt"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];              
  var Left = (function () {
      function Left(value0) {
          this.value0 = value0;
      };
      Left.create = function (value0) {
          return new Left(value0);
      };
      return Left;
  })();
  var Right = (function () {
      function Right(value0) {
          this.value0 = value0;
      };
      Right.create = function (value0) {
          return new Right(value0);
      };
      return Right;
  })();
  var note = function (a) {
      return Data_Maybe.maybe(new Left(a))(Right.create);
  }; 
  var functorEither = new Data_Functor.Functor(function (f) {
      return function (m) {
          if (m instanceof Left) {
              return new Left(m.value0);
          };
          if (m instanceof Right) {
              return new Right(f(m.value0));
          };
          throw new Error("Failed pattern match at Data.Either (line 31, column 1 - line 31, column 52): " + [ m.constructor.name ]);
      };
  });
  var either = function (v) {
      return function (v1) {
          return function (v2) {
              if (v2 instanceof Left) {
                  return v(v2.value0);
              };
              if (v2 instanceof Right) {
                  return v1(v2.value0);
              };
              throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
          };
      };
  };
  var applyEither = new Control_Apply.Apply(function () {
      return functorEither;
  }, function (v) {
      return function (v1) {
          if (v instanceof Left) {
              return new Left(v.value0);
          };
          if (v instanceof Right) {
              return Data_Functor.map(functorEither)(v.value0)(v1);
          };
          throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [ v.constructor.name, v1.constructor.name ]);
      };
  });
  var bindEither = new Control_Bind.Bind(function () {
      return applyEither;
  }, either(function (e) {
      return function (v) {
          return new Left(e);
      };
  })(function (a) {
      return function (f) {
          return f(a);
      };
  }));
  var applicativeEither = new Control_Applicative.Applicative(function () {
      return applyEither;
  }, Right.create);
  var altEither = new Control_Alt.Alt(function () {
      return functorEither;
  }, function (v) {
      return function (v1) {
          if (v instanceof Left) {
              return v1;
          };
          return v;
      };
  });
  exports["Left"] = Left;
  exports["Right"] = Right;
  exports["either"] = either;
  exports["note"] = note;
  exports["functorEither"] = functorEither;
  exports["applicativeEither"] = applicativeEither;
  exports["altEither"] = altEither;
  exports["bindEither"] = bindEither;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Bifunctor"] = $PS["Data.Bifunctor"] || {};
  var exports = $PS["Data.Bifunctor"];
  var Control_Category = $PS["Control.Category"];
  var Data_Either = $PS["Data.Either"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Bifunctor = function (bimap) {
      this.bimap = bimap;
  };
  var bimap = function (dict) {
      return dict.bimap;
  };
  var lmap = function (dictBifunctor) {
      return function (f) {
          return bimap(dictBifunctor)(f)(Control_Category.identity(Control_Category.categoryFn));
      };
  };
  var rmap = function (dictBifunctor) {
      return bimap(dictBifunctor)(Control_Category.identity(Control_Category.categoryFn));
  };
  var bifunctorTuple = new Bifunctor(function (f) {
      return function (g) {
          return function (v) {
              return new Data_Tuple.Tuple(f(v.value0), g(v.value1));
          };
      };
  });
  var bifunctorEither = new Bifunctor(function (v) {
      return function (v1) {
          return function (v2) {
              if (v2 instanceof Data_Either.Left) {
                  return new Data_Either.Left(v(v2.value0));
              };
              if (v2 instanceof Data_Either.Right) {
                  return new Data_Either.Right(v1(v2.value0));
              };
              throw new Error("Failed pattern match at Data.Bifunctor (line 32, column 1 - line 34, column 36): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
          };
      };
  });
  exports["bimap"] = bimap;
  exports["Bifunctor"] = Bifunctor;
  exports["lmap"] = lmap;
  exports["rmap"] = rmap;
  exports["bifunctorEither"] = bifunctorEither;
  exports["bifunctorTuple"] = bifunctorTuple;
})(PS);
(function(exports) {
  "use strict";

  exports.fromNumberImpl = function (just) {
    return function (nothing) {
      return function (n) {
        /* jshint bitwise: false */
        return (n | 0) === n ? just(n) : nothing;
      };
    };
  };

  exports.toNumber = function (n) {
    return n;
  };

  exports.toStringAs = function (radix) {
    return function (i) {
      return i.toString(radix);
    };
  };
})(PS["Data.Int"] = PS["Data.Int"] || {});
(function(exports) {
  "use strict";

  exports.topInt = 2147483647;
  exports.bottomInt = -2147483648;

  exports.topChar = String.fromCharCode(65535);
  exports.bottomChar = String.fromCharCode(0);
})(PS["Data.Bounded"] = PS["Data.Bounded"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Bounded"] = $PS["Data.Bounded"] || {};
  var exports = $PS["Data.Bounded"];
  var $foreign = $PS["Data.Bounded"];
  var Data_Ord = $PS["Data.Ord"];
  var Bounded = function (Ord0, bottom, top) {
      this.Ord0 = Ord0;
      this.bottom = bottom;
      this.top = top;
  };
  var top = function (dict) {
      return dict.top;
  };                                            
  var boundedInt = new Bounded(function () {
      return Data_Ord.ordInt;
  }, $foreign.bottomInt, $foreign.topInt);
  var boundedChar = new Bounded(function () {
      return Data_Ord.ordChar;
  }, $foreign.bottomChar, $foreign.topChar);
  var bottom = function (dict) {
      return dict.bottom;
  };
  exports["Bounded"] = Bounded;
  exports["bottom"] = bottom;
  exports["top"] = top;
  exports["boundedInt"] = boundedInt;
  exports["boundedChar"] = boundedChar;
})(PS);
(function(exports) {
  /* globals exports */
  "use strict";               

  exports.isFinite = isFinite;
})(PS["Data.Number"] = PS["Data.Number"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Number"] = $PS["Data.Number"] || {};
  var exports = $PS["Data.Number"];
  var $foreign = $PS["Data.Number"];
  exports["isFinite"] = $foreign["isFinite"];
})(PS);
(function(exports) {
  "use strict";          

  exports.floor = Math.floor;

  function nativeImul(a) {
    return function (b) {
      return Math.imul(a, b);
    };
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
  function emulatedImul(a) {
    /*jshint bitwise: false*/
    return function (b) {
      var ah = a >>> 16 & 0xffff;
      var al = a & 0xffff;
      var bh = b >>> 16 & 0xffff;
      var bl = b & 0xffff;
      // the shift by 0 fixes the sign on the high part
      // the final |0 converts the unsigned value into a signed value
      return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
    };
  }
})(PS["Math"] = PS["Math"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Math"] = $PS["Math"] || {};
  var exports = $PS["Math"];
  var $foreign = $PS["Math"];
  exports["floor"] = $foreign.floor;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Int"] = $PS["Data.Int"] || {};
  var exports = $PS["Data.Int"];
  var $foreign = $PS["Data.Int"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Bounded = $PS["Data.Bounded"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Number = $PS["Data.Number"];
  var $$Math = $PS["Math"];
  var hexadecimal = 16;             
  var fromNumber = $foreign.fromNumberImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var unsafeClamp = function (x) {
      if (!Data_Number["isFinite"](x)) {
          return 0;
      };
      if (x >= $foreign.toNumber(Data_Bounded.top(Data_Bounded.boundedInt))) {
          return Data_Bounded.top(Data_Bounded.boundedInt);
      };
      if (x <= $foreign.toNumber(Data_Bounded.bottom(Data_Bounded.boundedInt))) {
          return Data_Bounded.bottom(Data_Bounded.boundedInt);
      };
      if (Data_Boolean.otherwise) {
          return Data_Maybe.fromMaybe(0)(fromNumber(x));
      };
      throw new Error("Failed pattern match at Data.Int (line 66, column 1 - line 66, column 29): " + [ x.constructor.name ]);
  };
  var floor = function ($24) {
      return unsafeClamp($$Math.floor($24));
  };
  exports["fromNumber"] = fromNumber;
  exports["floor"] = floor;
  exports["hexadecimal"] = hexadecimal;
  exports["toNumber"] = $foreign.toNumber;
  exports["toStringAs"] = $foreign.toStringAs;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.FoldableWithIndex"] = $PS["Data.FoldableWithIndex"] || {};
  var exports = $PS["Data.FoldableWithIndex"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Tuple = $PS["Data.Tuple"];              
  var FoldableWithIndex = function (Foldable0, foldMapWithIndex, foldlWithIndex, foldrWithIndex) {
      this.Foldable0 = Foldable0;
      this.foldMapWithIndex = foldMapWithIndex;
      this.foldlWithIndex = foldlWithIndex;
      this.foldrWithIndex = foldrWithIndex;
  };
  var foldrWithIndex = function (dict) {
      return dict.foldrWithIndex;
  };
  var foldMapWithIndexDefaultR = function (dictFoldableWithIndex) {
      return function (dictMonoid) {
          return function (f) {
              return foldrWithIndex(dictFoldableWithIndex)(function (i) {
                  return function (x) {
                      return function (acc) {
                          return Data_Semigroup.append(dictMonoid.Semigroup0())(f(i)(x))(acc);
                      };
                  };
              })(Data_Monoid.mempty(dictMonoid));
          };
      };
  };
  var foldableWithIndexArray = new FoldableWithIndex(function () {
      return Data_Foldable.foldableArray;
  }, function (dictMonoid) {
      return foldMapWithIndexDefaultR(foldableWithIndexArray)(dictMonoid);
  }, function (f) {
      return function (z) {
          var $164 = Data_Foldable.foldl(Data_Foldable.foldableArray)(function (y) {
              return function (v) {
                  return f(v.value0)(y)(v.value1);
              };
          })(z);
          var $165 = Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(Data_Tuple.Tuple.create);
          return function ($166) {
              return $164($165($166));
          };
      };
  }, function (f) {
      return function (z) {
          var $167 = Data_Foldable.foldr(Data_Foldable.foldableArray)(function (v) {
              return function (y) {
                  return f(v.value0)(v.value1)(y);
              };
          })(z);
          var $168 = Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(Data_Tuple.Tuple.create);
          return function ($169) {
              return $167($168($169));
          };
      };
  });
  exports["foldableWithIndexArray"] = foldableWithIndexArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.TraversableWithIndex"] = $PS["Data.TraversableWithIndex"] || {};
  var exports = $PS["Data.TraversableWithIndex"];
  var Data_FoldableWithIndex = $PS["Data.FoldableWithIndex"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Traversable = $PS["Data.Traversable"];  
  var TraversableWithIndex = function (FoldableWithIndex1, FunctorWithIndex0, Traversable2, traverseWithIndex) {
      this.FoldableWithIndex1 = FoldableWithIndex1;
      this.FunctorWithIndex0 = FunctorWithIndex0;
      this.Traversable2 = Traversable2;
      this.traverseWithIndex = traverseWithIndex;
  };
  var traverseWithIndexDefault = function (dictTraversableWithIndex) {
      return function (dictApplicative) {
          return function (f) {
              var $63 = Data_Traversable.sequence(dictTraversableWithIndex.Traversable2())(dictApplicative);
              var $64 = Data_FunctorWithIndex.mapWithIndex(dictTraversableWithIndex.FunctorWithIndex0())(f);
              return function ($65) {
                  return $63($64($65));
              };
          };
      };
  };
  var traverseWithIndex = function (dict) {
      return dict.traverseWithIndex;
  };
  var traversableWithIndexArray = new TraversableWithIndex(function () {
      return Data_FoldableWithIndex.foldableWithIndexArray;
  }, function () {
      return Data_FunctorWithIndex.functorWithIndexArray;
  }, function () {
      return Data_Traversable.traversableArray;
  }, function (dictApplicative) {
      return traverseWithIndexDefault(traversableWithIndexArray)(dictApplicative);
  });
  exports["traverseWithIndex"] = traverseWithIndex;
  exports["traversableWithIndexArray"] = traversableWithIndexArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Decode.Decoders"] = $PS["Data.Argonaut.Decode.Decoders"] || {};
  var exports = $PS["Data.Argonaut.Decode.Decoders"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Argonaut_Decode_Error = $PS["Data.Argonaut.Decode.Error"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_TraversableWithIndex = $PS["Data.TraversableWithIndex"];
  var Data_Unit = $PS["Data.Unit"];
  var decodeString = Data_Argonaut_Core.caseJsonString(Data_Either.Left.create(new Data_Argonaut_Decode_Error.TypeMismatch("String")))(Data_Either.Right.create);
  var decodeNumber = Data_Argonaut_Core.caseJsonNumber(Data_Either.Left.create(new Data_Argonaut_Decode_Error.TypeMismatch("Number")))(Data_Either.Right.create);
  var decodeNull = Data_Argonaut_Core.caseJsonNull(Data_Either.Left.create(new Data_Argonaut_Decode_Error.TypeMismatch("null")))(Data_Function["const"](new Data_Either.Right(Data_Unit.unit)));
  var decodeMaybe = function (decoder) {
      return function (json) {
          if (Data_Argonaut_Core.isNull(json)) {
              return Control_Applicative.pure(Data_Either.applicativeEither)(Data_Maybe.Nothing.value);
          };
          if (Data_Boolean.otherwise) {
              return Data_Functor.map(Data_Either.functorEither)(Data_Maybe.Just.create)(decoder(json));
          };
          throw new Error("Failed pattern match at Data.Argonaut.Decode.Decoders (line 37, column 1 - line 41, column 38): " + [ decoder.constructor.name, json.constructor.name ]);
      };
  };   
  var decodeJArray = (function () {
      var $22 = Data_Either.note(new Data_Argonaut_Decode_Error.TypeMismatch("Array"));
      return function ($23) {
          return $22(Data_Argonaut_Core.toArray($23));
      };
  })();
  var decodeNonEmptyArray = function (decoder) {
      return Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
          var $30 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Argonaut_Decode_Error.Named.create("NonEmptyArray"));
          var $31 = Data_Traversable.traverse(Data_Array_NonEmpty_Internal.traversableNonEmptyArray)(Data_Either.applicativeEither)(decoder);
          return function ($32) {
              return $30($31($32));
          };
      })())(Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
          var $33 = Data_Functor.map(Data_Either.functorEither)(function (x) {
              return Data_Array_NonEmpty["cons'"](x.head)(x.tail);
          });
          var $34 = Data_Either.note(new Data_Argonaut_Decode_Error.TypeMismatch("NonEmptyArray"));
          return function ($35) {
              return $33($34(Data_Array.uncons($35)));
          };
      })())(decodeJArray));
  };
  var decodeInt = Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
      var $54 = Data_Either.note(new Data_Argonaut_Decode_Error.TypeMismatch("Integer"));
      return function ($55) {
          return $54(Data_Int.fromNumber($55));
      };
  })())(decodeNumber);
  var decodeBoolean = Data_Argonaut_Core.caseJsonBoolean(Data_Either.Left.create(new Data_Argonaut_Decode_Error.TypeMismatch("Boolean")))(Data_Either.Right.create);
  var decodeArray = function (decoder) {
      return Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
          var $59 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Argonaut_Decode_Error.Named.create("Array"));
          var $60 = Data_TraversableWithIndex.traverseWithIndex(Data_TraversableWithIndex.traversableWithIndexArray)(Data_Either.applicativeEither)(function (i) {
              var $62 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Argonaut_Decode_Error.AtIndex.create(i));
              return function ($63) {
                  return $62(decoder($63));
              };
          });
          return function ($61) {
              return $59($60($61));
          };
      })())(decodeJArray);
  };
  exports["decodeMaybe"] = decodeMaybe;
  exports["decodeNull"] = decodeNull;
  exports["decodeBoolean"] = decodeBoolean;
  exports["decodeInt"] = decodeInt;
  exports["decodeString"] = decodeString;
  exports["decodeNonEmptyArray"] = decodeNonEmptyArray;
  exports["decodeArray"] = decodeArray;
})(PS);
(function(exports) {
  "use strict";

  exports._copyST = function (m) {
    return function () {
      var r = {};
      for (var k in m) {
        if (hasOwnProperty.call(m, k)) {
          r[k] = m[k];
        }
      }
      return r;
    };
  };

  exports.empty = {};

  exports.runST = function (f) {
    return f();
  };

  exports._lookup = function (no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
  };

  function toArrayWithKey(f) {
    return function (m) {
      var r = [];
      for (var k in m) {
        if (hasOwnProperty.call(m, k)) {
          r.push(f(k)(m[k]));
        }
      }
      return r;
    };
  }
})(PS["Foreign.Object"] = PS["Foreign.Object"] || {});
(function(exports) {
  "use strict";

  exports.runFn4 = function (fn) {
    return function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return fn(a, b, c, d);
          };
        };
      };
    };
  };
})(PS["Data.Function.Uncurried"] = PS["Data.Function.Uncurried"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Function.Uncurried"] = $PS["Data.Function.Uncurried"] || {};
  var exports = $PS["Data.Function.Uncurried"];
  var $foreign = $PS["Data.Function.Uncurried"];
  exports["runFn4"] = $foreign.runFn4;
})(PS);
(function(exports) {
  "use strict";

  exports["new"] = function () {
    return {};
  };

  exports.poke = function (k) {
    return function (v) {
      return function (m) {
        return function () {
          m[k] = v;
          return m;
        };
      };
    };
  };
})(PS["Foreign.Object.ST"] = PS["Foreign.Object.ST"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Foreign.Object.ST"] = $PS["Foreign.Object.ST"] || {};
  var exports = $PS["Foreign.Object.ST"];
  var $foreign = $PS["Foreign.Object.ST"];
  exports["new"] = $foreign["new"];
  exports["poke"] = $foreign.poke;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Foreign.Object"] = $PS["Foreign.Object"] || {};
  var exports = $PS["Foreign.Object"];
  var $foreign = $PS["Foreign.Object"];
  var Data_Function_Uncurried = $PS["Data.Function.Uncurried"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Foreign_Object_ST = $PS["Foreign.Object.ST"];              
  var thawST = $foreign["_copyST"];
  var mutate = function (f) {
      return function (m) {
          return $foreign.runST(function __do() {
              var s = thawST(m)();
              f(s)();
              return s;
          });
      };
  };
  var lookup = Data_Function_Uncurried.runFn4($foreign["_lookup"])(Data_Maybe.Nothing.value)(Data_Maybe.Just.create);
  var insert = function (k) {
      return function (v) {
          return mutate(Foreign_Object_ST.poke(k)(v));
      };
  };
  exports["insert"] = insert;
  exports["lookup"] = lookup;
  exports["empty"] = $foreign.empty;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Decode.Class"] = $PS["Data.Argonaut.Decode.Class"] || {};
  var exports = $PS["Data.Argonaut.Decode.Class"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Argonaut_Decode_Decoders = $PS["Data.Argonaut.Decode.Decoders"];
  var Data_Argonaut_Decode_Error = $PS["Data.Argonaut.Decode.Error"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Foreign_Object = $PS["Foreign.Object"];
  var Record = $PS["Record"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var GDecodeJson = function (gDecodeJson) {
      this.gDecodeJson = gDecodeJson;
  };
  var DecodeJsonField = function (decodeJsonField) {
      this.decodeJsonField = decodeJsonField;
  };
  var DecodeJson = function (decodeJson) {
      this.decodeJson = decodeJson;
  };
  var gDecodeJsonNil = new GDecodeJson(function (v) {
      return function (v1) {
          return new Data_Either.Right({});
      };
  });
  var gDecodeJson = function (dict) {
      return dict.gDecodeJson;
  };                                                                        
  var decodeRecord = function (dictGDecodeJson) {
      return function (dictRowToList) {
          return new DecodeJson(function (json) {
              var v = Data_Argonaut_Core.toObject(json);
              if (v instanceof Data_Maybe.Just) {
                  return gDecodeJson(dictGDecodeJson)(v.value0)(Type_Proxy["Proxy"].value);
              };
              if (v instanceof Data_Maybe.Nothing) {
                  return Data_Either.Left.create(new Data_Argonaut_Decode_Error.TypeMismatch("Object"));
              };
              throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 103, column 5 - line 105, column 46): " + [ v.constructor.name ]);
          });
      };
  };
  var decodeJsonString = new DecodeJson(Data_Argonaut_Decode_Decoders.decodeString);
  var decodeJsonNull = new DecodeJson(Data_Argonaut_Decode_Decoders.decodeNull);
  var decodeJsonInt = new DecodeJson(Data_Argonaut_Decode_Decoders.decodeInt);
  var decodeJsonField = function (dict) {
      return dict.decodeJsonField;
  };
  var gDecodeJsonCons = function (dictDecodeJsonField) {
      return function (dictGDecodeJson) {
          return function (dictIsSymbol) {
              return function (dictCons) {
                  return function (dictLacks) {
                      return new GDecodeJson(function (object) {
                          return function (v) {
                              var fieldName = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                              var fieldValue = Foreign_Object.lookup(fieldName)(object);
                              var v1 = decodeJsonField(dictDecodeJsonField)(fieldValue);
                              if (v1 instanceof Data_Maybe.Just) {
                                  return Control_Bind.bind(Data_Either.bindEither)(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Argonaut_Decode_Error.AtKey.create(fieldName))(v1.value0))(function (val) {
                                      return Control_Bind.bind(Data_Either.bindEither)(gDecodeJson(dictGDecodeJson)(object)(Type_Proxy["Proxy"].value))(function (rest) {
                                          return Data_Either.Right.create(Record.insert(dictIsSymbol)()()(Type_Proxy["Proxy"].value)(val)(rest));
                                      });
                                  });
                              };
                              if (v1 instanceof Data_Maybe.Nothing) {
                                  return Data_Either.Left.create(new Data_Argonaut_Decode_Error.AtKey(fieldName, Data_Argonaut_Decode_Error.MissingValue.value));
                              };
                              throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 127, column 5 - line 134, column 44): " + [ v1.constructor.name ]);
                          };
                      });
                  };
              };
          };
      };
  };                                                                                      
  var decodeJsonBoolean = new DecodeJson(Data_Argonaut_Decode_Decoders.decodeBoolean);
  var decodeJson = function (dict) {
      return dict.decodeJson;
  };
  var decodeJsonMaybe = function (dictDecodeJson) {
      return new DecodeJson(Data_Argonaut_Decode_Decoders.decodeMaybe(decodeJson(dictDecodeJson)));
  };
  var decodeJsonNonEmptyArray = function (dictDecodeJson) {
      return new DecodeJson(Data_Argonaut_Decode_Decoders.decodeNonEmptyArray(decodeJson(dictDecodeJson)));
  };
  var decodeFieldMaybe = function (dictDecodeJson) {
      return new DecodeJsonField(function (v) {
          if (v instanceof Data_Maybe.Nothing) {
              return Data_Maybe.Just.create(new Data_Either.Right(Data_Maybe.Nothing.value));
          };
          if (v instanceof Data_Maybe.Just) {
              return Data_Maybe.Just.create(decodeJson(decodeJsonMaybe(dictDecodeJson))(v.value0));
          };
          throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 139, column 1 - line 143, column 49): " + [ v.constructor.name ]);
      });
  };
  var decodeFieldId = function (dictDecodeJson) {
      return new DecodeJsonField(function (j) {
          return Data_Functor.map(Data_Maybe.functorMaybe)(decodeJson(dictDecodeJson))(j);
      });
  };
  var decodeArray = function (dictDecodeJson) {
      return new DecodeJson(Data_Argonaut_Decode_Decoders.decodeArray(decodeJson(dictDecodeJson)));
  };
  exports["decodeJson"] = decodeJson;
  exports["DecodeJson"] = DecodeJson;
  exports["decodeJsonNull"] = decodeJsonNull;
  exports["decodeJsonBoolean"] = decodeJsonBoolean;
  exports["decodeJsonInt"] = decodeJsonInt;
  exports["decodeJsonString"] = decodeJsonString;
  exports["decodeJsonNonEmptyArray"] = decodeJsonNonEmptyArray;
  exports["decodeArray"] = decodeArray;
  exports["decodeRecord"] = decodeRecord;
  exports["gDecodeJsonNil"] = gDecodeJsonNil;
  exports["gDecodeJsonCons"] = gDecodeJsonCons;
  exports["decodeFieldMaybe"] = decodeFieldMaybe;
  exports["decodeFieldId"] = decodeFieldId;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Types.Generic"] = $PS["Data.Argonaut.Types.Generic"] || {};
  var exports = $PS["Data.Argonaut.Types.Generic"];
  var defaultEncoding = {
      tagKey: "tag",
      valuesKey: "values",
      unwrapSingleArguments: false
  };
  exports["defaultEncoding"] = defaultEncoding;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Generic.Rep"] = $PS["Data.Generic.Rep"] || {};
  var exports = $PS["Data.Generic.Rep"];             
  var Inl = (function () {
      function Inl(value0) {
          this.value0 = value0;
      };
      Inl.create = function (value0) {
          return new Inl(value0);
      };
      return Inl;
  })();
  var Inr = (function () {
      function Inr(value0) {
          this.value0 = value0;
      };
      Inr.create = function (value0) {
          return new Inr(value0);
      };
      return Inr;
  })();
  var Product = (function () {
      function Product(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Product.create = function (value0) {
          return function (value1) {
              return new Product(value0, value1);
          };
      };
      return Product;
  })();
  var NoArguments = (function () {
      function NoArguments() {

      };
      NoArguments.value = new NoArguments();
      return NoArguments;
  })();
  var Generic = function (from, to) {
      this.from = from;
      this.to = to;
  };
  var Constructor = function (x) {
      return x;
  };
  var Argument = function (x) {
      return x;
  };
  var to = function (dict) {
      return dict.to;
  };
  var from = function (dict) {
      return dict.from;
  };
  exports["Generic"] = Generic;
  exports["to"] = to;
  exports["from"] = from;
  exports["NoArguments"] = NoArguments;
  exports["Inl"] = Inl;
  exports["Inr"] = Inr;
  exports["Product"] = Product;
  exports["Constructor"] = Constructor;
  exports["Argument"] = Argument;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Decode.Generic"] = $PS["Data.Argonaut.Decode.Generic"] || {};
  var exports = $PS["Data.Argonaut.Decode.Generic"];
  var Control_Alt = $PS["Control.Alt"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Error = $PS["Data.Argonaut.Decode.Error"];
  var Data_Argonaut_Types_Generic = $PS["Data.Argonaut.Types.Generic"];
  var Data_Array = $PS["Data.Array"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Either = $PS["Data.Either"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Foreign_Object = $PS["Foreign.Object"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var DecodeRepArgs = function (decodeRepArgs) {
      this.decodeRepArgs = decodeRepArgs;
  };
  var DecodeRep = function (decodeRepWith) {
      this.decodeRepWith = decodeRepWith;
  };
  var withTag = function (e) {
      return function (j) {
          return function (name) {
              var decodingErr = Data_Argonaut_Decode_Error.Named.create(name);
              return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr(new Data_Argonaut_Decode_Error.TypeMismatch("Object")))(Data_Argonaut_Core.toObject(j)))(function (jObj) {
                  return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr(new Data_Argonaut_Decode_Error.AtKey(e.tagKey, Data_Argonaut_Decode_Error.MissingValue.value)))(Foreign_Object.lookup(e.tagKey)(jObj)))(function (jTag) {
                      return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr(Data_Argonaut_Decode_Error.AtKey.create(e.tagKey)(new Data_Argonaut_Decode_Error.TypeMismatch("String"))))(Data_Argonaut_Core.toString(jTag)))(function (tag) {
                          return Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither)(Control_Applicative.when(Data_Either.applicativeEither)(tag !== name)(Data_Either.Left.create(decodingErr(Data_Argonaut_Decode_Error.AtKey.create(e.tagKey)(Data_Argonaut_Decode_Error.UnexpectedValue.create(Data_Argonaut_Core.fromString(tag)))))))(function () {
                              return Control_Applicative.pure(Data_Either.applicativeEither)({
                                  tag: tag,
                                  decodingErr: decodingErr
                              });
                          });
                      });
                  });
              });
          };
      };
  };
  var withTagAndValues = function (e) {
      return function (j) {
          return function (name) {
              return Control_Bind.bind(Data_Either.bindEither)(withTag(e)(j)(name))(function (v) {
                  return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr(new Data_Argonaut_Decode_Error.TypeMismatch("Object")))(Data_Argonaut_Core.toObject(j)))(function (jObj) {
                      return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr(new Data_Argonaut_Decode_Error.AtKey(e.valuesKey, Data_Argonaut_Decode_Error.MissingValue.value)))(Foreign_Object.lookup(e.valuesKey)(jObj)))(function (values) {
                          return Control_Applicative.pure(Data_Either.applicativeEither)({
                              tag: v.tag,
                              values: values,
                              decodingErr: v.decodingErr
                          });
                      });
                  });
              });
          };
      };
  };
  var decodeRepWith = function (dict) {
      return dict.decodeRepWith;
  };
  var genericDecodeJsonWith = function (dictGeneric) {
      return function (dictDecodeRep) {
          return function (e) {
              var $61 = Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.to(dictGeneric));
              var $62 = decodeRepWith(dictDecodeRep)(e);
              return function ($63) {
                  return $61($62($63));
              };
          };
      };
  };
  var genericDecodeJson = function (dictGeneric) {
      return function (dictDecodeRep) {
          return genericDecodeJsonWith(dictGeneric)(dictDecodeRep)(Data_Argonaut_Types_Generic.defaultEncoding);
      };
  };
  var decodeRepSum = function (dictDecodeRep) {
      return function (dictDecodeRep1) {
          return new DecodeRep(function (e) {
              return function (j) {
                  return Control_Alt.alt(Data_Either.altEither)(Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.Inl.create)(decodeRepWith(dictDecodeRep)(e)(j)))(Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.Inr.create)(decodeRepWith(dictDecodeRep1)(e)(j)));
              };
          });
      };
  }; 
  var decodeRepArgsNoArguments = new DecodeRepArgs(function (js) {
      return new Data_Either.Right({
          init: Data_Generic_Rep.NoArguments.value,
          rest: js
      });
  });
  var decodeRepArgsArgument = function (dictDecodeJson) {
      return new DecodeRepArgs(function (js) {
          return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(new Data_Argonaut_Decode_Error.TypeMismatch("NonEmptyArray"))(Data_Array.uncons(js)))(function (v) {
              return Data_Functor.map(Data_Either.functorEither)(function ($64) {
                  return (function (v1) {
                      return {
                          init: v1,
                          rest: v.tail
                      };
                  })(Data_Generic_Rep.Argument($64));
              })(Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson)(v.head));
          });
      });
  };
  var decodeRepArgs = function (dict) {
      return dict.decodeRepArgs;
  };
  var decodeRepArgsProduct = function (dictDecodeRepArgs) {
      return function (dictDecodeRepArgs1) {
          return new DecodeRepArgs(function (js) {
              return Control_Bind.bind(Data_Either.bindEither)(decodeRepArgs(dictDecodeRepArgs)(js))(function (v) {
                  return Control_Bind.bind(Data_Either.bindEither)(decodeRepArgs(dictDecodeRepArgs1)(v.rest))(function (v1) {
                      return Control_Applicative.pure(Data_Either.applicativeEither)({
                          init: new Data_Generic_Rep.Product(v.init, v1.init),
                          rest: v1.rest
                      });
                  });
              });
          });
      };
  };
  var construct = function (dictDecodeRepArgs) {
      return function (e) {
          return function (valuesArray) {
              return function (decodingErr) {
                  return Control_Bind.bind(Data_Either.bindEither)(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(decodingErr)(decodeRepArgs(dictDecodeRepArgs)(valuesArray)))(function (v) {
                      return Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither)(Control_Applicative.when(Data_Either.applicativeEither)(Data_Eq.notEq(Data_Eq.eqArray(Data_Argonaut_Core.eqJson))(v.rest)([  ]))(Data_Either.Left.create(decodingErr(Data_Argonaut_Decode_Error.AtKey.create(e.valuesKey)(new Data_Argonaut_Decode_Error.UnexpectedValue(Data_Argonaut_Core.fromArray(v.rest)))))))(function () {
                          return Control_Applicative.pure(Data_Either.applicativeEither)(v.init);
                      });
                  });
              };
          };
      };
  };
  var decodeRepConstructor = function (dictIsSymbol) {
      return function (dictDecodeRepArgs) {
          return new DecodeRep(function (e) {
              return function (j) {
                  var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                  return Control_Bind.bind(Data_Either.bindEither)(withTagAndValues(e)(j)(name))(function (v) {
                      return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr(Data_Argonaut_Decode_Error.AtKey.create(e.valuesKey)(new Data_Argonaut_Decode_Error.TypeMismatch("Array"))))(Data_Argonaut_Core.toArray(v.values)))(function (valuesArray) {
                          return construct(dictDecodeRepArgs)(e)(valuesArray)(v.decodingErr);
                      });
                  });
              };
          });
      };
  };
  var decodeRepConstructorArg = function (dictIsSymbol) {
      return function (dictDecodeJson) {
          return new DecodeRep(function (e) {
              return function (j) {
                  var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                  return Control_Bind.bind(Data_Either.bindEither)(withTagAndValues(e)(j)(name))(function (v) {
                      if (e.unwrapSingleArguments) {
                          return construct(decodeRepArgsArgument(dictDecodeJson))(e)([ v.values ])(v.decodingErr);
                      };
                      return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr(Data_Argonaut_Decode_Error.AtKey.create(e.valuesKey)(new Data_Argonaut_Decode_Error.TypeMismatch("Array"))))(Data_Argonaut_Core.toArray(v.values)))(function (valuesArray) {
                          return construct(decodeRepArgsArgument(dictDecodeJson))(e)(valuesArray)(v.decodingErr);
                      });
                  });
              };
          });
      };
  };
  var decodeRepConstructorNoArgs = function (dictIsSymbol) {
      return new DecodeRep(function (e) {
          return function (j) {
              var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
              return Control_Bind.bind(Data_Either.bindEither)(withTag(e)(j)(name))(function (v) {
                  return construct(decodeRepArgsNoArguments)(e)([  ])(v.decodingErr);
              });
          };
      });
  };
  exports["genericDecodeJson"] = genericDecodeJson;
  exports["decodeRepSum"] = decodeRepSum;
  exports["decodeRepConstructorNoArgs"] = decodeRepConstructorNoArgs;
  exports["decodeRepConstructorArg"] = decodeRepConstructorArg;
  exports["decodeRepConstructor"] = decodeRepConstructor;
  exports["decodeRepArgsProduct"] = decodeRepArgsProduct;
  exports["decodeRepArgsArgument"] = decodeRepArgsArgument;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Encode.Encoders"] = $PS["Data.Argonaut.Encode.Encoders"] || {};
  var exports = $PS["Data.Argonaut.Encode.Encoders"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Data_Maybe = $PS["Data.Maybe"];
  var encodeUnit = Data_Function["const"](Data_Argonaut_Core.jsonNull);
  var encodeString = Data_Argonaut_Core.fromString;
  var encodeMaybe = function (encoder) {
      return function (v) {
          if (v instanceof Data_Maybe.Nothing) {
              return Data_Argonaut_Core.jsonNull;
          };
          if (v instanceof Data_Maybe.Just) {
              return encoder(v.value0);
          };
          throw new Error("Failed pattern match at Data.Argonaut.Encode.Encoders (line 31, column 23 - line 33, column 22): " + [ v.constructor.name ]);
      };
  };
  var encodeInt = function ($48) {
      return Data_Argonaut_Core.fromNumber(Data_Int.toNumber($48));
  };
  var encodeBoolean = Data_Argonaut_Core.fromBoolean;
  var encodeArray = function (encoder) {
      var $53 = Data_Functor.map(Data_Functor.functorArray)(encoder);
      return function ($54) {
          return Data_Argonaut_Core.fromArray($53($54));
      };
  };
  var encodeNonEmptyArray = function (encoder) {
      var $55 = encodeArray(encoder);
      return function ($56) {
          return $55(Data_Array_NonEmpty.toArray($56));
      };
  };
  exports["encodeMaybe"] = encodeMaybe;
  exports["encodeUnit"] = encodeUnit;
  exports["encodeBoolean"] = encodeBoolean;
  exports["encodeInt"] = encodeInt;
  exports["encodeString"] = encodeString;
  exports["encodeNonEmptyArray"] = encodeNonEmptyArray;
  exports["encodeArray"] = encodeArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Encode.Class"] = $PS["Data.Argonaut.Encode.Class"] || {};
  var exports = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Argonaut_Encode_Encoders = $PS["Data.Argonaut.Encode.Encoders"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Foreign_Object = $PS["Foreign.Object"];
  var Record = $PS["Record"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var GEncodeJson = function (gEncodeJson) {
      this.gEncodeJson = gEncodeJson;
  };
  var EncodeJson = function (encodeJson) {
      this.encodeJson = encodeJson;
  };
  var gEncodeJsonNil = new GEncodeJson(function (v) {
      return function (v1) {
          return Foreign_Object.empty;
      };
  });
  var gEncodeJson = function (dict) {
      return dict.gEncodeJson;
  };                                                                        
  var encodeRecord = function (dictGEncodeJson) {
      return function (dictRowToList) {
          return new EncodeJson(function (rec) {
              return Data_Argonaut_Core.fromObject(gEncodeJson(dictGEncodeJson)(rec)(Type_Proxy["Proxy"].value));
          });
      };
  };                                                                                            
  var encodeJsonUnit = new EncodeJson(Data_Argonaut_Encode_Encoders.encodeUnit);              
  var encodeJsonJString = new EncodeJson(Data_Argonaut_Encode_Encoders.encodeString);
  var encodeJsonJBoolean = new EncodeJson(Data_Argonaut_Encode_Encoders.encodeBoolean);
  var encodeJsonInt = new EncodeJson(Data_Argonaut_Encode_Encoders.encodeInt);  
  var encodeJson = function (dict) {
      return dict.encodeJson;
  };
  var encodeJsonArray = function (dictEncodeJson) {
      return new EncodeJson(Data_Argonaut_Encode_Encoders.encodeArray(encodeJson(dictEncodeJson)));
  };
  var encodeJsonMaybe = function (dictEncodeJson) {
      return new EncodeJson(Data_Argonaut_Encode_Encoders.encodeMaybe(encodeJson(dictEncodeJson)));
  };
  var encodeJsonNonEmptyArray = function (dictEncodeJson) {
      return new EncodeJson(Data_Argonaut_Encode_Encoders.encodeNonEmptyArray(encodeJson(dictEncodeJson)));
  };
  var gEncodeJsonCons = function (dictEncodeJson) {
      return function (dictGEncodeJson) {
          return function (dictIsSymbol) {
              return function (dictCons) {
                  return new GEncodeJson(function (row) {
                      return function (v) {
                          return Foreign_Object.insert(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value))(encodeJson(dictEncodeJson)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(row)))(gEncodeJson(dictGEncodeJson)(row)(Type_Proxy["Proxy"].value));
                      };
                  });
              };
          };
      };
  };
  exports["encodeJson"] = encodeJson;
  exports["EncodeJson"] = EncodeJson;
  exports["encodeJsonMaybe"] = encodeJsonMaybe;
  exports["encodeJsonUnit"] = encodeJsonUnit;
  exports["encodeJsonJBoolean"] = encodeJsonJBoolean;
  exports["encodeJsonInt"] = encodeJsonInt;
  exports["encodeJsonJString"] = encodeJsonJString;
  exports["encodeJsonNonEmptyArray"] = encodeJsonNonEmptyArray;
  exports["encodeJsonArray"] = encodeJsonArray;
  exports["encodeRecord"] = encodeRecord;
  exports["gEncodeJsonNil"] = gEncodeJsonNil;
  exports["gEncodeJsonCons"] = gEncodeJsonCons;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Encode.Generic"] = $PS["Data.Argonaut.Encode.Generic"] || {};
  var exports = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Types_Generic = $PS["Data.Argonaut.Types.Generic"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Foreign_Object = $PS["Foreign.Object"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var EncodeRepArgs = function (encodeRepArgs) {
      this.encodeRepArgs = encodeRepArgs;
  };
  var EncodeRep = function (encodeRepWith) {
      this.encodeRepWith = encodeRepWith;
  };
  var encodeRepWith = function (dict) {
      return dict.encodeRepWith;
  };
  var genericEncodeJsonWith = function (dictGeneric) {
      return function (dictEncodeRep) {
          return function (e) {
              var $47 = encodeRepWith(dictEncodeRep)(e);
              var $48 = Data_Generic_Rep.from(dictGeneric);
              return function ($49) {
                  return $47($48($49));
              };
          };
      };
  };
  var genericEncodeJson = function (dictGeneric) {
      return function (dictEncodeRep) {
          return genericEncodeJsonWith(dictGeneric)(dictEncodeRep)(Data_Argonaut_Types_Generic.defaultEncoding);
      };
  };
  var encodeRepSum = function (dictEncodeRep) {
      return function (dictEncodeRep1) {
          return new EncodeRep(function (e) {
              return function (v) {
                  if (v instanceof Data_Generic_Rep.Inl) {
                      return encodeRepWith(dictEncodeRep)(e)(v.value0);
                  };
                  if (v instanceof Data_Generic_Rep.Inr) {
                      return encodeRepWith(dictEncodeRep1)(e)(v.value0);
                  };
                  throw new Error("Failed pattern match at Data.Argonaut.Encode.Generic (line 36, column 1 - line 38, column 50): " + [ e.constructor.name, v.constructor.name ]);
              };
          });
      };
  }; 
  var encodeRepArgsNoArguments = new EncodeRepArgs(function (v) {
      return [  ];
  });
  var encodeRepArgsArgument = function (dictEncodeJson) {
      return new EncodeRepArgs(function (v) {
          return [ Data_Argonaut_Encode_Class.encodeJson(dictEncodeJson)(v) ];
      });
  };
  var encodeRepArgs = function (dict) {
      return dict.encodeRepArgs;
  };
  var encodeRepArgsProduct = function (dictEncodeRepArgs) {
      return function (dictEncodeRepArgs1) {
          return new EncodeRepArgs(function (v) {
              return Data_Semigroup.append(Data_Semigroup.semigroupArray)(encodeRepArgs(dictEncodeRepArgs)(v.value0))(encodeRepArgs(dictEncodeRepArgs1)(v.value1));
          });
      };
  };
  var encodeRepConstructor = function (dictIsSymbol) {
      return function (dictEncodeRepArgs) {
          return new EncodeRep(function (e) {
              return function (v) {
                  var values = (function () {
                      var vs = encodeRepArgs(dictEncodeRepArgs)(v);
                      if (e.unwrapSingleArguments) {
                          if (vs.length === 1) {
                              return vs[0];
                          };
                          return Data_Argonaut_Core.fromArray(vs);
                      };
                      return Data_Argonaut_Core.fromArray(vs);
                  })();
                  return Data_Argonaut_Core.fromObject(Foreign_Object.insert(e.tagKey)(Data_Argonaut_Core.fromString(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value)))(Foreign_Object.insert(e.valuesKey)(values)(Foreign_Object.empty)));
              };
          });
      };
  };
  exports["genericEncodeJson"] = genericEncodeJson;
  exports["encodeRepSum"] = encodeRepSum;
  exports["encodeRepConstructor"] = encodeRepConstructor;
  exports["encodeRepArgsNoArguments"] = encodeRepArgsNoArguments;
  exports["encodeRepArgsProduct"] = encodeRepArgsProduct;
  exports["encodeRepArgsArgument"] = encodeRepArgsArgument;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Getter"] = $PS["Data.Lens.Getter"] || {};
  var exports = $PS["Data.Lens.Getter"];
  var Control_Category = $PS["Control.Category"];
  var Data_Newtype = $PS["Data.Newtype"];                                    
  var view = function (l) {
      return Data_Newtype.unwrap()(l(Control_Category.identity(Control_Category.categoryFn)));
  };
  var viewOn = function (s) {
      return function (l) {
          return view(l)(s);
      };
  };
  exports["viewOn"] = viewOn;
  exports["view"] = view;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Const"] = $PS["Data.Const"] || {};
  var exports = $PS["Data.Const"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];      
  var Const = function (x) {
      return x;
  };
  var functorConst = new Data_Functor.Functor(function (f) {
      return function (m) {
          return m;
      };
  });
  var applyConst = function (dictSemigroup) {
      return new Control_Apply.Apply(function () {
          return functorConst;
      }, function (v) {
          return function (v1) {
              return Data_Semigroup.append(dictSemigroup)(v)(v1);
          };
      });
  };
  var applicativeConst = function (dictMonoid) {
      return new Control_Applicative.Applicative(function () {
          return applyConst(dictMonoid.Semigroup0());
      }, function (v) {
          return Data_Monoid.mempty(dictMonoid);
      });
  };
  exports["Const"] = Const;
  exports["applicativeConst"] = applicativeConst;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Identity"] = $PS["Data.Identity"] || {};
  var exports = $PS["Data.Identity"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Data_Functor = $PS["Data.Functor"];          
  var Identity = function (x) {
      return x;
  };
  var functorIdentity = new Data_Functor.Functor(function (f) {
      return function (m) {
          return f(m);
      };
  });
  var applyIdentity = new Control_Apply.Apply(function () {
      return functorIdentity;
  }, function (v) {
      return function (v1) {
          return v(v1);
      };
  });
  var bindIdentity = new Control_Bind.Bind(function () {
      return applyIdentity;
  }, function (v) {
      return function (f) {
          return f(v);
      };
  });
  var applicativeIdentity = new Control_Applicative.Applicative(function () {
      return applyIdentity;
  }, Identity);
  var monadIdentity = new Control_Monad.Monad(function () {
      return applicativeIdentity;
  }, function () {
      return bindIdentity;
  });
  exports["Identity"] = Identity;
  exports["applicativeIdentity"] = applicativeIdentity;
  exports["monadIdentity"] = monadIdentity;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Profunctor.Choice"] = $PS["Data.Profunctor.Choice"] || {};
  var exports = $PS["Data.Profunctor.Choice"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Profunctor = $PS["Data.Profunctor"];                
  var Choice = function (Profunctor0, left, right) {
      this.Profunctor0 = Profunctor0;
      this.left = left;
      this.right = right;
  };
  var right = function (dict) {
      return dict.right;
  };
  var choiceFn = new Choice(function () {
      return Data_Profunctor.profunctorFn;
  }, function (v) {
      return function (v1) {
          if (v1 instanceof Data_Either.Left) {
              return Data_Either.Left.create(v(v1.value0));
          };
          if (v1 instanceof Data_Either.Right) {
              return new Data_Either.Right(v1.value0);
          };
          throw new Error("Failed pattern match at Data.Profunctor.Choice (line 32, column 1 - line 35, column 16): " + [ v.constructor.name, v1.constructor.name ]);
      };
  }, Data_Functor.map(Data_Either.functorEither));
  exports["right"] = right;
  exports["Choice"] = Choice;
  exports["choiceFn"] = choiceFn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Profunctor.Star"] = $PS["Data.Profunctor.Star"] || {};
  var exports = $PS["Data.Profunctor.Star"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Star = function (x) {
      return x;
  };
  var profunctorStar = function (dictFunctor) {
      return new Data_Profunctor.Profunctor(function (f) {
          return function (g) {
              return function (v) {
                  var $75 = Data_Functor.map(dictFunctor)(g);
                  return function ($76) {
                      return $75(v(f($76)));
                  };
              };
          };
      });
  };
  var strongStar = function (dictFunctor) {
      return new Data_Profunctor_Strong.Strong(function () {
          return profunctorStar(dictFunctor);
      }, function (v) {
          return function (v1) {
              return Data_Functor.map(dictFunctor)(function (v2) {
                  return new Data_Tuple.Tuple(v2, v1.value1);
              })(v(v1.value0));
          };
      }, function (v) {
          return function (v1) {
              return Data_Functor.map(dictFunctor)(Data_Tuple.Tuple.create(v1.value0))(v(v1.value1));
          };
      });
  };
  var choiceStar = function (dictApplicative) {
      return new Data_Profunctor_Choice.Choice(function () {
          return profunctorStar((dictApplicative.Apply0()).Functor0());
      }, function (v) {
          return Star(Data_Either.either((function () {
              var $86 = Data_Functor.map((dictApplicative.Apply0()).Functor0())(Data_Either.Left.create);
              return function ($87) {
                  return $86(v($87));
              };
          })())((function () {
              var $88 = Control_Applicative.pure(dictApplicative);
              return function ($89) {
                  return $88(Data_Either.Right.create($89));
              };
          })()));
      }, function (v) {
          return Star(Data_Either.either((function () {
              var $90 = Control_Applicative.pure(dictApplicative);
              return function ($91) {
                  return $90(Data_Either.Left.create($91));
              };
          })())((function () {
              var $92 = Data_Functor.map((dictApplicative.Apply0()).Functor0())(Data_Either.Right.create);
              return function ($93) {
                  return $92(v($93));
              };
          })()));
      });
  };
  exports["Star"] = Star;
  exports["strongStar"] = strongStar;
  exports["choiceStar"] = choiceStar;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Internal.Wander"] = $PS["Data.Lens.Internal.Wander"] || {};
  var exports = $PS["Data.Lens.Internal.Wander"];
  var Data_Identity = $PS["Data.Identity"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];
  var Data_Profunctor_Star = $PS["Data.Profunctor.Star"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];                
  var Wander = function (Choice1, Strong0, wander) {
      this.Choice1 = Choice1;
      this.Strong0 = Strong0;
      this.wander = wander;
  };
  var wanderStar = function (dictApplicative) {
      return new Wander(function () {
          return Data_Profunctor_Star.choiceStar(dictApplicative);
      }, function () {
          return Data_Profunctor_Star.strongStar((dictApplicative.Apply0()).Functor0());
      }, function (t) {
          return function (v) {
              return t(dictApplicative)(v);
          };
      });
  };
  var wanderFunction = new Wander(function () {
      return Data_Profunctor_Choice.choiceFn;
  }, function () {
      return Data_Profunctor_Strong.strongFn;
  }, function (t) {
      return Data_Newtype.alaF()()()()(Data_Identity.Identity)(t(Data_Identity.applicativeIdentity));
  });
  var wander = function (dict) {
      return dict.wander;
  };
  exports["wander"] = wander;
  exports["Wander"] = Wander;
  exports["wanderFunction"] = wanderFunction;
  exports["wanderStar"] = wanderStar;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Internal.Forget"] = $PS["Data.Lens.Internal.Forget"] || {};
  var exports = $PS["Data.Lens.Internal.Forget"];
  var Data_Const = $PS["Data.Const"];
  var Data_Either = $PS["Data.Either"];
  var Data_Lens_Internal_Wander = $PS["Data.Lens.Internal.Wander"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Forget = function (x) {
      return x;
  };
  var profunctorForget = new Data_Profunctor.Profunctor(function (f) {
      return function (v) {
          return function (v1) {
              return function ($24) {
                  return v1(f($24));
              };
          };
      };
  });
  var strongForget = new Data_Profunctor_Strong.Strong(function () {
      return profunctorForget;
  }, function (v) {
      return function ($25) {
          return v(Data_Tuple.fst($25));
      };
  }, function (v) {
      return function ($26) {
          return v(Data_Tuple.snd($26));
      };
  });
  var choiceForget = function (dictMonoid) {
      return new Data_Profunctor_Choice.Choice(function () {
          return profunctorForget;
      }, function (v) {
          return Data_Either.either(v)(Data_Monoid.mempty(Data_Monoid.monoidFn(dictMonoid)));
      }, function (v) {
          return Data_Either.either(Data_Monoid.mempty(Data_Monoid.monoidFn(dictMonoid)))(v);
      });
  };
  var wanderForget = function (dictMonoid) {
      return new Data_Lens_Internal_Wander.Wander(function () {
          return choiceForget(dictMonoid);
      }, function () {
          return strongForget;
      }, function (f) {
          return function (v) {
              return Data_Newtype.alaF()()()()(Data_Const.Const)(f(Data_Const.applicativeConst(dictMonoid)))(v);
          };
      });
  };
  exports["Forget"] = Forget;
  exports["profunctorForget"] = profunctorForget;
  exports["choiceForget"] = choiceForget;
  exports["strongForget"] = strongForget;
  exports["wanderForget"] = wanderForget;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Internal.Market"] = $PS["Data.Lens.Internal.Market"] || {};
  var exports = $PS["Data.Lens.Internal.Market"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Either = $PS["Data.Either"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];                
  var Market = (function () {
      function Market(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Market.create = function (value0) {
          return function (value1) {
              return new Market(value0, value1);
          };
      };
      return Market;
  })();
  var profunctorMarket = new Data_Profunctor.Profunctor(function (f) {
      return function (g) {
          return function (v) {
              return new Market(function ($19) {
                  return g(v.value0($19));
              }, (function () {
                  var $20 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(g);
                  return function ($21) {
                      return $20(v.value1(f($21)));
                  };
              })());
          };
      };
  });
  var choiceMarket = new Data_Profunctor_Choice.Choice(function () {
      return profunctorMarket;
  }, function (v) {
      return new Market(function ($25) {
          return Data_Either.Left.create(v.value0($25));
      }, Data_Either.either((function () {
          var $26 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Either.Left.create);
          return function ($27) {
              return $26(v.value1($27));
          };
      })())(function ($28) {
          return Data_Either.Left.create(Data_Either.Right.create($28));
      }));
  }, function (v) {
      return new Market(function ($29) {
          return Data_Either.Right.create(v.value0($29));
      }, Data_Either.either(function ($30) {
          return Data_Either.Left.create(Data_Either.Left.create($30));
      })((function () {
          var $31 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Either.Right.create);
          return function ($32) {
              return $31(v.value1($32));
          };
      })()));
  });
  exports["Market"] = Market;
  exports["choiceMarket"] = choiceMarket;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Internal.Tagged"] = $PS["Data.Lens.Internal.Tagged"] || {};
  var exports = $PS["Data.Lens.Internal.Tagged"];
  var Data_Profunctor = $PS["Data.Profunctor"];                  
  var Tagged = function (x) {
      return x;
  };
  var taggedProfunctor = new Data_Profunctor.Profunctor(function (v) {
      return function (g) {
          return function (v1) {
              return g(v1);
          };
      };
  });
  exports["Tagged"] = Tagged;
  exports["taggedProfunctor"] = taggedProfunctor;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Prism"] = $PS["Data.Lens.Prism"] || {};
  var exports = $PS["Data.Lens.Prism"];
  var Control_Category = $PS["Control.Category"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Internal_Market = $PS["Data.Lens.Internal.Market"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];                
  var withPrism = function (l) {
      return function (f) {
          var v = l(new Data_Lens_Internal_Market.Market(Control_Category.identity(Control_Category.categoryFn), Data_Either.Right.create));
          return f(v.value0)(v.value1);
      };
  };
  var review = Data_Newtype.under()()(Data_Lens_Internal_Tagged.Tagged);
  var prism = function (to) {
      return function (fro) {
          return function (dictChoice) {
              return function (pab) {
                  return Data_Profunctor.dimap(dictChoice.Profunctor0())(fro)(Data_Either.either(Control_Category.identity(Control_Category.categoryFn))(Control_Category.identity(Control_Category.categoryFn)))(Data_Profunctor_Choice.right(dictChoice)(Data_Profunctor.rmap(dictChoice.Profunctor0())(to)(pab)));
              };
          };
      };
  };
  var prism$prime = function (to) {
      return function (fro) {
          return function (dictChoice) {
              return prism(to)(function (s) {
                  return Data_Maybe.maybe(new Data_Either.Left(s))(Data_Either.Right.create)(fro(s));
              })(dictChoice);
          };
      };
  };
  var matching = function (l) {
      return withPrism(l)(function (v) {
          return function (f) {
              return f;
          };
      });
  };
  var is = function (dictHeytingAlgebra) {
      return function (l) {
          var $16 = Data_Either.either(Data_Function["const"](Data_HeytingAlgebra.ff(dictHeytingAlgebra)))(Data_Function["const"](Data_HeytingAlgebra.tt(dictHeytingAlgebra)));
          var $17 = matching(l);
          return function ($18) {
              return $16($17($18));
          };
      };
  };
  exports["prism'"] = prism$prime;
  exports["prism"] = prism;
  exports["review"] = review;
  exports["is"] = is;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.List.Types"] = $PS["Data.List.Types"] || {};
  var exports = $PS["Data.List.Types"];
  var Control_Alt = $PS["Control.Alt"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Plus = $PS["Control.Plus"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];
  var Data_Unfoldable1 = $PS["Data.Unfoldable1"];                
  var Nil = (function () {
      function Nil() {

      };
      Nil.value = new Nil();
      return Nil;
  })();
  var Cons = (function () {
      function Cons(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Cons.create = function (value0) {
          return function (value1) {
              return new Cons(value0, value1);
          };
      };
      return Cons;
  })();
  var NonEmptyList = function (x) {
      return x;
  };
  var listMap = function (f) {
      var chunkedRevMap = function ($copy_chunksAcc) {
          return function ($copy_v) {
              var $tco_var_chunksAcc = $copy_chunksAcc;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(chunksAcc, v) {
                  if (v instanceof Cons && (v.value1 instanceof Cons && v.value1.value1 instanceof Cons)) {
                      $tco_var_chunksAcc = new Cons(v, chunksAcc);
                      $copy_v = v.value1.value1.value1;
                      return;
                  };
                  var unrolledMap = function (v1) {
                      if (v1 instanceof Cons && (v1.value1 instanceof Cons && v1.value1.value1 instanceof Nil)) {
                          return new Cons(f(v1.value0), new Cons(f(v1.value1.value0), Nil.value));
                      };
                      if (v1 instanceof Cons && v1.value1 instanceof Nil) {
                          return new Cons(f(v1.value0), Nil.value);
                      };
                      return Nil.value;
                  };
                  var reverseUnrolledMap = function ($copy_v1) {
                      return function ($copy_acc) {
                          var $tco_var_v1 = $copy_v1;
                          var $tco_done1 = false;
                          var $tco_result;
                          function $tco_loop(v1, acc) {
                              if (v1 instanceof Cons && (v1.value0 instanceof Cons && (v1.value0.value1 instanceof Cons && v1.value0.value1.value1 instanceof Cons))) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_acc = new Cons(f(v1.value0.value0), new Cons(f(v1.value0.value1.value0), new Cons(f(v1.value0.value1.value1.value0), acc)));
                                  return;
                              };
                              $tco_done1 = true;
                              return acc;
                          };
                          while (!$tco_done1) {
                              $tco_result = $tco_loop($tco_var_v1, $copy_acc);
                          };
                          return $tco_result;
                      };
                  };
                  $tco_done = true;
                  return reverseUnrolledMap(chunksAcc)(unrolledMap(v));
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_chunksAcc, $copy_v);
              };
              return $tco_result;
          };
      };
      return chunkedRevMap(Nil.value);
  };
  var functorList = new Data_Functor.Functor(listMap);                 
  var foldableList = new Data_Foldable.Foldable(function (dictMonoid) {
      return function (f) {
          return Data_Foldable.foldl(foldableList)(function (acc) {
              var $205 = Data_Semigroup.append(dictMonoid.Semigroup0())(acc);
              return function ($206) {
                  return $205(f($206));
              };
          })(Data_Monoid.mempty(dictMonoid));
      };
  }, function (f) {
      var go = function ($copy_b) {
          return function ($copy_v) {
              var $tco_var_b = $copy_b;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(b, v) {
                  if (v instanceof Nil) {
                      $tco_done = true;
                      return b;
                  };
                  if (v instanceof Cons) {
                      $tco_var_b = f(b)(v.value0);
                      $copy_v = v.value1;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.List.Types (line 112, column 12 - line 114, column 30): " + [ v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_b, $copy_v);
              };
              return $tco_result;
          };
      };
      return go;
  }, function (f) {
      return function (b) {
          var rev = (function () {
              var go = function ($copy_acc) {
                  return function ($copy_v) {
                      var $tco_var_acc = $copy_acc;
                      var $tco_done1 = false;
                      var $tco_result;
                      function $tco_loop(acc, v) {
                          if (v instanceof Nil) {
                              $tco_done1 = true;
                              return acc;
                          };
                          if (v instanceof Cons) {
                              $tco_var_acc = new Cons(v.value0, acc);
                              $copy_v = v.value1;
                              return;
                          };
                          throw new Error("Failed pattern match at Data.List.Types (line 108, column 7 - line 108, column 23): " + [ acc.constructor.name, v.constructor.name ]);
                      };
                      while (!$tco_done1) {
                          $tco_result = $tco_loop($tco_var_acc, $copy_v);
                      };
                      return $tco_result;
                  };
              };
              return go(Nil.value);
          })();
          var $207 = Data_Foldable.foldl(foldableList)(Data_Function.flip(f))(b);
          return function ($208) {
              return $207(rev($208));
          };
      };
  });
  var semigroupList = new Data_Semigroup.Semigroup(function (xs) {
      return function (ys) {
          return Data_Foldable.foldr(foldableList)(Cons.create)(ys)(xs);
      };
  });
  var unfoldable1List = new Data_Unfoldable1.Unfoldable1(function (f) {
      return function (b) {
          var go = function ($copy_source) {
              return function ($copy_memo) {
                  var $tco_var_source = $copy_source;
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(source, memo) {
                      var v = f(source);
                      if (v.value1 instanceof Data_Maybe.Just) {
                          $tco_var_source = v.value1.value0;
                          $copy_memo = new Cons(v.value0, memo);
                          return;
                      };
                      if (v.value1 instanceof Data_Maybe.Nothing) {
                          $tco_done = true;
                          return Data_Foldable.foldl(foldableList)(Data_Function.flip(Cons.create))(Nil.value)(new Cons(v.value0, memo));
                      };
                      throw new Error("Failed pattern match at Data.List.Types (line 136, column 22 - line 138, column 61): " + [ v.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($tco_var_source, $copy_memo);
                  };
                  return $tco_result;
              };
          };
          return go(b)(Nil.value);
      };
  });
  var unfoldableList = new Data_Unfoldable.Unfoldable(function () {
      return unfoldable1List;
  }, function (f) {
      return function (b) {
          var go = function ($copy_source) {
              return function ($copy_memo) {
                  var $tco_var_source = $copy_source;
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(source, memo) {
                      var v = f(source);
                      if (v instanceof Data_Maybe.Nothing) {
                          $tco_done = true;
                          return Data_Foldable.foldl(foldableList)(Data_Function.flip(Cons.create))(Nil.value)(memo);
                      };
                      if (v instanceof Data_Maybe.Just) {
                          $tco_var_source = v.value0.value1;
                          $copy_memo = new Cons(v.value0.value0, memo);
                          return;
                      };
                      throw new Error("Failed pattern match at Data.List.Types (line 143, column 22 - line 145, column 52): " + [ v.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($tco_var_source, $copy_memo);
                  };
                  return $tco_result;
              };
          };
          return go(b)(Nil.value);
      };
  });
  var applyList = new Control_Apply.Apply(function () {
      return functorList;
  }, function (v) {
      return function (v1) {
          if (v instanceof Nil) {
              return Nil.value;
          };
          if (v instanceof Cons) {
              return Data_Semigroup.append(semigroupList)(Data_Functor.map(functorList)(v.value0)(v1))(Control_Apply.apply(applyList)(v.value1)(v1));
          };
          throw new Error("Failed pattern match at Data.List.Types (line 158, column 1 - line 160, column 48): " + [ v.constructor.name, v1.constructor.name ]);
      };
  });
  var bindList = new Control_Bind.Bind(function () {
      return applyList;
  }, function (v) {
      return function (v1) {
          if (v instanceof Nil) {
              return Nil.value;
          };
          if (v instanceof Cons) {
              return Data_Semigroup.append(semigroupList)(v1(v.value0))(Control_Bind.bind(bindList)(v.value1)(v1));
          };
          throw new Error("Failed pattern match at Data.List.Types (line 165, column 1 - line 167, column 37): " + [ v.constructor.name, v1.constructor.name ]);
      };
  });
  var applicativeList = new Control_Applicative.Applicative(function () {
      return applyList;
  }, function (a) {
      return new Cons(a, Nil.value);
  });                                              
  var altList = new Control_Alt.Alt(function () {
      return functorList;
  }, Data_Semigroup.append(semigroupList));
  var plusList = new Control_Plus.Plus(function () {
      return altList;
  }, Nil.value);
  exports["Nil"] = Nil;
  exports["Cons"] = Cons;
  exports["NonEmptyList"] = NonEmptyList;
  exports["semigroupList"] = semigroupList;
  exports["foldableList"] = foldableList;
  exports["unfoldableList"] = unfoldableList;
  exports["applicativeList"] = applicativeList;
  exports["bindList"] = bindList;
  exports["plusList"] = plusList;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.List"] = $PS["Data.List"] || {};
  var exports = $PS["Data.List"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];                                  
  var uncons = function (v) {
      if (v instanceof Data_List_Types.Nil) {
          return Data_Maybe.Nothing.value;
      };
      if (v instanceof Data_List_Types.Cons) {
          return new Data_Maybe.Just({
              head: v.value0,
              tail: v.value1
          });
      };
      throw new Error("Failed pattern match at Data.List (line 263, column 1 - line 263, column 66): " + [ v.constructor.name ]);
  };
  var toUnfoldable = function (dictUnfoldable) {
      return Data_Unfoldable.unfoldr(dictUnfoldable)(function (xs) {
          return Data_Functor.map(Data_Maybe.functorMaybe)(function (rec) {
              return new Data_Tuple.Tuple(rec.head, rec.tail);
          })(uncons(xs));
      });
  };
  var tail = function (v) {
      if (v instanceof Data_List_Types.Nil) {
          return Data_Maybe.Nothing.value;
      };
      if (v instanceof Data_List_Types.Cons) {
          return new Data_Maybe.Just(v.value1);
      };
      throw new Error("Failed pattern match at Data.List (line 249, column 1 - line 249, column 43): " + [ v.constructor.name ]);
  };
  var reverse = (function () {
      var go = function ($copy_acc) {
          return function ($copy_v) {
              var $tco_var_acc = $copy_acc;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(acc, v) {
                  if (v instanceof Data_List_Types.Nil) {
                      $tco_done = true;
                      return acc;
                  };
                  if (v instanceof Data_List_Types.Cons) {
                      $tco_var_acc = new Data_List_Types.Cons(v.value0, acc);
                      $copy_v = v.value1;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.List (line 372, column 3 - line 372, column 19): " + [ acc.constructor.name, v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_acc, $copy_v);
              };
              return $tco_result;
          };
      };
      return go(Data_List_Types.Nil.value);
  })();
  var $$null = function (v) {
      if (v instanceof Data_List_Types.Nil) {
          return true;
      };
      return false;
  };
  var head = function (v) {
      if (v instanceof Data_List_Types.Nil) {
          return Data_Maybe.Nothing.value;
      };
      if (v instanceof Data_List_Types.Cons) {
          return new Data_Maybe.Just(v.value0);
      };
      throw new Error("Failed pattern match at Data.List (line 234, column 1 - line 234, column 22): " + [ v.constructor.name ]);
  };                                                                              
  var concat = function (v) {
      return Control_Bind.bind(Data_List_Types.bindList)(v)(Control_Category.identity(Control_Category.categoryFn));
  };
  exports["toUnfoldable"] = toUnfoldable;
  exports["null"] = $$null;
  exports["reverse"] = reverse;
  exports["concat"] = concat;
})(PS);
(function(exports) {
  "use strict";

  exports.intercalate = function (separator) {
    return function (xs) {
      var len = xs.length;
      if (len === 0) return "";

      var res = xs[0];
      for (var i = 1; i < len; i++) {
        res = res + separator + xs[i];
      }
      return res;
    };
  };
})(PS["Data.Show.Generic"] = PS["Data.Show.Generic"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Show.Generic"] = $PS["Data.Show.Generic"] || {};
  var exports = $PS["Data.Show.Generic"];
  var $foreign = $PS["Data.Show.Generic"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var GenericShowArgs = function (genericShowArgs) {
      this.genericShowArgs = genericShowArgs;
  };
  var GenericShow = function (genericShow$prime) {
      this["genericShow'"] = genericShow$prime;
  };
  var genericShowArgsNoArguments = new GenericShowArgs(function (v) {
      return [  ];
  });
  var genericShowArgsArgument = function (dictShow) {
      return new GenericShowArgs(function (v) {
          return [ Data_Show.show(dictShow)(v) ];
      });
  };
  var genericShowArgs = function (dict) {
      return dict.genericShowArgs;
  };
  var genericShowArgsProduct = function (dictGenericShowArgs) {
      return function (dictGenericShowArgs1) {
          return new GenericShowArgs(function (v) {
              return Data_Semigroup.append(Data_Semigroup.semigroupArray)(genericShowArgs(dictGenericShowArgs)(v.value0))(genericShowArgs(dictGenericShowArgs1)(v.value1));
          });
      };
  };
  var genericShowConstructor = function (dictGenericShowArgs) {
      return function (dictIsSymbol) {
          return new GenericShow(function (v) {
              var ctor = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
              var v1 = genericShowArgs(dictGenericShowArgs)(v);
              if (v1.length === 0) {
                  return ctor;
              };
              return "(" + ($foreign.intercalate(" ")(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ ctor ])(v1)) + ")");
          });
      };
  };
  var genericShow$prime = function (dict) {
      return dict["genericShow'"];
  }; 
  var genericShowSum = function (dictGenericShow) {
      return function (dictGenericShow1) {
          return new GenericShow(function (v) {
              if (v instanceof Data_Generic_Rep.Inl) {
                  return genericShow$prime(dictGenericShow)(v.value0);
              };
              if (v instanceof Data_Generic_Rep.Inr) {
                  return genericShow$prime(dictGenericShow1)(v.value0);
              };
              throw new Error("Failed pattern match at Data.Show.Generic (line 26, column 1 - line 28, column 40): " + [ v.constructor.name ]);
          });
      };
  };
  var genericShow = function (dictGeneric) {
      return function (dictGenericShow) {
          return function (x) {
              return genericShow$prime(dictGenericShow)(Data_Generic_Rep.from(dictGeneric)(x));
          };
      };
  };
  exports["genericShow"] = genericShow;
  exports["genericShowArgsNoArguments"] = genericShowArgsNoArguments;
  exports["genericShowSum"] = genericShowSum;
  exports["genericShowArgsProduct"] = genericShowArgsProduct;
  exports["genericShowConstructor"] = genericShowConstructor;
  exports["genericShowArgsArgument"] = genericShowArgsArgument;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Internal.Re"] = $PS["Data.Lens.Internal.Re"] || {};
  var exports = $PS["Data.Lens.Internal.Re"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var profunctorRe = function (dictProfunctor) {
      return new Data_Profunctor.Profunctor(function (f) {
          return function (g) {
              return function (v) {
                  var $25 = Data_Profunctor.dimap(dictProfunctor)(g)(f);
                  return function ($26) {
                      return v($25($26));
                  };
              };
          };
      });
  };
  exports["profunctorRe"] = profunctorRe;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Iso"] = $PS["Data.Lens.Iso"] || {};
  var exports = $PS["Data.Lens.Iso"];
  var Control_Category = $PS["Control.Category"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var re = function (t) {
      return Data_Newtype.unwrap()(t(Control_Category.identity(Control_Category.categoryFn)));
  };
  var iso = function (f) {
      return function (g) {
          return function (dictProfunctor) {
              return function (pab) {
                  return Data_Profunctor.dimap(dictProfunctor)(f)(g)(pab);
              };
          };
      };
  };
  exports["iso"] = iso;
  exports["re"] = re;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Iso.Newtype"] = $PS["Data.Lens.Iso.Newtype"] || {};
  var exports = $PS["Data.Lens.Iso.Newtype"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Newtype = $PS["Data.Newtype"];                
  var _Newtype = function (dictNewtype) {
      return function (dictNewtype1) {
          return function (dictProfunctor) {
              return Data_Lens_Iso.iso(Data_Newtype.unwrap())(Data_Newtype.wrap())(dictProfunctor);
          };
      };
  };
  exports["_Newtype"] = _Newtype;
})(PS);
(function(exports) {
  "use strict";

  // module Data.ArrayBuffer.ArrayBuffer

  exports.emptyImpl = function empty (s) {
      return new ArrayBuffer(s);
  };
})(PS["Data.ArrayBuffer.ArrayBuffer"] = PS["Data.ArrayBuffer.ArrayBuffer"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.ArrayBuffer.ArrayBuffer"] = $PS["Data.ArrayBuffer.ArrayBuffer"] || {};
  var exports = $PS["Data.ArrayBuffer.ArrayBuffer"];
  var $foreign = $PS["Data.ArrayBuffer.ArrayBuffer"];
  var empty = function (l) {
      return function () {
          return $foreign.emptyImpl(l);
      };
  };
  exports["empty"] = empty;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.ArrayBuffer.Class.Types"] = $PS["Data.ArrayBuffer.Class.Types"] || {};
  var exports = $PS["Data.ArrayBuffer.Class.Types"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ring = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];                
  var Uint8 = function (x) {
      return x;
  };
  var Uint32BE = function (x) {
      return x;
  };
  var Int16LE = function (x) {
      return x;
  };                                  
  var showInt16LE = Data_Show.showInt;            
  var semiringInt16LE = Data_Semiring.semiringInt;
  var ringInt16LE = Data_Ring.ringInt;
  var ordInt16LE = Data_Ord.ordInt;
  var eqInt16LE = Data_Eq.eqInt;
  exports["Uint32BE"] = Uint32BE;
  exports["Uint8"] = Uint8;
  exports["Int16LE"] = Int16LE;
  exports["eqInt16LE"] = eqInt16LE;
  exports["ordInt16LE"] = ordInt16LE;
  exports["showInt16LE"] = showInt16LE;
  exports["semiringInt16LE"] = semiringInt16LE;
  exports["ringInt16LE"] = ringInt16LE;
})(PS);
(function(exports) {
  "use strict";

  // module Data.ArrayBuffer.DataView


  exports.whole = function whole (b) {
      return new DataView(b);
  };

  exports.getterImpl = function getterImpl (data, v, o) {
      return ((o + data.bytesPerValue) >>> 0) <= v.byteLength
          ? v[data.functionName].call(v,o,data.littleEndian)
          : null;
  };

  exports.setterImpl = function setterImpl (data, v, o, n) {
      if (((o + data.bytesPerValue) >>> 0) <= v.byteLength) {
          v[data.functionName].call(v,o,n,data.littleEndian);
          return true;
      } else {
          return false;
      }
  };
})(PS["Data.ArrayBuffer.DataView"] = PS["Data.ArrayBuffer.DataView"] || {});
(function(exports) {
  /* eslint-disable no-eq-null, eqeqeq */

  "use strict";

  exports["null"] = null;

  exports.nullable = function (a, r, f) {
    return a == null ? r : f(a);
  };

  exports.notNull = function (x) {
    return x;
  };
})(PS["Data.Nullable"] = PS["Data.Nullable"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Nullable"] = $PS["Data.Nullable"] || {};
  var exports = $PS["Data.Nullable"];
  var $foreign = $PS["Data.Nullable"];
  var Data_Maybe = $PS["Data.Maybe"];              
  var toNullable = Data_Maybe.maybe($foreign["null"])($foreign.notNull);
  var toMaybe = function (n) {
      return $foreign.nullable(n, Data_Maybe.Nothing.value, Data_Maybe.Just.create);
  };
  exports["toMaybe"] = toMaybe;
  exports["toNullable"] = toNullable;
  exports["null"] = $foreign["null"];
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Typelevel.Undefined"] = $PS["Data.Typelevel.Undefined"] || {};
  var exports = $PS["Data.Typelevel.Undefined"];
  var Data_Unit = $PS["Data.Unit"];                
  var $$undefined = Data_Unit.unit;
  exports["undefined"] = $$undefined;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Typelevel.Num.Sets"] = $PS["Data.Typelevel.Num.Sets"] || {};
  var exports = $PS["Data.Typelevel.Num.Sets"];
  var Data_Typelevel_Undefined = $PS["Data.Typelevel.Undefined"];
  var Nat = function (toInt) {
      this.toInt = toInt;
  };
  var toInt = function (dict) {
      return dict.toInt;
  };
  var toInt$prime = function (dictNat) {
      return function (v) {
          return toInt(dictNat)(Data_Typelevel_Undefined["undefined"]);
      };
  }; 
  var natD4 = new Nat(function (v) {
      return 4;
  });
  var natD2 = new Nat(function (v) {
      return 2;
  });
  var natD1 = new Nat(function (v) {
      return 1;
  });
  exports["toInt'"] = toInt$prime;
  exports["natD1"] = natD1;
  exports["natD2"] = natD2;
  exports["natD4"] = natD4;
})(PS);
(function(exports) {
  "use strict";

  exports.pureE = function (a) {
    return function () {
      return a;
    };
  };

  exports.bindE = function (a) {
    return function (f) {
      return function () {
        return f(a())();
      };
    };
  };
})(PS["Effect"] = PS["Effect"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect"] = $PS["Effect"] || {};
  var exports = $PS["Effect"];
  var $foreign = $PS["Effect"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Data_Functor = $PS["Data.Functor"];                    
  var monadEffect = new Control_Monad.Monad(function () {
      return applicativeEffect;
  }, function () {
      return bindEffect;
  });
  var bindEffect = new Control_Bind.Bind(function () {
      return applyEffect;
  }, $foreign.bindE);
  var applyEffect = new Control_Apply.Apply(function () {
      return functorEffect;
  }, Control_Monad.ap(monadEffect));
  var applicativeEffect = new Control_Applicative.Applicative(function () {
      return applyEffect;
  }, $foreign.pureE);
  var functorEffect = new Data_Functor.Functor(Control_Applicative.liftA1(applicativeEffect));
  exports["functorEffect"] = functorEffect;
  exports["applyEffect"] = applyEffect;
  exports["applicativeEffect"] = applicativeEffect;
  exports["bindEffect"] = bindEffect;
  exports["monadEffect"] = monadEffect;
})(PS);
(function(exports) {
  "use strict";

  exports.runEffectFn4 = function runEffectFn4(fn) {
    return function(a) {
      return function(b) {
        return function(c) {
          return function(d) {
            return function() {
              return fn(a, b, c, d);
            };
          };
        };
      };
    };
  };
})(PS["Effect.Uncurried"] = PS["Effect.Uncurried"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Uncurried"] = $PS["Effect.Uncurried"] || {};
  var exports = $PS["Effect.Uncurried"];
  var $foreign = $PS["Effect.Uncurried"];
  exports["runEffectFn4"] = $foreign.runEffectFn4;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.ArrayBuffer.DataView"] = $PS["Data.ArrayBuffer.DataView"] || {};
  var exports = $PS["Data.ArrayBuffer.DataView"];
  var $foreign = $PS["Data.ArrayBuffer.DataView"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Typelevel_Num_Sets = $PS["Data.Typelevel.Num.Sets"];
  var Effect = $PS["Effect"];
  var Effect_Uncurried = $PS["Effect.Uncurried"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var LE = (function () {
      function LE() {

      };
      LE.value = new LE();
      return LE;
  })();
  var BE = (function () {
      function BE() {

      };
      BE.value = new BE();
      return BE;
  })();
  var AProxy = (function () {
      function AProxy() {

      };
      AProxy.value = new AProxy();
      return AProxy;
  })();
  var setter = function (d) {
      return function (o) {
          return function (t) {
              return Effect_Uncurried.runEffectFn4($foreign.setterImpl)(d)(o)(t);
          };
      };
  };
  var getter = function (data$prime) {
      return function (d) {
          return function (o) {
              return Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe)(function () {
                  return $foreign.getterImpl({
                      functionName: data$prime.functionName,
                      littleEndian: data$prime.littleEndian,
                      bytesPerValue: data$prime.bytesPerValue
                  }, d, o);
              });
          };
      };
  };
  var eqEndian = new Data_Eq.Eq(function (v) {
      return function (v1) {
          if (v instanceof LE && v1 instanceof LE) {
              return true;
          };
          if (v instanceof BE && v1 instanceof BE) {
              return true;
          };
          return false;
      };
  });
  var get = function (dictBinaryValue) {
      return function (dictBytesPerValue) {
          return function (dictShowArrayViewType) {
              return function (dictIsSymbol) {
                  return function (dictNat) {
                      return function (endian) {
                          return function (prx) {
                              var pnm = "get" + Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                              var le = Data_Eq.eq(eqEndian)(endian)(LE.value);
                              var bpv = Data_Typelevel_Num_Sets["toInt'"](dictNat)(Type_Proxy["Proxy"].value);
                              return getter({
                                  functionName: pnm,
                                  bytesPerValue: bpv,
                                  littleEndian: le
                              });
                          };
                      };
                  };
              };
          };
      };
  };
  var getBE = function (dictBinaryValue) {
      return function (dictBytesPerValue) {
          return function (dictShowArrayViewType) {
              return function (dictIsSymbol) {
                  return function (dictNat) {
                      return get()()()(dictIsSymbol)(dictNat)(BE.value);
                  };
              };
          };
      };
  };                                               
  var getUint32be = getBE()()()(new Data_Symbol.IsSymbol(function () {
      return "Uint32";
  }))(Data_Typelevel_Num_Sets.natD4)(AProxy.value);
  var getLE = function (dictBinaryValue) {
      return function (dictBytesPerValue) {
          return function (dictShowArrayViewType) {
              return function (dictIsSymbol) {
                  return function (dictNat) {
                      return get()()()(dictIsSymbol)(dictNat)(LE.value);
                  };
              };
          };
      };
  };                                               
  var getInt16le = getLE()()()(new Data_Symbol.IsSymbol(function () {
      return "Int16";
  }))(Data_Typelevel_Num_Sets.natD2)(AProxy.value);
  var getUint8 = getLE()()()(new Data_Symbol.IsSymbol(function () {
      return "Uint8";
  }))(Data_Typelevel_Num_Sets.natD1)(AProxy.value);
  var set = function (dictBinaryValue) {
      return function (dictBytesPerValue) {
          return function (dictShowArrayViewType) {
              return function (dictIsSymbol) {
                  return function (dictNat) {
                      return function (endian) {
                          return function (prx) {
                              var pnm = "set" + Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                              var le = Data_Eq.eq(eqEndian)(endian)(LE.value);
                              var bpv = Data_Typelevel_Num_Sets["toInt'"](dictNat)(Type_Proxy["Proxy"].value);
                              return setter({
                                  functionName: pnm,
                                  bytesPerValue: bpv,
                                  littleEndian: le
                              });
                          };
                      };
                  };
              };
          };
      };
  };
  var setBE = function (dictBinaryValue) {
      return function (dictBytesPerValue) {
          return function (dictShowArrayViewType) {
              return function (dictIsSymbol) {
                  return function (dictNat) {
                      return set()()()(dictIsSymbol)(dictNat)(BE.value);
                  };
              };
          };
      };
  };                                               
  var setUint32be = setBE()()()(new Data_Symbol.IsSymbol(function () {
      return "Uint32";
  }))(Data_Typelevel_Num_Sets.natD4)(AProxy.value);
  var setLE = function (dictBinaryValue) {
      return function (dictBytesPerValue) {
          return function (dictShowArrayViewType) {
              return function (dictIsSymbol) {
                  return function (dictNat) {
                      return set()()()(dictIsSymbol)(dictNat)(LE.value);
                  };
              };
          };
      };
  };                                               
  var setInt16le = setLE()()()(new Data_Symbol.IsSymbol(function () {
      return "Int16";
  }))(Data_Typelevel_Num_Sets.natD2)(AProxy.value);
  var setUint8 = setLE()()()(new Data_Symbol.IsSymbol(function () {
      return "Uint8";
  }))(Data_Typelevel_Num_Sets.natD1)(AProxy.value);
  exports["getInt16le"] = getInt16le;
  exports["getUint32be"] = getUint32be;
  exports["getUint8"] = getUint8;
  exports["setInt16le"] = setInt16le;
  exports["setUint32be"] = setUint32be;
  exports["setUint8"] = setUint8;
  exports["whole"] = $foreign.whole;
})(PS);
(function(exports) {
  "use strict";

  exports.toCharCode = function (c) {
    return c.charCodeAt(0);
  };

  exports.fromCharCode = function (c) {
    return String.fromCharCode(c);
  };
})(PS["Data.Enum"] = PS["Data.Enum"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Enum"] = $PS["Data.Enum"] || {};
  var exports = $PS["Data.Enum"];
  var $foreign = $PS["Data.Enum"];
  var Data_Bounded = $PS["Data.Bounded"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];                  
  var Enum = function (Ord0, pred, succ) {
      this.Ord0 = Ord0;
      this.pred = pred;
      this.succ = succ;
  };
  var BoundedEnum = function (Bounded0, Enum1, cardinality, fromEnum, toEnum) {
      this.Bounded0 = Bounded0;
      this.Enum1 = Enum1;
      this.cardinality = cardinality;
      this.fromEnum = fromEnum;
      this.toEnum = toEnum;
  };
  var toEnum = function (dict) {
      return dict.toEnum;
  }; 
  var fromEnum = function (dict) {
      return dict.fromEnum;
  };
  var toEnumWithDefaults = function (dictBoundedEnum) {
      return function (low) {
          return function (high) {
              return function (x) {
                  var v = toEnum(dictBoundedEnum)(x);
                  if (v instanceof Data_Maybe.Just) {
                      return v.value0;
                  };
                  if (v instanceof Data_Maybe.Nothing) {
                      var $51 = x < fromEnum(dictBoundedEnum)(Data_Bounded.bottom(dictBoundedEnum.Bounded0()));
                      if ($51) {
                          return low;
                      };
                      return high;
                  };
                  throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [ v.constructor.name ]);
              };
          };
      };
  };
  var defaultSucc = function (toEnum$prime) {
      return function (fromEnum$prime) {
          return function (a) {
              return toEnum$prime(fromEnum$prime(a) + 1 | 0);
          };
      };
  };
  var defaultPred = function (toEnum$prime) {
      return function (fromEnum$prime) {
          return function (a) {
              return toEnum$prime(fromEnum$prime(a) - 1 | 0);
          };
      };
  };
  var charToEnum = function (v) {
      if (v >= Data_Bounded.bottom(Data_Bounded.boundedInt) && v <= Data_Bounded.top(Data_Bounded.boundedInt)) {
          return new Data_Maybe.Just($foreign.fromCharCode(v));
      };
      return Data_Maybe.Nothing.value;
  };
  var enumChar = new Enum(function () {
      return Data_Ord.ordChar;
  }, defaultPred(charToEnum)($foreign.toCharCode), defaultSucc(charToEnum)($foreign.toCharCode));
  var boundedEnumChar = new BoundedEnum(function () {
      return Data_Bounded.boundedChar;
  }, function () {
      return enumChar;
  }, $foreign.toCharCode(Data_Bounded.top(Data_Bounded.boundedChar)) - $foreign.toCharCode(Data_Bounded.bottom(Data_Bounded.boundedChar)) | 0, $foreign.toCharCode, charToEnum);
  exports["Enum"] = Enum;
  exports["BoundedEnum"] = BoundedEnum;
  exports["toEnum"] = toEnum;
  exports["fromEnum"] = fromEnum;
  exports["toEnumWithDefaults"] = toEnumWithDefaults;
  exports["defaultSucc"] = defaultSucc;
  exports["defaultPred"] = defaultPred;
  exports["boundedEnumChar"] = boundedEnumChar;
})(PS);
(function(exports) {
  "use strict";

  exports.xor = function (n1) {
    return function (n2) {
      /* jshint bitwise: false */
      return n1 ^ n2;
    };
  };
})(PS["Data.Int.Bits"] = PS["Data.Int.Bits"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Int.Bits"] = $PS["Data.Int.Bits"] || {};
  var exports = $PS["Data.Int.Bits"];
  var $foreign = $PS["Data.Int.Bits"];
  exports["xor"] = $foreign.xor;
})(PS);
(function(exports) {
  "use strict";
  /* global Symbol */

  var hasArrayFrom = typeof Array.from === "function";
  var hasStringIterator =
    typeof Symbol !== "undefined" &&
    Symbol != null &&
    typeof Symbol.iterator !== "undefined" &&
    typeof String.prototype[Symbol.iterator] === "function";
  var hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
  var hasCodePointAt = typeof String.prototype.codePointAt === "function";

  exports._unsafeCodePointAt0 = function (fallback) {
    return hasCodePointAt
      ? function (str) { return str.codePointAt(0); }
      : fallback;
  };

  exports._fromCodePointArray = function (singleton) {
    return hasFromCodePoint
      ? function (cps) {
        // Function.prototype.apply will fail for very large second parameters,
        // so we don't use it for arrays with 10,000 or more entries.
        if (cps.length < 10e3) {
          return String.fromCodePoint.apply(String, cps);
        }
        return cps.map(singleton).join("");
      }
      : function (cps) {
        return cps.map(singleton).join("");
      };
  };

  exports._singleton = function (fallback) {
    return hasFromCodePoint ? String.fromCodePoint : fallback;
  };

  exports._take = function (fallback) {
    return function (n) {
      if (hasStringIterator) {
        return function (str) {
          var accum = "";
          var iter = str[Symbol.iterator]();
          for (var i = 0; i < n; ++i) {
            var o = iter.next();
            if (o.done) return accum;
            accum += o.value;
          }
          return accum;
        };
      }
      return fallback(n);
    };
  };

  exports._toCodePointArray = function (fallback) {
    return function (unsafeCodePointAt0) {
      if (hasArrayFrom) {
        return function (str) {
          return Array.from(str, unsafeCodePointAt0);
        };
      }
      return fallback;
    };
  };
})(PS["Data.String.CodePoints"] = PS["Data.String.CodePoints"] || {});
(function(exports) {
  "use strict";

  exports.intDegree = function (x) {
    return Math.min(Math.abs(x), 2147483647);
  };

  // See the Euclidean definition in
  // https://en.m.wikipedia.org/wiki/Modulo_operation.
  exports.intDiv = function (x) {
    return function (y) {
      if (y === 0) return 0;
      return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
  };

  exports.intMod = function (x) {
    return function (y) {
      if (y === 0) return 0;
      var yy = Math.abs(y);
      return ((x % yy) + yy) % yy;
    };
  };
})(PS["Data.EuclideanRing"] = PS["Data.EuclideanRing"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.CommutativeRing"] = $PS["Data.CommutativeRing"] || {};
  var exports = $PS["Data.CommutativeRing"];
  var Data_Ring = $PS["Data.Ring"];
  var CommutativeRing = function (Ring0) {
      this.Ring0 = Ring0;
  }; 
  var commutativeRingInt = new CommutativeRing(function () {
      return Data_Ring.ringInt;
  });
  exports["commutativeRingInt"] = commutativeRingInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.EuclideanRing"] = $PS["Data.EuclideanRing"] || {};
  var exports = $PS["Data.EuclideanRing"];
  var $foreign = $PS["Data.EuclideanRing"];
  var Data_CommutativeRing = $PS["Data.CommutativeRing"];  
  var EuclideanRing = function (CommutativeRing0, degree, div, mod) {
      this.CommutativeRing0 = CommutativeRing0;
      this.degree = degree;
      this.div = div;
      this.mod = mod;
  };
  var mod = function (dict) {
      return dict.mod;
  }; 
  var euclideanRingInt = new EuclideanRing(function () {
      return Data_CommutativeRing.commutativeRingInt;
  }, $foreign.intDegree, $foreign.intDiv, $foreign.intMod);
  var div = function (dict) {
      return dict.div;
  };
  exports["div"] = div;
  exports["mod"] = mod;
  exports["euclideanRingInt"] = euclideanRingInt;
})(PS);
(function(exports) {
  "use strict";

  exports.singleton = function (c) {
    return c;
  };

  exports.length = function (s) {
    return s.length;
  };

  exports.drop = function (n) {
    return function (s) {
      return s.substring(n);
    };
  };
})(PS["Data.String.CodeUnits"] = PS["Data.String.CodeUnits"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.String.CodeUnits"] = $PS["Data.String.CodeUnits"] || {};
  var exports = $PS["Data.String.CodeUnits"];
  var $foreign = $PS["Data.String.CodeUnits"];
  exports["singleton"] = $foreign.singleton;
  exports["length"] = $foreign.length;
  exports["drop"] = $foreign.drop;
})(PS);
(function(exports) {
  "use strict";

  exports.toUpper = function (s) {
    return s.toUpperCase();
  };

  exports.joinWith = function (s) {
    return function (xs) {
      return xs.join(s);
    };
  };
})(PS["Data.String.Common"] = PS["Data.String.Common"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.String.Common"] = $PS["Data.String.Common"] || {};
  var exports = $PS["Data.String.Common"];
  var $foreign = $PS["Data.String.Common"];
  exports["toUpper"] = $foreign.toUpper;
  exports["joinWith"] = $foreign.joinWith;
})(PS);
(function(exports) {
  "use strict";

  exports.charAt = function (i) {
    return function (s) {
      if (i >= 0 && i < s.length) return s.charAt(i);
      throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
  };
})(PS["Data.String.Unsafe"] = PS["Data.String.Unsafe"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.String.Unsafe"] = $PS["Data.String.Unsafe"] || {};
  var exports = $PS["Data.String.Unsafe"];
  var $foreign = $PS["Data.String.Unsafe"];
  exports["charAt"] = $foreign.charAt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.String.CodePoints"] = $PS["Data.String.CodePoints"] || {};
  var exports = $PS["Data.String.CodePoints"];
  var $foreign = $PS["Data.String.CodePoints"];
  var Data_Array = $PS["Data.Array"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Bounded = $PS["Data.Bounded"];
  var Data_Enum = $PS["Data.Enum"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_EuclideanRing = $PS["Data.EuclideanRing"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Show = $PS["Data.Show"];
  var Data_String_CodeUnits = $PS["Data.String.CodeUnits"];
  var Data_String_Common = $PS["Data.String.Common"];
  var Data_String_Unsafe = $PS["Data.String.Unsafe"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];
  var unsurrogate = function (lead) {
      return function (trail) {
          return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
      };
  };
  var showCodePoint = new Data_Show.Show(function (v) {
      return "(CodePoint 0x" + (Data_String_Common.toUpper(Data_Int.toStringAs(Data_Int.hexadecimal)(v)) + ")");
  });
  var isTrail = function (cu) {
      return 56320 <= cu && cu <= 57343;
  };
  var isLead = function (cu) {
      return 55296 <= cu && cu <= 56319;
  };
  var uncons = function (s) {
      var v = Data_String_CodeUnits.length(s);
      if (v === 0) {
          return Data_Maybe.Nothing.value;
      };
      if (v === 1) {
          return new Data_Maybe.Just({
              head: Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(Data_String_Unsafe.charAt(0)(s)),
              tail: ""
          });
      };
      var cu1 = Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(Data_String_Unsafe.charAt(1)(s));
      var cu0 = Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(Data_String_Unsafe.charAt(0)(s));
      var $21 = isLead(cu0) && isTrail(cu1);
      if ($21) {
          return new Data_Maybe.Just({
              head: unsurrogate(cu0)(cu1),
              tail: Data_String_CodeUnits.drop(2)(s)
          });
      };
      return new Data_Maybe.Just({
          head: cu0,
          tail: Data_String_CodeUnits.drop(1)(s)
      });
  };
  var unconsButWithTuple = function (s) {
      return Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
          return new Data_Tuple.Tuple(v.head, v.tail);
      })(uncons(s));
  };
  var toCodePointArrayFallback = function (s) {
      return Data_Unfoldable.unfoldr(Data_Unfoldable.unfoldableArray)(unconsButWithTuple)(s);
  };
  var unsafeCodePointAt0Fallback = function (s) {
      var cu0 = Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(Data_String_Unsafe.charAt(0)(s));
      var $25 = isLead(cu0) && Data_String_CodeUnits.length(s) > 1;
      if ($25) {
          var cu1 = Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(Data_String_Unsafe.charAt(1)(s));
          var $26 = isTrail(cu1);
          if ($26) {
              return unsurrogate(cu0)(cu1);
          };
          return cu0;
      };
      return cu0;
  };
  var unsafeCodePointAt0 = $foreign["_unsafeCodePointAt0"](unsafeCodePointAt0Fallback);
  var toCodePointArray = $foreign["_toCodePointArray"](toCodePointArrayFallback)(unsafeCodePointAt0);
  var length = function ($52) {
      return Data_Array.length(toCodePointArray($52));
  };
  var fromCharCode = (function () {
      var $53 = Data_Enum.toEnumWithDefaults(Data_Enum.boundedEnumChar)(Data_Bounded.bottom(Data_Bounded.boundedChar))(Data_Bounded.top(Data_Bounded.boundedChar));
      return function ($54) {
          return Data_String_CodeUnits.singleton($53($54));
      };
  })();
  var singletonFallback = function (v) {
      if (v <= 65535) {
          return fromCharCode(v);
      };
      var lead = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v - 65536 | 0)(1024) + 55296 | 0;
      var trail = Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v - 65536 | 0)(1024) + 56320 | 0;
      return fromCharCode(lead) + fromCharCode(trail);
  };
  var fromCodePointArray = $foreign["_fromCodePointArray"](singletonFallback);
  var singleton = $foreign["_singleton"](singletonFallback);
  var takeFallback = function (n) {
      return function (v) {
          if (n < 1) {
              return "";
          };
          var v1 = uncons(v);
          if (v1 instanceof Data_Maybe.Just) {
              return singleton(v1.value0.head) + takeFallback(n - 1 | 0)(v1.value0.tail);
          };
          return v;
      };
  };
  var take = $foreign["_take"](takeFallback);
  var eqCodePoint = new Data_Eq.Eq(function (x) {
      return function (y) {
          return x === y;
      };
  });
  var ordCodePoint = new Data_Ord.Ord(function () {
      return eqCodePoint;
  }, function (x) {
      return function (y) {
          return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
      };
  });
  var drop = function (n) {
      return function (s) {
          return Data_String_CodeUnits.drop(Data_String_CodeUnits.length(take(n)(s)))(s);
      };
  };
  var boundedCodePoint = new Data_Bounded.Bounded(function () {
      return ordCodePoint;
  }, 0, 1114111);
  var boundedEnumCodePoint = new Data_Enum.BoundedEnum(function () {
      return boundedCodePoint;
  }, function () {
      return enumCodePoint;
  }, 1114111 + 1 | 0, function (v) {
      return v;
  }, function (n) {
      if (n >= 0 && n <= 1114111) {
          return new Data_Maybe.Just(n);
      };
      if (Data_Boolean.otherwise) {
          return Data_Maybe.Nothing.value;
      };
      throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [ n.constructor.name ]);
  });
  var enumCodePoint = new Data_Enum.Enum(function () {
      return ordCodePoint;
  }, Data_Enum.defaultPred(Data_Enum.toEnum(boundedEnumCodePoint))(Data_Enum.fromEnum(boundedEnumCodePoint)), Data_Enum.defaultSucc(Data_Enum.toEnum(boundedEnumCodePoint))(Data_Enum.fromEnum(boundedEnumCodePoint)));
  exports["fromCodePointArray"] = fromCodePointArray;
  exports["toCodePointArray"] = toCodePointArray;
  exports["showCodePoint"] = showCodePoint;
  exports["boundedEnumCodePoint"] = boundedEnumCodePoint;
})(PS);
(function(exports) {
  "use strict";

  exports.from = function (val) {
      return val >>> 0;
  };

  exports.toInt = function (uval) {
      return uval | 0;
  };

  exports.toNumber = function (uval) {
      return uval;
  };

  exports.toString = function (x) {
      return x.toString();
  };
})(PS["Data.UInt"] = PS["Data.UInt"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.UInt"] = $PS["Data.UInt"] || {};
  var exports = $PS["Data.UInt"];
  var $foreign = $PS["Data.UInt"];
  var Data_Show = $PS["Data.Show"];                                    
  var uintShowInstance = new Data_Show.Show(function (u) {
      return $foreign.toString(u) + "u";
  });                                                                                                
  var fromNumber = $foreign.from;
  var fromInt = $foreign.from;
  exports["fromInt"] = fromInt;
  exports["fromNumber"] = fromNumber;
  exports["uintShowInstance"] = uintShowInstance;
  exports["toInt"] = $foreign.toInt;
  exports["toNumber"] = $foreign.toNumber;
})(PS);
(function(exports) {
  "use strict";

  exports.showErrorImpl = function (err) {
    return err.stack || err.toString();
  };

  exports.error = function (msg) {
    return new Error(msg);
  };

  exports.throwException = function (e) {
    return function () {
      throw e;
    };
  };
})(PS["Effect.Exception"] = PS["Effect.Exception"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Exception"] = $PS["Effect.Exception"] || {};
  var exports = $PS["Effect.Exception"];
  var $foreign = $PS["Effect.Exception"];
  var Data_Show = $PS["Data.Show"];
  var $$throw = function ($2) {
      return $foreign.throwException($foreign.error($2));
  };                                                                               
  var showError = new Data_Show.Show($foreign.showErrorImpl);
  exports["throw"] = $$throw;
  exports["showError"] = showError;
  exports["error"] = $foreign.error;
  exports["throwException"] = $foreign.throwException;
})(PS);
(function(exports) {
  "use strict";

  exports.new = function (val) {
    return function () {
      return { value: val };
    };
  };

  exports.read = function (ref) {
    return function () {
      return ref.value;
    };
  };

  exports.modifyImpl = function (f) {
    return function (ref) {
      return function () {
        var t = f(ref.value);
        ref.value = t.state;
        return t.value;
      };
    };
  };

  exports.write = function (val) {
    return function (ref) {
      return function () {
        ref.value = val;
      };
    };
  };
})(PS["Effect.Ref"] = PS["Effect.Ref"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Ref"] = $PS["Effect.Ref"] || {};
  var exports = $PS["Effect.Ref"];
  var $foreign = $PS["Effect.Ref"];
  var Data_Functor = $PS["Data.Functor"];
  var Effect = $PS["Effect"];                
  var modify$prime = $foreign.modifyImpl;
  var modify = function (f) {
      return modify$prime(function (s) {
          var s$prime = f(s);
          return {
              state: s$prime,
              value: s$prime
          };
      });
  };
  var modify_ = function (f) {
      return function (s) {
          return Data_Functor["void"](Effect.functorEffect)(modify(f)(s));
      };
  };
  exports["modify'"] = modify$prime;
  exports["modify_"] = modify_;
  exports["new"] = $foreign["new"];
  exports["read"] = $foreign.read;
  exports["write"] = $foreign.write;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.ArrayBuffer.Class"] = $PS["Data.ArrayBuffer.Class"] || {};
  var exports = $PS["Data.ArrayBuffer.Class"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Array = $PS["Data.Array"];
  var Data_ArrayBuffer_ArrayBuffer = $PS["Data.ArrayBuffer.ArrayBuffer"];
  var Data_ArrayBuffer_Class_Types = $PS["Data.ArrayBuffer.Class.Types"];
  var Data_ArrayBuffer_DataView = $PS["Data.ArrayBuffer.DataView"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Either = $PS["Data.Either"];
  var Data_Enum = $PS["Data.Enum"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Int_Bits = $PS["Data.Int.Bits"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_String_CodePoints = $PS["Data.String.CodePoints"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_UInt = $PS["Data.UInt"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Effect_Ref = $PS["Effect.Ref"];
  var EncodeArrayBuffer = function (putArrayBuffer) {
      this.putArrayBuffer = putArrayBuffer;
  };
  var DynamicByteLength = function (byteLength) {
      this.byteLength = byteLength;
  };
  var DecodeArrayBuffer = function (readArrayBuffer) {
      this.readArrayBuffer = readArrayBuffer;
  };
  var readArrayBuffer = function (dict) {
      return dict.readArrayBuffer;
  };
  var putArrayBuffer = function (dict) {
      return dict.putArrayBuffer;
  };
  var genericReadArrayBuffer = function (dictGeneric) {
      return function (dictDecodeArrayBuffer) {
          return function (b) {
              return function (o) {
                  return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.to(dictGeneric)))(readArrayBuffer(dictDecodeArrayBuffer)(b)(o));
              };
          };
      };
  };
  var genericPutArrayBuffer = function (dictGeneric) {
      return function (dictEncodeArrayBuffer) {
          return function (b) {
              return function (o) {
                  return function (x) {
                      return putArrayBuffer(dictEncodeArrayBuffer)(b)(o)(Data_Generic_Rep.from(dictGeneric)(x));
                  };
              };
          };
      };
  };
  var encodeArrayBufferUnit = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (v) {
              return Control_Applicative.pure(Effect.applicativeEffect)(new Data_Maybe.Just(0));
          };
      };
  });
  var encodeArrayBufferTuple = function (dictEncodeArrayBuffer) {
      return function (dictEncodeArrayBuffer1) {
          return new EncodeArrayBuffer(function (b) {
              return function (o) {
                  return function (v) {
                      return function __do() {
                          var mW = putArrayBuffer(dictEncodeArrayBuffer)(b)(o)(v.value0)();
                          if (mW instanceof Data_Maybe.Nothing) {
                              return Data_Maybe.Nothing.value;
                          };
                          if (mW instanceof Data_Maybe.Just) {
                              var mW$prime = putArrayBuffer(dictEncodeArrayBuffer1)(b)(o + mW.value0 | 0)(v.value1)();
                              if (mW$prime instanceof Data_Maybe.Nothing) {
                                  return new Data_Maybe.Just(mW.value0);
                              };
                              if (mW$prime instanceof Data_Maybe.Just) {
                                  return new Data_Maybe.Just(mW.value0 + mW$prime.value0 | 0);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 516, column 9 - line 518, column 42): " + [ mW$prime.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 512, column 5 - line 518, column 42): " + [ mW.constructor.name ]);
                      };
                  };
              };
          });
      };
  };
  var encodeArrayBufferProduct = function (dictEncodeArrayBuffer) {
      return function (dictEncodeArrayBuffer1) {
          return new EncodeArrayBuffer(function (b) {
              return function (o) {
                  return function (v) {
                      return putArrayBuffer(encodeArrayBufferTuple(dictEncodeArrayBuffer)(dictEncodeArrayBuffer1))(b)(o)(new Data_Tuple.Tuple(v.value0, v.value1));
                  };
              };
          });
      };
  }; 
  var encodeArrayBufferNoArguments = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (v) {
              return Control_Applicative.pure(Effect.applicativeEffect)(new Data_Maybe.Just(0));
          };
      };
  });
  var encodeArrayBufferConstructor = function (dictEncodeArrayBuffer) {
      return new EncodeArrayBuffer(function (b) {
          return function (o) {
              return function (v) {
                  return putArrayBuffer(dictEncodeArrayBuffer)(b)(o)(v);
              };
          };
      });
  };
  var encodeArrayBufferArgument = function (dictEncodeArrayBuffer) {
      return new EncodeArrayBuffer(function (b) {
          return function (o) {
              return function (v) {
                  return putArrayBuffer(dictEncodeArrayBuffer)(b)(o)(v);
              };
          };
      });
  }; 
  var dynamicByteLengthUnit = new DynamicByteLength(function (v) {
      return Control_Applicative.pure(Effect.applicativeEffect)(0);
  });
  var dynamicByteLengthUint8 = new DynamicByteLength(function (v) {
      return Control_Applicative.pure(Effect.applicativeEffect)(1);
  });
  var dynamicByteLengthUint32BE = new DynamicByteLength(function (v) {
      return Control_Applicative.pure(Effect.applicativeEffect)(4);
  });
  var dynamicByteLengthNoArguments = new DynamicByteLength(function (v) {
      return Control_Applicative.pure(Effect.applicativeEffect)(0);
  });
  var dynamicByteLengthInt16LE = new DynamicByteLength(function (v) {
      return Control_Applicative.pure(Effect.applicativeEffect)(2);
  });
  var dynamicByteLengthCodePoint = new DynamicByteLength(function (c) {
      var v = Data_Enum.fromEnum(Data_String_CodePoints.boundedEnumCodePoint)(c);
      if (v <= 127) {
          return Control_Applicative.pure(Effect.applicativeEffect)(1);
      };
      if (v <= 2047) {
          return Control_Applicative.pure(Effect.applicativeEffect)(2);
      };
      if (v <= 65535) {
          return Control_Applicative.pure(Effect.applicativeEffect)(3);
      };
      if (v <= 1114111) {
          return Control_Applicative.pure(Effect.applicativeEffect)(4);
      };
      if (Data_Boolean.otherwise) {
          return Effect_Exception["throw"]("CodePoint not in unicode range: " + Data_Show.show(Data_String_CodePoints.showCodePoint)(c));
      };
      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 119, column 18 - line 124, column 74): " + [ v.constructor.name ]);
  });
  var dynamicByteLengthBoolean = new DynamicByteLength(function (v) {
      return Control_Applicative.pure(Effect.applicativeEffect)(1);
  });
  var decodeArrayBufferUnit = new DecodeArrayBuffer(function (b) {
      return function (o) {
          return Control_Applicative.pure(Effect.applicativeEffect)(new Data_Maybe.Just(Data_Unit.unit));
      };
  });
  var decodeArrayBufferUint8 = new DecodeArrayBuffer(function (b) {
      return function (o) {
          return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_ArrayBuffer_Class_Types.Uint8))(Data_ArrayBuffer_DataView.getUint8(Data_ArrayBuffer_DataView.whole(b))(o));
      };
  });
  var decodeArrayBufferUint32BE = new DecodeArrayBuffer(function (b) {
      return function (o) {
          return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_ArrayBuffer_Class_Types.Uint32BE))(Data_ArrayBuffer_DataView.getUint32be(Data_ArrayBuffer_DataView.whole(b))(o));
      };
  });
  var decodeArrayBufferNoArguments = new DecodeArrayBuffer(function (b) {
      return function (o) {
          return Control_Applicative.pure(Effect.applicativeEffect)(new Data_Maybe.Just(Data_Generic_Rep.NoArguments.value));
      };
  });
  var decodeArrayBufferMaybe = function (dictDecodeArrayBuffer) {
      return new DecodeArrayBuffer(function (b) {
          return function (o) {
              return function __do() {
                  var mX = readArrayBuffer(decodeArrayBufferUint8)(b)(o)();
                  if (mX instanceof Data_Maybe.Nothing) {
                      return Data_Maybe.Nothing.value;
                  };
                  if (mX instanceof Data_Maybe.Just) {
                      var i$prime = Data_UInt.toInt(mX.value0);
                      if (i$prime === 0) {
                          return new Data_Maybe.Just(Data_Maybe.Nothing.value);
                      };
                      if (i$prime === 1) {
                          var mX$prime = readArrayBuffer(dictDecodeArrayBuffer)(b)(o + 1 | 0)();
                          if (mX$prime instanceof Data_Maybe.Nothing) {
                              return Effect_Exception["throw"]("Incorrect Maybe encoding - got Just flag, but no data")();
                          };
                          if (mX$prime instanceof Data_Maybe.Just) {
                              return new Data_Maybe.Just(new Data_Maybe.Just(mX$prime.value0));
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 505, column 17 - line 507, column 49): " + [ mX$prime.constructor.name ]);
                      };
                      if (Data_Boolean.otherwise) {
                          return Effect_Exception["throw"]("Incorrect Maybe encoding - flag out of range: " + Data_Show.show(Data_Show.showInt)(i$prime))();
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 501, column 13 - line 508, column 99): " + [ Data_Unit.unit.constructor.name ]);
                  };
                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 497, column 5 - line 508, column 99): " + [ mX.constructor.name ]);
              };
          };
      });
  }; 
  var decodeArrayBufferInt16LE = new DecodeArrayBuffer(function (b) {
      return function (o) {
          return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_ArrayBuffer_Class_Types.Int16LE))(Data_ArrayBuffer_DataView.getInt16le(Data_ArrayBuffer_DataView.whole(b))(o));
      };
  });
  var decodeArrayBufferEither = function (dictDecodeArrayBuffer) {
      return function (dictDecodeArrayBuffer1) {
          return function (dictDynamicByteLength) {
              return function (dictDynamicByteLength1) {
                  return new DecodeArrayBuffer(function (b) {
                      return function (o) {
                          return function __do() {
                              var mX = readArrayBuffer(decodeArrayBufferUint8)(b)(o)();
                              if (mX instanceof Data_Maybe.Nothing) {
                                  return Data_Maybe.Nothing.value;
                              };
                              if (mX instanceof Data_Maybe.Just) {
                                  var i$prime = Data_UInt.toInt(mX.value0);
                                  if (i$prime === 0) {
                                      var mX$prime = readArrayBuffer(dictDecodeArrayBuffer)(b)(o + 1 | 0)();
                                      if (mX$prime instanceof Data_Maybe.Nothing) {
                                          return Effect_Exception["throw"]("Incorrect Either encoding - got Left flag, but no data")();
                                      };
                                      if (mX$prime instanceof Data_Maybe.Just) {
                                          return new Data_Maybe.Just(new Data_Either.Left(mX$prime.value0));
                                      };
                                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 560, column 17 - line 562, column 49): " + [ mX$prime.constructor.name ]);
                                  };
                                  if (i$prime === 1) {
                                      var mY$prime = readArrayBuffer(dictDecodeArrayBuffer1)(b)(o + 1 | 0)();
                                      if (mY$prime instanceof Data_Maybe.Nothing) {
                                          return Effect_Exception["throw"]("Incorrect Either encoding - got Right flag, but no data")();
                                      };
                                      if (mY$prime instanceof Data_Maybe.Just) {
                                          return new Data_Maybe.Just(new Data_Either.Right(mY$prime.value0));
                                      };
                                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 565, column 17 - line 567, column 50): " + [ mY$prime.constructor.name ]);
                                  };
                                  if (Data_Boolean.otherwise) {
                                      return Effect_Exception["throw"]("Incorrect Either encoding - flag out of range: " + Data_Show.show(Data_Show.showInt)(i$prime))();
                                  };
                                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 557, column 13 - line 568, column 100): " + [ Data_Unit.unit.constructor.name ]);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 553, column 5 - line 568, column 100): " + [ mX.constructor.name ]);
                          };
                      };
                  });
              };
          };
      };
  };
  var decodeArrayBufferSum = function (dictDecodeArrayBuffer) {
      return function (dictDecodeArrayBuffer1) {
          return function (dictDynamicByteLength) {
              return function (dictDynamicByteLength1) {
                  return new DecodeArrayBuffer(function (b) {
                      return function (o) {
                          var getS = function (v) {
                              if (v instanceof Data_Either.Left) {
                                  return new Data_Generic_Rep.Inl(v.value0);
                              };
                              if (v instanceof Data_Either.Right) {
                                  return new Data_Generic_Rep.Inr(v.value0);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 762, column 18 - line 764, column 27): " + [ v.constructor.name ]);
                          };
                          return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(getS))(readArrayBuffer(decodeArrayBufferEither(dictDecodeArrayBuffer)(dictDecodeArrayBuffer1)(dictDynamicByteLength)(dictDynamicByteLength1))(b)(o));
                      };
                  });
              };
          };
      };
  };
  var decodeArrayBufferConstructor = function (dictDecodeArrayBuffer) {
      return new DecodeArrayBuffer(function (b) {
          return function (o) {
              return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.Constructor))(readArrayBuffer(dictDecodeArrayBuffer)(b)(o));
          };
      });
  };
  var decodeArrayBufferCodePoint = new DecodeArrayBuffer(function (b) {
      return function (o) {
          var shl6 = function (x) {
              return x << 6;
          };
          var readNextByte = function (o$prime) {
              return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
                  return Data_UInt.toInt(v);
              }))(readArrayBuffer(decodeArrayBufferUint8)(b)(o$prime));
          };
          return function __do() {
              var mW = readNextByte(o)();
              if (mW instanceof Data_Maybe.Nothing) {
                  return Data_Maybe.Nothing.value;
              };
              if (mW instanceof Data_Maybe.Just) {
                  var r = (function () {
                      var $295 = mW.value0 < 128;
                      if ($295) {
                          return mW.value0;
                      };
                      var mX = Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Int_Bits.xor(128)))(readNextByte(o + 1 | 0))();
                      if (mX instanceof Data_Maybe.Nothing) {
                          return Effect_Exception["throw"]("Incorrect unicode char encoding - w: " + Data_Show.show(Data_Show.showInt)(mW.value0))();
                      };
                      if (mX instanceof Data_Maybe.Just) {
                          var $297 = mW.value0 < 224;
                          if ($297) {
                              return mX.value0 | shl6(192 ^ mW.value0);
                          };
                          var mY = Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Int_Bits.xor(128)))(readNextByte(o + 2 | 0))();
                          if (mY instanceof Data_Maybe.Nothing) {
                              return Effect_Exception["throw"]("Incorrect unicode char encoding - w: " + (Data_Show.show(Data_Show.showInt)(mW.value0) + (", x: " + Data_Show.show(Data_Show.showInt)(mX.value0))))();
                          };
                          if (mY instanceof Data_Maybe.Just) {
                              var $299 = mW.value0 < 240;
                              if ($299) {
                                  return mY.value0 | shl6(mX.value0 | shl6(224 ^ mW.value0));
                              };
                              var mZ = Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Int_Bits.xor(128)))(readNextByte(o + 3 | 0))();
                              if (mZ instanceof Data_Maybe.Nothing) {
                                  return Effect_Exception["throw"]("Incorrect unicode char encoding - w: " + (Data_Show.show(Data_Show.showInt)(mW.value0) + (", x: " + (Data_Show.show(Data_Show.showInt)(mX.value0) + (", y: " + Data_Show.show(Data_Show.showInt)(mY.value0))))))();
                              };
                              if (mZ instanceof Data_Maybe.Just) {
                                  return mZ.value0 | shl6(mY.value0 | shl6(mX.value0 | shl6(240 ^ mW.value0)));
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 424, column 31 - line 426, column 99): " + [ mZ.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 418, column 23 - line 426, column 99): " + [ mY.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 412, column 15 - line 426, column 99): " + [ mX.constructor.name ]);
                  })();
                  var v = Data_Enum.toEnum(Data_String_CodePoints.boundedEnumCodePoint)(r);
                  if (v instanceof Data_Maybe.Nothing) {
                      return Effect_Exception["throw"]("Incorrect unicode char encoding: " + Data_Show.show(Data_Show.showInt)(r))();
                  };
                  if (v instanceof Data_Maybe.Just) {
                      return new Data_Maybe.Just(v.value0);
                  };
                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 427, column 9 - line 429, column 34): " + [ v.constructor.name ]);
              };
              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 405, column 5 - line 429, column 34): " + [ mW.constructor.name ]);
          };
      };
  });
  var decodeArrayBufferBoolean = new DecodeArrayBuffer(function (b) {
      return function (o) {
          var f = function (mV) {
              if (mV instanceof Data_Maybe.Nothing) {
                  return Control_Applicative.pure(Effect.applicativeEffect)(Data_Maybe.Nothing.value);
              };
              if (mV instanceof Data_Maybe.Just) {
                  var v$prime = Data_UInt.toInt(mV.value0);
                  var $312 = v$prime === 0;
                  if ($312) {
                      return Control_Applicative.pure(Effect.applicativeEffect)(new Data_Maybe.Just(false));
                  };
                  var $313 = v$prime === 1;
                  if ($313) {
                      return Control_Applicative.pure(Effect.applicativeEffect)(new Data_Maybe.Just(true));
                  };
                  return Effect_Exception["throw"]("Not a Boolean ArrayBuffer encoding: " + Data_Show.show(Data_UInt.uintShowInstance)(mV.value0));
              };
              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 319, column 16 - line 325, column 82): " + [ mV.constructor.name ]);
          };
          return Control_Bind.bind(Effect.bindEffect)(readArrayBuffer(decodeArrayBufferUint8)(b)(o))(f);
      };
  });
  var decodeArrayBufferArgument = function (dictDecodeArrayBuffer) {
      return new DecodeArrayBuffer(function (b) {
          return function (o) {
              return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.Argument))(readArrayBuffer(dictDecodeArrayBuffer)(b)(o));
          };
      });
  };
  var decodeArrayBuffer = function (dictDecodeArrayBuffer) {
      return function (b) {
          return readArrayBuffer(dictDecodeArrayBuffer)(b)(0);
      };
  };
  var byteLength = function (dict) {
      return dict.byteLength;
  };
  var decodeArrayBufferArray = function (dictDecodeArrayBuffer) {
      return function (dictDynamicByteLength) {
          return new DecodeArrayBuffer(function (b) {
              return function (o) {
                  return function __do() {
                      var mL = readArrayBuffer(decodeArrayBufferUint32BE)(b)(o)();
                      if (mL instanceof Data_Maybe.Nothing) {
                          return Data_Maybe.Nothing.value;
                      };
                      if (mL instanceof Data_Maybe.Just) {
                          var nextORef = Effect_Ref["new"](o + 4 | 0)();
                          return Data_Functor.map(Effect.functorEffect)(Data_Maybe.Just.create)(Data_Unfoldable.replicateA(Effect.applicativeEffect)(Data_Unfoldable.unfoldableArray)(Data_Traversable.traversableArray)(Data_UInt.toNumber(mL.value0))(function __do() {
                              var o$prime = Effect_Ref.read(nextORef)();
                              var mX = readArrayBuffer(dictDecodeArrayBuffer)(b)(o$prime)();
                              if (mX instanceof Data_Maybe.Nothing) {
                                  return Effect_Exception["throw"]("Incorrect ArrayBuffer encoding - retreived length, but not all values: " + Data_Show.show(Data_Show.showInt)(o$prime))();
                              };
                              if (mX instanceof Data_Maybe.Just) {
                                  var l$prime = byteLength(dictDynamicByteLength)(mX.value0)();
                                  Effect_Ref.write(o$prime + l$prime | 0)(nextORef)();
                                  return mX.value0;
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 596, column 11 - line 601, column 21): " + [ mX.constructor.name ]);
                          }))();
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 589, column 5 - line 601, column 21): " + [ mL.constructor.name ]);
                  };
              };
          });
      };
  };
  var decodeArrayBufferNonEmptyArray = function (dictDecodeArrayBuffer) {
      return function (dictDynamicByteLength) {
          return new DecodeArrayBuffer(function (b) {
              return function (o) {
                  return function __do() {
                      var mXs = readArrayBuffer(decodeArrayBufferArray(dictDecodeArrayBuffer)(dictDynamicByteLength))(b)(o)();
                      if (mXs instanceof Data_Maybe.Nothing) {
                          return Data_Maybe.Nothing.value;
                      };
                      if (mXs instanceof Data_Maybe.Just) {
                          var v = Data_Array.uncons(mXs.value0);
                          if (v instanceof Data_Maybe.Nothing) {
                              return Effect_Exception["throw"]("Incorrect NonEmpty Array encoding - array is empty")();
                          };
                          if (v instanceof Data_Maybe.Just) {
                              return new Data_Maybe.Just(new Data_NonEmpty.NonEmpty(v.value0.head, v.value0.tail));
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 640, column 18 - line 642, column 61): " + [ v.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 638, column 5 - line 642, column 61): " + [ mXs.constructor.name ]);
                  };
              };
          });
      };
  };
  var decodeArrayBufferString = new DecodeArrayBuffer(function (b) {
      return function (o) {
          return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_String_CodePoints.fromCodePointArray))(readArrayBuffer(decodeArrayBufferArray(decodeArrayBufferCodePoint)(dynamicByteLengthCodePoint))(b)(o));
      };
  });
  var decodeArrayBufferTuple = function (dictDecodeArrayBuffer) {
      return function (dictDecodeArrayBuffer1) {
          return function (dictDynamicByteLength) {
              return function (dictDynamicByteLength1) {
                  return new DecodeArrayBuffer(function (b) {
                      return function (o) {
                          return function __do() {
                              var mX = readArrayBuffer(dictDecodeArrayBuffer)(b)(o)();
                              if (mX instanceof Data_Maybe.Nothing) {
                                  return Data_Maybe.Nothing.value;
                              };
                              if (mX instanceof Data_Maybe.Just) {
                                  var l = byteLength(dictDynamicByteLength)(mX.value0)();
                                  var mY = readArrayBuffer(dictDecodeArrayBuffer1)(b)(o + l | 0)();
                                  if (mY instanceof Data_Maybe.Nothing) {
                                      return Effect_Exception["throw"]("Incorrect Tuple encoding - got one value, but not the next")();
                                  };
                                  if (mY instanceof Data_Maybe.Just) {
                                      return new Data_Maybe.Just(new Data_Tuple.Tuple(mX.value0, mY.value0));
                                  };
                                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 527, column 9 - line 529, column 44): " + [ mY.constructor.name ]);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 522, column 5 - line 529, column 44): " + [ mX.constructor.name ]);
                          };
                      };
                  });
              };
          };
      };
  };
  var decodeArrayBufferProduct = function (dictDecodeArrayBuffer) {
      return function (dictDecodeArrayBuffer1) {
          return function (dictDynamicByteLength) {
              return function (dictDynamicByteLength1) {
                  return new DecodeArrayBuffer(function (b) {
                      return function (o) {
                          var getS = function (v) {
                              return new Data_Generic_Rep.Product(v.value0, v.value1);
                          };
                          return Data_Functor.map(Effect.functorEffect)(Data_Functor.map(Data_Maybe.functorMaybe)(getS))(readArrayBuffer(decodeArrayBufferTuple(dictDecodeArrayBuffer)(dictDecodeArrayBuffer1)(dictDynamicByteLength)(dictDynamicByteLength1))(b)(o));
                      };
                  });
              };
          };
      };
  };
  var dynamicByteLengthArgument = function (dictDynamicByteLength) {
      return new DynamicByteLength(function (v) {
          return byteLength(dictDynamicByteLength)(v);
      });
  };
  var dynamicByteLengthArray = function (dictDynamicByteLength) {
      return new DynamicByteLength(function (xs) {
          return Data_Functor.map(Effect.functorEffect)(function (ys) {
              return Data_Foldable.sum(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(ys) + 4 | 0;
          })(Data_Traversable.traverse(Data_Traversable.traversableArray)(Effect.applicativeEffect)(byteLength(dictDynamicByteLength))(xs));
      });
  };
  var dynamicByteLengthConstructor = function (dictDynamicByteLength) {
      return new DynamicByteLength(function (v) {
          return byteLength(dictDynamicByteLength)(v);
      });
  };
  var dynamicByteLengthMaybe = function (dictDynamicByteLength) {
      return new DynamicByteLength(function (mX) {
          if (mX instanceof Data_Maybe.Nothing) {
              return Control_Applicative.pure(Effect.applicativeEffect)(1);
          };
          if (mX instanceof Data_Maybe.Just) {
              return Data_Functor.map(Effect.functorEffect)(function (v) {
                  return v + 1 | 0;
              })(byteLength(dictDynamicByteLength)(mX.value0));
          };
          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 130, column 19 - line 132, column 39): " + [ mX.constructor.name ]);
      });
  };
  var dynamicByteLengthNonEmptyArray = function (dictDynamicByteLength) {
      return new DynamicByteLength(function (v) {
          return byteLength(dynamicByteLengthArray(dictDynamicByteLength))(Data_Array.cons(v.value0)(v.value1));
      });
  };
  var dynamicByteLengthProduct = function (dictDynamicByteLength) {
      return function (dictDynamicByteLength1) {
          return new DynamicByteLength(function (v) {
              return Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Data_Semiring.add(Data_Semiring.semiringInt))(byteLength(dictDynamicByteLength)(v.value0)))(byteLength(dictDynamicByteLength1)(v.value1));
          });
      };
  };
  var dynamicByteLengthString = new DynamicByteLength(function (xs) {
      return byteLength(dynamicByteLengthArray(dynamicByteLengthCodePoint))(Data_String_CodePoints.toCodePointArray(xs));
  });
  var dynamicByteLengthSum = function (dictDynamicByteLength) {
      return function (dictDynamicByteLength1) {
          return new DynamicByteLength(function (s) {
              if (s instanceof Data_Generic_Rep.Inl) {
                  return Data_Functor.map(Effect.functorEffect)(function (v) {
                      return v + 1 | 0;
                  })(byteLength(dictDynamicByteLength)(s.value0));
              };
              if (s instanceof Data_Generic_Rep.Inr) {
                  return Data_Functor.map(Effect.functorEffect)(function (v) {
                      return v + 1 | 0;
                  })(byteLength(dictDynamicByteLength1)(s.value0));
              };
              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 186, column 18 - line 188, column 38): " + [ s.constructor.name ]);
          });
      };
  };
  var dynamicByteLengthTuple = function (dictDynamicByteLength) {
      return function (dictDynamicByteLength1) {
          return new DynamicByteLength(function (v) {
              return Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Data_Semiring.add(Data_Semiring.semiringInt))(byteLength(dictDynamicByteLength)(v.value0)))(byteLength(dictDynamicByteLength1)(v.value1));
          });
      };
  };
  var encodeArrayBuffer = function (dictEncodeArrayBuffer) {
      return function (dictDynamicByteLength) {
          return function (x) {
              return function __do() {
                  var l = byteLength(dictDynamicByteLength)(x)();
                  var b = Data_ArrayBuffer_ArrayBuffer.empty(l)();
                  var mW = putArrayBuffer(dictEncodeArrayBuffer)(b)(0)(x)();
                  if (mW instanceof Data_Maybe.Nothing) {
                      return Effect_Exception["throw"]("Couldn't serialize to ArrayBuffer")();
                  };
                  if (mW instanceof Data_Maybe.Just) {
                      if (mW.value0 !== l) {
                          return Effect_Exception["throw"]("Written bytes and dynamic byte length are not identical - written: " + (Data_Show.show(Data_Show.showInt)(mW.value0) + (", byte length: " + Data_Show.show(Data_Show.showInt)(l))))();
                      };
                      if (Data_Boolean.otherwise) {
                          return b;
                      };
                  };
                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 791, column 3 - line 795, column 28): " + [ mW.constructor.name ]);
              };
          };
      };
  };
  var genericByteLength = function (dictGeneric) {
      return function (dictDynamicByteLength) {
          return function (x) {
              return byteLength(dictDynamicByteLength)(Data_Generic_Rep.from(dictGeneric)(x));
          };
      };
  };
  var guardByteLength = function (dictDynamicByteLength) {
      return function (x) {
          return function (success) {
              if (success) {
                  return Data_Functor.map(Effect.functorEffect)(Data_Maybe.Just.create)(byteLength(dictDynamicByteLength)(x));
              };
              return Control_Applicative.pure(Effect.applicativeEffect)(Data_Maybe.Nothing.value);
          };
      };
  }; 
  var encodeArrayBufferInt16LE = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (v) {
              return Control_Bind.bind(Effect.bindEffect)(Data_ArrayBuffer_DataView.setInt16le(Data_ArrayBuffer_DataView.whole(b))(o)(v))(guardByteLength(dynamicByteLengthInt16LE)(v));
          };
      };
  });
  var encodeArrayBufferUint32BE = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (v) {
              return Control_Bind.bind(Effect.bindEffect)(Data_ArrayBuffer_DataView.setUint32be(Data_ArrayBuffer_DataView.whole(b))(o)(v))(guardByteLength(dynamicByteLengthUint32BE)(v));
          };
      };
  });
  var encodeArrayBufferArray = function (dictEncodeArrayBuffer) {
      return new EncodeArrayBuffer(function (b) {
          return function (o) {
              return function (xs) {
                  var l = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringNumber)(xs);
                  return function __do() {
                      var mW = putArrayBuffer(encodeArrayBufferUint32BE)(b)(o)(Data_UInt.fromNumber(l))();
                      if (mW instanceof Data_Maybe.Nothing) {
                          return Data_Maybe.Nothing.value;
                      };
                      if (mW instanceof Data_Maybe.Just) {
                          var nextORef = Effect_Ref["new"](o + mW.value0 | 0)();
                          Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(xs)(function (x) {
                              return function __do() {
                                  var o$prime = Effect_Ref.read(nextORef)();
                                  var mW$prime = putArrayBuffer(dictEncodeArrayBuffer)(b)(o$prime)(x)();
                                  if (mW$prime instanceof Data_Maybe.Nothing) {
                                      return Effect_Exception["throw"]("Incorrect ArrayBuffer length - wrote array length and possible bytes: " + Data_Show.show(Data_Show.showInt)(o$prime))();
                                  };
                                  if (mW$prime instanceof Data_Maybe.Just) {
                                      return Effect_Ref.write(o$prime + mW$prime.value0 | 0)(nextORef)();
                                  };
                                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 581, column 11 - line 583, column 52): " + [ mW$prime.constructor.name ]);
                              };
                          })();
                          var withOffset = Effect_Ref.read(nextORef)();
                          return new Data_Maybe.Just(withOffset - o | 0);
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 574, column 5 - line 585, column 37): " + [ mW.constructor.name ]);
                  };
              };
          };
      });
  };
  var encodeArrayBufferNonEmptyArray = function (dictEncodeArrayBuffer) {
      return new EncodeArrayBuffer(function (b) {
          return function (o) {
              return function (v) {
                  return putArrayBuffer(encodeArrayBufferArray(dictEncodeArrayBuffer))(b)(o)(Data_Array.cons(v.value0)(v.value1));
              };
          };
      });
  }; 
  var encodeArrayBufferUint8 = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (v) {
              return Control_Bind.bind(Effect.bindEffect)(Data_ArrayBuffer_DataView.setUint8(Data_ArrayBuffer_DataView.whole(b))(o)(v))(guardByteLength(dynamicByteLengthUint8)(v));
          };
      };
  });
  var encodeArrayBufferBoolean = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (x) {
              var v = (function () {
                  if (x) {
                      return 1;
                  };
                  return 0;
              })();
              return putArrayBuffer(encodeArrayBufferUint8)(b)(o)(Data_UInt.fromInt(v));
          };
      };
  });
  var encodeArrayBufferCodePoint = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (c) {
              var v = Data_Enum.fromEnum(Data_String_CodePoints.boundedEnumCodePoint)(c);
              var w = v >> 18 & 7;
              var x = v >> 12 & 63;
              var y = v >> 6 & 63;
              var z = v & 63;
              var mkVal = function ($487) {
                  return Data_ArrayBuffer_Class_Types.Uint8(Data_UInt.fromInt($487));
              };
              if (v <= 127) {
                  return putArrayBuffer(encodeArrayBufferUint8)(b)(o)(Data_UInt.fromInt(v));
              };
              if (v <= 2047) {
                  return function __do() {
                      var mW = putArrayBuffer(encodeArrayBufferUint8)(b)(o)(mkVal(192 | y))();
                      if (mW instanceof Data_Maybe.Nothing) {
                          return Data_Maybe.Nothing.value;
                      };
                      if (mW instanceof Data_Maybe.Just) {
                          var mW$prime = putArrayBuffer(encodeArrayBufferUint8)(b)(o + mW.value0 | 0)(mkVal(128 | z))();
                          if (mW$prime instanceof Data_Maybe.Nothing) {
                              return new Data_Maybe.Just(mW.value0);
                          };
                          if (mW$prime instanceof Data_Maybe.Just) {
                              return new Data_Maybe.Just(mW.value0 + mW$prime.value0 | 0);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 362, column 19 - line 364, column 70): " + [ mW$prime.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 358, column 15 - line 364, column 70): " + [ mW.constructor.name ]);
                  };
              };
              if (v <= 65535) {
                  return function __do() {
                      var mW = putArrayBuffer(encodeArrayBufferUint8)(b)(o)(mkVal(224 | x))();
                      if (mW instanceof Data_Maybe.Nothing) {
                          return Data_Maybe.Nothing.value;
                      };
                      if (mW instanceof Data_Maybe.Just) {
                          var mW$prime = putArrayBuffer(encodeArrayBufferUint8)(b)(o + mW.value0 | 0)(mkVal(128 | y))();
                          if (mW$prime instanceof Data_Maybe.Nothing) {
                              return new Data_Maybe.Just(mW.value0);
                          };
                          if (mW$prime instanceof Data_Maybe.Just) {
                              var mW$prime$prime = putArrayBuffer(encodeArrayBufferUint8)(b)((o + mW.value0 | 0) + mW$prime.value0 | 0)(mkVal(128 | z))();
                              if (mW$prime$prime instanceof Data_Maybe.Nothing) {
                                  return new Data_Maybe.Just(mW.value0 + mW$prime.value0 | 0);
                              };
                              if (mW$prime$prime instanceof Data_Maybe.Just) {
                                  return new Data_Maybe.Just((mW.value0 + mW$prime.value0 | 0) + mW$prime$prime.value0 | 0);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 375, column 23 - line 377, column 87): " + [ mW$prime$prime.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 371, column 19 - line 377, column 87): " + [ mW$prime.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 367, column 15 - line 377, column 87): " + [ mW.constructor.name ]);
                  };
              };
              if (v <= 1114111) {
                  return function __do() {
                      var mW = putArrayBuffer(encodeArrayBufferUint8)(b)(o)(mkVal(240 | w))();
                      if (mW instanceof Data_Maybe.Nothing) {
                          return Data_Maybe.Nothing.value;
                      };
                      if (mW instanceof Data_Maybe.Just) {
                          var o$prime = o + mW.value0 | 0;
                          var mW$prime = putArrayBuffer(encodeArrayBufferUint8)(b)(o$prime)(mkVal(128 | x))();
                          if (mW$prime instanceof Data_Maybe.Nothing) {
                              return new Data_Maybe.Just(mW.value0);
                          };
                          if (mW$prime instanceof Data_Maybe.Just) {
                              var o$prime$prime = o$prime + mW$prime.value0 | 0;
                              var mW$prime$prime = putArrayBuffer(encodeArrayBufferUint8)(b)(o$prime$prime)(mkVal(128 | y))();
                              if (mW$prime$prime instanceof Data_Maybe.Nothing) {
                                  return new Data_Maybe.Just(mW.value0 + mW$prime.value0 | 0);
                              };
                              if (mW$prime$prime instanceof Data_Maybe.Just) {
                                  var o$prime$prime$prime = o$prime$prime + mW$prime$prime.value0 | 0;
                                  var mW$prime$prime$prime = putArrayBuffer(encodeArrayBufferUint8)(b)(o$prime$prime$prime)(mkVal(128 | z))();
                                  if (mW$prime$prime$prime instanceof Data_Maybe.Nothing) {
                                      return new Data_Maybe.Just((mW.value0 + mW$prime.value0 | 0) + mW$prime$prime.value0 | 0);
                                  };
                                  if (mW$prime$prime$prime instanceof Data_Maybe.Just) {
                                      return new Data_Maybe.Just(((mW.value0 + mW$prime.value0 | 0) + mW$prime$prime.value0 | 0) + mW$prime$prime$prime.value0 | 0);
                                  };
                                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 395, column 27 - line 398, column 88): " + [ mW$prime$prime$prime.constructor.name ]);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 390, column 23 - line 398, column 88): " + [ mW$prime$prime.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 385, column 19 - line 398, column 88): " + [ mW$prime.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 380, column 15 - line 398, column 88): " + [ mW.constructor.name ]);
                  };
              };
              if (Data_Boolean.otherwise) {
                  return Effect_Exception["throw"]("Char not in unicode range: " + Data_Show.show(Data_String_CodePoints.showCodePoint)(c));
              };
              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 354, column 9 - line 399, column 75): " + [ Data_Unit.unit.constructor.name ]);
          };
      };
  });
  var encodeArrayBufferString = new EncodeArrayBuffer(function (b) {
      return function (o) {
          return function (xs) {
              return putArrayBuffer(encodeArrayBufferArray(encodeArrayBufferCodePoint))(b)(o)(Data_String_CodePoints.toCodePointArray(xs));
          };
      };
  });
  var encodeArrayBufferEither = function (dictEncodeArrayBuffer) {
      return function (dictEncodeArrayBuffer1) {
          return new EncodeArrayBuffer(function (b) {
              return function (o) {
                  return function (eXY) {
                      if (eXY instanceof Data_Either.Left) {
                          return function __do() {
                              var mW = putArrayBuffer(encodeArrayBufferUint8)(b)(o)(Data_UInt.fromInt(0))();
                              if (mW instanceof Data_Maybe.Nothing) {
                                  return Data_Maybe.Nothing.value;
                              };
                              if (mW instanceof Data_Maybe.Just) {
                                  var mW$prime = putArrayBuffer(dictEncodeArrayBuffer)(b)(o + 1 | 0)(eXY.value0)();
                                  if (mW$prime instanceof Data_Maybe.Nothing) {
                                      return new Data_Maybe.Just(1);
                                  };
                                  if (mW$prime instanceof Data_Maybe.Just) {
                                      return new Data_Maybe.Just(mW$prime.value0 + 1 | 0);
                                  };
                                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 538, column 11 - line 540, column 44): " + [ mW$prime.constructor.name ]);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 534, column 7 - line 540, column 44): " + [ mW.constructor.name ]);
                          };
                      };
                      if (eXY instanceof Data_Either.Right) {
                          return function __do() {
                              var mW = putArrayBuffer(encodeArrayBufferUint8)(b)(o)(Data_UInt.fromInt(1))();
                              if (mW instanceof Data_Maybe.Nothing) {
                                  return Data_Maybe.Nothing.value;
                              };
                              if (mW instanceof Data_Maybe.Just) {
                                  var mW$prime = putArrayBuffer(dictEncodeArrayBuffer1)(b)(o + 1 | 0)(eXY.value0)();
                                  if (mW$prime instanceof Data_Maybe.Nothing) {
                                      return new Data_Maybe.Just(1);
                                  };
                                  if (mW$prime instanceof Data_Maybe.Just) {
                                      return new Data_Maybe.Just(mW$prime.value0 + 1 | 0);
                                  };
                                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 547, column 11 - line 549, column 44): " + [ mW$prime.constructor.name ]);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 543, column 7 - line 549, column 44): " + [ mW.constructor.name ]);
                          };
                      };
                      throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 531, column 28 - line 549, column 44): " + [ eXY.constructor.name ]);
                  };
              };
          });
      };
  };
  var encodeArrayBufferSum = function (dictEncodeArrayBuffer) {
      return function (dictEncodeArrayBuffer1) {
          return new EncodeArrayBuffer(function (b) {
              return function (o) {
                  return function (s) {
                      var v = (function () {
                          if (s instanceof Data_Generic_Rep.Inl) {
                              return new Data_Either.Left(s.value0);
                          };
                          if (s instanceof Data_Generic_Rep.Inr) {
                              return new Data_Either.Right(s.value0);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 756, column 13 - line 758, column 31): " + [ s.constructor.name ]);
                      })();
                      return putArrayBuffer(encodeArrayBufferEither(dictEncodeArrayBuffer)(dictEncodeArrayBuffer1))(b)(o)(v);
                  };
              };
          });
      };
  };
  var encodeArrayBufferMaybe = function (dictEncodeArrayBuffer) {
      return new EncodeArrayBuffer(function (b) {
          return function (o) {
              return function (mX) {
                  if (mX instanceof Data_Maybe.Nothing) {
                      return putArrayBuffer(encodeArrayBufferUint8)(b)(o)(Data_UInt.fromInt(0));
                  };
                  if (mX instanceof Data_Maybe.Just) {
                      return function __do() {
                          var mW = putArrayBuffer(encodeArrayBufferUint8)(b)(o)(Data_UInt.fromInt(1))();
                          if (mW instanceof Data_Maybe.Nothing) {
                              return Data_Maybe.Nothing.value;
                          };
                          if (mW instanceof Data_Maybe.Just) {
                              var mW$prime = putArrayBuffer(dictEncodeArrayBuffer)(b)(o + mW.value0 | 0)(mX.value0)();
                              if (mW$prime instanceof Data_Maybe.Nothing) {
                                  return new Data_Maybe.Just(mW.value0);
                              };
                              if (mW$prime instanceof Data_Maybe.Just) {
                                  return new Data_Maybe.Just(mW$prime.value0 + mW.value0 | 0);
                              };
                              throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 491, column 11 - line 493, column 44): " + [ mW$prime.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 487, column 7 - line 493, column 44): " + [ mW.constructor.name ]);
                      };
                  };
                  throw new Error("Failed pattern match at Data.ArrayBuffer.Class (line 483, column 27 - line 493, column 44): " + [ mX.constructor.name ]);
              };
          };
      });
  };
  exports["EncodeArrayBuffer"] = EncodeArrayBuffer;
  exports["DecodeArrayBuffer"] = DecodeArrayBuffer;
  exports["DynamicByteLength"] = DynamicByteLength;
  exports["encodeArrayBuffer"] = encodeArrayBuffer;
  exports["decodeArrayBuffer"] = decodeArrayBuffer;
  exports["genericByteLength"] = genericByteLength;
  exports["genericPutArrayBuffer"] = genericPutArrayBuffer;
  exports["genericReadArrayBuffer"] = genericReadArrayBuffer;
  exports["dynamicByteLengthInt16LE"] = dynamicByteLengthInt16LE;
  exports["dynamicByteLengthUnit"] = dynamicByteLengthUnit;
  exports["dynamicByteLengthBoolean"] = dynamicByteLengthBoolean;
  exports["dynamicByteLengthString"] = dynamicByteLengthString;
  exports["dynamicByteLengthMaybe"] = dynamicByteLengthMaybe;
  exports["dynamicByteLengthTuple"] = dynamicByteLengthTuple;
  exports["dynamicByteLengthArray"] = dynamicByteLengthArray;
  exports["dynamicByteLengthNonEmptyArray"] = dynamicByteLengthNonEmptyArray;
  exports["dynamicByteLengthNoArguments"] = dynamicByteLengthNoArguments;
  exports["dynamicByteLengthSum"] = dynamicByteLengthSum;
  exports["dynamicByteLengthProduct"] = dynamicByteLengthProduct;
  exports["dynamicByteLengthConstructor"] = dynamicByteLengthConstructor;
  exports["dynamicByteLengthArgument"] = dynamicByteLengthArgument;
  exports["encodeArrayBufferInt16LE"] = encodeArrayBufferInt16LE;
  exports["decodeArrayBufferInt16LE"] = decodeArrayBufferInt16LE;
  exports["encodeArrayBufferUnit"] = encodeArrayBufferUnit;
  exports["decodeArrayBufferUnit"] = decodeArrayBufferUnit;
  exports["encodeArrayBufferBoolean"] = encodeArrayBufferBoolean;
  exports["decodeArrayBufferBoolean"] = decodeArrayBufferBoolean;
  exports["encodeArrayBufferString"] = encodeArrayBufferString;
  exports["decodeArrayBufferString"] = decodeArrayBufferString;
  exports["encodeArrayBufferMaybe"] = encodeArrayBufferMaybe;
  exports["decodeArrayBufferMaybe"] = decodeArrayBufferMaybe;
  exports["encodeArrayBufferTuple"] = encodeArrayBufferTuple;
  exports["decodeArrayBufferTuple"] = decodeArrayBufferTuple;
  exports["encodeArrayBufferArray"] = encodeArrayBufferArray;
  exports["decodeArrayBufferArray"] = decodeArrayBufferArray;
  exports["encodeArrayBufferNonEmptyArray"] = encodeArrayBufferNonEmptyArray;
  exports["decodeArrayBufferNonEmptyArray"] = decodeArrayBufferNonEmptyArray;
  exports["encodeArrayBufferNoArguments"] = encodeArrayBufferNoArguments;
  exports["decodeArrayBufferNoArguments"] = decodeArrayBufferNoArguments;
  exports["encodeArrayBufferSum"] = encodeArrayBufferSum;
  exports["decodeArrayBufferSum"] = decodeArrayBufferSum;
  exports["encodeArrayBufferProduct"] = encodeArrayBufferProduct;
  exports["decodeArrayBufferProduct"] = decodeArrayBufferProduct;
  exports["encodeArrayBufferConstructor"] = encodeArrayBufferConstructor;
  exports["decodeArrayBufferConstructor"] = decodeArrayBufferConstructor;
  exports["encodeArrayBufferArgument"] = encodeArrayBufferArgument;
  exports["decodeArrayBufferArgument"] = decodeArrayBufferArgument;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Int"] = $PS["Domination.Data.Wire.Int"] || {};
  var exports = $PS["Domination.Data.Wire.Int"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_ArrayBuffer_Class_Types = $PS["Data.ArrayBuffer.Class.Types"];
  var Data_Either = $PS["Data.Either"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                                
  var WireInt = function (x) {
      return x;
  };
  var semiringWireInt = Data_ArrayBuffer_Class_Types.semiringInt16LE;
  var ringWireInt = Data_ArrayBuffer_Class_Types.ringInt16LE;
  var genericWireInt = new Data_Generic_Rep.Generic(function (x) {
      return x;
  }, function (x) {
      return x;
  });
  var showWireInt = new Data_Show.Show(Data_Show_Generic.genericShow(genericWireInt)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_ArrayBuffer_Class_Types.showInt16LE))(new Data_Symbol.IsSymbol(function () {
      return "WireInt";
  }))));
  var eqWireInt = new Data_Eq.Eq(function (x) {
      return function (y) {
          return Data_Eq.eq(Data_ArrayBuffer_Class_Types.eqInt16LE)(x)(y);
      };
  });
  var ordWireInt = new Data_Ord.Ord(function () {
      return eqWireInt;
  }, function (x) {
      return function (y) {
          return Data_Ord.compare(Data_ArrayBuffer_Class_Types.ordInt16LE)(x)(y);
      };
  });
  var encodeJsonWireInt = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
      return Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonInt)(v);
  });
  var encodeArrayBufferWireInt = Data_ArrayBuffer_Class.encodeArrayBufferInt16LE;
  var dynamicByteLengthWireInt = Data_ArrayBuffer_Class.dynamicByteLengthInt16LE;
  var decodeJsonWireInt = new Data_Argonaut_Decode_Class.DecodeJson(function (i) {
      return Data_Functor.map(Data_Either.functorEither)(function ($22) {
          return WireInt(Data_ArrayBuffer_Class_Types.Int16LE($22));
      })(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonInt)(i));
  });
  var decodeArrayBufferWireInt = Data_ArrayBuffer_Class.decodeArrayBufferInt16LE;
  var _toWire = function (dictProfunctor) {
      return Data_Lens_Iso.iso(function ($24) {
          return WireInt(Data_ArrayBuffer_Class_Types.Int16LE($24));
      })(function (v) {
          return v;
      })(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["eqWireInt"] = eqWireInt;
  exports["ordWireInt"] = ordWireInt;
  exports["semiringWireInt"] = semiringWireInt;
  exports["ringWireInt"] = ringWireInt;
  exports["showWireInt"] = showWireInt;
  exports["encodeJsonWireInt"] = encodeJsonWireInt;
  exports["decodeJsonWireInt"] = decodeJsonWireInt;
  exports["encodeArrayBufferWireInt"] = encodeArrayBufferWireInt;
  exports["decodeArrayBufferWireInt"] = decodeArrayBufferWireInt;
  exports["dynamicByteLengthWireInt"] = dynamicByteLengthWireInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Actions"] = $PS["Domination.Data.Actions"] || {};
  var exports = $PS["Domination.Data.Actions"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Internal_Re = $PS["Data.Lens.Internal.Re"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Iso_Newtype = $PS["Data.Lens.Iso.Newtype"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var semiringActions = Domination_Data_Wire_Int.ringWireInt;
  var ringActions = Domination_Data_Wire_Int.semiringWireInt;
  var ordActions = Domination_Data_Wire_Int.ordWireInt;          
  var genericActions = new Data_Generic_Rep.Generic(function (x) {
      return x;
  }, function (x) {
      return x;
  });
  var showActions = new Data_Show.Show(Data_Show_Generic.genericShow(genericActions)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Wire_Int.showWireInt))(new Data_Symbol.IsSymbol(function () {
      return "Actions";
  }))));
  var eqActions = Domination_Data_Wire_Int.eqWireInt;
  var encodeJsonActions = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericActions)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Actions";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Wire_Int.encodeJsonWireInt))));
  var encodeArrayBufferActions = Domination_Data_Wire_Int.encodeArrayBufferWireInt;
  var dynamicByteLengthActions = Domination_Data_Wire_Int.dynamicByteLengthWireInt;
  var decodeJsonActions = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericActions)(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "Actions";
  }))(Domination_Data_Wire_Int.decodeJsonWireInt)));
  var decodeArrayBufferActions = Domination_Data_Wire_Int.decodeArrayBufferWireInt;
  var _int = function (dictProfunctor) {
      var $5 = Data_Lens_Iso_Newtype["_Newtype"]()()(dictProfunctor);
      var $6 = Data_Lens_Iso.re(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Re.profunctorRe(dictProfunctor)));
      return function ($7) {
          return $5($6($7));
      };
  };
  var actions = Data_Lens_Prism.review(_int(Data_Lens_Internal_Tagged.taggedProfunctor));
  exports["actions"] = actions;
  exports["_int"] = _int;
  exports["eqActions"] = eqActions;
  exports["ordActions"] = ordActions;
  exports["ringActions"] = ringActions;
  exports["semiringActions"] = semiringActions;
  exports["showActions"] = showActions;
  exports["encodeJsonActions"] = encodeJsonActions;
  exports["decodeJsonActions"] = decodeJsonActions;
  exports["encodeArrayBufferActions"] = encodeArrayBufferActions;
  exports["decodeArrayBufferActions"] = decodeArrayBufferActions;
  exports["dynamicByteLengthActions"] = dynamicByteLengthActions;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Buys"] = $PS["Domination.Data.Buys"] || {};
  var exports = $PS["Domination.Data.Buys"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Internal_Re = $PS["Data.Lens.Internal.Re"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Iso_Newtype = $PS["Data.Lens.Iso.Newtype"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var semiringBuys = Domination_Data_Wire_Int.ringWireInt;
  var ringBuys = Domination_Data_Wire_Int.semiringWireInt;
  var ordBuys = Domination_Data_Wire_Int.ordWireInt;          
  var genericBuys = new Data_Generic_Rep.Generic(function (x) {
      return x;
  }, function (x) {
      return x;
  });
  var showBuys = new Data_Show.Show(Data_Show_Generic.genericShow(genericBuys)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Wire_Int.showWireInt))(new Data_Symbol.IsSymbol(function () {
      return "Buys";
  }))));
  var eqBuys = Domination_Data_Wire_Int.eqWireInt;
  var encodeJsonBuys = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericBuys)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Buys";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Wire_Int.encodeJsonWireInt))));
  var encodeArrayBufferBuys = Domination_Data_Wire_Int.encodeArrayBufferWireInt;
  var dynamicByteLengthBuys = Domination_Data_Wire_Int.dynamicByteLengthWireInt;
  var decodeJsonBuys = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericBuys)(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "Buys";
  }))(Domination_Data_Wire_Int.decodeJsonWireInt)));
  var decodeArrayBufferBuys = Domination_Data_Wire_Int.decodeArrayBufferWireInt;
  var _int = function (dictProfunctor) {
      var $5 = Data_Lens_Iso_Newtype["_Newtype"]()()(dictProfunctor);
      var $6 = Data_Lens_Iso.re(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Re.profunctorRe(dictProfunctor)));
      return function ($7) {
          return $5($6($7));
      };
  };
  var buys = Data_Lens_Prism.review(_int(Data_Lens_Internal_Tagged.taggedProfunctor));
  exports["buys"] = buys;
  exports["_int"] = _int;
  exports["eqBuys"] = eqBuys;
  exports["ordBuys"] = ordBuys;
  exports["ringBuys"] = ringBuys;
  exports["semiringBuys"] = semiringBuys;
  exports["showBuys"] = showBuys;
  exports["encodeJsonBuys"] = encodeJsonBuys;
  exports["decodeJsonBuys"] = decodeJsonBuys;
  exports["encodeArrayBufferBuys"] = encodeArrayBufferBuys;
  exports["decodeArrayBufferBuys"] = decodeArrayBufferBuys;
  exports["dynamicByteLengthBuys"] = dynamicByteLengthBuys;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.CardType"] = $PS["Domination.Data.CardType"] || {};
  var exports = $PS["Domination.Data.CardType"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var Action = (function () {
      function Action() {

      };
      Action.value = new Action();
      return Action;
  })();
  var Treasure = (function () {
      function Treasure() {

      };
      Treasure.value = new Treasure();
      return Treasure;
  })();
  var Victory = (function () {
      function Victory() {

      };
      Victory.value = new Victory();
      return Victory;
  })();
  var Curse = (function () {
      function Curse() {

      };
      Curse.value = new Curse();
      return Curse;
  })();
  var Attack = (function () {
      function Attack() {

      };
      Attack.value = new Attack();
      return Attack;
  })();
  var Reaction = (function () {
      function Reaction() {

      };
      Reaction.value = new Reaction();
      return Reaction;
  })();
  var genericCardType = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof Action) {
          return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
      };
      if (x instanceof Treasure) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
      };
      if (x instanceof Victory) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
      };
      if (x instanceof Curse) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
      };
      if (x instanceof Attack) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
      };
      if (x instanceof Reaction) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))));
      };
      throw new Error("Failed pattern match at Domination.Data.CardType (line 30, column 1 - line 30, column 54): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return Action.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return Treasure.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return Victory.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return Curse.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return Attack.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
          return Reaction.value;
      };
      throw new Error("Failed pattern match at Domination.Data.CardType (line 30, column 1 - line 30, column 54): " + [ x.constructor.name ]);
  });
  var showCardType = new Data_Show.Show(Data_Show_Generic.genericShow(genericCardType)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Action";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Treasure";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Victory";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Curse";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Attack";
  })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Reaction";
  })))))))));
  var eqCardType = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof Action && y instanceof Action) {
              return true;
          };
          if (x instanceof Treasure && y instanceof Treasure) {
              return true;
          };
          if (x instanceof Victory && y instanceof Victory) {
              return true;
          };
          if (x instanceof Curse && y instanceof Curse) {
              return true;
          };
          if (x instanceof Attack && y instanceof Attack) {
              return true;
          };
          if (x instanceof Reaction && y instanceof Reaction) {
              return true;
          };
          return false;
      };
  });
  var encodeJsonCardType = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericCardType)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Action";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Treasure";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Victory";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Curse";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Attack";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Reaction";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))))));
  var encodeArrayBuffeCardType = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericCardType)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))))))));
  var dynamicByteLengthCardType = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericCardType)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))));
  var decodeJsonCardType = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericCardType)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Action";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Treasure";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Victory";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Curse";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Attack";
  })))(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Reaction";
  })))))))));
  var decodeArrayBuffeCardType = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericCardType)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))));
  exports["Action"] = Action;
  exports["Treasure"] = Treasure;
  exports["Victory"] = Victory;
  exports["Curse"] = Curse;
  exports["Attack"] = Attack;
  exports["Reaction"] = Reaction;
  exports["eqCardType"] = eqCardType;
  exports["showCardType"] = showCardType;
  exports["encodeJsonCardType"] = encodeJsonCardType;
  exports["decodeJsonCardType"] = decodeJsonCardType;
  exports["dynamicByteLengthCardType"] = dynamicByteLengthCardType;
  exports["encodeArrayBuffeCardType"] = encodeArrayBuffeCardType;
  exports["decodeArrayBuffeCardType"] = decodeArrayBuffeCardType;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Bonus"] = $PS["Domination.Data.Bonus"] || {};
  var exports = $PS["Domination.Data.Bonus"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var Cash = (function () {
      function Cash(value0) {
          this.value0 = value0;
      };
      Cash.create = function (value0) {
          return new Cash(value0);
      };
      return Cash;
  })();
  var genericBonus = new Data_Generic_Rep.Generic(function (x) {
      return x.value0;
  }, function (x) {
      return new Cash(x);
  });
  var showBonus = new Data_Show.Show(Data_Show_Generic.genericShow(genericBonus)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
      return "Cash";
  }))));
  var eqBonus = new Data_Eq.Eq(function (x) {
      return function (y) {
          return x.value0 === y.value0;
      };
  });
  var encodeJsonBonus = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericBonus)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Cash";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(a);
  });
  var decodeJsonBonus = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericBonus)(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Cash";
      }))(Data_Argonaut_Decode_Class.decodeJsonInt))(a);
  });
  var cashValue1 = function (v) {
      return v.value0;
  };             
  var cashValue = Data_Array.foldr(function (a) {
      return function (b) {
          return cashValue1(a) + b | 0;
      };
  })(0);
  exports["Cash"] = Cash;
  exports["cashValue"] = cashValue;
  exports["eqBonus"] = eqBonus;
  exports["showBonus"] = showBonus;
  exports["encodeJsonBonus"] = encodeJsonBonus;
  exports["decodeJsonBonus"] = decodeJsonBonus;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Condition"] = $PS["Domination.Data.Condition"] || {};
  var exports = $PS["Domination.Data.Condition"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];                
  var HasCard = (function () {
      function HasCard(value0) {
          this.value0 = value0;
      };
      HasCard.create = function (value0) {
          return new HasCard(value0);
      };
      return HasCard;
  })();
  var HasCardType = (function () {
      function HasCardType(value0) {
          this.value0 = value0;
      };
      HasCardType.create = function (value0) {
          return new HasCardType(value0);
      };
      return HasCardType;
  })();
  var HasDiscard = (function () {
      function HasDiscard() {

      };
      HasDiscard.value = new HasDiscard();
      return HasDiscard;
  })();
  var DiscardContains = (function () {
      function DiscardContains(value0) {
          this.value0 = value0;
      };
      DiscardContains.create = function (value0) {
          return new DiscardContains(value0);
      };
      return DiscardContains;
  })();
  var DiscardContainsCardType = (function () {
      function DiscardContainsCardType(value0) {
          this.value0 = value0;
      };
      DiscardContainsCardType.create = function (value0) {
          return new DiscardContainsCardType(value0);
      };
      return DiscardContainsCardType;
  })();
  var TrashContainsCardType = (function () {
      function TrashContainsCardType(value0) {
          this.value0 = value0;
      };
      TrashContainsCardType.create = function (value0) {
          return new TrashContainsCardType(value0);
      };
      return TrashContainsCardType;
  })();
  var Randomly = (function () {
      function Randomly(value0) {
          this.value0 = value0;
      };
      Randomly.create = function (value0) {
          return new Randomly(value0);
      };
      return Randomly;
  })();
  var genericCondition = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof HasCard) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof HasCardType) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof HasDiscard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
      };
      if (x instanceof DiscardContains) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof DiscardContainsCardType) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof TrashContainsCardType) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
      };
      if (x instanceof Randomly) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
      };
      throw new Error("Failed pattern match at Domination.Data.Condition (line 33, column 1 - line 33, column 56): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new HasCard(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new HasCardType(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return HasDiscard.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new DiscardContains(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new DiscardContainsCardType(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return new TrashContainsCardType(x.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
          return new Randomly(x.value0.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Condition (line 33, column 1 - line 33, column 56): " + [ x.constructor.name ]);
  });
  var showCondition = new Data_Show.Show(function (condition) {
      return Data_Show_Generic.genericShow(genericCondition)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
          return "HasCard";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_CardType.showCardType))(new Data_Symbol.IsSymbol(function () {
          return "HasCardType";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "HasDiscard";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
          return "DiscardContains";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_CardType.showCardType))(new Data_Symbol.IsSymbol(function () {
          return "DiscardContainsCardType";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_CardType.showCardType))(new Data_Symbol.IsSymbol(function () {
          return "TrashContainsCardType";
      })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Wire_Int.showWireInt))(new Data_Symbol.IsSymbol(function () {
          return "Randomly";
      })))))))))(condition);
  });
  var eqCondition = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof HasCard && y instanceof HasCard) {
              return x.value0 === y.value0;
          };
          if (x instanceof HasCardType && y instanceof HasCardType) {
              return Data_Eq.eq(Domination_Data_CardType.eqCardType)(x.value0)(y.value0);
          };
          if (x instanceof HasDiscard && y instanceof HasDiscard) {
              return true;
          };
          if (x instanceof DiscardContains && y instanceof DiscardContains) {
              return x.value0 === y.value0;
          };
          if (x instanceof DiscardContainsCardType && y instanceof DiscardContainsCardType) {
              return Data_Eq.eq(Domination_Data_CardType.eqCardType)(x.value0)(y.value0);
          };
          if (x instanceof TrashContainsCardType && y instanceof TrashContainsCardType) {
              return Data_Eq.eq(Domination_Data_CardType.eqCardType)(x.value0)(y.value0);
          };
          if (x instanceof Randomly && y instanceof Randomly) {
              return Data_Eq.eq(Domination_Data_Wire_Int.eqWireInt)(x.value0)(y.value0);
          };
          return false;
      };
  });
  var encodeJsonCondition = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericCondition)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "HasCard";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "HasCardType";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_CardType.encodeJsonCardType)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "HasDiscard";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "DiscardContains";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "DiscardContainsCardType";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_CardType.encodeJsonCardType)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "TrashContainsCardType";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_CardType.encodeJsonCardType)))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Randomly";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Wire_Int.encodeJsonWireInt)))))))))(a);
  });
  var encodeArrayBufferCondition = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericCondition)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_CardType.encodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_CardType.encodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_CardType.encodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))))))));
  var dynamicByteLengthCondition = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericCondition)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))));
  var decodeJsonCondition = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericCondition)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "HasCard";
      }))(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "HasCardType";
      }))(Domination_Data_CardType.decodeJsonCardType))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "HasDiscard";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "DiscardContains";
      }))(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "DiscardContainsCardType";
      }))(Domination_Data_CardType.decodeJsonCardType))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "TrashContainsCardType";
      }))(Domination_Data_CardType.decodeJsonCardType))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Randomly";
      }))(Domination_Data_Wire_Int.decodeJsonWireInt))))))))(a);
  });
  var decodeArrayBufferCondition = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericCondition)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_CardType.decodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_CardType.decodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_CardType.decodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))));
  exports["HasCard"] = HasCard;
  exports["HasCardType"] = HasCardType;
  exports["HasDiscard"] = HasDiscard;
  exports["DiscardContains"] = DiscardContains;
  exports["DiscardContainsCardType"] = DiscardContainsCardType;
  exports["TrashContainsCardType"] = TrashContainsCardType;
  exports["Randomly"] = Randomly;
  exports["eqCondition"] = eqCondition;
  exports["showCondition"] = showCondition;
  exports["encodeJsonCondition"] = encodeJsonCondition;
  exports["decodeJsonCondition"] = decodeJsonCondition;
  exports["dynamicByteLengthCondition"] = dynamicByteLengthCondition;
  exports["encodeArrayBufferCondition"] = encodeArrayBufferCondition;
  exports["decodeArrayBufferCondition"] = decodeArrayBufferCondition;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Relationship"] = $PS["Relationship"] || {};
  var exports = $PS["Relationship"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Show = $PS["Data.Show"];                
  var EQ = (function () {
      function EQ() {

      };
      EQ.value = new EQ();
      return EQ;
  })();
  var NEQ = (function () {
      function NEQ() {

      };
      NEQ.value = new NEQ();
      return NEQ;
  })();
  var LT = (function () {
      function LT() {

      };
      LT.value = new LT();
      return LT;
  })();
  var LTE = (function () {
      function LTE() {

      };
      LTE.value = new LTE();
      return LTE;
  })();
  var GT = (function () {
      function GT() {

      };
      GT.value = new GT();
      return GT;
  })();
  var GTE = (function () {
      function GTE() {

      };
      GTE.value = new GTE();
      return GTE;
  })();
  var showRelationship = new Data_Show.Show(function (v) {
      if (v instanceof EQ) {
          return "exactly";
      };
      if (v instanceof NEQ) {
          return "not";
      };
      if (v instanceof LT) {
          return "less than";
      };
      if (v instanceof LTE) {
          return "at most";
      };
      if (v instanceof GT) {
          return "more than";
      };
      if (v instanceof GTE) {
          return "at least";
      };
      throw new Error("Failed pattern match at Relationship (line 25, column 10 - line 31, column 22): " + [ v.constructor.name ]);
  });
  var is = function (dictOrd) {
      return function (r) {
          return function (n) {
              if (r instanceof EQ) {
                  return function (v) {
                      return Data_Eq.eq(dictOrd.Eq0())(v)(n);
                  };
              };
              if (r instanceof NEQ) {
                  return function (v) {
                      return Data_Eq.notEq(dictOrd.Eq0())(v)(n);
                  };
              };
              if (r instanceof LT) {
                  return function (v) {
                      return Data_Ord.lessThan(dictOrd)(v)(n);
                  };
              };
              if (r instanceof LTE) {
                  return function (v) {
                      return Data_Ord.lessThanOrEq(dictOrd)(v)(n);
                  };
              };
              if (r instanceof GT) {
                  return function (v) {
                      return Data_Ord.greaterThan(dictOrd)(v)(n);
                  };
              };
              if (r instanceof GTE) {
                  return function (v) {
                      return Data_Ord.greaterThan(dictOrd)(v)(n);
                  };
              };
              throw new Error("Failed pattern match at Relationship (line 34, column 10 - line 40, column 17): " + [ r.constructor.name ]);
          };
      };
  };
  exports["EQ"] = EQ;
  exports["LT"] = LT;
  exports["LTE"] = LTE;
  exports["is"] = is;
  exports["showRelationship"] = showRelationship;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Error.Class"] = $PS["Control.Monad.Error.Class"] || {};
  var exports = $PS["Control.Monad.Error.Class"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];                        
  var MonadThrow = function (Monad0, throwError) {
      this.Monad0 = Monad0;
      this.throwError = throwError;
  };
  var MonadError = function (MonadThrow0, catchError) {
      this.MonadThrow0 = MonadThrow0;
      this.catchError = catchError;
  };
  var throwError = function (dict) {
      return dict.throwError;
  };                                                      
  var catchError = function (dict) {
      return dict.catchError;
  };
  var $$try = function (dictMonadError) {
      return function (a) {
          return catchError(dictMonadError)(Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Either.Right.create)(a))((function () {
              var $17 = Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0());
              return function ($18) {
                  return $17(Data_Either.Left.create($18));
              };
          })());
      };
  };
  exports["throwError"] = throwError;
  exports["MonadThrow"] = MonadThrow;
  exports["MonadError"] = MonadError;
  exports["try"] = $$try;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Rule"] = $PS["Rule"] || {};
  var exports = $PS["Rule"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Unit = $PS["Data.Unit"];
  var Relationship = $PS["Relationship"];                
  var False = (function () {
      function False() {

      };
      False.value = new False();
      return False;
  })();
  var True = (function () {
      function True() {

      };
      True.value = new True();
      return True;
  })();
  var Claim = (function () {
      function Claim(value0) {
          this.value0 = value0;
      };
      Claim.create = function (value0) {
          return new Claim(value0);
      };
      return Claim;
  })();
  var Not = (function () {
      function Not(value0) {
          this.value0 = value0;
      };
      Not.create = function (value0) {
          return new Not(value0);
      };
      return Not;
  })();
  var And = (function () {
      function And(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      And.create = function (value0) {
          return function (value1) {
              return new And(value0, value1);
          };
      };
      return And;
  })();
  var Or = (function () {
      function Or(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Or.create = function (value0) {
          return function (value1) {
              return new Or(value0, value1);
          };
      };
      return Or;
  })();
  var Implies = (function () {
      function Implies(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Implies.create = function (value0) {
          return function (value1) {
              return new Implies(value0, value1);
          };
      };
      return Implies;
  })();
  var rule = function (dictShow) {
      return function (predicate) {
          return function (error) {
              return {
                  error: (function () {
                      var $192 = Data_Show.show(dictShow);
                      return function ($193) {
                          return Claim.create(error($192($193)));
                      };
                  })(),
                  predicate: predicate
              };
          };
      };
  };
  var simpleRule = function (dictShow) {
      return function (predicate) {
          return function (string) {
              return rule(dictShow)(predicate)(Data_Function["const"](string));
          };
      };
  };
  var print = function (v) {
      if (v instanceof False) {
          return "FALSE";
      };
      if (v instanceof True) {
          return "TRUE";
      };
      if (v instanceof Claim) {
          return v.value0;
      };
      if (v instanceof Not) {
          return "NOT (" + (print(v.value0) + ")");
      };
      if (v instanceof And) {
          return "(" + (print(v.value0) + (" AND " + (print(v.value1) + ")")));
      };
      if (v instanceof Or) {
          return "(" + (print(v.value0) + (" OR " + (print(v.value1) + ")")));
      };
      if (v instanceof Implies) {
          return "IF (" + (print(v.value0) + (") then (" + (print(v.value1) + ")")));
      };
      throw new Error("Failed pattern match at Rule (line 78, column 9 - line 85, column 67): " + [ v.constructor.name ]);
  };
  var logicHeytingAlgebra = new Data_HeytingAlgebra.HeytingAlgebra(function (a) {
      return function (b) {
          return new And(a, b);
      };
  }, function (a) {
      return function (b) {
          return new Or(a, b);
      };
  }, False.value, function (a) {
      return function (b) {
          return new Implies(a, b);
      };
  }, function (a) {
      return new Not(a);
  }, True.value);
  var lengthIs = function (dictShow) {
      return function (r) {
          return function (n) {
              return simpleRule(Data_Show.showArray(dictShow))((function () {
                  var $194 = Relationship.is(Data_Ord.ordInt)(r)(n);
                  return function ($195) {
                      return $194(Data_Array.length($195));
                  };
              })())("must have " + (Data_Show.show(Relationship.showRelationship)(r) + (" " + Data_Show.show(Data_Show.showInt)(n))));
          };
      };
  }; 
  var functorLogic = new Data_Functor.Functor(function (f) {
      return function (m) {
          if (m instanceof False) {
              return False.value;
          };
          if (m instanceof True) {
              return True.value;
          };
          if (m instanceof Claim) {
              return new Claim(f(m.value0));
          };
          if (m instanceof Not) {
              return new Not(Data_Functor.map(functorLogic)(f)(m.value0));
          };
          if (m instanceof And) {
              return new And(Data_Functor.map(functorLogic)(f)(m.value0), Data_Functor.map(functorLogic)(f)(m.value1));
          };
          if (m instanceof Or) {
              return new Or(Data_Functor.map(functorLogic)(f)(m.value0), Data_Functor.map(functorLogic)(f)(m.value1));
          };
          if (m instanceof Implies) {
              return new Implies(Data_Functor.map(functorLogic)(f)(m.value0), Data_Functor.map(functorLogic)(f)(m.value1));
          };
          throw new Error("Failed pattern match at Rule (line 67, column 1 - line 67, column 46): " + [ m.constructor.name ]);
      };
  });
  var enforce = function (v) {
      return function (x) {
          return {
              error: v.error(x),
              ok: v.predicate(x)
          };
      };
  };
  var enforceOn = Data_Function.flip(enforce);
  var check = function (dictMonadError) {
      return function (v) {
          if (v.ok) {
              return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(Data_Unit.unit);
          };
          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())(print(v.error));
      };
  };
  var _error = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "error";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var appendErrorOn = function (r) {
      return function (s) {
          return Data_Lens_Setter.over(_error(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(functorLogic)(function (v) {
              return v + (" " + s);
          })))(r);
      };
  };
  var appendError = Data_Function.flip(appendErrorOn);
  exports["check"] = check;
  exports["enforceOn"] = enforceOn;
  exports["simpleRule"] = simpleRule;
  exports["appendErrorOn"] = appendErrorOn;
  exports["appendError"] = appendError;
  exports["lengthIs"] = lengthIs;
  exports["logicHeytingAlgebra"] = logicHeytingAlgebra;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Constraint"] = $PS["Domination.Data.Constraint"] || {};
  var exports = $PS["Domination.Data.Constraint"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Unit = $PS["Data.Unit"];
  var Relationship = $PS["Relationship"];
  var Rule = $PS["Rule"];                
  var UpTo = (function () {
      function UpTo(value0) {
          this.value0 = value0;
      };
      UpTo.create = function (value0) {
          return new UpTo(value0);
      };
      return UpTo;
  })();
  var Exactly = (function () {
      function Exactly(value0) {
          this.value0 = value0;
      };
      Exactly.create = function (value0) {
          return new Exactly(value0);
      };
      return Exactly;
  })();
  var DownTo = (function () {
      function DownTo(value0) {
          this.value0 = value0;
      };
      DownTo.create = function (value0) {
          return new DownTo(value0);
      };
      return DownTo;
  })();
  var Unlimited = (function () {
      function Unlimited() {

      };
      Unlimited.value = new Unlimited();
      return Unlimited;
  })();
  var genericConstraint = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof UpTo) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof Exactly) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof DownTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof Unlimited) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
      };
      throw new Error("Failed pattern match at Domination.Data.Constraint (line 75, column 1 - line 75, column 58): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new UpTo(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new Exactly(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new DownTo(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
          return Unlimited.value;
      };
      throw new Error("Failed pattern match at Domination.Data.Constraint (line 75, column 1 - line 75, column 58): " + [ x.constructor.name ]);
  });
  var showConstraint = new Data_Show.Show(Data_Show_Generic.genericShow(genericConstraint)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
      return "UpTo";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
      return "Exactly";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
      return "DownTo";
  })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Unlimited";
  })))))));
  var eqConstraint = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof UpTo && y instanceof UpTo) {
              return x.value0 === y.value0;
          };
          if (x instanceof Exactly && y instanceof Exactly) {
              return x.value0 === y.value0;
          };
          if (x instanceof DownTo && y instanceof DownTo) {
              return x.value0 === y.value0;
          };
          if (x instanceof Unlimited && y instanceof Unlimited) {
              return true;
          };
          return false;
      };
  });
  var encodeJsonConstraint = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericConstraint)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "UpTo";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Exactly";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "DownTo";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Unlimited";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))));
  var decodeJsonConstraint = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericConstraint)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "UpTo";
  }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "Exactly";
  }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "DownTo";
  }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Unlimited";
  })))))));
  var check = function (dictMonadError) {
      return function (dictShow) {
          return function (constraint) {
              return function (selected) {
                  return function (remaining) {
                      return function (sourcePile) {
                          var forSource = function ($46) {
                              return (function (v) {
                                  return Rule.enforceOn(sourcePile)(v);
                              })((function (v) {
                                  return Rule.appendError("source cards")(v);
                              })($46));
                          };
                          var forSelected = function ($47) {
                              return (function (v) {
                                  return Rule.enforceOn(selected)(v);
                              })((function (v) {
                                  return Rule.appendError("selected cards")(v);
                              })($47));
                          };
                          var forRemaining = function ($48) {
                              return (function (v) {
                                  return Rule.enforceOn(remaining)(v);
                              })((function (v) {
                                  return Rule.appendError("remaining cards")(v);
                              })($48));
                          };
                          if (constraint instanceof UpTo) {
                              return Rule.check(dictMonadError)(forSelected(Rule.lengthIs(dictShow)(Relationship.LTE.value)(constraint.value0)));
                          };
                          if (constraint instanceof DownTo) {
                              return Rule.check(dictMonadError)(Data_HeytingAlgebra.disj(Data_HeytingAlgebra.heytingAlgebraRecord()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "error";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "ok";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordNil)(Data_HeytingAlgebra.heytingAlgebraBoolean))(Rule.logicHeytingAlgebra)))(forRemaining(Rule.lengthIs(dictShow)(Relationship.EQ.value)(constraint.value0)))(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraRecord()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "error";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "ok";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordNil)(Data_HeytingAlgebra.heytingAlgebraBoolean))(Rule.logicHeytingAlgebra)))(forSource(Rule.lengthIs(dictShow)(Relationship.LT.value)(constraint.value0)))(forSelected(Rule.lengthIs(dictShow)(Relationship.EQ.value)(0)))));
                          };
                          if (constraint instanceof Exactly) {
                              return Rule.check(dictMonadError)(Data_HeytingAlgebra.disj(Data_HeytingAlgebra.heytingAlgebraRecord()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "error";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "ok";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordNil)(Data_HeytingAlgebra.heytingAlgebraBoolean))(Rule.logicHeytingAlgebra)))(forSelected(Rule.lengthIs(dictShow)(Relationship.EQ.value)(constraint.value0)))(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraRecord()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "error";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordCons(new Data_Symbol.IsSymbol(function () {
                                  return "ok";
                              }))()(Data_HeytingAlgebra.heytingAlgebraRecordNil)(Data_HeytingAlgebra.heytingAlgebraBoolean))(Rule.logicHeytingAlgebra)))(forSource(Rule.lengthIs(dictShow)(Relationship.LT.value)(constraint.value0)))(forSelected(Rule.lengthIs(dictShow)(Relationship.EQ.value)(Data_Array.length(sourcePile))))));
                          };
                          if (constraint instanceof Unlimited) {
                              return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(Data_Unit.unit);
                          };
                          throw new Error("Failed pattern match at Domination.Data.Constraint (line 55, column 3 - line 73, column 27): " + [ constraint.constructor.name ]);
                      };
                  };
              };
          };
      };
  };
  exports["UpTo"] = UpTo;
  exports["Exactly"] = Exactly;
  exports["DownTo"] = DownTo;
  exports["Unlimited"] = Unlimited;
  exports["check"] = check;
  exports["eqConstraint"] = eqConstraint;
  exports["showConstraint"] = showConstraint;
  exports["encodeJsonConstraint"] = encodeJsonConstraint;
  exports["decodeJsonConstraint"] = decodeJsonConstraint;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Filter"] = $PS["Domination.Data.Filter"] || {};
  var exports = $PS["Domination.Data.Filter"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];                
  var HasName = (function () {
      function HasName(value0) {
          this.value0 = value0;
      };
      HasName.create = function (value0) {
          return new HasName(value0);
      };
      return HasName;
  })();
  var HasType = (function () {
      function HasType(value0) {
          this.value0 = value0;
      };
      HasType.create = function (value0) {
          return new HasType(value0);
      };
      return HasType;
  })();
  var CostUpTo = (function () {
      function CostUpTo(value0) {
          this.value0 = value0;
      };
      CostUpTo.create = function (value0) {
          return new CostUpTo(value0);
      };
      return CostUpTo;
  })();
  var Any = (function () {
      function Any() {

      };
      Any.value = new Any();
      return Any;
  })();
  var And = (function () {
      function And(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      And.create = function (value0) {
          return function (value1) {
              return new And(value0, value1);
          };
      };
      return And;
  })();
  var genericFilter = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof HasName) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof HasType) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof CostUpTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof Any) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
      };
      if (x instanceof And) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1)))));
      };
      throw new Error("Failed pattern match at Domination.Data.Filter (line 29, column 1 - line 29, column 50): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new HasName(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new HasType(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new CostUpTo(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return Any.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
          return new And(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
      };
      throw new Error("Failed pattern match at Domination.Data.Filter (line 29, column 1 - line 29, column 50): " + [ x.constructor.name ]);
  });
  var showFilter = new Data_Show.Show(function (condition) {
      return Data_Show_Generic.genericShow(genericFilter)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
          return "HasName";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_CardType.showCardType))(new Data_Symbol.IsSymbol(function () {
          return "HasType";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
          return "CostUpTo";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "Any";
      })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(showFilter))(Data_Show_Generic.genericShowArgsArgument(showFilter)))(new Data_Symbol.IsSymbol(function () {
          return "And";
      })))))))(condition);
  });
  var eqFilter = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof HasName && y instanceof HasName) {
              return x.value0 === y.value0;
          };
          if (x instanceof HasType && y instanceof HasType) {
              return Data_Eq.eq(Domination_Data_CardType.eqCardType)(x.value0)(y.value0);
          };
          if (x instanceof CostUpTo && y instanceof CostUpTo) {
              return x.value0 === y.value0;
          };
          if (x instanceof Any && y instanceof Any) {
              return true;
          };
          if (x instanceof And && y instanceof And) {
              return Data_Eq.eq(eqFilter)(x.value0)(y.value0) && Data_Eq.eq(eqFilter)(x.value1)(y.value1);
          };
          return false;
      };
  });
  var encodeJsonFilter = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericFilter)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "HasName";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "HasType";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_CardType.encodeJsonCardType)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "CostUpTo";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Any";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "And";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsProduct(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(encodeJsonFilter))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(encodeJsonFilter))))))))(a);
  });
  var decodeJsonFilter = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericFilter)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "HasName";
      }))(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "HasType";
      }))(Domination_Data_CardType.decodeJsonCardType))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "CostUpTo";
      }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "Any";
      })))(Data_Argonaut_Decode_Generic.decodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "And";
      }))(Data_Argonaut_Decode_Generic.decodeRepArgsProduct(Data_Argonaut_Decode_Generic.decodeRepArgsArgument(decodeJsonFilter))(Data_Argonaut_Decode_Generic.decodeRepArgsArgument(decodeJsonFilter))))))))(a);
  });
  exports["HasName"] = HasName;
  exports["HasType"] = HasType;
  exports["CostUpTo"] = CostUpTo;
  exports["Any"] = Any;
  exports["And"] = And;
  exports["eqFilter"] = eqFilter;
  exports["showFilter"] = showFilter;
  exports["encodeJsonFilter"] = encodeJsonFilter;
  exports["decodeJsonFilter"] = decodeJsonFilter;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Pile"] = $PS["Domination.Data.Pile"] || {};
  var exports = $PS["Domination.Data.Pile"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var Supply = (function () {
      function Supply() {

      };
      Supply.value = new Supply();
      return Supply;
  })();
  var Trash = (function () {
      function Trash() {

      };
      Trash.value = new Trash();
      return Trash;
  })();
  var AtPlay = (function () {
      function AtPlay() {

      };
      AtPlay.value = new AtPlay();
      return AtPlay;
  })();
  var Buying = (function () {
      function Buying() {

      };
      Buying.value = new Buying();
      return Buying;
  })();
  var Deck = (function () {
      function Deck() {

      };
      Deck.value = new Deck();
      return Deck;
  })();
  var Discard = (function () {
      function Discard() {

      };
      Discard.value = new Discard();
      return Discard;
  })();
  var Discarding = (function () {
      function Discarding() {

      };
      Discarding.value = new Discarding();
      return Discarding;
  })();
  var Hand = (function () {
      function Hand() {

      };
      Hand.value = new Hand();
      return Hand;
  })();                                                                                                     
  var genericPile = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof Supply) {
          return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
      };
      if (x instanceof Trash) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
      };
      if (x instanceof AtPlay) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
      };
      if (x instanceof Buying) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
      };
      if (x instanceof Deck) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
      };
      if (x instanceof Discard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
      };
      if (x instanceof Discarding) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
      };
      if (x instanceof Hand) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))));
      };
      throw new Error("Failed pattern match at Domination.Data.Pile (line 41, column 1 - line 41, column 46): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return Supply.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return Trash.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return AtPlay.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return Buying.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return Deck.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return Discard.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
          return Discarding.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))) {
          return Hand.value;
      };
      throw new Error("Failed pattern match at Domination.Data.Pile (line 41, column 1 - line 41, column 46): " + [ x.constructor.name ]);
  });
  var showPile = new Data_Show.Show(Data_Show_Generic.genericShow(genericPile)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Supply";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Trash";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "AtPlay";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Buying";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Deck";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Discard";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Discarding";
  })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Hand";
  })))))))))));
  var eqPile = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof Supply && y instanceof Supply) {
              return true;
          };
          if (x instanceof Trash && y instanceof Trash) {
              return true;
          };
          if (x instanceof AtPlay && y instanceof AtPlay) {
              return true;
          };
          if (x instanceof Buying && y instanceof Buying) {
              return true;
          };
          if (x instanceof Deck && y instanceof Deck) {
              return true;
          };
          if (x instanceof Discard && y instanceof Discard) {
              return true;
          };
          if (x instanceof Discarding && y instanceof Discarding) {
              return true;
          };
          if (x instanceof Hand && y instanceof Hand) {
              return true;
          };
          return false;
      };
  });                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
  var encodeJsonPile = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericPile)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Supply";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Trash";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "AtPlay";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Buying";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Deck";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Discard";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Discarding";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Hand";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))))))));
  var encodeArrayBuffePile = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericPile)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))))))))));
  var dynamicByteLengthPile = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericPile)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))))));
  var decodeJsonPile = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericPile)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Supply";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Trash";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "AtPlay";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Buying";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Deck";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Discard";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Discarding";
  })))(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Hand";
  })))))))))));
  var decodeArrayBuffePile = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericPile)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))))))));
  exports["Supply"] = Supply;
  exports["Trash"] = Trash;
  exports["AtPlay"] = AtPlay;
  exports["Buying"] = Buying;
  exports["Deck"] = Deck;
  exports["Discard"] = Discard;
  exports["Discarding"] = Discarding;
  exports["Hand"] = Hand;
  exports["eqPile"] = eqPile;
  exports["encodeJsonPile"] = encodeJsonPile;
  exports["decodeJsonPile"] = decodeJsonPile;
  exports["showPile"] = showPile;
  exports["dynamicByteLengthPile"] = dynamicByteLengthPile;
  exports["encodeArrayBuffePile"] = encodeArrayBuffePile;
  exports["decodeArrayBuffePile"] = decodeArrayBuffePile;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.SelectCards"] = $PS["Domination.Data.SelectCards"] || {};
  var exports = $PS["Domination.Data.SelectCards"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var SelectAll = (function () {
      function SelectAll() {

      };
      SelectAll.value = new SelectAll();
      return SelectAll;
  })();
  var genericSelectCards = new Data_Generic_Rep.Generic(function (x) {
      return Data_Generic_Rep.NoArguments.value;
  }, function (x) {
      return SelectAll.value;
  });
  var showSelectCards = new Data_Show.Show(Data_Show_Generic.genericShow(genericSelectCards)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "SelectAll";
  }))));
  var eqSelectCards = new Data_Eq.Eq(function (x) {
      return function (y) {
          return true;
      };
  });
  var encodeJsonSelectCards = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericSelectCards)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "SelectAll";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)));
  var encodeArrayBuffeSelectCards = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericSelectCards)(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments)));
  var dynamicByteLengthSelectCards = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericSelectCards)(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)));
  var decodeJsonSelectCards = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericSelectCards)(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "SelectAll";
  }))));
  var decodeArrayBuffeSelectCards = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericSelectCards)(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments)));
  exports["SelectAll"] = SelectAll;
  exports["eqSelectCards"] = eqSelectCards;
  exports["showSelectCards"] = showSelectCards;
  exports["encodeJsonSelectCards"] = encodeJsonSelectCards;
  exports["decodeJsonSelectCards"] = decodeJsonSelectCards;
  exports["dynamicByteLengthSelectCards"] = dynamicByteLengthSelectCards;
  exports["encodeArrayBuffeSelectCards"] = encodeArrayBuffeSelectCards;
  exports["decodeArrayBuffeSelectCards"] = decodeArrayBuffeSelectCards;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Var"] = $PS["Domination.Data.Var"] || {};
  var exports = $PS["Domination.Data.Var"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var Unbound = (function () {
      function Unbound() {

      };
      Unbound.value = new Unbound();
      return Unbound;
  })();
  var Bound = (function () {
      function Bound(value0) {
          this.value0 = value0;
      };
      Bound.create = function (value0) {
          return new Bound(value0);
      };
      return Bound;
  })();
  var genericVar = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof Unbound) {
          return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
      };
      if (x instanceof Bound) {
          return new Data_Generic_Rep.Inr(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Var (line 24, column 1 - line 24, column 48): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return Unbound.value;
      };
      if (x instanceof Data_Generic_Rep.Inr) {
          return new Bound(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Var (line 24, column 1 - line 24, column 48): " + [ x.constructor.name ]);
  });
  var showVar = function (dictShow) {
      return new Data_Show.Show(function (a) {
          return Data_Show_Generic.genericShow(genericVar)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
              return "Unbound";
          })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
              return "Bound";
          }))))(a);
      });
  };
  var functorVar = new Data_Functor.Functor(function (f) {
      return function (m) {
          if (m instanceof Unbound) {
              return Unbound.value;
          };
          if (m instanceof Bound) {
              return new Bound(f(m.value0));
          };
          throw new Error("Failed pattern match at Domination.Data.Var (line 28, column 1 - line 28, column 42): " + [ m.constructor.name ]);
      };
  });
  var eqVar = function (dictEq) {
      return new Data_Eq.Eq(function (x) {
          return function (y) {
              if (x instanceof Unbound && y instanceof Unbound) {
                  return true;
              };
              if (x instanceof Bound && y instanceof Bound) {
                  return Data_Eq.eq(dictEq)(x.value0)(y.value0);
              };
              return false;
          };
      });
  };
  var encodeJsonVar = function (dictEncodeJson) {
      return new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
          return Data_Argonaut_Encode_Generic.genericEncodeJson(genericVar)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
              return "Unbound";
          }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
              return "Bound";
          }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(dictEncodeJson))))(a);
      });
  };
  var encodeArrayBuffeVar = function (dictEncodeArrayBuffer) {
      return new Data_ArrayBuffer_Class.EncodeArrayBuffer(function (x) {
          return Data_ArrayBuffer_Class.genericPutArrayBuffer(genericVar)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(dictEncodeArrayBuffer))))(x);
      });
  };
  var dynamicByteLengthVar = function (dictDynamicByteLength) {
      return new Data_ArrayBuffer_Class.DynamicByteLength(function (x) {
          return Data_ArrayBuffer_Class.genericByteLength(genericVar)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dictDynamicByteLength))))(x);
      });
  };
  var decodeJsonVar = function (dictDecodeJson) {
      return new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
          return Data_Argonaut_Decode_Generic.genericDecodeJson(genericVar)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
              return "Unbound";
          })))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
              return "Bound";
          }))(dictDecodeJson)))(a);
      });
  };
  var decodeArrayBuffeVar = function (dictDecodeArrayBuffer) {
      return function (dictDynamicByteLength) {
          return new Data_ArrayBuffer_Class.DecodeArrayBuffer(function (x) {
              return Data_ArrayBuffer_Class.genericReadArrayBuffer(genericVar)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(dictDecodeArrayBuffer)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dictDynamicByteLength))))(x);
          });
      };
  };
  exports["Unbound"] = Unbound;
  exports["Bound"] = Bound;
  exports["eqVar"] = eqVar;
  exports["functorVar"] = functorVar;
  exports["showVar"] = showVar;
  exports["encodeJsonVar"] = encodeJsonVar;
  exports["decodeJsonVar"] = decodeJsonVar;
  exports["dynamicByteLengthVar"] = dynamicByteLengthVar;
  exports["encodeArrayBuffeVar"] = encodeArrayBuffeVar;
  exports["decodeArrayBuffeVar"] = decodeArrayBuffeVar;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.StackEvaluation"] = $PS["Domination.Data.StackEvaluation"] || {};
  var exports = $PS["Domination.Data.StackEvaluation"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Var = $PS["Domination.Data.Var"];                
  var StackArrayInt = (function () {
      function StackArrayInt(value0) {
          this.value0 = value0;
      };
      StackArrayInt.create = function (value0) {
          return new StackArrayInt(value0);
      };
      return StackArrayInt;
  })();
  var StackInt = (function () {
      function StackInt(value0) {
          this.value0 = value0;
      };
      StackInt.create = function (value0) {
          return new StackInt(value0);
      };
      return StackInt;
  })();
  var StackString = (function () {
      function StackString(value0) {
          this.value0 = value0;
      };
      StackString.create = function (value0) {
          return new StackString(value0);
      };
      return StackString;
  })();
  var StackFilter = (function () {
      function StackFilter(value0) {
          this.value0 = value0;
      };
      StackFilter.create = function (value0) {
          return new StackFilter(value0);
      };
      return StackFilter;
  })();
  var StackBool = (function () {
      function StackBool(value0) {
          this.value0 = value0;
      };
      StackBool.create = function (value0) {
          return new StackBool(value0);
      };
      return StackBool;
  })();
  var StackChooseCards = (function () {
      function StackChooseCards(value0) {
          this.value0 = value0;
      };
      StackChooseCards.create = function (value0) {
          return new StackChooseCards(value0);
      };
      return StackChooseCards;
  })();
  var StackDuplicate = (function () {
      function StackDuplicate() {

      };
      StackDuplicate.value = new StackDuplicate();
      return StackDuplicate;
  })();
  var StackDiscard = (function () {
      function StackDiscard() {

      };
      StackDiscard.value = new StackDiscard();
      return StackDiscard;
  })();
  var StackLength = (function () {
      function StackLength() {

      };
      StackLength.value = new StackLength();
      return StackLength;
  })();
  var StackAddN = (function () {
      function StackAddN(value0) {
          this.value0 = value0;
      };
      StackAddN.create = function (value0) {
          return new StackAddN(value0);
      };
      return StackAddN;
  })();
  var StackDraw = (function () {
      function StackDraw() {

      };
      StackDraw.value = new StackDraw();
      return StackDraw;
  })();
  var StackTrash = (function () {
      function StackTrash() {

      };
      StackTrash.value = new StackTrash();
      return StackTrash;
  })();
  var StackNth = (function () {
      function StackNth(value0) {
          this.value0 = value0;
      };
      StackNth.create = function (value0) {
          return new StackNth(value0);
      };
      return StackNth;
  })();
  var StackCostOf = (function () {
      function StackCostOf() {

      };
      StackCostOf.value = new StackCostOf();
      return StackCostOf;
  })();
  var StackMakeFilterCostUpTo = (function () {
      function StackMakeFilterCostUpTo() {

      };
      StackMakeFilterCostUpTo.value = new StackMakeFilterCostUpTo();
      return StackMakeFilterCostUpTo;
  })();
  var StackMakeFilterAnd = (function () {
      function StackMakeFilterAnd() {

      };
      StackMakeFilterAnd.value = new StackMakeFilterAnd();
      return StackMakeFilterAnd;
  })();
  var StackBind = (function () {
      function StackBind(value0) {
          this.value0 = value0;
      };
      StackBind.create = function (value0) {
          return new StackBind(value0);
      };
      return StackBind;
  })();
  var StackGainTo = (function () {
      function StackGainTo(value0) {
          this.value0 = value0;
      };
      StackGainTo.create = function (value0) {
          return new StackGainTo(value0);
      };
      return StackGainTo;
  })();
  var StackChooseCardFromSupply = (function () {
      function StackChooseCardFromSupply(value0) {
          this.value0 = value0;
      };
      StackChooseCardFromSupply.create = function (value0) {
          return new StackChooseCardFromSupply(value0);
      };
      return StackChooseCardFromSupply;
  })();
  var StackEquals = (function () {
      function StackEquals(value0) {
          this.value0 = value0;
      };
      StackEquals.create = function (value0) {
          return new StackEquals(value0);
      };
      return StackEquals;
  })();
  var StackPush = (function () {
      function StackPush(value0) {
          this.value0 = value0;
      };
      StackPush.create = function (value0) {
          return new StackPush(value0);
      };
      return StackPush;
  })();
  var StackIf = (function () {
      function StackIf(value0) {
          this.value0 = value0;
      };
      StackIf.create = function (value0) {
          return new StackIf(value0);
      };
      return StackIf;
  })();
  var StackGainBonus = (function () {
      function StackGainBonus(value0) {
          this.value0 = value0;
      };
      StackGainBonus.create = function (value0) {
          return new StackGainBonus(value0);
      };
      return StackGainBonus;
  })();
  var StackOption = (function () {
      function StackOption(value0) {
          this.value0 = value0;
      };
      StackOption.create = function (value0) {
          return new StackOption(value0);
      };
      return StackOption;
  })();
  var genericStackValue = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof StackArrayInt) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof StackInt) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof StackString) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof StackFilter) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof StackBool) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
      };
      throw new Error("Failed pattern match at Domination.Data.StackEvaluation (line 76, column 1 - line 76, column 58): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new StackArrayInt(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new StackInt(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new StackString(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new StackFilter(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
          return new StackBool(x.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.StackEvaluation (line 76, column 1 - line 76, column 58): " + [ x.constructor.name ]);
  });
  var showStackValue = new Data_Show.Show(function (a) {
      return Data_Show_Generic.genericShow(genericStackValue)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showArray(Data_Show.showInt)))(new Data_Symbol.IsSymbol(function () {
          return "StackArrayInt";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
          return "StackInt";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
          return "StackString";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Filter.showFilter))(new Data_Symbol.IsSymbol(function () {
          return "StackFilter";
      })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showBoolean))(new Data_Symbol.IsSymbol(function () {
          return "StackBool";
      })))))))(a);
  });
  var genericStackExpression = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof StackChooseCards) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof StackDuplicate) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
      };
      if (x instanceof StackDiscard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
      };
      if (x instanceof StackLength) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
      };
      if (x instanceof StackAddN) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof StackDraw) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
      };
      if (x instanceof StackTrash) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
      };
      if (x instanceof StackNth) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
      };
      if (x instanceof StackCostOf) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
      };
      if (x instanceof StackMakeFilterCostUpTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
      };
      if (x instanceof StackMakeFilterAnd) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
      };
      if (x instanceof StackBind) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))));
      };
      if (x instanceof StackGainTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))));
      };
      if (x instanceof StackChooseCardFromSupply) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))));
      };
      if (x instanceof StackEquals) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))));
      };
      if (x instanceof StackPush) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))));
      };
      if (x instanceof StackIf) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))))));
      };
      if (x instanceof StackGainBonus) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))))));
      };
      if (x instanceof StackOption) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))))))))))))))));
      };
      throw new Error("Failed pattern match at Domination.Data.StackEvaluation (line 60, column 1 - line 60, column 68): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new StackChooseCards(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return StackDuplicate.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return StackDiscard.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return StackLength.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new StackAddN(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return StackDraw.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
          return StackTrash.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
          return new StackNth(x.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
          return StackCostOf.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
          return StackMakeFilterCostUpTo.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
          return StackMakeFilterAnd.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
          return new StackBind(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
          return new StackGainTo(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
          return new StackChooseCardFromSupply(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
          return new StackEquals(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
          return new StackPush(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
          return new StackIf(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
          return new StackGainBonus(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))))))))) {
          return new StackOption(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.StackEvaluation (line 60, column 1 - line 60, column 68): " + [ x.constructor.name ]);
  });
  var showStackExpression = new Data_Show.Show(function (a) {
      return Data_Show_Generic.genericShow(genericStackExpression)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "from";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Var.showVar(Domination_Data_Constraint.showConstraint)))(Domination_Data_Var.showVar(Domination_Data_Pile.showPile)))(Domination_Data_Var.showVar(Domination_Data_Filter.showFilter)))(Domination_Data_Var.showVar(Data_Show.showArray(Data_Show.showInt))))))(new Data_Symbol.IsSymbol(function () {
          return "StackChooseCards";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackDuplicate";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackDiscard";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackLength";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
          return "StackAddN";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackDraw";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackTrash";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(new Data_Symbol.IsSymbol(function () {
          return "StackNth";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackCostOf";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackMakeFilterCostUpTo";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
          return "StackMakeFilterAnd";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
          return "StackBind";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Pile.showPile))(new Data_Symbol.IsSymbol(function () {
          return "StackGainTo";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "cardName";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Var.showVar(Domination_Data_Filter.showFilter)))(Domination_Data_Var.showVar(Data_Show.showString)))))(new Data_Symbol.IsSymbol(function () {
          return "StackChooseCardFromSupply";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showStackValue))(new Data_Symbol.IsSymbol(function () {
          return "StackEquals";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showStackValue))(new Data_Symbol.IsSymbol(function () {
          return "StackPush";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "condition";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "following";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "otherwise";
      }))(Data_Show.showRecordFieldsNil)(Data_Show.showArray(showStackExpression)))(Data_Show.showArray(showStackExpression)))(Data_Show.showArray(showStackExpression)))))(new Data_Symbol.IsSymbol(function () {
          return "StackIf";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Bonus.showBonus))(new Data_Symbol.IsSymbol(function () {
          return "StackGainBonus";
      })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Var.showVar(Data_Show.showBoolean)))(new Data_Symbol.IsSymbol(function () {
          return "StackOption";
      })))))))))))))))))))))(a);
  });
  var eqStackValue = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof StackArrayInt && y instanceof StackArrayInt) {
              return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqInt))(x.value0)(y.value0);
          };
          if (x instanceof StackInt && y instanceof StackInt) {
              return x.value0 === y.value0;
          };
          if (x instanceof StackString && y instanceof StackString) {
              return x.value0 === y.value0;
          };
          if (x instanceof StackFilter && y instanceof StackFilter) {
              return Data_Eq.eq(Domination_Data_Filter.eqFilter)(x.value0)(y.value0);
          };
          if (x instanceof StackBool && y instanceof StackBool) {
              return x.value0 === y.value0;
          };
          return false;
      };
  });
  var eqStackExpression = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof StackChooseCards && y instanceof StackChooseCards) {
              return Data_Eq.eq(Domination_Data_Var.eqVar(Data_Eq.eqArray(Data_Eq.eqInt)))(x.value0.cards)(y.value0.cards) && Data_Eq.eq(Domination_Data_Var.eqVar(Domination_Data_Filter.eqFilter))(x.value0.filter)(y.value0.filter) && Data_Eq.eq(Domination_Data_Var.eqVar(Domination_Data_Pile.eqPile))(x.value0.from)(y.value0.from) && Data_Eq.eq(Domination_Data_Var.eqVar(Domination_Data_Constraint.eqConstraint))(x.value0.n)(y.value0.n);
          };
          if (x instanceof StackDuplicate && y instanceof StackDuplicate) {
              return true;
          };
          if (x instanceof StackDiscard && y instanceof StackDiscard) {
              return true;
          };
          if (x instanceof StackLength && y instanceof StackLength) {
              return true;
          };
          if (x instanceof StackAddN && y instanceof StackAddN) {
              return x.value0 === y.value0;
          };
          if (x instanceof StackDraw && y instanceof StackDraw) {
              return true;
          };
          if (x instanceof StackTrash && y instanceof StackTrash) {
              return true;
          };
          if (x instanceof StackNth && y instanceof StackNth) {
              return x.value0 === y.value0;
          };
          if (x instanceof StackCostOf && y instanceof StackCostOf) {
              return true;
          };
          if (x instanceof StackMakeFilterCostUpTo && y instanceof StackMakeFilterCostUpTo) {
              return true;
          };
          if (x instanceof StackMakeFilterAnd && y instanceof StackMakeFilterAnd) {
              return true;
          };
          if (x instanceof StackBind && y instanceof StackBind) {
              return x.value0 === y.value0;
          };
          if (x instanceof StackGainTo && y instanceof StackGainTo) {
              return Data_Eq.eq(Domination_Data_Pile.eqPile)(x.value0)(y.value0);
          };
          if (x instanceof StackChooseCardFromSupply && y instanceof StackChooseCardFromSupply) {
              return Data_Eq.eq(Domination_Data_Var.eqVar(Data_Eq.eqString))(x.value0.cardName)(y.value0.cardName) && Data_Eq.eq(Domination_Data_Var.eqVar(Domination_Data_Filter.eqFilter))(x.value0.filter)(y.value0.filter);
          };
          if (x instanceof StackEquals && y instanceof StackEquals) {
              return Data_Eq.eq(eqStackValue)(x.value0)(y.value0);
          };
          if (x instanceof StackPush && y instanceof StackPush) {
              return Data_Eq.eq(eqStackValue)(x.value0)(y.value0);
          };
          if (x instanceof StackIf && y instanceof StackIf) {
              return Data_Eq.eq(Data_Eq.eqArray(eqStackExpression))(x.value0.condition)(y.value0.condition) && Data_Eq.eq(Data_Eq.eqArray(eqStackExpression))(x.value0.following)(y.value0.following) && Data_Eq.eq(Data_Eq.eqArray(eqStackExpression))(x.value0.otherwise)(y.value0.otherwise);
          };
          if (x instanceof StackGainBonus && y instanceof StackGainBonus) {
              return Data_Eq.eq(Domination_Data_Bonus.eqBonus)(x.value0)(y.value0);
          };
          if (x instanceof StackOption && y instanceof StackOption) {
              return Data_Eq.eq(Domination_Data_Var.eqVar(Data_Eq.eqBoolean))(x.value0)(y.value0);
          };
          return false;
      };
  });
  var encodeJsonStackValue = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericStackValue)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackArrayInt";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonInt))))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackInt";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackString";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackFilter";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Filter.encodeJsonFilter)))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackBool";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJBoolean)))))))(a);
  });
  var encodeJsonStackExpression = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericStackExpression)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackChooseCards";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Var.encodeJsonVar(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Var.encodeJsonVar(Domination_Data_Filter.encodeJsonFilter))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Var.encodeJsonVar(Domination_Data_Pile.encodeJsonPile))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Var.encodeJsonVar(Domination_Data_Constraint.encodeJsonConstraint))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "from";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackDuplicate";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackDiscard";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackLength";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackAddN";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackDraw";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackTrash";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackNth";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackCostOf";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackMakeFilterCostUpTo";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackMakeFilterAnd";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackBind";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackGainTo";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Pile.encodeJsonPile)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackChooseCardFromSupply";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Var.encodeJsonVar(Data_Argonaut_Encode_Class.encodeJsonJString))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Var.encodeJsonVar(Domination_Data_Filter.encodeJsonFilter))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cardName";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackEquals";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(encodeJsonStackValue)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackPush";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(encodeJsonStackValue)))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackIf";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonStackExpression))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonStackExpression))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonStackExpression))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "otherwise";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "following";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "condition";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackGainBonus";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Bonus.encodeJsonBonus)))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackOption";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Var.encodeJsonVar(Data_Argonaut_Encode_Class.encodeJsonJBoolean))))))))))))))))))))))(a);
  });
  var decodeJsonStackValue = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericStackValue)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackArrayInt";
      }))(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonInt)))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackInt";
      }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackString";
      }))(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackFilter";
      }))(Domination_Data_Filter.decodeJsonFilter))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackBool";
      }))(Data_Argonaut_Decode_Class.decodeJsonBoolean))))))(a);
  });
  var decodeJsonStackExpression = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericStackExpression)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackChooseCards";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Var.decodeJsonVar(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonInt))))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Var.decodeJsonVar(Domination_Data_Filter.decodeJsonFilter)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Var.decodeJsonVar(Domination_Data_Pile.decodeJsonPile)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Var.decodeJsonVar(Domination_Data_Constraint.decodeJsonConstraint)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "from";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackDuplicate";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackDiscard";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackLength";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackAddN";
      }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackDraw";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackTrash";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackNth";
      }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackCostOf";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackMakeFilterCostUpTo";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "StackMakeFilterAnd";
      })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackBind";
      }))(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackGainTo";
      }))(Domination_Data_Pile.decodeJsonPile))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackChooseCardFromSupply";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Var.decodeJsonVar(Data_Argonaut_Decode_Class.decodeJsonString)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Var.decodeJsonVar(Domination_Data_Filter.decodeJsonFilter)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cardName";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackEquals";
      }))(decodeJsonStackValue))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackPush";
      }))(decodeJsonStackValue))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackIf";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(decodeJsonStackExpression)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(decodeJsonStackExpression)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(decodeJsonStackExpression)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "otherwise";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "following";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "condition";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackGainBonus";
      }))(Domination_Data_Bonus.decodeJsonBonus))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackOption";
      }))(Domination_Data_Var.decodeJsonVar(Data_Argonaut_Decode_Class.decodeJsonBoolean)))))))))))))))))))))(a);
  });
  exports["StackChooseCards"] = StackChooseCards;
  exports["StackDuplicate"] = StackDuplicate;
  exports["StackDiscard"] = StackDiscard;
  exports["StackLength"] = StackLength;
  exports["StackAddN"] = StackAddN;
  exports["StackDraw"] = StackDraw;
  exports["StackTrash"] = StackTrash;
  exports["StackNth"] = StackNth;
  exports["StackCostOf"] = StackCostOf;
  exports["StackMakeFilterCostUpTo"] = StackMakeFilterCostUpTo;
  exports["StackMakeFilterAnd"] = StackMakeFilterAnd;
  exports["StackBind"] = StackBind;
  exports["StackGainTo"] = StackGainTo;
  exports["StackChooseCardFromSupply"] = StackChooseCardFromSupply;
  exports["StackEquals"] = StackEquals;
  exports["StackPush"] = StackPush;
  exports["StackIf"] = StackIf;
  exports["StackGainBonus"] = StackGainBonus;
  exports["StackOption"] = StackOption;
  exports["StackArrayInt"] = StackArrayInt;
  exports["StackInt"] = StackInt;
  exports["StackString"] = StackString;
  exports["StackFilter"] = StackFilter;
  exports["StackBool"] = StackBool;
  exports["eqStackExpression"] = eqStackExpression;
  exports["showStackExpression"] = showStackExpression;
  exports["encodeJsonStackExpression"] = encodeJsonStackExpression;
  exports["decodeJsonStackExpression"] = decodeJsonStackExpression;
  exports["eqStackValue"] = eqStackValue;
  exports["showStackValue"] = showStackValue;
  exports["encodeJsonStackValue"] = encodeJsonStackValue;
  exports["decodeJsonStackValue"] = decodeJsonStackValue;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Choice"] = $PS["Domination.Data.Choice"] || {};
  var exports = $PS["Domination.Data.Choice"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Unit = $PS["Data.Unit"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Condition = $PS["Domination.Data.Condition"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_SelectCards = $PS["Domination.Data.SelectCards"];
  var Domination_Data_StackEvaluation = $PS["Domination.Data.StackEvaluation"];                
  var If = (function () {
      function If(value0) {
          this.value0 = value0;
      };
      If.create = function (value0) {
          return new If(value0);
      };
      return If;
  })();
  var And = (function () {
      function And(value0) {
          this.value0 = value0;
      };
      And.create = function (value0) {
          return new And(value0);
      };
      return And;
  })();
  var Or = (function () {
      function Or(value0) {
          this.value0 = value0;
      };
      Or.create = function (value0) {
          return new Or(value0);
      };
      return Or;
  })();
  var PickN = (function () {
      function PickN(value0) {
          this.value0 = value0;
      };
      PickN.create = function (value0) {
          return new PickN(value0);
      };
      return PickN;
  })();
  var Option = (function () {
      function Option(value0) {
          this.value0 = value0;
      };
      Option.create = function (value0) {
          return new Option(value0);
      };
      return Option;
  })();
  var MoveFromTo = (function () {
      function MoveFromTo(value0) {
          this.value0 = value0;
      };
      MoveFromTo.create = function (value0) {
          return new MoveFromTo(value0);
      };
      return MoveFromTo;
  })();
  var GainCard = (function () {
      function GainCard(value0) {
          this.value0 = value0;
      };
      GainCard.create = function (value0) {
          return new GainCard(value0);
      };
      return GainCard;
  })();
  var GainCards = (function () {
      function GainCards(value0) {
          this.value0 = value0;
      };
      GainCards.create = function (value0) {
          return new GainCards(value0);
      };
      return GainCards;
  })();
  var GainActions = (function () {
      function GainActions(value0) {
          this.value0 = value0;
      };
      GainActions.create = function (value0) {
          return new GainActions(value0);
      };
      return GainActions;
  })();
  var GainBuys = (function () {
      function GainBuys(value0) {
          this.value0 = value0;
      };
      GainBuys.create = function (value0) {
          return new GainBuys(value0);
      };
      return GainBuys;
  })();
  var Discard = (function () {
      function Discard(value0) {
          this.value0 = value0;
      };
      Discard.create = function (value0) {
          return new Discard(value0);
      };
      return Discard;
  })();
  var Draw = (function () {
      function Draw(value0) {
          this.value0 = value0;
      };
      Draw.create = function (value0) {
          return new Draw(value0);
      };
      return Draw;
  })();
  var GainBonus = (function () {
      function GainBonus(value0) {
          this.value0 = value0;
      };
      GainBonus.create = function (value0) {
          return new GainBonus(value0);
      };
      return GainBonus;
  })();
  var StackChoice = (function () {
      function StackChoice(value0) {
          this.value0 = value0;
      };
      StackChoice.create = function (value0) {
          return new StackChoice(value0);
      };
      return StackChoice;
  })();
  var isAttack = function (v) {
      if (v instanceof If) {
          return v.value0.attack;
      };
      if (v instanceof And) {
          return v.value0.attack;
      };
      if (v instanceof Or) {
          return v.value0.attack;
      };
      if (v instanceof PickN) {
          return v.value0.attack;
      };
      if (v instanceof Option) {
          return v.value0.attack;
      };
      if (v instanceof MoveFromTo) {
          return v.value0.attack;
      };
      if (v instanceof GainCards) {
          return v.value0.attack;
      };
      if (v instanceof GainCard) {
          return v.value0.attack;
      };
      if (v instanceof GainActions) {
          return v.value0.attack;
      };
      if (v instanceof GainBuys) {
          return v.value0.attack;
      };
      if (v instanceof Discard) {
          return v.value0.attack;
      };
      if (v instanceof Draw) {
          return v.value0.attack;
      };
      if (v instanceof GainBonus) {
          return v.value0.attack;
      };
      if (v instanceof StackChoice) {
          return v.value0.attack;
      };
      throw new Error("Failed pattern match at Domination.Data.Choice (line 115, column 12 - line 129, column 35): " + [ v.constructor.name ]);
  };
  var genericChoice = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof If) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof And) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof Or) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof PickN) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof Option) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof MoveFromTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
      };
      if (x instanceof GainCard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
      };
      if (x instanceof GainCards) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
      };
      if (x instanceof GainActions) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
      };
      if (x instanceof GainBuys) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
      };
      if (x instanceof Discard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))));
      };
      if (x instanceof Draw) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))));
      };
      if (x instanceof GainBonus) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))));
      };
      if (x instanceof StackChoice) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))))))))));
      };
      throw new Error("Failed pattern match at Domination.Data.Choice (line 131, column 1 - line 131, column 50): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new If(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new And(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new Or(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new PickN(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new Option(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return new MoveFromTo(x.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
          return new GainCard(x.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
          return new GainCards(x.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
          return new GainActions(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
          return new GainBuys(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
          return new Discard(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
          return new Draw(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
          return new GainBonus(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))) {
          return new StackChoice(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Choice (line 131, column 1 - line 131, column 50): " + [ x.constructor.name ]);
  });
  var showChoice = new Data_Show.Show(function (choice) {
      return Data_Show_Generic.genericShow(genericChoice)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "choice";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "condition";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "otherwise";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Data_Maybe.showMaybe(showChoice)))(Domination_Data_Condition.showCondition))(showChoice))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "If";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Data_Show.showArray(showChoice)))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "And";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(showChoice)))(Data_Show.showArray(showChoice)))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "Or";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Show.showArray(showChoice))))(Data_Show.showInt))(Data_Show.showArray(showChoice)))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "PickN";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "choice";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Show.showBoolean)))(showChoice))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "Option";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "source";
      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Pile.showPile))(Data_Maybe.showMaybe(Data_Show.showArray(Data_Show.showInt))))(Domination_Data_Constraint.showConstraint))(Domination_Data_Filter.showFilter))(Domination_Data_Pile.showPile))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "MoveFromTo";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Show.showString)))(Domination_Data_Filter.showFilter))(Domination_Data_Pile.showPile))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "GainCard";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "cardName";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Data_Show.showInt))(Domination_Data_Pile.showPile))(Data_Show.showString))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "GainCards";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Domination_Data_Actions.showActions))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "GainActions";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Domination_Data_Buys.showBuys))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "GainBuys";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "selection";
      }))(Data_Show.showRecordFieldsNil)(Domination_Data_SelectCards.showSelectCards))(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "Discard";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Data_Show.showInt))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "Draw";
      })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "bonus";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Unit.showUnit)))(Domination_Data_Bonus.showBonus))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "GainBonus";
      })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "expression";
      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
          return "stack";
      }))(Data_Show.showRecordFieldsNil)(Data_Show.showArray(Domination_Data_StackEvaluation.showStackValue)))(Data_Show.showArray(Domination_Data_StackEvaluation.showStackExpression)))(Data_Show.showString))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
          return "StackChoice";
      }))))))))))))))))(choice);
  });
  var eqChoice = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof If && y instanceof If) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(eqChoice)(x.value0.choice)(y.value0.choice) && Data_Eq.eq(Domination_Data_Condition.eqCondition)(x.value0.condition)(y.value0.condition) && Data_Eq.eq(Data_Maybe.eqMaybe(eqChoice))(x.value0.otherwise)(y.value0.otherwise) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof And && y instanceof And) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Data_Eq.eqArray(eqChoice))(x.value0.choices)(y.value0.choices) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof Or && y instanceof Or) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Data_Eq.eqArray(eqChoice))(x.value0.choices)(y.value0.choices) && Data_Eq.eq(Data_Maybe.eqMaybe(eqChoice))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof PickN && y instanceof PickN) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Data_Eq.eqArray(eqChoice))(x.value0.choices)(y.value0.choices) && x.value0.n === y.value0.n && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqArray(eqChoice)))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof Option && y instanceof Option) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(eqChoice)(x.value0.choice)(y.value0.choice) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof MoveFromTo && y instanceof MoveFromTo) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Domination_Data_Pile.eqPile)(x.value0.destination)(y.value0.destination) && Data_Eq.eq(Domination_Data_Filter.eqFilter)(x.value0.filter)(y.value0.filter) && Data_Eq.eq(Domination_Data_Constraint.eqConstraint)(x.value0.n)(y.value0.n) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqArray(Data_Eq.eqInt)))(x.value0.resolution)(y.value0.resolution) && Data_Eq.eq(Domination_Data_Pile.eqPile)(x.value0.source)(y.value0.source);
          };
          if (x instanceof GainCard && y instanceof GainCard) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Domination_Data_Pile.eqPile)(x.value0.destination)(y.value0.destination) && Data_Eq.eq(Domination_Data_Filter.eqFilter)(x.value0.filter)(y.value0.filter) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof GainCards && y instanceof GainCards) {
              return x.value0.attack === y.value0.attack && x.value0.cardName === y.value0.cardName && Data_Eq.eq(Domination_Data_Pile.eqPile)(x.value0.destination)(y.value0.destination) && x.value0.n === y.value0.n && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof GainActions && y instanceof GainActions) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Domination_Data_Actions.eqActions)(x.value0.n)(y.value0.n) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof GainBuys && y instanceof GainBuys) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Domination_Data_Buys.eqBuys)(x.value0.n)(y.value0.n) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof Discard && y instanceof Discard) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution) && Data_Eq.eq(Domination_Data_SelectCards.eqSelectCards)(x.value0.selection)(y.value0.selection);
          };
          if (x instanceof Draw && y instanceof Draw) {
              return x.value0.attack === y.value0.attack && x.value0.n === y.value0.n && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof GainBonus && y instanceof GainBonus) {
              return x.value0.attack === y.value0.attack && Data_Eq.eq(Domination_Data_Bonus.eqBonus)(x.value0.bonus)(y.value0.bonus) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqUnit))(x.value0.resolution)(y.value0.resolution);
          };
          if (x instanceof StackChoice && y instanceof StackChoice) {
              return x.value0.attack === y.value0.attack && x.value0.description === y.value0.description && Data_Eq.eq(Data_Eq.eqArray(Domination_Data_StackEvaluation.eqStackExpression))(x.value0.expression)(y.value0.expression) && Data_Eq.eq(Data_Eq.eqArray(Domination_Data_StackEvaluation.eqStackValue))(x.value0.stack)(y.value0.stack);
          };
          return false;
      };
  });
  var encodeJsonChoice = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericChoice)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "If";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonChoice)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Condition.encodeJsonCondition)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "otherwise";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "condition";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "choice";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "And";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Or";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "PickN";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonChoice)))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Option";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonChoice)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJBoolean))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "choice";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "MoveFromTo";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Pile.encodeJsonPile)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Filter.encodeJsonFilter)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Constraint.encodeJsonConstraint)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Pile.encodeJsonPile)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "source";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "GainCard";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Pile.encodeJsonPile)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Filter.encodeJsonFilter)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "GainCards";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Pile.encodeJsonPile)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cardName";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "GainActions";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "GainBuys";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Discard";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_SelectCards.encodeJsonSelectCards)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "selection";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Draw";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "GainBonus";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Bonus.encodeJsonBonus)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonUnit))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "bonus";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "StackChoice";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_StackEvaluation.encodeJsonStackExpression))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_StackEvaluation.encodeJsonStackValue))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "stack";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "expression";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))())()))))))))))))))))(a);
  });
  var decodeJsonChoice = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericChoice)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "If";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonChoice))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Condition.decodeJsonCondition))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(decodeJsonChoice))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "otherwise";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "condition";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "choice";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "And";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Or";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(decodeJsonChoice))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "PickN";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeArray(decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Option";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonChoice))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "choice";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "MoveFromTo";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Pile.decodeJsonPile))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Filter.decodeJsonFilter))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Constraint.decodeJsonConstraint))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonInt)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Pile.decodeJsonPile))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "source";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "GainCard";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Pile.decodeJsonPile))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Filter.decodeJsonFilter))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "filter";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "GainCards";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Pile.decodeJsonPile))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "destination";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cardName";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "GainActions";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "GainBuys";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Discard";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_SelectCards.decodeJsonSelectCards))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "selection";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Draw";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "n";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "GainBonus";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Bonus.decodeJsonBonus))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonNull))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "resolution";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "bonus";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "StackChoice";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_StackEvaluation.decodeJsonStackExpression)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_StackEvaluation.decodeJsonStackValue)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "stack";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "expression";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "attack";
      }))()())())))))))))))))))(a);
  });
  exports["If"] = If;
  exports["And"] = And;
  exports["Or"] = Or;
  exports["PickN"] = PickN;
  exports["Option"] = Option;
  exports["MoveFromTo"] = MoveFromTo;
  exports["GainCard"] = GainCard;
  exports["GainCards"] = GainCards;
  exports["GainActions"] = GainActions;
  exports["GainBuys"] = GainBuys;
  exports["Discard"] = Discard;
  exports["Draw"] = Draw;
  exports["GainBonus"] = GainBonus;
  exports["StackChoice"] = StackChoice;
  exports["isAttack"] = isAttack;
  exports["eqChoice"] = eqChoice;
  exports["showChoice"] = showChoice;
  exports["encodeJsonChoice"] = encodeJsonChoice;
  exports["decodeJsonChoice"] = decodeJsonChoice;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Points"] = $PS["Domination.Data.Points"] || {};
  var exports = $PS["Domination.Data.Points"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Internal_Re = $PS["Data.Lens.Internal.Re"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Iso_Newtype = $PS["Data.Lens.Iso.Newtype"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var semiringPoints = Domination_Data_Wire_Int.ringWireInt;
  var ringPoints = Domination_Data_Wire_Int.semiringWireInt;
  var ordPoints = Domination_Data_Wire_Int.ordWireInt;
  var genericPoints = new Data_Generic_Rep.Generic(function (x) {
      return x;
  }, function (x) {
      return x;
  });
  var showPoints = new Data_Show.Show(Data_Show_Generic.genericShow(genericPoints)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Wire_Int.showWireInt))(new Data_Symbol.IsSymbol(function () {
      return "Points";
  }))));
  var eqPoints = Domination_Data_Wire_Int.eqWireInt;
  var encodeJsonPoints = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericPoints)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Points";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Wire_Int.encodeJsonWireInt))));
  var decodeJsonPoints = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericPoints)(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "Points";
  }))(Domination_Data_Wire_Int.decodeJsonWireInt)));                              
  var _int = function (dictProfunctor) {
      var $5 = Data_Lens_Iso_Newtype["_Newtype"]()()(dictProfunctor);
      var $6 = Data_Lens_Iso.re(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Re.profunctorRe(dictProfunctor)));
      return function ($7) {
          return $5($6($7));
      };
  };
  var points = Data_Lens_Prism.review(_int(Data_Lens_Internal_Tagged.taggedProfunctor));
  exports["points"] = points;
  exports["_int"] = _int;
  exports["eqPoints"] = eqPoints;
  exports["ordPoints"] = ordPoints;
  exports["ringPoints"] = ringPoints;
  exports["semiringPoints"] = semiringPoints;
  exports["showPoints"] = showPoints;
  exports["encodeJsonPoints"] = encodeJsonPoints;
  exports["decodeJsonPoints"] = decodeJsonPoints;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Reaction"] = $PS["Domination.Data.Reaction"] || {};
  var exports = $PS["Domination.Data.Reaction"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var BlockAttack = (function () {
      function BlockAttack() {

      };
      BlockAttack.value = new BlockAttack();
      return BlockAttack;
  })();
  var genericReaction = new Data_Generic_Rep.Generic(function (x) {
      return Data_Generic_Rep.NoArguments.value;
  }, function (x) {
      return BlockAttack.value;
  });
  var showReaction = new Data_Show.Show(Data_Show_Generic.genericShow(genericReaction)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "BlockAttack";
  }))));
  var eqReaction = new Data_Eq.Eq(function (x) {
      return function (y) {
          return true;
      };
  });
  var encodeJsonReaction = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericReaction)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "BlockAttack";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(a);
  });
  var encodeArrayBufferReaction = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericReaction)(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments)));
  var dynamicByteLengthReaction = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericReaction)(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)));
  var decodeJsonReaction = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericReaction)(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
          return "BlockAttack";
      })))(a);
  });
  var decodeArrayBufferReaction = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericReaction)(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments)));
  exports["BlockAttack"] = BlockAttack;
  exports["eqReaction"] = eqReaction;
  exports["showReaction"] = showReaction;
  exports["encodeJsonReaction"] = encodeJsonReaction;
  exports["decodeJsonReaction"] = decodeJsonReaction;
  exports["dynamicByteLengthReaction"] = dynamicByteLengthReaction;
  exports["encodeArrayBufferReaction"] = encodeArrayBufferReaction;
  exports["decodeArrayBufferReaction"] = decodeArrayBufferReaction;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Target"] = $PS["Domination.Data.Target"] || {};
  var exports = $PS["Domination.Data.Target"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var Self = (function () {
      function Self() {

      };
      Self.value = new Self();
      return Self;
  })();
  var Everyone = (function () {
      function Everyone() {

      };
      Everyone.value = new Everyone();
      return Everyone;
  })();
  var EveryoneElse = (function () {
      function EveryoneElse() {

      };
      EveryoneElse.value = new EveryoneElse();
      return EveryoneElse;
  })();
  var genericTarget = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof Self) {
          return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
      };
      if (x instanceof Everyone) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
      };
      if (x instanceof EveryoneElse) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
      };
      throw new Error("Failed pattern match at Domination.Data.Target (line 25, column 1 - line 25, column 50): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return Self.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return Everyone.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
          return EveryoneElse.value;
      };
      throw new Error("Failed pattern match at Domination.Data.Target (line 25, column 1 - line 25, column 50): " + [ x.constructor.name ]);
  });
  var showTarget = new Data_Show.Show(Data_Show_Generic.genericShow(genericTarget)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Self";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "Everyone";
  })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "EveryoneElse";
  }))))));
  var eqTarget = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof Self && y instanceof Self) {
              return true;
          };
          if (x instanceof Everyone && y instanceof Everyone) {
              return true;
          };
          if (x instanceof EveryoneElse && y instanceof EveryoneElse) {
              return true;
          };
          return false;
      };
  });
  var encodeJsonTarget = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericTarget)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Self";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Everyone";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "EveryoneElse";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)))));
  var decodeJsonTarget = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericTarget)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Self";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "Everyone";
  })))(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "EveryoneElse";
  }))))));
  exports["Self"] = Self;
  exports["Everyone"] = Everyone;
  exports["EveryoneElse"] = EveryoneElse;
  exports["eqTarget"] = eqTarget;
  exports["showTarget"] = showTarget;
  exports["encodeJsonTarget"] = encodeJsonTarget;
  exports["decodeJsonTarget"] = decodeJsonTarget;
})(PS);
(function(exports) {
  "use strict";

  exports._jsonParser = function (fail, succ, s) {
    try {
      return succ(JSON.parse(s));
    }
    catch (e) {
      return fail(e.message);
    }
  };
})(PS["Data.Argonaut.Parser"] = PS["Data.Argonaut.Parser"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Argonaut.Parser"] = $PS["Data.Argonaut.Parser"] || {};
  var exports = $PS["Data.Argonaut.Parser"];
  var $foreign = $PS["Data.Argonaut.Parser"];
  var Data_Either = $PS["Data.Either"];                
  var jsonParser = function (j) {
      return $foreign["_jsonParser"](Data_Either.Left.create, Data_Either.Right.create, j);
  };
  exports["jsonParser"] = jsonParser;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Traversal"] = $PS["Data.Lens.Traversal"] || {};
  var exports = $PS["Data.Lens.Traversal"];
  var Data_Lens_Internal_Wander = $PS["Data.Lens.Internal.Wander"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Profunctor_Star = $PS["Data.Profunctor.Star"];
  var Data_Traversable = $PS["Data.Traversable"];    
  var traversed = function (dictTraversable) {
      return function (dictWander) {
          return Data_Lens_Internal_Wander.wander(dictWander)(function (dictApplicative) {
              return Data_Traversable.traverse(dictTraversable)(dictApplicative);
          });
      };
  };
  var traverseOf = Data_Newtype.under()()(Data_Profunctor_Star.Star);
  exports["traversed"] = traversed;
  exports["traverseOf"] = traverseOf;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Util"] = $PS["Util"] || {};
  var exports = $PS["Util"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Error = $PS["Data.Argonaut.Decode.Error"];
  var Data_Argonaut_Parser = $PS["Data.Argonaut.Parser"];
  var Data_Array = $PS["Data.Array"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Either = $PS["Data.Either"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Lens_Traversal = $PS["Data.Lens.Traversal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Star = $PS["Data.Profunctor.Star"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_Tuple = $PS["Data.Tuple"];
  var withIndices = function (dictFunctorWithIndex) {
      return Data_FunctorWithIndex.mapWithIndex(dictFunctorWithIndex)(Data_Tuple.Tuple.create);
  };
  var reviewOn = Data_Function.flip(Data_Lens_Prism.review);
  var readJson = function (dictDecodeJson) {
      return Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
          var $51 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Show.show(Data_Argonaut_Decode_Error.showJsonDecodeError));
          var $52 = Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson);
          return function ($53) {
              return $51($52($53));
          };
      })())(Data_Argonaut_Parser.jsonParser);
  };
  var pushOver = function (lens) {
      return function (x) {
          return Data_Lens_Setter.over(lens(Data_Profunctor_Strong.strongFn))(function (v) {
              return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ x ]);
          });
      };
  };
  var prependOver = function (lens) {
      return function (x) {
          return Data_Lens_Setter.over(lens(Data_Profunctor_Strong.strongFn))(function (v) {
              return Data_Array.cons(x)(v);
          });
      };
  };
  var nthOf = function (i) {
      return function (lens) {
          var $54 = Data_Lens_Getter.view(lens(Data_Lens_Internal_Forget.strongForget));
          return function ($55) {
              return (function (v) {
                  return Data_Array.index(v)(i);
              })($54($55));
          };
      };
  };
  var moveAll = function (lens1) {
      return function (lens2) {
          return function (s) {
              var from = Data_Lens_Getter.view(lens1(Data_Lens_Internal_Forget.strongForget))(s);
              var s$prime = Data_Lens_Setter.over(lens2(Data_Profunctor_Strong.strongFn))(function (v) {
                  return Data_Semigroup.append(Data_Semigroup.semigroupArray)(from)(v);
              })(s);
              return Data_Lens_Setter.set(lens1(Data_Profunctor_Strong.strongFn))([  ])(s$prime);
          };
      };
  };
  var mapOver = function (dictFunctor) {
      return function (lens) {
          return function (f) {
              return Data_Lens_Setter.over(lens(Data_Profunctor_Strong.strongFn))(Data_Functor.map(dictFunctor)(f));
          };
      };
  };
  var mapLeft = function (v) {
      return function (v1) {
          if (v1 instanceof Data_Either.Left) {
              return new Data_Either.Left(v(v1.value0));
          };
          if (v1 instanceof Data_Either.Right) {
              return new Data_Either.Right(v1.value0);
          };
          throw new Error("Failed pattern match at Util (line 225, column 1 - line 225, column 62): " + [ v.constructor.name, v1.constructor.name ]);
      };
  };
  var justIf = function (f) {
      return function (x) {
          var $39 = f(x);
          if ($39) {
              return new Data_Maybe.Just(x);
          };
          return Data_Maybe.Nothing.value;
      };
  };
  var indices = function (dictFunctorWithIndex) {
      return function (xs) {
          return Data_Functor.map(dictFunctorWithIndex.Functor0())(Data_Tuple.fst)(Data_FunctorWithIndex.mapWithIndex(dictFunctorWithIndex)(Data_Tuple.Tuple.create)(xs));
      };
  };
  var fromJust = function (dictMonadError) {
      return function (e) {
          return function (v) {
              if (v instanceof Data_Maybe.Nothing) {
                  return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())(e);
              };
              if (v instanceof Data_Maybe.Just) {
                  return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(v.value0);
              };
              throw new Error("Failed pattern match at Util (line 103, column 14 - line 105, column 19): " + [ v.constructor.name ]);
          };
      };
  };
  var takeIndices = function (dictMonadError) {
      return function (is) {
          return function (xs) {
              return fromJust(dictMonadError)("failed to drop indices")((function () {
                  var $42 = Data_Array.length(is) > Data_Array.length(xs) || (Data_Array.length(Data_Array.nub(Data_Ord.ordInt)(is)) !== Data_Array.length(is) || (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v) {
                      return v < 0;
                  })(is) || Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v) {
                      return v >= Data_Array.length(xs);
                  })(is)));
                  if ($42) {
                      return Data_Maybe.Nothing.value;
                  };
                  return Data_Maybe.Just.create(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Array.filter((function () {
                      var $56 = Data_Function.flip(Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqInt))(is);
                      return function ($57) {
                          return $56(Data_Tuple.fst($57));
                      };
                  })())(withIndices(Data_FunctorWithIndex.functorWithIndexArray)(xs))));
              })());
          };
      };
  };
  var firstOf = nthOf(0);
  var dropNthOf = function (n) {
      return function (lens) {
          return Data_Lens_Traversal.traverseOf(lens(Data_Profunctor_Star.strongStar(Data_Maybe.functorMaybe)))(Data_Array.deleteAt(n));
      };
  };
  var dropIndices = function (dictMonadError) {
      return function (is) {
          return function (xs) {
              return fromJust(dictMonadError)("failed to drop indices")((function () {
                  var $43 = Data_Array.length(is) > Data_Array.length(xs) || (Data_Array.length(Data_Array.nub(Data_Ord.ordInt)(is)) !== Data_Array.length(is) || (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v) {
                      return v < 0;
                  })(is) || Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v) {
                      return v >= Data_Array.length(xs);
                  })(is)));
                  if ($43) {
                      return Data_Maybe.Nothing.value;
                  };
                  return Data_Maybe.Just.create(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Array.filter((function () {
                      var $58 = Data_Function.flip(Data_Foldable.notElem(Data_Foldable.foldableArray)(Data_Eq.eqInt))(is);
                      return function ($59) {
                          return $58(Data_Tuple.fst($59));
                      };
                  })())(withIndices(Data_FunctorWithIndex.functorWithIndexArray)(xs))));
              })());
          };
      };
  };
  var dropIndex = function (i) {
      return function (xs) {
          return Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Array.take(i)(xs))(Data_Array.drop(i + 1 | 0)(xs));
      };
  };
  var dropFirstOf = dropNthOf(0);
  var moveOne = function (lens1) {
      return function (lens2) {
          return function (s) {
              return Control_Bind.bind(Data_Maybe.bindMaybe)(firstOf(function (dictStrong) {
                  return lens1(dictStrong);
              })(s))(function (x) {
                  var s$prime = pushOver(function (dictStrong) {
                      return lens2(dictStrong);
                  })(x)(s);
                  return dropFirstOf(function (dictStrong) {
                      return lens1(dictStrong);
                  })(s$prime);
              });
          };
      };
  };
  var decOver = function (dictRing) {
      return Data_Function.flip(Data_Lens_Setter.subOver(dictRing))(Data_Semiring.one(dictRing.Semiring0()));
  };
  var assert = function (dictMonadError) {
      return function (p) {
          return function (e) {
              return function (x) {
                  var $45 = p(x);
                  if ($45) {
                      return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(x);
                  };
                  return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())(e);
              };
          };
      };
  };
  exports["dropIndex"] = dropIndex;
  exports["withIndices"] = withIndices;
  exports["dropIndices"] = dropIndices;
  exports["takeIndices"] = takeIndices;
  exports["indices"] = indices;
  exports["justIf"] = justIf;
  exports["assert"] = assert;
  exports["fromJust"] = fromJust;
  exports["reviewOn"] = reviewOn;
  exports["prependOver"] = prependOver;
  exports["mapOver"] = mapOver;
  exports["decOver"] = decOver;
  exports["moveOne"] = moveOne;
  exports["moveAll"] = moveAll;
  exports["readJson"] = readJson;
  exports["mapLeft"] = mapLeft;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Card"] = $PS["Domination.Data.Card"] || {};
  var exports = $PS["Domination.Data.Card"];
  var Control_Category = $PS["Control.Category"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Market = $PS["Data.Lens.Internal.Market"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_List = $PS["Data.List"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Util = $PS["Util"];                
  var Choose = (function () {
      function Choose(value0) {
          this.value0 = value0;
      };
      Choose.create = function (value0) {
          return new Choose(value0);
      };
      return Choose;
  })();
  var IndependentCard = (function () {
      function IndependentCard(value0) {
          this.value0 = value0;
      };
      IndependentCard.create = function (value0) {
          return new IndependentCard(value0);
      };
      return IndependentCard;
  })();
  var CardWithRequirements = (function () {
      function CardWithRequirements(value0) {
          this.value0 = value0;
      };
      CardWithRequirements.create = function (value0) {
          return new CardWithRequirements(value0);
      };
      return CardWithRequirements;
  })();
  var value = (function () {
      var $95 = Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Semiring.add(Data_Semiring.semiringInt))(0);
      var $96 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
          return v.treasure;
      });
      return function ($97) {
          return $95($96($97));
      };
  })();
  var positivePoints = (function () {
      var $98 = Data_Ord.max(Domination_Data_Points.ordPoints)(Data_Semiring.zero(Domination_Data_Points.ringPoints));
      return function ($99) {
          return $98((function (v) {
              return v.victoryPoints;
          })($99));
      };
  })();
  var independentCard = IndependentCard.create;
  var genericCommand = new Data_Generic_Rep.Generic(function (x) {
      return x.value0;
  }, function (x) {
      return new Choose(x);
  });
  var showCommand = new Data_Show.Show(function (x) {
      return Data_Show_Generic.genericShow(genericCommand)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Domination_Data_Choice.showChoice))(new Data_Symbol.IsSymbol(function () {
          return "Choose";
      })))(x);
  });
  var genericCardSpec = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof IndependentCard) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof CardWithRequirements) {
          return new Data_Generic_Rep.Inr(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Card (line 61, column 1 - line 61, column 54): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new IndependentCard(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr) {
          return new CardWithRequirements(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Card (line 61, column 1 - line 61, column 54): " + [ x.constructor.name ]);
  });
  var eqCommand = new Data_Eq.Eq(function (x) {
      return function (y) {
          return Data_Eq.eq(Domination_Data_Choice.eqChoice)(x.value0)(y.value0);
      };
  });
  var eqCardSpec = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof IndependentCard && y instanceof IndependentCard) {
              return Data_Eq.eq(Domination_Data_Actions.eqActions)(x.value0.actions)(y.value0.actions) && Data_Eq.eq(Domination_Data_Buys.eqBuys)(x.value0.buys)(y.value0.buys) && x.value0.cards === y.value0.cards && x.value0.cost === y.value0.cost && x.value0.name === y.value0.name && Data_Eq.eq(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction))(x.value0.reaction)(y.value0.reaction) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                  return "target";
              }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                  return "description";
              }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                  return "command";
              }))(eqCommand))))(x.value0.special)(y.value0.special) && x.value0.treasure === y.value0.treasure && Data_Eq.eq(Data_Eq.eqArray(Domination_Data_CardType.eqCardType))(x.value0.types)(y.value0.types) && Data_Eq.eq(Domination_Data_Points.eqPoints)(x.value0.victoryPoints)(y.value0.victoryPoints);
          };
          if (x instanceof CardWithRequirements && y instanceof CardWithRequirements) {
              return Data_Eq.eq(Domination_Data_Actions.eqActions)(x.value0.card.actions)(y.value0.card.actions) && Data_Eq.eq(Domination_Data_Buys.eqBuys)(x.value0.card.buys)(y.value0.card.buys) && x.value0.card.cards === y.value0.card.cards && x.value0.card.cost === y.value0.card.cost && x.value0.card.name === y.value0.card.name && Data_Eq.eq(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction))(x.value0.card.reaction)(y.value0.card.reaction) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                  return "target";
              }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                  return "description";
              }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                  return "command";
              }))(eqCommand))))(x.value0.card.special)(y.value0.card.special) && x.value0.card.treasure === y.value0.card.treasure && Data_Eq.eq(Data_Eq.eqArray(Domination_Data_CardType.eqCardType))(x.value0.card.types)(y.value0.card.types) && Data_Eq.eq(Domination_Data_Points.eqPoints)(x.value0.card.victoryPoints)(y.value0.card.victoryPoints) && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                  return "victoryPoints";
              }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                  return "types";
              }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                  return "treasure";
              }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                  return "special";
              }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                  return "target";
              }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                  return "description";
              }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                  return "command";
              }))(eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                  return "reaction";
              }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                  return "name";
              }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                  return "cost";
              }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                  return "cards";
              }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                  return "buys";
              }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                  return "actions";
              }))(Domination_Data_Actions.eqActions))))(x.value0.requirements)(y.value0.requirements);
          };
          return false;
      };
  });
  var encodeJsonCommand = new Data_Argonaut_Encode_Class.EncodeJson(function (x) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericCommand)(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Choose";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Domination_Data_Choice.encodeJsonChoice)))(x);
  });
  var encodeJsonCardSpec = new Data_Argonaut_Encode_Class.EncodeJson(function (x) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericCardSpec)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "IndependentCard";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "target";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "command";
      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "victoryPoints";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "types";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "treasure";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "special";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))())())))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "CardWithRequirements";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "target";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "command";
      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "victoryPoints";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "types";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "treasure";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "special";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "target";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "command";
      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "victoryPoints";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "types";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "treasure";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "special";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "requirements";
      }))())(new Data_Symbol.IsSymbol(function () {
          return "card";
      }))())()))))(x);
  });
  var decodeJsonCommand = new Data_Argonaut_Decode_Class.DecodeJson(function (x) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericCommand)(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Choose";
      }))(Domination_Data_Choice.decodeJsonChoice))(x);
  });
  var decodeJsonCardSpec = new Data_Argonaut_Decode_Class.DecodeJson(function (x) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericCardSpec)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "IndependentCard";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "target";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "command";
      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "victoryPoints";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "types";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "treasure";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "special";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))()())()))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "CardWithRequirements";
      }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "target";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "command";
      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "victoryPoints";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "types";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "treasure";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "special";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "target";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "description";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "command";
      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "victoryPoints";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "types";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "treasure";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "special";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "cards";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
          return "requirements";
      }))()())(new Data_Symbol.IsSymbol(function () {
          return "card";
      }))()())())))(x);
  });
  var cost = (function () {
      var $102 = Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Semiring.add(Data_Semiring.semiringInt))(0);
      var $103 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
          return v.cost;
      });
      return function ($104) {
          return $102($103($104));
      };
  })();
  var cardWithRequirements = function (c) {
      return function (specs) {
          var transitiveRequirements = function (v) {
              if (v instanceof Data_List_Types.Nil) {
                  return Data_List_Types.Nil.value;
              };
              if (v instanceof Data_List_Types.Cons && v.value0 instanceof IndependentCard) {
                  return Data_List_Types.Cons.create(v.value0.value0)(transitiveRequirements(v.value1));
              };
              if (v instanceof Data_List_Types.Cons && v.value0 instanceof CardWithRequirements) {
                  var l2 = transitiveRequirements(v.value1);
                  var l1 = new Data_List_Types.Cons(v.value0.value0.card, Data_Array.toUnfoldable(Data_List_Types.unfoldableList)(v.value0.value0.requirements));
                  return Data_List.concat(Data_List_Types.Cons.create(l1)(new Data_List_Types.Cons(l2, Data_List_Types.Nil.value)));
              };
              throw new Error("Failed pattern match at Domination.Data.Card (line 92, column 5 - line 92, column 57): " + [ v.constructor.name ]);
          };
          var specList = Data_Array.toUnfoldable(Data_List_Types.unfoldableList)(specs);
          var newRequirements = Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray)(transitiveRequirements(specList));
          return new CardWithRequirements({
              card: c,
              requirements: newRequirements
          });
      };
  };
  var card = {
      types: [  ],
      name: "",
      cost: 0,
      victoryPoints: Data_Semiring.zero(Domination_Data_Points.ringPoints),
      treasure: 0,
      buys: Data_Semiring.zero(Domination_Data_Buys.ringBuys),
      cards: 0,
      actions: Data_Semiring.zero(Domination_Data_Actions.ringActions),
      special: Data_Maybe.Nothing.value,
      reaction: Data_Maybe.Nothing.value
  };
  var reaction = {
      types: [ Domination_Data_CardType.Reaction.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var treasure = {
      types: [ Domination_Data_CardType.Treasure.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var victory = {
      types: [ Domination_Data_CardType.Victory.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var actionVictory = {
      types: [ Domination_Data_CardType.Action.value, Domination_Data_CardType.Victory.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var actionReaction = {
      types: [ Domination_Data_CardType.Action.value, Domination_Data_CardType.Reaction.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var actionAttack = {
      types: [ Domination_Data_CardType.Action.value, Domination_Data_CardType.Attack.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var action = {
      types: [ Domination_Data_CardType.Action.value ],
      name: card.name,
      cost: card.cost,
      victoryPoints: card.victoryPoints,
      treasure: card.treasure,
      buys: card.buys,
      cards: card.cards,
      actions: card.actions,
      special: card.special,
      reaction: card.reaction
  };
  var _requirements = function (v) {
      if (v instanceof IndependentCard) {
          return [  ];
      };
      if (v instanceof CardWithRequirements) {
          return v.value0.requirements;
      };
      throw new Error("Failed pattern match at Domination.Data.Card (line 75, column 1 - line 75, column 40): " + [ v.constructor.name ]);
  };
  var _ofType = function (cardType) {
      return function (dictChoice) {
          return Data_Lens_Prism["prism'"](Control_Category.identity(Control_Category.categoryFn))(Util.justIf((function () {
              var $111 = Data_Foldable.elem(Data_Foldable.foldableArray)(Domination_Data_CardType.eqCardType)(cardType);
              return function ($112) {
                  return $111((function (v) {
                      return v.types;
                  })($112));
              };
          })()))(dictChoice);
      };
  };
  var hasType = function (t) {
      return Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(_ofType(t)(Data_Lens_Internal_Market.choiceMarket));
  };
  var isAction = hasType(Domination_Data_CardType.Action.value);    
  var isTreasure = hasType(Domination_Data_CardType.Treasure.value);
  var _name = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "name";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _cost = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "cost";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var passFilter = function (v) {
      if (v instanceof Domination_Data_Filter.HasName) {
          return function ($113) {
              return (function (v1) {
                  return v1 === v.value0;
              })((function (v1) {
                  return v1.name;
              })($113));
          };
      };
      if (v instanceof Domination_Data_Filter.HasType) {
          return hasType(v.value0);
      };
      if (v instanceof Domination_Data_Filter.CostUpTo) {
          var $114 = Data_Lens_Getter.view(_cost(Data_Lens_Internal_Forget.strongForget));
          return function ($115) {
              return (function (v1) {
                  return v1 <= v.value0;
              })($114($115));
          };
      };
      if (v instanceof Domination_Data_Filter.Any) {
          return Data_Function["const"](true);
      };
      if (v instanceof Domination_Data_Filter.And) {
          return Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(passFilter(v.value0))(passFilter(v.value1));
      };
      throw new Error("Failed pattern match at Domination.Data.Card (line 223, column 14 - line 228, column 53): " + [ v.constructor.name ]);
  };
  var _card = function (v) {
      if (v instanceof IndependentCard) {
          return v.value0;
      };
      if (v instanceof CardWithRequirements) {
          return v.value0.card;
      };
      throw new Error("Failed pattern match at Domination.Data.Card (line 71, column 1 - line 71, column 26): " + [ v.constructor.name ]);
  };
  exports["IndependentCard"] = IndependentCard;
  exports["CardWithRequirements"] = CardWithRequirements;
  exports["_card"] = _card;
  exports["_requirements"] = _requirements;
  exports["independentCard"] = independentCard;
  exports["cardWithRequirements"] = cardWithRequirements;
  exports["_name"] = _name;
  exports["hasType"] = hasType;
  exports["isAction"] = isAction;
  exports["isTreasure"] = isTreasure;
  exports["value"] = value;
  exports["cost"] = cost;
  exports["card"] = card;
  exports["treasure"] = treasure;
  exports["victory"] = victory;
  exports["action"] = action;
  exports["actionAttack"] = actionAttack;
  exports["actionVictory"] = actionVictory;
  exports["actionReaction"] = actionReaction;
  exports["Choose"] = Choose;
  exports["positivePoints"] = positivePoints;
  exports["passFilter"] = passFilter;
  exports["eqCardSpec"] = eqCardSpec;
  exports["encodeJsonCardSpec"] = encodeJsonCardSpec;
  exports["decodeJsonCardSpec"] = decodeJsonCardSpec;
  exports["eqCommand"] = eqCommand;
  exports["showCommand"] = showCommand;
  exports["encodeJsonCommand"] = encodeJsonCommand;
  exports["decodeJsonCommand"] = decodeJsonCommand;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Cards"] = $PS["Domination.Data.Cards"] || {};
  var exports = $PS["Domination.Data.Cards"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ring = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Condition = $PS["Domination.Data.Condition"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_SelectCards = $PS["Domination.Data.SelectCards"];
  var Domination_Data_StackEvaluation = $PS["Domination.Data.StackEvaluation"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Data_Var = $PS["Domination.Data.Var"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];                
  var workersVillage = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Worker's Village",
      cost: 4,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      cards: 1,
      actions: Domination_Data_Actions.actions(2),
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var woodCutter = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Wood Cutter",
      cost: 3,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: 2,
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var village = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Village",
      cost: 3,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: 1,
      actions: Domination_Data_Actions.actions(2),
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var smithy = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Smithy",
      cost: 4,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: 3,
      actions: Domination_Data_Card.action.actions,
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var silver = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.treasure.types,
      name: "Silver",
      cost: 3,
      victoryPoints: Domination_Data_Card.treasure.victoryPoints,
      treasure: 2,
      buys: Domination_Data_Card.treasure.buys,
      cards: Domination_Data_Card.treasure.cards,
      actions: Domination_Data_Card.treasure.actions,
      special: Domination_Data_Card.treasure.special,
      reaction: Domination_Data_Card.treasure.reaction
  });
  var tradingPost = (function () {
      var rs = [ silver ];
      var description = "Trash 2 cards from your hand." + " If you did, gain a Silver to your hand.";
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Trading Post",
          cost: 5,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.StackChoice({
                  expression: [ new Domination_Data_StackEvaluation.StackChooseCards({
                      cards: Domination_Data_Var.Unbound.value,
                      filter: new Domination_Data_Var.Bound(Domination_Data_Filter.Any.value),
                      from: new Domination_Data_Var.Bound(Domination_Data_Pile.Hand.value),
                      n: Domination_Data_Var.Bound.create(new Domination_Data_Constraint.Exactly(2))
                  }), Domination_Data_StackEvaluation.StackDuplicate.value, Domination_Data_StackEvaluation.StackTrash.value, Domination_Data_StackEvaluation.StackLength.value, new Domination_Data_StackEvaluation.StackIf({
                      condition: [ Domination_Data_StackEvaluation.StackEquals.create(new Domination_Data_StackEvaluation.StackInt(2)) ],
                      following: [ Domination_Data_StackEvaluation.StackPush.create(new Domination_Data_StackEvaluation.StackString((function (v1) {
                          return v1.name;
                      })(Domination_Data_Card["_card"](silver)))), new Domination_Data_StackEvaluation.StackGainTo(Domination_Data_Pile.Hand.value) ],
                      otherwise: [  ]
                  }) ],
                  stack: [  ],
                  attack: false,
                  description: description
              })),
              description: description
          }),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var resolution = Data_Maybe.Nothing.value;
  var spiceMerchant = (function () {
      var description = "You may trash a Treasure from your hand to choose one:" + " +2 Cards and +1 Action; or +1 Buy and +$2";
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Spice Merchant",
          cost: 4,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.Option({
                  choice: new Domination_Data_Choice.If({
                      condition: new Domination_Data_Condition.HasCardType(Domination_Data_CardType.Treasure.value),
                      otherwise: Data_Maybe.Nothing.value,
                      choice: new Domination_Data_Choice.And({
                          choices: [ new Domination_Data_Choice.MoveFromTo({
                              n: new Domination_Data_Constraint.Exactly(1),
                              filter: new Domination_Data_Filter.HasType(Domination_Data_CardType.Treasure.value),
                              source: Domination_Data_Pile.Hand.value,
                              destination: Domination_Data_Pile.Trash.value,
                              resolution: resolution,
                              attack: false
                          }), new Domination_Data_Choice.Or({
                              choices: [ new Domination_Data_Choice.And({
                                  choices: [ new Domination_Data_Choice.Draw({
                                      n: 2,
                                      resolution: resolution,
                                      attack: false
                                  }), new Domination_Data_Choice.GainActions({
                                      n: Domination_Data_Actions.actions(1),
                                      attack: false,
                                      resolution: resolution
                                  }) ],
                                  resolution: resolution,
                                  attack: false
                              }), new Domination_Data_Choice.And({
                                  choices: [ new Domination_Data_Choice.GainBuys({
                                      n: Domination_Data_Buys.buys(1),
                                      resolution: resolution,
                                      attack: false
                                  }), new Domination_Data_Choice.GainBonus({
                                      bonus: new Domination_Data_Bonus.Cash(2),
                                      attack: false,
                                      resolution: resolution
                                  }) ],
                                  resolution: resolution,
                                  attack: false
                              }) ],
                              resolution: resolution,
                              attack: false
                          }) ],
                          attack: false,
                          resolution: resolution
                      }),
                      attack: false,
                      resolution: resolution
                  }),
                  attack: false,
                  resolution: resolution
              })),
              description: description
          }),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.independentCard(c);
  })();
  var stables = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Stables",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.Option({
              choice: new Domination_Data_Choice.If({
                  condition: new Domination_Data_Condition.HasCardType(Domination_Data_CardType.Treasure.value),
                  otherwise: Data_Maybe.Nothing.value,
                  choice: new Domination_Data_Choice.And({
                      choices: [ new Domination_Data_Choice.MoveFromTo({
                          filter: new Domination_Data_Filter.HasType(Domination_Data_CardType.Treasure.value),
                          n: new Domination_Data_Constraint.Exactly(1),
                          source: Domination_Data_Pile.Hand.value,
                          destination: Domination_Data_Pile.Discarding.value,
                          attack: false,
                          resolution: resolution
                      }), new Domination_Data_Choice.Draw({
                          n: 3,
                          resolution: resolution,
                          attack: false
                      }), new Domination_Data_Choice.GainActions({
                          n: Data_Semiring.one(Domination_Data_Actions.ringActions),
                          resolution: resolution,
                          attack: false
                      }) ],
                      resolution: resolution,
                      attack: false
                  }),
                  attack: false,
                  resolution: resolution
              }),
              attack: false,
              resolution: resolution
          })),
          description: "You may discard a treasure for +3 Cards" + " and +1 Action."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var stewardChoice = new Domination_Data_Choice.Or({
      choices: [ new Domination_Data_Choice.Draw({
          n: 2,
          attack: false,
          resolution: resolution
      }), new Domination_Data_Choice.GainBonus({
          bonus: new Domination_Data_Bonus.Cash(2),
          attack: false,
          resolution: resolution
      }), new Domination_Data_Choice.MoveFromTo({
          source: Domination_Data_Pile.Hand.value,
          destination: Domination_Data_Pile.Trash.value,
          filter: Domination_Data_Filter.Any.value,
          n: new Domination_Data_Constraint.Exactly(2),
          attack: false,
          resolution: resolution
      }) ],
      resolution: resolution,
      attack: false
  });
  var stewardSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(stewardChoice),
      description: "Choose 1: + 2 cards, + $2, or trash 2 cards from your hand"
  };
  var steward = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Steward",
      cost: 3,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just(stewardSpecial),
      reaction: Domination_Data_Card.action.reaction
  });
  var torturerChoice = new Domination_Data_Choice.PickN({
      n: 1,
      choices: [ new Domination_Data_Choice.MoveFromTo({
          n: new Domination_Data_Constraint.Exactly(2),
          filter: Domination_Data_Filter.Any.value,
          source: Domination_Data_Pile.Hand.value,
          destination: Domination_Data_Pile.Discard.value,
          attack: true,
          resolution: resolution
      }), new Domination_Data_Choice.GainCards({
          n: 1,
          cardName: "Curse",
          destination: Domination_Data_Pile.Discard.value,
          attack: true,
          resolution: resolution
      }) ],
      resolution: resolution,
      attack: true
  });
  var torturerSpecial = {
      target: Domination_Data_Target.EveryoneElse.value,
      command: new Domination_Data_Card.Choose(torturerChoice),
      description: "Each other player either discards 2 cards or gains a Curse to their hand, their choice. (They may pick an option they can't do.)"
  };
  var workshop = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Workshop",
      cost: 3,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.GainCard({
              filter: new Domination_Data_Filter.CostUpTo(4),
              destination: Domination_Data_Pile.Discarding.value,
              attack: false,
              resolution: resolution
          })),
          description: "Gain a card costing up to 4."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var remodel = (function () {
      var description = "Trash a card from your hand." + " Gain a card costing up to 2 more than it.";
      return Domination_Data_Card.independentCard({
          types: Domination_Data_Card.action.types,
          name: "Remodel",
          cost: 4,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.StackChoice({
                  expression: [ new Domination_Data_StackEvaluation.StackChooseCards({
                      cards: Domination_Data_Var.Unbound.value,
                      filter: new Domination_Data_Var.Bound(Domination_Data_Filter.Any.value),
                      from: new Domination_Data_Var.Bound(Domination_Data_Pile.Hand.value),
                      n: Domination_Data_Var.Bound.create(new Domination_Data_Constraint.Exactly(1))
                  }), Domination_Data_StackEvaluation.StackDuplicate.value, Domination_Data_StackEvaluation.StackTrash.value, new Domination_Data_StackEvaluation.StackNth(0), Domination_Data_StackEvaluation.StackCostOf.value, new Domination_Data_StackEvaluation.StackAddN(2), Domination_Data_StackEvaluation.StackMakeFilterCostUpTo.value, new Domination_Data_StackEvaluation.StackBind("filter"), new Domination_Data_StackEvaluation.StackChooseCardFromSupply({
                      cardName: Domination_Data_Var.Unbound.value,
                      filter: Domination_Data_Var.Unbound.value
                  }), new Domination_Data_StackEvaluation.StackGainTo(Domination_Data_Pile.Discarding.value) ],
                  stack: [  ],
                  attack: false,
                  description: description
              })),
              description: description
          }),
          reaction: Domination_Data_Card.action.reaction
      });
  })();
  var province = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.victory.types,
      name: "Province",
      cost: 8,
      victoryPoints: Domination_Data_Points.points(6),
      treasure: Domination_Data_Card.victory.treasure,
      buys: Domination_Data_Card.victory.buys,
      cards: Domination_Data_Card.victory.cards,
      actions: Domination_Data_Card.victory.actions,
      special: Domination_Data_Card.victory.special,
      reaction: Domination_Data_Card.victory.reaction
  });
  var platinum = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.treasure.types,
      name: "Platinum",
      cost: 9,
      victoryPoints: Domination_Data_Card.treasure.victoryPoints,
      treasure: 5,
      buys: Domination_Data_Card.treasure.buys,
      cards: Domination_Data_Card.treasure.cards,
      actions: Domination_Data_Card.treasure.actions,
      special: Domination_Data_Card.treasure.special,
      reaction: Domination_Data_Card.treasure.reaction
  });
  var pawnChoice = new Domination_Data_Choice.PickN({
      n: 2,
      choices: [ new Domination_Data_Choice.Draw({
          n: 1,
          attack: false,
          resolution: resolution
      }), new Domination_Data_Choice.GainBonus({
          bonus: new Domination_Data_Bonus.Cash(1),
          attack: false,
          resolution: resolution
      }), new Domination_Data_Choice.GainActions({
          n: Data_Semiring.one(Domination_Data_Actions.ringActions),
          attack: false,
          resolution: resolution
      }), new Domination_Data_Choice.GainBuys({
          n: Data_Semiring.one(Domination_Data_Buys.ringBuys),
          attack: false,
          resolution: resolution
      }) ],
      resolution: resolution,
      attack: false
  });
  var pawnSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(pawnChoice),
      description: "Choose 2 of: + $1, + 1 card, + 1 action, or +1 buy"
  };
  var pawn = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Pawn",
      cost: 2,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just(pawnSpecial),
      reaction: Domination_Data_Card.action.reaction
  });
  var oasis = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Oasis",
      cost: 3,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: 1,
      buys: Domination_Data_Card.action.buys,
      cards: 1,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.MoveFromTo({
              n: new Domination_Data_Constraint.Exactly(1),
              filter: Domination_Data_Filter.Any.value,
              source: Domination_Data_Pile.Hand.value,
              destination: Domination_Data_Pile.Discarding.value,
              resolution: resolution,
              attack: false
          })),
          description: "Discard a card."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var noblesChoice = new Domination_Data_Choice.Or({
      choices: [ new Domination_Data_Choice.Draw({
          n: 3,
          attack: false,
          resolution: resolution
      }), new Domination_Data_Choice.GainActions({
          n: Domination_Data_Actions.actions(2),
          attack: false,
          resolution: resolution
      }) ],
      resolution: resolution,
      attack: false
  });
  var noblesSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(noblesChoice),
      description: "Choose one: +3 cards or +2 actions"
  };
  var nobles = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.actionVictory.types,
      name: "Nobles",
      cost: 6,
      victoryPoints: Domination_Data_Points.points(2),
      treasure: Domination_Data_Card.actionVictory.treasure,
      buys: Domination_Data_Card.actionVictory.buys,
      cards: Domination_Data_Card.actionVictory.cards,
      actions: Domination_Data_Card.actionVictory.actions,
      special: new Data_Maybe.Just(noblesSpecial),
      reaction: Domination_Data_Card.actionVictory.reaction
  });
  var monument = Domination_Data_Card.independentCard({
      types: [ Domination_Data_CardType.Action.value, Domination_Data_CardType.Victory.value ],
      name: "Monument",
      cost: 4,
      victoryPoints: Data_Semiring.one(Domination_Data_Points.ringPoints),
      treasure: 2,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var moneyLenderChoice = new Domination_Data_Choice.If({
      condition: new Domination_Data_Condition.HasCard("Copper"),
      choice: new Domination_Data_Choice.Option({
          choice: new Domination_Data_Choice.And({
              choices: [ new Domination_Data_Choice.MoveFromTo({
                  n: new Domination_Data_Constraint.Exactly(1),
                  filter: new Domination_Data_Filter.HasName("Copper"),
                  source: Domination_Data_Pile.Hand.value,
                  destination: Domination_Data_Pile.Trash.value,
                  attack: false,
                  resolution: resolution
              }), new Domination_Data_Choice.GainBonus({
                  bonus: new Domination_Data_Bonus.Cash(3),
                  attack: false,
                  resolution: resolution
              }) ],
              attack: false,
              resolution: resolution
          }),
          attack: false,
          resolution: resolution
      }),
      otherwise: Data_Maybe.Nothing.value,
      attack: false,
      resolution: resolution
  });
  var moneyLenderSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(moneyLenderChoice),
      description: "You may trash a copper from your hand for + $3"
  };
  var moat = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.actionReaction.types,
      name: "Moat",
      cost: 2,
      victoryPoints: Domination_Data_Card.actionReaction.victoryPoints,
      treasure: Domination_Data_Card.actionReaction.treasure,
      buys: Domination_Data_Card.actionReaction.buys,
      cards: 2,
      actions: Domination_Data_Card.actionReaction.actions,
      special: Domination_Data_Card.actionReaction.special,
      reaction: new Data_Maybe.Just(Domination_Data_Reaction.BlockAttack.value)
  });
  var mine = (function () {
      var description = "You may trash a Treasure card from your hand." + (" Gain a Treasure card to your hand" + " costing up to $3 more than it.");
      return Domination_Data_Card.independentCard({
          types: Domination_Data_Card.action.types,
          name: "Mine",
          cost: 5,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.StackChoice({
                  expression: [ new Domination_Data_StackEvaluation.StackChooseCards({
                      cards: Domination_Data_Var.Unbound.value,
                      filter: Domination_Data_Var.Bound.create(new Domination_Data_Filter.HasType(Domination_Data_CardType.Treasure.value)),
                      from: new Domination_Data_Var.Bound(Domination_Data_Pile.Hand.value),
                      n: Domination_Data_Var.Bound.create(new Domination_Data_Constraint.Exactly(1))
                  }), Domination_Data_StackEvaluation.StackDuplicate.value, Domination_Data_StackEvaluation.StackTrash.value, new Domination_Data_StackEvaluation.StackNth(0), Domination_Data_StackEvaluation.StackCostOf.value, new Domination_Data_StackEvaluation.StackAddN(3), Domination_Data_StackEvaluation.StackMakeFilterCostUpTo.value, new Domination_Data_StackEvaluation.StackPush(new Domination_Data_StackEvaluation.StackFilter(new Domination_Data_Filter.HasType(Domination_Data_CardType.Treasure.value))), Domination_Data_StackEvaluation.StackMakeFilterAnd.value, new Domination_Data_StackEvaluation.StackBind("filter"), new Domination_Data_StackEvaluation.StackChooseCardFromSupply({
                      cardName: Domination_Data_Var.Unbound.value,
                      filter: Domination_Data_Var.Unbound.value
                  }), new Domination_Data_StackEvaluation.StackGainTo(Domination_Data_Pile.Hand.value) ],
                  stack: [  ],
                  attack: false,
                  description: description
              })),
              description: description
          }),
          reaction: Domination_Data_Card.action.reaction
      });
  })();
  var mill = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.actionVictory.types,
      name: "Mill",
      cost: 4,
      victoryPoints: Data_Semiring.one(Domination_Data_Points.ringPoints),
      treasure: Domination_Data_Card.actionVictory.treasure,
      buys: Domination_Data_Card.actionVictory.buys,
      cards: Domination_Data_Card.actionVictory.cards,
      actions: Domination_Data_Card.actionVictory.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.StackChoice({
              expression: [ new Domination_Data_StackEvaluation.StackChooseCards({
                  cards: Domination_Data_Var.Unbound.value,
                  filter: new Domination_Data_Var.Bound(Domination_Data_Filter.Any.value),
                  from: new Domination_Data_Var.Bound(Domination_Data_Pile.Hand.value),
                  n: Domination_Data_Var.Bound.create(new Domination_Data_Constraint.Exactly(2))
              }), Domination_Data_StackEvaluation.StackDuplicate.value, Domination_Data_StackEvaluation.StackDiscard.value, Domination_Data_StackEvaluation.StackLength.value, new Domination_Data_StackEvaluation.StackIf({
                  condition: [ Domination_Data_StackEvaluation.StackEquals.create(new Domination_Data_StackEvaluation.StackInt(2)) ],
                  following: [ Domination_Data_StackEvaluation.StackGainBonus.create(new Domination_Data_Bonus.Cash(2)) ],
                  otherwise: [  ]
              }) ],
              stack: [  ],
              attack: false,
              description: "You may discard 2 cards, for +$2"
          })),
          description: "You may discard 2 cards, for +$2"
      }),
      reaction: Domination_Data_Card.actionVictory.reaction
  });
  var market = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Market",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: 1,
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      cards: 1,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var lurker = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Lurker",
      cost: 2,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.Or({
              choices: [ new Domination_Data_Choice.MoveFromTo({
                  n: new Domination_Data_Constraint.Exactly(1),
                  filter: new Domination_Data_Filter.HasType(Domination_Data_CardType.Action.value),
                  source: Domination_Data_Pile.Supply.value,
                  destination: Domination_Data_Pile.Trash.value,
                  attack: false,
                  resolution: resolution
              }), new Domination_Data_Choice.If({
                  condition: new Domination_Data_Condition.TrashContainsCardType(Domination_Data_CardType.Action.value),
                  choice: new Domination_Data_Choice.MoveFromTo({
                      n: new Domination_Data_Constraint.Exactly(1),
                      filter: new Domination_Data_Filter.HasType(Domination_Data_CardType.Action.value),
                      source: Domination_Data_Pile.Trash.value,
                      destination: Domination_Data_Pile.Discarding.value,
                      attack: false,
                      resolution: resolution
                  }),
                  otherwise: Data_Maybe.Nothing.value,
                  attack: false,
                  resolution: resolution
              }) ],
              resolution: resolution,
              attack: false
          })),
          description: "Trash an action card from the supply" + " or gain an action card from the trash."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var laboratory = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Laboratory",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: 2,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var junkDealer = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Junk Dealer",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: 1,
      buys: Domination_Data_Card.action.buys,
      cards: 1,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.MoveFromTo({
              n: new Domination_Data_Constraint.Exactly(1),
              filter: Domination_Data_Filter.Any.value,
              source: Domination_Data_Pile.Hand.value,
              destination: Domination_Data_Pile.Trash.value,
              resolution: resolution,
              attack: false
          })),
          description: "Trash a card from your hand."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var innkeeper = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Innkeeper",
      cost: 4,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.Or({
              choices: [ new Domination_Data_Choice.Draw({
                  n: 1,
                  attack: false,
                  resolution: resolution
              }), new Domination_Data_Choice.And({
                  choices: [ new Domination_Data_Choice.Draw({
                      n: 3,
                      attack: false,
                      resolution: resolution
                  }), new Domination_Data_Choice.MoveFromTo({
                      n: new Domination_Data_Constraint.Exactly(3),
                      filter: Domination_Data_Filter.Any.value,
                      source: Domination_Data_Pile.Hand.value,
                      destination: Domination_Data_Pile.Discarding.value,
                      attack: false,
                      resolution: resolution
                  }) ],
                  resolution: resolution,
                  attack: false
              }), new Domination_Data_Choice.And({
                  choices: [ new Domination_Data_Choice.Draw({
                      n: 5,
                      attack: false,
                      resolution: resolution
                  }), new Domination_Data_Choice.MoveFromTo({
                      n: new Domination_Data_Constraint.Exactly(6),
                      filter: Domination_Data_Filter.Any.value,
                      source: Domination_Data_Pile.Hand.value,
                      destination: Domination_Data_Pile.Discarding.value,
                      attack: false,
                      resolution: resolution
                  }) ],
                  resolution: resolution,
                  attack: false
              }) ],
              resolution: resolution,
              attack: false
          })),
          description: "Choose one: +1 Card; or +3 Cards, then discard 3 cards; or +5 Cards, then discard 6 cards."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var harem = Domination_Data_Card.independentCard({
      types: [ Domination_Data_CardType.Treasure.value, Domination_Data_CardType.Victory.value ],
      name: "Harem",
      cost: 6,
      victoryPoints: Domination_Data_Points.points(2),
      treasure: 2,
      buys: Domination_Data_Card.treasure.buys,
      cards: Domination_Data_Card.treasure.cards,
      actions: Domination_Data_Card.treasure.actions,
      special: Domination_Data_Card.treasure.special,
      reaction: Domination_Data_Card.treasure.reaction
  });
  var harbingerChoice = new Domination_Data_Choice.MoveFromTo({
      n: new Domination_Data_Constraint.UpTo(1),
      filter: Domination_Data_Filter.Any.value,
      source: Domination_Data_Pile.Discard.value,
      destination: Domination_Data_Pile.Deck.value,
      resolution: resolution,
      attack: false
  });
  var harbingerSpecial = {
      target: Domination_Data_Target.Self.value,
      command: Domination_Data_Card.Choose.create(harbingerChoice),
      description: "Look through your discard pile." + " You may put a card from it onto your deck."
  };
  var harbinger = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Harbinger",
      cost: 3,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: 1,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: new Data_Maybe.Just(harbingerSpecial),
      reaction: Domination_Data_Card.action.reaction
  });
  var greatHall = Domination_Data_Card.independentCard({
      types: [ Domination_Data_CardType.Action.value, Domination_Data_CardType.Victory.value ],
      name: "Great Hall",
      cost: 3,
      victoryPoints: Data_Semiring.one(Domination_Data_Points.ringPoints),
      treasure: Domination_Data_Card.victory.treasure,
      buys: Domination_Data_Card.victory.buys,
      cards: 1,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: Domination_Data_Card.victory.special,
      reaction: Domination_Data_Card.victory.reaction
  });
  var goldfishChoice = new Domination_Data_Choice.If({
      condition: Domination_Data_Condition.Randomly.create(Data_Lens_Getter.viewOn(50)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))),
      choice: new Domination_Data_Choice.GainCards({
          cardName: "Gold",
          destination: Domination_Data_Pile.Hand.value,
          n: 1,
          resolution: resolution,
          attack: false
      }),
      otherwise: Data_Maybe.Nothing.value,
      attack: false,
      resolution: resolution
  });
  var goldfishSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(goldfishChoice),
      description: "50% chance to gain a gold to your hand"
  };
  var gold = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.treasure.types,
      name: "Gold",
      cost: 6,
      victoryPoints: Domination_Data_Card.treasure.victoryPoints,
      treasure: 3,
      buys: Domination_Data_Card.treasure.buys,
      cards: Domination_Data_Card.treasure.cards,
      actions: Domination_Data_Card.treasure.actions,
      special: Domination_Data_Card.treasure.special,
      reaction: Domination_Data_Card.treasure.reaction
  });
  var goldfish = (function () {
      var rs = [ gold ];
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Goldfish",
          cost: 4,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just(goldfishSpecial),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var gainCurseAndCopper = new Domination_Data_Choice.And({
      choices: [ new Domination_Data_Choice.GainCards({
          cardName: "Copper",
          destination: Domination_Data_Pile.Discard.value,
          n: 1,
          attack: true,
          resolution: resolution
      }), new Domination_Data_Choice.GainCards({
          cardName: "Curse",
          destination: Domination_Data_Pile.Discard.value,
          n: 1,
          attack: true,
          resolution: resolution
      }) ],
      attack: true,
      resolution: resolution
  });
  var mountebankChoice = new Domination_Data_Choice.If({
      condition: new Domination_Data_Condition.HasCard("Curse"),
      choice: new Domination_Data_Choice.Or({
          choices: [ new Domination_Data_Choice.MoveFromTo({
              n: new Domination_Data_Constraint.Exactly(1),
              filter: new Domination_Data_Filter.HasName("Curse"),
              source: Domination_Data_Pile.Hand.value,
              destination: Domination_Data_Pile.Discard.value,
              attack: true,
              resolution: resolution
          }), gainCurseAndCopper ],
          attack: true,
          resolution: resolution
      }),
      attack: true,
      resolution: resolution,
      otherwise: new Data_Maybe.Just(gainCurseAndCopper)
  });
  var gainCurse = new Domination_Data_Choice.GainCards({
      cardName: "Curse",
      destination: Domination_Data_Pile.Discard.value,
      n: 1,
      resolution: resolution,
      attack: true
  });
  var witchSpecial = {
      target: Domination_Data_Target.EveryoneElse.value,
      command: new Domination_Data_Card.Choose(gainCurse),
      description: "Each other player gains a Curse."
  };
  var gain4Cash = new Domination_Data_Choice.GainBonus({
      bonus: new Domination_Data_Bonus.Cash(4),
      attack: false,
      resolution: resolution
  });
  var gain1Estate = new Domination_Data_Choice.GainCards({
      cardName: "Estate",
      n: 1,
      destination: Domination_Data_Pile.Discard.value,
      attack: false,
      resolution: resolution
  });
  var festival = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Festival",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: 2,
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Actions.actions(2),
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var expand = (function () {
      var description = "Trash a card from your hand." + " Gain a card costing up to 3 more than it.";
      return Domination_Data_Card.independentCard({
          types: Domination_Data_Card.action.types,
          name: "Expand",
          cost: 7,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.StackChoice({
                  expression: [ new Domination_Data_StackEvaluation.StackChooseCards({
                      cards: Domination_Data_Var.Unbound.value,
                      filter: new Domination_Data_Var.Bound(Domination_Data_Filter.Any.value),
                      from: new Domination_Data_Var.Bound(Domination_Data_Pile.Hand.value),
                      n: Domination_Data_Var.Bound.create(new Domination_Data_Constraint.Exactly(1))
                  }), Domination_Data_StackEvaluation.StackDuplicate.value, Domination_Data_StackEvaluation.StackTrash.value, new Domination_Data_StackEvaluation.StackNth(0), Domination_Data_StackEvaluation.StackCostOf.value, new Domination_Data_StackEvaluation.StackAddN(3), Domination_Data_StackEvaluation.StackMakeFilterCostUpTo.value, new Domination_Data_StackEvaluation.StackBind("filter"), new Domination_Data_StackEvaluation.StackChooseCardFromSupply({
                      cardName: Domination_Data_Var.Unbound.value,
                      filter: Domination_Data_Var.Unbound.value
                  }), new Domination_Data_StackEvaluation.StackGainTo(Domination_Data_Pile.Discarding.value) ],
                  stack: [  ],
                  attack: false,
                  description: description
              })),
              description: description
          }),
          reaction: Domination_Data_Card.action.reaction
      });
  })();
  var estate = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.victory.types,
      name: "Estate",
      cost: 2,
      victoryPoints: Data_Semiring.one(Domination_Data_Points.ringPoints),
      treasure: Domination_Data_Card.victory.treasure,
      buys: Domination_Data_Card.victory.buys,
      cards: Domination_Data_Card.victory.cards,
      actions: Domination_Data_Card.victory.actions,
      special: Domination_Data_Card.victory.special,
      reaction: Domination_Data_Card.victory.reaction
  });
  var duchy = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.victory.types,
      name: "Duchy",
      cost: 5,
      victoryPoints: Domination_Data_Points.points(3),
      treasure: Domination_Data_Card.victory.treasure,
      buys: Domination_Data_Card.victory.buys,
      cards: Domination_Data_Card.victory.cards,
      actions: Domination_Data_Card.victory.actions,
      special: Domination_Data_Card.victory.special,
      reaction: Domination_Data_Card.victory.reaction
  });
  var draw1Card = new Domination_Data_Choice.Draw({
      n: 1,
      resolution: resolution,
      attack: false
  });
  var discardYourHand = function (attack) {
      return new Domination_Data_Choice.Discard({
          selection: Domination_Data_SelectCards.SelectAll.value,
          resolution: resolution,
          attack: attack
      });
  };
  var huntingLodge = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Hunting Lodge",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: 1,
      actions: Domination_Data_Actions.actions(2),
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.Option({
              choice: new Domination_Data_Choice.And({
                  choices: [ discardYourHand(false), new Domination_Data_Choice.Draw({
                      n: 5,
                      resolution: resolution,
                      attack: false
                  }) ],
                  resolution: resolution,
                  attack: false
              }),
              attack: false,
              resolution: resolution
          })),
          description: "You may discard your hand for +5 Cards"
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var scholarChoice = new Domination_Data_Choice.And({
      choices: [ discardYourHand(false), new Domination_Data_Choice.Draw({
          n: 7,
          resolution: resolution,
          attack: false
      }) ],
      resolution: resolution,
      attack: false
  });
  var scholarSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(scholarChoice),
      description: "Discard your hand and draw 7 cards"
  };
  var scholar = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Scholar",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just(scholarSpecial),
      reaction: Domination_Data_Card.action.reaction
  });
  var discardDownTo3 = new Domination_Data_Choice.MoveFromTo({
      n: new Domination_Data_Constraint.DownTo(3),
      filter: Domination_Data_Filter.Any.value,
      source: Domination_Data_Pile.Hand.value,
      destination: Domination_Data_Pile.Discard.value,
      resolution: resolution,
      attack: true
  });
  var margrave = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.actionAttack.types,
      name: "Margrave",
      cost: 5,
      victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
      treasure: Domination_Data_Card.actionAttack.treasure,
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      cards: 3,
      actions: Domination_Data_Card.actionAttack.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.EveryoneElse.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.And({
              choices: [ draw1Card, discardDownTo3 ],
              attack: true,
              resolution: resolution
          })),
          description: "Each other player draws a card" + ", then discards down to 3 cards in hand."
      }),
      reaction: Domination_Data_Card.actionAttack.reaction
  });
  var militiaSpecial = {
      target: Domination_Data_Target.EveryoneElse.value,
      command: new Domination_Data_Card.Choose(discardDownTo3),
      description: "Each other player discards down to 3 cards"
  };
  var militia = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.actionAttack.types,
      name: "Militia",
      cost: 4,
      victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
      treasure: 2,
      buys: Domination_Data_Card.actionAttack.buys,
      cards: Domination_Data_Card.actionAttack.cards,
      actions: Domination_Data_Card.actionAttack.actions,
      special: new Data_Maybe.Just(militiaSpecial),
      reaction: Domination_Data_Card.actionAttack.reaction
  });
  var discardCopper = new Domination_Data_Choice.MoveFromTo({
      n: new Domination_Data_Constraint.Exactly(1),
      filter: new Domination_Data_Filter.HasName("Copper"),
      source: Domination_Data_Pile.Hand.value,
      destination: Domination_Data_Pile.Discard.value,
      resolution: resolution,
      attack: true
  });
  var discard1Estate = new Domination_Data_Choice.MoveFromTo({
      filter: new Domination_Data_Filter.HasName("Estate"),
      n: new Domination_Data_Constraint.Exactly(1),
      source: Domination_Data_Pile.Hand.value,
      destination: Domination_Data_Pile.Discarding.value,
      attack: false,
      resolution: resolution
  });
  var discard1EstateAndGain4Cash = new Domination_Data_Choice.And({
      choices: [ gain4Cash, discard1Estate ],
      attack: false,
      resolution: resolution
  });
  var discardOrGain1Estate = new Domination_Data_Choice.Or({
      choices: [ gain1Estate, discard1EstateAndGain4Cash ],
      attack: false,
      resolution: resolution
  });
  var curse = Domination_Data_Card.independentCard({
      types: [ Domination_Data_CardType.Curse.value ],
      name: "Curse",
      cost: Domination_Data_Card.card.cost,
      victoryPoints: Data_Ring.negate(Domination_Data_Points.semiringPoints)(Data_Semiring.one(Domination_Data_Points.ringPoints)),
      treasure: Domination_Data_Card.card.treasure,
      buys: Domination_Data_Card.card.buys,
      cards: Domination_Data_Card.card.cards,
      actions: Domination_Data_Card.card.actions,
      special: Domination_Data_Card.card.special,
      reaction: Domination_Data_Card.card.reaction
  });
  var oldWitch = (function () {
      var rs = [ curse ];
      var c = {
          types: Domination_Data_Card.actionAttack.types,
          name: "Old Witch",
          cost: 5,
          victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
          treasure: Domination_Data_Card.actionAttack.treasure,
          buys: Domination_Data_Card.actionAttack.buys,
          cards: 3,
          actions: Domination_Data_Card.actionAttack.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.EveryoneElse.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.And({
                  choices: [ gainCurse, new Domination_Data_Choice.If({
                      condition: new Domination_Data_Condition.HasCard("Curse"),
                      choice: new Domination_Data_Choice.MoveFromTo({
                          n: new Domination_Data_Constraint.UpTo(1),
                          filter: new Domination_Data_Filter.HasName("Curse"),
                          source: Domination_Data_Pile.Hand.value,
                          destination: Domination_Data_Pile.Trash.value,
                          attack: true,
                          resolution: resolution
                      }),
                      otherwise: Data_Maybe.Nothing.value,
                      attack: true,
                      resolution: resolution
                  }) ],
                  resolution: resolution,
                  attack: true
              })),
              description: "Each other player gains a Curse" + " and may trash a Curse from their hand."
          }),
          reaction: Domination_Data_Card.actionAttack.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var torturer = (function () {
      var rs = [ curse ];
      var c = {
          types: Domination_Data_Card.actionAttack.types,
          name: "Torturer",
          cost: 5,
          victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
          treasure: Domination_Data_Card.actionAttack.treasure,
          buys: Domination_Data_Card.actionAttack.buys,
          cards: 3,
          actions: Domination_Data_Card.actionAttack.actions,
          special: new Data_Maybe.Just(torturerSpecial),
          reaction: Domination_Data_Card.actionAttack.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var witch = (function () {
      var rs = [ curse ];
      var c = {
          types: Domination_Data_Card.actionAttack.types,
          name: "Witch",
          cost: 5,
          victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
          treasure: Domination_Data_Card.actionAttack.treasure,
          buys: Domination_Data_Card.actionAttack.buys,
          cards: 2,
          actions: Domination_Data_Card.actionAttack.actions,
          special: new Data_Maybe.Just(witchSpecial),
          reaction: Domination_Data_Card.actionAttack.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var courtyard = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Courtyard",
      cost: 2,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: 3,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.MoveFromTo({
              n: new Domination_Data_Constraint.Exactly(1),
              filter: Domination_Data_Filter.Any.value,
              source: Domination_Data_Pile.Hand.value,
              destination: Domination_Data_Pile.Deck.value,
              resolution: resolution,
              attack: false
          })),
          description: "Put a card from your hand onto your deck."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var councilRoomSpecial = {
      target: Domination_Data_Target.EveryoneElse.value,
      command: new Domination_Data_Card.Choose(draw1Card),
      description: "Each other player draws a card."
  };
  var councilRoom = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Council Room",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      cards: 4,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just(councilRoomSpecial),
      reaction: Domination_Data_Card.action.reaction
  });
  var copper = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.treasure.types,
      name: "Copper",
      cost: Domination_Data_Card.treasure.cost,
      victoryPoints: Domination_Data_Card.treasure.victoryPoints,
      treasure: 1,
      buys: Domination_Data_Card.treasure.buys,
      cards: Domination_Data_Card.treasure.cards,
      actions: Domination_Data_Card.treasure.actions,
      special: Domination_Data_Card.treasure.special,
      reaction: Domination_Data_Card.treasure.reaction
  });
  var countingHouse = (function () {
      var rs = [ copper ];
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Counting House",
          cost: 5,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.MoveFromTo({
                  n: Domination_Data_Constraint.Unlimited.value,
                  filter: new Domination_Data_Filter.HasName("Copper"),
                  source: Domination_Data_Pile.Discard.value,
                  destination: Domination_Data_Pile.Hand.value,
                  resolution: resolution,
                  attack: false
              })),
              description: "Look through your discard pile." + "Reveal any number of Copper from it and put them into your hand."
          }),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var moneyLender = (function () {
      var rs = [ copper ];
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Money Lender",
          cost: 4,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just(moneyLenderSpecial),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var mountebank = (function () {
      var rs = [ curse, copper ];
      var c = {
          types: Domination_Data_Card.actionAttack.types,
          name: "Mountebank",
          cost: 5,
          victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
          treasure: 2,
          buys: Domination_Data_Card.actionAttack.buys,
          cards: Domination_Data_Card.actionAttack.cards,
          actions: Domination_Data_Card.actionAttack.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.EveryoneElse.value,
              command: new Domination_Data_Card.Choose(mountebankChoice),
              description: "Each other player may discard a Curse." + "If they don't, they gain a Curse and a Copper."
          }),
          reaction: Domination_Data_Card.actionAttack.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var settlers = (function () {
      var rs = [ copper ];
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Settlers",
          cost: 2,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: 1,
          actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.Self.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.MoveFromTo({
                  n: new Domination_Data_Constraint.UpTo(1),
                  filter: new Domination_Data_Filter.HasName("Copper"),
                  source: Domination_Data_Pile.Discard.value,
                  destination: Domination_Data_Pile.Hand.value,
                  resolution: resolution,
                  attack: false
              })),
              description: "Look through your discard pile." + "You may reveal a Copper from it and put it into your hand."
          }),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var consolationChoice = new Domination_Data_Choice.If({
      condition: new Domination_Data_Condition.HasCard("Estate"),
      choice: new Domination_Data_Choice.GainBonus({
          bonus: new Domination_Data_Bonus.Cash(2),
          attack: false,
          resolution: resolution
      }),
      otherwise: Data_Maybe.Nothing.value,
      resolution: resolution,
      attack: false
  });
  var consolationSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(consolationChoice),
      description: "If you have an Estate in your hand, + $2"
  };
  var consolation = (function () {
      var rs = [ estate ];
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Consolation",
          cost: 2,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Domination_Data_Card.action.buys,
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just(consolationSpecial),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var colony = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.victory.types,
      name: "Colony",
      cost: 11,
      victoryPoints: Domination_Data_Points.points(10),
      treasure: Domination_Data_Card.victory.treasure,
      buys: Domination_Data_Card.victory.buys,
      cards: Domination_Data_Card.victory.cards,
      actions: Domination_Data_Card.victory.actions,
      special: Domination_Data_Card.victory.special,
      reaction: Domination_Data_Card.victory.reaction
  });
  var chapelChoice = new Domination_Data_Choice.MoveFromTo({
      n: new Domination_Data_Constraint.UpTo(4),
      filter: Domination_Data_Filter.Any.value,
      source: Domination_Data_Pile.Hand.value,
      destination: Domination_Data_Pile.Trash.value,
      resolution: resolution,
      attack: false
  });
  var chapelSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(chapelChoice),
      description: "Trash up to 4 cards from your hand"
  };
  var chapel = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Chapel",
      cost: 2,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just(chapelSpecial),
      reaction: Domination_Data_Card.action.reaction
  });
  var cellar = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Cellar",
      cost: 2,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.StackChoice({
              expression: [ new Domination_Data_StackEvaluation.StackChooseCards({
                  cards: Domination_Data_Var.Unbound.value,
                  filter: new Domination_Data_Var.Bound(Domination_Data_Filter.Any.value),
                  from: new Domination_Data_Var.Bound(Domination_Data_Pile.Hand.value),
                  n: new Domination_Data_Var.Bound(Domination_Data_Constraint.Unlimited.value)
              }), Domination_Data_StackEvaluation.StackDuplicate.value, Domination_Data_StackEvaluation.StackDiscard.value, Domination_Data_StackEvaluation.StackLength.value, Domination_Data_StackEvaluation.StackDraw.value ],
              stack: [  ],
              attack: false,
              description: "Discard N cards, then draw N cards."
          })),
          description: "Discard N cards, then draw N cards."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var catpurse = (function () {
      var rs = [ copper ];
      var c = {
          types: Domination_Data_Card.actionAttack.types,
          name: "Catpurse",
          cost: 4,
          victoryPoints: Domination_Data_Card.actionAttack.victoryPoints,
          treasure: 2,
          buys: Domination_Data_Card.actionAttack.buys,
          cards: Domination_Data_Card.actionAttack.cards,
          actions: Domination_Data_Card.actionAttack.actions,
          special: new Data_Maybe.Just({
              target: Domination_Data_Target.EveryoneElse.value,
              command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.If({
                  condition: new Domination_Data_Condition.HasCard("Copper"),
                  choice: discardCopper,
                  otherwise: Data_Maybe.Nothing.value,
                  attack: true,
                  resolution: resolution
              })),
              description: "Each other player discards a Copper."
          }),
          reaction: Domination_Data_Card.actionAttack.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var bazaar = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Bazaar",
      cost: 5,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: 1,
      buys: Domination_Data_Card.action.buys,
      cards: 1,
      actions: Domination_Data_Actions.actions(2),
      special: Domination_Data_Card.action.special,
      reaction: Domination_Data_Card.action.reaction
  });
  var baronChoice = new Domination_Data_Choice.If({
      condition: new Domination_Data_Condition.HasCard("Estate"),
      choice: discardOrGain1Estate,
      otherwise: new Data_Maybe.Just(gain1Estate),
      attack: false,
      resolution: resolution
  });
  var baronSpecial = {
      target: Domination_Data_Target.Self.value,
      command: new Domination_Data_Card.Choose(baronChoice),
      description: "You may discard an estate for + $4." + " If you don't, gain an Estate."
  };
  var baron = (function () {
      var rs = [ estate ];
      var c = {
          types: Domination_Data_Card.action.types,
          name: "Baron",
          cost: 4,
          victoryPoints: Domination_Data_Card.action.victoryPoints,
          treasure: Domination_Data_Card.action.treasure,
          buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
          cards: Domination_Data_Card.action.cards,
          actions: Domination_Data_Card.action.actions,
          special: new Data_Maybe.Just(baronSpecial),
          reaction: Domination_Data_Card.action.reaction
      };
      return Domination_Data_Card.cardWithRequirements(c)(rs);
  })();
  var artisan = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Artisan",
      cost: 6,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.And({
              choices: [ new Domination_Data_Choice.GainCard({
                  filter: new Domination_Data_Filter.CostUpTo(5),
                  destination: Domination_Data_Pile.Hand.value,
                  attack: false,
                  resolution: resolution
              }), new Domination_Data_Choice.MoveFromTo({
                  n: new Domination_Data_Constraint.Exactly(1),
                  filter: Domination_Data_Filter.Any.value,
                  source: Domination_Data_Pile.Hand.value,
                  destination: Domination_Data_Pile.Deck.value,
                  attack: false,
                  resolution: resolution
              }) ],
              attack: false,
              resolution: resolution
          })),
          description: "Gain a card to your hand costing up to 5." + "Put a card from your hand onto your deck."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var armory = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Armory",
      cost: 4,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.GainCard({
              filter: new Domination_Data_Filter.CostUpTo(4),
              destination: Domination_Data_Pile.Deck.value,
              attack: false,
              resolution: resolution
          })),
          description: "Gain a card onto your deck costing up to 4."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var altar = Domination_Data_Card.independentCard({
      types: Domination_Data_Card.action.types,
      name: "Altar",
      cost: 6,
      victoryPoints: Domination_Data_Card.action.victoryPoints,
      treasure: Domination_Data_Card.action.treasure,
      buys: Domination_Data_Card.action.buys,
      cards: Domination_Data_Card.action.cards,
      actions: Domination_Data_Card.action.actions,
      special: new Data_Maybe.Just({
          target: Domination_Data_Target.Self.value,
          command: Domination_Data_Card.Choose.create(new Domination_Data_Choice.And({
              choices: [ new Domination_Data_Choice.MoveFromTo({
                  n: new Domination_Data_Constraint.Exactly(1),
                  filter: Domination_Data_Filter.Any.value,
                  source: Domination_Data_Pile.Hand.value,
                  destination: Domination_Data_Pile.Trash.value,
                  attack: false,
                  resolution: resolution
              }), new Domination_Data_Choice.GainCard({
                  filter: new Domination_Data_Filter.CostUpTo(5),
                  destination: Domination_Data_Pile.Discarding.value,
                  attack: false,
                  resolution: resolution
              }) ],
              attack: false,
              resolution: resolution
          })),
          description: "Trash a card from your hand." + "Gain a card costing up to 5."
      }),
      reaction: Domination_Data_Card.action.reaction
  });
  var cardSpecMap = [ copper, silver, gold, platinum, estate, duchy, province, colony, curse, chapel, moat, pawn, consolation, settlers, courtyard, lurker, cellar, greatHall, village, woodCutter, steward, harbinger, workshop, oasis, mill, goldfish, baron, monument, smithy, workersVillage, militia, moneyLender, armory, remodel, innkeeper, catpurse, spiceMerchant, bazaar, festival, laboratory, market, witch, councilRoom, scholar, torturer, mountebank, margrave, huntingLodge, oldWitch, junkDealer, stables, tradingPost, mine, countingHouse, harem, nobles, artisan, altar, expand ];
  var cardMap = Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Card["_card"])(cardSpecMap);
  var upgrade = function (card) {
      return Data_Maybe.fromMaybe(card)(Data_Foldable.find(Data_Foldable.foldableArray)(function ($62) {
          return (function (v) {
              return v === card.name;
          })((function (v) {
              return v.name;
          })($62));
      })(cardMap));
  };
  exports["upgrade"] = upgrade;
  exports["cardMap"] = cardMap;
  exports["cardSpecMap"] = cardSpecMap;
  exports["copper"] = copper;
  exports["estate"] = estate;
  exports["province"] = province;
  exports["colony"] = colony;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["AppState"] = $PS["AppState"] || {};
  var exports = $PS["AppState"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HashMap = $PS["Data.HashMap"];
  var Data_Lens_Lens = $PS["Data.Lens.Lens"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_Cards = $PS["Domination.Data.Cards"];                
  var globalRoomCode = "global-dev";
  var defaultServerUrl = "wss://purescript-wip.onrender.com";
  var defaultKingdom = Data_Functor.map(Data_Functor.functorArray)(function (v) {
      return {
          cardSpec: v,
          selected: true
      };
  })(Domination_Data_Cards.cardSpecMap);
  var newConfig = {
      nextPlayerCount: 1,
      nextPlayerIndex: 0,
      kingdom: defaultKingdom,
      longGame: false
  };
  var defaultHeartbeatTimeout = 15000;
  var defaultHeartbeatInterval = 5000;
  var newApp = {
      connectionCount: 0,
      id: "",
      username: "",
      serverUrl: defaultServerUrl,
      usernames: Data_HashMap.empty,
      message: "",
      messages: [  ],
      chatNumber: 0,
      gameOn: false,
      maybeBroadcaster: Data_Maybe.Nothing.value,
      roomCode: globalRoomCode,
      dominationConfig: newConfig,
      showMenu: false,
      longGame: false,
      maybeAudioContext: Data_Maybe.Nothing.value,
      connectedClients: Data_HashMap.empty,
      heartbeatInterval: defaultHeartbeatInterval,
      heartbeatTimeout: defaultHeartbeatTimeout
  };
  var _usernames = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "usernames";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _username = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "username";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _showMenu = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "showMenu";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _serverUrl = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "serverUrl";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _nextPlayerIndex = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "nextPlayerIndex";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _nextPlayerCount = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "nextPlayerCount";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _messages = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "messages";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _message = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "message";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _maybeBroadcaster = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "maybeBroadcaster";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _maybeAudioContext = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "maybeAudioContext";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _longGame = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "longGame";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _kingdom = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "kingdom";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _id = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "id";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _dominationConfig = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "dominationConfig";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _connectionCount = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "connectionCount";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _connectedClients = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "connectedClients";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _chatNumber = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "chatNumber";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _cardSpec = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "cardSpec";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _card = function (dictStrong) {
      var f = function (v) {
          if (v instanceof Domination_Data_Card.IndependentCard) {
              return new Data_Tuple.Tuple(v.value0, Domination_Data_Card.IndependentCard.create);
          };
          if (v instanceof Domination_Data_Card.CardWithRequirements) {
              return new Data_Tuple.Tuple(v.value0.card, function (c1) {
                  return new Domination_Data_Card.CardWithRequirements({
                      card: c1,
                      requirements: v.value0.requirements
                  });
              });
          };
          throw new Error("Failed pattern match at AppState (line 58, column 5 - line 58, column 51): " + [ v.constructor.name ]);
      };
      return Data_Lens_Lens["lens'"](f)(dictStrong);
  };
  var _cardSpecCard = function (dictStrong) {
      var $30 = _cardSpec(dictStrong);
      var $31 = _card(dictStrong);
      return function ($32) {
          return $30($31($32));
      };
  };
  var upgradeSelection = Data_Lens_Setter.over(_cardSpecCard(Data_Profunctor_Strong.strongFn))(Domination_Data_Cards.upgrade);
  exports["_id"] = _id;
  exports["_messages"] = _messages;
  exports["_message"] = _message;
  exports["_chatNumber"] = _chatNumber;
  exports["_connectionCount"] = _connectionCount;
  exports["_usernames"] = _usernames;
  exports["_username"] = _username;
  exports["_serverUrl"] = _serverUrl;
  exports["_maybeBroadcaster"] = _maybeBroadcaster;
  exports["_dominationConfig"] = _dominationConfig;
  exports["_showMenu"] = _showMenu;
  exports["_maybeAudioContext"] = _maybeAudioContext;
  exports["_connectedClients"] = _connectedClients;
  exports["defaultServerUrl"] = defaultServerUrl;
  exports["newApp"] = newApp;
  exports["defaultKingdom"] = defaultKingdom;
  exports["upgradeSelection"] = upgradeSelection;
  exports["_nextPlayerIndex"] = _nextPlayerIndex;
  exports["_nextPlayerCount"] = _nextPlayerCount;
  exports["_longGame"] = _longGame;
  exports["_kingdom"] = _kingdom;
})(PS);
(function(exports) {
  /* jshint maxparams: false */
  /* global exports, XMLHttpRequest */
  "use strict";

  // module Audio.WebAudio.AudioParam

  exports.setValue = function(value) {
    return function(param) {
      return function() {
        param.value = value;
      };
    };
  };
})(PS["Audio.WebAudio.AudioParam"] = PS["Audio.WebAudio.AudioParam"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Audio.WebAudio.AudioParam"] = $PS["Audio.WebAudio.AudioParam"] || {};
  var exports = $PS["Audio.WebAudio.AudioParam"];
  var $foreign = $PS["Audio.WebAudio.AudioParam"];
  exports["setValue"] = $foreign.setValue;
})(PS);
(function(exports) {
  /* jshint maxparams: false */
  /* global exports, XMLHttpRequest */
  "use strict";

  exports.currentTime = function(cx) {
    return function() {
      return cx.currentTime;
    };
  };

  exports.resume = function(ctx) {
    return function() {
      return ctx.resume();
    };
  };

  /* uncurrried version */
  function _decodeAudioData (cx, audioData, onError, onSuccess) {
     cx.decodeAudioData(audioData, function (buff) {
       // console.log('buffer decoded OK ');
       onSuccess(buff);
      },
      function (e) {
        // console.log('buffer decode failed ');
        onError(e.err);
     });
  };

  exports.createGain = function(ctx) {
    return function() {
      return ctx.createGain();
    };
  };

  exports.createOscillator = function(ctx) {
    return function() {
      return ctx.createOscillator();
    };
  };

  exports.newAudioContext = function() {
    return new (window.AudioContext || window.webkitAudioContext)();
  };
})(PS["Audio.WebAudio.BaseAudioContext"] = PS["Audio.WebAudio.BaseAudioContext"] || {});
(function(exports) {
  /* jshint maxparams: false */
  /* global exports, XMLHttpRequest */
  "use strict";


  exports.unsafeGetProp = function(prop) {
    return function(obj) {
      return function() {
        return obj[prop];
      };
    };
  };
})(PS["Audio.WebAudio.Utils"] = PS["Audio.WebAudio.Utils"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Audio.WebAudio.Utils"] = $PS["Audio.WebAudio.Utils"] || {};
  var exports = $PS["Audio.WebAudio.Utils"];
  var $foreign = $PS["Audio.WebAudio.Utils"];
  exports["unsafeGetProp"] = $foreign.unsafeGetProp;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Audio.WebAudio.BaseAudioContext"] = $PS["Audio.WebAudio.BaseAudioContext"] || {};
  var exports = $PS["Audio.WebAudio.BaseAudioContext"];
  var $foreign = $PS["Audio.WebAudio.BaseAudioContext"];
  var Audio_WebAudio_Utils = $PS["Audio.WebAudio.Utils"];       
  var destination = Audio_WebAudio_Utils.unsafeGetProp("destination");
  exports["destination"] = destination;
  exports["newAudioContext"] = $foreign.newAudioContext;
  exports["currentTime"] = $foreign.currentTime;
  exports["resume"] = $foreign.resume;
  exports["createGain"] = $foreign.createGain;
  exports["createOscillator"] = $foreign.createOscillator;
})(PS);
(function(exports) {
  /* jshint maxparams: false */
  /* global exports, XMLHttpRequest */
  "use strict";

  // module Audio.WebAudio.GainNode

  exports.gain = function(node) {
    return function() {
      return node.gain;
    };
  };
})(PS["Audio.WebAudio.GainNode"] = PS["Audio.WebAudio.GainNode"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Audio.WebAudio.GainNode"] = $PS["Audio.WebAudio.GainNode"] || {};
  var exports = $PS["Audio.WebAudio.GainNode"];
  var $foreign = $PS["Audio.WebAudio.GainNode"];
  var Audio_WebAudio_AudioParam = $PS["Audio.WebAudio.AudioParam"];
  var Control_Bind = $PS["Control.Bind"];
  var Effect = $PS["Effect"];                
  var setGain = function (num) {
      return function (node) {
          return Control_Bind.bindFlipped(Effect.bindEffect)(Audio_WebAudio_AudioParam.setValue(num))($foreign.gain(node));
      };
  };
  exports["setGain"] = setGain;
})(PS);
(function(exports) {
  /* jshint maxparams: false */
  /* global exports, XMLHttpRequest */
  "use strict";

  // module Audio.WebAudio.Oscillator

  exports.startOscillator = function(when) {
    return function(n) {
      return function() {
        return n[n.start ? 'start' : 'noteOn'](when);
      };
    };
  };


  exports.stopOscillator = function(when) {
    return function(n) {
      return function() {
        return n[n.stop ? 'stop' : 'noteOff'](when);
      };
    };
  };
})(PS["Audio.WebAudio.Oscillator"] = PS["Audio.WebAudio.Oscillator"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Audio.WebAudio.Oscillator"] = $PS["Audio.WebAudio.Oscillator"] || {};
  var exports = $PS["Audio.WebAudio.Oscillator"];
  var $foreign = $PS["Audio.WebAudio.Oscillator"];
  var Audio_WebAudio_AudioParam = $PS["Audio.WebAudio.AudioParam"];
  var Audio_WebAudio_Utils = $PS["Audio.WebAudio.Utils"];
  var Control_Bind = $PS["Control.Bind"];
  var Effect = $PS["Effect"];
  var frequency = Audio_WebAudio_Utils.unsafeGetProp("frequency");
  var setFrequency = function (num) {
      return function (node) {
          return Control_Bind.bindFlipped(Effect.bindEffect)(Audio_WebAudio_AudioParam.setValue(num))(frequency(node));
      };
  };
  exports["setFrequency"] = setFrequency;
  exports["startOscillator"] = $foreign.startOscillator;
  exports["stopOscillator"] = $foreign.stopOscillator;
})(PS);
(function(exports) {
  "use strict";


  exports.nodeConnect = function(_) {
    return function(_) {
      return function(source) {
        return function(sink) {
          return function() {
            source.connect(sink);
          };
        };
      };
    };
  };

  exports.nodeDisconnect = function(_) {
    return function(_) {
      return function(source) {
        return function(sink) {
          return function() {
            source.disconnect(sink);
          };
        };
      };
    };
  };

  exports.unsafeConnectParam = function(_) {
    return function(_) {
      return function(source) {
        return function(target) {
          return function(prop) {
            return function() {
              var value = target[prop];
              source.connect(value);
            };
          };
        };
      };
    };
  };
})(PS["Audio.WebAudio.Types"] = PS["Audio.WebAudio.Types"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Audio.WebAudio.Types"] = $PS["Audio.WebAudio.Types"] || {};
  var exports = $PS["Audio.WebAudio.Types"];
  var $foreign = $PS["Audio.WebAudio.Types"];
  var Connectable = function (connect, connectParam, disconnect) {
      this.connect = connect;
      this.connectParam = connectParam;
      this.disconnect = disconnect;
  };
  var connect = function (dict) {
      return dict.connect;
  };                                   
  var connectableGainNode = new Connectable(function (dictRawAudioNode) {
      return $foreign.nodeConnect()();
  }, function (dictRawAudioNode) {
      return $foreign.unsafeConnectParam()();
  }, function (dictRawAudioNode) {
      return $foreign.nodeDisconnect()();
  });                                         
  var connectableDestinationNode = new Connectable(function (dictRawAudioNode) {
      return $foreign.nodeConnect()();
  }, function (dictRawAudioNode) {
      return $foreign.unsafeConnectParam()();
  }, function (dictRawAudioNode) {
      return $foreign.nodeDisconnect()();
  });
  exports["connect"] = connect;
  exports["connectableGainNode"] = connectableGainNode;
  exports["connectableDestinationNode"] = connectableDestinationNode;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.List.NonEmpty"] = $PS["Data.List.NonEmpty"] || {};
  var exports = $PS["Data.List.NonEmpty"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var singleton = (function () {
      var $172 = Data_NonEmpty.singleton(Data_List_Types.plusList);
      return function ($173) {
          return Data_List_Types.NonEmptyList($172($173));
      };
  })();
  var cons = function (y) {
      return function (v) {
          return new Data_NonEmpty.NonEmpty(y, new Data_List_Types.Cons(v.value0, v.value1));
      };
  };
  exports["singleton"] = singleton;
  exports["cons"] = cons;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Applicative.Free"] = $PS["Control.Applicative.Free"] || {};
  var exports = $PS["Control.Applicative.Free"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Category = $PS["Control.Category"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List_NonEmpty = $PS["Data.List.NonEmpty"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Pure = (function () {
      function Pure(value0) {
          this.value0 = value0;
      };
      Pure.create = function (value0) {
          return new Pure(value0);
      };
      return Pure;
  })();
  var Lift = (function () {
      function Lift(value0) {
          this.value0 = value0;
      };
      Lift.create = function (value0) {
          return new Lift(value0);
      };
      return Lift;
  })();
  var Ap = (function () {
      function Ap(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Ap.create = function (value0) {
          return function (value1) {
              return new Ap(value0, value1);
          };
      };
      return Ap;
  })();
  var mkAp = function (fba) {
      return function (fb) {
          return new Ap(fba, fb);
      };
  };
  var liftFreeAp = Lift.create;
  var goLeft = function ($copy_dictApplicative) {
      return function ($copy_fStack) {
          return function ($copy_valStack) {
              return function ($copy_nat) {
                  return function ($copy_func) {
                      return function ($copy_count) {
                          var $tco_var_dictApplicative = $copy_dictApplicative;
                          var $tco_var_fStack = $copy_fStack;
                          var $tco_var_valStack = $copy_valStack;
                          var $tco_var_nat = $copy_nat;
                          var $tco_var_func = $copy_func;
                          var $tco_done = false;
                          var $tco_result;
                          function $tco_loop(dictApplicative, fStack, valStack, nat, func, count) {
                              if (func instanceof Pure) {
                                  $tco_done = true;
                                  return new Data_Tuple.Tuple(new Data_List_Types.Cons({
                                      func: Control_Applicative.pure(dictApplicative)(func.value0),
                                      count: count
                                  }, fStack), valStack);
                              };
                              if (func instanceof Lift) {
                                  $tco_done = true;
                                  return new Data_Tuple.Tuple(new Data_List_Types.Cons({
                                      func: nat(func.value0),
                                      count: count
                                  }, fStack), valStack);
                              };
                              if (func instanceof Ap) {
                                  $tco_var_dictApplicative = dictApplicative;
                                  $tco_var_fStack = fStack;
                                  $tco_var_valStack = Data_List_NonEmpty.cons(func.value1)(valStack);
                                  $tco_var_nat = nat;
                                  $tco_var_func = func.value0;
                                  $copy_count = count + 1 | 0;
                                  return;
                              };
                              throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [ func.constructor.name ]);
                          };
                          while (!$tco_done) {
                              $tco_result = $tco_loop($tco_var_dictApplicative, $tco_var_fStack, $tco_var_valStack, $tco_var_nat, $tco_var_func, $copy_count);
                          };
                          return $tco_result;
                      };
                  };
              };
          };
      };
  };
  var goApply = function ($copy_dictApplicative) {
      return function ($copy_fStack) {
          return function ($copy_vals) {
              return function ($copy_gVal) {
                  var $tco_var_dictApplicative = $copy_dictApplicative;
                  var $tco_var_fStack = $copy_fStack;
                  var $tco_var_vals = $copy_vals;
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(dictApplicative, fStack, vals, gVal) {
                      if (fStack instanceof Data_List_Types.Nil) {
                          $tco_done = true;
                          return new Data_Either.Left(gVal);
                      };
                      if (fStack instanceof Data_List_Types.Cons) {
                          var gRes = Control_Apply.apply(dictApplicative.Apply0())(fStack.value0.func)(gVal);
                          var $14 = fStack.value0.count === 1;
                          if ($14) {
                              if (fStack.value1 instanceof Data_List_Types.Nil) {
                                  $tco_done = true;
                                  return new Data_Either.Left(gRes);
                              };
                              $tco_var_dictApplicative = dictApplicative;
                              $tco_var_fStack = fStack.value1;
                              $tco_var_vals = vals;
                              $copy_gVal = gRes;
                              return;
                          };
                          if (vals instanceof Data_List_Types.Nil) {
                              $tco_done = true;
                              return new Data_Either.Left(gRes);
                          };
                          if (vals instanceof Data_List_Types.Cons) {
                              $tco_done = true;
                              return Data_Either.Right.create(new Data_Tuple.Tuple(new Data_List_Types.Cons({
                                  func: gRes,
                                  count: fStack.value0.count - 1 | 0
                              }, fStack.value1), new Data_NonEmpty.NonEmpty(vals.value0, vals.value1)));
                          };
                          throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [ vals.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [ fStack.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($tco_var_dictApplicative, $tco_var_fStack, $tco_var_vals, $copy_gVal);
                  };
                  return $tco_result;
              };
          };
      };
  };
  var functorFreeAp = new Data_Functor.Functor(function (f) {
      return function (x) {
          return mkAp(new Pure(f))(x);
      };
  });
  var foldFreeAp = function (dictApplicative) {
      return function (nat) {
          return function (z) {
              var go = function ($copy_v) {
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(v) {
                      if (v.value1.value0 instanceof Pure) {
                          var v1 = goApply(dictApplicative)(v.value0)(v.value1.value1)(Control_Applicative.pure(dictApplicative)(v.value1.value0.value0));
                          if (v1 instanceof Data_Either.Left) {
                              $tco_done = true;
                              return v1.value0;
                          };
                          if (v1 instanceof Data_Either.Right) {
                              $copy_v = v1.value0;
                              return;
                          };
                          throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [ v1.constructor.name ]);
                      };
                      if (v.value1.value0 instanceof Lift) {
                          var v1 = goApply(dictApplicative)(v.value0)(v.value1.value1)(nat(v.value1.value0.value0));
                          if (v1 instanceof Data_Either.Left) {
                              $tco_done = true;
                              return v1.value0;
                          };
                          if (v1 instanceof Data_Either.Right) {
                              $copy_v = v1.value0;
                              return;
                          };
                          throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [ v1.constructor.name ]);
                      };
                      if (v.value1.value0 instanceof Ap) {
                          var nextVals = new Data_NonEmpty.NonEmpty(v.value1.value0.value1, v.value1.value1);
                          $copy_v = goLeft(dictApplicative)(v.value0)(nextVals)(nat)(v.value1.value0.value0)(1);
                          return;
                      };
                      throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [ v.value1.value0.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($copy_v);
                  };
                  return $tco_result;
              };
              return go(new Data_Tuple.Tuple(Data_List_Types.Nil.value, Data_List_NonEmpty.singleton(z)));
          };
      };
  };
  var retractFreeAp = function (dictApplicative) {
      return foldFreeAp(dictApplicative)(Control_Category.identity(Control_Category.categoryFn));
  };
  var applyFreeAp = new Control_Apply.Apply(function () {
      return functorFreeAp;
  }, function (fba) {
      return function (fb) {
          return mkAp(fba)(fb);
      };
  });
  var applicativeFreeAp = new Control_Applicative.Applicative(function () {
      return applyFreeAp;
  }, Pure.create);
  var hoistFreeAp = function (f) {
      return foldFreeAp(applicativeFreeAp)(function ($37) {
          return liftFreeAp(f($37));
      });
  };
  exports["retractFreeAp"] = retractFreeAp;
  exports["hoistFreeAp"] = hoistFreeAp;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Trans.Class"] = $PS["Control.Monad.Trans.Class"] || {};
  var exports = $PS["Control.Monad.Trans.Class"];
  var MonadTrans = function (lift) {
      this.lift = lift;
  };
  var lift = function (dict) {
      return dict.lift;
  };
  exports["lift"] = lift;
  exports["MonadTrans"] = MonadTrans;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Except.Trans"] = $PS["Control.Monad.Except.Trans"] || {};
  var exports = $PS["Control.Monad.Except.Trans"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];                
  var ExceptT = function (x) {
      return x;
  };
  var runExceptT = function (v) {
      return v;
  }; 
  var monadTransExceptT = new Control_Monad_Trans_Class.MonadTrans(function (dictMonad) {
      return function (m) {
          return Control_Bind.bind(dictMonad.Bind1())(m)(function (a) {
              return Control_Applicative.pure(dictMonad.Applicative0())(new Data_Either.Right(a));
          });
      };
  });
  var mapExceptT = function (f) {
      return function (v) {
          return f(v);
      };
  };
  var functorExceptT = function (dictFunctor) {
      return new Data_Functor.Functor(function (f) {
          return mapExceptT(Data_Functor.map(dictFunctor)(Data_Functor.map(Data_Either.functorEither)(f)));
      });
  };
  var monadExceptT = function (dictMonad) {
      return new Control_Monad.Monad(function () {
          return applicativeExceptT(dictMonad);
      }, function () {
          return bindExceptT(dictMonad);
      });
  };
  var bindExceptT = function (dictMonad) {
      return new Control_Bind.Bind(function () {
          return applyExceptT(dictMonad);
      }, function (v) {
          return function (k) {
              return Control_Bind.bind(dictMonad.Bind1())(v)(Data_Either.either((function () {
                  var $91 = Control_Applicative.pure(dictMonad.Applicative0());
                  return function ($92) {
                      return $91(Data_Either.Left.create($92));
                  };
              })())(function (a) {
                  var v1 = k(a);
                  return v1;
              }));
          };
      });
  };
  var applyExceptT = function (dictMonad) {
      return new Control_Apply.Apply(function () {
          return functorExceptT(((dictMonad.Bind1()).Apply0()).Functor0());
      }, Control_Monad.ap(monadExceptT(dictMonad)));
  };
  var applicativeExceptT = function (dictMonad) {
      return new Control_Applicative.Applicative(function () {
          return applyExceptT(dictMonad);
      }, (function () {
          var $93 = Control_Applicative.pure(dictMonad.Applicative0());
          return function ($94) {
              return ExceptT($93(Data_Either.Right.create($94)));
          };
      })());
  };
  var monadThrowExceptT = function (dictMonad) {
      return new Control_Monad_Error_Class.MonadThrow(function () {
          return monadExceptT(dictMonad);
      }, (function () {
          var $103 = Control_Applicative.pure(dictMonad.Applicative0());
          return function ($104) {
              return ExceptT($103(Data_Either.Left.create($104)));
          };
      })());
  };
  var monadErrorExceptT = function (dictMonad) {
      return new Control_Monad_Error_Class.MonadError(function () {
          return monadThrowExceptT(dictMonad);
      }, function (v) {
          return function (k) {
              return Control_Bind.bind(dictMonad.Bind1())(v)(Data_Either.either(function (a) {
                  var v1 = k(a);
                  return v1;
              })((function () {
                  var $105 = Control_Applicative.pure(dictMonad.Applicative0());
                  return function ($106) {
                      return $105(Data_Either.Right.create($106));
                  };
              })()));
          };
      });
  };
  exports["runExceptT"] = runExceptT;
  exports["applicativeExceptT"] = applicativeExceptT;
  exports["bindExceptT"] = bindExceptT;
  exports["monadExceptT"] = monadExceptT;
  exports["monadTransExceptT"] = monadTransExceptT;
  exports["monadThrowExceptT"] = monadThrowExceptT;
  exports["monadErrorExceptT"] = monadErrorExceptT;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Except"] = $PS["Control.Monad.Except"] || {};
  var exports = $PS["Control.Monad.Except"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Newtype = $PS["Data.Newtype"];                                                
  var runExcept = (function () {
      var $0 = Data_Newtype.unwrap();
      return function ($1) {
          return $0(Control_Monad_Except_Trans.runExceptT($1));
      };
  })();
  exports["runExcept"] = runExcept;
})(PS);
(function(exports) {
  /* globals setImmediate, clearImmediate, setTimeout, clearTimeout */
  /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */
  "use strict";

  var Aff = function () {
    // A unique value for empty.
    var EMPTY = {};

    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */  
    var PURE    = "Pure";
    var THROW   = "Throw";
    var CATCH   = "Catch";
    var SYNC    = "Sync";
    var ASYNC   = "Async";
    var BIND    = "Bind";
    var BRACKET = "Bracket";
    var FORK    = "Fork";
    var SEQ     = "Sequential";

    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */  
    var MAP   = "Map";
    var APPLY = "Apply";
    var ALT   = "Alt";

    // Various constructors used in interpretation
    var CONS      = "Cons";      // Cons-list, for stacks
    var RESUME    = "Resume";    // Continue indiscriminately
    var RELEASE   = "Release";   // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED    = "Forked";    // Reference to a forked fiber, with resumption stack
    var FIBER     = "Fiber";     // Actual fiber reference
    var THUNK     = "Thunk";     // Primed effect, ready to invoke

    function Aff(tag, _1, _2, _3) {
      this.tag = tag;
      this._1  = _1;
      this._2  = _2;
      this._3  = _3;
    }

    function AffCtr(tag) {
      var fn = function (_1, _2, _3) {
        return new Aff(tag, _1, _2, _3);
      };
      fn.tag = tag;
      return fn;
    }

    function nonCanceler(error) {
      return new Aff(PURE, void 0);
    }

    function runEff(eff) {
      try {
        eff();
      } catch (error) {
        setTimeout(function () {
          throw error;
        }, 0);
      }
    }

    function runSync(left, right, eff) {
      try {
        return right(eff());
      } catch (error) {
        return left(error);
      }
    }

    function runAsync(left, eff, k) {
      try {
        return eff(k)();
      } catch (error) {
        k(left(error))();
        return nonCanceler;
      }
    }

    var Scheduler = function () {
      var limit    = 1024;
      var size     = 0;
      var ix       = 0;
      var queue    = new Array(limit);
      var draining = false;

      function drain() {
        var thunk;
        draining = true;
        while (size !== 0) {
          size--;
          thunk     = queue[ix];
          queue[ix] = void 0;
          ix        = (ix + 1) % limit;
          thunk();
        }
        draining = false;
      }

      return {
        isDraining: function () {
          return draining;
        },
        enqueue: function (cb) {
          var i, tmp;
          if (size === limit) {
            tmp = draining;
            drain();
            draining = tmp;
          }

          queue[(ix + size) % limit] = cb;
          size++;

          if (!draining) {
            drain();
          }
        }
      };
    }();

    function Supervisor(util) {
      var fibers  = {};
      var fiberId = 0;
      var count   = 0;

      return {
        register: function (fiber) {
          var fid = fiberId++;
          fiber.onComplete({
            rethrow: true,
            handler: function (result) {
              return function () {
                count--;
                delete fibers[fid];
              };
            }
          })();
          fibers[fid] = fiber;
          count++;
        },
        isEmpty: function () {
          return count === 0;
        },
        killAll: function (killError, cb) {
          return function () {
            if (count === 0) {
              return cb();
            }

            var killCount = 0;
            var kills     = {};

            function kill(fid) {
              kills[fid] = fibers[fid].kill(killError, function (result) {
                return function () {
                  delete kills[fid];
                  killCount--;
                  if (util.isLeft(result) && util.fromLeft(result)) {
                    setTimeout(function () {
                      throw util.fromLeft(result);
                    }, 0);
                  }
                  if (killCount === 0) {
                    cb();
                  }
                };
              })();
            }

            for (var k in fibers) {
              if (fibers.hasOwnProperty(k)) {
                killCount++;
                kill(k);
              }
            }

            fibers  = {};
            fiberId = 0;
            count   = 0;

            return function (error) {
              return new Aff(SYNC, function () {
                for (var k in kills) {
                  if (kills.hasOwnProperty(k)) {
                    kills[k]();
                  }
                }
              });
            };
          };
        }
      };
    }

    // Fiber state machine
    var SUSPENDED   = 0; // Suspended, pending a join.
    var CONTINUE    = 1; // Interpret the next instruction.
    var STEP_BIND   = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING     = 4; // An async effect is running.
    var RETURN      = 5; // The current stack has returned.
    var COMPLETED   = 6; // The entire fiber has completed.

    function Fiber(util, supervisor, aff) {
      // Monotonically increasing tick, increased on each asynchronous turn.
      var runTick = 0;

      // The current branch of the state machine.
      var status = SUSPENDED;

      // The current point of interest for the state machine branch.
      var step      = aff;  // Successful step
      var fail      = null; // Failure step
      var interrupt = null; // Asynchronous interrupt

      // Stack of continuations for the current fiber.
      var bhead = null;
      var btail = null;

      // Stack of attempts and finalizers for error recovery. Every `Cons` is also
      // tagged with current `interrupt` state. We use this to track which items
      // should be ignored or evaluated as a result of a kill.
      var attempts = null;

      // A special state is needed for Bracket, because it cannot be killed. When
      // we enter a bracket acquisition or finalizer, we increment the counter,
      // and then decrement once complete.
      var bracketCount = 0;

      // Each join gets a new id so they can be revoked.
      var joinId  = 0;
      var joins   = null;
      var rethrow = true;

      // Each invocation of `run` requires a tick. When an asynchronous effect is
      // resolved, we must check that the local tick coincides with the fiber
      // tick before resuming. This prevents multiple async continuations from
      // accidentally resuming the same fiber. A common example may be invoking
      // the provided callback in `makeAff` more than once, but it may also be an
      // async effect resuming after the fiber was already cancelled.
      function run(localRunTick) {
        var tmp, result, attempt;
        while (true) {
          tmp       = null;
          result    = null;
          attempt   = null;

          switch (status) {
          case STEP_BIND:
            status = CONTINUE;
            try {
              step   = bhead(step);
              if (btail === null) {
                bhead = null;
              } else {
                bhead = btail._1;
                btail = btail._2;
              }
            } catch (e) {
              status = RETURN;
              fail   = util.left(e);
              step   = null;
            }
            break;

          case STEP_RESULT:
            if (util.isLeft(step)) {
              status = RETURN;
              fail   = step;
              step   = null;
            } else if (bhead === null) {
              status = RETURN;
            } else {
              status = STEP_BIND;
              step   = util.fromRight(step);
            }
            break;

          case CONTINUE:
            switch (step.tag) {
            case BIND:
              if (bhead) {
                btail = new Aff(CONS, bhead, btail);
              }
              bhead  = step._2;
              status = CONTINUE;
              step   = step._1;
              break;

            case PURE:
              if (bhead === null) {
                status = RETURN;
                step   = util.right(step._1);
              } else {
                status = STEP_BIND;
                step   = step._1;
              }
              break;

            case SYNC:
              status = STEP_RESULT;
              step   = runSync(util.left, util.right, step._1);
              break;

            case ASYNC:
              status = PENDING;
              step   = runAsync(util.left, step._1, function (result) {
                return function () {
                  if (runTick !== localRunTick) {
                    return;
                  }
                  runTick++;
                  Scheduler.enqueue(function () {
                    // It's possible to interrupt the fiber between enqueuing and
                    // resuming, so we need to check that the runTick is still
                    // valid.
                    if (runTick !== localRunTick + 1) {
                      return;
                    }
                    status = STEP_RESULT;
                    step   = result;
                    run(runTick);
                  });
                };
              });
              return;

            case THROW:
              status = RETURN;
              fail   = util.left(step._1);
              step   = null;
              break;

            // Enqueue the Catch so that we can call the error handler later on
            // in case of an exception.
            case CATCH:
              if (bhead === null) {
                attempts = new Aff(CONS, step, attempts, interrupt);
              } else {
                attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
              }
              bhead    = null;
              btail    = null;
              status   = CONTINUE;
              step     = step._1;
              break;

            // Enqueue the Bracket so that we can call the appropriate handlers
            // after resource acquisition.
            case BRACKET:
              bracketCount++;
              if (bhead === null) {
                attempts = new Aff(CONS, step, attempts, interrupt);
              } else {
                attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
              }
              bhead  = null;
              btail  = null;
              status = CONTINUE;
              step   = step._1;
              break;

            case FORK:
              status = STEP_RESULT;
              tmp    = Fiber(util, supervisor, step._2);
              if (supervisor) {
                supervisor.register(tmp);
              }
              if (step._1) {
                tmp.run();
              }
              step = util.right(tmp);
              break;

            case SEQ:
              status = CONTINUE;
              step   = sequential(util, supervisor, step._1);
              break;
            }
            break;

          case RETURN:
            bhead = null;
            btail = null;
            // If the current stack has returned, and we have no other stacks to
            // resume or finalizers to run, the fiber has halted and we can
            // invoke all join callbacks. Otherwise we need to resume.
            if (attempts === null) {
              status = COMPLETED;
              step   = interrupt || fail || step;
            } else {
              // The interrupt status for the enqueued item.
              tmp      = attempts._3;
              attempt  = attempts._1;
              attempts = attempts._2;

              switch (attempt.tag) {
              // We cannot recover from an unmasked interrupt. Otherwise we should
              // continue stepping, or run the exception handler if an exception
              // was raised.
              case CATCH:
                // We should compare the interrupt status as well because we
                // only want it to apply if there has been an interrupt since
                // enqueuing the catch.
                if (interrupt && interrupt !== tmp && bracketCount === 0) {
                  status = RETURN;
                } else if (fail) {
                  status = CONTINUE;
                  step   = attempt._2(util.fromLeft(fail));
                  fail   = null;
                }
                break;

              // We cannot resume from an unmasked interrupt or exception.
              case RESUME:
                // As with Catch, we only want to ignore in the case of an
                // interrupt since enqueing the item.
                if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) {
                  status = RETURN;
                } else {
                  bhead  = attempt._1;
                  btail  = attempt._2;
                  status = STEP_BIND;
                  step   = util.fromRight(step);
                }
                break;

              // If we have a bracket, we should enqueue the handlers,
              // and continue with the success branch only if the fiber has
              // not been interrupted. If the bracket acquisition failed, we
              // should not run either.
              case BRACKET:
                bracketCount--;
                if (fail === null) {
                  result   = util.fromRight(step);
                  // We need to enqueue the Release with the same interrupt
                  // status as the Bracket that is initiating it.
                  attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                  // We should only coninue as long as the interrupt status has not changed or
                  // we are currently within a non-interruptable finalizer.
                  if (interrupt === tmp || bracketCount > 0) {
                    status = CONTINUE;
                    step   = attempt._3(result);
                  }
                }
                break;

              // Enqueue the appropriate handler. We increase the bracket count
              // because it should not be cancelled.
              case RELEASE:
                attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                status   = CONTINUE;
                // It has only been killed if the interrupt status has changed
                // since we enqueued the item, and the bracket count is 0. If the
                // bracket count is non-zero then we are in a masked state so it's
                // impossible to be killed.
                if (interrupt && interrupt !== tmp && bracketCount === 0) {
                  step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                } else if (fail) {
                  step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                } else {
                  step = attempt._1.completed(util.fromRight(step))(attempt._2);
                }
                fail = null;
                bracketCount++;
                break;

              case FINALIZER:
                bracketCount++;
                attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                status   = CONTINUE;
                step     = attempt._1;
                break;

              case FINALIZED:
                bracketCount--;
                status = RETURN;
                step   = attempt._1;
                fail   = attempt._2;
                break;
              }
            }
            break;

          case COMPLETED:
            for (var k in joins) {
              if (joins.hasOwnProperty(k)) {
                rethrow = rethrow && joins[k].rethrow;
                runEff(joins[k].handler(step));
              }
            }
            joins = null;
            // If we have an interrupt and a fail, then the thread threw while
            // running finalizers. This should always rethrow in a fresh stack.
            if (interrupt && fail) {
              setTimeout(function () {
                throw util.fromLeft(fail);
              }, 0);
            // If we have an unhandled exception, and no other fiber has joined
            // then we need to throw the exception in a fresh stack.
            } else if (util.isLeft(step) && rethrow) {
              setTimeout(function () {
                // Guard on reathrow because a completely synchronous fiber can
                // still have an observer which was added after-the-fact.
                if (rethrow) {
                  throw util.fromLeft(step);
                }
              }, 0);
            }
            return;
          case SUSPENDED:
            status = CONTINUE;
            break;
          case PENDING: return;
          }
        }
      }

      function onComplete(join) {
        return function () {
          if (status === COMPLETED) {
            rethrow = rethrow && join.rethrow;
            join.handler(step)();
            return function () {};
          }

          var jid    = joinId++;
          joins      = joins || {};
          joins[jid] = join;

          return function() {
            if (joins !== null) {
              delete joins[jid];
            }
          };
        };
      }

      function kill(error, cb) {
        return function () {
          if (status === COMPLETED) {
            cb(util.right(void 0))();
            return function () {};
          }

          var canceler = onComplete({
            rethrow: false,
            handler: function (/* unused */) {
              return cb(util.right(void 0));
            }
          })();

          switch (status) {
          case SUSPENDED:
            interrupt = util.left(error);
            status    = COMPLETED;
            step      = interrupt;
            run(runTick);
            break;
          case PENDING:
            if (interrupt === null) {
              interrupt = util.left(error);
            }
            if (bracketCount === 0) {
              if (status === PENDING) {
                attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
              }
              status   = RETURN;
              step     = null;
              fail     = null;
              run(++runTick);
            }
            break;
          default:
            if (interrupt === null) {
              interrupt = util.left(error);
            }
            if (bracketCount === 0) {
              status = RETURN;
              step   = null;
              fail   = null;
            }
          }

          return canceler;
        };
      }

      function join(cb) {
        return function () {
          var canceler = onComplete({
            rethrow: false,
            handler: cb
          })();
          if (status === SUSPENDED) {
            run(runTick);
          }
          return canceler;
        };
      }

      return {
        kill: kill,
        join: join,
        onComplete: onComplete,
        isSuspended: function () {
          return status === SUSPENDED;
        },
        run: function () {
          if (status === SUSPENDED) {
            if (!Scheduler.isDraining()) {
              Scheduler.enqueue(function () {
                run(runTick);
              });
            } else {
              run(runTick);
            }
          }
        }
      };
    }

    function runPar(util, supervisor, par, cb) {
      // Table of all forked fibers.
      var fiberId   = 0;
      var fibers    = {};

      // Table of currently running cancelers, as a product of `Alt` behavior.
      var killId    = 0;
      var kills     = {};

      // Error used for early cancelation on Alt branches.
      var early     = new Error("[ParAff] Early exit");

      // Error used to kill the entire tree.
      var interrupt = null;

      // The root pointer of the tree.
      var root      = EMPTY;

      // Walks a tree, invoking all the cancelers. Returns the table of pending
      // cancellation fibers.
      function kill(error, par, cb) {
        var step  = par;
        var head  = null;
        var tail  = null;
        var count = 0;
        var kills = {};
        var tmp, kid;

        loop: while (true) {
          tmp = null;

          switch (step.tag) {
          case FORKED:
            if (step._3 === EMPTY) {
              tmp = fibers[step._1];
              kills[count++] = tmp.kill(error, function (result) {
                return function () {
                  count--;
                  if (count === 0) {
                    cb(result)();
                  }
                };
              });
            }
            // Terminal case.
            if (head === null) {
              break loop;
            }
            // Go down the right side of the tree.
            step = head._2;
            if (tail === null) {
              head = null;
            } else {
              head = tail._1;
              tail = tail._2;
            }
            break;
          case MAP:
            step = step._2;
            break;
          case APPLY:
          case ALT:
            if (head) {
              tail = new Aff(CONS, head, tail);
            }
            head = step;
            step = step._1;
            break;
          }
        }

        if (count === 0) {
          cb(util.right(void 0))();
        } else {
          // Run the cancelation effects. We alias `count` because it's mutable.
          kid = 0;
          tmp = count;
          for (; kid < tmp; kid++) {
            kills[kid] = kills[kid]();
          }
        }

        return kills;
      }

      // When a fiber resolves, we need to bubble back up the tree with the
      // result, computing the applicative nodes.
      function join(result, head, tail) {
        var fail, step, lhs, rhs, tmp, kid;

        if (util.isLeft(result)) {
          fail = result;
          step = null;
        } else {
          step = result;
          fail = null;
        }

        loop: while (true) {
          lhs = null;
          rhs = null;
          tmp = null;
          kid = null;

          // We should never continue if the entire tree has been interrupted.
          if (interrupt !== null) {
            return;
          }

          // We've made it all the way to the root of the tree, which means
          // the tree has fully evaluated.
          if (head === null) {
            cb(fail || step)();
            return;
          }

          // The tree has already been computed, so we shouldn't try to do it
          // again. This should never happen.
          // TODO: Remove this?
          if (head._3 !== EMPTY) {
            return;
          }

          switch (head.tag) {
          case MAP:
            if (fail === null) {
              head._3 = util.right(head._1(util.fromRight(step)));
              step    = head._3;
            } else {
              head._3 = fail;
            }
            break;
          case APPLY:
            lhs = head._1._3;
            rhs = head._2._3;
            // If we have a failure we should kill the other side because we
            // can't possible yield a result anymore.
            if (fail) {
              head._3 = fail;
              tmp     = true;
              kid     = killId++;

              kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function (/* unused */) {
                return function () {
                  delete kills[kid];
                  if (tmp) {
                    tmp = false;
                  } else if (tail === null) {
                    join(fail, null, null);
                  } else {
                    join(fail, tail._1, tail._2);
                  }
                };
              });

              if (tmp) {
                tmp = false;
                return;
              }
            } else if (lhs === EMPTY || rhs === EMPTY) {
              // We can only proceed if both sides have resolved.
              return;
            } else {
              step    = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
              head._3 = step;
            }
            break;
          case ALT:
            lhs = head._1._3;
            rhs = head._2._3;
            // We can only proceed if both have resolved or we have a success
            if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) {
              return;
            }
            // If both sides resolve with an error, we should continue with the
            // first error
            if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
              fail    = step === lhs ? rhs : lhs;
              step    = null;
              head._3 = fail;
            } else {
              head._3 = step;
              tmp     = true;
              kid     = killId++;
              // Once a side has resolved, we need to cancel the side that is still
              // pending before we can continue.
              kills[kid] = kill(early, step === lhs ? head._2 : head._1, function (/* unused */) {
                return function () {
                  delete kills[kid];
                  if (tmp) {
                    tmp = false;
                  } else if (tail === null) {
                    join(step, null, null);
                  } else {
                    join(step, tail._1, tail._2);
                  }
                };
              });

              if (tmp) {
                tmp = false;
                return;
              }
            }
            break;
          }

          if (tail === null) {
            head = null;
          } else {
            head = tail._1;
            tail = tail._2;
          }
        }
      }

      function resolve(fiber) {
        return function (result) {
          return function () {
            delete fibers[fiber._1];
            fiber._3 = result;
            join(result, fiber._2._1, fiber._2._2);
          };
        };
      }

      // Walks the applicative tree, substituting non-applicative nodes with
      // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
      // as a mutable slot for memoization. In an unresolved state, the `_3`
      // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
      // the left side first, because both operations are left-associative. As
      // we `RETURN` from those branches, we then walk the right side.
      function run() {
        var status = CONTINUE;
        var step   = par;
        var head   = null;
        var tail   = null;
        var tmp, fid;

        loop: while (true) {
          tmp = null;
          fid = null;

          switch (status) {
          case CONTINUE:
            switch (step.tag) {
            case MAP:
              if (head) {
                tail = new Aff(CONS, head, tail);
              }
              head = new Aff(MAP, step._1, EMPTY, EMPTY);
              step = step._2;
              break;
            case APPLY:
              if (head) {
                tail = new Aff(CONS, head, tail);
              }
              head = new Aff(APPLY, EMPTY, step._2, EMPTY);
              step = step._1;
              break;
            case ALT:
              if (head) {
                tail = new Aff(CONS, head, tail);
              }
              head = new Aff(ALT, EMPTY, step._2, EMPTY);
              step = step._1;
              break;
            default:
              // When we hit a leaf value, we suspend the stack in the `FORKED`.
              // When the fiber resolves, it can bubble back up the tree.
              fid    = fiberId++;
              status = RETURN;
              tmp    = step;
              step   = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
              tmp    = Fiber(util, supervisor, tmp);
              tmp.onComplete({
                rethrow: false,
                handler: resolve(step)
              })();
              fibers[fid] = tmp;
              if (supervisor) {
                supervisor.register(tmp);
              }
            }
            break;
          case RETURN:
            // Terminal case, we are back at the root.
            if (head === null) {
              break loop;
            }
            // If we are done with the right side, we need to continue down the
            // left. Otherwise we should continue up the stack.
            if (head._1 === EMPTY) {
              head._1 = step;
              status  = CONTINUE;
              step    = head._2;
              head._2 = EMPTY;
            } else {
              head._2 = step;
              step    = head;
              if (tail === null) {
                head  = null;
              } else {
                head  = tail._1;
                tail  = tail._2;
              }
            }
          }
        }

        // Keep a reference to the tree root so it can be cancelled.
        root = step;

        for (fid = 0; fid < fiberId; fid++) {
          fibers[fid].run();
        }
      }

      // Cancels the entire tree. If there are already subtrees being canceled,
      // we need to first cancel those joins. We will then add fresh joins for
      // all pending branches including those that were in the process of being
      // canceled.
      function cancel(error, cb) {
        interrupt = util.left(error);
        var innerKills;
        for (var kid in kills) {
          if (kills.hasOwnProperty(kid)) {
            innerKills = kills[kid];
            for (kid in innerKills) {
              if (innerKills.hasOwnProperty(kid)) {
                innerKills[kid]();
              }
            }
          }
        }

        kills = null;
        var newKills = kill(error, root, cb);

        return function (killError) {
          return new Aff(ASYNC, function (killCb) {
            return function () {
              for (var kid in newKills) {
                if (newKills.hasOwnProperty(kid)) {
                  newKills[kid]();
                }
              }
              return nonCanceler;
            };
          });
        };
      }

      run();

      return function (killError) {
        return new Aff(ASYNC, function (killCb) {
          return function () {
            return cancel(killError, killCb);
          };
        });
      };
    }

    function sequential(util, supervisor, par) {
      return new Aff(ASYNC, function (cb) {
        return function () {
          return runPar(util, supervisor, par, cb);
        };
      });
    }

    Aff.EMPTY       = EMPTY;
    Aff.Pure        = AffCtr(PURE);
    Aff.Throw       = AffCtr(THROW);
    Aff.Catch       = AffCtr(CATCH);
    Aff.Sync        = AffCtr(SYNC);
    Aff.Async       = AffCtr(ASYNC);
    Aff.Bind        = AffCtr(BIND);
    Aff.Bracket     = AffCtr(BRACKET);
    Aff.Fork        = AffCtr(FORK);
    Aff.Seq         = AffCtr(SEQ);
    Aff.ParMap      = AffCtr(MAP);
    Aff.ParApply    = AffCtr(APPLY);
    Aff.ParAlt      = AffCtr(ALT);
    Aff.Fiber       = Fiber;
    Aff.Supervisor  = Supervisor;
    Aff.Scheduler   = Scheduler;
    Aff.nonCanceler = nonCanceler;

    return Aff;
  }();

  exports._pure = Aff.Pure;

  exports._throwError = Aff.Throw;

  exports._catchError = function (aff) {
    return function (k) {
      return Aff.Catch(aff, k);
    };
  };

  exports._map = function (f) {
    return function (aff) {
      if (aff.tag === Aff.Pure.tag) {
        return Aff.Pure(f(aff._1));
      } else {
        return Aff.Bind(aff, function (value) {
          return Aff.Pure(f(value));
        });
      }
    };
  };

  exports._bind = function (aff) {
    return function (k) {
      return Aff.Bind(aff, k);
    };
  };

  exports._fork = function (immediate) {
    return function (aff) {
      return Aff.Fork(immediate, aff);
    };
  };

  exports._liftEffect = Aff.Sync;

  exports._parAffMap = function (f) {
    return function (aff) {
      return Aff.ParMap(f, aff);
    };
  };

  exports._parAffApply = function (aff1) {
    return function (aff2) {
      return Aff.ParApply(aff1, aff2);
    };
  };

  exports.makeAff = Aff.Async;

  exports.generalBracket = function (acquire) {
    return function (options) {
      return function (k) {
        return Aff.Bracket(acquire, options, k);
      };
    };
  };

  exports._makeFiber = function (util, aff) {
    return function () {
      return Aff.Fiber(util, null, aff);
    };
  };

  exports._delay = function () {
    function setDelay(n, k) {
      if (n === 0 && typeof setImmediate !== "undefined") {
        return setImmediate(k);
      } else {
        return setTimeout(k, n);
      }
    }

    function clearDelay(n, t) {
      if (n === 0 && typeof clearImmediate !== "undefined") {
        return clearImmediate(t);
      } else {
        return clearTimeout(t);
      }
    }

    return function (right, ms) {
      return Aff.Async(function (cb) {
        return function () {
          var timer = setDelay(ms, cb(right()));
          return function () {
            return Aff.Sync(function () {
              return right(clearDelay(ms, timer));
            });
          };
        };
      });
    };
  }();

  exports._sequential = Aff.Seq;
})(PS["Effect.Aff"] = PS["Effect.Aff"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Rec.Class"] = $PS["Control.Monad.Rec.Class"] || {};
  var exports = $PS["Control.Monad.Rec.Class"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Ref = $PS["Effect.Ref"];                
  var Loop = (function () {
      function Loop(value0) {
          this.value0 = value0;
      };
      Loop.create = function (value0) {
          return new Loop(value0);
      };
      return Loop;
  })();
  var Done = (function () {
      function Done(value0) {
          this.value0 = value0;
      };
      Done.create = function (value0) {
          return new Done(value0);
      };
      return Done;
  })();
  var MonadRec = function (Monad0, tailRecM) {
      this.Monad0 = Monad0;
      this.tailRecM = tailRecM;
  };
  var tailRecM = function (dict) {
      return dict.tailRecM;
  }; 
  var monadRecEffect = new MonadRec(function () {
      return Effect.monadEffect;
  }, function (f) {
      return function (a) {
          var fromDone = function (v) {
              if (v instanceof Done) {
                  return v.value0;
              };
              throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 113, column 30 - line 113, column 44): " + [ v.constructor.name ]);
          };
          return function __do() {
              var r = Control_Bind.bindFlipped(Effect.bindEffect)(Effect_Ref["new"])(f(a))();
              (function () {
                  while (!(function __do() {
                      var v = Effect_Ref.read(r)();
                      if (v instanceof Loop) {
                          var e = f(v.value0)();
                          Effect_Ref.write(e)(r)();
                          return false;
                      };
                      if (v instanceof Done) {
                          return true;
                      };
                      throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 104, column 22 - line 109, column 28): " + [ v.constructor.name ]);
                  })()) {

                  };
                  return {};
              })();
              return Data_Functor.map(Effect.functorEffect)(fromDone)(Effect_Ref.read(r))();
          };
      };
  });
  var forever = function (dictMonadRec) {
      return function (ma) {
          return tailRecM(dictMonadRec)(function (u) {
              return Data_Functor.voidRight((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0())(new Loop(u))(ma);
          })(Data_Unit.unit);
      };
  };
  exports["Loop"] = Loop;
  exports["Done"] = Done;
  exports["MonadRec"] = MonadRec;
  exports["tailRecM"] = tailRecM;
  exports["forever"] = forever;
  exports["monadRecEffect"] = monadRecEffect;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Parallel.Class"] = $PS["Control.Parallel.Class"] || {};
  var exports = $PS["Control.Parallel.Class"];       
  var Parallel = function (Applicative1, Monad0, parallel, sequential) {
      this.Applicative1 = Applicative1;
      this.Monad0 = Monad0;
      this.parallel = parallel;
      this.sequential = sequential;
  };
  var sequential = function (dict) {
      return dict.sequential;
  };
  var parallel = function (dict) {
      return dict.parallel;
  };
  exports["parallel"] = parallel;
  exports["sequential"] = sequential;
  exports["Parallel"] = Parallel;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Class"] = $PS["Effect.Class"] || {};
  var exports = $PS["Effect.Class"];
  var Control_Category = $PS["Control.Category"];
  var Effect = $PS["Effect"];                
  var MonadEffect = function (Monad0, liftEffect) {
      this.Monad0 = Monad0;
      this.liftEffect = liftEffect;
  };
  var monadEffectEffect = new MonadEffect(function () {
      return Effect.monadEffect;
  }, Control_Category.identity(Control_Category.categoryFn));
  var liftEffect = function (dict) {
      return dict.liftEffect;
  };
  exports["liftEffect"] = liftEffect;
  exports["MonadEffect"] = MonadEffect;
  exports["monadEffectEffect"] = monadEffectEffect;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafePerformEffect = function (f) {
    return f();
  };
})(PS["Effect.Unsafe"] = PS["Effect.Unsafe"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Unsafe"] = $PS["Effect.Unsafe"] || {};
  var exports = $PS["Effect.Unsafe"];
  var $foreign = $PS["Effect.Unsafe"];
  exports["unsafePerformEffect"] = $foreign.unsafePerformEffect;
})(PS);
(function(exports) {
  "use strict";

  // module Partial.Unsafe

  exports._unsafePartial = function (f) {
    return f();
  };
})(PS["Partial.Unsafe"] = PS["Partial.Unsafe"] || {});
(function(exports) {
  "use strict";

  // module Partial

  exports._crashWith = function (msg) {
    throw new Error(msg);
  };
})(PS["Partial"] = PS["Partial"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Partial"] = $PS["Partial"] || {};
  var exports = $PS["Partial"];
  var $foreign = $PS["Partial"];         
  var crashWith = function (dictPartial) {
      return $foreign["_crashWith"];
  };
  exports["crashWith"] = crashWith;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Partial.Unsafe"] = $PS["Partial.Unsafe"] || {};
  var exports = $PS["Partial.Unsafe"];
  var $foreign = $PS["Partial.Unsafe"];
  var Partial = $PS["Partial"];                
  var unsafePartial = $foreign["_unsafePartial"];
  var unsafeCrashWith = function (msg) {
      return unsafePartial(function (dictPartial) {
          return Partial.crashWith()(msg);
      });
  };
  exports["unsafeCrashWith"] = unsafeCrashWith;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Aff"] = $PS["Effect.Aff"] || {};
  var exports = $PS["Effect.Aff"];
  var $foreign = $PS["Effect.Aff"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Control_Parallel_Class = $PS["Control.Parallel.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Unsafe = $PS["Effect.Unsafe"];
  var Partial_Unsafe = $PS["Partial.Unsafe"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Canceler = function (x) {
      return x;
  };
  var suspendAff = $foreign["_fork"](false);
  var functorParAff = new Data_Functor.Functor($foreign["_parAffMap"]);
  var functorAff = new Data_Functor.Functor($foreign["_map"]);
  var forkAff = $foreign["_fork"](true);
  var ffiUtil = (function () {
      var unsafeFromRight = function (v) {
          if (v instanceof Data_Either.Right) {
              return v.value0;
          };
          if (v instanceof Data_Either.Left) {
              return Partial_Unsafe.unsafeCrashWith("unsafeFromRight: Left");
          };
          throw new Error("Failed pattern match at Effect.Aff (line 404, column 21 - line 406, column 54): " + [ v.constructor.name ]);
      };
      var unsafeFromLeft = function (v) {
          if (v instanceof Data_Either.Left) {
              return v.value0;
          };
          if (v instanceof Data_Either.Right) {
              return Partial_Unsafe.unsafeCrashWith("unsafeFromLeft: Right");
          };
          throw new Error("Failed pattern match at Effect.Aff (line 399, column 20 - line 401, column 54): " + [ v.constructor.name ]);
      };
      var isLeft = function (v) {
          if (v instanceof Data_Either.Left) {
              return true;
          };
          if (v instanceof Data_Either.Right) {
              return false;
          };
          throw new Error("Failed pattern match at Effect.Aff (line 394, column 12 - line 396, column 20): " + [ v.constructor.name ]);
      };
      return {
          isLeft: isLeft,
          fromLeft: unsafeFromLeft,
          fromRight: unsafeFromRight,
          left: Data_Either.Left.create,
          right: Data_Either.Right.create
      };
  })();
  var makeFiber = function (aff) {
      return $foreign["_makeFiber"](ffiUtil, aff);
  };
  var launchAff = function (aff) {
      return function __do() {
          var fiber = makeFiber(aff)();
          fiber.run();
          return fiber;
      };
  };
  var launchAff_ = (function () {
      var $40 = Data_Functor["void"](Effect.functorEffect);
      return function ($41) {
          return $40(launchAff($41));
      };
  })();                              
  var delay = function (v) {
      return $foreign["_delay"](Data_Either.Right.create, v);
  };
  var bracket = function (acquire) {
      return function (completed) {
          return $foreign.generalBracket(acquire)({
              killed: Data_Function["const"](completed),
              failed: Data_Function["const"](completed),
              completed: Data_Function["const"](completed)
          });
      };
  };
  var applyParAff = new Control_Apply.Apply(function () {
      return functorParAff;
  }, $foreign["_parAffApply"]);
  var monadAff = new Control_Monad.Monad(function () {
      return applicativeAff;
  }, function () {
      return bindAff;
  });
  var bindAff = new Control_Bind.Bind(function () {
      return applyAff;
  }, $foreign["_bind"]);
  var applyAff = new Control_Apply.Apply(function () {
      return functorAff;
  }, Control_Monad.ap(monadAff));
  var applicativeAff = new Control_Applicative.Applicative(function () {
      return applyAff;
  }, $foreign["_pure"]);
  var $$finally = function (fin) {
      return function (a) {
          return bracket(Control_Applicative.pure(applicativeAff)(Data_Unit.unit))(Data_Function["const"](fin))(Data_Function["const"](a));
      };
  };
  var monadEffectAff = new Effect_Class.MonadEffect(function () {
      return monadAff;
  }, $foreign["_liftEffect"]);
  var effectCanceler = (function () {
      var $42 = Effect_Class.liftEffect(monadEffectAff);
      return function ($43) {
          return Canceler(Data_Function["const"]($42($43)));
      };
  })();
  var joinFiber = function (v) {
      return $foreign.makeAff(function (k) {
          return Data_Functor.map(Effect.functorEffect)(effectCanceler)(v.join(k));
      });
  };
  var functorFiber = new Data_Functor.Functor(function (f) {
      return function (t) {
          return Effect_Unsafe.unsafePerformEffect(makeFiber(Data_Functor.map(functorAff)(f)(joinFiber(t))));
      };
  });
  var killFiber = function (e) {
      return function (v) {
          return Control_Bind.bind(bindAff)(Effect_Class.liftEffect(monadEffectAff)(v.isSuspended))(function (v1) {
              if (v1) {
                  return Effect_Class.liftEffect(monadEffectAff)(Data_Functor["void"](Effect.functorEffect)(v.kill(e, Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit)))));
              };
              return $foreign.makeAff(function (k) {
                  return Data_Functor.map(Effect.functorEffect)(effectCanceler)(v.kill(e, k));
              });
          });
      };
  };   
  var monadThrowAff = new Control_Monad_Error_Class.MonadThrow(function () {
      return monadAff;
  }, $foreign["_throwError"]);
  var monadErrorAff = new Control_Monad_Error_Class.MonadError(function () {
      return monadThrowAff;
  }, $foreign["_catchError"]);                                  
  var runAff = function (k) {
      return function (aff) {
          return launchAff(Control_Bind.bindFlipped(bindAff)((function () {
              var $46 = Effect_Class.liftEffect(monadEffectAff);
              return function ($47) {
                  return $46(k($47));
              };
          })())(Control_Monad_Error_Class["try"](monadErrorAff)(aff)));
      };
  };
  var runAff_ = function (k) {
      return function (aff) {
          return Data_Functor["void"](Effect.functorEffect)(runAff(k)(aff));
      };
  };
  var parallelAff = new Control_Parallel_Class.Parallel(function () {
      return applicativeParAff;
  }, function () {
      return monadAff;
  }, Unsafe_Coerce.unsafeCoerce, $foreign["_sequential"]);
  var applicativeParAff = new Control_Applicative.Applicative(function () {
      return applyParAff;
  }, (function () {
      var $50 = Control_Parallel_Class.parallel(parallelAff);
      var $51 = Control_Applicative.pure(applicativeAff);
      return function ($52) {
          return $50($51($52));
      };
  })());
  var monadRecAff = new Control_Monad_Rec_Class.MonadRec(function () {
      return monadAff;
  }, function (k) {
      var go = function (a) {
          return Control_Bind.bind(bindAff)(k(a))(function (res) {
              if (res instanceof Control_Monad_Rec_Class.Done) {
                  return Control_Applicative.pure(applicativeAff)(res.value0);
              };
              if (res instanceof Control_Monad_Rec_Class.Loop) {
                  return go(res.value0);
              };
              throw new Error("Failed pattern match at Effect.Aff (line 102, column 7 - line 104, column 22): " + [ res.constructor.name ]);
          });
      };
      return go;
  });
  var nonCanceler = Data_Function["const"](Control_Applicative.pure(applicativeAff)(Data_Unit.unit));
  exports["launchAff_"] = launchAff_;
  exports["runAff_"] = runAff_;
  exports["forkAff"] = forkAff;
  exports["suspendAff"] = suspendAff;
  exports["delay"] = delay;
  exports["finally"] = $$finally;
  exports["killFiber"] = killFiber;
  exports["joinFiber"] = joinFiber;
  exports["nonCanceler"] = nonCanceler;
  exports["effectCanceler"] = effectCanceler;
  exports["functorAff"] = functorAff;
  exports["applicativeAff"] = applicativeAff;
  exports["bindAff"] = bindAff;
  exports["monadAff"] = monadAff;
  exports["monadRecAff"] = monadRecAff;
  exports["monadThrowAff"] = monadThrowAff;
  exports["monadErrorAff"] = monadErrorAff;
  exports["monadEffectAff"] = monadEffectAff;
  exports["applicativeParAff"] = applicativeParAff;
  exports["parallelAff"] = parallelAff;
  exports["functorFiber"] = functorFiber;
  exports["makeAff"] = $foreign.makeAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Fork.Class"] = $PS["Control.Monad.Fork.Class"] || {};
  var exports = $PS["Control.Monad.Fork.Class"];
  var Effect_Aff = $PS["Effect.Aff"];                
  var MonadFork = function (Functor1, Monad0, fork, join, suspend) {
      this.Functor1 = Functor1;
      this.Monad0 = Monad0;
      this.fork = fork;
      this.join = join;
      this.suspend = suspend;
  };
  var monadForkAff = new MonadFork(function () {
      return Effect_Aff.functorFiber;
  }, function () {
      return Effect_Aff.monadAff;
  }, Effect_Aff.forkAff, Effect_Aff.joinFiber, Effect_Aff.suspendAff);
  var fork = function (dict) {
      return dict.fork;
  };
  exports["fork"] = fork;
  exports["monadForkAff"] = monadForkAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.CatQueue"] = $PS["Data.CatQueue"] || {};
  var exports = $PS["Data.CatQueue"];
  var Data_List = $PS["Data.List"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Tuple = $PS["Data.Tuple"];                            
  var CatQueue = (function () {
      function CatQueue(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CatQueue.create = function (value0) {
          return function (value1) {
              return new CatQueue(value0, value1);
          };
      };
      return CatQueue;
  })();
  var uncons = function ($copy_v) {
      var $tco_done = false;
      var $tco_result;
      function $tco_loop(v) {
          if (v.value0 instanceof Data_List_Types.Nil && v.value1 instanceof Data_List_Types.Nil) {
              $tco_done = true;
              return Data_Maybe.Nothing.value;
          };
          if (v.value0 instanceof Data_List_Types.Nil) {
              $copy_v = new CatQueue(Data_List.reverse(v.value1), Data_List_Types.Nil.value);
              return;
          };
          if (v.value0 instanceof Data_List_Types.Cons) {
              $tco_done = true;
              return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0.value0, new CatQueue(v.value0.value1, v.value1)));
          };
          throw new Error("Failed pattern match at Data.CatQueue (line 83, column 1 - line 83, column 63): " + [ v.constructor.name ]);
      };
      while (!$tco_done) {
          $tco_result = $tco_loop($copy_v);
      };
      return $tco_result;
  };
  var snoc = function (v) {
      return function (a) {
          return new CatQueue(v.value0, new Data_List_Types.Cons(a, v.value1));
      };
  };
  var $$null = function (v) {
      if (v.value0 instanceof Data_List_Types.Nil && v.value1 instanceof Data_List_Types.Nil) {
          return true;
      };
      return false;
  };                                                                                                
  var empty = new CatQueue(Data_List_Types.Nil.value, Data_List_Types.Nil.value);
  exports["empty"] = empty;
  exports["null"] = $$null;
  exports["snoc"] = snoc;
  exports["uncons"] = uncons;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.CatList"] = $PS["Data.CatList"] || {};
  var exports = $PS["Data.CatList"];
  var Data_CatQueue = $PS["Data.CatQueue"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Tuple = $PS["Data.Tuple"];                            
  var CatNil = (function () {
      function CatNil() {

      };
      CatNil.value = new CatNil();
      return CatNil;
  })();
  var CatCons = (function () {
      function CatCons(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CatCons.create = function (value0) {
          return function (value1) {
              return new CatCons(value0, value1);
          };
      };
      return CatCons;
  })();
  var link = function (v) {
      return function (v1) {
          if (v instanceof CatNil) {
              return v1;
          };
          if (v1 instanceof CatNil) {
              return v;
          };
          if (v instanceof CatCons) {
              return new CatCons(v.value0, Data_CatQueue.snoc(v.value1)(v1));
          };
          throw new Error("Failed pattern match at Data.CatList (line 109, column 1 - line 109, column 54): " + [ v.constructor.name, v1.constructor.name ]);
      };
  };
  var foldr = function (k) {
      return function (b) {
          return function (q) {
              var foldl = function ($copy_v) {
                  return function ($copy_c) {
                      return function ($copy_v1) {
                          var $tco_var_v = $copy_v;
                          var $tco_var_c = $copy_c;
                          var $tco_done = false;
                          var $tco_result;
                          function $tco_loop(v, c, v1) {
                              if (v1 instanceof Data_List_Types.Nil) {
                                  $tco_done = true;
                                  return c;
                              };
                              if (v1 instanceof Data_List_Types.Cons) {
                                  $tco_var_v = v;
                                  $tco_var_c = v(c)(v1.value0);
                                  $copy_v1 = v1.value1;
                                  return;
                              };
                              throw new Error("Failed pattern match at Data.CatList (line 125, column 3 - line 125, column 59): " + [ v.constructor.name, c.constructor.name, v1.constructor.name ]);
                          };
                          while (!$tco_done) {
                              $tco_result = $tco_loop($tco_var_v, $tco_var_c, $copy_v1);
                          };
                          return $tco_result;
                      };
                  };
              };
              var go = function ($copy_xs) {
                  return function ($copy_ys) {
                      var $tco_var_xs = $copy_xs;
                      var $tco_done1 = false;
                      var $tco_result;
                      function $tco_loop(xs, ys) {
                          var v = Data_CatQueue.uncons(xs);
                          if (v instanceof Data_Maybe.Nothing) {
                              $tco_done1 = true;
                              return foldl(function (x) {
                                  return function (i) {
                                      return i(x);
                                  };
                              })(b)(ys);
                          };
                          if (v instanceof Data_Maybe.Just) {
                              $tco_var_xs = v.value0.value1;
                              $copy_ys = new Data_List_Types.Cons(k(v.value0.value0), ys);
                              return;
                          };
                          throw new Error("Failed pattern match at Data.CatList (line 121, column 14 - line 123, column 67): " + [ v.constructor.name ]);
                      };
                      while (!$tco_done1) {
                          $tco_result = $tco_loop($tco_var_xs, $copy_ys);
                      };
                      return $tco_result;
                  };
              };
              return go(q)(Data_List_Types.Nil.value);
          };
      };
  };
  var uncons = function (v) {
      if (v instanceof CatNil) {
          return Data_Maybe.Nothing.value;
      };
      if (v instanceof CatCons) {
          return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0, (function () {
              var $45 = Data_CatQueue["null"](v.value1);
              if ($45) {
                  return CatNil.value;
              };
              return foldr(link)(CatNil.value)(v.value1);
          })()));
      };
      throw new Error("Failed pattern match at Data.CatList (line 100, column 1 - line 100, column 61): " + [ v.constructor.name ]);
  };
  var empty = CatNil.value;
  var append = link;
  var semigroupCatList = new Data_Semigroup.Semigroup(append);
  var snoc = function (cat) {
      return function (a) {
          return append(cat)(new CatCons(a, Data_CatQueue.empty));
      };
  };
  exports["empty"] = empty;
  exports["snoc"] = snoc;
  exports["uncons"] = uncons;
  exports["semigroupCatList"] = semigroupCatList;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Free"] = $PS["Control.Monad.Free"] || {};
  var exports = $PS["Control.Monad.Free"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Data_CatList = $PS["Data.CatList"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Free = (function () {
      function Free(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Free.create = function (value0) {
          return function (value1) {
              return new Free(value0, value1);
          };
      };
      return Free;
  })();
  var Return = (function () {
      function Return(value0) {
          this.value0 = value0;
      };
      Return.create = function (value0) {
          return new Return(value0);
      };
      return Return;
  })();
  var Bind = (function () {
      function Bind(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Bind.create = function (value0) {
          return function (value1) {
              return new Bind(value0, value1);
          };
      };
      return Bind;
  })();
  var toView = function ($copy_v) {
      var $tco_done = false;
      var $tco_result;
      function $tco_loop(v) {
          var runExpF = function (v2) {
              return v2;
          };
          var concatF = function (v2) {
              return function (r) {
                  return new Free(v2.value0, Data_Semigroup.append(Data_CatList.semigroupCatList)(v2.value1)(r));
              };
          };
          if (v.value0 instanceof Return) {
              var v2 = Data_CatList.uncons(v.value1);
              if (v2 instanceof Data_Maybe.Nothing) {
                  $tco_done = true;
                  return new Return(v.value0.value0);
              };
              if (v2 instanceof Data_Maybe.Just) {
                  $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                  return;
              };
              throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [ v2.constructor.name ]);
          };
          if (v.value0 instanceof Bind) {
              $tco_done = true;
              return new Bind(v.value0.value0, function (a) {
                  return concatF(v.value0.value1(a))(v.value1);
              });
          };
          throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [ v.value0.constructor.name ]);
      };
      while (!$tco_done) {
          $tco_result = $tco_loop($copy_v);
      };
      return $tco_result;
  };
  var fromView = function (f) {
      return new Free(f, Data_CatList.empty);
  };
  var freeMonad = new Control_Monad.Monad(function () {
      return freeApplicative;
  }, function () {
      return freeBind;
  });
  var freeFunctor = new Data_Functor.Functor(function (k) {
      return function (f) {
          return Control_Bind.bindFlipped(freeBind)((function () {
              var $119 = Control_Applicative.pure(freeApplicative);
              return function ($120) {
                  return $119(k($120));
              };
          })())(f);
      };
  });
  var freeBind = new Control_Bind.Bind(function () {
      return freeApply;
  }, function (v) {
      return function (k) {
          return new Free(v.value0, Data_CatList.snoc(v.value1)(k));
      };
  });
  var freeApply = new Control_Apply.Apply(function () {
      return freeFunctor;
  }, Control_Monad.ap(freeMonad));
  var freeApplicative = new Control_Applicative.Applicative(function () {
      return freeApply;
  }, function ($121) {
      return fromView(Return.create($121));
  });
  var liftF = function (f) {
      return fromView(new Bind(f, (function () {
          var $122 = Control_Applicative.pure(freeApplicative);
          return function ($123) {
              return $122($123);
          };
      })()));
  };
  var substFree = function (k) {
      var go = function (f) {
          var v = toView(f);
          if (v instanceof Return) {
              return Control_Applicative.pure(freeApplicative)(v.value0);
          };
          if (v instanceof Bind) {
              return Control_Bind.bind(freeBind)(k(v.value0))(Data_Functor.map(Data_Functor.functorFn)(go)(v.value1));
          };
          throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [ v.constructor.name ]);
      };
      return go;
  };
  var hoistFree = function (k) {
      return substFree(function ($124) {
          return liftF(k($124));
      });
  };
  var foldFree = function (dictMonadRec) {
      return function (k) {
          var go = function (f) {
              var v = toView(f);
              if (v instanceof Return) {
                  return Data_Functor.map((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0())(Control_Monad_Rec_Class.Done.create)(Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(v.value0));
              };
              if (v instanceof Bind) {
                  return Data_Functor.map((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0())(function ($135) {
                      return Control_Monad_Rec_Class.Loop.create(v.value1($135));
                  })(k(v.value0));
              };
              throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [ v.constructor.name ]);
          };
          return Control_Monad_Rec_Class.tailRecM(dictMonadRec)(go);
      };
  };
  exports["liftF"] = liftF;
  exports["hoistFree"] = hoistFree;
  exports["foldFree"] = foldFree;
  exports["freeFunctor"] = freeFunctor;
  exports["freeBind"] = freeBind;
  exports["freeApplicative"] = freeApplicative;
  exports["freeMonad"] = freeMonad;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.Reader.Trans"] = $PS["Control.Monad.Reader.Trans"] || {};
  var exports = $PS["Control.Monad.Reader.Trans"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Effect_Class = $PS["Effect.Class"];                
  var ReaderT = function (x) {
      return x;
  };
  var runReaderT = function (v) {
      return v;
  }; 
  var monadTransReaderT = new Control_Monad_Trans_Class.MonadTrans(function (dictMonad) {
      return function ($64) {
          return ReaderT(Data_Function["const"]($64));
      };
  });
  var mapReaderT = function (f) {
      return function (v) {
          return function ($65) {
              return f(v($65));
          };
      };
  };
  var functorReaderT = function (dictFunctor) {
      return new Data_Functor.Functor((function () {
          var $66 = Data_Functor.map(dictFunctor);
          return function ($67) {
              return mapReaderT($66($67));
          };
      })());
  };
  var applyReaderT = function (dictApply) {
      return new Control_Apply.Apply(function () {
          return functorReaderT(dictApply.Functor0());
      }, function (v) {
          return function (v1) {
              return function (r) {
                  return Control_Apply.apply(dictApply)(v(r))(v1(r));
              };
          };
      });
  };
  var bindReaderT = function (dictBind) {
      return new Control_Bind.Bind(function () {
          return applyReaderT(dictBind.Apply0());
      }, function (v) {
          return function (k) {
              return function (r) {
                  return Control_Bind.bind(dictBind)(v(r))(function (a) {
                      var v1 = k(a);
                      return v1(r);
                  });
              };
          };
      });
  };
  var applicativeReaderT = function (dictApplicative) {
      return new Control_Applicative.Applicative(function () {
          return applyReaderT(dictApplicative.Apply0());
      }, (function () {
          var $71 = Control_Applicative.pure(dictApplicative);
          return function ($72) {
              return ReaderT(Data_Function["const"]($71($72)));
          };
      })());
  };
  var monadReaderT = function (dictMonad) {
      return new Control_Monad.Monad(function () {
          return applicativeReaderT(dictMonad.Applicative0());
      }, function () {
          return bindReaderT(dictMonad.Bind1());
      });
  };
  var monadEffectReader = function (dictMonadEffect) {
      return new Effect_Class.MonadEffect(function () {
          return monadReaderT(dictMonadEffect.Monad0());
      }, (function () {
          var $74 = Control_Monad_Trans_Class.lift(monadTransReaderT)(dictMonadEffect.Monad0());
          var $75 = Effect_Class.liftEffect(dictMonadEffect);
          return function ($76) {
              return $74($75($76));
          };
      })());
  };
  exports["runReaderT"] = runReaderT;
  exports["monadReaderT"] = monadReaderT;
  exports["monadTransReaderT"] = monadTransReaderT;
  exports["monadEffectReader"] = monadEffectReader;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Monad.State.Class"] = $PS["Control.Monad.State.Class"] || {};
  var exports = $PS["Control.Monad.State.Class"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unit = $PS["Data.Unit"];                
  var MonadState = function (Monad0, state) {
      this.Monad0 = Monad0;
      this.state = state;
  };
  var state = function (dict) {
      return dict.state;
  };
  var put = function (dictMonadState) {
      return function (s) {
          return state(dictMonadState)(function (v) {
              return new Data_Tuple.Tuple(Data_Unit.unit, s);
          });
      };
  };
  var modify_ = function (dictMonadState) {
      return function (f) {
          return state(dictMonadState)(function (s) {
              return new Data_Tuple.Tuple(Data_Unit.unit, f(s));
          });
      };
  };
  var gets = function (dictMonadState) {
      return function (f) {
          return state(dictMonadState)(function (s) {
              return new Data_Tuple.Tuple(f(s), s);
          });
      };
  };
  var get = function (dictMonadState) {
      return state(dictMonadState)(function (s) {
          return new Data_Tuple.Tuple(s, s);
      });
  };
  exports["MonadState"] = MonadState;
  exports["get"] = get;
  exports["gets"] = gets;
  exports["put"] = put;
  exports["modify_"] = modify_;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Control.Parallel"] = $PS["Control.Parallel"] || {};
  var exports = $PS["Control.Parallel"];
  var Control_Category = $PS["Control.Category"];
  var Control_Parallel_Class = $PS["Control.Parallel.Class"];
  var Data_Foldable = $PS["Data.Foldable"];                      
  var parTraverse_ = function (dictParallel) {
      return function (dictFoldable) {
          return function (f) {
              var $17 = Control_Parallel_Class.sequential(dictParallel);
              var $18 = Data_Foldable.traverse_(dictParallel.Applicative1())(dictFoldable)((function () {
                  var $20 = Control_Parallel_Class.parallel(dictParallel);
                  return function ($21) {
                      return $20(f($21));
                  };
              })());
              return function ($19) {
                  return $17($18($19));
              };
          };
      };
  };
  var parSequence_ = function (dictParallel) {
      return function (dictFoldable) {
          return parTraverse_(dictParallel)(dictFoldable)(Control_Category.identity(Control_Category.categoryFn));
      };
  };
  exports["parSequence_"] = parSequence_;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["DOM.HTML.Indexed.InputType"] = $PS["DOM.HTML.Indexed.InputType"] || {};
  var exports = $PS["DOM.HTML.Indexed.InputType"];
  var InputButton = (function () {
      function InputButton() {

      };
      InputButton.value = new InputButton();
      return InputButton;
  })();
  var InputCheckbox = (function () {
      function InputCheckbox() {

      };
      InputCheckbox.value = new InputCheckbox();
      return InputCheckbox;
  })();
  var InputColor = (function () {
      function InputColor() {

      };
      InputColor.value = new InputColor();
      return InputColor;
  })();
  var InputDate = (function () {
      function InputDate() {

      };
      InputDate.value = new InputDate();
      return InputDate;
  })();
  var InputDatetimeLocal = (function () {
      function InputDatetimeLocal() {

      };
      InputDatetimeLocal.value = new InputDatetimeLocal();
      return InputDatetimeLocal;
  })();
  var InputEmail = (function () {
      function InputEmail() {

      };
      InputEmail.value = new InputEmail();
      return InputEmail;
  })();
  var InputFile = (function () {
      function InputFile() {

      };
      InputFile.value = new InputFile();
      return InputFile;
  })();
  var InputHidden = (function () {
      function InputHidden() {

      };
      InputHidden.value = new InputHidden();
      return InputHidden;
  })();
  var InputImage = (function () {
      function InputImage() {

      };
      InputImage.value = new InputImage();
      return InputImage;
  })();
  var InputMonth = (function () {
      function InputMonth() {

      };
      InputMonth.value = new InputMonth();
      return InputMonth;
  })();
  var InputNumber = (function () {
      function InputNumber() {

      };
      InputNumber.value = new InputNumber();
      return InputNumber;
  })();
  var InputPassword = (function () {
      function InputPassword() {

      };
      InputPassword.value = new InputPassword();
      return InputPassword;
  })();
  var InputRadio = (function () {
      function InputRadio() {

      };
      InputRadio.value = new InputRadio();
      return InputRadio;
  })();
  var InputRange = (function () {
      function InputRange() {

      };
      InputRange.value = new InputRange();
      return InputRange;
  })();
  var InputReset = (function () {
      function InputReset() {

      };
      InputReset.value = new InputReset();
      return InputReset;
  })();
  var InputSearch = (function () {
      function InputSearch() {

      };
      InputSearch.value = new InputSearch();
      return InputSearch;
  })();
  var InputSubmit = (function () {
      function InputSubmit() {

      };
      InputSubmit.value = new InputSubmit();
      return InputSubmit;
  })();
  var InputTel = (function () {
      function InputTel() {

      };
      InputTel.value = new InputTel();
      return InputTel;
  })();
  var InputText = (function () {
      function InputText() {

      };
      InputText.value = new InputText();
      return InputText;
  })();
  var InputTime = (function () {
      function InputTime() {

      };
      InputTime.value = new InputTime();
      return InputTime;
  })();
  var InputUrl = (function () {
      function InputUrl() {

      };
      InputUrl.value = new InputUrl();
      return InputUrl;
  })();
  var InputWeek = (function () {
      function InputWeek() {

      };
      InputWeek.value = new InputWeek();
      return InputWeek;
  })();
  var renderInputType = function (v) {
      if (v instanceof InputButton) {
          return "button";
      };
      if (v instanceof InputCheckbox) {
          return "checkbox";
      };
      if (v instanceof InputColor) {
          return "color";
      };
      if (v instanceof InputDate) {
          return "date";
      };
      if (v instanceof InputDatetimeLocal) {
          return "datetime-local";
      };
      if (v instanceof InputEmail) {
          return "email";
      };
      if (v instanceof InputFile) {
          return "file";
      };
      if (v instanceof InputHidden) {
          return "hidden";
      };
      if (v instanceof InputImage) {
          return "image";
      };
      if (v instanceof InputMonth) {
          return "month";
      };
      if (v instanceof InputNumber) {
          return "number";
      };
      if (v instanceof InputPassword) {
          return "password";
      };
      if (v instanceof InputRadio) {
          return "radio";
      };
      if (v instanceof InputRange) {
          return "range";
      };
      if (v instanceof InputReset) {
          return "reset";
      };
      if (v instanceof InputSearch) {
          return "search";
      };
      if (v instanceof InputSubmit) {
          return "submit";
      };
      if (v instanceof InputTel) {
          return "tel";
      };
      if (v instanceof InputText) {
          return "text";
      };
      if (v instanceof InputTime) {
          return "time";
      };
      if (v instanceof InputUrl) {
          return "url";
      };
      if (v instanceof InputWeek) {
          return "week";
      };
      throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 28, column 19 - line 50, column 22): " + [ v.constructor.name ]);
  };
  exports["InputCheckbox"] = InputCheckbox;
  exports["InputText"] = InputText;
  exports["renderInputType"] = renderInputType;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Exists"] = $PS["Data.Exists"] || {};
  var exports = $PS["Data.Exists"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var runExists = Unsafe_Coerce.unsafeCoerce;
  var mkExists = Unsafe_Coerce.unsafeCoerce;
  exports["mkExists"] = mkExists;
  exports["runExists"] = runExists;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Coyoneda"] = $PS["Data.Coyoneda"] || {};
  var exports = $PS["Data.Coyoneda"];
  var Control_Category = $PS["Control.Category"];
  var Data_Exists = $PS["Data.Exists"];
  var Data_Functor = $PS["Data.Functor"];                        
  var CoyonedaF = (function () {
      function CoyonedaF(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CoyonedaF.create = function (value0) {
          return function (value1) {
              return new CoyonedaF(value0, value1);
          };
      };
      return CoyonedaF;
  })();
  var Coyoneda = function (x) {
      return x;
  };
  var unCoyoneda = function (f) {
      return function (v) {
          return Data_Exists.runExists(function (v1) {
              return f(v1.value0)(v1.value1);
          })(v);
      };
  };
  var coyoneda = function (k) {
      return function (fi) {
          return Coyoneda(Data_Exists.mkExists(new CoyonedaF(k, fi)));
      };
  };
  var functorCoyoneda = new Data_Functor.Functor(function (f) {
      return function (v) {
          return Data_Exists.runExists(function (v1) {
              return coyoneda(function ($84) {
                  return f(v1.value0($84));
              })(v1.value1);
          })(v);
      };
  });
  var liftCoyoneda = coyoneda(Control_Category.identity(Control_Category.categoryFn));
  exports["unCoyoneda"] = unCoyoneda;
  exports["liftCoyoneda"] = liftCoyoneda;
  exports["functorCoyoneda"] = functorCoyoneda;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.AffineTraversal"] = $PS["Data.Lens.AffineTraversal"] || {};
  var exports = $PS["Data.Lens.AffineTraversal"];
  var Control_Category = $PS["Control.Category"];
  var Data_Either = $PS["Data.Either"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var affineTraversal$prime = function (to) {
      return function (dictStrong) {
          return function (dictChoice) {
              return function (pab) {
                  return Data_Profunctor.dimap(dictChoice.Profunctor0())(to)(function (v) {
                      return Data_Either.either(Control_Category.identity(Control_Category.categoryFn))(v.value0)(v.value1);
                  })(Data_Profunctor_Strong.second(dictStrong)(Data_Profunctor_Choice.right(dictChoice)(pab)));
              };
          };
      };
  };
  var affineTraversal = function (set) {
      return function (pre) {
          return function (dictStrong) {
              return function (dictChoice) {
                  return affineTraversal$prime(Data_Profunctor_Strong.fanout(Control_Category.categoryFn)(Data_Profunctor_Strong.strongFn)(set)(pre))(dictStrong)(dictChoice);
              };
          };
      };
  };
  exports["affineTraversal"] = affineTraversal;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Maybe.First"] = $PS["Data.Maybe.First"] || {};
  var exports = $PS["Data.Maybe.First"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];      
  var First = function (x) {
      return x;
  };
  var semigroupFirst = new Data_Semigroup.Semigroup(function (v) {
      return function (v1) {
          if (v instanceof Data_Maybe.Just) {
              return v;
          };
          return v1;
      };
  });
  var monoidFirst = new Data_Monoid.Monoid(function () {
      return semigroupFirst;
  }, Data_Maybe.Nothing.value);
  exports["First"] = First;
  exports["monoidFirst"] = monoidFirst;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Fold"] = $PS["Data.Lens.Fold"] || {};
  var exports = $PS["Data.Lens.Fold"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Newtype = $PS["Data.Newtype"];
  var foldMapOf = Data_Newtype.under()()(Data_Lens_Internal_Forget.Forget);
  var preview = function (p) {
      var $99 = Data_Newtype.unwrap();
      var $100 = foldMapOf(p)(function ($102) {
          return Data_Maybe_First.First(Data_Maybe.Just.create($102));
      });
      return function ($101) {
          return $99($100($101));
      };
  };
  var previewOn = function (s) {
      return function (p) {
          return preview(p)(s);
      };
  };
  var firstOf = function (p) {
      var $112 = Data_Newtype.unwrap();
      var $113 = foldMapOf(p)(function ($115) {
          return Data_Maybe_First.First(Data_Maybe.Just.create($115));
      });
      return function ($114) {
          return $112($113($114));
      };
  };
  exports["previewOn"] = previewOn;
  exports["preview"] = preview;
  exports["firstOf"] = firstOf;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Index"] = $PS["Data.Lens.Index"] || {};
  var exports = $PS["Data.Lens.Index"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Either = $PS["Data.Either"];
  var Data_Lens_AffineTraversal = $PS["Data.Lens.AffineTraversal"];
  var Data_Maybe = $PS["Data.Maybe"];                        
  var Index = function (ix) {
      this.ix = ix;
  };
  var ix = function (dict) {
      return dict.ix;
  };
  var indexNonEmptyArray = new Index(function (n) {
      return function (dictStrong) {
          return function (dictChoice) {
              var set = function (s) {
                  return function (b) {
                      return Data_Maybe.fromMaybe(s)(Data_Array_NonEmpty.updateAt(n)(b)(s));
                  };
              };
              var pre = function (s) {
                  return Data_Maybe.maybe(new Data_Either.Left(s))(Data_Either.Right.create)(Data_Array_NonEmpty.index(s)(n));
              };
              return Data_Lens_AffineTraversal.affineTraversal(set)(pre)(dictStrong)(dictChoice);
          };
      };
  });
  var indexArray = new Index(function (n) {
      return function (dictStrong) {
          return function (dictChoice) {
              var set = function (s) {
                  return function (b) {
                      return Data_Maybe.fromMaybe(s)(Data_Array.updateAt(n)(b)(s));
                  };
              };
              var pre = function (s) {
                  return Data_Maybe.maybe(new Data_Either.Left(s))(Data_Either.Right.create)(Data_Array.index(s)(n));
              };
              return Data_Lens_AffineTraversal.affineTraversal(set)(pre)(dictStrong)(dictChoice);
          };
      };
  });
  exports["ix"] = ix;
  exports["indexArray"] = indexArray;
  exports["indexNonEmptyArray"] = indexNonEmptyArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Lens.Prism.Maybe"] = $PS["Data.Lens.Prism.Maybe"] || {};
  var exports = $PS["Data.Lens.Prism.Maybe"];
  var Data_Either = $PS["Data.Either"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Maybe = $PS["Data.Maybe"];
  var _Just = function (dictChoice) {
      return Data_Lens_Prism.prism(Data_Maybe.Just.create)(Data_Maybe.maybe(new Data_Either.Left(Data_Maybe.Nothing.value))(Data_Either.Right.create))(dictChoice);
  };
  exports["_Just"] = _Just;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Data.Map.Internal"] = $PS["Data.Map.Internal"] || {};
  var exports = $PS["Data.Map.Internal"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Tuple = $PS["Data.Tuple"];                          
  var Leaf = (function () {
      function Leaf() {

      };
      Leaf.value = new Leaf();
      return Leaf;
  })();
  var Two = (function () {
      function Two(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Two.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Two(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Two;
  })();
  var Three = (function () {
      function Three(value0, value1, value2, value3, value4, value5, value6) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
          this.value6 = value6;
      };
      Three.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return function (value6) {
                                  return new Three(value0, value1, value2, value3, value4, value5, value6);
                              };
                          };
                      };
                  };
              };
          };
      };
      return Three;
  })();
  var TwoLeft = (function () {
      function TwoLeft(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      TwoLeft.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new TwoLeft(value0, value1, value2);
              };
          };
      };
      return TwoLeft;
  })();
  var TwoRight = (function () {
      function TwoRight(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      TwoRight.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new TwoRight(value0, value1, value2);
              };
          };
      };
      return TwoRight;
  })();
  var ThreeLeft = (function () {
      function ThreeLeft(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      ThreeLeft.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new ThreeLeft(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return ThreeLeft;
  })();
  var ThreeMiddle = (function () {
      function ThreeMiddle(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      ThreeMiddle.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new ThreeMiddle(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return ThreeMiddle;
  })();
  var ThreeRight = (function () {
      function ThreeRight(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      ThreeRight.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new ThreeRight(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return ThreeRight;
  })();
  var KickUp = (function () {
      function KickUp(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      KickUp.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new KickUp(value0, value1, value2, value3);
                  };
              };
          };
      };
      return KickUp;
  })();
  var values = function (v) {
      if (v instanceof Leaf) {
          return Data_List_Types.Nil.value;
      };
      if (v instanceof Two) {
          return Data_Semigroup.append(Data_List_Types.semigroupList)(values(v.value0))(Data_Semigroup.append(Data_List_Types.semigroupList)(Control_Applicative.pure(Data_List_Types.applicativeList)(v.value2))(values(v.value3)));
      };
      if (v instanceof Three) {
          return Data_Semigroup.append(Data_List_Types.semigroupList)(values(v.value0))(Data_Semigroup.append(Data_List_Types.semigroupList)(Control_Applicative.pure(Data_List_Types.applicativeList)(v.value2))(Data_Semigroup.append(Data_List_Types.semigroupList)(values(v.value3))(Data_Semigroup.append(Data_List_Types.semigroupList)(Control_Applicative.pure(Data_List_Types.applicativeList)(v.value5))(values(v.value6)))));
      };
      throw new Error("Failed pattern match at Data.Map.Internal (line 626, column 1 - line 626, column 40): " + [ v.constructor.name ]);
  };
  var lookup = function (dictOrd) {
      return function (k) {
          var comp = Data_Ord.compare(dictOrd);
          var go = function ($copy_v) {
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(v) {
                  if (v instanceof Leaf) {
                      $tco_done = true;
                      return Data_Maybe.Nothing.value;
                  };
                  if (v instanceof Two) {
                      var v2 = comp(k)(v.value1);
                      if (v2 instanceof Data_Ordering.EQ) {
                          $tco_done = true;
                          return new Data_Maybe.Just(v.value2);
                      };
                      if (v2 instanceof Data_Ordering.LT) {
                          $copy_v = v.value0;
                          return;
                      };
                      $copy_v = v.value3;
                      return;
                  };
                  if (v instanceof Three) {
                      var v3 = comp(k)(v.value1);
                      if (v3 instanceof Data_Ordering.EQ) {
                          $tco_done = true;
                          return new Data_Maybe.Just(v.value2);
                      };
                      var v4 = comp(k)(v.value4);
                      if (v4 instanceof Data_Ordering.EQ) {
                          $tco_done = true;
                          return new Data_Maybe.Just(v.value5);
                      };
                      if (v3 instanceof Data_Ordering.LT) {
                          $copy_v = v.value0;
                          return;
                      };
                      if (v4 instanceof Data_Ordering.GT) {
                          $copy_v = v.value6;
                          return;
                      };
                      $copy_v = v.value3;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 211, column 5 - line 211, column 22): " + [ v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($copy_v);
              };
              return $tco_result;
          };
          return go;
      };
  }; 
  var fromZipper = function ($copy_dictOrd) {
      return function ($copy_v) {
          return function ($copy_tree) {
              var $tco_var_dictOrd = $copy_dictOrd;
              var $tco_var_v = $copy_v;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(dictOrd, v, tree) {
                  if (v instanceof Data_List_Types.Nil) {
                      $tco_done = true;
                      return tree;
                  };
                  if (v instanceof Data_List_Types.Cons) {
                      if (v.value0 instanceof TwoLeft) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Two(tree, v.value0.value0, v.value0.value1, v.value0.value2);
                          return;
                      };
                      if (v.value0 instanceof TwoRight) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Two(v.value0.value0, v.value0.value1, v.value0.value2, tree);
                          return;
                      };
                      if (v.value0 instanceof ThreeLeft) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Three(tree, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v.value0.value4, v.value0.value5);
                          return;
                      };
                      if (v.value0 instanceof ThreeMiddle) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Three(v.value0.value0, v.value0.value1, v.value0.value2, tree, v.value0.value3, v.value0.value4, v.value0.value5);
                          return;
                      };
                      if (v.value0 instanceof ThreeRight) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v.value0.value4, v.value0.value5, tree);
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 432, column 3 - line 437, column 88): " + [ v.value0.constructor.name ]);
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 429, column 1 - line 429, column 80): " + [ v.constructor.name, tree.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_dictOrd, $tco_var_v, $copy_tree);
              };
              return $tco_result;
          };
      };
  };
  var insert = function (dictOrd) {
      return function (k) {
          return function (v) {
              var up = function ($copy_v1) {
                  return function ($copy_v2) {
                      var $tco_var_v1 = $copy_v1;
                      var $tco_done = false;
                      var $tco_result;
                      function $tco_loop(v1, v2) {
                          if (v1 instanceof Data_List_Types.Nil) {
                              $tco_done = true;
                              return new Two(v2.value0, v2.value1, v2.value2, v2.value3);
                          };
                          if (v1 instanceof Data_List_Types.Cons) {
                              if (v1.value0 instanceof TwoLeft) {
                                  $tco_done = true;
                                  return fromZipper(dictOrd)(v1.value1)(new Three(v2.value0, v2.value1, v2.value2, v2.value3, v1.value0.value0, v1.value0.value1, v1.value0.value2));
                              };
                              if (v1.value0 instanceof TwoRight) {
                                  $tco_done = true;
                                  return fromZipper(dictOrd)(v1.value1)(new Three(v1.value0.value0, v1.value0.value1, v1.value0.value2, v2.value0, v2.value1, v2.value2, v2.value3));
                              };
                              if (v1.value0 instanceof ThreeLeft) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_v2 = new KickUp(new Two(v2.value0, v2.value1, v2.value2, v2.value3), v1.value0.value0, v1.value0.value1, new Two(v1.value0.value2, v1.value0.value3, v1.value0.value4, v1.value0.value5));
                                  return;
                              };
                              if (v1.value0 instanceof ThreeMiddle) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_v2 = new KickUp(new Two(v1.value0.value0, v1.value0.value1, v1.value0.value2, v2.value0), v2.value1, v2.value2, new Two(v2.value3, v1.value0.value3, v1.value0.value4, v1.value0.value5));
                                  return;
                              };
                              if (v1.value0 instanceof ThreeRight) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_v2 = new KickUp(new Two(v1.value0.value0, v1.value0.value1, v1.value0.value2, v1.value0.value3), v1.value0.value4, v1.value0.value5, new Two(v2.value0, v2.value1, v2.value2, v2.value3));
                                  return;
                              };
                              throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 5 - line 473, column 108): " + [ v1.value0.constructor.name, v2.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.Map.Internal (line 465, column 3 - line 465, column 56): " + [ v1.constructor.name, v2.constructor.name ]);
                      };
                      while (!$tco_done) {
                          $tco_result = $tco_loop($tco_var_v1, $copy_v2);
                      };
                      return $tco_result;
                  };
              };
              var comp = Data_Ord.compare(dictOrd);
              var down = function ($copy_ctx) {
                  return function ($copy_v1) {
                      var $tco_var_ctx = $copy_ctx;
                      var $tco_done1 = false;
                      var $tco_result;
                      function $tco_loop(ctx, v1) {
                          if (v1 instanceof Leaf) {
                              $tco_done1 = true;
                              return up(ctx)(new KickUp(Leaf.value, k, v, Leaf.value));
                          };
                          if (v1 instanceof Two) {
                              var v2 = comp(k)(v1.value1);
                              if (v2 instanceof Data_Ordering.EQ) {
                                  $tco_done1 = true;
                                  return fromZipper(dictOrd)(ctx)(new Two(v1.value0, k, v, v1.value3));
                              };
                              if (v2 instanceof Data_Ordering.LT) {
                                  $tco_var_ctx = new Data_List_Types.Cons(new TwoLeft(v1.value1, v1.value2, v1.value3), ctx);
                                  $copy_v1 = v1.value0;
                                  return;
                              };
                              $tco_var_ctx = new Data_List_Types.Cons(new TwoRight(v1.value0, v1.value1, v1.value2), ctx);
                              $copy_v1 = v1.value3;
                              return;
                          };
                          if (v1 instanceof Three) {
                              var v3 = comp(k)(v1.value1);
                              if (v3 instanceof Data_Ordering.EQ) {
                                  $tco_done1 = true;
                                  return fromZipper(dictOrd)(ctx)(new Three(v1.value0, k, v, v1.value3, v1.value4, v1.value5, v1.value6));
                              };
                              var v4 = comp(k)(v1.value4);
                              if (v4 instanceof Data_Ordering.EQ) {
                                  $tco_done1 = true;
                                  return fromZipper(dictOrd)(ctx)(new Three(v1.value0, v1.value1, v1.value2, v1.value3, k, v, v1.value6));
                              };
                              if (v3 instanceof Data_Ordering.LT) {
                                  $tco_var_ctx = new Data_List_Types.Cons(new ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4, v1.value5, v1.value6), ctx);
                                  $copy_v1 = v1.value0;
                                  return;
                              };
                              if (v3 instanceof Data_Ordering.GT && v4 instanceof Data_Ordering.LT) {
                                  $tco_var_ctx = new Data_List_Types.Cons(new ThreeMiddle(v1.value0, v1.value1, v1.value2, v1.value4, v1.value5, v1.value6), ctx);
                                  $copy_v1 = v1.value3;
                                  return;
                              };
                              $tco_var_ctx = new Data_List_Types.Cons(new ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3, v1.value4, v1.value5), ctx);
                              $copy_v1 = v1.value6;
                              return;
                          };
                          throw new Error("Failed pattern match at Data.Map.Internal (line 448, column 3 - line 448, column 55): " + [ ctx.constructor.name, v1.constructor.name ]);
                      };
                      while (!$tco_done1) {
                          $tco_result = $tco_loop($tco_var_ctx, $copy_v1);
                      };
                      return $tco_result;
                  };
              };
              return down(Data_List_Types.Nil.value);
          };
      };
  };
  var pop = function (dictOrd) {
      return function (k) {
          var up = function ($copy_ctxs) {
              return function ($copy_tree) {
                  var $tco_var_ctxs = $copy_ctxs;
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(ctxs, tree) {
                      if (ctxs instanceof Data_List_Types.Nil) {
                          $tco_done = true;
                          return tree;
                      };
                      if (ctxs instanceof Data_List_Types.Cons) {
                          if (ctxs.value0 instanceof TwoLeft && (ctxs.value0.value2 instanceof Leaf && tree instanceof Leaf)) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(Leaf.value, ctxs.value0.value0, ctxs.value0.value1, Leaf.value));
                          };
                          if (ctxs.value0 instanceof TwoRight && (ctxs.value0.value0 instanceof Leaf && tree instanceof Leaf)) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(Leaf.value, ctxs.value0.value1, ctxs.value0.value2, Leaf.value));
                          };
                          if (ctxs.value0 instanceof TwoLeft && ctxs.value0.value2 instanceof Two) {
                              $tco_var_ctxs = ctxs.value1;
                              $copy_tree = new Three(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0, ctxs.value0.value2.value1, ctxs.value0.value2.value2, ctxs.value0.value2.value3);
                              return;
                          };
                          if (ctxs.value0 instanceof TwoRight && ctxs.value0.value0 instanceof Two) {
                              $tco_var_ctxs = ctxs.value1;
                              $copy_tree = new Three(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3, ctxs.value0.value1, ctxs.value0.value2, tree);
                              return;
                          };
                          if (ctxs.value0 instanceof TwoLeft && ctxs.value0.value2 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Two(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0), ctxs.value0.value2.value1, ctxs.value0.value2.value2, new Two(ctxs.value0.value2.value3, ctxs.value0.value2.value4, ctxs.value0.value2.value5, ctxs.value0.value2.value6)));
                          };
                          if (ctxs.value0 instanceof TwoRight && ctxs.value0.value0 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Two(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3), ctxs.value0.value0.value4, ctxs.value0.value0.value5, new Two(ctxs.value0.value0.value6, ctxs.value0.value1, ctxs.value0.value2, tree)));
                          };
                          if (ctxs.value0 instanceof ThreeLeft && (ctxs.value0.value2 instanceof Leaf && (ctxs.value0.value5 instanceof Leaf && tree instanceof Leaf))) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(Leaf.value, ctxs.value0.value0, ctxs.value0.value1, Leaf.value, ctxs.value0.value3, ctxs.value0.value4, Leaf.value));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && (ctxs.value0.value0 instanceof Leaf && (ctxs.value0.value5 instanceof Leaf && tree instanceof Leaf))) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(Leaf.value, ctxs.value0.value1, ctxs.value0.value2, Leaf.value, ctxs.value0.value3, ctxs.value0.value4, Leaf.value));
                          };
                          if (ctxs.value0 instanceof ThreeRight && (ctxs.value0.value0 instanceof Leaf && (ctxs.value0.value3 instanceof Leaf && tree instanceof Leaf))) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(Leaf.value, ctxs.value0.value1, ctxs.value0.value2, Leaf.value, ctxs.value0.value4, ctxs.value0.value5, Leaf.value));
                          };
                          if (ctxs.value0 instanceof ThreeLeft && ctxs.value0.value2 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Three(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0, ctxs.value0.value2.value1, ctxs.value0.value2.value2, ctxs.value0.value2.value3), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value0 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Three(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3, ctxs.value0.value1, ctxs.value0.value2, tree), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value5 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Three(tree, ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5.value0, ctxs.value0.value5.value1, ctxs.value0.value5.value2, ctxs.value0.value5.value3)));
                          };
                          if (ctxs.value0 instanceof ThreeRight && ctxs.value0.value3 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Three(ctxs.value0.value3.value0, ctxs.value0.value3.value1, ctxs.value0.value3.value2, ctxs.value0.value3.value3, ctxs.value0.value4, ctxs.value0.value5, tree)));
                          };
                          if (ctxs.value0 instanceof ThreeLeft && ctxs.value0.value2 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(new Two(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0), ctxs.value0.value2.value1, ctxs.value0.value2.value2, new Two(ctxs.value0.value2.value3, ctxs.value0.value2.value4, ctxs.value0.value2.value5, ctxs.value0.value2.value6), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value0 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(new Two(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3), ctxs.value0.value0.value4, ctxs.value0.value0.value5, new Two(ctxs.value0.value0.value6, ctxs.value0.value1, ctxs.value0.value2, tree), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value5 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Two(tree, ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5.value0), ctxs.value0.value5.value1, ctxs.value0.value5.value2, new Two(ctxs.value0.value5.value3, ctxs.value0.value5.value4, ctxs.value0.value5.value5, ctxs.value0.value5.value6)));
                          };
                          if (ctxs.value0 instanceof ThreeRight && ctxs.value0.value3 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Two(ctxs.value0.value3.value0, ctxs.value0.value3.value1, ctxs.value0.value3.value2, ctxs.value0.value3.value3), ctxs.value0.value3.value4, ctxs.value0.value3.value5, new Two(ctxs.value0.value3.value6, ctxs.value0.value4, ctxs.value0.value5, tree)));
                          };
                          throw new Error("Failed pattern match at Data.Map.Internal (line 525, column 9 - line 542, column 136): " + [ ctxs.value0.constructor.name, tree.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 522, column 5 - line 542, column 136): " + [ ctxs.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($tco_var_ctxs, $copy_tree);
                  };
                  return $tco_result;
              };
          };
          var removeMaxNode = function ($copy_ctx) {
              return function ($copy_m) {
                  var $tco_var_ctx = $copy_ctx;
                  var $tco_done1 = false;
                  var $tco_result;
                  function $tco_loop(ctx, m) {
                      if (m instanceof Two && (m.value0 instanceof Leaf && m.value3 instanceof Leaf)) {
                          $tco_done1 = true;
                          return up(ctx)(Leaf.value);
                      };
                      if (m instanceof Two) {
                          $tco_var_ctx = new Data_List_Types.Cons(new TwoRight(m.value0, m.value1, m.value2), ctx);
                          $copy_m = m.value3;
                          return;
                      };
                      if (m instanceof Three && (m.value0 instanceof Leaf && (m.value3 instanceof Leaf && m.value6 instanceof Leaf))) {
                          $tco_done1 = true;
                          return up(new Data_List_Types.Cons(new TwoRight(Leaf.value, m.value1, m.value2), ctx))(Leaf.value);
                      };
                      if (m instanceof Three) {
                          $tco_var_ctx = new Data_List_Types.Cons(new ThreeRight(m.value0, m.value1, m.value2, m.value3, m.value4, m.value5), ctx);
                          $copy_m = m.value6;
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 554, column 5 - line 558, column 107): " + [ m.constructor.name ]);
                  };
                  while (!$tco_done1) {
                      $tco_result = $tco_loop($tco_var_ctx, $copy_m);
                  };
                  return $tco_result;
              };
          };
          var maxNode = function ($copy_m) {
              var $tco_done2 = false;
              var $tco_result;
              function $tco_loop(m) {
                  if (m instanceof Two && m.value3 instanceof Leaf) {
                      $tco_done2 = true;
                      return {
                          key: m.value1,
                          value: m.value2
                      };
                  };
                  if (m instanceof Two) {
                      $copy_m = m.value3;
                      return;
                  };
                  if (m instanceof Three && m.value6 instanceof Leaf) {
                      $tco_done2 = true;
                      return {
                          key: m.value4,
                          value: m.value5
                      };
                  };
                  if (m instanceof Three) {
                      $copy_m = m.value6;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 545, column 33 - line 549, column 45): " + [ m.constructor.name ]);
              };
              while (!$tco_done2) {
                  $tco_result = $tco_loop($copy_m);
              };
              return $tco_result;
          };
          var comp = Data_Ord.compare(dictOrd);
          var down = function ($copy_ctx) {
              return function ($copy_m) {
                  var $tco_var_ctx = $copy_ctx;
                  var $tco_done3 = false;
                  var $tco_result;
                  function $tco_loop(ctx, m) {
                      if (m instanceof Leaf) {
                          $tco_done3 = true;
                          return Data_Maybe.Nothing.value;
                      };
                      if (m instanceof Two) {
                          var v = comp(k)(m.value1);
                          if (m.value3 instanceof Leaf && v instanceof Data_Ordering.EQ) {
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, up(ctx)(Leaf.value)));
                          };
                          if (v instanceof Data_Ordering.EQ) {
                              var max = maxNode(m.value0);
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, removeMaxNode(new Data_List_Types.Cons(new TwoLeft(max.key, max.value, m.value3), ctx))(m.value0)));
                          };
                          if (v instanceof Data_Ordering.LT) {
                              $tco_var_ctx = new Data_List_Types.Cons(new TwoLeft(m.value1, m.value2, m.value3), ctx);
                              $copy_m = m.value0;
                              return;
                          };
                          $tco_var_ctx = new Data_List_Types.Cons(new TwoRight(m.value0, m.value1, m.value2), ctx);
                          $copy_m = m.value3;
                          return;
                      };
                      if (m instanceof Three) {
                          var leaves = (function () {
                              if (m.value0 instanceof Leaf && (m.value3 instanceof Leaf && m.value6 instanceof Leaf)) {
                                  return true;
                              };
                              return false;
                          })();
                          var v = comp(k)(m.value4);
                          var v3 = comp(k)(m.value1);
                          if (leaves && v3 instanceof Data_Ordering.EQ) {
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, fromZipper(dictOrd)(ctx)(new Two(Leaf.value, m.value4, m.value5, Leaf.value))));
                          };
                          if (leaves && v instanceof Data_Ordering.EQ) {
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value5, fromZipper(dictOrd)(ctx)(new Two(Leaf.value, m.value1, m.value2, Leaf.value))));
                          };
                          if (v3 instanceof Data_Ordering.EQ) {
                              var max = maxNode(m.value0);
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, removeMaxNode(new Data_List_Types.Cons(new ThreeLeft(max.key, max.value, m.value3, m.value4, m.value5, m.value6), ctx))(m.value0)));
                          };
                          if (v instanceof Data_Ordering.EQ) {
                              var max = maxNode(m.value3);
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value5, removeMaxNode(new Data_List_Types.Cons(new ThreeMiddle(m.value0, m.value1, m.value2, max.key, max.value, m.value6), ctx))(m.value3)));
                          };
                          if (v3 instanceof Data_Ordering.LT) {
                              $tco_var_ctx = new Data_List_Types.Cons(new ThreeLeft(m.value1, m.value2, m.value3, m.value4, m.value5, m.value6), ctx);
                              $copy_m = m.value0;
                              return;
                          };
                          if (v3 instanceof Data_Ordering.GT && v instanceof Data_Ordering.LT) {
                              $tco_var_ctx = new Data_List_Types.Cons(new ThreeMiddle(m.value0, m.value1, m.value2, m.value4, m.value5, m.value6), ctx);
                              $copy_m = m.value3;
                              return;
                          };
                          $tco_var_ctx = new Data_List_Types.Cons(new ThreeRight(m.value0, m.value1, m.value2, m.value3, m.value4, m.value5), ctx);
                          $copy_m = m.value6;
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 34 - line 518, column 80): " + [ m.constructor.name ]);
                  };
                  while (!$tco_done3) {
                      $tco_result = $tco_loop($tco_var_ctx, $copy_m);
                  };
                  return $tco_result;
              };
          };
          return down(Data_List_Types.Nil.value);
      };
  };
  var foldableMap = new Data_Foldable.Foldable(function (dictMonoid) {
      return function (f) {
          return function (m) {
              return Data_Foldable.foldMap(Data_List_Types.foldableList)(dictMonoid)(f)(values(m));
          };
      };
  }, function (f) {
      return function (z) {
          return function (m) {
              return Data_Foldable.foldl(Data_List_Types.foldableList)(f)(z)(values(m));
          };
      };
  }, function (f) {
      return function (z) {
          return function (m) {
              return Data_Foldable.foldr(Data_List_Types.foldableList)(f)(z)(values(m));
          };
      };
  });
  var empty = Leaf.value;
  var $$delete = function (dictOrd) {
      return function (k) {
          return function (m) {
              return Data_Maybe.maybe(m)(Data_Tuple.snd)(pop(dictOrd)(k)(m));
          };
      };
  };
  var alter = function (dictOrd) {
      return function (f) {
          return function (k) {
              return function (m) {
                  var v = f(lookup(dictOrd)(k)(m));
                  if (v instanceof Data_Maybe.Nothing) {
                      return $$delete(dictOrd)(k)(m);
                  };
                  if (v instanceof Data_Maybe.Just) {
                      return insert(dictOrd)(k)(v.value0)(m);
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 563, column 15 - line 565, column 25): " + [ v.constructor.name ]);
              };
          };
      };
  };
  exports["empty"] = empty;
  exports["insert"] = insert;
  exports["lookup"] = lookup;
  exports["delete"] = $$delete;
  exports["pop"] = pop;
  exports["alter"] = alter;
  exports["foldableMap"] = foldableMap;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Aff.Class"] = $PS["Effect.Aff.Class"] || {};
  var exports = $PS["Effect.Aff.Class"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_Reader_Trans = $PS["Control.Monad.Reader.Trans"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Effect_Aff = $PS["Effect.Aff"];                
  var MonadAff = function (MonadEffect0, liftAff) {
      this.MonadEffect0 = MonadEffect0;
      this.liftAff = liftAff;
  };
  var monadAffAff = new MonadAff(function () {
      return Effect_Aff.monadEffectAff;
  }, Control_Category.identity(Control_Category.categoryFn));
  var liftAff = function (dict) {
      return dict.liftAff;
  };
  var monadAffReader = function (dictMonadAff) {
      return new MonadAff(function () {
          return Control_Monad_Reader_Trans.monadEffectReader(dictMonadAff.MonadEffect0());
      }, (function () {
          var $25 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)((dictMonadAff.MonadEffect0()).Monad0());
          var $26 = liftAff(dictMonadAff);
          return function ($27) {
              return $25($26($27));
          };
      })());
  };
  exports["liftAff"] = liftAff;
  exports["monadAffAff"] = monadAffAff;
  exports["monadAffReader"] = monadAffReader;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.AppM"] = $PS["Domination.AppM"] || {};
  var exports = $PS["Domination.AppM"];
  var Control_Monad_Reader_Trans = $PS["Control.Monad.Reader.Trans"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Aff_Class = $PS["Effect.Aff.Class"];
  var runAppM = function (env) {
      return function (v) {
          return Control_Monad_Reader_Trans.runReaderT(v)(env);
      };
  };
  var monadEffectAppM = Control_Monad_Reader_Trans.monadEffectReader(Effect_Aff.monadEffectAff);
  var monadAppM = Control_Monad_Reader_Trans.monadReaderT(Effect_Aff.monadAff);
  var monadAffAppM = Effect_Aff_Class.monadAffReader(Effect_Aff_Class.monadAffAff);
  exports["runAppM"] = runAppM;
  exports["monadAppM"] = monadAppM;
  exports["monadEffectAppM"] = monadEffectAppM;
  exports["monadAffAppM"] = monadAffAppM;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Data.OrdBox"] = $PS["Halogen.Data.OrdBox"] || {};
  var exports = $PS["Halogen.Data.OrdBox"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ord = $PS["Data.Ord"];                
  var OrdBox = (function () {
      function OrdBox(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      OrdBox.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new OrdBox(value0, value1, value2);
              };
          };
      };
      return OrdBox;
  })();
  var mkOrdBox = function (dictOrd) {
      return OrdBox.create(Data_Eq.eq(dictOrd.Eq0()))(Data_Ord.compare(dictOrd));
  };
  var eqOrdBox = new Data_Eq.Eq(function (v) {
      return function (v1) {
          return v.value0(v.value2)(v1.value2);
      };
  });
  var ordOrdBox = new Data_Ord.Ord(function () {
      return eqOrdBox;
  }, function (v) {
      return function (v1) {
          return v.value1(v.value2)(v1.value2);
      };
  });
  exports["mkOrdBox"] = mkOrdBox;
  exports["ordOrdBox"] = ordOrdBox;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Data.Slot"] = $PS["Halogen.Data.Slot"] || {};
  var exports = $PS["Halogen.Data.Slot"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Halogen_Data_OrdBox = $PS["Halogen.Data.OrdBox"];
  var pop = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (key) {
                      return function (v) {
                          return Data_Map_Internal.pop(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(sym), Halogen_Data_OrdBox.mkOrdBox(dictOrd)(key)))(v);
                      };
                  };
              };
          };
      };
  };
  var lookup = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (key) {
                      return function (v) {
                          return Data_Map_Internal.lookup(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(sym), Halogen_Data_OrdBox.mkOrdBox(dictOrd)(key)))(v);
                      };
                  };
              };
          };
      };
  };
  var insert = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (key) {
                      return function (val) {
                          return function (v) {
                              return Data_Map_Internal.insert(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(sym), Halogen_Data_OrdBox.mkOrdBox(dictOrd)(key)))(val)(v);
                          };
                      };
                  };
              };
          };
      };
  };
  var foreachSlot = function (dictApplicative) {
      return function (v) {
          return function (k) {
              return Data_Foldable.traverse_(dictApplicative)(Data_Map_Internal.foldableMap)(function ($37) {
                  return k($37);
              })(v);
          };
      };
  };
  var empty = Data_Map_Internal.empty;
  exports["empty"] = empty;
  exports["lookup"] = lookup;
  exports["insert"] = insert;
  exports["pop"] = pop;
  exports["foreachSlot"] = foreachSlot;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Query.ChildQuery"] = $PS["Halogen.Query.ChildQuery"] || {};
  var exports = $PS["Halogen.Query.ChildQuery"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var ChildQuery = (function () {
      function ChildQuery(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      ChildQuery.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new ChildQuery(value0, value1, value2);
              };
          };
      };
      return ChildQuery;
  })();
  var unChildQueryBox = Unsafe_Coerce.unsafeCoerce;
  var mkChildQueryBox = Unsafe_Coerce.unsafeCoerce;
  exports["ChildQuery"] = ChildQuery;
  exports["mkChildQueryBox"] = mkChildQueryBox;
  exports["unChildQueryBox"] = unChildQueryBox;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Query.HalogenM"] = $PS["Halogen.Query.HalogenM"] || {};
  var exports = $PS["Halogen.Query.HalogenM"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Applicative_Free = $PS["Control.Applicative.Free"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_Free = $PS["Control.Monad.Free"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Function = $PS["Data.Function"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Unit = $PS["Data.Unit"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Halogen_Query_ChildQuery = $PS["Halogen.Query.ChildQuery"];        
  var SubscriptionId = function (x) {
      return x;
  };
  var ForkId = function (x) {
      return x;
  };
  var State = (function () {
      function State(value0) {
          this.value0 = value0;
      };
      State.create = function (value0) {
          return new State(value0);
      };
      return State;
  })();
  var Subscribe = (function () {
      function Subscribe(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Subscribe.create = function (value0) {
          return function (value1) {
              return new Subscribe(value0, value1);
          };
      };
      return Subscribe;
  })();
  var Unsubscribe = (function () {
      function Unsubscribe(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Unsubscribe.create = function (value0) {
          return function (value1) {
              return new Unsubscribe(value0, value1);
          };
      };
      return Unsubscribe;
  })();
  var Lift = (function () {
      function Lift(value0) {
          this.value0 = value0;
      };
      Lift.create = function (value0) {
          return new Lift(value0);
      };
      return Lift;
  })();
  var ChildQuery = (function () {
      function ChildQuery(value0) {
          this.value0 = value0;
      };
      ChildQuery.create = function (value0) {
          return new ChildQuery(value0);
      };
      return ChildQuery;
  })();
  var Raise = (function () {
      function Raise(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Raise.create = function (value0) {
          return function (value1) {
              return new Raise(value0, value1);
          };
      };
      return Raise;
  })();
  var Par = (function () {
      function Par(value0) {
          this.value0 = value0;
      };
      Par.create = function (value0) {
          return new Par(value0);
      };
      return Par;
  })();
  var Fork = (function () {
      function Fork(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Fork.create = function (value0) {
          return function (value1) {
              return new Fork(value0, value1);
          };
      };
      return Fork;
  })();
  var Kill = (function () {
      function Kill(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Kill.create = function (value0) {
          return function (value1) {
              return new Kill(value0, value1);
          };
      };
      return Kill;
  })();
  var GetRef = (function () {
      function GetRef(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      GetRef.create = function (value0) {
          return function (value1) {
              return new GetRef(value0, value1);
          };
      };
      return GetRef;
  })();
  var HalogenAp = function (x) {
      return x;
  };
  var HalogenM = function (x) {
      return x;
  };
  var subscribe$prime = function (esc) {
      return HalogenM(Control_Monad_Free.liftF(new Subscribe(esc, Data_Function["const"](Data_Unit.unit))));
  };
  var subscribe = function (es) {
      return HalogenM(Control_Monad_Free.liftF(new Subscribe(function (v) {
          return es;
      }, Control_Category.identity(Control_Category.categoryFn))));
  };
  var raise = function (o) {
      return HalogenM(Control_Monad_Free.liftF(new Raise(o, Data_Unit.unit)));
  };
  var query = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (p) {
                      return function (q) {
                          return HalogenM(Control_Monad_Free.liftF(ChildQuery.create(Halogen_Query_ChildQuery.mkChildQueryBox(new Halogen_Query_ChildQuery.ChildQuery(function (dictApplicative) {
                              return function (k) {
                                  var $132 = Data_Maybe.maybe(Control_Applicative.pure(dictApplicative)(Data_Maybe.Nothing.value))(k);
                                  var $133 = Halogen_Data_Slot.lookup()(dictIsSymbol)(dictOrd)(label)(p);
                                  return function ($134) {
                                      return $132($133($134));
                                  };
                              };
                          }, q, Control_Category.identity(Control_Category.categoryFn))))));
                      };
                  };
              };
          };
      };
  };
  var ordSubscriptionId = Data_Ord.ordInt;
  var ordForkId = Data_Ord.ordInt;
  var monadTransHalogenM = new Control_Monad_Trans_Class.MonadTrans(function (dictMonad) {
      return function ($135) {
          return HalogenM(Control_Monad_Free.liftF(Lift.create($135)));
      };
  });
  var monadHalogenM = Control_Monad_Free.freeMonad;
  var monadStateHalogenM = new Control_Monad_State_Class.MonadState(function () {
      return monadHalogenM;
  }, function ($136) {
      return HalogenM(Control_Monad_Free.liftF(State.create($136)));
  });
  var hoist = function (dictFunctor) {
      return function (nat) {
          return function (v) {
              var go = function (v1) {
                  if (v1 instanceof State) {
                      return new State(v1.value0);
                  };
                  if (v1 instanceof Subscribe) {
                      return new Subscribe(v1.value0, v1.value1);
                  };
                  if (v1 instanceof Unsubscribe) {
                      return new Unsubscribe(v1.value0, v1.value1);
                  };
                  if (v1 instanceof Lift) {
                      return new Lift(nat(v1.value0));
                  };
                  if (v1 instanceof ChildQuery) {
                      return new ChildQuery(v1.value0);
                  };
                  if (v1 instanceof Raise) {
                      return new Raise(v1.value0, v1.value1);
                  };
                  if (v1 instanceof Par) {
                      return new Par(Data_Newtype.over()()(HalogenAp)(Control_Applicative_Free.hoistFreeAp(hoist(dictFunctor)(nat)))(v1.value0));
                  };
                  if (v1 instanceof Fork) {
                      return new Fork(hoist(dictFunctor)(nat)(v1.value0), v1.value1);
                  };
                  if (v1 instanceof Kill) {
                      return new Kill(v1.value0, v1.value1);
                  };
                  if (v1 instanceof GetRef) {
                      return new GetRef(v1.value0, v1.value1);
                  };
                  throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 300, column 8 - line 310, column 29): " + [ v1.constructor.name ]);
              };
              return Control_Monad_Free.hoistFree(go)(v);
          };
      };
  };
  var functorHalogenM = Control_Monad_Free.freeFunctor;
  var bindHalogenM = Control_Monad_Free.freeBind;           
  var applicativeHalogenM = Control_Monad_Free.freeApplicative;
  exports["State"] = State;
  exports["Subscribe"] = Subscribe;
  exports["Unsubscribe"] = Unsubscribe;
  exports["Lift"] = Lift;
  exports["ChildQuery"] = ChildQuery;
  exports["Raise"] = Raise;
  exports["Par"] = Par;
  exports["Fork"] = Fork;
  exports["Kill"] = Kill;
  exports["GetRef"] = GetRef;
  exports["raise"] = raise;
  exports["query"] = query;
  exports["SubscriptionId"] = SubscriptionId;
  exports["subscribe"] = subscribe;
  exports["subscribe'"] = subscribe$prime;
  exports["ForkId"] = ForkId;
  exports["hoist"] = hoist;
  exports["functorHalogenM"] = functorHalogenM;
  exports["applicativeHalogenM"] = applicativeHalogenM;
  exports["bindHalogenM"] = bindHalogenM;
  exports["monadHalogenM"] = monadHalogenM;
  exports["monadTransHalogenM"] = monadTransHalogenM;
  exports["monadStateHalogenM"] = monadStateHalogenM;
  exports["ordSubscriptionId"] = ordSubscriptionId;
  exports["ordForkId"] = ordForkId;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Audio"] = $PS["Domination.Capability.Audio"] || {};
  var exports = $PS["Domination.Capability.Audio"];
  var Audio_WebAudio_BaseAudioContext = $PS["Audio.WebAudio.BaseAudioContext"];
  var Audio_WebAudio_GainNode = $PS["Audio.WebAudio.GainNode"];
  var Audio_WebAudio_Oscillator = $PS["Audio.WebAudio.Oscillator"];
  var Audio_WebAudio_Types = $PS["Audio.WebAudio.Types"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect = $PS["Effect"];
  var Effect_Class = $PS["Effect.Class"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var Acknowledge = (function () {
      function Acknowledge() {

      };
      Acknowledge.value = new Acknowledge();
      return Acknowledge;
  })();
  var Purchase = (function () {
      function Purchase() {

      };
      Purchase.value = new Purchase();
      return Purchase;
  })();
  var $$Error = (function () {
      function $$Error() {

      };
      $$Error.value = new $$Error();
      return $$Error;
  })();
  var Attacked = (function () {
      function Attacked() {

      };
      Attacked.value = new Attacked();
      return Attacked;
  })();
  var Benefitted = (function () {
      function Benefitted() {

      };
      Benefitted.value = new Benefitted();
      return Benefitted;
  })();
  var YourTurn = (function () {
      function YourTurn() {

      };
      YourTurn.value = new YourTurn();
      return YourTurn;
  })();
  var Audio = function (Monad0, newAudioContext, note) {
      this.Monad0 = Monad0;
      this.newAudioContext = newAudioContext;
      this.note = note;
  };
  var runAudioM = function (v) {
      return Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(v);
  };
  var note$prime$prime = function (freq) {
      return function (start) {
          return function (stop) {
              return function (audioContext) {
                  return function __do() {
                      var oscillatorNode = Audio_WebAudio_BaseAudioContext.createOscillator(audioContext)();
                      Audio_WebAudio_Oscillator.setFrequency(freq)(oscillatorNode)();
                      var gainNode = Audio_WebAudio_BaseAudioContext.createGain(audioContext)();
                      Audio_WebAudio_GainNode.setGain(0.1)(gainNode)();
                      Audio_WebAudio_Types.connect(Audio_WebAudio_Types.connectableGainNode)()(oscillatorNode)(gainNode)();
                      var now = Audio_WebAudio_BaseAudioContext.currentTime(audioContext)();
                      Audio_WebAudio_Oscillator.startOscillator(now + start)(oscillatorNode)();
                      Audio_WebAudio_Oscillator.stopOscillator(now + stop)(oscillatorNode)();
                      var dest = Audio_WebAudio_BaseAudioContext.destination(audioContext)();
                      Audio_WebAudio_Types.connect(Audio_WebAudio_Types.connectableDestinationNode)()(gainNode)(dest)();
                      return Audio_WebAudio_BaseAudioContext.resume(audioContext)();
                  };
              };
          };
      };
  };
  var note$prime = function (context) {
      return function (freq) {
          return function (start) {
              return function (stop) {
                  return note$prime$prime(freq)(start)(stop)(context);
              };
          };
      };
  };
  var note = function (dict) {
      return dict.note;
  };
  var newAudioContext = function (dict) {
      return dict.newAudioContext;
  };
  var monadEffectAudioM = Effect_Class.monadEffectEffect;
  var monadAudioM = Effect.monadEffect;
  var g4 = 391.995;                        
  var fH4 = 369.99;
  var eb4 = 311.13;
  var e6 = 1318.51;
  var e5 = 659.25;
  var e4 = 329.628;
  var compose = function (dictAudio) {
      return function (context) {
          return function (notes) {
              var v = Data_Array.head(notes);
              if (v instanceof Data_Maybe.Nothing) {
                  return Control_Applicative.pure((dictAudio.Monad0()).Applicative0())(Data_Unit.unit);
              };
              if (v instanceof Data_Maybe.Just) {
                  var tail = Data_Array.drop(1)(notes);
                  return Control_Bind.discard(Control_Bind.discardUnit)((dictAudio.Monad0()).Bind1())(note(dictAudio)(context)(v.value0.frequency)(v.value0.start)(v.value0.start + v.value0.duration))(function () {
                      return compose(dictAudio)(context)(tail);
                  });
              };
              throw new Error("Failed pattern match at Domination.Capability.Audio (line 112, column 3 - line 117, column 27): " + [ v.constructor.name ]);
          };
      };
  };              
  var c5 = 523.25;             
  var doorbell = function (dictAudio) {
      return function (context) {
          return compose(dictAudio)(context)([ {
              frequency: e5,
              duration: 0.2,
              start: 0.0
          }, {
              frequency: c5,
              duration: 0.3,
              start: 0.2
          } ]);
      };
  };
  var c4 = 261.63;
  var goodNews = function (dictAudio) {
      return function (context) {
          return compose(dictAudio)(context)([ {
              frequency: c4,
              duration: 7.0e-2,
              start: 0.0
          }, {
              frequency: e4,
              duration: 7.0e-2,
              start: 0.12
          }, {
              frequency: g4,
              duration: 7.0e-2,
              start: 0.24
          }, {
              frequency: c5,
              duration: 0.2,
              start: 0.4
          } ]);
      };
  };
  var suspense = function (dictAudio) {
      return function (context) {
          return compose(dictAudio)(context)([ {
              frequency: eb4,
              duration: 0.1,
              start: 0.0
          }, {
              frequency: c4,
              duration: 0.1,
              start: 0.2
          }, {
              frequency: fH4,
              duration: 0.3,
              start: 0.4
          } ]);
      };
  };               
  var b5 = 987.77;             
  var marioCoin = function (dictAudio) {
      return function (context) {
          return compose(dictAudio)(context)([ {
              frequency: b5,
              duration: 0.1,
              start: 0.0
          }, {
              frequency: e6,
              duration: 0.2,
              start: 0.1
          } ]);
      };
  };              
  var audioHalogenM = function (dictAudio) {
      return new Audio(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictAudio.Monad0())(newAudioContext(dictAudio)), function (c) {
          return function (f) {
              return function (s) {
                  var $22 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictAudio.Monad0());
                  var $23 = note(dictAudio)(c)(f)(s);
                  return function ($24) {
                      return $22($23($24));
                  };
              };
          };
      });
  };
  var audioAudioM = new Audio(function () {
      return monadAudioM;
  }, Effect_Class.liftEffect(monadEffectAudioM)(Audio_WebAudio_BaseAudioContext.newAudioContext), function (c) {
      return function (f) {
          return function (s) {
              var $25 = Effect_Class.liftEffect(monadEffectAudioM);
              var $26 = note$prime(c)(f)(s);
              return function ($27) {
                  return $25($26($27));
              };
          };
      };
  });
  var audioAppM = new Audio(function () {
      return Domination_AppM.monadAppM;
  }, Effect_Class.liftEffect(Domination_AppM.monadEffectAppM)(Audio_WebAudio_BaseAudioContext.newAudioContext), function (c) {
      return function (f) {
          return function (s) {
              var $28 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
              var $29 = note$prime(c)(f)(s);
              return function ($30) {
                  return $28($29($30));
              };
          };
      };
  });                                              
  var ab4 = 415.3;
  var beep = function (dictAudio) {
      return function (context) {
          return function (v) {
              if (v instanceof Acknowledge) {
                  return note(dictAudio)(context)(c5)(0.0)(5.0e-2);
              };
              if (v instanceof Purchase) {
                  return marioCoin(dictAudio)(context);
              };
              if (v instanceof $$Error) {
                  return note(dictAudio)(context)(ab4)(0.0)(5.0e-2);
              };
              if (v instanceof Attacked) {
                  return suspense(dictAudio)(context);
              };
              if (v instanceof Benefitted) {
                  return goodNews(dictAudio)(context);
              };
              if (v instanceof YourTurn) {
                  return doorbell(dictAudio)(context);
              };
              throw new Error("Failed pattern match at Domination.Capability.Audio (line 65, column 16 - line 71, column 31): " + [ v.constructor.name ]);
          };
      };
  };
  exports["newAudioContext"] = newAudioContext;
  exports["runAudioM"] = runAudioM;
  exports["Acknowledge"] = Acknowledge;
  exports["Purchase"] = Purchase;
  exports["Error"] = $$Error;
  exports["Attacked"] = Attacked;
  exports["Benefitted"] = Benefitted;
  exports["YourTurn"] = YourTurn;
  exports["beep"] = beep;
  exports["audioHalogenM"] = audioHalogenM;
  exports["audioAppM"] = audioAppM;
  exports["audioAudioM"] = audioAudioM;
})(PS);
(function(exports) {
  'use strict'

  // Add singleton management at the top
  const getWebSocket = () => window._singletonWebSocket
  const setWebSocket = (ws) => { window._singletonWebSocket = ws }
  const clearWebSocket = () => {
    const ws = getWebSocket()
    if (ws) {
      try {
        ws.close()
        logInfo('Closed existing WebSocket connection')
      } catch (e) {
        logError('Error closing existing WebSocket:', e)
      }
    }
    window._singletonWebSocket = null
  }

  const log = level => (...args) => console[level]('WebSocket FFI: ', ...args)
  const logInfo = (...args) => log('log')(...args)
  const logError = (...args) => {
    log('error')(...args)
    const errorMessage = args.map(arg =>
      typeof arg === 'object' ? JSON.stringify(arg) : arg
    ).join(' ')
    alert('Error: ' + errorMessage)
  }

  const broadcastEvent = messageTarget => event => {
    const eventTarget = document.querySelector('#' + messageTarget)
    if (eventTarget) {
      eventTarget.dispatchEvent(customEvent(event))
    }
    else {
      logError(`${domQuery} undefined, cannot dispatch event: `, event)
    }
  }

  const customEvent = detail =>
    new CustomEvent('purescript', { detail })

  exports.showWebSocket = ws => `WebSocket(${ws.url})`

  exports.makeWebSocketFFI = left =>
    right =>
    roomCode =>
    remoteMessageTarget =>
    serverUrl =>
    callback =>
    () => {
      try {
        // Check for existing connection
        const existing = getWebSocket()
        if (existing) {
          logInfo('Reusing existing WebSocket connection')
          callback(right(existing))()
          return () => {} // No-op cleanup for reused connection
        }

        const ws = new WebSocket(serverUrl)
        ws.address = crypto.randomUUID()
        setWebSocket(ws)

        const shutdown = (event) => {
          try {
            ws.close()
            clearWebSocket()
            logInfo(`closed websocket on '${event.type}'`)
          } catch (e) {
            logInfo(`failed to close websocket on '${event.type}'`)
          }
        }

        window.addEventListener("unload", shutdown)
        window.addEventListener("beforeunload", shutdown)

        ws.onopen = () => {
          logInfo('WebSocket connected')
          callback(right(ws))()
        }

        ws.onclose = (event) => {
          logInfo('WebSocket disconnected', event.code, event.reason)

          // Attempt reconnection if not intentionally closed
          if (event.code !== 1000 && event.code !== 1001) {
            logInfo('Attempting to reconnect in 5 seconds...')
            setTimeout(() => {
              clearWebSocket()
              exports.makeWebSocketFFI(left)(right)(roomCode)
                (remoteMessageTarget)(serverUrl)(callback)()
            }, 5000)
          }
        }

        ws.onmessage = event => {
          logInfo('Received message:', event.data)
          if (event.data instanceof Blob) {
            event.data.text().then(text => {
              broadcastEvent(remoteMessageTarget)(text)
            })
          } else {
            broadcastEvent(remoteMessageTarget)(event.data)
          }
        }

        ws.onerror = error => {
          logError('WebSocket error:', error)
          callback(left(error))()
        }

        return () => shutdown({ type: 'cancel' })
      } catch (error) {
        logError('Connection setup error:', error)
        callback(left(error))()
        return () => {}
      }
  }

  exports.send = ws => message => () => {
    logInfo("sent message: ", message)
    ws.send(message)
  }

  exports.address = ws => () => ws.address
})(PS["FFI.WebSocket"] = PS["FFI.WebSocket"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["FFI.WebSocket"] = $PS["FFI.WebSocket"] || {};
  var exports = $PS["FFI.WebSocket"];
  var $foreign = $PS["FFI.WebSocket"];
  var Data_Either = $PS["Data.Either"];                
  var makeWebSocket = $foreign.makeWebSocketFFI(Data_Either.Left.create)(Data_Either.Right.create);
  exports["makeWebSocket"] = makeWebSocket;
  exports["showWebSocket"] = $foreign.showWebSocket;
  exports["send"] = $foreign.send;
  exports["address"] = $foreign.address;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Broadcast.WebSocket"] = $PS["Domination.Capability.Broadcast.WebSocket"] || {};
  var exports = $PS["Domination.Capability.Broadcast.WebSocket"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Show = $PS["Data.Show"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var FFI_WebSocket = $PS["FFI.WebSocket"];                
  var WebSocketBroadcaster = function (x) {
      return x;
  };
  var showWebSocketBroadcaster = new Data_Show.Show(function (v) {
      return FFI_WebSocket.showWebSocket(v);
  });
  var getWebSocketAddress = function (v) {
      return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(FFI_WebSocket.address(v));
  };
  var createWebSocketBroadcaster = function (roomCode) {
      return function (remoteMessageTarget) {
          return function (serverUrl) {
              return Control_Monad_Error_Class["try"](Effect_Aff.monadErrorAff)(Data_Functor.map(Effect_Aff.functorAff)(WebSocketBroadcaster)(Effect_Aff.makeAff(FFI_WebSocket.makeWebSocket(roomCode)(remoteMessageTarget)(serverUrl))));
          };
      };
  };
  var broadcastWebSocketMessage = function (v) {
      var $6 = Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
      var $7 = FFI_WebSocket.send(v);
      return function ($8) {
          return $6($7($8));
      };
  };
  exports["broadcastWebSocketMessage"] = broadcastWebSocketMessage;
  exports["createWebSocketBroadcaster"] = createWebSocketBroadcaster;
  exports["getWebSocketAddress"] = getWebSocketAddress;
  exports["showWebSocketBroadcaster"] = showWebSocketBroadcaster;
})(PS);
(function(exports) {
  "use strict";

  exports.log = function (s) {
    return function () {
      console.log(s);
    };
  };

  exports.warn = function (s) {
    return function () {
      console.warn(s);
    };
  };

  exports.error = function (s) {
    return function () {
      console.error(s);
    };
  };
})(PS["Effect.Console"] = PS["Effect.Console"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Console"] = $PS["Effect.Console"] || {};
  var exports = $PS["Effect.Console"];
  var $foreign = $PS["Effect.Console"];
  exports["log"] = $foreign.log;
  exports["warn"] = $foreign.warn;
  exports["error"] = $foreign.error;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Log"] = $PS["Domination.Capability.Log"] || {};
  var exports = $PS["Domination.Capability.Log"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Console = $PS["Effect.Console"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Log = function (Monad0, error, log) {
      this.Monad0 = Monad0;
      this.error = error;
      this.log = log;
  };    
  var logAppM = new Log(function () {
      return Domination_AppM.monadAppM;
  }, (function () {
      var $12 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      return function ($13) {
          return $12(Effect_Console.error($13));
      };
  })(), (function () {
      var $14 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      return function ($15) {
          return $14(Effect_Console.log($15));
      };
  })());
  var log = function (dict) {
      return dict.log;
  };                                     
  var error = function (dict) {
      return dict.error;
  };
  var logExceptTString = function (dictLog) {
      return new Log(function () {
          return Control_Monad_Except_Trans.monadExceptT(dictLog.Monad0());
      }, (function () {
          var $16 = Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(dictLog.Monad0());
          var $17 = error(dictLog);
          return function ($18) {
              return $16($17($18));
          };
      })(), (function () {
          var $19 = Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(dictLog.Monad0());
          var $20 = log(dictLog);
          return function ($21) {
              return $19($20($21));
          };
      })());
  };
  var logHalogenM = function (dictLog) {
      return new Log(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, (function () {
          var $22 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictLog.Monad0());
          var $23 = error(dictLog);
          return function ($24) {
              return $22($23($24));
          };
      })(), (function () {
          var $25 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictLog.Monad0());
          var $26 = log(dictLog);
          return function ($27) {
              return $25($26($27));
          };
      })());
  };
  exports["error"] = error;
  exports["log"] = log;
  exports["logHalogenM"] = logHalogenM;
  exports["logAppM"] = logAppM;
  exports["logExceptTString"] = logExceptTString;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Broadcast"] = $PS["Domination.Capability.Broadcast"] || {};
  var exports = $PS["Domination.Capability.Broadcast"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Show = $PS["Data.Show"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Domination_Capability_Broadcast_WebSocket = $PS["Domination.Capability.Broadcast.WebSocket"];
  var Domination_Capability_Log = $PS["Domination.Capability.Log"];
  var Effect_Aff_Class = $PS["Effect.Aff.Class"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Broadcast = function (Monad0, address, broadcast, create) {
      this.Monad0 = Monad0;
      this.address = address;
      this.broadcast = broadcast;
      this.create = create;
  };
  var webSocketBroadcasterAppM = new Broadcast(function () {
      return Domination_AppM.monadAppM;
  }, (function () {
      var $8 = Effect_Aff_Class.liftAff(Domination_AppM.monadAffAppM);
      return function ($9) {
          return $8(Domination_Capability_Broadcast_WebSocket.getWebSocketAddress($9));
      };
  })(), function (broadcaster) {
      var $10 = Effect_Aff_Class.liftAff(Domination_AppM.monadAffAppM);
      var $11 = Domination_Capability_Broadcast_WebSocket.broadcastWebSocketMessage(broadcaster);
      return function ($12) {
          return $10($11($12));
      };
  }, function (roomCode) {
      return function (remoteMessageTarget) {
          return function (serverUrl) {
              return Effect_Aff_Class.liftAff(Domination_AppM.monadAffAppM)(Domination_Capability_Broadcast_WebSocket.createWebSocketBroadcaster(roomCode)(remoteMessageTarget)(serverUrl));
          };
      };
  });                                           
  var create = function (dict) {
      return dict.create;
  };
  var maybeCreateBroadcaster = function (dictLog) {
      return function (dictBroadcast) {
          return function (roomCode) {
              return function (remoteMessageTarget) {
                  return function (serverUrl) {
                      return Control_Bind.bind((dictBroadcast.Monad0()).Bind1())(create(dictBroadcast)(roomCode)(remoteMessageTarget)(serverUrl))(function (eBroadcaster) {
                          if (eBroadcaster instanceof Data_Either.Left) {
                              return Control_Bind.discard(Control_Bind.discardUnit)((dictBroadcast.Monad0()).Bind1())(Domination_Capability_Log.log(dictLog)("Error creating broadcaster: " + Data_Show.show(Effect_Exception.showError)(eBroadcaster.value0)))(function () {
                                  return Control_Applicative.pure((dictBroadcast.Monad0()).Applicative0())(Data_Maybe.Nothing.value);
                              });
                          };
                          if (eBroadcaster instanceof Data_Either.Right) {
                              return Control_Applicative.pure((dictBroadcast.Monad0()).Applicative0())(new Data_Maybe.Just(eBroadcaster.value0));
                          };
                          throw new Error("Failed pattern match at Domination.Capability.Broadcast (line 75, column 3 - line 79, column 29): " + [ eBroadcaster.constructor.name ]);
                      });
                  };
              };
          };
      };
  }; 
  var broadcast = function (dict) {
      return dict.broadcast;
  };                                                    
  var address = function (dict) {
      return dict.address;
  };
  var broadcastHalogenM = function (dictBroadcast) {
      return new Broadcast(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, (function () {
          var $18 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictBroadcast.Monad0());
          var $19 = address(dictBroadcast);
          return function ($20) {
              return $18($19($20));
          };
      })(), function (broadcaster) {
          var $21 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictBroadcast.Monad0());
          var $22 = broadcast(dictBroadcast)(broadcaster);
          return function ($23) {
              return $21($22($23));
          };
      }, function (a) {
          return function (b) {
              var $24 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictBroadcast.Monad0());
              var $25 = create(dictBroadcast)(a)(b);
              return function ($26) {
                  return $24($25($26));
              };
          };
      });
  };
  exports["broadcast"] = broadcast;
  exports["maybeCreateBroadcaster"] = maybeCreateBroadcaster;
  exports["webSocketBroadcasterAppM"] = webSocketBroadcasterAppM;
  exports["broadcastHalogenM"] = broadcastHalogenM;
})(PS);
(function(exports) {
  'use strict'

  // helpers

  const broadcastEvent = messageTarget => event => {
    const eventTarget = document.querySelector('#' + messageTarget)
    if (eventTarget) {
      eventTarget.dispatchEvent(customEvent(event))
    }
    else {
      logError(`${domQuery} undefined, cannot dispatch event: `, event)
    }
  }

  const customEvent = detail =>
    new CustomEvent('purescript', { detail })

  const log = level => (...args) => console[level]('FFI: ', ...args)

  const logInfo = (...args) => log('log')(...args)

  const logError = (...args) => log('error')(...args)

  // exports

  exports.registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
      const onLoad = () =>
        navigator.serviceWorker.
           register('sw.js')
          .then(({ scope }) =>
            logInfo(
              'ServiceWorker registration successful with scope: ',
              scope
            )
          )
          .catch(error =>
            logInfo('ServiceWorker registration failed: ', error)
          )
      window.addEventListener('load', onLoad)
    } else {
      logInfo('ServiceWorker unsupported')
    }
  }

  exports.detail = ({ detail }) => detail

  const MESSAGE_BUFFER_LENGTH = 4
  const messageBuffer = []

  const newMessage = (message) => {
    if (messageBuffer.includes(message)) {
      return false
    }
    messageBuffer.push(message)
    while (messageBuffer.length > MESSAGE_BUFFER_LENGTH) {
      messageBuffer.shift()
    }
    return true
  }                                       

  const getBugout = () => {
    // TODO: check if bugout is in a good state, or if it needs to be destroyed
    if (window.bugout instanceof Bugout) {
      return window.bugout
    }
  }

  const reloadOnNetworkChange = () => {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    let type = connection.effectiveType

    function updateConnectionStatus() {
      logInfo("Connection type changed from " + type + " to " + connection.effectiveType)
      location.reload()
    }

    connection.addEventListener('change', updateConnectionStatus);
  }

  // https://stackoverflow.com/a/8809472
  exports.genUuid = () => { // Public Domain/MIT
    var d = new Date().getTime()

    // Time in microseconds since page-load or 0 if unsupported
    var d2 = (performance && performance.now && (performance.now() * 1000)) || 0
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.
       replace(/[xy]/g, c => {
        // random number between 0 and 16
        var r = Math.random() * 16

        if(d > 0){
          // Use timestamp until depleted
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else {
          // Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).
           toString(16)
      })
  }

  exports.arrayBufferAsString = buffer =>
    String.fromCharCode.apply(null, new Uint8Array(buffer))

  exports.stringAsArrayBuffer = string => {
    const stringLength = string.length
    const buffer = new ArrayBuffer(stringLength * 2)
    const bufferView = new Uint8Array(buffer)
    for (let i = 0; i < stringLength; i++) {
      bufferView[i] = string.charCodeAt(i)
    }
    return buffer
  }

  // cannot eta-reduce this function because LZString does not
  // exist in our test suite - we currently import the library
  // in an HTML script tag
  // https://github.com/pieroxy/lz-string/issues/167#issuecomment-1319644753
  exports.compressString = s => LZString.compressToUTF16(s)

  exports.decompressStringFFI = just => nothing => s => {
  // https://github.com/pieroxy/lz-string/issues/167#issuecomment-1319644753
    const result = LZString.decompressFromUTF16(s)
    return result == null
      ? nothing
      : just(result)
  }

  exports.setItem = left => right => unit => key => value => storage => () => {
    try {
      storage.setItem(key, value)
      return right(unit)
    } catch (e) {
      return left(`Error: setItem: key='${key}', value='${value}', error message: '${e.message || e}'`)
    }
  }

  exports.now = () => performance.now()
})(PS["FFI"] = PS["FFI"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["FFI"] = $PS["FFI"] || {};
  var exports = $PS["FFI"];
  var $foreign = $PS["FFI"];
  var Data_Maybe = $PS["Data.Maybe"];                                                        
  var decompressString = $foreign.decompressStringFFI(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  exports["decompressString"] = decompressString;
  exports["registerServiceWorker"] = $foreign.registerServiceWorker;
  exports["detail"] = $foreign.detail;
  exports["genUuid"] = $foreign.genUuid;
  exports["arrayBufferAsString"] = $foreign.arrayBufferAsString;
  exports["stringAsArrayBuffer"] = $foreign.stringAsArrayBuffer;
  exports["compressString"] = $foreign.compressString;
  exports["setItem"] = $foreign.setItem;
  exports["now"] = $foreign.now;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Clock"] = $PS["Domination.Capability.Clock"] || {};
  var exports = $PS["Domination.Capability.Clock"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect_Class = $PS["Effect.Class"];
  var FFI = $PS["FFI"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var Clock = function (Monad0, now) {
      this.Monad0 = Monad0;
      this.now = now;
  };
  var now = function (dict) {
      return dict.now;
  };                                                                                    
  var clockHalogenM = function (dictClock) {
      return new Clock(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictClock.Monad0())(now(dictClock)));
  };
  var clockAppM = new Clock(function () {
      return Domination_AppM.monadAppM;
  }, Effect_Class.liftEffect(Domination_AppM.monadEffectAppM)(FFI.now));
  exports["now"] = now;
  exports["clockHalogenM"] = clockHalogenM;
  exports["clockAppM"] = clockAppM;
})(PS);
(function(exports) {
  "use strict";

  exports._currentTarget = function (e) {
    return e.currentTarget;
  };

  exports.stopPropagation = function (e) {
    return function () {
      return e.stopPropagation();
    };
  };
})(PS["Web.Event.Event"] = PS["Web.Event.Event"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.Event.Event"] = $PS["Web.Event.Event"] || {};
  var exports = $PS["Web.Event.Event"];
  var $foreign = $PS["Web.Event.Event"];
  var Data_Nullable = $PS["Data.Nullable"];
  var currentTarget = function ($5) {
      return Data_Nullable.toMaybe($foreign["_currentTarget"]($5));
  };
  exports["currentTarget"] = currentTarget;
  exports["stopPropagation"] = $foreign.stopPropagation;
})(PS);
(function(exports) {
  "use strict";

  exports.window = function () {
    return window;
  };
})(PS["Web.HTML"] = PS["Web.HTML"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML"] = $PS["Web.HTML"] || {};
  var exports = $PS["Web.HTML"];
  var $foreign = $PS["Web.HTML"];
  exports["window"] = $foreign.window;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Dom"] = $PS["Domination.Capability.Dom"] || {};
  var exports = $PS["Domination.Capability.Dom"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect_Class = $PS["Effect.Class"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Web_Event_Event = $PS["Web.Event.Event"];
  var Web_HTML = $PS["Web.HTML"];
  var Dom = function (Monad0, stopPropagation, window) {
      this.Monad0 = Monad0;
      this.stopPropagation = stopPropagation;
      this.window = window;
  };
  var window = function (dict) {
      return dict.window;
  };
  var stopPropagation = function (dict) {
      return dict.stopPropagation;
  };                                     
  var domHalogenM = function (dictDom) {
      return new Dom(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, (function () {
          var $3 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictDom.Monad0());
          var $4 = stopPropagation(dictDom);
          return function ($5) {
              return $3($4($5));
          };
      })(), Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictDom.Monad0())(window(dictDom)));
  };                                                               
  var domAppM = new Dom(function () {
      return Domination_AppM.monadAppM;
  }, (function () {
      var $8 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      return function ($9) {
          return $8(Web_Event_Event.stopPropagation($9));
      };
  })(), Effect_Class.liftEffect(Domination_AppM.monadEffectAppM)(Web_HTML.window));
  exports["stopPropagation"] = stopPropagation;
  exports["window"] = window;
  exports["domHalogenM"] = domHalogenM;
  exports["domAppM"] = domAppM;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.GenUuid"] = $PS["Domination.Capability.GenUuid"] || {};
  var exports = $PS["Domination.Capability.GenUuid"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect_Class = $PS["Effect.Class"];
  var FFI = $PS["FFI"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var GenUuid = function (Monad0, genUuid) {
      this.Monad0 = Monad0;
      this.genUuid = genUuid;
  };                                                            
  var genUuidAppM = new GenUuid(function () {
      return Domination_AppM.monadAppM;
  }, Effect_Class.liftEffect(Domination_AppM.monadEffectAppM)(FFI.genUuid));
  var genUuid = function (dict) {
      return dict.genUuid;
  };
  var genUuidHalogenM = function (dictGenUuid) {
      return new GenUuid(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictGenUuid.Monad0())(genUuid(dictGenUuid)));
  };
  exports["genUuid"] = genUuid;
  exports["genUuidHalogenM"] = genUuidHalogenM;
  exports["genUuidAppM"] = genUuidAppM;
})(PS);
(function(exports) {
  "use strict";

  exports.random = Math.random;
})(PS["Effect.Random"] = PS["Effect.Random"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Effect.Random"] = $PS["Effect.Random"] || {};
  var exports = $PS["Effect.Random"];
  var $foreign = $PS["Effect.Random"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Effect = $PS["Effect"];
  var randomInt = function (low) {
      return function (high) {
          return function __do() {
              var n = $foreign.random();
              var asNumber = ((Data_Int.toNumber(high) - Data_Int.toNumber(low)) + 1) * n + Data_Int.toNumber(low);
              return Data_Int.floor(asNumber);
          };
      };
  };
  var randomBool = Data_Functor.map(Effect.functorEffect)(function (v) {
      return v < 0.5;
  })($foreign.random);
  exports["randomInt"] = randomInt;
  exports["randomBool"] = randomBool;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Random"] = $PS["Domination.Capability.Random"] || {};
  var exports = $PS["Domination.Capability.Random"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Random = $PS["Effect.Random"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Util = $PS["Util"];
  var Random = function (Monad0, randomBoolean, randomElement, randomIntBetween, shuffle) {
      this.Monad0 = Monad0;
      this.randomBoolean = randomBoolean;
      this.randomElement = randomElement;
      this.randomIntBetween = randomIntBetween;
      this.shuffle = shuffle;
  };
  var shuffle = function (dict) {
      return dict.shuffle;
  };
  var randomShuffle = function (dictMonadEffect) {
      return function (dictEq) {
          return function (array) {
              var shuffle$prime = function (v) {
                  if (v.value1.length === 0) {
                      return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(new Data_Tuple.Tuple(v.value0, [  ]));
                  };
                  return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Effect_Random.randomInt(0)(Data_Array.length(v.value1) - 1 | 0)))(function (i) {
                      var randomElement$prime = Data_Array.take(1)(Data_Array.drop(i)(v.value1));
                      var unshuffledRemainder = Util.dropIndex(i)(v.value1);
                      return shuffle$prime(new Data_Tuple.Tuple(Data_Semigroup.append(Data_Semigroup.semigroupArray)(randomElement$prime)(v.value0), unshuffledRemainder));
                  });
              };
              return Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(Data_Tuple.fst)(shuffle$prime(new Data_Tuple.Tuple([  ], array)));
          };
      };
  };
  var randomIntBetween = function (dict) {
      return dict.randomIntBetween;
  };
  var randomElement = function (dict) {
      return dict.randomElement;
  };
  var randomBoolean = function (dict) {
      return dict.randomBoolean;
  };
  var randomHalogenM = function (dictRandom) {
      return new Random(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictRandom.Monad0())(randomBoolean(dictRandom)), (function () {
          var $31 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictRandom.Monad0());
          var $32 = randomElement(dictRandom);
          return function ($33) {
              return $31($32($33));
          };
      })(), function (a) {
          var $34 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictRandom.Monad0());
          var $35 = randomIntBetween(dictRandom)(a);
          return function ($36) {
              return $34($35($36));
          };
      }, function (dictEq) {
          var $37 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictRandom.Monad0());
          var $38 = shuffle(dictRandom)(dictEq);
          return function ($39) {
              return $37($38($39));
          };
      });
  };
  var pickRandomElement = function (dictMonadEffect) {
      return function (xs) {
          return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Effect_Random.randomInt(0)(Data_Array.length(xs) - 1 | 0)))(function (i) {
              return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(Data_Array.index(xs)(i));
          });
      };
  };
  var randomAppM = new Random(function () {
      return Domination_AppM.monadAppM;
  }, Effect_Class.liftEffect(Domination_AppM.monadEffectAppM)(Effect_Random.randomBool), (function () {
      var $40 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      var $41 = pickRandomElement(Effect_Class.monadEffectEffect);
      return function ($42) {
          return $40($41($42));
      };
  })(), function (a) {
      var $43 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      var $44 = Effect_Random.randomInt(a);
      return function ($45) {
          return $43($44($45));
      };
  }, function (dictEq) {
      var $46 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      var $47 = randomShuffle(Effect_Class.monadEffectEffect)(dictEq);
      return function ($48) {
          return $46($47($48));
      };
  });                                       
  var exceptTStringRandomM = function (dictRandom) {
      return new Random(function () {
          return Control_Monad_Except_Trans.monadExceptT(dictRandom.Monad0());
      }, Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(dictRandom.Monad0())(randomBoolean(dictRandom)), function (xs) {
          return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictRandom.Monad0()))(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictRandom.Monad0()))(xs))((function () {
              var $58 = Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(dictRandom.Monad0());
              var $59 = randomElement(dictRandom);
              return function ($60) {
                  return $58($59($60));
              };
          })());
      }, function (a) {
          var $61 = Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(dictRandom.Monad0());
          var $62 = randomIntBetween(dictRandom)(a);
          return function ($63) {
              return $61($62($63));
          };
      }, function (dictEq) {
          return function (xs) {
              return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictRandom.Monad0()))(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictRandom.Monad0()))(xs))((function () {
                  var $64 = Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(dictRandom.Monad0());
                  var $65 = shuffle(dictRandom)(dictEq);
                  return function ($66) {
                      return $64($65($66));
                  };
              })());
          };
      });
  };
  exports["randomElement"] = randomElement;
  exports["randomIntBetween"] = randomIntBetween;
  exports["shuffle"] = shuffle;
  exports["randomHalogenM"] = randomHalogenM;
  exports["exceptTStringRandomM"] = exceptTStringRandomM;
  exports["randomAppM"] = randomAppM;
})(PS);
(function(exports) {
  "use strict";

  exports.document = function (window) {
    return function () {
      return window.document;
    };
  };

  exports.localStorage = function (window) {
    return function () {
      return window.localStorage;
    };
  };
})(PS["Web.HTML.Window"] = PS["Web.HTML.Window"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML.Window"] = $PS["Web.HTML.Window"] || {};
  var exports = $PS["Web.HTML.Window"];
  var $foreign = $PS["Web.HTML.Window"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var toEventTarget = Unsafe_Coerce.unsafeCoerce;
  exports["toEventTarget"] = toEventTarget;
  exports["document"] = $foreign.document;
  exports["localStorage"] = $foreign.localStorage;
})(PS);
(function(exports) {
  "use strict";

  exports._getItem = function (key) {
    return function (storage) {
      return function () {
        return storage.getItem(key);
      };
    };
  };
})(PS["Web.Storage.Storage"] = PS["Web.Storage.Storage"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.Storage.Storage"] = $PS["Web.Storage.Storage"] || {};
  var exports = $PS["Web.Storage.Storage"];
  var $foreign = $PS["Web.Storage.Storage"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Effect = $PS["Effect"];
  var getItem = function (s) {
      var $3 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      var $4 = $foreign["_getItem"](s);
      return function ($5) {
          return $3($4($5));
      };
  };
  exports["getItem"] = getItem;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Storage"] = $PS["Domination.Capability.Storage"] || {};
  var exports = $PS["Domination.Capability.Storage"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Argonaut_Core = $PS["Data.Argonaut.Core"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Unit = $PS["Data.Unit"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect = $PS["Effect"];
  var Effect_Class = $PS["Effect.Class"];
  var FFI = $PS["FFI"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Util = $PS["Util"];
  var Web_HTML = $PS["Web.HTML"];
  var Web_HTML_Window = $PS["Web.HTML.Window"];
  var Web_Storage_Storage = $PS["Web.Storage.Storage"];
  var Storage = function (Monad0, load, save) {
      this.Monad0 = Monad0;
      this.load = load;
      this.save = save;
  };
  var saveStorage = function (dictMonadEffect) {
      return function (dictEncodeJson) {
          return function (dictDecodeJson) {
              return function (key) {
                  return function (value) {
                      var stringValue = Data_Argonaut_Core.stringify(Data_Argonaut_Encode_Class.encodeJson(dictEncodeJson)(value));
                      var contextualizeError = function (error) {
                          return "Error saving to local storage." + (" key: '" + (key + ("'" + (" value: '" + (stringValue + ("'" + (" error: '" + (error + "'"))))))));
                      };
                      return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
                          var result = Control_Bind.bind(Effect.bindEffect)(Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.localStorage))(FFI.setItem(Data_Either.Left.create)(Data_Either.Right.create)(Data_Unit.unit)(key)(stringValue))();
                          return Util.mapLeft(contextualizeError)(result);
                      });
                  };
              };
          };
      };
  };
  var save = function (dict) {
      return dict.save;
  };                                                       
  var loadStorage = function (dictMonadEffect) {
      return function (dictEncodeJson) {
          return function (dictDecodeJson) {
              return function (key) {
                  var error = "Error loading item from storage at key: '" + (key + "'");
                  return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
                      var maybeItem = Control_Bind.bind(Effect.bindEffect)(Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.localStorage))(Web_Storage_Storage.getItem(key))();
                      var eitherItemOrError = Data_Either.note(error)(maybeItem);
                      return Control_Bind.bind(Data_Either.bindEither)(eitherItemOrError)(Util.readJson(dictDecodeJson));
                  });
              };
          };
      };
  };
  var storageAppM = new Storage(function () {
      return Domination_AppM.monadAppM;
  }, function (dictEncodeJson) {
      return function (dictDecodeJson) {
          var $21 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
          var $22 = loadStorage(Effect_Class.monadEffectEffect)(dictEncodeJson)(dictDecodeJson);
          return function ($23) {
              return $21($22($23));
          };
      };
  }, function (dictEncodeJson) {
      return function (dictDecodeJson) {
          return function (key) {
              var $24 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
              var $25 = saveStorage(Effect_Class.monadEffectEffect)(dictEncodeJson)(dictDecodeJson)(key);
              return function ($26) {
                  return $24($25($26));
              };
          };
      };
  });
  var load = function (dict) {
      return dict.load;
  };
  var storageHalogenM = function (dictStorage) {
      return new Storage(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, function (dictEncodeJson) {
          return function (dictDecodeJson) {
              var $33 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictStorage.Monad0());
              var $34 = load(dictStorage)(dictEncodeJson)(dictDecodeJson);
              return function ($35) {
                  return $33($34($35));
              };
          };
      }, function (dictEncodeJson) {
          return function (dictDecodeJson) {
              return function (key) {
                  var $36 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictStorage.Monad0());
                  var $37 = save(dictStorage)(dictEncodeJson)(dictDecodeJson)(key);
                  return function ($38) {
                      return $36($37($38));
                  };
              };
          };
      });
  };
  exports["load"] = load;
  exports["save"] = save;
  exports["storageHalogenM"] = storageHalogenM;
  exports["storageAppM"] = storageAppM;
})(PS);
(function(exports) {
  "use strict";

  exports.reallyUnsafeRefEq = function (a) {
    return function (b) {
      return a === b;
    };
  };
})(PS["Unsafe.Reference"] = PS["Unsafe.Reference"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Unsafe.Reference"] = $PS["Unsafe.Reference"] || {};
  var exports = $PS["Unsafe.Reference"];
  var $foreign = $PS["Unsafe.Reference"];
  var unsafeRefEq = $foreign.reallyUnsafeRefEq;
  exports["unsafeRefEq"] = unsafeRefEq;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Subscription"] = $PS["Halogen.Subscription"] || {};
  var exports = $PS["Halogen.Subscription"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Array = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Effect = $PS["Effect"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Safe_Coerce = $PS["Safe.Coerce"];
  var Unsafe_Reference = $PS["Unsafe.Reference"];
  var unsubscribe = function (v) {
      return v;
  };
  var subscribe = function (v) {
      return function (k) {
          return v((function () {
              var $55 = Data_Functor["void"](Effect.functorEffect);
              return function ($56) {
                  return $55(k($56));
              };
          })());
      };
  };                                                                               
  var notify = function (v) {
      return function (a) {
          return v(a);
      };
  };                                                                   
  var makeEmitter = Safe_Coerce.coerce();
  var create = function __do() {
      var subscribers = Effect_Ref["new"]([  ])();
      return {
          emitter: function (k) {
              return function __do() {
                  Effect_Ref.modify_(function (v) {
                      return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ k ]);
                  })(subscribers)();
                  return Effect_Ref.modify_(Data_Array.deleteBy(Unsafe_Reference.unsafeRefEq)(k))(subscribers);
              };
          },
          listener: function (a) {
              return Control_Bind.bind(Effect.bindEffect)(Effect_Ref.read(subscribers))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(function (k) {
                  return k(a);
              }));
          }
      };
  };
  exports["create"] = create;
  exports["notify"] = notify;
  exports["makeEmitter"] = makeEmitter;
  exports["subscribe"] = subscribe;
  exports["unsubscribe"] = unsubscribe;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.Timer"] = $PS["Domination.Capability.Timer"] || {};
  var exports = $PS["Domination.Capability.Timer"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_Int = $PS["Data.Int"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Aff_Class = $PS["Effect.Aff.Class"];
  var Effect_Class = $PS["Effect.Class"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Halogen_Subscription = $PS["Halogen.Subscription"];
  var Timer = function (Monad0, createTimer) {
      this.Monad0 = Monad0;
      this.createTimer = createTimer;
  };                                                         
  var createTimer = function (dict) {
      return dict.createTimer;
  };
  var timerHalogenM = function (dictTimer) {
      return new Timer(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, function (opts) {
          var $10 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictTimer.Monad0());
          var $11 = createTimer(dictTimer)(opts);
          return function ($12) {
              return $10($11($12));
          };
      });
  };
  var createAffTimer = function (dictMonadAff) {
      return function (v) {
          return function (val) {
              return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadAff.MonadEffect0())(Halogen_Subscription.create))(function (v1) {
                  return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Effect_Aff_Class.liftAff(dictMonadAff)(Effect_Aff.forkAff(Control_Monad_Rec_Class.forever(Effect_Aff.monadRecAff)(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Aff.delay(Data_Int.toNumber(v.interval)))(function () {
                      return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Halogen_Subscription.notify(v1.listener)(val));
                  })))))(function () {
                      return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(v1.emitter);
                  });
              });
          };
      };
  };
  var timerAppM = new Timer(function () {
      return Domination_AppM.monadAppM;
  }, function (opts) {
      var $13 = Effect_Aff_Class.liftAff(Domination_AppM.monadAffAppM);
      var $14 = createAffTimer(Effect_Aff_Class.monadAffAff)(opts);
      return function ($15) {
          return $13($14($15));
      };
  });
  exports["createTimer"] = createTimer;
  exports["timerHalogenM"] = timerHalogenM;
  exports["timerAppM"] = timerAppM;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Capability.WireCodec"] = $PS["Domination.Capability.WireCodec"] || {};
  var exports = $PS["Domination.Capability.WireCodec"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Trans_Class = $PS["Control.Monad.Trans.Class"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Effect = $PS["Effect"];
  var Effect_Class = $PS["Effect.Class"];
  var FFI = $PS["FFI"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var WireCodec = function (Monad0, readWire, writeWire) {
      this.Monad0 = Monad0;
      this.readWire = readWire;
      this.writeWire = writeWire;
  };
  var writeWire$prime = function (dictEncodeArrayBuffer) {
      return function (dictDynamicByteLength) {
          var $18 = Data_Functor.map(Effect.functorEffect)(function ($21) {
              return Data_Either.Right.create(FFI.compressString(FFI.arrayBufferAsString($21)));
          });
          var $19 = Data_ArrayBuffer_Class.encodeArrayBuffer(dictEncodeArrayBuffer)(dictDynamicByteLength);
          return function ($20) {
              return $18($19($20));
          };
      };
  };
  var writeWire = function (dict) {
      return dict.writeWire;
  };
  var readWire$prime = function (dictDecodeArrayBuffer) {
      return function (string) {
          var v = FFI.decompressString(string);
          if (v instanceof Data_Maybe.Nothing) {
              return Control_Applicative.pure(Effect.applicativeEffect)(Data_Either.Left.create("Failed to decompress string" + (" (are you sure this string was compressed?): " + string)));
          };
          if (v instanceof Data_Maybe.Just) {
              return function __do() {
                  var maybeA = Data_ArrayBuffer_Class.decodeArrayBuffer(dictDecodeArrayBuffer)(FFI.stringAsArrayBuffer(v.value0))();
                  return Data_Either.note("Failed to decode ArrayBuffer")(maybeA);
              };
          };
          throw new Error("Failed pattern match at Domination.Capability.WireCodec (line 78, column 3 - line 85, column 56): " + [ v.constructor.name ]);
      };
  };
  var wireCodecAppM = new WireCodec(function () {
      return Domination_AppM.monadAppM;
  }, function (dictDecodeArrayBuffer) {
      var $22 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
      var $23 = readWire$prime(dictDecodeArrayBuffer);
      return function ($24) {
          return $22($23($24));
      };
  }, function (dictEncodeArrayBuffer) {
      return function (dictDynamicByteLength) {
          var $25 = Effect_Class.liftEffect(Domination_AppM.monadEffectAppM);
          var $26 = writeWire$prime(dictEncodeArrayBuffer)(dictDynamicByteLength);
          return function ($27) {
              return $25($26($27));
          };
      };
  });
  var readWire = function (dict) {
      return dict.readWire;
  };
  var wireCodecHalogenM = function (dictWireCodec) {
      return new WireCodec(function () {
          return Halogen_Query_HalogenM.monadHalogenM;
      }, function (dictDecodeArrayBuffer) {
          var $28 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictWireCodec.Monad0());
          var $29 = readWire(dictWireCodec)(dictDecodeArrayBuffer);
          return function ($30) {
              return $28($29($30));
          };
      }, function (dictEncodeArrayBuffer) {
          return function (dictDynamicByteLength) {
              var $31 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictWireCodec.Monad0());
              var $32 = writeWire(dictWireCodec)(dictEncodeArrayBuffer)(dictDynamicByteLength);
              return function ($33) {
                  return $31($32($33));
              };
          };
      });
  };
  exports["readWire"] = readWire;
  exports["writeWire"] = writeWire;
  exports["wireCodecHalogenM"] = wireCodecHalogenM;
  exports["wireCodecAppM"] = wireCodecAppM;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Phase"] = $PS["Domination.Data.Phase"] || {};
  var exports = $PS["Domination.Data.Phase"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Show = $PS["Data.Show"];
  var Data_Show_Generic = $PS["Data.Show.Generic"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var ActionPhase = (function () {
      function ActionPhase() {

      };
      ActionPhase.value = new ActionPhase();
      return ActionPhase;
  })();
  var BuyPhase = (function () {
      function BuyPhase() {

      };
      BuyPhase.value = new BuyPhase();
      return BuyPhase;
  })();
  var CleanupPhase = (function () {
      function CleanupPhase() {

      };
      CleanupPhase.value = new CleanupPhase();
      return CleanupPhase;
  })();
  var next = function (v) {
      if (v instanceof ActionPhase) {
          return BuyPhase.value;
      };
      if (v instanceof BuyPhase) {
          return CleanupPhase.value;
      };
      if (v instanceof CleanupPhase) {
          return ActionPhase.value;
      };
      throw new Error("Failed pattern match at Domination.Data.Phase (line 43, column 1 - line 43, column 23): " + [ v.constructor.name ]);
  };
  var genericPhase = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof ActionPhase) {
          return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
      };
      if (x instanceof BuyPhase) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
      };
      if (x instanceof CleanupPhase) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
      };
      throw new Error("Failed pattern match at Domination.Data.Phase (line 27, column 1 - line 27, column 48): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return ActionPhase.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return BuyPhase.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
          return CleanupPhase.value;
      };
      throw new Error("Failed pattern match at Domination.Data.Phase (line 27, column 1 - line 27, column 48): " + [ x.constructor.name ]);
  });
  var phaseDecodeArrayBuffer = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericPhase)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))));
  var phaseEncodeArrayBuffer = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericPhase)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments)))));
  var showPhase = new Data_Show.Show(Data_Show_Generic.genericShow(genericPhase)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "ActionPhase";
  })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "BuyPhase";
  })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
      return "CleanupPhase";
  }))))));
  var eqPhase = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof ActionPhase && y instanceof ActionPhase) {
              return true;
          };
          if (x instanceof BuyPhase && y instanceof BuyPhase) {
              return true;
          };
          if (x instanceof CleanupPhase && y instanceof CleanupPhase) {
              return true;
          };
          return false;
      };
  });
  var encodeJsonPhase = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericPhase)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "ActionPhase";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "BuyPhase";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "CleanupPhase";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)))));
  var dynamicByteLengthPhase = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericPhase)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))));
  var decodeJsonPhase = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericPhase)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "ActionPhase";
  })))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "BuyPhase";
  })))(Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
      return "CleanupPhase";
  }))))));
  exports["ActionPhase"] = ActionPhase;
  exports["BuyPhase"] = BuyPhase;
  exports["CleanupPhase"] = CleanupPhase;
  exports["next"] = next;
  exports["eqPhase"] = eqPhase;
  exports["showPhase"] = showPhase;
  exports["encodeJsonPhase"] = encodeJsonPhase;
  exports["decodeJsonPhase"] = decodeJsonPhase;
  exports["dynamicByteLengthPhase"] = dynamicByteLengthPhase;
  exports["phaseEncodeArrayBuffer"] = phaseEncodeArrayBuffer;
  exports["phaseDecodeArrayBuffer"] = phaseDecodeArrayBuffer;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Stack"] = $PS["Domination.Data.Stack"] || {};
  var exports = $PS["Domination.Data.Stack"];
  var Data_Array = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Lens = $PS["Data.Lens.Lens"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Ring = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Cards = $PS["Domination.Data.Cards"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Util = $PS["Util"];                
  var toCards = function (v) {
      return Data_Array.replicate(v.count)(v.card);
  };
  var stacksToCards = Data_Array.concatMap(toCards);
  var stackCards = function (cards) {
      var names = Data_Array.nub(Data_Ord.ordString)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
          return v.name;
      })(cards));
      var f = function (name) {
          return function (stacks) {
              var cards$prime = Data_Array.filter(function ($25) {
                  return (function (v) {
                      return v === name;
                  })((function (v) {
                      return v.name;
                  })($25));
              })(cards);
              return Data_Array.cons(Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
                  return {
                      card: v,
                      count: Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(cards$prime)
                  };
              })(Data_Array.head(cards$prime)))(stacks);
          };
      };
      return Data_Array.catMaybes(Data_Array.foldr(f)([  ])(names));
  };
  var sortByStacks = function ($26) {
      return stacksToCards(stackCards($26));
  };
  var points = function (v) {
      return Data_Semiring.mul(Domination_Data_Points.ringPoints)(v.card.victoryPoints)(Domination_Data_Points.points(v.count));
  };
  var positivePoints = (function () {
      var $27 = Data_Ord.max(Domination_Data_Points.ordPoints)(Data_Semiring.zero(Domination_Data_Points.ringPoints));
      return function ($28) {
          return $27(points($28));
      };
  })();
  var $$new = function (card) {
      return function (count) {
          return {
              card: card,
              count: count
          };
      };
  };
  var negativePoints = (function () {
      var $29 = Data_Ord.min(Domination_Data_Points.ordPoints)(Data_Semiring.zero(Domination_Data_Points.ringPoints));
      return function ($30) {
          return $29(points($30));
      };
  })();
  var isEmpty = function ($31) {
      return (function (v) {
          return v <= 0;
      })((function (v) {
          return v.count;
      })($31));
  };
  var assertNotEmpty = function (dictMonadError) {
      return Util.assert(dictMonadError)(function ($32) {
          return (function (v) {
              return v > 0;
          })((function (v) {
              return v.count;
          })($32));
      })("stack is empty!");
  };
  var _stacksToCardsIso = function (dictProfunctor) {
      return Data_Lens_Iso.iso(stacksToCards)(stackCards)(dictProfunctor);
  };
  var _stacksFromCards = function (dictStrong) {
      var f = function (cards) {
          return new Data_Tuple.Tuple(stackCards(cards), stacksToCards);
      };
      return Data_Lens_Lens["lens'"](f)(dictStrong);
  };
  var _count = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "count";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var take = Util.decOver(Data_Ring.ringInt)(_count(Data_Profunctor_Strong.strongFn));
  var _card = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "card";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var upgrade = Data_Lens_Setter.over(_card(Data_Profunctor_Strong.strongFn))(Domination_Data_Cards.upgrade);
  exports["_card"] = _card;
  exports["_count"] = _count;
  exports["take"] = take;
  exports["isEmpty"] = isEmpty;
  exports["assertNotEmpty"] = assertNotEmpty;
  exports["new"] = $$new;
  exports["_stacksToCardsIso"] = _stacksToCardsIso;
  exports["stacksToCards"] = stacksToCards;
  exports["sortByStacks"] = sortByStacks;
  exports["_stacksFromCards"] = _stacksFromCards;
  exports["stackCards"] = stackCards;
  exports["upgrade"] = upgrade;
  exports["positivePoints"] = positivePoints;
  exports["negativePoints"] = negativePoints;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Bonus"] = $PS["Domination.Data.Wire.Bonus"] || {};
  var exports = $PS["Domination.Data.Wire.Bonus"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Util = $PS["Util"];                
  var WireCash = (function () {
      function WireCash(value0) {
          this.value0 = value0;
      };
      WireCash.create = function (value0) {
          return new WireCash(value0);
      };
      return WireCash;
  })();
  var genericWireBonus = new Data_Generic_Rep.Generic(function (x) {
      return x.value0;
  }, function (x) {
      return new WireCash(x);
  });
  var encodeArrayBuffeWireBonus = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireBonus)(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))));
  var dynamicByteLengthWireBonus = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericWireBonus)(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))));
  var decodeArrayBuffeWireBonus = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireBonus)(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))));
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          return WireCash.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
      };
      var from = function (v) {
          return Domination_Data_Bonus.Cash.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireBonus"] = dynamicByteLengthWireBonus;
  exports["encodeArrayBuffeWireBonus"] = encodeArrayBuffeWireBonus;
  exports["decodeArrayBuffeWireBonus"] = decodeArrayBuffeWireBonus;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Card"] = $PS["Domination.Data.Wire.Card"] || {};
  var exports = $PS["Domination.Data.Wire.Card"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Cards = $PS["Domination.Data.Cards"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];                
  var _toWire = function (dictProfunctor) {
      var to = function (card) {
          return Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(Data_Maybe.fromMaybe(-1 | 0)(Data_Array.findIndex(function (v) {
              return Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                  return "victoryPoints";
              }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                  return "types";
              }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                  return "treasure";
              }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                  return "special";
              }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                  return "target";
              }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                  return "description";
              }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                  return "command";
              }))(Domination_Data_Card.eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                  return "reaction";
              }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                  return "name";
              }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                  return "cost";
              }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                  return "cards";
              }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                  return "buys";
              }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                  return "actions";
              }))(Domination_Data_Actions.eqActions)))(v)(card);
          })(Domination_Data_Cards.cardMap)));
      };
      var from = (function () {
          var $3 = Data_Maybe.fromMaybe(Domination_Data_Card.card);
          var $4 = Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor));
          return function ($5) {
              return $3((function (v) {
                  return Data_Array.index(Domination_Data_Cards.cardMap)(v);
              })($4($5)));
          };
      })();
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Constraint"] = $PS["Domination.Data.Wire.Constraint"] || {};
  var exports = $PS["Domination.Data.Wire.Constraint"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Util = $PS["Util"];                
  var WireUpTo = (function () {
      function WireUpTo(value0) {
          this.value0 = value0;
      };
      WireUpTo.create = function (value0) {
          return new WireUpTo(value0);
      };
      return WireUpTo;
  })();
  var WireExactly = (function () {
      function WireExactly(value0) {
          this.value0 = value0;
      };
      WireExactly.create = function (value0) {
          return new WireExactly(value0);
      };
      return WireExactly;
  })();
  var WireDownTo = (function () {
      function WireDownTo(value0) {
          this.value0 = value0;
      };
      WireDownTo.create = function (value0) {
          return new WireDownTo(value0);
      };
      return WireDownTo;
  })();
  var WireUnlimited = (function () {
      function WireUnlimited() {

      };
      WireUnlimited.value = new WireUnlimited();
      return WireUnlimited;
  })();
  var genericWireConstraint = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireUpTo) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof WireExactly) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof WireDownTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof WireUnlimited) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Constraint (line 50, column 1 - line 50, column 66): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireUpTo(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new WireExactly(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new WireDownTo(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
          return WireUnlimited.value;
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Constraint (line 50, column 1 - line 50, column 66): " + [ x.constructor.name ]);
  });                                                             
  var encodeArrayBuffeWireConstraint = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireConstraint)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))))));
  var dynamicByteLengthWireConstraint = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericWireConstraint)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))));
  var decodeArrayBuffeWireConstraint = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireConstraint)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))))));
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_Constraint.UpTo) {
              return WireUpTo.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_Constraint.Exactly) {
              return WireExactly.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_Constraint.DownTo) {
              return WireDownTo.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_Constraint.Unlimited) {
              return WireUnlimited.value;
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Constraint (line 39, column 8 - line 43, column 31): " + [ v.constructor.name ]);
      };
      var from = function (v) {
          if (v instanceof WireUpTo) {
              return Domination_Data_Constraint.UpTo.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireExactly) {
              return Domination_Data_Constraint.Exactly.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireDownTo) {
              return Domination_Data_Constraint.DownTo.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireUnlimited) {
              return Domination_Data_Constraint.Unlimited.value;
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Constraint (line 44, column 10 - line 48, column 31): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireConstraint"] = dynamicByteLengthWireConstraint;
  exports["encodeArrayBuffeWireConstraint"] = encodeArrayBuffeWireConstraint;
  exports["decodeArrayBuffeWireConstraint"] = decodeArrayBuffeWireConstraint;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Filter"] = $PS["Domination.Data.Wire.Filter"] || {};
  var exports = $PS["Domination.Data.Wire.Filter"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Util = $PS["Util"];                
  var WireHasName = (function () {
      function WireHasName(value0) {
          this.value0 = value0;
      };
      WireHasName.create = function (value0) {
          return new WireHasName(value0);
      };
      return WireHasName;
  })();
  var WireHasType = (function () {
      function WireHasType(value0) {
          this.value0 = value0;
      };
      WireHasType.create = function (value0) {
          return new WireHasType(value0);
      };
      return WireHasType;
  })();
  var WireCostUpTo = (function () {
      function WireCostUpTo(value0) {
          this.value0 = value0;
      };
      WireCostUpTo.create = function (value0) {
          return new WireCostUpTo(value0);
      };
      return WireCostUpTo;
  })();
  var WireAny = (function () {
      function WireAny() {

      };
      WireAny.value = new WireAny();
      return WireAny;
  })();
  var WireAnd = (function () {
      function WireAnd(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      WireAnd.create = function (value0) {
          return function (value1) {
              return new WireAnd(value0, value1);
          };
      };
      return WireAnd;
  })();
  var genericWireFilter = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireHasName) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof WireHasType) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof WireCostUpTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof WireAny) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
      };
      if (x instanceof WireAnd) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1)))));
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Filter (line 52, column 1 - line 52, column 58): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireHasName(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new WireHasType(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new WireCostUpTo(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return WireAny.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
          return new WireAnd(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Filter (line 52, column 1 - line 52, column 58): " + [ x.constructor.name ]);
  });
  var encodeArrayBuffeWireFilter = new Data_ArrayBuffer_Class.EncodeArrayBuffer(function (a) {
      return Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireFilter)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_CardType.encodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(encodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(encodeArrayBuffeWireFilter))))))))(a);
  });
  var dynamicByteLengthWireFilter = new Data_ArrayBuffer_Class.DynamicByteLength(function (a) {
      return Data_ArrayBuffer_Class.genericByteLength(genericWireFilter)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))))))))(a);
  });
  var decodeArrayBuffeWireFilter = new Data_ArrayBuffer_Class.DecodeArrayBuffer(function (a) {
      return Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireFilter)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_CardType.decodeArrayBuffeCardType)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(decodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(decodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_CardType.dynamicByteLengthCardType)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireFilter))))))))(a);
  });
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_Filter.HasName) {
              return new WireHasName(v.value0);
          };
          if (v instanceof Domination_Data_Filter.HasType) {
              return new WireHasType(v.value0);
          };
          if (v instanceof Domination_Data_Filter.CostUpTo) {
              return WireCostUpTo.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_Filter.Any) {
              return WireAny.value;
          };
          if (v instanceof Domination_Data_Filter.And) {
              return new WireAnd(Data_Lens_Getter.viewOn(v.value0)(_toWire(Data_Lens_Internal_Forget.profunctorForget)), Data_Lens_Getter.viewOn(v.value1)(_toWire(Data_Lens_Internal_Forget.profunctorForget)));
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Filter (line 39, column 8 - line 44, column 57): " + [ v.constructor.name ]);
      };
      var from = function (v) {
          if (v instanceof WireHasName) {
              return new Domination_Data_Filter.HasName(v.value0);
          };
          if (v instanceof WireHasType) {
              return new Domination_Data_Filter.HasType(v.value0);
          };
          if (v instanceof WireCostUpTo) {
              return Domination_Data_Filter.CostUpTo.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireAny) {
              return Domination_Data_Filter.Any.value;
          };
          if (v instanceof WireAnd) {
              return new Domination_Data_Filter.And(Util.reviewOn(v.value0)(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)), Util.reviewOn(v.value1)(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Filter (line 45, column 10 - line 50, column 57): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireFilter"] = dynamicByteLengthWireFilter;
  exports["encodeArrayBuffeWireFilter"] = encodeArrayBuffeWireFilter;
  exports["decodeArrayBuffeWireFilter"] = decodeArrayBuffeWireFilter;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.StackValue"] = $PS["Domination.Data.Wire.StackValue"] || {};
  var exports = $PS["Domination.Data.Wire.StackValue"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Domination_Data_StackEvaluation = $PS["Domination.Data.StackEvaluation"];
  var Domination_Data_Wire_Filter = $PS["Domination.Data.Wire.Filter"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Util = $PS["Util"];                
  var WireStackArrayInt = (function () {
      function WireStackArrayInt(value0) {
          this.value0 = value0;
      };
      WireStackArrayInt.create = function (value0) {
          return new WireStackArrayInt(value0);
      };
      return WireStackArrayInt;
  })();
  var WireStackInt = (function () {
      function WireStackInt(value0) {
          this.value0 = value0;
      };
      WireStackInt.create = function (value0) {
          return new WireStackInt(value0);
      };
      return WireStackInt;
  })();
  var WireStackString = (function () {
      function WireStackString(value0) {
          this.value0 = value0;
      };
      WireStackString.create = function (value0) {
          return new WireStackString(value0);
      };
      return WireStackString;
  })();
  var WireStackFilter = (function () {
      function WireStackFilter(value0) {
          this.value0 = value0;
      };
      WireStackFilter.create = function (value0) {
          return new WireStackFilter(value0);
      };
      return WireStackFilter;
  })();
  var WireStackBool = (function () {
      function WireStackBool(value0) {
          this.value0 = value0;
      };
      WireStackBool.create = function (value0) {
          return new WireStackBool(value0);
      };
      return WireStackBool;
  })();
  var genericWireStackValue = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireStackArrayInt) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof WireStackInt) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof WireStackString) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof WireStackFilter) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof WireStackBool) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.StackValue (line 53, column 1 - line 53, column 66): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireStackArrayInt(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new WireStackInt(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new WireStackString(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new WireStackFilter(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
          return new WireStackBool(x.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.StackValue (line 53, column 1 - line 53, column 66): " + [ x.constructor.name ]);
  });
  var encodeArrayBuffeWireStackValue = new Data_ArrayBuffer_Class.EncodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireStackValue)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Filter.encodeArrayBuffeWireFilter)))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean)))))))(x);
  });
  var dynamicByteLengthWireStackValue = new Data_ArrayBuffer_Class.DynamicByteLength(function (x) {
      return Data_ArrayBuffer_Class.genericByteLength(genericWireStackValue)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))(x);
  });
  var decodeArrayBuffeWireStackValue = new Data_ArrayBuffer_Class.DecodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireStackValue)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Filter.decodeArrayBuffeWireFilter)))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))(x);
  });
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_StackEvaluation.StackArrayInt) {
              return new WireStackArrayInt(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackInt) {
              return new WireStackInt(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackString) {
              return new WireStackString(v.value0);
          };
          if (v instanceof Domination_Data_StackEvaluation.StackFilter) {
              return WireStackFilter.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackBool) {
              return new WireStackBool(v.value0);
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.StackValue (line 40, column 8 - line 45, column 35): " + [ v.constructor.name ]);
      };
      var from = function (v) {
          if (v instanceof WireStackArrayInt) {
              return new Domination_Data_StackEvaluation.StackArrayInt(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value0));
          };
          if (v instanceof WireStackInt) {
              return new Domination_Data_StackEvaluation.StackInt(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0));
          };
          if (v instanceof WireStackString) {
              return new Domination_Data_StackEvaluation.StackString(v.value0);
          };
          if (v instanceof WireStackFilter) {
              return Domination_Data_StackEvaluation.StackFilter.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireStackBool) {
              return new Domination_Data_StackEvaluation.StackBool(v.value0);
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.StackValue (line 46, column 10 - line 51, column 35): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireStackValue"] = dynamicByteLengthWireStackValue;
  exports["encodeArrayBuffeWireStackValue"] = encodeArrayBuffeWireStackValue;
  exports["decodeArrayBuffeWireStackValue"] = decodeArrayBuffeWireStackValue;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.StackExpression"] = $PS["Domination.Data.Wire.StackExpression"] || {};
  var exports = $PS["Domination.Data.Wire.StackExpression"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_StackEvaluation = $PS["Domination.Data.StackEvaluation"];
  var Domination_Data_Var = $PS["Domination.Data.Var"];
  var Domination_Data_Wire_Bonus = $PS["Domination.Data.Wire.Bonus"];
  var Domination_Data_Wire_Constraint = $PS["Domination.Data.Wire.Constraint"];
  var Domination_Data_Wire_Filter = $PS["Domination.Data.Wire.Filter"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Domination_Data_Wire_StackValue = $PS["Domination.Data.Wire.StackValue"];
  var Util = $PS["Util"];                
  var WireStackChooseCards = (function () {
      function WireStackChooseCards(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      WireStackChooseCards.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new WireStackChooseCards(value0, value1, value2, value3);
                  };
              };
          };
      };
      return WireStackChooseCards;
  })();
  var WireStackDuplicate = (function () {
      function WireStackDuplicate() {

      };
      WireStackDuplicate.value = new WireStackDuplicate();
      return WireStackDuplicate;
  })();
  var WireStackDiscard = (function () {
      function WireStackDiscard() {

      };
      WireStackDiscard.value = new WireStackDiscard();
      return WireStackDiscard;
  })();
  var WireStackLength = (function () {
      function WireStackLength() {

      };
      WireStackLength.value = new WireStackLength();
      return WireStackLength;
  })();
  var WireStackAddN = (function () {
      function WireStackAddN(value0) {
          this.value0 = value0;
      };
      WireStackAddN.create = function (value0) {
          return new WireStackAddN(value0);
      };
      return WireStackAddN;
  })();
  var WireStackDraw = (function () {
      function WireStackDraw() {

      };
      WireStackDraw.value = new WireStackDraw();
      return WireStackDraw;
  })();
  var WireStackTrash = (function () {
      function WireStackTrash() {

      };
      WireStackTrash.value = new WireStackTrash();
      return WireStackTrash;
  })();
  var WireStackNth = (function () {
      function WireStackNth(value0) {
          this.value0 = value0;
      };
      WireStackNth.create = function (value0) {
          return new WireStackNth(value0);
      };
      return WireStackNth;
  })();
  var WireStackCostOf = (function () {
      function WireStackCostOf() {

      };
      WireStackCostOf.value = new WireStackCostOf();
      return WireStackCostOf;
  })();
  var WireStackMakeFilterCostUpTo = (function () {
      function WireStackMakeFilterCostUpTo() {

      };
      WireStackMakeFilterCostUpTo.value = new WireStackMakeFilterCostUpTo();
      return WireStackMakeFilterCostUpTo;
  })();
  var WireStackMakeFilterAnd = (function () {
      function WireStackMakeFilterAnd() {

      };
      WireStackMakeFilterAnd.value = new WireStackMakeFilterAnd();
      return WireStackMakeFilterAnd;
  })();
  var WireStackBind = (function () {
      function WireStackBind(value0) {
          this.value0 = value0;
      };
      WireStackBind.create = function (value0) {
          return new WireStackBind(value0);
      };
      return WireStackBind;
  })();
  var WireStackGainTo = (function () {
      function WireStackGainTo(value0) {
          this.value0 = value0;
      };
      WireStackGainTo.create = function (value0) {
          return new WireStackGainTo(value0);
      };
      return WireStackGainTo;
  })();
  var WireStackChooseCardFromSupply = (function () {
      function WireStackChooseCardFromSupply(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      WireStackChooseCardFromSupply.create = function (value0) {
          return function (value1) {
              return new WireStackChooseCardFromSupply(value0, value1);
          };
      };
      return WireStackChooseCardFromSupply;
  })();
  var WireStackEquals = (function () {
      function WireStackEquals(value0) {
          this.value0 = value0;
      };
      WireStackEquals.create = function (value0) {
          return new WireStackEquals(value0);
      };
      return WireStackEquals;
  })();
  var WireStackIf = (function () {
      function WireStackIf(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireStackIf.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireStackIf(value0, value1, value2);
              };
          };
      };
      return WireStackIf;
  })();
  var WireStackPush = (function () {
      function WireStackPush(value0) {
          this.value0 = value0;
      };
      WireStackPush.create = function (value0) {
          return new WireStackPush(value0);
      };
      return WireStackPush;
  })();
  var WireStackGainBonus = (function () {
      function WireStackGainBonus(value0) {
          this.value0 = value0;
      };
      WireStackGainBonus.create = function (value0) {
          return new WireStackGainBonus(value0);
      };
      return WireStackGainBonus;
  })();
  var WireStackOption = (function () {
      function WireStackOption(value0) {
          this.value0 = value0;
      };
      WireStackOption.create = function (value0) {
          return new WireStackOption(value0);
      };
      return WireStackOption;
  })();
  var genericWireStackExpression = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireStackChooseCards) {
          return new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, x.value3))));
      };
      if (x instanceof WireStackDuplicate) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
      };
      if (x instanceof WireStackDiscard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
      };
      if (x instanceof WireStackLength) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
      };
      if (x instanceof WireStackAddN) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof WireStackDraw) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
      };
      if (x instanceof WireStackTrash) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
      };
      if (x instanceof WireStackNth) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
      };
      if (x instanceof WireStackCostOf) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
      };
      if (x instanceof WireStackMakeFilterCostUpTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
      };
      if (x instanceof WireStackMakeFilterAnd) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
      };
      if (x instanceof WireStackBind) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))));
      };
      if (x instanceof WireStackGainTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))));
      };
      if (x instanceof WireStackChooseCardFromSupply) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))))))))))))));
      };
      if (x instanceof WireStackEquals) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))));
      };
      if (x instanceof WireStackIf) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2))))))))))))))))));
      };
      if (x instanceof WireStackPush) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))))));
      };
      if (x instanceof WireStackGainBonus) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))))));
      };
      if (x instanceof WireStackOption) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))))))))))))))));
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.StackExpression (line 138, column 1 - line 139, column 35): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireStackChooseCards(x.value0.value0, x.value0.value1.value0, x.value0.value1.value1.value0, x.value0.value1.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return WireStackDuplicate.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return WireStackDiscard.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return WireStackLength.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new WireStackAddN(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return WireStackDraw.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
          return WireStackTrash.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
          return new WireStackNth(x.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
          return WireStackCostOf.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
          return WireStackMakeFilterCostUpTo.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
          return WireStackMakeFilterAnd.value;
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
          return new WireStackBind(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
          return new WireStackGainTo(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
          return new WireStackChooseCardFromSupply(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
          return new WireStackEquals(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
          return new WireStackIf(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
          return new WireStackPush(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
          return new WireStackGainBonus(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))))))))) {
          return new WireStackOption(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.StackExpression (line 138, column 1 - line 139, column 35): " + [ x.constructor.name ]);
  });
  var encodeArrayBuffeWireStackExpression = new Data_ArrayBuffer_Class.EncodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireStackExpression)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Domination_Data_Wire_Filter.encodeArrayBuffeWireFilter)))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Domination_Data_Pile.encodeArrayBuffePile)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Domination_Data_Wire_Constraint.encodeArrayBuffeWireConstraint)))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Pile.encodeArrayBuffePile)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Data_ArrayBuffer_Class.encodeArrayBufferString)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Domination_Data_Wire_Filter.encodeArrayBuffeWireFilter)))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_StackValue.encodeArrayBuffeWireStackValue)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireStackExpression)))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireStackExpression)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireStackExpression))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_StackValue.encodeArrayBuffeWireStackValue)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Bonus.encodeArrayBuffeWireBonus)))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Var.encodeArrayBuffeVar(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))))))))))))))))))))))(x);
  });
  var dynamicByteLengthWireStackExpression = new Data_ArrayBuffer_Class.DynamicByteLength(function (x) {
      return Data_ArrayBuffer_Class.genericByteLength(genericWireStackExpression)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))))))))))))(x);
  });
  var decodeArrayBuffeWireStackExpression = new Data_ArrayBuffer_Class.DecodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireStackExpression)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Domination_Data_Wire_Filter.decodeArrayBuffeWireFilter)(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Domination_Data_Pile.decodeArrayBuffePile)(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Domination_Data_Wire_Constraint.decodeArrayBuffeWireConstraint)(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint)))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferNoArguments))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Pile.decodeArrayBuffePile)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Data_ArrayBuffer_Class.decodeArrayBufferString)(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Domination_Data_Wire_Filter.decodeArrayBuffeWireFilter)(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_StackValue.decodeArrayBuffeWireStackValue)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireStackExpression)(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireStackExpression)(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireStackExpression)(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_StackValue.decodeArrayBuffeWireStackValue)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Bonus.decodeArrayBuffeWireBonus)))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Var.decodeArrayBuffeVar(Data_ArrayBuffer_Class.decodeArrayBufferBoolean)(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthNoArguments))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireStackExpression))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Var.dynamicByteLengthVar(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))))))))))))))))))(x);
  });
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_StackEvaluation.StackChooseCards) {
              return new WireStackChooseCards(Data_Functor.map(Domination_Data_Var.functorVar)(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))))(v.value0.cards), Data_Functor.map(Domination_Data_Var.functorVar)(Data_Lens_Getter.view(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0.filter), v.value0.from, Data_Functor.map(Domination_Data_Var.functorVar)(Data_Lens_Getter.view(Domination_Data_Wire_Constraint["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0.n));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackDuplicate) {
              return WireStackDuplicate.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackDiscard) {
              return WireStackDiscard.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackLength) {
              return WireStackLength.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackAddN) {
              return WireStackAddN.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackDraw) {
              return WireStackDraw.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackTrash) {
              return WireStackTrash.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackNth) {
              return WireStackNth.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackCostOf) {
              return WireStackCostOf.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackMakeFilterCostUpTo) {
              return WireStackMakeFilterCostUpTo.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackMakeFilterAnd) {
              return WireStackMakeFilterAnd.value;
          };
          if (v instanceof Domination_Data_StackEvaluation.StackBind) {
              return new WireStackBind(v.value0);
          };
          if (v instanceof Domination_Data_StackEvaluation.StackGainTo) {
              return new WireStackGainTo(v.value0);
          };
          if (v instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply) {
              return new WireStackChooseCardFromSupply(v.value0.cardName, Data_Functor.map(Domination_Data_Var.functorVar)(Data_Lens_Getter.view(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0.filter));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackEquals) {
              return WireStackEquals.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_StackValue["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackIf) {
              return new WireStackIf(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(_toWire(Data_Lens_Internal_Forget.profunctorForget)))(v.value0.condition), Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(_toWire(Data_Lens_Internal_Forget.profunctorForget)))(v.value0.following), Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(_toWire(Data_Lens_Internal_Forget.profunctorForget)))(v.value0.otherwise));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackPush) {
              return WireStackPush.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_StackValue["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackGainBonus) {
              return WireStackGainBonus.create(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Bonus["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_StackEvaluation.StackOption) {
              return new WireStackOption(v.value0);
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.StackExpression (line 69, column 8 - line 100, column 43): " + [ v.constructor.name ]);
      };
      var fro = function (v) {
          if (v instanceof WireStackChooseCards) {
              return new Domination_Data_StackEvaluation.StackChooseCards({
                  cards: Data_Functor.map(Domination_Data_Var.functorVar)(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))))(v.value0),
                  filter: Data_Functor.map(Domination_Data_Var.functorVar)(Data_Lens_Prism.review(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  from: v.value2,
                  n: Data_Functor.map(Domination_Data_Var.functorVar)(Data_Lens_Prism.review(Domination_Data_Wire_Constraint["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value3)
              });
          };
          if (v instanceof WireStackDuplicate) {
              return Domination_Data_StackEvaluation.StackDuplicate.value;
          };
          if (v instanceof WireStackDiscard) {
              return Domination_Data_StackEvaluation.StackDiscard.value;
          };
          if (v instanceof WireStackLength) {
              return Domination_Data_StackEvaluation.StackLength.value;
          };
          if (v instanceof WireStackAddN) {
              return Domination_Data_StackEvaluation.StackAddN.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireStackDraw) {
              return Domination_Data_StackEvaluation.StackDraw.value;
          };
          if (v instanceof WireStackTrash) {
              return Domination_Data_StackEvaluation.StackTrash.value;
          };
          if (v instanceof WireStackNth) {
              return Domination_Data_StackEvaluation.StackNth.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireStackCostOf) {
              return Domination_Data_StackEvaluation.StackCostOf.value;
          };
          if (v instanceof WireStackMakeFilterCostUpTo) {
              return Domination_Data_StackEvaluation.StackMakeFilterCostUpTo.value;
          };
          if (v instanceof WireStackMakeFilterAnd) {
              return Domination_Data_StackEvaluation.StackMakeFilterAnd.value;
          };
          if (v instanceof WireStackBind) {
              return new Domination_Data_StackEvaluation.StackBind(v.value0);
          };
          if (v instanceof WireStackGainTo) {
              return new Domination_Data_StackEvaluation.StackGainTo(v.value0);
          };
          if (v instanceof WireStackChooseCardFromSupply) {
              return new Domination_Data_StackEvaluation.StackChooseCardFromSupply({
                  cardName: v.value0,
                  filter: Data_Functor.map(Domination_Data_Var.functorVar)(Data_Lens_Prism.review(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1)
              });
          };
          if (v instanceof WireStackEquals) {
              return Domination_Data_StackEvaluation.StackEquals.create(Util.reviewOn(v.value0)(Domination_Data_Wire_StackValue["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireStackIf) {
              return new Domination_Data_StackEvaluation.StackIf({
                  condition: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value0),
                  following: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  otherwise: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value2)
              });
          };
          if (v instanceof WireStackPush) {
              return Domination_Data_StackEvaluation.StackPush.create(Util.reviewOn(v.value0)(Domination_Data_Wire_StackValue["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireStackGainBonus) {
              return Domination_Data_StackEvaluation.StackGainBonus.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Bonus["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireStackOption) {
              return new Domination_Data_StackEvaluation.StackOption(v.value0);
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.StackExpression (line 102, column 9 - line 136, column 43): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(fro)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireStackExpression"] = dynamicByteLengthWireStackExpression;
  exports["encodeArrayBuffeWireStackExpression"] = encodeArrayBuffeWireStackExpression;
  exports["decodeArrayBuffeWireStackExpression"] = decodeArrayBuffeWireStackExpression;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Choice"] = $PS["Domination.Data.Wire.Choice"] || {};
  var exports = $PS["Domination.Data.Wire.Choice"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Prism_Maybe = $PS["Data.Lens.Prism.Maybe"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Condition = $PS["Domination.Data.Condition"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_SelectCards = $PS["Domination.Data.SelectCards"];
  var Domination_Data_Wire_Bonus = $PS["Domination.Data.Wire.Bonus"];
  var Domination_Data_Wire_Constraint = $PS["Domination.Data.Wire.Constraint"];
  var Domination_Data_Wire_Filter = $PS["Domination.Data.Wire.Filter"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Domination_Data_Wire_StackExpression = $PS["Domination.Data.Wire.StackExpression"];
  var Domination_Data_Wire_StackValue = $PS["Domination.Data.Wire.StackValue"];
  var Util = $PS["Util"];                
  var WireIf = (function () {
      function WireIf(value0, value1, value2, value3, value4) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
      };
      WireIf.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return new WireIf(value0, value1, value2, value3, value4);
                      };
                  };
              };
          };
      };
      return WireIf;
  })();
  var WireAnd = (function () {
      function WireAnd(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireAnd.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireAnd(value0, value1, value2);
              };
          };
      };
      return WireAnd;
  })();
  var WireOr = (function () {
      function WireOr(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireOr.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireOr(value0, value1, value2);
              };
          };
      };
      return WireOr;
  })();
  var WirePickN = (function () {
      function WirePickN(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      WirePickN.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new WirePickN(value0, value1, value2, value3);
                  };
              };
          };
      };
      return WirePickN;
  })();
  var WireOption = (function () {
      function WireOption(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireOption.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireOption(value0, value1, value2);
              };
          };
      };
      return WireOption;
  })();
  var WireMoveFromTo = (function () {
      function WireMoveFromTo(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      WireMoveFromTo.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new WireMoveFromTo(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return WireMoveFromTo;
  })();
  var WireGainCards = (function () {
      function WireGainCards(value0, value1, value2, value3, value4) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
      };
      WireGainCards.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return new WireGainCards(value0, value1, value2, value3, value4);
                      };
                  };
              };
          };
      };
      return WireGainCards;
  })();
  var WireGainCard = (function () {
      function WireGainCard(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      WireGainCard.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new WireGainCard(value0, value1, value2, value3);
                  };
              };
          };
      };
      return WireGainCard;
  })();
  var WireGainActions = (function () {
      function WireGainActions(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireGainActions.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireGainActions(value0, value1, value2);
              };
          };
      };
      return WireGainActions;
  })();
  var WireGainBuys = (function () {
      function WireGainBuys(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireGainBuys.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireGainBuys(value0, value1, value2);
              };
          };
      };
      return WireGainBuys;
  })();
  var WireDiscard = (function () {
      function WireDiscard(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireDiscard.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireDiscard(value0, value1, value2);
              };
          };
      };
      return WireDiscard;
  })();
  var WireDraw = (function () {
      function WireDraw(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireDraw.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireDraw(value0, value1, value2);
              };
          };
      };
      return WireDraw;
  })();
  var WireGainBonus = (function () {
      function WireGainBonus(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireGainBonus.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireGainBonus(value0, value1, value2);
              };
          };
      };
      return WireGainBonus;
  })();
  var WireStackChoice = (function () {
      function WireStackChoice(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      WireStackChoice.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new WireStackChoice(value0, value1, value2, value3);
                  };
              };
          };
      };
      return WireStackChoice;
  })();
  var genericWireChoice = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireIf) {
          return new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, x.value4)))));
      };
      if (x instanceof WireAnd) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2))));
      };
      if (x instanceof WireOr) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)))));
      };
      if (x instanceof WirePickN) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, x.value3)))))));
      };
      if (x instanceof WireOption) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)))))));
      };
      if (x instanceof WireMoveFromTo) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, x.value5)))))))))));
      };
      if (x instanceof WireGainCards) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, x.value4)))))))))));
      };
      if (x instanceof WireGainCard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, x.value3)))))))))));
      };
      if (x instanceof WireGainActions) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)))))))))));
      };
      if (x instanceof WireGainBuys) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2))))))))))));
      };
      if (x instanceof WireDiscard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)))))))))))));
      };
      if (x instanceof WireDraw) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2))))))))))))));
      };
      if (x instanceof WireGainBonus) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)))))))))))))));
      };
      if (x instanceof WireStackChoice) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, x.value3))))))))))))))));
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Choice (line 226, column 1 - line 226, column 58): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireIf(x.value0.value0, x.value0.value1.value0, x.value0.value1.value1.value0, x.value0.value1.value1.value1.value0, x.value0.value1.value1.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new WireAnd(x.value0.value0.value0, x.value0.value0.value1.value0, x.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new WireOr(x.value0.value0.value0.value0, x.value0.value0.value0.value1.value0, x.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new WirePickN(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value1.value1.value0, x.value0.value0.value0.value0.value1.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new WireOption(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return new WireMoveFromTo(x.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value1.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value1.value1.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value1.value1.value1.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
          return new WireGainCards(x.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value1.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value1.value1.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
          return new WireGainCard(x.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
          return new WireGainActions(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
          return new WireGainBuys(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
          return new WireDiscard(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
          return new WireDraw(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
          return new WireGainBonus(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))) {
          return new WireStackChoice(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1.value1.value1);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Choice (line 226, column 1 - line 226, column 58): " + [ x.constructor.name ]);
  });
  var encodeArrayBuffeWireChoice = new Data_ArrayBuffer_Class.EncodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireChoice)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(encodeArrayBuffeWireChoice))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Condition.encodeArrayBufferCondition))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(encodeArrayBuffeWireChoice)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireChoice)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireChoice)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(encodeArrayBuffeWireChoice))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireChoice)))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferArray(encodeArrayBuffeWireChoice))))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(encodeArrayBuffeWireChoice))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Pile.encodeArrayBuffePile))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Filter.encodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Constraint.encodeArrayBuffeWireConstraint))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Pile.encodeArrayBuffePile))))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Pile.encodeArrayBuffePile))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Pile.encodeArrayBuffePile))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Filter.encodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferString)))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Actions.encodeArrayBufferActions))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Buys.encodeArrayBufferBuys))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_SelectCards.encodeArrayBuffeSelectCards)))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Bonus.encodeArrayBuffeWireBonus))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferUnit))))))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_StackExpression.encodeArrayBuffeWireStackExpression)))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_StackValue.encodeArrayBuffeWireStackValue)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString)))))))))))))))))))(x);
  });
  var dynamicByteLengthWireChoice = new Data_ArrayBuffer_Class.DynamicByteLength(function (x) {
      return Data_ArrayBuffer_Class.genericByteLength(genericWireChoice)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Condition.dynamicByteLengthCondition))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))))))))))))(x);
  });
  var decodeArrayBuffeWireChoice = new Data_ArrayBuffer_Class.DecodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireChoice)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(decodeArrayBuffeWireChoice))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Condition.decodeArrayBufferCondition))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(decodeArrayBuffeWireChoice)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Condition.dynamicByteLengthCondition))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Condition.dynamicByteLengthCondition))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Condition.dynamicByteLengthCondition))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireChoice)(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireChoice)(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(decodeArrayBuffeWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireChoice)(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferArray(decodeArrayBuffeWireChoice)(dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(decodeArrayBuffeWireChoice))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferBoolean)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Pile.decodeArrayBuffePile))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Filter.decodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Constraint.decodeArrayBuffeWireConstraint))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Pile.decodeArrayBuffePile))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Pile.decodeArrayBuffePile))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Pile.decodeArrayBuffePile))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Filter.decodeArrayBuffeWireFilter))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Actions.decodeArrayBufferActions))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Buys.decodeArrayBufferBuys))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_SelectCards.decodeArrayBuffeSelectCards))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Bonus.decodeArrayBuffeWireBonus))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_StackExpression.decodeArrayBuffeWireStackExpression)(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_StackValue.decodeArrayBuffeWireStackValue)(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))))))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Condition.dynamicByteLengthCondition))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(dynamicByteLengthWireChoice))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(dynamicByteLengthWireChoice))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Constraint.dynamicByteLengthWireConstraint))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Pile.dynamicByteLengthPile))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Filter.dynamicByteLengthWireFilter))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Actions.dynamicByteLengthActions))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Buys.dynamicByteLengthBuys))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_SelectCards.dynamicByteLengthSelectCards)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthUnit))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackExpression.dynamicByteLengthWireStackExpression)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_StackValue.dynamicByteLengthWireStackValue)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString)))))))))))))))))))(x);
  });
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_Choice.If) {
              return new WireIf(v.value0.attack, Data_Lens_Getter.viewOn(v.value0.choice)(_toWire(Data_Lens_Internal_Forget.profunctorForget)), v.value0.condition, Data_Lens_Fold.previewOn(v.value0.otherwise)((function () {
                  var $626 = Data_Lens_Prism_Maybe["_Just"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
                  var $627 = _toWire(Data_Lens_Internal_Forget.profunctorForget);
                  return function ($628) {
                      return $626($627($628));
                  };
              })()), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.And) {
              return new WireAnd(v.value0.attack, Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                  return Data_Lens_Getter.viewOn(v1)(_toWire(Data_Lens_Internal_Forget.profunctorForget));
              })(v.value0.choices), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.Or) {
              return new WireOr(v.value0.attack, Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                  return Data_Lens_Getter.viewOn(v1)(_toWire(Data_Lens_Internal_Forget.profunctorForget));
              })(v.value0.choices), Data_Lens_Fold.previewOn(v.value0.resolution)((function () {
                  var $629 = Data_Lens_Prism_Maybe["_Just"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
                  var $630 = _toWire(Data_Lens_Internal_Forget.profunctorForget);
                  return function ($631) {
                      return $629($630($631));
                  };
              })()));
          };
          if (v instanceof Domination_Data_Choice.PickN) {
              return new WirePickN(v.value0.attack, Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                  return Data_Lens_Getter.viewOn(v1)(_toWire(Data_Lens_Internal_Forget.profunctorForget));
              })(v.value0.choices), Data_Lens_Getter.viewOn(v.value0.n)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                  return Data_Lens_Getter.viewOn(v1)(_toWire(Data_Lens_Internal_Forget.profunctorForget));
              }))(v.value0.resolution));
          };
          if (v instanceof Domination_Data_Choice.Option) {
              return new WireOption(v.value0.attack, Data_Lens_Getter.viewOn(v.value0.choice)(_toWire(Data_Lens_Internal_Forget.profunctorForget)), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.MoveFromTo) {
              return new WireMoveFromTo(v.value0.attack, v.value0.destination, Data_Lens_Getter.viewOn(v.value0.filter)(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), Data_Lens_Getter.viewOn(v.value0.n)(Domination_Data_Wire_Constraint["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))))(v.value0.resolution), v.value0.source);
          };
          if (v instanceof Domination_Data_Choice.GainCards) {
              return new WireGainCards(v.value0.attack, v.value0.cardName, v.value0.destination, Data_Lens_Getter.viewOn(v.value0.n)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.GainCard) {
              return new WireGainCard(v.value0.attack, v.value0.destination, Data_Lens_Getter.viewOn(v.value0.filter)(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.GainActions) {
              return new WireGainActions(v.value0.attack, v.value0.n, v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.GainBuys) {
              return new WireGainBuys(v.value0.attack, v.value0.n, v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.Discard) {
              return new WireDiscard(v.value0.attack, v.value0.resolution, v.value0.selection);
          };
          if (v instanceof Domination_Data_Choice.Draw) {
              return new WireDraw(v.value0.attack, Data_Lens_Getter.viewOn(v.value0.n)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.GainBonus) {
              return new WireGainBonus(v.value0.attack, Data_Lens_Getter.viewOn(v.value0.bonus)(Domination_Data_Wire_Bonus["_toWire"](Data_Lens_Internal_Forget.profunctorForget)), v.value0.resolution);
          };
          if (v instanceof Domination_Data_Choice.StackChoice) {
              return new WireStackChoice(v.value0.attack, Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_StackExpression["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0.expression), Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_StackValue["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0.stack), v.value0.description);
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Choice (line 76, column 9 - line 145, column 20): " + [ v.constructor.name ]);
      };
      var from = function (v) {
          if (v instanceof WireIf) {
              return new Domination_Data_Choice.If({
                  attack: v.value0,
                  choice: Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1),
                  condition: v.value2,
                  otherwise: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value3),
                  resolution: v.value4
              });
          };
          if (v instanceof WireAnd) {
              return new Domination_Data_Choice.And({
                  attack: v.value0,
                  choices: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  resolution: v.value2
              });
          };
          if (v instanceof WireOr) {
              return new Domination_Data_Choice.Or({
                  attack: v.value0,
                  choices: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  resolution: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value2)
              });
          };
          if (v instanceof WirePickN) {
              return new Domination_Data_Choice.PickN({
                  attack: v.value0,
                  choices: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  n: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value2),
                  resolution: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor))))(v.value3)
              });
          };
          if (v instanceof WireOption) {
              return new Domination_Data_Choice.Option({
                  attack: v.value0,
                  choice: Data_Lens_Prism.review(_toWire(Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1),
                  resolution: v.value2
              });
          };
          if (v instanceof WireMoveFromTo) {
              return new Domination_Data_Choice.MoveFromTo({
                  attack: v.value0,
                  destination: v.value1,
                  filter: Util.reviewOn(v.value2)(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)),
                  n: Util.reviewOn(v.value3)(Domination_Data_Wire_Constraint["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)),
                  resolution: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))))(v.value4),
                  source: v.value5
              });
          };
          if (v instanceof WireGainCards) {
              return new Domination_Data_Choice.GainCards({
                  attack: v.value0,
                  cardName: v.value1,
                  destination: v.value2,
                  n: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value3),
                  resolution: v.value4
              });
          };
          if (v instanceof WireGainCard) {
              return new Domination_Data_Choice.GainCard({
                  attack: v.value0,
                  destination: v.value1,
                  filter: Util.reviewOn(v.value2)(Domination_Data_Wire_Filter["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)),
                  resolution: v.value3
              });
          };
          if (v instanceof WireGainActions) {
              return new Domination_Data_Choice.GainActions({
                  attack: v.value0,
                  n: v.value1,
                  resolution: v.value2
              });
          };
          if (v instanceof WireGainBuys) {
              return new Domination_Data_Choice.GainBuys({
                  attack: v.value0,
                  n: v.value1,
                  resolution: v.value2
              });
          };
          if (v instanceof WireDiscard) {
              return new Domination_Data_Choice.Discard({
                  attack: v.value0,
                  resolution: v.value1,
                  selection: v.value2
              });
          };
          if (v instanceof WireDraw) {
              return new Domination_Data_Choice.Draw({
                  attack: v.value0,
                  n: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1),
                  resolution: v.value2
              });
          };
          if (v instanceof WireGainBonus) {
              return new Domination_Data_Choice.GainBonus({
                  attack: v.value0,
                  bonus: Util.reviewOn(v.value1)(Domination_Data_Wire_Bonus["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)),
                  resolution: v.value2
              });
          };
          if (v instanceof WireStackChoice) {
              return new Domination_Data_Choice.StackChoice({
                  attack: v.value0,
                  expression: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_StackExpression["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  stack: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_StackValue["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value2),
                  description: v.value3
              });
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Choice (line 147, column 10 - line 224, column 10): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireChoice"] = dynamicByteLengthWireChoice;
  exports["encodeArrayBuffeWireChoice"] = encodeArrayBuffeWireChoice;
  exports["decodeArrayBuffeWireChoice"] = decodeArrayBuffeWireChoice;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Player"] = $PS["Domination.Data.Player"] || {};
  var exports = $PS["Domination.Data.Player"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Index = $PS["Data.Lens.Index"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Prism_Maybe = $PS["Data.Lens.Prism.Maybe"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Lens_Traversal = $PS["Data.Lens.Traversal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Star = $PS["Data.Profunctor.Star"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Ring = $PS["Data.Ring"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Capability_Random = $PS["Domination.Capability.Random"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Cards = $PS["Domination.Data.Cards"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Data_Wire_Bonus = $PS["Domination.Data.Wire.Bonus"];
  var Domination_Data_Wire_Card = $PS["Domination.Data.Wire.Card"];
  var Domination_Data_Wire_Choice = $PS["Domination.Data.Wire.Choice"];
  var Rule = $PS["Rule"];
  var Util = $PS["Util"];                
  var reactionInHand = (function () {
      var $118 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
          return v.reaction;
      });
      return function ($119) {
          return Data_Array.head(Data_Array.catMaybes($118((function (v) {
              return v.hand;
          })($119))));
      };
  })();
  var newPlayer = {
      deck: [  ],
      hand: [  ],
      discard: Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Array.replicate(7)(Domination_Data_Card["_card"](Domination_Data_Cards.copper)))(Data_Array.replicate(3)(Domination_Data_Card["_card"](Domination_Data_Cards.estate))),
      toDiscard: [  ],
      atPlay: [  ],
      buying: [  ],
      actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
      buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
      choices: [  ],
      reaction: Data_Maybe.Nothing.value,
      bonuses: [  ]
  };
  var hasChoices = (function () {
      var $120 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_Foldable["null"](Data_Foldable.foldableArray));
      return function ($121) {
          return $120((function (v) {
              return v.choices;
          })($121));
      };
  })();
  var hasActions = function ($122) {
      return (function (v) {
          return Data_Ord.greaterThan(Domination_Data_Actions.ordActions)(v)(Data_Semiring.zero(Domination_Data_Actions.ringActions));
      })((function (v) {
          return v.actions;
      })($122));
  };
  var hasActionCardsInHand = (function () {
      var $123 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_Foldable["null"](Data_Foldable.foldableArray));
      var $124 = Data_Array.filter(Domination_Data_Card.isAction);
      return function ($125) {
          return $123($124((function (v) {
              return v.hand;
          })($125)));
      };
  })();
  var gainReaction = function (reaction) {
      return function (v) {
          return {
              actions: v.actions,
              atPlay: v.atPlay,
              bonuses: v.bonuses,
              buying: v.buying,
              buys: v.buys,
              choices: v.choices,
              deck: v.deck,
              discard: v.discard,
              hand: v.hand,
              reaction: new Data_Maybe.Just(reaction),
              toDiscard: v.toDiscard
          };
      };
  };
  var dropReaction = function (v) {
      return {
          actions: v.actions,
          atPlay: v.atPlay,
          bonuses: v.bonuses,
          buying: v.buying,
          buys: v.buys,
          choices: v.choices,
          deck: v.deck,
          discard: v.discard,
          hand: v.hand,
          reaction: Data_Maybe.Nothing.value,
          toDiscard: v.toDiscard
      };
  };
  var dropCard = function (dictMonadError) {
      return function (i) {
          var $128 = Util.fromJust(dictMonadError)("cannot drop card!");
          var $129 = Data_Array.deleteAt(i);
          return function ($130) {
              return $128($129((function (v) {
                  return v.hand;
              })($130)));
          };
      };
  };
  var cash = function (player) {
      return ((Domination_Data_Card.value(player.atPlay) + Domination_Data_Bonus.cashValue(player.bonuses) | 0) + Domination_Data_Card.value(Data_Array.filter(Domination_Data_Card.isTreasure)(player.hand)) | 0) - Domination_Data_Card.cost(player.buying) | 0;
  };
  var assertHasCash = function (dictMonadError) {
      return function (i) {
          return Util.assert(dictMonadError)(function ($132) {
              return (function (v) {
                  return v >= i;
              })(cash($132));
          })("not enough treasure!");
      };
  };
  var assertHasBuys = function (dictMonadError) {
      return Util.assert(dictMonadError)(function ($133) {
          return (function (v) {
              return Data_Ord.greaterThan(Domination_Data_Buys.ordBuys)(v)(Data_Semiring.zero(Domination_Data_Buys.ringBuys));
          })((function (v) {
              return v.buys;
          })($133));
      })("no buys!");
  };
  var assertHasActions = function (dictMonadError) {
      return Util.assert(dictMonadError)(function ($134) {
          return (function (v) {
              return Data_Ord.greaterThan(Domination_Data_Actions.ordActions)(v)(Data_Semiring.zero(Domination_Data_Actions.ringActions));
          })((function (v) {
              return v.actions;
          })($134));
      })("no actions!");
  };
  var allCards = function (player) {
      return Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.hand)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.deck)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.atPlay)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.discard)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.toDiscard)(player.buying)))));
  };   
  var positivePoints = (function () {
      var $138 = Data_Foldable.sum(Data_Foldable.foldableArray)(Domination_Data_Points.ringPoints);
      var $139 = Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Card.positivePoints);
      return function ($140) {
          return $138($139(allCards($140)));
      };
  })();
  var score = function (player) {
      return Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Semiring.add(Domination_Data_Points.ringPoints))(Data_Semiring.zero(Domination_Data_Points.ringPoints))(Data_Functor.map(Data_Functor.functorArray)(function (v) {
          return v.victoryPoints;
      })(allCards(player)));
  };
  var _toDiscard = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "toDiscard";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _reaction = function (dictWander) {
      var $141 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "reaction";
      }))()()(Data_Symbol.SProxy.value)(dictWander.Strong0());
      var $142 = Data_Lens_Prism_Maybe["_Just"](dictWander.Choice1());
      return function ($143) {
          return $141($142($143));
      };
  };
  var _hand = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "hand";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _discard = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "discard";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _deck = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "deck";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var drawIfPossible = function (p) {
      return Data_Maybe.fromMaybe(p)(Util.moveOne(function (dictStrong) {
          return _deck(dictStrong);
      })(function (dictStrong) {
          return _hand(dictStrong);
      })(p));
  };
  var drawCard = function (dictMonadError) {
      return function (dictRandom) {
          return function (player) {
              return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())((function () {
                  var $79 = Data_Foldable["null"](Data_Foldable.foldableArray)(player.deck);
                  if ($79) {
                      return Domination_Capability_Random.shuffle(dictRandom)(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                          return "victoryPoints";
                      }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                          return "types";
                      }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                          return "treasure";
                      }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                          return "special";
                      }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                          return "target";
                      }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                          return "description";
                      }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                          return "command";
                      }))(Domination_Data_Card.eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                          return "reaction";
                      }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                          return "name";
                      }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                          return "cost";
                      }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                          return "cards";
                      }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                          return "buys";
                      }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                          return "actions";
                      }))(Domination_Data_Actions.eqActions)))(player.discard);
                  };
                  return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(player.deck);
              })())(function (deck) {
                  var discarded = (function () {
                      var $80 = Data_Foldable["null"](Data_Foldable.foldableArray)(player.deck);
                      if ($80) {
                          return [  ];
                      };
                      return player.discard;
                  })();
                  var player$prime = {
                      deck: deck,
                      discard: discarded,
                      actions: player.actions,
                      atPlay: player.atPlay,
                      bonuses: player.bonuses,
                      buying: player.buying,
                      buys: player.buys,
                      choices: player.choices,
                      hand: player.hand,
                      reaction: player.reaction,
                      toDiscard: player.toDiscard
                  };
                  var player$prime$prime = drawIfPossible(player$prime);
                  var player$prime$prime$prime = Data_Lens_Setter.over(_hand(Data_Profunctor_Strong.strongFn))(Domination_Data_Stack.sortByStacks)(player$prime$prime);
                  return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(player$prime$prime$prime);
              });
          };
      };
  };
  var drawCards = function (dictMonadError) {
      return function (dictRandom) {
          return function (n) {
              return function (p) {
                  var $81 = n > 0;
                  if ($81) {
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(drawCard(dictMonadError)(dictRandom)(p))(drawCards(dictMonadError)(dictRandom)(n - 1 | 0));
                  };
                  return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(p);
              };
          };
      };
  };
  var cleanup = function (dictMonadError) {
      return function (dictRandom) {
          return function (player) {
              return drawCards(dictMonadError)(dictRandom)(5)({
                  actions: Data_Semiring.one(Domination_Data_Actions.ringActions),
                  atPlay: [  ],
                  bonuses: [  ],
                  buying: [  ],
                  buys: Data_Semiring.one(Domination_Data_Buys.ringBuys),
                  choices: player.choices,
                  deck: player.deck,
                  discard: Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.discard)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.atPlay)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.hand)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(player.toDiscard)(player.buying)))),
                  hand: [  ],
                  reaction: player.reaction,
                  toDiscard: [  ]
              });
          };
      };
  };
  var _choices = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "choices";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var dropChoice = function (dictMonadError) {
      var $147 = Util.fromJust(dictMonadError)("failed to drop choice");
      var $148 = Data_Lens_Traversal.traverseOf(_choices(Data_Profunctor_Star.strongStar(Data_Maybe.functorMaybe)))(Data_Array.deleteAt(0));
      return function ($149) {
          return $147($148($149));
      };
  };
  var firstChoice = (function () {
      var $150 = Data_Lens_Fold.firstOf(Data_Lens_Traversal.traversed(Data_Traversable.traversableArray)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
      var $151 = Data_Lens_Getter.view(_choices(Data_Lens_Internal_Forget.strongForget));
      return function ($152) {
          return $150($151($152));
      };
  })();
  var gainChoice = function (choice) {
      return function (player) {
          var player$prime = Data_Lens_Setter.over(_choices(Data_Profunctor_Strong.strongFn))(function (v) {
              return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ choice ]);
          })(player);
          var $82 = Domination_Data_Choice.isAttack(choice);
          if ($82) {
              var v = reactionInHand(player);
              if (v instanceof Data_Maybe.Just) {
                  return gainReaction(v.value0)(player$prime);
              };
              if (v instanceof Data_Maybe.Nothing) {
                  return player$prime;
              };
              throw new Error("Failed pattern match at Domination.Data.Player (line 251, column 10 - line 253, column 25): " + [ v.constructor.name ]);
          };
          return player$prime;
      };
  };
  var gainChoices = (function () {
      var $153 = Data_Function.flip(Data_Foldable.foldr(Data_Foldable.foldableArray)(gainChoice));
      return function ($154) {
          return $153(Data_Array.reverse($154));
      };
  })();
  var _cardInHand = function (i) {
      return function (dictWander) {
          var $155 = _hand(dictWander.Strong0());
          var $156 = Data_Lens_Index.ix(Data_Lens_Index.indexArray)(i)(dictWander.Strong0())(dictWander.Choice1());
          return function ($157) {
              return $155($156($157));
          };
      };
  };
  var getCard = function (dictMonadError) {
      return function (i) {
          var $158 = Util.fromJust(dictMonadError)("cannot get card!");
          var $159 = Data_Lens_Fold.preview(_cardInHand(i)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
          return function ($160) {
              return $158($159($160));
          };
      };
  };
  var _buys = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "buys";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var gainBuys = function (n) {
      return Data_Lens_Setter.over(_buys(Data_Profunctor_Strong.strongFn))(function (v) {
          return Data_Semiring.add(Domination_Data_Buys.ringBuys)(v)(n);
      });
  };
  var _buying = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "buying";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var purchase = function (card) {
      var $161 = Util.prependOver(function (dictStrong) {
          return _buying(dictStrong);
      })(card);
      var $162 = Util.decOver(Domination_Data_Buys.semiringBuys)(_buys(Data_Profunctor_Strong.strongFn));
      return function ($163) {
          return $161($162($163));
      };
  };
  var _bonuses = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "bonuses";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var gainBonus = Util.prependOver(function (dictStrong) {
      return _bonuses(dictStrong);
  });
  var _atPlay = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "atPlay";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _toWire = function (dictProfunctor) {
      var toTuple = function (v) {
          return Data_Tuple.Tuple.create(v.actions)(Data_Tuple.Tuple.create(v.atPlay)(Data_Tuple.Tuple.create(v.bonuses)(Data_Tuple.Tuple.create(v.buying)(Data_Tuple.Tuple.create(v.buys)(Data_Tuple.Tuple.create(v.choices)(Data_Tuple.Tuple.create(v.deck)(Data_Tuple.Tuple.create(v.discard)(Data_Tuple.Tuple.create(v.hand)(new Data_Tuple.Tuple(v.reaction, v.toDiscard))))))))));
      };
      var to = (function () {
          var $164 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _buying(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $165 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _atPlay(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $166 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _toDiscard(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $167 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _discard(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $168 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _hand(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $169 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _deck(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $170 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _bonuses(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Bonus["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $171 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _choices(dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Choice["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          return function ($172) {
              return toTuple($164($165($166($167($168($169($170($171($172)))))))));
          };
      })();
      var fromTuple = function (v) {
          return {
              actions: v.value0,
              atPlay: v.value1.value0,
              bonuses: v.value1.value1.value0,
              buying: v.value1.value1.value1.value0,
              buys: v.value1.value1.value1.value1.value0,
              choices: v.value1.value1.value1.value1.value1.value0,
              deck: v.value1.value1.value1.value1.value1.value1.value0,
              discard: v.value1.value1.value1.value1.value1.value1.value1.value0,
              hand: v.value1.value1.value1.value1.value1.value1.value1.value1.value0,
              reaction: v.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0,
              toDiscard: v.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1
          };
      };
      var from = (function () {
          var $173 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _buying(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $174 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _atPlay(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $175 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _toDiscard(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $176 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _discard(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $177 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _hand(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $178 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _deck(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $179 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _bonuses(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Bonus["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $180 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return _choices(dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Choice["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          return function ($181) {
              return $173($174($175($176($177($178($179($180(fromTuple($181)))))))));
          };
      })();
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  var upgrade = (function () {
      var $182 = Data_Lens_Setter.over(_toDiscard(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      var $183 = Data_Lens_Setter.over(_hand(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      var $184 = Data_Lens_Setter.over(_discard(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      var $185 = Data_Lens_Setter.over(_deck(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      var $186 = Data_Lens_Setter.over(_buying(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      var $187 = Data_Lens_Setter.over(_atPlay(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      return function ($188) {
          return $182($183($184($185($186($187($188))))));
      };
  })();
  var _actions = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "actions";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var gainActions = function (n) {
      return Data_Lens_Setter.over(_actions(Data_Profunctor_Strong.strongFn))(function (v) {
          return Data_Semiring.add(Domination_Data_Actions.ringActions)(v)(n);
      });
  };
  var play = function (dictMonadError) {
      return function (dictRandom) {
          return function (cardIndex) {
              return function (player) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(getCard(dictMonadError)(cardIndex)(player))(function (playedCard) {
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(dropCard(dictMonadError)(cardIndex)(player))(function (hand$prime) {
                          return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(drawCards(dictMonadError)(dictRandom)(playedCard.cards)(Data_Lens_Setter.set(_hand(Data_Profunctor_Strong.strongFn))(hand$prime)(player)))(function (player$prime) {
                              return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Rule.check(dictMonadError)(Rule.enforceOn(playedCard)(Rule.simpleRule(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "actions";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "buys";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "cards";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "cost";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "name";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "reaction";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "special";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "treasure";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "types";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "victoryPoints";
                              }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "command";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "description";
                              }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                  return "target";
                              }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))(Domination_Data_Card.isAction)("must play action cards"))))(function () {
                                  return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())((function () {
                                      var $189 = Data_Lens_Setter.addOver(Domination_Data_Buys.ringBuys)(_buys(Data_Profunctor_Strong.strongFn))(playedCard.buys);
                                      var $190 = Data_Lens_Setter.addOver(Domination_Data_Actions.ringActions)(_actions(Data_Profunctor_Strong.strongFn))(Data_Ring.sub(Domination_Data_Actions.semiringActions)(playedCard.actions)(Data_Semiring.one(Domination_Data_Actions.ringActions)));
                                      return function ($191) {
                                          return $189($190($191));
                                      };
                                  })()(Util.prependOver(function (dictStrong) {
                                      return _atPlay(dictStrong);
                                  })(playedCard)(player$prime)));
                              });
                          });
                      });
                  });
              };
          };
      };
  };
  exports["_toWire"] = _toWire;
  exports["_deck"] = _deck;
  exports["_hand"] = _hand;
  exports["_discard"] = _discard;
  exports["_toDiscard"] = _toDiscard;
  exports["_atPlay"] = _atPlay;
  exports["_buying"] = _buying;
  exports["_reaction"] = _reaction;
  exports["_cardInHand"] = _cardInHand;
  exports["getCard"] = getCard;
  exports["hasChoices"] = hasChoices;
  exports["play"] = play;
  exports["firstChoice"] = firstChoice;
  exports["dropChoice"] = dropChoice;
  exports["gainBonus"] = gainBonus;
  exports["gainActions"] = gainActions;
  exports["gainBuys"] = gainBuys;
  exports["gainChoices"] = gainChoices;
  exports["gainChoice"] = gainChoice;
  exports["dropReaction"] = dropReaction;
  exports["purchase"] = purchase;
  exports["hasActions"] = hasActions;
  exports["hasActionCardsInHand"] = hasActionCardsInHand;
  exports["cash"] = cash;
  exports["drawCards"] = drawCards;
  exports["cleanup"] = cleanup;
  exports["score"] = score;
  exports["assertHasBuys"] = assertHasBuys;
  exports["assertHasActions"] = assertHasActions;
  exports["assertHasCash"] = assertHasCash;
  exports["upgrade"] = upgrade;
  exports["positivePoints"] = positivePoints;
  exports["newPlayer"] = newPlayer;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Supply"] = $PS["Domination.Data.Supply"] || {};
  var exports = $PS["Domination.Data.Supply"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Index = $PS["Data.Lens.Index"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Util = $PS["Util"];                
  var upgrade = Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Stack.upgrade);
  var updateStack = function (dictMonadError) {
      return function (i) {
          return function (stack) {
              return function (stacks) {
                  return Util.fromJust(dictMonadError)("cannot update stack!")(Data_Array.updateAt(i)(stack)(stacks));
              };
          };
      };
  };
  var stackByName = function (dictMonadError) {
      return function (cardName) {
          return function (supply) {
              return Util.fromJust(dictMonadError)("card not in supply!")(Data_Foldable.find(Data_Foldable.foldableArray)((function () {
                  var $19 = Data_Lens_Getter.view((function () {
                      var $21 = Domination_Data_Stack["_card"](Data_Lens_Internal_Forget.strongForget);
                      var $22 = Domination_Data_Card["_name"](Data_Lens_Internal_Forget.strongForget);
                      return function ($23) {
                          return $21($22($23));
                      };
                  })());
                  return function ($20) {
                      return (function (v) {
                          return v === cardName;
                      })($19($20));
                  };
              })())(supply));
          };
      };
  };
  var positivePoints = (function () {
      var $24 = Data_Foldable.sum(Data_Foldable.foldableArray)(Domination_Data_Points.ringPoints);
      var $25 = Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Stack.positivePoints);
      return function ($26) {
          return $24($25($26));
      };
  })();
  var nonEmptyStacks = Data_Array.filter(function ($27) {
      return (function (v) {
          return v > 0;
      })((function (v) {
          return v.count;
      })($27));
  });
  var negativePoints = (function () {
      var $28 = Data_Foldable.sum(Data_Foldable.foldableArray)(Domination_Data_Points.ringPoints);
      var $29 = Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Stack.negativePoints);
      return function ($30) {
          return $28($29($30));
      };
  })();
  var makeSupply = function (playerCount) {
      return function (cards) {
          var victoryCount = 4 * playerCount | 0;
          var treasureCount = 10 * playerCount | 0;
          var kingdomCount = 10 + (Data_Ord.max(Data_Ord.ordInt)(0)(playerCount - 4 | 0) * 2 | 0) | 0;
          var curseCount = 10 * (playerCount - 1 | 0) | 0;
          var countOf = function (card) {
              var $16 = Domination_Data_Card.hasType(Domination_Data_CardType.Victory.value)(card);
              if ($16) {
                  return victoryCount;
              };
              var $17 = Domination_Data_Card.hasType(Domination_Data_CardType.Curse.value)(card);
              if ($17) {
                  return curseCount;
              };
              var $18 = Domination_Data_Card.hasType(Domination_Data_CardType.Treasure.value)(card);
              if ($18) {
                  return treasureCount;
              };
              return kingdomCount;
          };
          var makeStack = function (card) {
              return {
                  card: card,
                  count: countOf(card)
              };
          };
          return Data_Functor.map(Data_Functor.functorArray)(makeStack)(cards);
      };
  };
  var indexOfStack = function (dictMonadError) {
      return function (card) {
          return function (stacks) {
              return Util.fromJust(dictMonadError)("card not in supply!")(Data_Array.findIndex((function () {
                  var $31 = Data_Lens_Getter.view(Domination_Data_Stack["_card"](Data_Lens_Internal_Forget.strongForget));
                  return function ($32) {
                      return (function (v) {
                          return Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Domination_Data_Card.eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Domination_Data_Actions.eqActions)))(v)(card);
                      })($31($32));
                  };
              })())(stacks));
          };
      };
  };
  var highestVictoryCardStack = (function () {
      var isPureVictory = function ($33) {
          return (function (v) {
              return Data_Eq.eq(Data_Eq.eqArray(Domination_Data_CardType.eqCardType))(v)([ Domination_Data_CardType.Victory.value ]);
          })((function (v) {
              return v.types;
          })((function (v) {
              return v.card;
          })($33)));
      };
      var comparingPoints = function (a) {
          return function (b) {
              return Data_Ord.compare(Domination_Data_Points.ordPoints)(a.card.victoryPoints)(b.card.victoryPoints);
          };
      };
      var $34 = Data_Foldable.maximumBy(Data_Foldable.foldableArray)(comparingPoints);
      var $35 = Data_Array.filter(isPureVictory);
      return function ($36) {
          return $34($35($36));
      };
  })();
  var highestVictoryCardStackIsEmpty = (function () {
      var $37 = Data_Functor.map(Data_Maybe.functorMaybe)(Domination_Data_Stack.isEmpty);
      return function ($38) {
          return (function (v) {
              return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(v)(new Data_Maybe.Just(true));
          })($37(highestVictoryCardStack($38)));
      };
  })();
  var emptyStacks = Data_Array.filter(function ($39) {
      return (function (v) {
          return v <= 0;
      })((function (v) {
          return v.count;
      })($39));
  });
  var emptyStackCount = function ($40) {
      return Data_Array.length(emptyStacks($40));
  };
  var _stack = function (i) {
      return function (dictWander) {
          return Data_Lens_Index.ix(Data_Lens_Index.indexArray)(i)(dictWander.Strong0())(dictWander.Choice1());
      };
  };
  var getStack = function (dictMonadError) {
      return function (i) {
          var $41 = Util.fromJust(dictMonadError)("cannot get stack!");
          return function ($42) {
              return $41((function (v) {
                  return Data_Lens_Fold.previewOn(v)(_stack(i)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
              })($42));
          };
      };
  };
  exports["_stack"] = _stack;
  exports["makeSupply"] = makeSupply;
  exports["upgrade"] = upgrade;
  exports["indexOfStack"] = indexOfStack;
  exports["updateStack"] = updateStack;
  exports["stackByName"] = stackByName;
  exports["nonEmptyStacks"] = nonEmptyStacks;
  exports["emptyStackCount"] = emptyStackCount;
  exports["getStack"] = getStack;
  exports["positivePoints"] = positivePoints;
  exports["negativePoints"] = negativePoints;
  exports["highestVictoryCardStackIsEmpty"] = highestVictoryCardStackIsEmpty;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Game"] = $PS["Domination.Data.Game"] || {};
  var exports = $PS["Domination.Data.Game"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Index = $PS["Data.Lens.Index"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Lens_Traversal = $PS["Data.Lens.Traversal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Profunctor_Star = $PS["Data.Profunctor.Star"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Capability_Random = $PS["Domination.Capability.Random"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_Cards = $PS["Domination.Data.Cards"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Condition = $PS["Domination.Data.Condition"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_Supply = $PS["Domination.Data.Supply"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Type_Proxy = $PS["Type.Proxy"];
  var Util = $PS["Util"];                
  var $$new = function (playerCount) {
      return function (cards) {
          return function (longGame) {
              return {
                  turn: 0,
                  phase: Domination_Data_Phase.ActionPhase.value,
                  players: Data_Array_NonEmpty.replicate(playerCount)(Domination_Data_Player.newPlayer),
                  result: Data_Maybe.Nothing.value,
                  supply: Domination_Data_Supply.makeSupply(playerCount)(cards),
                  trash: [  ],
                  longGame: longGame
              };
          };
      };
  };
  var describes = function (dictRandom) {
      return function (game) {
          return function (v) {
              if (v instanceof Domination_Data_Condition.HasCard) {
                  var $52 = Control_Applicative.pure((dictRandom.Monad0()).Applicative0());
                  var $53 = Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function ($55) {
                      return (function (v1) {
                          return v1 === v.value0;
                      })((function (v1) {
                          return v1.name;
                      })($55));
                  });
                  return function ($54) {
                      return $52($53((function (v1) {
                          return v1.hand;
                      })($54)));
                  };
              };
              if (v instanceof Domination_Data_Condition.HasCardType) {
                  var $56 = Control_Applicative.pure((dictRandom.Monad0()).Applicative0());
                  var $57 = Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Domination_Data_Card.hasType(v.value0));
                  return function ($58) {
                      return $56($57((function (v1) {
                          return v1.hand;
                      })($58)));
                  };
              };
              if (v instanceof Domination_Data_Condition.HasDiscard) {
                  var $59 = Control_Applicative.pure((dictRandom.Monad0()).Applicative0());
                  var $60 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                  return function ($61) {
                      return $59($60(Data_Array["null"]((function (v1) {
                          return v1.discard;
                      })($61))));
                  };
              };
              if (v instanceof Domination_Data_Condition.DiscardContains) {
                  var $62 = Control_Applicative.pure((dictRandom.Monad0()).Applicative0());
                  var $63 = Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function ($65) {
                      return (function (v1) {
                          return v1 === v.value0;
                      })((function (v1) {
                          return v1.name;
                      })($65));
                  });
                  return function ($64) {
                      return $62($63((function (v1) {
                          return v1.discard;
                      })($64)));
                  };
              };
              if (v instanceof Domination_Data_Condition.DiscardContainsCardType) {
                  var $66 = Control_Applicative.pure((dictRandom.Monad0()).Applicative0());
                  var $67 = Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Domination_Data_Card.hasType(v.value0));
                  return function ($68) {
                      return $66($67((function (v1) {
                          return v1.discard;
                      })($68)));
                  };
              };
              if (v instanceof Domination_Data_Condition.TrashContainsCardType) {
                  var $69 = Control_Applicative.pure((dictRandom.Monad0()).Applicative0());
                  var $70 = Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Domination_Data_Card.hasType(v.value0));
                  var $71 = Data_Function["const"]((function (v1) {
                      return v1.trash;
                  })(game));
                  return function ($72) {
                      return $69($70($71($72)));
                  };
              };
              if (v instanceof Domination_Data_Condition.Randomly) {
                  return Data_Function["const"](Data_Functor.map((((dictRandom.Monad0()).Bind1()).Apply0()).Functor0())(function (v1) {
                      return v1 > Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor));
                  })(Domination_Capability_Random.randomIntBetween(dictRandom)(0)(100)));
              };
              throw new Error("Failed pattern match at Domination.Data.Game (line 262, column 18 - line 271, column 34): " + [ v.constructor.name ]);
          };
      };
  };
  var assertTurn = function (dictMonadError) {
      return function (playerIndex) {
          return Util.assert(dictMonadError)(function ($73) {
              return (function (v) {
                  return playerIndex === v;
              })((function (v) {
                  return v.turn;
              })($73));
          })("not your turn!");
      };
  };
  var assertPhase = function (dictMonadError) {
      return function (expected) {
          return Util.assert(dictMonadError)(function ($74) {
              return (function (v) {
                  return Data_Eq.eq(Domination_Data_Phase.eqPhase)(v)(expected);
              })((function (v) {
                  return v.phase;
              })($74));
          })("Expected: " + Data_Show.show(Domination_Data_Phase.showPhase)(expected));
      };
  };
  var _turn = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "turn";
      }))()()(Type_Proxy["Proxy"].value)(dictStrong);
  };
  var _trash = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "trash";
      }))()()(Type_Proxy["Proxy"].value)(dictStrong);
  };
  var _supply = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "supply";
      }))()()(Type_Proxy["Proxy"].value)(dictStrong);
  };
  var updateStack = function (dictMonadError) {
      return function (i) {
          var $75 = Data_Lens_Traversal.traverseOf(_supply(Data_Profunctor_Star.strongStar(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())));
          var $76 = Domination_Data_Supply.updateStack(dictMonadError)(i);
          return function ($77) {
              return $75($76($77));
          };
      };
  };
  var modifyStack = function (dictMonadError) {
      return function (i) {
          return function (f) {
              return function (state) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Data_Functor.mapFlipped(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Domination_Data_Supply.getStack(dictMonadError)(i)(state.supply))(f))(Data_Function.flip(updateStack(dictMonadError)(i))(state));
              };
          };
      };
  };
  var modifyStackM = function (dictMonadError) {
      return function (i) {
          return function (f) {
              return function (state) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.getStack(dictMonadError)(i)(state.supply))(f))(Data_Function.flip(updateStack(dictMonadError)(i))(state));
              };
          };
      };
  };
  var _stack = function (i) {
      return function (dictWander) {
          var $78 = _supply(dictWander.Strong0());
          var $79 = Domination_Data_Supply["_stack"](i)(dictWander);
          return function ($80) {
              return $78($79($80));
          };
      };
  };
  var _result = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "result";
      }))()()(Type_Proxy["Proxy"].value)(dictStrong);
  };
  var _players = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "players";
      }))()()(Type_Proxy["Proxy"].value)(dictStrong);
  };
  var choicesOutstanding = (function () {
      var $81 = Data_Foldable.any(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Domination_Data_Player.hasChoices);
      var $82 = Data_Lens_Getter.view(_players(Data_Lens_Internal_Forget.strongForget));
      return function ($83) {
          return $81($82($83));
      };
  })();
  var assertChoicesResolved = function (dictMonadError) {
      return Util.assert(dictMonadError)((function () {
          var $84 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
          return function ($85) {
              return $84(choicesOutstanding($85));
          };
      })())("error: play: choices outstanding!");
  };
  var updatePlayer = function (dictMonadError) {
      return function (i) {
          return function (player) {
              return function (state) {
                  return Util.fromJust(dictMonadError)("cannot update player!")(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(Data_Array_NonEmpty.updateAt(i)(player)(state.players))(Data_Function.flip(Data_Lens_Setter.set(_players(Data_Profunctor_Strong.strongFn)))(state)));
              };
          };
      };
  };
  var upgrade = (function () {
      var $86 = Data_Lens_Setter.over(_trash(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Functor.functorArray)(Domination_Data_Cards.upgrade));
      var $87 = Data_Lens_Setter.over(_players(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(Domination_Data_Player.upgrade));
      var $88 = Data_Lens_Setter.over(_supply(Data_Profunctor_Strong.strongFn))(Domination_Data_Supply.upgrade);
      return function ($89) {
          return $86($87($88($89)));
      };
  })();
  var _player = function (i) {
      return function (dictWander) {
          var $90 = _players(dictWander.Strong0());
          var $91 = Data_Lens_Index.ix(Data_Lens_Index.indexNonEmptyArray)(i)(dictWander.Strong0())(dictWander.Choice1());
          return function ($92) {
              return $90($91($92));
          };
      };
  };
  var firstChoice = function (playerIndex) {
      return function (state) {
          return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Lens_Fold.previewOn(state)(_player(playerIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst))))(Domination_Data_Player.firstChoice);
      };
  };
  var isAttacked = function (playerIndex) {
      return function (state) {
          return Data_Maybe.fromMaybe(false)(Data_Functor.map(Data_Maybe.functorMaybe)(Domination_Data_Choice.isAttack)(firstChoice(playerIndex)(state)));
      };
  };
  var isBenefitted = function (playerIndex) {
      return function (state) {
          return Data_Maybe.fromMaybe(false)(Data_Functor.map(Data_Maybe.functorMaybe)((function () {
              var $93 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
              return function ($94) {
                  return $93(Domination_Data_Choice.isAttack($94));
              };
          })())(firstChoice(playerIndex)(state)));
      };
  };
  var getPlayer = function (dictMonadError) {
      return function (i) {
          var $95 = Util.fromJust(dictMonadError)("cannot get player!");
          return function ($96) {
              return $95((function (v) {
                  return Data_Lens_Fold.previewOn(v)(_player(i)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
              })($96));
          };
      };
  };
  var currentPlayer = function (dictMonadError) {
      return function (state) {
          return getPlayer(dictMonadError)(state.turn)(state);
      };
  };
  var modifyPlayer = function (dictMonadError) {
      return function (i) {
          return function (f) {
              return function (state) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Data_Functor.mapFlipped(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(getPlayer(dictMonadError)(i)(state))(f))(Data_Function.flip(updatePlayer(dictMonadError)(i))(state));
              };
          };
      };
  };
  var modifyPlayerM = function (dictMonadError) {
      return function (i) {
          return function (f) {
              return function (state) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(getPlayer(dictMonadError)(i)(state))(f))(Data_Function.flip(updatePlayer(dictMonadError)(i))(state));
              };
          };
      };
  };
  var assertPlayerCanAfford = function (dictMonadError) {
      return function (playerIndex) {
          return function (stackIndex) {
              return function (state) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.getStack(dictMonadError)(stackIndex)(state.supply))(function (stack) {
                      return modifyPlayerM(dictMonadError)(playerIndex)(Domination_Data_Player.assertHasCash(dictMonadError)(stack.card.cost))(state);
                  });
              };
          };
      };
  };
  var hasReaction = function (playerIndex) {
      return function (state) {
          var v = Data_Lens_Fold.previewOn(state)((function () {
              var $97 = _player(playerIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
              var $98 = Domination_Data_Player["_reaction"](Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
              return function ($99) {
                  return $97($98($99));
              };
          })());
          if (v instanceof Data_Maybe.Just) {
              return true;
          };
          if (v instanceof Data_Maybe.Nothing) {
              return false;
          };
          throw new Error("Failed pattern match at Domination.Data.Game (line 199, column 3 - line 201, column 21): " + [ v.constructor.name ]);
      };
  };
  var _pile = function (pile) {
      return function (playerIndex) {
          return function (dictWander) {
              if (pile instanceof Domination_Data_Pile.AtPlay) {
                  var $100 = _player(playerIndex)(dictWander);
                  var $101 = Domination_Data_Player["_atPlay"](dictWander.Strong0());
                  var $102 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($103) {
                      return $100($101($102($103)));
                  };
              };
              if (pile instanceof Domination_Data_Pile.Buying) {
                  var $104 = _player(playerIndex)(dictWander);
                  var $105 = Domination_Data_Player["_buying"](dictWander.Strong0());
                  var $106 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($107) {
                      return $104($105($106($107)));
                  };
              };
              if (pile instanceof Domination_Data_Pile.Deck) {
                  var $108 = _player(playerIndex)(dictWander);
                  var $109 = Domination_Data_Player["_deck"](dictWander.Strong0());
                  var $110 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($111) {
                      return $108($109($110($111)));
                  };
              };
              if (pile instanceof Domination_Data_Pile.Discard) {
                  var $112 = _player(playerIndex)(dictWander);
                  var $113 = Domination_Data_Player["_discard"](dictWander.Strong0());
                  var $114 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($115) {
                      return $112($113($114($115)));
                  };
              };
              if (pile instanceof Domination_Data_Pile.Discarding) {
                  var $116 = _player(playerIndex)(dictWander);
                  var $117 = Domination_Data_Player["_toDiscard"](dictWander.Strong0());
                  var $118 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($119) {
                      return $116($117($118($119)));
                  };
              };
              if (pile instanceof Domination_Data_Pile.Hand) {
                  var $120 = _player(playerIndex)(dictWander);
                  var $121 = Domination_Data_Player["_hand"](dictWander.Strong0());
                  var $122 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($123) {
                      return $120($121($122($123)));
                  };
              };
              if (pile instanceof Domination_Data_Pile.Supply) {
                  return _supply(dictWander.Strong0());
              };
              if (pile instanceof Domination_Data_Pile.Trash) {
                  var $124 = _trash(dictWander.Strong0());
                  var $125 = Domination_Data_Stack["_stacksFromCards"](dictWander.Strong0());
                  return function ($126) {
                      return $124($125($126));
                  };
              };
              throw new Error("Failed pattern match at Domination.Data.Game (line 97, column 26 - line 105, column 44): " + [ pile.constructor.name ]);
          };
      };
  };
  var _phase = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "phase";
      }))()()(Type_Proxy["Proxy"].value)(dictStrong);
  };
  exports["_turn"] = _turn;
  exports["_phase"] = _phase;
  exports["_players"] = _players;
  exports["_supply"] = _supply;
  exports["_trash"] = _trash;
  exports["_result"] = _result;
  exports["_player"] = _player;
  exports["_stack"] = _stack;
  exports["_pile"] = _pile;
  exports["new"] = $$new;
  exports["getPlayer"] = getPlayer;
  exports["modifyStack"] = modifyStack;
  exports["modifyPlayer"] = modifyPlayer;
  exports["modifyPlayerM"] = modifyPlayerM;
  exports["modifyStackM"] = modifyStackM;
  exports["upgrade"] = upgrade;
  exports["currentPlayer"] = currentPlayer;
  exports["hasReaction"] = hasReaction;
  exports["isAttacked"] = isAttacked;
  exports["isBenefitted"] = isBenefitted;
  exports["choicesOutstanding"] = choicesOutstanding;
  exports["assertTurn"] = assertTurn;
  exports["assertPhase"] = assertPhase;
  exports["assertPlayerCanAfford"] = assertPlayerCanAfford;
  exports["assertChoicesResolved"] = assertChoicesResolved;
  exports["describes"] = describes;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Game.Mode"] = $PS["Domination.Data.Game.Mode"] || {};
  var exports = $PS["Domination.Data.Game.Mode"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];                
  var Solo = (function () {
      function Solo(value0) {
          this.value0 = value0;
      };
      Solo.create = function (value0) {
          return new Solo(value0);
      };
      return Solo;
  })();
  var Short = (function () {
      function Short(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Short.create = function (value0) {
          return function (value1) {
              return new Short(value0, value1);
          };
      };
      return Short;
  })();
  var Long = (function () {
      function Long(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Long.create = function (value0) {
          return function (value1) {
              return new Long(value0, value1);
          };
      };
      return Long;
  })();
  var mode = function (dictMonadError) {
      return function (v) {
          var p2 = function ($18) {
              return (function (v1) {
                  if (v1 instanceof Data_Maybe.Nothing) {
                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("Where is player 2???");
                  };
                  if (v1 instanceof Data_Maybe.Just) {
                      return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(v1.value0);
                  };
                  throw new Error("Failed pattern match at Domination.Data.Game.Mode (line 37, column 19 - line 39, column 35): " + [ v1.constructor.name ]);
              })(Data_Array.head($18));
          };
          var v2 = Data_Array_NonEmpty.uncons(v.players);
          if (v2.tail.length === 0) {
              return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(new Solo(v2.head));
          };
          if (v.longGame) {
              return Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Long.create(v2.head))(p2(v2.tail));
          };
          return Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Short.create(v2.head))(p2(v2.tail));
      };
  };
  exports["Solo"] = Solo;
  exports["Short"] = Short;
  exports["Long"] = Long;
  exports["mode"] = mode;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Game.ResolveChoice"] = $PS["Domination.Data.Game.ResolveChoice"] || {};
  var exports = $PS["Domination.Data.Game.ResolveChoice"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Wander = $PS["Data.Lens.Internal.Wander"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Lens_Traversal = $PS["Data.Lens.Traversal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor = $PS["Data.Profunctor"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Capability_Log = $PS["Domination.Capability.Log"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_StackEvaluation = $PS["Domination.Data.StackEvaluation"];
  var Domination_Data_Supply = $PS["Domination.Data.Supply"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Data_Var = $PS["Domination.Data.Var"];
  var Record = $PS["Record"];
  var Relationship = $PS["Relationship"];
  var Rule = $PS["Rule"];
  var Util = $PS["Util"];                
  var moveFromTo = function (dictMonadError) {
      return function (dictRandom) {
          return function (v) {
              return function (v1) {
                  return function (v2) {
                      if (v2.resolution instanceof Data_Maybe.Nothing) {
                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("this is an unresolved choice: " + Data_Show.show(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "attack";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "destination";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "filter";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "n";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "resolution";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "source";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Pile.showPile))(Data_Maybe.showMaybe(Data_Show.showArray(Data_Show.showInt))))(Domination_Data_Constraint.showConstraint))(Domination_Data_Filter.showFilter))(Domination_Data_Pile.showPile))(Data_Show.showBoolean)))(v2));
                      };
                      if (v2.resolution instanceof Data_Maybe.Just) {
                          var _source = function (dictWander) {
                              var $348 = Domination_Data_Game["_pile"](v2.source)(v)(dictWander);
                              var $349 = Domination_Data_Stack["_stacksToCardsIso"]((dictWander.Choice1()).Profunctor0());
                              return function ($350) {
                                  return $348($349($350));
                              };
                          };
                          var _destination = function (dictWander) {
                              var $351 = Domination_Data_Game["_pile"](v2.destination)(v)(dictWander);
                              var $352 = Domination_Data_Stack["_stacksToCardsIso"]((dictWander.Choice1()).Profunctor0());
                              return function ($353) {
                                  return $351($352($353));
                              };
                          };
                          return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Util.fromJust(dictMonadError)("failed to get source")(Data_Lens_Fold.previewOn(v1)(_source(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))))(function (sourcePile) {
                              return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Util.takeIndices(dictMonadError)(v2.resolution.value0)(sourcePile))(function (selected) {
                                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Util.dropIndices(dictMonadError)(v2.resolution.value0)(sourcePile))(function (remaining) {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Constraint.check(dictMonadError)(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "actions";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "buys";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "cards";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "cost";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "name";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "reaction";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "special";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "treasure";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "types";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "victoryPoints";
                                      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "command";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "description";
                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                          return "target";
                                      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))(v2.n)(selected)(remaining)(sourcePile))(function () {
                                          return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Rule.check(dictMonadError)((function (v3) {
                                              return Rule.enforceOn(selected)(v3);
                                          })((function (v3) {
                                              return Rule.appendError("selected cards")(v3);
                                          })(Rule.simpleRule(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "actions";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "buys";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "cards";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "cost";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "name";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "reaction";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "special";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "treasure";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "types";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "victoryPoints";
                                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "command";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "description";
                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                              return "target";
                                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions))))(Data_Array.all(Domination_Data_Card.passFilter(v2.filter)))("illegal choice in")))))(function () {
                                              return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(Data_Lens_Setter.set(_source(Data_Lens_Internal_Wander.wanderFunction))(remaining)(Data_Lens_Setter.over(_destination(Data_Lens_Internal_Wander.wanderFunction))(function (v3) {
                                                  return Data_Semigroup.append(Data_Semigroup.semigroupArray)(selected)(v3);
                                              })(v1)));
                                          });
                                      });
                                  });
                              });
                          });
                      };
                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 506, column 1 - line 513, column 12): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
                  };
              };
          };
      };
  };
  var gainCards = function (dictMonadError) {
      return function (dictRandom) {
          return function (playerIndex) {
              return function (state) {
                  return function (v) {
                      var _destination = (function () {
                          var $354 = Domination_Data_Game["_pile"](v.destination)(playerIndex)(Data_Lens_Internal_Wander.wanderFunction);
                          var $355 = Domination_Data_Stack["_stacksToCardsIso"](Data_Profunctor.profunctorFn);
                          return function ($356) {
                              return $354($355($356));
                          };
                      })();
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.stackByName(dictMonadError)(v.cardName)(state.supply))(function (v1) {
                          return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.indexOfStack(dictMonadError)(v1.card)(state.supply))(function (stackIndex) {
                              var newCount = Data_Ord.max(Data_Ord.ordInt)(0)(v1.count - v.n | 0);
                              var stackUpdate = Data_Lens_Setter.set(Domination_Data_Stack["_count"](Data_Profunctor_Strong.strongFn))(newCount);
                              var cardsToGain = Data_Ord.min(Data_Ord.ordInt)(v.n)(v1.count);
                              var cards = Data_Array.replicate(cardsToGain)(v1.card);
                              return Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Lens_Setter.over(_destination)(function (v2) {
                                  return Data_Semigroup.append(Data_Semigroup.semigroupArray)(cards)(v2);
                              }))(Domination_Data_Game.modifyStack(dictMonadError)(stackIndex)(stackUpdate)(state));
                          });
                      });
                  };
              };
          };
      };
  };
  var gainCard = function (dictMonadError) {
      return function (dictRandom) {
          return function (playerIndex) {
              return function (state) {
                  return function (v) {
                      var _destination = (function () {
                          var $357 = Domination_Data_Game["_pile"](v.destination)(playerIndex)(Data_Lens_Internal_Wander.wanderFunction);
                          var $358 = Domination_Data_Stack["_stacksToCardsIso"](Data_Profunctor.profunctorFn);
                          return function ($359) {
                              return $357($358($359));
                          };
                      })();
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.stackByName(dictMonadError)(v.cardName)(state.supply))(function (stack) {
                          return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.indexOfStack(dictMonadError)(stack.card)(state.supply))(function (stackIndex) {
                              var cards = [ stack.card ];
                              return Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Lens_Setter.over(_destination)(function (v1) {
                                  return Data_Semigroup.append(Data_Semigroup.semigroupArray)(cards)(v1);
                              }))(Domination_Data_Game.modifyStack(dictMonadError)(stackIndex)(Domination_Data_Stack.take)(state));
                          });
                      });
                  };
              };
          };
      };
  };
  var resolveChoice = function (dictMonadError) {
      return function (dictRandom) {
          return function (dictLog) {
              return function (v) {
                  return function (state) {
                      var unresolved = Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("this is an unresolved choice: " + Data_Show.show(Domination_Data_Choice.showChoice)(v.choice));
                      return Control_Bind.bind((dictLog.Monad0()).Bind1())(Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Domination_Capability_Log.log(dictLog)("resolveChoice\x0aplayerIndex=" + (Data_Show.show(Data_Show.showInt)(v.playerIndex) + ("\x0a choice=" + Data_Show.show(Domination_Data_Choice.showChoice)(v.choice)))))(function () {
                          if (v.choice instanceof Domination_Data_Choice.StackChoice) {
                              var evalStackChoice = function (expression) {
                                  return function (stack) {
                                      return function (state$prime) {
                                          return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Domination_Capability_Log.log(dictLog)(" evalStackChoice\x0aexpr=" + (Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackExpression))(expression) + ("\x0a  stack=" + Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackValue))(stack)))))(function () {
                                              var v1 = Data_Array.uncons(expression);
                                              if (v1 instanceof Data_Maybe.Nothing) {
                                                  return Control_Applicative.pure((dictLog.Monad0()).Applicative0())({
                                                      state: state$prime,
                                                      expr: [  ],
                                                      stack: stack
                                                  });
                                              };
                                              if (v1 instanceof Data_Maybe.Just) {
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackGainBonus) {
                                                      return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainBonus(v1.value0.head.value0))(state$prime))(function (state$prime$prime) {
                                                          return evalStackChoice(v1.value0.tail)(stack)(state$prime$prime);
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackIf) {
                                                      return Control_Bind.bind((dictLog.Monad0()).Bind1())(evalStackChoice(v1.value0.head.value0.condition)(stack)(state$prime))(function (v2) {
                                                          var v3 = Data_Array.uncons(v2.stack);
                                                          if (v3 instanceof Data_Maybe.Nothing) {
                                                              return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackIf: condition" + " evaluated to empty stack!");
                                                          };
                                                          if (v3 instanceof Data_Maybe.Just) {
                                                              if (v3.value0.head instanceof Domination_Data_StackEvaluation.StackBool) {
                                                                  var expr$prime = (function () {
                                                                      if (v3.value0.head.value0) {
                                                                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v1.value0.head.value0.following)(v1.value0.tail);
                                                                      };
                                                                      return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v1.value0.head.value0.otherwise)(v1.value0.tail);
                                                                  })();
                                                                  return evalStackChoice(expr$prime)(v3.value0.tail)(v2.state);
                                                              };
                                                              return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackIf: condition must" + (" evaluate to a boolean, not: " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v3.value0.head)));
                                                          };
                                                          throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 99, column 17 - line 113, column 34): " + [ v3.constructor.name ]);
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackPush) {
                                                      return evalStackChoice(v1.value0.tail)(Data_Array.cons(v1.value0.head.value0)(stack))(state$prime);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackEquals) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackEquals with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          var stack$prime = Data_Array.cons(new Domination_Data_StackEvaluation.StackBool(Data_Eq.eq(Domination_Data_StackEvaluation.eqStackValue)(v2.value0.head)(v1.value0.head.value0)))(v2.value0.tail);
                                                          return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 119, column 17 - line 124, column 68): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply && (v1.value0.head.value0.cardName instanceof Domination_Data_Var.Bound && v1.value0.head.value0.filter instanceof Domination_Data_Var.Bound)) {
                                                      return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Supply.stackByName(dictMonadError)(v1.value0.head.value0.cardName.value0)(state$prime.supply))(function (v2) {
                                                          return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Rule.check(dictMonadError)((function (v3) {
                                                              return Rule.enforceOn(v2.card)(v3);
                                                          })((function (v3) {
                                                              return Rule.appendError("selected card")(v3);
                                                          })(Rule.simpleRule(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "actions";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "buys";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "cards";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "cost";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "name";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "reaction";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "special";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "treasure";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "types";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "victoryPoints";
                                                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "command";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "description";
                                                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                              return "target";
                                                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))(Domination_Data_Card.passFilter(v1.value0.head.value0.filter.value0))("illegal card")))))(function () {
                                                              return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Rule.check(dictMonadError)((function (v3) {
                                                                  return Rule.enforceOn(v2.count)(v3);
                                                              })((function (v3) {
                                                                  return Rule.appendError("selected stack")(v3);
                                                              })(Rule.simpleRule(Data_Show.showInt)(function (v3) {
                                                                  return v3 > 0;
                                                              })("empty")))))(function () {
                                                                  var stack$prime = Data_Array.cons(new Domination_Data_StackEvaluation.StackString(v1.value0.head.value0.cardName.value0))(stack);
                                                                  return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackOption && v1.value0.head.value0 instanceof Domination_Data_Var.Bound) {
                                                      var value = new Domination_Data_StackEvaluation.StackBool(v1.value0.head.value0.value0);
                                                      return evalStackChoice(v1.value0.tail)(Data_Array.cons(value)(stack))(state$prime);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackOption && v1.value0.head.value0 instanceof Domination_Data_Var.Unbound) {
                                                      var choice$prime = new Domination_Data_Choice.StackChoice({
                                                          attack: v.choice.value0.attack,
                                                          expression: expression,
                                                          stack: stack,
                                                          description: v.choice.value0.description
                                                      });
                                                      return Data_Functor.mapFlipped((((dictLog.Monad0()).Bind1()).Apply0()).Functor0())(Control_Bind.bind((dictLog.Monad0()).Bind1())(Data_Lens_Traversal.traverseOf(Domination_Data_Game["_player"](v.playerIndex)(Data_Lens_Internal_Wander.wanderStar((dictLog.Monad0()).Applicative0())))(Domination_Data_Player.dropChoice(dictMonadError))(state$prime))(Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainChoices([ choice$prime, choice$prime ]))))(function (v2) {
                                                          return {
                                                              state: v2,
                                                              expr: expression,
                                                              stack: stack
                                                          };
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply && (v1.value0.head.value0.cardName instanceof Domination_Data_Var.Unbound && v1.value0.head.value0.filter instanceof Domination_Data_Var.Bound)) {
                                                      var choice$prime = new Domination_Data_Choice.StackChoice({
                                                          attack: v.choice.value0.attack,
                                                          expression: expression,
                                                          stack: stack,
                                                          description: v.choice.value0.description
                                                      });
                                                      return Data_Functor.mapFlipped((((dictLog.Monad0()).Bind1()).Apply0()).Functor0())(Control_Bind.bind((dictLog.Monad0()).Bind1())(Data_Lens_Traversal.traverseOf(Domination_Data_Game["_player"](v.playerIndex)(Data_Lens_Internal_Wander.wanderStar((dictLog.Monad0()).Applicative0())))(Domination_Data_Player.dropChoice(dictMonadError))(state$prime))(Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainChoices([ choice$prime, choice$prime ]))))(function (v2) {
                                                          return {
                                                              state: v2,
                                                              expr: expression,
                                                              stack: stack
                                                          };
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply && v1.value0.head.value0.filter instanceof Domination_Data_Var.Unbound) {
                                                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("Unbound filter");
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && (v1.value0.head.value0.cards instanceof Domination_Data_Var.Bound && (v1.value0.head.value0.filter instanceof Domination_Data_Var.Bound && (v1.value0.head.value0.from instanceof Domination_Data_Var.Bound && v1.value0.head.value0.n instanceof Domination_Data_Var.Bound)))) {
                                                      var stack$prime = Data_Array.cons(new Domination_Data_StackEvaluation.StackArrayInt(v1.value0.head.value0.cards.value0))(stack);
                                                      var _source = (function () {
                                                          var $360 = Domination_Data_Game["_pile"](v1.value0.head.value0.from.value0)(v.playerIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
                                                          var $361 = Domination_Data_Stack["_stacksToCardsIso"](Data_Lens_Internal_Forget.profunctorForget);
                                                          return function ($362) {
                                                              return $360($361($362));
                                                          };
                                                      })();
                                                      return Control_Bind.bind((dictLog.Monad0()).Bind1())(Util.fromJust(dictMonadError)("failed to get source")(Data_Lens_Fold.previewOn(state$prime)(_source)))(function (sourcePile) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(Util.takeIndices(dictMonadError)(v1.value0.head.value0.cards.value0)(sourcePile))(function (selected) {
                                                              return Control_Bind.bind((dictLog.Monad0()).Bind1())(Util.dropIndices(dictMonadError)(v1.value0.head.value0.cards.value0)(sourcePile))(function (remaining) {
                                                                  return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Domination_Data_Constraint.check(dictMonadError)(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "actions";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "buys";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "cards";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "cost";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "name";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "reaction";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "special";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "treasure";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "types";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "victoryPoints";
                                                                  }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "command";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "description";
                                                                  }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                      return "target";
                                                                  }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))(v1.value0.head.value0.n.value0)(selected)(remaining)(sourcePile))(function () {
                                                                      return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Rule.check(dictMonadError)((function (v2) {
                                                                          return Rule.enforceOn(selected)(v2);
                                                                      })((function (v2) {
                                                                          return Rule.appendError("selected cards")(v2);
                                                                      })(Rule.simpleRule(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "actions";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "buys";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "cards";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "cost";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "name";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "reaction";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "special";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "treasure";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "types";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "victoryPoints";
                                                                      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "command";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "description";
                                                                      }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                                                                          return "target";
                                                                      }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions))))(Data_Array.all(Domination_Data_Card.passFilter(v1.value0.head.value0.filter.value0)))("illegal choice in")))))(function () {
                                                                          return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                                      });
                                                                  });
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && (v1.value0.head.value0.cards instanceof Domination_Data_Var.Unbound && (v1.value0.head.value0.filter instanceof Domination_Data_Var.Bound && (v1.value0.head.value0.from instanceof Domination_Data_Var.Bound && v1.value0.head.value0.n instanceof Domination_Data_Var.Bound)))) {
                                                      var choice$prime = new Domination_Data_Choice.StackChoice({
                                                          attack: v.choice.value0.attack,
                                                          expression: expression,
                                                          stack: stack,
                                                          description: v.choice.value0.description
                                                      });
                                                      return Data_Functor.mapFlipped((((dictLog.Monad0()).Bind1()).Apply0()).Functor0())(Control_Bind.bind((dictLog.Monad0()).Bind1())(Data_Lens_Traversal.traverseOf(Domination_Data_Game["_player"](v.playerIndex)(Data_Lens_Internal_Wander.wanderStar((dictLog.Monad0()).Applicative0())))(Domination_Data_Player.dropChoice(dictMonadError))(state$prime))(Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainChoices([ choice$prime, choice$prime ]))))(function (v2) {
                                                          return {
                                                              state: v2,
                                                              expr: v1.value0.tail,
                                                              stack: stack
                                                          };
                                                      });
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && v1.value0.head.value0.cards instanceof Domination_Data_Var.Unbound) {
                                                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("Unbound cards");
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && v1.value0.head.value0.filter instanceof Domination_Data_Var.Unbound) {
                                                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("Unbound filter");
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && v1.value0.head.value0.from instanceof Domination_Data_Var.Unbound) {
                                                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("Unbound from");
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && v1.value0.head.value0.n instanceof Domination_Data_Var.Unbound) {
                                                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("Unbound n");
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackBind) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackBind with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          var v3 = Data_Array.uncons(v1.value0.tail);
                                                          if (v3 instanceof Data_Maybe.Nothing) {
                                                              return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("nothing to bind to!");
                                                          };
                                                          if (v3 instanceof Data_Maybe.Just) {
                                                              if (v2.value0.head instanceof Domination_Data_StackEvaluation.StackFilter && (v1.value0.head.value0 === "filter" && v3.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply)) {
                                                                  var z = Record.merge()()({
                                                                      filter: new Domination_Data_Var.Bound(v2.value0.head.value0)
                                                                  })(v3.value0.head.value0);
                                                                  var top = new Domination_Data_StackEvaluation.StackChooseCardFromSupply(z);
                                                                  var expr$prime = Data_Array.cons(top)(v3.value0.tail);
                                                                  return evalStackChoice(expr$prime)(v2.value0.tail)(state$prime);
                                                              };
                                                              return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("unimplemented - " + ("stackValue: " + (Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head) + (", label: " + (Data_Show.show(Data_Show.showString)(v1.value0.head.value0) + (", nextExpr: " + Data_Show.show(Domination_Data_StackEvaluation.showStackExpression)(v3.value0.head)))))));
                                                          };
                                                          throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 263, column 21 - line 279, column 63): " + [ v3.constructor.name ]);
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 260, column 17 - line 279, column 63): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackDuplicate) {
                                                      var v2 = Data_Array.head(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackDuplicate with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return evalStackChoice(v1.value0.tail)(Data_Array.cons(v2.value0)(stack))(state$prime);
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 282, column 17 - line 286, column 70): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackCostOf) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackCostOf with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackInt) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Game.getPlayer(dictMonadError)(v.playerIndex)(state))(function (player) {
                                                              return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Player.getCard(dictMonadError)(v2.value0.head.value0)(player))(function (v3) {
                                                                  var top = new Domination_Data_StackEvaluation.StackInt(v3.cost);
                                                                  var stack$prime = Data_Array.cons(top)(v2.value0.tail);
                                                                  return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                              });
                                                          });
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't get the cost of " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 289, column 17 - line 299, column 58): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackGainTo) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackGainTo with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackString) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(gainCards(dictMonadError)(dictRandom)(v.playerIndex)(state$prime)({
                                                              n: 1,
                                                              cardName: v2.value0.head.value0,
                                                              destination: v1.value0.head.value0
                                                          }))(evalStackChoice(v1.value0.tail)(v2.value0.tail));
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't gain " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 302, column 17 - line 311, column 47): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackDiscard) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackDiscard with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackArrayInt) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(moveFromTo(dictMonadError)(dictRandom)(v.playerIndex)(state$prime)({
                                                              filter: Domination_Data_Filter.Any.value,
                                                              n: Domination_Data_Constraint.Unlimited.value,
                                                              source: Domination_Data_Pile.Hand.value,
                                                              destination: Domination_Data_Pile.Discarding.value,
                                                              resolution: new Data_Maybe.Just(v2.value0.head.value0),
                                                              attack: v.choice.value0.attack
                                                          }))(function (state$prime$prime) {
                                                              return evalStackChoice(v1.value0.tail)(v2.value0.tail)(state$prime$prime);
                                                          });
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't discard " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 314, column 17 - line 328, column 50): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackTrash) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackTrash with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackArrayInt) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(moveFromTo(dictMonadError)(dictRandom)(v.playerIndex)(state$prime)({
                                                              filter: Domination_Data_Filter.Any.value,
                                                              n: Domination_Data_Constraint.Unlimited.value,
                                                              source: Domination_Data_Pile.Hand.value,
                                                              destination: Domination_Data_Pile.Trash.value,
                                                              resolution: new Data_Maybe.Just(v2.value0.head.value0),
                                                              attack: v.choice.value0.attack
                                                          }))(function (state$prime$prime) {
                                                              return evalStackChoice(v1.value0.tail)(v2.value0.tail)(state$prime$prime);
                                                          });
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't trash " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 331, column 17 - line 344, column 48): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackLength) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackLength with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackArrayInt) {
                                                          var stack$prime = Data_Array.cons(new Domination_Data_StackEvaluation.StackInt(Data_Array.length(v2.value0.head.value0)))(v2.value0.tail);
                                                          return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't take the length of " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 347, column 17 - line 353, column 61): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackAddN) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackAddN with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackInt) {
                                                          var stack$prime = Data_Array.cons(new Domination_Data_StackEvaluation.StackInt(v2.value0.head.value0 + v1.value0.head.value0 | 0))(v2.value0.tail);
                                                          return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't add to " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 356, column 17 - line 362, column 49): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackMakeFilterAnd) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackMakeFilterAnd with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackFilter) {
                                                          var v3 = Data_Array.uncons(v2.value0.tail);
                                                          if (v3 instanceof Data_Maybe.Nothing) {
                                                              return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackMakeFilterAnd requires 2 items on stack");
                                                          };
                                                          if (v3 instanceof Data_Maybe.Just && v3.value0.head instanceof Domination_Data_StackEvaluation.StackFilter) {
                                                              var top = Domination_Data_StackEvaluation.StackFilter.create(new Domination_Data_Filter.And(v2.value0.head.value0, v3.value0.head.value0));
                                                              var stack$prime = Data_Array.cons(top)(v3.value0.tail);
                                                              return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                          };
                                                          if (v3 instanceof Data_Maybe.Just) {
                                                              return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't make a filter from " + (Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v3.value0.head) + (" stack: " + (Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackValue))(stack) + (", expression: " + Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackExpression))(expression))))));
                                                          };
                                                          throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 369, column 21 - line 380, column 63): " + [ v3.constructor.name ]);
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't make a filter from " + (Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head) + (" stack: " + (Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackValue))(stack) + (", expression: " + Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackExpression))(expression))))));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 365, column 17 - line 384, column 59): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackMakeFilterCostUpTo) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackMakeFilterCostUpTo with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackInt) {
                                                          var top = Domination_Data_StackEvaluation.StackFilter.create(new Domination_Data_Filter.CostUpTo(v2.value0.head.value0));
                                                          var stack$prime = Data_Array.cons(top)(v2.value0.tail);
                                                          return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't make a filter from " + (Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head) + (" stack: " + (Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackValue))(stack) + (", expression: " + Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackExpression))(expression))))));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 387, column 17 - line 398, column 59): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackNth) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackNth with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackArrayInt) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(Util.fromJust(dictMonadError)("cannot get element " + (Data_Show.show(Data_Show.showInt)(v1.value0.head.value0) + (" from array " + Data_Show.show(Data_Show.showArray(Data_Show.showInt))(v2.value0.head.value0))))(Data_Array.index(v2.value0.head.value0)(v1.value0.head.value0)))(function (v3) {
                                                              var stack$prime = Data_Array.cons(new Domination_Data_StackEvaluation.StackInt(v3))(v2.value0.tail);
                                                              return evalStackChoice(v1.value0.tail)(stack$prime)(state$prime);
                                                          });
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't take the nth of " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 401, column 17 - line 413, column 58): " + [ v2.constructor.name ]);
                                                  };
                                                  if (v1.value0.head instanceof Domination_Data_StackEvaluation.StackDraw) {
                                                      var v2 = Data_Array.uncons(stack);
                                                      if (v2 instanceof Data_Maybe.Nothing) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("StackDuplicate with empty Stack");
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just && v2.value0.head instanceof Domination_Data_StackEvaluation.StackInt) {
                                                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Game.modifyPlayerM(dictMonadError)(v.playerIndex)(Domination_Data_Player.drawCards(dictMonadError)(dictRandom)(v2.value0.head.value0))(state$prime))(evalStackChoice(v1.value0.tail)(v2.value0.tail));
                                                      };
                                                      if (v2 instanceof Data_Maybe.Just) {
                                                          return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("can't draw " + Data_Show.show(Domination_Data_StackEvaluation.showStackValue)(v2.value0.head));
                                                      };
                                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 416, column 17 - line 427, column 47): " + [ v2.constructor.name ]);
                                                  };
                                                  throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 88, column 55 - line 427, column 47): " + [ v1.value0.head.constructor.name ]);
                                              };
                                              throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 85, column 11 - line 427, column 47): " + [ v1.constructor.name ]);
                                          });
                                      };
                                  };
                              };
                              return Control_Bind.bind((dictLog.Monad0()).Bind1())(evalStackChoice(v.choice.value0.expression)(v.choice.value0.stack)(state))(function (v1) {
                                  if (v1.expr.length === 0 && v1.stack.length === 0) {
                                      return Control_Applicative.pure((dictLog.Monad0()).Applicative0())(v1.state);
                                  };
                                  if (v1.expr.length === 0) {
                                      return Control_Monad_Error_Class.throwError(dictMonadError.MonadThrow0())("leftover stack: " + Data_Show.show(Data_Show.showArray(Domination_Data_StackEvaluation.showStackValue))(v1.stack));
                                  };
                                  return Control_Applicative.pure((dictLog.Monad0()).Applicative0())(v1.state);
                              });
                          };
                          if (v.choice instanceof Domination_Data_Choice.MoveFromTo) {
                              return moveFromTo(dictMonadError)(dictRandom)(v.playerIndex)(state)(v.choice.value0);
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainCard && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return gainCard(dictMonadError)(dictRandom)(v.playerIndex)(state)({
                                  filter: v.choice.value0.filter,
                                  destination: v.choice.value0.destination,
                                  cardName: v.choice.value0.resolution.value0
                              });
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainCards && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return gainCards(dictMonadError)(dictRandom)(v.playerIndex)(state)({
                                  n: v.choice.value0.n,
                                  cardName: v.choice.value0.cardName,
                                  destination: v.choice.value0.destination
                              });
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainActions && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainActions(v.choice.value0.n))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainBuys && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainBuys(v.choice.value0.n))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.Discard && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Util.moveAll(function (dictStrong) {
                                  return Domination_Data_Player["_hand"](dictStrong);
                              })(function (dictStrong) {
                                  return Domination_Data_Player["_toDiscard"](dictStrong);
                              }))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.Draw && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayerM(dictMonadError)(v.playerIndex)(Domination_Data_Player.drawCards(dictMonadError)(dictRandom)(v.choice.value0.n))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainBonus && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainBonus(v.choice.value0.bonus))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.If && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              var playerUpdate = function (ok) {
                                  return function (player) {
                                      if (ok) {
                                          return Domination_Data_Player.gainChoice(v.choice.value0.choice)(player);
                                      };
                                      if (v.choice.value0.otherwise instanceof Data_Maybe.Nothing) {
                                          return player;
                                      };
                                      if (v.choice.value0.otherwise instanceof Data_Maybe.Just) {
                                          return Domination_Data_Player.gainChoice(v.choice.value0.otherwise.value0)(player);
                                      };
                                      throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 454, column 16 - line 456, column 49): " + [ v.choice.value0.otherwise.constructor.name ]);
                                  };
                              };
                              return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Game.getPlayer(dictMonadError)(v.playerIndex)(state))(function (player) {
                                  return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Data_Game.describes(dictRandom)(state)(v.choice.value0.condition)(player))(function (ok) {
                                      return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(playerUpdate(ok))(state);
                                  });
                              });
                          };
                          if (v.choice instanceof Domination_Data_Choice.And && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainChoices(v.choice.value0.choices))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.Or && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainChoice(v.choice.value0.resolution.value0))(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.PickN && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Rule.check(dictMonadError)(Rule.enforceOn(v.choice.value0.resolution.value0)(Rule.appendErrorOn(Rule.lengthIs(Domination_Data_Choice.showChoice)(Relationship.EQ.value)(v.choice.value0.n))("choices"))))(function () {
                                  return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.gainChoices(v.choice.value0.resolution.value0))(state);
                              });
                          };
                          if (v.choice instanceof Domination_Data_Choice.Option && v.choice.value0.resolution instanceof Data_Maybe.Just) {
                              var playerUpdate = (function () {
                                  if (v.choice.value0.resolution.value0) {
                                      return Domination_Data_Player.gainChoice(v.choice.value0.choice);
                                  };
                                  return Control_Category.identity(Control_Category.categoryFn);
                              })();
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(playerUpdate)(state);
                          };
                          if (v.choice instanceof Domination_Data_Choice.If && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.And && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.Or && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.PickN && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.Option && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainCards && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainCard && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              var unfiltered = Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                                  return v1.card;
                              })(Domination_Data_Supply.nonEmptyStacks(state.supply));
                              var cards = Data_Array.filter(Domination_Data_Card.passFilter(v.choice.value0.filter))(unfiltered);
                              if (cards.length === 0) {
                                  return Control_Applicative.pure((dictLog.Monad0()).Applicative0())(state);
                              };
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainActions && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainBuys && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.Discard && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.Draw && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          if (v.choice instanceof Domination_Data_Choice.GainBonus && v.choice.value0.resolution instanceof Data_Maybe.Nothing) {
                              return unresolved;
                          };
                          throw new Error("Failed pattern match at Domination.Data.Game.ResolveChoice (line 57, column 3 - line 491, column 52): " + [ v.choice.constructor.name ]);
                      }))(Data_Lens_Traversal.traverseOf(Domination_Data_Game["_player"](v.playerIndex)(Data_Lens_Internal_Wander.wanderStar((dictLog.Monad0()).Applicative0())))(Domination_Data_Player.dropChoice(dictMonadError)));
                  };
              };
          };
      };
  };
  exports["resolveChoice"] = resolveChoice;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Play"] = $PS["Domination.Data.Play"] || {};
  var exports = $PS["Domination.Data.Play"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Internal_Wander = $PS["Data.Lens.Internal.Wander"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Traversal = $PS["Data.Lens.Traversal"];
  var Data_Profunctor_Star = $PS["Data.Profunctor.Star"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];                
  var NewGame = (function () {
      function NewGame(value0) {
          this.value0 = value0;
      };
      NewGame.create = function (value0) {
          return new NewGame(value0);
      };
      return NewGame;
  })();
  var EndPhase = (function () {
      function EndPhase(value0) {
          this.value0 = value0;
      };
      EndPhase.create = function (value0) {
          return new EndPhase(value0);
      };
      return EndPhase;
  })();
  var PlayCard = (function () {
      function PlayCard(value0) {
          this.value0 = value0;
      };
      PlayCard.create = function (value0) {
          return new PlayCard(value0);
      };
      return PlayCard;
  })();
  var Purchase = (function () {
      function Purchase(value0) {
          this.value0 = value0;
      };
      Purchase.create = function (value0) {
          return new Purchase(value0);
      };
      return Purchase;
  })();
  var ResolveChoice = (function () {
      function ResolveChoice(value0) {
          this.value0 = value0;
      };
      ResolveChoice.create = function (value0) {
          return new ResolveChoice(value0);
      };
      return ResolveChoice;
  })();
  var React = (function () {
      function React(value0) {
          this.value0 = value0;
      };
      React.create = function (value0) {
          return new React(value0);
      };
      return React;
  })();
  var genericPlay = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof NewGame) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof EndPhase) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof PlayCard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof Purchase) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof ResolveChoice) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof React) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
      };
      throw new Error("Failed pattern match at Domination.Data.Play (line 55, column 1 - line 55, column 46): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new NewGame(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new EndPhase(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new PlayCard(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new Purchase(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new ResolveChoice(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
          return new React(x.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Play (line 55, column 1 - line 55, column 46): " + [ x.constructor.name ]);
  });
  var encodeJsonPlay = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericPlay)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "NewGame";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "playerCount";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "EndPhase";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "PlayCard";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cardIndex";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "Purchase";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "stackIndex";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "ResolveChoice";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Choice.encodeJsonChoice)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "choice";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "React";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())())))))))));
  var decodeJsonPlay = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericPlay)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "NewGame";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "playerCount";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "EndPhase";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "PlayCard";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cardIndex";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "Purchase";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "stackIndex";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "ResolveChoice";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Choice.decodeJsonChoice))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "choice";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "React";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())()))))))));
  var _playerIndex$prime = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "playerIndex";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _playerIndex = function (dictWander) {
      return Data_Lens_Internal_Wander.wander(dictWander)(function (dictApplicative) {
          return function (f) {
              return function (s) {
                  if (s instanceof NewGame) {
                      return Control_Applicative.pure(dictApplicative)(s);
                  };
                  if (s instanceof EndPhase) {
                      return Data_Functor.map((dictApplicative.Apply0()).Functor0())(EndPhase.create)(Data_Lens_Traversal.traverseOf(_playerIndex$prime(Data_Profunctor_Star.strongStar((dictApplicative.Apply0()).Functor0())))(f)(s.value0));
                  };
                  if (s instanceof PlayCard) {
                      return Data_Functor.map((dictApplicative.Apply0()).Functor0())(PlayCard.create)(Data_Lens_Traversal.traverseOf(_playerIndex$prime(Data_Profunctor_Star.strongStar((dictApplicative.Apply0()).Functor0())))(f)(s.value0));
                  };
                  if (s instanceof Purchase) {
                      return Data_Functor.map((dictApplicative.Apply0()).Functor0())(Purchase.create)(Data_Lens_Traversal.traverseOf(_playerIndex$prime(Data_Profunctor_Star.strongStar((dictApplicative.Apply0()).Functor0())))(f)(s.value0));
                  };
                  if (s instanceof ResolveChoice) {
                      return Data_Functor.map((dictApplicative.Apply0()).Functor0())(ResolveChoice.create)(Data_Lens_Traversal.traverseOf(_playerIndex$prime(Data_Profunctor_Star.strongStar((dictApplicative.Apply0()).Functor0())))(f)(s.value0));
                  };
                  if (s instanceof React) {
                      return Data_Functor.map((dictApplicative.Apply0()).Functor0())(React.create)(Data_Lens_Traversal.traverseOf(_playerIndex$prime(Data_Profunctor_Star.strongStar((dictApplicative.Apply0()).Functor0())))(f)(s.value0));
                  };
                  throw new Error("Failed pattern match at Domination.Data.Play (line 47, column 31 - line 53, column 52): " + [ s.constructor.name ]);
              };
          };
      });
  };
  exports["NewGame"] = NewGame;
  exports["EndPhase"] = EndPhase;
  exports["PlayCard"] = PlayCard;
  exports["Purchase"] = Purchase;
  exports["ResolveChoice"] = ResolveChoice;
  exports["React"] = React;
  exports["_playerIndex"] = _playerIndex;
  exports["encodeJsonPlay"] = encodeJsonPlay;
  exports["decodeJsonPlay"] = decodeJsonPlay;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Result"] = $PS["Domination.Data.Result"] || {};
  var exports = $PS["Domination.Data.Result"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Symbol = $PS["Data.Symbol"];                
  var Victory = (function () {
      function Victory(value0) {
          this.value0 = value0;
      };
      Victory.create = function (value0) {
          return new Victory(value0);
      };
      return Victory;
  })();
  var Tie = (function () {
      function Tie(value0) {
          this.value0 = value0;
      };
      Tie.create = function (value0) {
          return new Tie(value0);
      };
      return Tie;
  })();
  var genericResult = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof Victory) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof Tie) {
          return new Data_Generic_Rep.Inr(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Result (line 25, column 1 - line 25, column 50): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new Victory(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr) {
          return new Tie(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Result (line 25, column 1 - line 25, column 50): " + [ x.constructor.name ]);
  });
  var encodeJsonResult = new Data_Argonaut_Encode_Class.EncodeJson(function (a) {
      return Data_Argonaut_Encode_Generic.genericEncodeJson(genericResult)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Victory";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
          return "Tie";
      }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonInt)))))(a);
  });
  var decodeJsonResult = new Data_Argonaut_Decode_Class.DecodeJson(function (a) {
      return Data_Argonaut_Decode_Generic.genericDecodeJson(genericResult)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Victory";
      }))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
          return "Tie";
      }))(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonInt))))(a);
  });
  exports["Victory"] = Victory;
  exports["Tie"] = Tie;
  exports["encodeJsonResult"] = encodeJsonResult;
  exports["decodeJsonResult"] = decodeJsonResult;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Game.Engine"] = $PS["Domination.Data.Game.Engine"] || {};
  var exports = $PS["Domination.Data.Game.Engine"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Either = $PS["Data.Either"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_EuclideanRing = $PS["Data.EuclideanRing"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Internal_Wander = $PS["Data.Lens.Internal.Wander"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Lens_Traversal = $PS["Data.Lens.Traversal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Capability_Log = $PS["Domination.Capability.Log"];
  var Domination_Capability_Random = $PS["Domination.Capability.Random"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Cards = $PS["Domination.Data.Cards"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];
  var Domination_Data_Game_Mode = $PS["Domination.Data.Game.Mode"];
  var Domination_Data_Game_ResolveChoice = $PS["Domination.Data.Game.ResolveChoice"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Play = $PS["Domination.Data.Play"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Result = $PS["Domination.Data.Result"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_Supply = $PS["Domination.Data.Supply"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Util = $PS["Util"];                
  var setup = function (dictMonadError) {
      return function (dictRandom) {
          return function (game) {
              return Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Function.flip(Data_Lens_Setter.set(Domination_Data_Game["_players"](Data_Profunctor_Strong.strongFn)))(game))(Data_Traversable.traverse(Data_Array_NonEmpty_Internal.traversableNonEmptyArray)(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(Domination_Data_Player.drawCards(dictMonadError)(dictRandom)(5))(game.players));
          };
      };
  };
  var react = function (dictMonadError) {
      return function (v) {
          return Control_Bind.composeKleisli(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.dropReaction))((function () {
              if (v.reaction instanceof Data_Maybe.Nothing) {
                  return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0());
              };
              if (v.reaction instanceof Data_Maybe.Just) {
                  return Data_Lens_Traversal.traverseOf(Domination_Data_Game["_player"](v.playerIndex)(Data_Lens_Internal_Wander.wanderStar(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())))(Domination_Data_Player.dropChoice(dictMonadError));
              };
              throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 174, column 3 - line 178, column 62): " + [ v.reaction.constructor.name ]);
          })());
      };
  };
  var purchase = function (dictMonadError) {
      return function (v) {
          var purchase$prime = function (state) {
              return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Supply.getStack(dictMonadError)(v.stackIndex)(state.supply))(function (stack) {
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.modifyPlayer(dictMonadError)(v.playerIndex)(Domination_Data_Player.purchase(stack.card))(state))(Domination_Data_Game.modifyStack(dictMonadError)(v.stackIndex)(Domination_Data_Stack.take));
              });
          };
          return Control_Bind.composeKleisli(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.assertTurn(dictMonadError)(v.playerIndex))(Control_Bind.composeKleisli(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.assertPhase(dictMonadError)(Domination_Data_Phase.BuyPhase.value))(Control_Bind.composeKleisli(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.modifyPlayerM(dictMonadError)(v.playerIndex)(Domination_Data_Player.assertHasBuys(dictMonadError)))(Control_Bind.composeKleisli(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.modifyStackM(dictMonadError)(v.stackIndex)(Domination_Data_Stack.assertNotEmpty(dictMonadError)))(Control_Bind.composeKleisli(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.assertPlayerCanAfford(dictMonadError)(v.playerIndex)(v.stackIndex))(purchase$prime)))));
      };
  };
  var play = function (dictMonadError) {
      return function (dictRandom) {
          return function (v) {
              return function (state) {
                  var targetIndices = function (v1) {
                      return function (v2) {
                          if (v1 instanceof Domination_Data_Target.EveryoneElse) {
                              var $99 = Data_Array.filter(function (v3) {
                                  return v3 !== v2;
                              });
                              var $100 = Util.indices(Data_Array_NonEmpty_Internal.functorWithIndexNonEmptyArray);
                              return function ($101) {
                                  return $99(Data_Array_NonEmpty.toArray($100((function (v3) {
                                      return v3.players;
                                  })($101))));
                              };
                          };
                          if (v1 instanceof Domination_Data_Target.Everyone) {
                              var $102 = Util.indices(Data_Array_NonEmpty_Internal.functorWithIndexNonEmptyArray);
                              return function ($103) {
                                  return Data_Array_NonEmpty.toArray($102((function (v3) {
                                      return v3.players;
                                  })($103)));
                              };
                          };
                          if (v1 instanceof Domination_Data_Target.Self) {
                              return Data_Function["const"]([ v2 ]);
                          };
                          throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 212, column 5 - line 212, column 56): " + [ v1.constructor.name, v2.constructor.name ]);
                      };
                  };
                  var applySpecialToTarget = function (v1) {
                      return function (targetIndex) {
                          return function (state$prime) {
                              return Domination_Data_Game.modifyPlayer(dictMonadError)(targetIndex)(Domination_Data_Player.gainChoice(v1.value0))(state$prime);
                          };
                      };
                  };
                  var applySpecialToTargets = function (attackerIndex) {
                      return function (state$prime) {
                          return function (v1) {
                              return Data_Foldable.foldM(Data_Foldable.foldableArray)((dictMonadError.MonadThrow0()).Monad0())(Data_Function.flip(applySpecialToTarget(v1.command)))(state$prime)(targetIndices(v1.target)(attackerIndex)(state$prime));
                          };
                      };
                  };
                  var applySpecialsToTargets = function (card) {
                      return Data_Function.flip(Data_Foldable.foldM(Data_Foldable.foldableMaybe)((dictMonadError.MonadThrow0()).Monad0())(applySpecialToTargets(v.playerIndex)))(card.special);
                  };
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.getPlayer(dictMonadError)(v.playerIndex)(state))(function (player) {
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Player.getCard(dictMonadError)(v.cardIndex)(player))(function (card) {
                          return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.assertTurn(dictMonadError)(v.playerIndex)(state))(Domination_Data_Game.assertChoicesResolved(dictMonadError)))(Domination_Data_Game.modifyPlayerM(dictMonadError)(v.playerIndex)(Domination_Data_Player.assertHasActions(dictMonadError))))(Domination_Data_Game.modifyPlayerM(dictMonadError)(v.playerIndex)(Domination_Data_Player.play(dictMonadError)(dictRandom)(v.cardIndex))))(applySpecialsToTargets(card));
                      });
                  });
              };
          };
      };
  };
  var nextPhase = function (dictMonadError) {
      return function (dictRandom) {
          return function (playerIndex) {
              return function (state) {
                  var playerUpdate = (function () {
                      if (state.phase instanceof Domination_Data_Phase.CleanupPhase) {
                          return Domination_Data_Player.cleanup(dictMonadError)(dictRandom);
                      };
                      return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0());
                  })();
                  var nextPlayer = function (s) {
                      return {
                          turn: (function () {
                              var $60 = Data_Eq.eq(Domination_Data_Phase.eqPhase)(s.phase)(Domination_Data_Phase.CleanupPhase.value);
                              if ($60) {
                                  return Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(s.turn + 1 | 0)(Data_Foldable.length(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringInt)(s.players));
                              };
                              return s.turn;
                          })(),
                          phase: s.phase,
                          players: s.players,
                          longGame: s.longGame,
                          result: s.result,
                          supply: s.supply,
                          trash: s.trash
                      };
                  };
                  return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.assertTurn(dictMonadError)(playerIndex)(state))(Domination_Data_Game.assertChoicesResolved(dictMonadError)))(Data_Functor.map(Data_Functor.functorFn)(Domination_Data_Game.modifyPlayerM(dictMonadError)(playerIndex)(playerUpdate))((function () {
                      var $104 = Data_Lens_Setter.over(Domination_Data_Game["_phase"](Data_Profunctor_Strong.strongFn))(Domination_Data_Phase.next);
                      return function ($105) {
                          return $104(nextPlayer($105));
                      };
                  })()));
              };
          };
      };
  };
  var gameResult = function (v) {
      var winners = function (currentBest) {
          return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(Data_Array.filter(function ($106) {
              return (function (v1) {
                  return Data_Eq.eq(Domination_Data_Points.eqPoints)(v1)(currentBest);
              })(Domination_Data_Player.score(Data_Tuple.snd($106)));
          })(Data_Array_NonEmpty.toArray(Data_Array_NonEmpty.mapWithIndex(Data_Tuple.Tuple.create)(v.players))));
      };
      var $62 = Data_Foldable.length(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringInt)(v.players) === 1;
      if ($62) {
          return Data_Maybe.Just.create(new Domination_Data_Result.Victory(0));
      };
      return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Foldable.maximum(Domination_Data_Points.ordPoints)(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(Domination_Data_Player.score)(v.players)))(function (currentBest) {
          var winners$prime = winners(currentBest);
          var $63 = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(winners$prime) === 1;
          if ($63) {
              return Data_Functor.map(Data_Maybe.functorMaybe)(Domination_Data_Result.Victory.create)(Data_Array.head(winners$prime));
          };
          return Data_Maybe.Just.create(Domination_Data_Result.Tie.create(winners$prime));
      });
  };
  var finalResult = function (dictMonadError) {
      return function (v) {
          var gameIsOver = function (v1) {
              if (v1 instanceof Domination_Data_Game_Mode.Solo) {
                  return Data_Ord.lessThanOrEq(Domination_Data_Points.ordPoints)(Domination_Data_Supply.positivePoints(v.supply))(Data_Semiring.zero(Domination_Data_Points.ringPoints));
              };
              if (v1 instanceof Domination_Data_Game_Mode.Short) {
                  return Domination_Data_Supply.emptyStackCount(v.supply) >= 3 || (Data_Array.elem(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                      return "count";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "card";
                  }))(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                      return "victoryPoints";
                  }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                      return "types";
                  }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                      return "treasure";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "special";
                  }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                      return "target";
                  }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                      return "description";
                  }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                      return "command";
                  }))(Domination_Data_Card.eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                      return "reaction";
                  }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                      return "name";
                  }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                      return "cost";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "cards";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "buys";
                  }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                      return "actions";
                  }))(Domination_Data_Actions.eqActions)))))(Domination_Data_Stack["new"](Domination_Data_Card["_card"](Domination_Data_Cards.province))(0))(v.supply) || (Data_Array.elem(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                      return "count";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "card";
                  }))(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                      return "victoryPoints";
                  }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                      return "types";
                  }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                      return "treasure";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "special";
                  }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                      return "target";
                  }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                      return "description";
                  }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                      return "command";
                  }))(Domination_Data_Card.eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                      return "reaction";
                  }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                      return "name";
                  }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                      return "cost";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "cards";
                  }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                      return "buys";
                  }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                      return "actions";
                  }))(Domination_Data_Actions.eqActions)))))(Domination_Data_Stack["new"](Domination_Data_Card["_card"](Domination_Data_Cards.colony))(0))(v.supply) || Domination_Data_Supply.highestVictoryCardStackIsEmpty(v.supply)));
              };
              if (v1 instanceof Domination_Data_Game_Mode.Long) {
                  var remainingPoints = Domination_Data_Supply.positivePoints(v.supply);
                  var remainingCurses = Domination_Data_Supply.negativePoints(v.supply);
                  var p1Score = Domination_Data_Player.score(v1.value0);
                  var noRemainingPoints = Data_Eq.eq(Domination_Data_Points.eqPoints)(remainingPoints)(Data_Semiring.zero(Domination_Data_Points.ringPoints)) && Data_Eq.eq(Domination_Data_Points.eqPoints)(remainingCurses)(Data_Semiring.zero(Domination_Data_Points.ringPoints));
                  var currentBest = Data_Ord.max(Domination_Data_Points.ordPoints)(p1Score)(Data_Maybe.fromMaybe(p1Score)(Data_Foldable.maximum(Domination_Data_Points.ordPoints)(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(Domination_Data_Player.score)(v.players))));
                  var worstOutcomeForCurrentLeader = Data_Semiring.add(Domination_Data_Points.ringPoints)(currentBest)(remainingCurses);
                  var bestOutcomeForSecondPlace = Data_Semiring.add(Domination_Data_Points.ringPoints)(Domination_Data_Player.positivePoints(v1.value1))(remainingPoints);
                  var clearWinner = Data_Ord.greaterThan(Domination_Data_Points.ordPoints)(worstOutcomeForCurrentLeader)(bestOutcomeForSecondPlace);
                  return clearWinner || noRemainingPoints;
              };
              throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 257, column 18 - line 279, column 36): " + [ v1.constructor.name ]);
          };
          return Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(function ($107) {
              return (function (v1) {
                  if (v1) {
                      return gameResult(v);
                  };
                  return Data_Maybe.Nothing.value;
              })(gameIsOver($107));
          })(Domination_Data_Game_Mode.mode(dictMonadError)(v));
      };
  };
  var makePlay = function (dictMonadError) {
      return function (dictRandom) {
          return function (dictLog) {
              return function (play$prime) {
                  var maybeGameOver = function (state) {
                      return Control_Apply.apply(((dictLog.Monad0()).Bind1()).Apply0())(Data_Functor.map((((dictLog.Monad0()).Bind1()).Apply0()).Functor0())(Data_Lens_Setter.set(Domination_Data_Game["_result"](Data_Profunctor_Strong.strongFn)))(finalResult(dictMonadError)(state)))(Control_Applicative.pure((dictLog.Monad0()).Applicative0())(state));
                  };
                  return Control_Bind.composeKleisliFlipped((dictLog.Monad0()).Bind1())(maybeGameOver)((function () {
                      if (play$prime instanceof Domination_Data_Play.NewGame) {
                          return Data_Function["const"](setup(dictMonadError)(dictRandom)(Domination_Data_Game["new"](play$prime.value0.playerCount)(play$prime.value0.supply)(play$prime.value0.longGame)));
                      };
                      if (play$prime instanceof Domination_Data_Play.EndPhase) {
                          return nextPhase(dictMonadError)(dictRandom)(play$prime.value0.playerIndex);
                      };
                      if (play$prime instanceof Domination_Data_Play.PlayCard) {
                          return play(dictMonadError)(dictRandom)(play$prime.value0);
                      };
                      if (play$prime instanceof Domination_Data_Play.Purchase) {
                          return purchase(dictMonadError)(play$prime.value0);
                      };
                      if (play$prime instanceof Domination_Data_Play.ResolveChoice) {
                          return Domination_Data_Game_ResolveChoice.resolveChoice(dictMonadError)(dictRandom)(dictLog)(play$prime.value0);
                      };
                      if (play$prime instanceof Domination_Data_Play.React) {
                          return react(dictMonadError)(play$prime.value0);
                      };
                      throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 70, column 36 - line 77, column 21): " + [ play$prime.constructor.name ]);
                  })());
              };
          };
      };
  };
  var choiceTurn = function (state) {
      var players$prime = Util.withIndices(Data_Array_NonEmpty_Internal.functorWithIndexNonEmptyArray)(state.players);
      var v = Data_Array_NonEmpty.span(function ($108) {
          return (function (v1) {
              return v1 !== state.turn;
          })(Data_Tuple.fst($108));
      })(players$prime);
      var rotated = Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.rest)(v.init);
      var withChoices = Data_Array.filter(function ($109) {
          return Domination_Data_Player.hasChoices(Data_Tuple.snd($109));
      })(rotated);
      return Data_Maybe.fromMaybe(0)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.fst)(Data_Array.head(withChoices)));
  };
  var autoAdvance = function (dictMonadError) {
      return function (dictRandom) {
          return function (game) {
              var canAffordSomething = function (player) {
                  var costs = Data_Functor.map(Data_Functor.functorArray)(function (v) {
                      return v.card.cost;
                  })(Domination_Data_Supply.nonEmptyStacks(game.supply));
                  var v = Data_Array.uncons(costs);
                  if (v instanceof Data_Maybe.Nothing) {
                      return false;
                  };
                  if (v instanceof Data_Maybe.Just) {
                      var minCost = Data_Array.foldr(Data_Ord.min(Data_Ord.ordInt))(v.value0.head)(v.value0.tail);
                      return minCost <= Domination_Data_Player.cash(player);
                  };
                  throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 107, column 10 - line 110, column 40): " + [ v.constructor.name ]);
              };
              var advancePhase = nextPhase(dictMonadError)(dictRandom)(game.turn)(game);
              return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(Domination_Data_Game.currentPlayer(dictMonadError)(game))(function (player) {
                  if (game.phase instanceof Domination_Data_Phase.ActionPhase) {
                      var $94 = Domination_Data_Player.hasActions(player) && Domination_Data_Player.hasActionCardsInHand(player);
                      if ($94) {
                          return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(game);
                      };
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(advancePhase)(autoAdvance(dictMonadError)(dictRandom));
                  };
                  if (game.phase instanceof Domination_Data_Phase.BuyPhase) {
                      var $95 = Data_Ord.greaterThan(Domination_Data_Buys.ordBuys)(player.buys)(Data_Semiring.zero(Domination_Data_Buys.ringBuys)) && canAffordSomething(player);
                      if ($95) {
                          return Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0())(game);
                      };
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(advancePhase)(autoAdvance(dictMonadError)(dictRandom));
                  };
                  if (game.phase instanceof Domination_Data_Phase.CleanupPhase) {
                      return Control_Bind.bind(((dictMonadError.MonadThrow0()).Monad0()).Bind1())(advancePhase)(autoAdvance(dictMonadError)(dictRandom));
                  };
                  throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 91, column 3 - line 103, column 35): " + [ game.phase.constructor.name ]);
              });
          };
      };
  };
  var makeAutoPlay = function (dictRandom) {
      return function (dictLog) {
          return function (p) {
              return function (s) {
                  return Control_Monad_Except_Trans.runExceptT(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictLog.Monad0()))(makePlay(Control_Monad_Except_Trans.monadErrorExceptT(dictLog.Monad0()))(Domination_Capability_Random.exceptTStringRandomM(dictRandom))(Domination_Capability_Log.logExceptTString(dictLog))(p)(s))(function (state) {
                      return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictLog.Monad0()))(Control_Monad_Except_Trans.runExceptT(autoAdvance(Control_Monad_Except_Trans.monadErrorExceptT(Control_Monad_Except_Trans.monadExceptT(dictLog.Monad0())))(Domination_Capability_Random.exceptTStringRandomM(Domination_Capability_Random.exceptTStringRandomM(dictRandom)))(state)))(function (eNextState) {
                          return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictLog.Monad0()))((function () {
                              if (eNextState instanceof Data_Either.Left) {
                                  return state;
                              };
                              if (eNextState instanceof Data_Either.Right) {
                                  return eNextState.value0;
                              };
                              throw new Error("Failed pattern match at Domination.Data.Game.Engine (line 58, column 8 - line 60, column 33): " + [ eNextState.constructor.name ]);
                          })());
                      });
                  }));
              };
          };
      };
  };
  exports["makeAutoPlay"] = makeAutoPlay;
  exports["choiceTurn"] = choiceTurn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Result"] = $PS["Domination.Data.Wire.Result"] || {};
  var exports = $PS["Domination.Data.Wire.Result"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Domination_Data_Result = $PS["Domination.Data.Result"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Util = $PS["Util"];                
  var WireVictory = (function () {
      function WireVictory(value0) {
          this.value0 = value0;
      };
      WireVictory.create = function (value0) {
          return new WireVictory(value0);
      };
      return WireVictory;
  })();
  var WireTie = (function () {
      function WireTie(value0) {
          this.value0 = value0;
      };
      WireTie.create = function (value0) {
          return new WireTie(value0);
      };
      return WireTie;
  })();
  var genericWireResult = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireVictory) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof WireTie) {
          return new Data_Generic_Rep.Inr(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Result (line 46, column 1 - line 46, column 58): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireVictory(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr) {
          return new WireTie(x.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Result (line 46, column 1 - line 46, column 58): " + [ x.constructor.name ]);
  });
  var encodeArrayBufferWireResult = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireResult)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))));
  var dynamicByteLengthWireResult = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericWireResult)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))));
  var decodeArrayBufferWireResult = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireResult)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))));
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_Result.Victory) {
              return new WireVictory(Data_Lens_Getter.viewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          };
          if (v instanceof Domination_Data_Result.Tie) {
              return WireTie.create(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0));
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Result (line 31, column 9 - line 35, column 51): " + [ v.constructor.name ]);
      };
      var from = function (v) {
          if (v instanceof WireVictory) {
              return Domination_Data_Result.Victory.create(Util.reviewOn(v.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          };
          if (v instanceof WireTie) {
              return Domination_Data_Result.Tie.create(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value0));
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Result (line 36, column 10 - line 40, column 53): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireResult"] = dynamicByteLengthWireResult;
  exports["encodeArrayBufferWireResult"] = encodeArrayBufferWireResult;
  exports["decodeArrayBufferWireResult"] = decodeArrayBufferWireResult;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Stack"] = $PS["Domination.Data.Wire.Stack"] || {};
  var exports = $PS["Domination.Data.Wire.Stack"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_Wire_Card = $PS["Domination.Data.Wire.Card"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];                
  var _toWire = function (dictProfunctor) {
      var toTuple = function (v) {
          return new Data_Tuple.Tuple(v.card, v.count);
      };
      var to = (function () {
          var $9 = Data_Lens_Setter.over(Domination_Data_Stack["_count"](Data_Profunctor_Strong.strongFn))(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $10 = Data_Lens_Setter.over(Domination_Data_Stack["_card"](Data_Profunctor_Strong.strongFn))(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          return function ($11) {
              return toTuple($9($10($11)));
          };
      })();
      var fromTuple = function (v) {
          return {
              card: v.value0,
              count: v.value1
          };
      };
      var from = (function () {
          var $12 = Data_Lens_Setter.over(Domination_Data_Stack["_count"](Data_Profunctor_Strong.strongFn))(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $13 = Data_Lens_Setter.over(Domination_Data_Stack["_card"](Data_Profunctor_Strong.strongFn))(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          return function ($14) {
              return $12($13(fromTuple($14)));
          };
      })();
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Supply"] = $PS["Domination.Data.Wire.Supply"] || {};
  var exports = $PS["Domination.Data.Wire.Supply"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Domination_Data_Wire_Stack = $PS["Domination.Data.Wire.Stack"];                
  var _toWire = function (dictProfunctor) {
      var to = Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_Stack["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
      var from = Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_Stack["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Game"] = $PS["Domination.Data.Wire.Game"] || {};
  var exports = $PS["Domination.Data.Wire.Game"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Wire_Bonus = $PS["Domination.Data.Wire.Bonus"];
  var Domination_Data_Wire_Card = $PS["Domination.Data.Wire.Card"];
  var Domination_Data_Wire_Choice = $PS["Domination.Data.Wire.Choice"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Domination_Data_Wire_Result = $PS["Domination.Data.Wire.Result"];
  var Domination_Data_Wire_Supply = $PS["Domination.Data.Wire.Supply"];
  var Util = $PS["Util"];                
  var WireGame = (function () {
      function WireGame(value0, value1, value2, value3, value4, value5, value6) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
          this.value6 = value6;
      };
      WireGame.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return function (value6) {
                                  return new WireGame(value0, value1, value2, value3, value4, value5, value6);
                              };
                          };
                      };
                  };
              };
          };
      };
      return WireGame;
  })();
  var genericWireGame = new Data_Generic_Rep.Generic(function (x) {
      return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, x.value6))))));
  }, function (x) {
      return new WireGame(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1);
  });
  var encodeArrayBuffeWireGame = new Data_ArrayBuffer_Class.EncodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireGame)(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Phase.phaseEncodeArrayBuffer))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferNonEmptyArray(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Actions.encodeArrayBufferActions)(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Bonus.encodeArrayBuffeWireBonus))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Buys.encodeArrayBufferBuys)(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Choice.encodeArrayBuffeWireChoice))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Domination_Data_Reaction.encodeArrayBufferReaction))(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))))))))))))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Domination_Data_Wire_Result.encodeArrayBufferWireResult)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean)))))))))(x);
  });
  var dynamicByteLengthWireGame = new Data_ArrayBuffer_Class.DynamicByteLength(function (x) {
      return Data_ArrayBuffer_Class.genericByteLength(genericWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Phase.dynamicByteLengthPhase))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthNonEmptyArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Actions.dynamicByteLengthActions)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))(x);
  });
  var decodeArrayBuffeWireGame = new Data_ArrayBuffer_Class.DecodeArrayBuffer(function (x) {
      return Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireGame)(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Phase.phaseDecodeArrayBuffer))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferNonEmptyArray(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Actions.decodeArrayBufferActions)(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Bonus.decodeArrayBuffeWireBonus)(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Buys.decodeArrayBufferBuys)(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Choice.decodeArrayBuffeWireChoice)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Domination_Data_Reaction.decodeArrayBufferReaction))(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))))))(Domination_Data_Actions.dynamicByteLengthActions)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Actions.dynamicByteLengthActions)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))))))))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Domination_Data_Wire_Result.decodeArrayBufferWireResult)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean))))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthNonEmptyArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Actions.dynamicByteLengthActions)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Phase.dynamicByteLengthPhase))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthNonEmptyArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Actions.dynamicByteLengthActions)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Bonus.dynamicByteLengthWireBonus))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Buys.dynamicByteLengthBuys)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))))))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Wire_Result.dynamicByteLengthWireResult)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))))))(x);
  });
  var _toWire = function (dictProfunctor) {
      var to$prime = function (v) {
          return new WireGame(v.phase, v.players, v.supply, v.trash, v.turn, v.result, v.longGame);
      };
      var to = (function () {
          var $86 = Util.mapOver(Data_Maybe.functorMaybe)(function (dictStrong) {
              return Domination_Data_Game["_result"](dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Result["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $87 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return Domination_Data_Game["_trash"](dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $88 = Data_Lens_Setter.over(Domination_Data_Game["_supply"](Data_Profunctor_Strong.strongFn))(Data_Lens_Getter.view(Domination_Data_Wire_Supply["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $89 = Util.mapOver(Data_NonEmpty.functorNonEmpty(Data_Functor.functorArray))(function (dictStrong) {
              return Domination_Data_Game["_players"](dictStrong);
          })(Data_Lens_Getter.view(Domination_Data_Player["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          var $90 = Data_Lens_Setter.over(Domination_Data_Game["_players"](Data_Profunctor_Strong.strongFn))(Data_Array_NonEmpty.toNonEmpty);
          var $91 = Data_Lens_Setter.over(Domination_Data_Game["_turn"](Data_Profunctor_Strong.strongFn))(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget)));
          return function ($92) {
              return to$prime($86($87($88($89($90($91($92)))))));
          };
      })();
      var from$prime = function (v) {
          return {
              phase: v.value0,
              players: v.value1,
              result: v.value5,
              supply: v.value2,
              trash: v.value3,
              turn: v.value4,
              longGame: v.value6
          };
      };
      var from = (function () {
          var $93 = Util.mapOver(Data_Maybe.functorMaybe)(function (dictStrong) {
              return Domination_Data_Game["_result"](dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Result["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $94 = Util.mapOver(Data_Functor.functorArray)(function (dictStrong) {
              return Domination_Data_Game["_trash"](dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $95 = Data_Lens_Setter.over(Domination_Data_Game["_supply"](Data_Profunctor_Strong.strongFn))(Data_Lens_Prism.review(Domination_Data_Wire_Supply["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $96 = Util.mapOver(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(function (dictStrong) {
              return Domination_Data_Game["_players"](dictStrong);
          })(Data_Lens_Prism.review(Domination_Data_Player["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          var $97 = Data_Lens_Setter.over(Domination_Data_Game["_players"](Data_Profunctor_Strong.strongFn))(Data_Array_NonEmpty.fromNonEmpty);
          var $98 = Data_Lens_Setter.over(Domination_Data_Game["_turn"](Data_Profunctor_Strong.strongFn))(Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
          return function ($99) {
              return $93($94($95($96($97($98(from$prime($99)))))));
          };
      })();
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWireGame"] = dynamicByteLengthWireGame;
  exports["encodeArrayBuffeWireGame"] = encodeArrayBuffeWireGame;
  exports["decodeArrayBuffeWireGame"] = decodeArrayBuffeWireGame;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Data.Wire.Play"] = $PS["Domination.Data.Wire.Play"] || {};
  var exports = $PS["Domination.Data.Wire.Play"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Play = $PS["Domination.Data.Play"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Wire_Card = $PS["Domination.Data.Wire.Card"];
  var Domination_Data_Wire_Choice = $PS["Domination.Data.Wire.Choice"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];                
  var WireNewGame = (function () {
      function WireNewGame(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      WireNewGame.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new WireNewGame(value0, value1, value2);
              };
          };
      };
      return WireNewGame;
  })();
  var WireEndPhase = (function () {
      function WireEndPhase(value0) {
          this.value0 = value0;
      };
      WireEndPhase.create = function (value0) {
          return new WireEndPhase(value0);
      };
      return WireEndPhase;
  })();
  var WirePlayCard = (function () {
      function WirePlayCard(value0) {
          this.value0 = value0;
      };
      WirePlayCard.create = function (value0) {
          return new WirePlayCard(value0);
      };
      return WirePlayCard;
  })();
  var WirePurchase = (function () {
      function WirePurchase(value0) {
          this.value0 = value0;
      };
      WirePurchase.create = function (value0) {
          return new WirePurchase(value0);
      };
      return WirePurchase;
  })();
  var WireResolveChoice = (function () {
      function WireResolveChoice(value0) {
          this.value0 = value0;
      };
      WireResolveChoice.create = function (value0) {
          return new WireResolveChoice(value0);
      };
      return WireResolveChoice;
  })();
  var WireReact = (function () {
      function WireReact(value0) {
          this.value0 = value0;
      };
      WireReact.create = function (value0) {
          return new WireReact(value0);
      };
      return WireReact;
  })();
  var genericWirePlay = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof WireNewGame) {
          return new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)));
      };
      if (x instanceof WireEndPhase) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof WirePlayCard) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof WirePurchase) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof WireResolveChoice) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof WireReact) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Play (line 96, column 1 - line 96, column 54): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new WireNewGame(x.value0.value0, x.value0.value1.value0, x.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new WireEndPhase(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new WirePlayCard(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new WirePurchase(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new WireResolveChoice(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
          return new WireReact(x.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Domination.Data.Wire.Play (line 96, column 1 - line 96, column 54): " + [ x.constructor.name ]);
  });                                                                                                                                                                                                                                             
  var encodeArrayBuffeWirePlay = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWirePlay)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferArray(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferBoolean)))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Domination_Data_Wire_Choice.encodeArrayBuffeWireChoice))))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Domination_Data_Reaction.encodeArrayBufferReaction)))))))))));
  var dynamicByteLengthWirePlay = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction)))))))))));
  var decodeArrayBuffeWirePlay = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWirePlay)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferArray(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferBoolean))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt)))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Choice.decodeArrayBuffeWireChoice)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Domination_Data_Reaction.decodeArrayBufferReaction))(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction)))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthArray(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthBoolean)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Choice.dynamicByteLengthWireChoice))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Domination_Data_Reaction.dynamicByteLengthReaction)))))))))));
  var _toWire = function (dictProfunctor) {
      var to = function (v) {
          if (v instanceof Domination_Data_Play.NewGame) {
              return new WireNewGame(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.playerCount), Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Getter.view(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Forget.profunctorForget)))(v.value0.supply), v.value0.longGame);
          };
          if (v instanceof Domination_Data_Play.EndPhase) {
              return WireEndPhase.create(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.playerIndex));
          };
          if (v instanceof Domination_Data_Play.PlayCard) {
              return WirePlayCard.create(new Data_Tuple.Tuple(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.playerIndex), Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.cardIndex)));
          };
          if (v instanceof Domination_Data_Play.Purchase) {
              return WirePurchase.create(new Data_Tuple.Tuple(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.playerIndex), Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.stackIndex)));
          };
          if (v instanceof Domination_Data_Play.ResolveChoice) {
              return WireResolveChoice.create(new Data_Tuple.Tuple(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.playerIndex), Data_Lens_Getter.view(Domination_Data_Wire_Choice["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.choice)));
          };
          if (v instanceof Domination_Data_Play.React) {
              return WireReact.create(new Data_Tuple.Tuple(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.playerIndex), v.value0.reaction));
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Play (line 36, column 8 - line 57, column 64): " + [ v.constructor.name ]);
      };
      var from = function (v) {
          if (v instanceof WireNewGame) {
              return new Domination_Data_Play.NewGame({
                  playerCount: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0),
                  supply: Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Prism.review(Domination_Data_Wire_Card["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)))(v.value1),
                  longGame: v.value2
              });
          };
          if (v instanceof WireEndPhase) {
              return new Domination_Data_Play.EndPhase({
                  playerIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0)
              });
          };
          if (v instanceof WirePlayCard) {
              return new Domination_Data_Play.PlayCard({
                  playerIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value0),
                  cardIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value1)
              });
          };
          if (v instanceof WirePurchase) {
              return new Domination_Data_Play.Purchase({
                  playerIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value0),
                  stackIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value1)
              });
          };
          if (v instanceof WireResolveChoice) {
              return new Domination_Data_Play.ResolveChoice({
                  playerIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value0),
                  choice: Data_Lens_Prism.review(Domination_Data_Wire_Choice["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value1)
              });
          };
          if (v instanceof WireReact) {
              return new Domination_Data_Play.React({
                  playerIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value0),
                  reaction: v.value0.value1
              });
          };
          throw new Error("Failed pattern match at Domination.Data.Wire.Play (line 58, column 10 - line 86, column 10): " + [ v.constructor.name ]);
      };
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["_toWire"] = _toWire;
  exports["dynamicByteLengthWirePlay"] = dynamicByteLengthWirePlay;
  exports["encodeArrayBuffeWirePlay"] = encodeArrayBuffeWirePlay;
  exports["decodeArrayBuffeWirePlay"] = decodeArrayBuffeWirePlay;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.Env"] = $PS["Domination.Env"] || {};
  var exports = $PS["Domination.Env"];
  var env = {
      wsUrl: "ws://localhost:8080"
  };
  exports["env"] = env;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Css"] = $PS["Domination.UI.Css"] || {};
  var exports = $PS["Domination.UI.Css"];
  var waiting = "waiting";
  var victoryCard = "victory-card";
  var usernameInput = "username-input";
  var undo = "undo";
  var treasureCard = "treasure-card";
  var toolTip = "tool-tip";
  var toggleLongGame = "toggle-long-game";
  var toggle = "toggle";
  var toTrash = "to-trash";
  var toKeep = "to-keep";
  var title = "title";
  var table = "table";
  var supplyToggle = "supply-toggle";
  var supply = "supply";
  var statsContainer = "stats-container";
  var stats = "stats";
  var stat = "stat";
  var stackCount = "stack-count";
  var stackCard = "stack-card";
  var stack = "stack";
  var showing = "showing";
  var settingsMenu = "settings-menu";
  var settingsButton = "settings-button";
  var settings = "settings";
  var serverUrlInput = "server-url-input";
  var resolveChoice = "resolve-choice";
  var reactionCard = "reaction-card";
  var points = "points";
  var playerName = "player-name";
  var playTitle = "play-title";
  var play = "play";
  var nextPhase = "next-phase";
  var newGameButton = "new-game-button";
  var money = "money";
  var loadGameButton = "load-game-button";
  var kingdom = "kingdom";
  var iteration = "iteration";
  var incrementer = "incrementer";
  var inactive = "inactive";
  var icon = "icon";
  var handTitle = "hand-title";
  var handInfos = "hand-infos";
  var handInfo = "hand-info";
  var hand = "hand";
  var drawAttention = "draw-attention";
  var domination = "domination";
  var dialogue = "dialogue";
  var description = "description";
  var curseCard = "curse-card";
  var currentPlayer = "current-player";
  var controls = "controls";
  var connections = "connections";
  var collapsed = "collapsed";
  var cards = "cards";
  var cardVictoryPoints = "card-victory-points";
  var cardTreasure = "card-treasure";
  var cardText = "card-text";
  var cardName = "card-name";
  var cardCost = "card-cost";
  var cardCards = "card-cards";
  var cardBuys = "card-buys";
  var cardActions = "card-actions";
  var card = "card";
  var cantPlay = "cant-play";
  var cantBuy = "cant-buy";
  var canPlay = "can-play";
  var canBuy = "can-buy";
  var buys = "buys";
  var buyingTitle = "buying-title";
  var buying = "buying";
  var backButtonContainer = "back-button-container";
  var backButton = "back-button";
  var attackCard = "attack-card";
  var active = "active";
  var actions = "actions";
  var actionCard = "action-card";
  exports["stats"] = stats;
  exports["stat"] = stat;
  exports["supply"] = supply;
  exports["hand"] = hand;
  exports["table"] = table;
  exports["handTitle"] = handTitle;
  exports["handInfos"] = handInfos;
  exports["handInfo"] = handInfo;
  exports["play"] = play;
  exports["playTitle"] = playTitle;
  exports["buying"] = buying;
  exports["buyingTitle"] = buyingTitle;
  exports["card"] = card;
  exports["curseCard"] = curseCard;
  exports["attackCard"] = attackCard;
  exports["actionCard"] = actionCard;
  exports["reactionCard"] = reactionCard;
  exports["treasureCard"] = treasureCard;
  exports["victoryCard"] = victoryCard;
  exports["cardName"] = cardName;
  exports["cardCards"] = cardCards;
  exports["cardActions"] = cardActions;
  exports["cardBuys"] = cardBuys;
  exports["cardTreasure"] = cardTreasure;
  exports["cardVictoryPoints"] = cardVictoryPoints;
  exports["cardCost"] = cardCost;
  exports["cardText"] = cardText;
  exports["stack"] = stack;
  exports["stackCard"] = stackCard;
  exports["stackCount"] = stackCount;
  exports["active"] = active;
  exports["waiting"] = waiting;
  exports["inactive"] = inactive;
  exports["canBuy"] = canBuy;
  exports["cantBuy"] = cantBuy;
  exports["canPlay"] = canPlay;
  exports["cantPlay"] = cantPlay;
  exports["nextPhase"] = nextPhase;
  exports["resolveChoice"] = resolveChoice;
  exports["toTrash"] = toTrash;
  exports["toKeep"] = toKeep;
  exports["description"] = description;
  exports["toolTip"] = toolTip;
  exports["toggle"] = toggle;
  exports["supplyToggle"] = supplyToggle;
  exports["showing"] = showing;
  exports["collapsed"] = collapsed;
  exports["settingsButton"] = settingsButton;
  exports["backButton"] = backButton;
  exports["backButtonContainer"] = backButtonContainer;
  exports["settingsMenu"] = settingsMenu;
  exports["settings"] = settings;
  exports["usernameInput"] = usernameInput;
  exports["serverUrlInput"] = serverUrlInput;
  exports["connections"] = connections;
  exports["statsContainer"] = statsContainer;
  exports["drawAttention"] = drawAttention;
  exports["kingdom"] = kingdom;
  exports["newGameButton"] = newGameButton;
  exports["loadGameButton"] = loadGameButton;
  exports["toggleLongGame"] = toggleLongGame;
  exports["incrementer"] = incrementer;
  exports["dialogue"] = dialogue;
  exports["domination"] = domination;
  exports["title"] = title;
  exports["playerName"] = playerName;
  exports["iteration"] = iteration;
  exports["controls"] = controls;
  exports["undo"] = undo;
  exports["currentPlayer"] = currentPlayer;
  exports["icon"] = icon;
  exports["actions"] = actions;
  exports["buys"] = buys;
  exports["money"] = money;
  exports["points"] = points;
  exports["cards"] = cards;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.DomSlot"] = $PS["Domination.UI.DomSlot"] || {};
  var exports = $PS["Domination.UI.DomSlot"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];            
  var GameArea = (function () {
      function GameArea() {

      };
      GameArea.value = new GameArea();
      return GameArea;
  })();
  var SupplyArea = (function () {
      function SupplyArea() {

      };
      SupplyArea.value = new SupplyArea();
      return SupplyArea;
  })();
  var AtPlayArea = (function () {
      function AtPlayArea() {

      };
      AtPlayArea.value = new AtPlayArea();
      return AtPlayArea;
  })();
  var BuyingArea = (function () {
      function BuyingArea() {

      };
      BuyingArea.value = new BuyingArea();
      return BuyingArea;
  })();
  var HandArea = (function () {
      function HandArea() {

      };
      HandArea.value = new HandArea();
      return HandArea;
  })();
  var ChoiceArea = (function () {
      function ChoiceArea() {

      };
      ChoiceArea.value = new ChoiceArea();
      return ChoiceArea;
  })();
  var KingdomConfigArea = (function () {
      function KingdomConfigArea() {

      };
      KingdomConfigArea.value = new KingdomConfigArea();
      return KingdomConfigArea;
  })();
  var AreaSlot = (function () {
      function AreaSlot(value0) {
          this.value0 = value0;
      };
      AreaSlot.create = function (value0) {
          return new AreaSlot(value0);
      };
      return AreaSlot;
  })();
  var CardSlot = (function () {
      function CardSlot(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CardSlot.create = function (value0) {
          return function (value1) {
              return new CardSlot(value0, value1);
          };
      };
      return CardSlot;
  })();  
  var eqArea = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof GameArea && y instanceof GameArea) {
              return true;
          };
          if (x instanceof SupplyArea && y instanceof SupplyArea) {
              return true;
          };
          if (x instanceof AtPlayArea && y instanceof AtPlayArea) {
              return true;
          };
          if (x instanceof BuyingArea && y instanceof BuyingArea) {
              return true;
          };
          if (x instanceof HandArea && y instanceof HandArea) {
              return true;
          };
          if (x instanceof ChoiceArea && y instanceof ChoiceArea) {
              return true;
          };
          if (x instanceof KingdomConfigArea && y instanceof KingdomConfigArea) {
              return true;
          };
          return false;
      };
  });
  var eqDomSlot = new Data_Eq.Eq(function (x) {
      return function (y) {
          if (x instanceof AreaSlot && y instanceof AreaSlot) {
              return Data_Eq.eq(eqArea)(x.value0)(y.value0);
          };
          if (x instanceof CardSlot && y instanceof CardSlot) {
              return Data_Eq.eq(eqArea)(x.value0)(y.value0) && x.value1 === y.value1;
          };
          return false;
      };
  });
  var ordArea = new Data_Ord.Ord(function () {
      return eqArea;
  }, function (x) {
      return function (y) {
          if (x instanceof GameArea && y instanceof GameArea) {
              return Data_Ordering.EQ.value;
          };
          if (x instanceof GameArea) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof GameArea) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof SupplyArea && y instanceof SupplyArea) {
              return Data_Ordering.EQ.value;
          };
          if (x instanceof SupplyArea) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof SupplyArea) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof AtPlayArea && y instanceof AtPlayArea) {
              return Data_Ordering.EQ.value;
          };
          if (x instanceof AtPlayArea) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof AtPlayArea) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof BuyingArea && y instanceof BuyingArea) {
              return Data_Ordering.EQ.value;
          };
          if (x instanceof BuyingArea) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof BuyingArea) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof HandArea && y instanceof HandArea) {
              return Data_Ordering.EQ.value;
          };
          if (x instanceof HandArea) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof HandArea) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof ChoiceArea && y instanceof ChoiceArea) {
              return Data_Ordering.EQ.value;
          };
          if (x instanceof ChoiceArea) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof ChoiceArea) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof KingdomConfigArea && y instanceof KingdomConfigArea) {
              return Data_Ordering.EQ.value;
          };
          throw new Error("Failed pattern match at Domination.UI.DomSlot (line 39, column 1 - line 39, column 36): " + [ x.constructor.name, y.constructor.name ]);
      };
  });
  var ordDomSlot = new Data_Ord.Ord(function () {
      return eqDomSlot;
  }, function (x) {
      return function (y) {
          if (x instanceof AreaSlot && y instanceof AreaSlot) {
              return Data_Ord.compare(ordArea)(x.value0)(y.value0);
          };
          if (x instanceof AreaSlot) {
              return Data_Ordering.LT.value;
          };
          if (y instanceof AreaSlot) {
              return Data_Ordering.GT.value;
          };
          if (x instanceof CardSlot && y instanceof CardSlot) {
              var v = Data_Ord.compare(ordArea)(x.value0)(y.value0);
              if (v instanceof Data_Ordering.LT) {
                  return Data_Ordering.LT.value;
              };
              if (v instanceof Data_Ordering.GT) {
                  return Data_Ordering.GT.value;
              };
              return Data_Ord.compare(Data_Ord.ordInt)(x.value1)(y.value1);
          };
          throw new Error("Failed pattern match at Domination.UI.DomSlot (line 24, column 1 - line 24, column 42): " + [ x.constructor.name, y.constructor.name ]);
      };
  });
  exports["AreaSlot"] = AreaSlot;
  exports["CardSlot"] = CardSlot;
  exports["GameArea"] = GameArea;
  exports["SupplyArea"] = SupplyArea;
  exports["AtPlayArea"] = AtPlayArea;
  exports["BuyingArea"] = BuyingArea;
  exports["HandArea"] = HandArea;
  exports["ChoiceArea"] = ChoiceArea;
  exports["KingdomConfigArea"] = KingdomConfigArea;
  exports["ordDomSlot"] = ordDomSlot;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Query.Input"] = $PS["Halogen.Query.Input"] || {};
  var exports = $PS["Halogen.Query.Input"];
  var Data_Functor = $PS["Data.Functor"];
  var RefUpdate = (function () {
      function RefUpdate(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      RefUpdate.create = function (value0) {
          return function (value1) {
              return new RefUpdate(value0, value1);
          };
      };
      return RefUpdate;
  })();
  var Action = (function () {
      function Action(value0) {
          this.value0 = value0;
      };
      Action.create = function (value0) {
          return new Action(value0);
      };
      return Action;
  })();
  var functorInput = new Data_Functor.Functor(function (f) {
      return function (m) {
          if (m instanceof RefUpdate) {
              return new RefUpdate(m.value0, m.value1);
          };
          if (m instanceof Action) {
              return new Action(f(m.value0));
          };
          throw new Error("Failed pattern match at Halogen.Query.Input (line 19, column 1 - line 19, column 46): " + [ m.constructor.name ]);
      };
  });
  exports["RefUpdate"] = RefUpdate;
  exports["Action"] = Action;
  exports["functorInput"] = functorInput;
})(PS);
(function(exports) {
  "use strict";

  exports.typeOf = function (value) {
    return typeof value;
  };

  exports.tagOf = function (value) {
    return Object.prototype.toString.call(value).slice(8, -1);
  };
})(PS["Foreign"] = PS["Foreign"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Foreign"] = $PS["Foreign"] || {};
  var exports = $PS["Foreign"];
  var $foreign = $PS["Foreign"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_List_NonEmpty = $PS["Data.List.NonEmpty"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var TypeMismatch = (function () {
      function TypeMismatch(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      TypeMismatch.create = function (value0) {
          return function (value1) {
              return new TypeMismatch(value0, value1);
          };
      };
      return TypeMismatch;
  })();
  var unsafeToForeign = Unsafe_Coerce.unsafeCoerce;
  var unsafeFromForeign = Unsafe_Coerce.unsafeCoerce;
  var fail = function (dictMonad) {
      var $118 = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(dictMonad));
      return function ($119) {
          return $118(Data_List_NonEmpty.singleton($119));
      };
  };
  var unsafeReadTagged = function (dictMonad) {
      return function (tag) {
          return function (value) {
              if ($foreign.tagOf(value) === tag) {
                  return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad))(unsafeFromForeign(value));
              };
              if (Data_Boolean.otherwise) {
                  return fail(dictMonad)(new TypeMismatch(tag, $foreign.tagOf(value)));
              };
              throw new Error("Failed pattern match at Foreign (line 110, column 1 - line 110, column 71): " + [ tag.constructor.name, value.constructor.name ]);
          };
      };
  };
  var readBoolean = function (dictMonad) {
      return unsafeReadTagged(dictMonad)("Boolean");
  };
  var readString = function (dictMonad) {
      return unsafeReadTagged(dictMonad)("String");
  };
  exports["TypeMismatch"] = TypeMismatch;
  exports["unsafeToForeign"] = unsafeToForeign;
  exports["readString"] = readString;
  exports["readBoolean"] = readBoolean;
  exports["fail"] = fail;
  exports["typeOf"] = $foreign.typeOf;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.Machine"] = $PS["Halogen.VDom.Machine"] || {};
  var exports = $PS["Halogen.VDom.Machine"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var Step = (function () {
      function Step(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Step.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Step(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Step;
  })();
  var unStep = Unsafe_Coerce.unsafeCoerce;
  var step = function (v, a) {
      return v.value2(v.value1, a);
  };
  var mkStep = Unsafe_Coerce.unsafeCoerce;
  var halt = function (v) {
      return v.value3(v.value1);
  };
  var extract = unStep(function (v) {
      return v.value0;
  });
  exports["Step"] = Step;
  exports["mkStep"] = mkStep;
  exports["unStep"] = unStep;
  exports["extract"] = extract;
  exports["step"] = step;
  exports["halt"] = halt;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeGetAny = function (key, obj) {
    return obj[key];
  };

  exports.unsafeHasAny = function (key, obj) {
    return obj.hasOwnProperty(key);
  };

  exports.unsafeSetAny = function (key, val, obj) {
      obj[key] = val;
  };

  exports.forE = function (a, f) {
    var b = [];
    for (var i = 0; i < a.length; i++) {
      b.push(f(i, a[i]));
    }
    return b;
  };

  exports.forEachE = function (a, f) {
    for (var i = 0; i < a.length; i++) {
      f(a[i]);
    }
  };

  exports.forInE = function (o, f) {
    var ks = Object.keys(o);
    for (var i = 0; i < ks.length; i++) {
      var k = ks[i];
      f(k, o[k]);
    }
  };

  exports.diffWithIxE = function (a1, a2, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a2.length;
    var i  = 0;
    while (1) {
      if (i < l1) {
        if (i < l2) {
          a3.push(f1(i, a1[i], a2[i]));
        } else {
          f2(i, a1[i]);
        }
      } else if (i < l2) {
        a3.push(f3(i, a2[i]));
      } else {
        break;
      }
      i++;
    }
    return a3;
  };

  exports.strMapWithIxE = function (as, fk, f) {
    var o = {};
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      var k = fk(a);
      o[k] = f(k, i, a);
    }
    return o;
  };

  exports.diffWithKeyAndIxE = function (o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      var k = fk(a);
      if (o1.hasOwnProperty(k)) {
        o2[k] = f1(k, i, o1[k], a);
      } else {
        o2[k] = f3(k, i, a);
      }
    }
    for (var k in o1) {
      if (k in o2) {
        continue;
      }
      f2(k, o1[k]);
    }
    return o2;
  };

  exports.refEq = function (a, b) {
    return a === b;
  };

  exports.createTextNode = function (s, doc) {
    return doc.createTextNode(s);
  };

  exports.setTextContent = function (s, n) {
    n.textContent = s;
  };

  exports.createElement = function (ns, name, doc) {
    if (ns != null) {
      return doc.createElementNS(ns, name);
    } else {
      return doc.createElement(name)
    }
  };

  exports.insertChildIx = function (i, a, b) {
    var n = b.childNodes.item(i) || null;
    if (n !== a) {
      b.insertBefore(a, n);
    }
  };

  exports.removeChild = function (a, b) {
    if (b && a.parentNode === b) {
      b.removeChild(a);
    }
  };

  exports.parentNode = function (a) {
    return a.parentNode;
  };

  exports.setAttribute = function (ns, attr, val, el) {
    if (ns != null) {
      el.setAttributeNS(ns, attr, val);
    } else {
      el.setAttribute(attr, val);
    }
  };

  exports.removeAttribute = function (ns, attr, el) {
    if (ns != null) {
      el.removeAttributeNS(ns, attr);
    } else {
      el.removeAttribute(attr);
    }
  };

  exports.hasAttribute = function (ns, attr, el) {
    if (ns != null) {
      return el.hasAttributeNS(ns, attr);
    } else {
      return el.hasAttribute(attr);
    }
  };

  exports.addEventListener = function (ev, listener, el) {
    el.addEventListener(ev, listener, false);
  };

  exports.removeEventListener = function (ev, listener, el) {
    el.removeEventListener(ev, listener, false);
  };

  exports.jsUndefined = void 0;
})(PS["Halogen.VDom.Util"] = PS["Halogen.VDom.Util"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.Util"] = $PS["Halogen.VDom.Util"] || {};
  var exports = $PS["Halogen.VDom.Util"];
  var $foreign = $PS["Halogen.VDom.Util"];
  var Foreign_Object_ST = $PS["Foreign.Object.ST"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var unsafeLookup = $foreign.unsafeGetAny;
  var unsafeFreeze = Unsafe_Coerce.unsafeCoerce;
  var pokeMutMap = $foreign.unsafeSetAny;
  var newMutMap = Foreign_Object_ST["new"];
  exports["newMutMap"] = newMutMap;
  exports["pokeMutMap"] = pokeMutMap;
  exports["unsafeFreeze"] = unsafeFreeze;
  exports["unsafeLookup"] = unsafeLookup;
  exports["unsafeGetAny"] = $foreign.unsafeGetAny;
  exports["unsafeHasAny"] = $foreign.unsafeHasAny;
  exports["unsafeSetAny"] = $foreign.unsafeSetAny;
  exports["forE"] = $foreign.forE;
  exports["forEachE"] = $foreign.forEachE;
  exports["forInE"] = $foreign.forInE;
  exports["diffWithIxE"] = $foreign.diffWithIxE;
  exports["diffWithKeyAndIxE"] = $foreign.diffWithKeyAndIxE;
  exports["strMapWithIxE"] = $foreign.strMapWithIxE;
  exports["refEq"] = $foreign.refEq;
  exports["createTextNode"] = $foreign.createTextNode;
  exports["setTextContent"] = $foreign.setTextContent;
  exports["createElement"] = $foreign.createElement;
  exports["insertChildIx"] = $foreign.insertChildIx;
  exports["removeChild"] = $foreign.removeChild;
  exports["parentNode"] = $foreign.parentNode;
  exports["setAttribute"] = $foreign.setAttribute;
  exports["removeAttribute"] = $foreign.removeAttribute;
  exports["hasAttribute"] = $foreign.hasAttribute;
  exports["addEventListener"] = $foreign.addEventListener;
  exports["removeEventListener"] = $foreign.removeEventListener;
  exports["jsUndefined"] = $foreign.jsUndefined;
})(PS);
(function(exports) {
  "use strict";

  exports.eventListener = function (fn) {
    return function () {
      return function (event) {
        return fn(event)();
      };
    };
  };

  exports.addEventListener = function (type) {
    return function (listener) {
      return function (useCapture) {
        return function (target) {
          return function () {
            return target.addEventListener(type, listener, useCapture);
          };
        };
      };
    };
  };

  exports.removeEventListener = function (type) {
    return function (listener) {
      return function (useCapture) {
        return function (target) {
          return function () {
            return target.removeEventListener(type, listener, useCapture);
          };
        };
      };
    };
  };
})(PS["Web.Event.EventTarget"] = PS["Web.Event.EventTarget"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.Event.EventTarget"] = $PS["Web.Event.EventTarget"] || {};
  var exports = $PS["Web.Event.EventTarget"];
  var $foreign = $PS["Web.Event.EventTarget"];
  exports["eventListener"] = $foreign.eventListener;
  exports["addEventListener"] = $foreign.addEventListener;
  exports["removeEventListener"] = $foreign.removeEventListener;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.DOM.Prop"] = $PS["Halogen.VDom.DOM.Prop"] || {};
  var exports = $PS["Halogen.VDom.DOM.Prop"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Foreign = $PS["Foreign"];
  var Foreign_Object = $PS["Foreign.Object"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Util = $PS["Halogen.VDom.Util"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Web_Event_EventTarget = $PS["Web.Event.EventTarget"];                
  var Created = (function () {
      function Created(value0) {
          this.value0 = value0;
      };
      Created.create = function (value0) {
          return new Created(value0);
      };
      return Created;
  })();
  var Removed = (function () {
      function Removed(value0) {
          this.value0 = value0;
      };
      Removed.create = function (value0) {
          return new Removed(value0);
      };
      return Removed;
  })();
  var Attribute = (function () {
      function Attribute(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      Attribute.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new Attribute(value0, value1, value2);
              };
          };
      };
      return Attribute;
  })();
  var Property = (function () {
      function Property(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Property.create = function (value0) {
          return function (value1) {
              return new Property(value0, value1);
          };
      };
      return Property;
  })();
  var Handler = (function () {
      function Handler(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Handler.create = function (value0) {
          return function (value1) {
              return new Handler(value0, value1);
          };
      };
      return Handler;
  })();
  var Ref = (function () {
      function Ref(value0) {
          this.value0 = value0;
      };
      Ref.create = function (value0) {
          return new Ref(value0);
      };
      return Ref;
  })();
  var unsafeGetProperty = Halogen_VDom_Util.unsafeGetAny;
  var setProperty = Halogen_VDom_Util.unsafeSetAny;
  var removeProperty = function (key, el) {
      var v = Halogen_VDom_Util.hasAttribute(Data_Nullable["null"], key, el);
      if (v) {
          return Halogen_VDom_Util.removeAttribute(Data_Nullable["null"], key, el);
      };
      var v1 = Foreign.typeOf(Halogen_VDom_Util.unsafeGetAny(key, el));
      if (v1 === "string") {
          return Halogen_VDom_Util.unsafeSetAny(key, "", el);
      };
      if (key === "rowSpan") {
          return Halogen_VDom_Util.unsafeSetAny(key, 1, el);
      };
      if (key === "colSpan") {
          return Halogen_VDom_Util.unsafeSetAny(key, 1, el);
      };
      return Halogen_VDom_Util.unsafeSetAny(key, Halogen_VDom_Util.jsUndefined, el);
  };
  var propToStrKey = function (v) {
      if (v instanceof Attribute && v.value0 instanceof Data_Maybe.Just) {
          return "attr/" + (v.value0.value0 + (":" + v.value1));
      };
      if (v instanceof Attribute) {
          return "attr/:" + v.value1;
      };
      if (v instanceof Property) {
          return "prop/" + v.value0;
      };
      if (v instanceof Handler) {
          return "handler/" + v.value0;
      };
      if (v instanceof Ref) {
          return "ref";
      };
      throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [ v.constructor.name ]);
  };
  var propFromString = Unsafe_Coerce.unsafeCoerce;
  var propFromNumber = Unsafe_Coerce.unsafeCoerce;
  var propFromBoolean = Unsafe_Coerce.unsafeCoerce;
  var functorProp = new Data_Functor.Functor(function (v) {
      return function (v1) {
          if (v1 instanceof Handler) {
              return new Handler(v1.value0, Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Data_Maybe.functorMaybe)(v))(v1.value1));
          };
          if (v1 instanceof Ref) {
              return new Ref(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Data_Maybe.functorMaybe)(v))(v1.value0));
          };
          return v1;
      };
  });
  var buildProp = function (emit) {
      return function (el) {
          var removeProp = function (prevEvents) {
              return function (v, v1) {
                  if (v1 instanceof Attribute) {
                      return Halogen_VDom_Util.removeAttribute(Data_Nullable.toNullable(v1.value0), v1.value1, el);
                  };
                  if (v1 instanceof Property) {
                      return removeProperty(v1.value0, el);
                  };
                  if (v1 instanceof Handler) {
                      var handler = Halogen_VDom_Util.unsafeLookup(v1.value0, prevEvents);
                      return Halogen_VDom_Util.removeEventListener(v1.value0, Data_Tuple.fst(handler), el);
                  };
                  if (v1 instanceof Ref) {
                      return Data_Unit.unit;
                  };
                  throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [ v1.constructor.name ]);
              };
          };
          var mbEmit = function (v) {
              if (v instanceof Data_Maybe.Just) {
                  return emit(v.value0)();
              };
              return Data_Unit.unit;
          };
          var haltProp = function (state) {
              var v = Foreign_Object.lookup("ref")(state.props);
              if (v instanceof Data_Maybe.Just && v.value0 instanceof Ref) {
                  return mbEmit(v.value0.value0(new Removed(el)));
              };
              return Data_Unit.unit;
          };
          var diffProp = function (prevEvents, events) {
              return function (v, v1, v11, v2) {
                  if (v11 instanceof Attribute && v2 instanceof Attribute) {
                      var $57 = v11.value2 === v2.value2;
                      if ($57) {
                          return v2;
                      };
                      Halogen_VDom_Util.setAttribute(Data_Nullable.toNullable(v2.value0), v2.value1, v2.value2, el);
                      return v2;
                  };
                  if (v11 instanceof Property && v2 instanceof Property) {
                      var v4 = Halogen_VDom_Util.refEq(v11.value1, v2.value1);
                      if (v4) {
                          return v2;
                      };
                      if (v2.value0 === "value") {
                          var elVal = unsafeGetProperty("value", el);
                          var $66 = Halogen_VDom_Util.refEq(elVal, v2.value1);
                          if ($66) {
                              return v2;
                          };
                          setProperty(v2.value0, v2.value1, el);
                          return v2;
                      };
                      setProperty(v2.value0, v2.value1, el);
                      return v2;
                  };
                  if (v11 instanceof Handler && v2 instanceof Handler) {
                      var handler = Halogen_VDom_Util.unsafeLookup(v2.value0, prevEvents);
                      Effect_Ref.write(v2.value1)(Data_Tuple.snd(handler))();
                      Halogen_VDom_Util.pokeMutMap(v2.value0, handler, events);
                      return v2;
                  };
                  return v2;
              };
          };
          var applyProp = function (events) {
              return function (v, v1, v2) {
                  if (v2 instanceof Attribute) {
                      Halogen_VDom_Util.setAttribute(Data_Nullable.toNullable(v2.value0), v2.value1, v2.value2, el);
                      return v2;
                  };
                  if (v2 instanceof Property) {
                      setProperty(v2.value0, v2.value1, el);
                      return v2;
                  };
                  if (v2 instanceof Handler) {
                      var v3 = Halogen_VDom_Util.unsafeGetAny(v2.value0, events);
                      if (Halogen_VDom_Util.unsafeHasAny(v2.value0, events)) {
                          Effect_Ref.write(v2.value1)(Data_Tuple.snd(v3))();
                          return v2;
                      };
                      var ref = Effect_Ref["new"](v2.value1)();
                      var listener = Web_Event_EventTarget.eventListener(function (ev) {
                          return function __do() {
                              var f$prime = Effect_Ref.read(ref)();
                              return mbEmit(f$prime(ev));
                          };
                      })();
                      Halogen_VDom_Util.pokeMutMap(v2.value0, new Data_Tuple.Tuple(listener, ref), events);
                      Halogen_VDom_Util.addEventListener(v2.value0, listener, el);
                      return v2;
                  };
                  if (v2 instanceof Ref) {
                      mbEmit(v2.value0(new Created(el)));
                      return v2;
                  };
                  throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [ v2.constructor.name ]);
              };
          };
          var patchProp = function (state, ps2) {
              var events = Halogen_VDom_Util.newMutMap();
              var onThis = removeProp(state.events);
              var onThese = diffProp(state.events, events);
              var onThat = applyProp(events);
              var props = Halogen_VDom_Util.diffWithKeyAndIxE(state.props, ps2, propToStrKey, onThese, onThis, onThat);
              var nextState = {
                  events: Halogen_VDom_Util.unsafeFreeze(events),
                  props: props
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Data_Unit.unit, nextState, patchProp, haltProp));
          };
          var renderProp = function (ps1) {
              var events = Halogen_VDom_Util.newMutMap();
              var ps1$prime = Halogen_VDom_Util.strMapWithIxE(ps1, propToStrKey, applyProp(events));
              var state = {
                  events: Halogen_VDom_Util.unsafeFreeze(events),
                  props: ps1$prime
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Data_Unit.unit, state, patchProp, haltProp));
          };
          return renderProp;
      };
  };
  exports["Attribute"] = Attribute;
  exports["Property"] = Property;
  exports["Handler"] = Handler;
  exports["propFromString"] = propFromString;
  exports["propFromBoolean"] = propFromBoolean;
  exports["propFromNumber"] = propFromNumber;
  exports["buildProp"] = buildProp;
  exports["functorProp"] = functorProp;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.Types"] = $PS["Halogen.VDom.Types"] || {};
  var exports = $PS["Halogen.VDom.Types"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Text = (function () {
      function Text(value0) {
          this.value0 = value0;
      };
      Text.create = function (value0) {
          return new Text(value0);
      };
      return Text;
  })();
  var Elem = (function () {
      function Elem(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Elem.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Elem(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Elem;
  })();
  var Keyed = (function () {
      function Keyed(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Keyed.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Keyed(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Keyed;
  })();
  var Widget = (function () {
      function Widget(value0) {
          this.value0 = value0;
      };
      Widget.create = function (value0) {
          return new Widget(value0);
      };
      return Widget;
  })();
  var Grafted = (function () {
      function Grafted(value0) {
          this.value0 = value0;
      };
      Grafted.create = function (value0) {
          return new Grafted(value0);
      };
      return Grafted;
  })();
  var Graft = (function () {
      function Graft(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      Graft.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new Graft(value0, value1, value2);
              };
          };
      };
      return Graft;
  })();
  var unGraft = function (f) {
      return function ($55) {
          return f($55);
      };
  }; 
  var graft = Unsafe_Coerce.unsafeCoerce;
  var bifunctorGraft = new Data_Bifunctor.Bifunctor(function (f) {
      return function (g) {
          return unGraft(function (v) {
              return graft(new Graft(function ($57) {
                  return f(v.value0($57));
              }, function ($58) {
                  return g(v.value1($58));
              }, v.value2));
          });
      };
  });
  var bifunctorVDom = new Data_Bifunctor.Bifunctor(function (v) {
      return function (v1) {
          return function (v2) {
              if (v2 instanceof Text) {
                  return new Text(v2.value0);
              };
              if (v2 instanceof Grafted) {
                  return new Grafted(Data_Bifunctor.bimap(bifunctorGraft)(v)(v1)(v2.value0));
              };
              return new Grafted(graft(new Graft(v, v1, v2)));
          };
      };
  });
  var runGraft = unGraft(function (v) {
      var go = function (v2) {
          if (v2 instanceof Text) {
              return new Text(v2.value0);
          };
          if (v2 instanceof Elem) {
              return new Elem(v2.value0, v2.value1, v.value0(v2.value2), Data_Functor.map(Data_Functor.functorArray)(go)(v2.value3));
          };
          if (v2 instanceof Keyed) {
              return new Keyed(v2.value0, v2.value1, v.value0(v2.value2), Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(go))(v2.value3));
          };
          if (v2 instanceof Widget) {
              return new Widget(v.value1(v2.value0));
          };
          if (v2 instanceof Grafted) {
              return new Grafted(Data_Bifunctor.bimap(bifunctorGraft)(v.value0)(v.value1)(v2.value0));
          };
          throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [ v2.constructor.name ]);
      };
      return go(v.value2);
  });
  exports["Text"] = Text;
  exports["Elem"] = Elem;
  exports["Keyed"] = Keyed;
  exports["Widget"] = Widget;
  exports["Grafted"] = Grafted;
  exports["runGraft"] = runGraft;
  exports["bifunctorVDom"] = bifunctorVDom;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.HTML.Core"] = $PS["Halogen.HTML.Core"] || {};
  var exports = $PS["Halogen.HTML.Core"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Functor = $PS["Data.Functor"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Halogen_VDom_DOM_Prop = $PS["Halogen.VDom.DOM.Prop"];
  var Halogen_VDom_Types = $PS["Halogen.VDom.Types"];          
  var IsProp = function (toPropValue) {
      this.toPropValue = toPropValue;
  };
  var HTML = function (x) {
      return x;
  };
  var widget = function ($18) {
      return HTML(Halogen_VDom_Types.Widget.create($18));
  };
  var toPropValue = function (dict) {
      return dict.toPropValue;
  };
  var text = function ($19) {
      return HTML(Halogen_VDom_Types.Text.create($19));
  };
  var prop = function (dictIsProp) {
      return function (v) {
          var $21 = Halogen_VDom_DOM_Prop.Property.create(v);
          var $22 = toPropValue(dictIsProp);
          return function ($23) {
              return $21($22($23));
          };
      };
  }; 
  var isPropString = new IsProp(Halogen_VDom_DOM_Prop.propFromString);
  var isPropNumber = new IsProp(Halogen_VDom_DOM_Prop.propFromNumber);
  var isPropInputType = new IsProp(function ($37) {
      return Halogen_VDom_DOM_Prop.propFromString(DOM_HTML_Indexed_InputType.renderInputType($37));
  });
  var isPropBoolean = new IsProp(Halogen_VDom_DOM_Prop.propFromBoolean);
  var handler = Halogen_VDom_DOM_Prop.Handler.create;
  var element = function (ns) {
      return function (name) {
          return function (props) {
              return function (children) {
                  return new Halogen_VDom_Types.Elem(ns, name, props, children);
              };
          };
      };
  };
  var bifunctorHTML = new Data_Bifunctor.Bifunctor(function (f) {
      return function (g) {
          return function (v) {
              return Data_Bifunctor.bimap(Halogen_VDom_Types.bifunctorVDom)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Halogen_VDom_DOM_Prop.functorProp)(Data_Functor.map(Halogen_Query_Input.functorInput)(g))))(f)(v);
          };
      };
  });                                                                            
  var attr = function (ns) {
      return function (v) {
          return Halogen_VDom_DOM_Prop.Attribute.create(ns)(v);
      };
  };
  exports["widget"] = widget;
  exports["text"] = text;
  exports["element"] = element;
  exports["prop"] = prop;
  exports["attr"] = attr;
  exports["handler"] = handler;
  exports["bifunctorHTML"] = bifunctorHTML;
  exports["isPropString"] = isPropString;
  exports["isPropNumber"] = isPropNumber;
  exports["isPropBoolean"] = isPropBoolean;
  exports["isPropInputType"] = isPropInputType;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.HTML.Elements"] = $PS["Halogen.HTML.Elements"] || {};
  var exports = $PS["Halogen.HTML.Elements"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var element = Halogen_HTML_Core.element(Data_Maybe.Nothing.value);
  var h1 = element("h1");
  var h1_ = h1([  ]);
  var h2 = element("h2");
  var h2_ = h2([  ]);        
  var hr = function (props) {
      return element("hr")(props)([  ]);
  };
  var hr_ = hr([  ]);    
  var i = element("i");
  var input = function (props) {
      return element("input")(props)([  ]);
  };                   
  var label = element("label");
  var label_ = label([  ]);  
  var li = element("li");
  var main = element("main");
  var main_ = main([  ]);    
  var p = element("p");
  var p_ = p([  ]);
  var span = element("span");
  var span_ = span([  ]);
  var ul = element("ul");
  var ul_ = ul([  ]);
  var div = element("div");
  var div_ = div([  ]);
  var button = element("button");
  exports["button"] = button;
  exports["div"] = div;
  exports["div_"] = div_;
  exports["h1"] = h1;
  exports["h1_"] = h1_;
  exports["h2_"] = h2_;
  exports["hr_"] = hr_;
  exports["i"] = i;
  exports["input"] = input;
  exports["label"] = label;
  exports["label_"] = label_;
  exports["li"] = li;
  exports["main_"] = main_;
  exports["p_"] = p_;
  exports["span"] = span;
  exports["span_"] = span_;
  exports["ul"] = ul;
  exports["ul_"] = ul_;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.HTML.Properties"] = $PS["Halogen.HTML.Properties"] || {};
  var exports = $PS["Halogen.HTML.Properties"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_String_Common = $PS["Data.String.Common"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var prop = function (dictIsProp) {
      return Halogen_HTML_Core.prop(dictIsProp);
  };                                                    
  var required = prop(Halogen_HTML_Core.isPropBoolean)("required");
  var type_ = function (dictIsProp) {
      return prop(dictIsProp)("type");
  };
  var value = prop(Halogen_HTML_Core.isPropString)("value");  
  var placeholder = prop(Halogen_HTML_Core.isPropString)("placeholder");
  var min = prop(Halogen_HTML_Core.isPropNumber)("min");          
  var max = prop(Halogen_HTML_Core.isPropNumber)("max");   
  var id = prop(Halogen_HTML_Core.isPropString)("id");            
  var disabled = prop(Halogen_HTML_Core.isPropBoolean)("disabled");
  var classes = (function () {
      var $12 = prop(Halogen_HTML_Core.isPropString)("className");
      var $13 = Data_String_Common.joinWith(" ");
      var $14 = Data_Functor.map(Data_Functor.functorArray)(Data_Newtype.unwrap());
      return function ($15) {
          return $12($13($14($15)));
      };
  })();
  var class_ = (function () {
      var $16 = prop(Halogen_HTML_Core.isPropString)("className");
      var $17 = Data_Newtype.unwrap();
      return function ($18) {
          return $16($17($18));
      };
  })();
  var checked = prop(Halogen_HTML_Core.isPropBoolean)("checked");
  var attr = Halogen_HTML_Core.attr(Data_Maybe.Nothing.value);
  exports["attr"] = attr;
  exports["class_"] = class_;
  exports["classes"] = classes;
  exports["id"] = id;
  exports["type_"] = type_;
  exports["value"] = value;
  exports["min"] = min;
  exports["max"] = max;
  exports["disabled"] = disabled;
  exports["required"] = required;
  exports["checked"] = checked;
  exports["placeholder"] = placeholder;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Icons"] = $PS["Domination.UI.Icons"] || {};
  var exports = $PS["Domination.UI.Icons"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];                
  var icon = function (i) {
      return Halogen_HTML_Elements.i([ Halogen_HTML_Properties.classes([ Domination_UI_Css.icon, i ]) ])([  ]);
  };
  var money = icon(Domination_UI_Css.money);
  var points = icon(Domination_UI_Css.points);
  var settings = icon(Domination_UI_Css.settings);
  var empty = Halogen_HTML_Elements.i([ Halogen_HTML_Properties.classes([ Domination_UI_Css.icon ]) ])([  ]);
  var cards = icon(Domination_UI_Css.cards);
  var buys = icon(Domination_UI_Css.buys);
  var actions = icon(Domination_UI_Css.actions);
  exports["empty"] = empty;
  exports["actions"] = actions;
  exports["buys"] = buys;
  exports["cards"] = cards;
  exports["money"] = money;
  exports["points"] = points;
  exports["settings"] = settings;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeReadPropImpl = function (f, s, key, value) {
    return value == null ? f : s(value[key]);
  };
})(PS["Foreign.Index"] = PS["Foreign.Index"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Foreign.Index"] = $PS["Foreign.Index"] || {};
  var exports = $PS["Foreign.Index"];
  var $foreign = $PS["Foreign.Index"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Foreign = $PS["Foreign"];
  var unsafeReadProp = function (dictMonad) {
      return function (k) {
          return function (value) {
              return $foreign.unsafeReadPropImpl(Foreign.fail(dictMonad)(new Foreign.TypeMismatch("object", Foreign.typeOf(value))), Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad)), k, value);
          };
      };
  };
  var readProp = function (dictMonad) {
      return unsafeReadProp(dictMonad);
  };
  exports["readProp"] = readProp;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML.Event.EventTypes"] = $PS["Web.HTML.Event.EventTypes"] || {};
  var exports = $PS["Web.HTML.Event.EventTypes"];
  var input = "input";
  var domcontentloaded = "DOMContentLoaded";
  var change = "change";
  exports["change"] = change;
  exports["domcontentloaded"] = domcontentloaded;
  exports["input"] = input;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.UIEvent.KeyboardEvent.EventTypes"] = $PS["Web.UIEvent.KeyboardEvent.EventTypes"] || {};
  var exports = $PS["Web.UIEvent.KeyboardEvent.EventTypes"];
  var keydown = "keydown";
  exports["keydown"] = keydown;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.UIEvent.MouseEvent.EventTypes"] = $PS["Web.UIEvent.MouseEvent.EventTypes"] || {};
  var exports = $PS["Web.UIEvent.MouseEvent.EventTypes"];
  var click = "click";
  exports["click"] = click;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.HTML.Events"] = $PS["Halogen.HTML.Events"] || {};
  var exports = $PS["Halogen.HTML.Events"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Except = $PS["Control.Monad.Except"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Identity = $PS["Data.Identity"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Foreign = $PS["Foreign"];
  var Foreign_Index = $PS["Foreign.Index"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Web_Event_Event = $PS["Web.Event.Event"];
  var Web_HTML_Event_EventTypes = $PS["Web.HTML.Event.EventTypes"];
  var Web_UIEvent_KeyboardEvent_EventTypes = $PS["Web.UIEvent.KeyboardEvent.EventTypes"];
  var Web_UIEvent_MouseEvent_EventTypes = $PS["Web.UIEvent.MouseEvent.EventTypes"];
  var mouseHandler = Unsafe_Coerce.unsafeCoerce;
  var keyHandler = Unsafe_Coerce.unsafeCoerce;
  var handler$prime = function (et) {
      return function (f) {
          return Halogen_HTML_Core.handler(et)(function (ev) {
              return Data_Functor.map(Data_Maybe.functorMaybe)(Halogen_Query_Input.Action.create)(f(ev));
          });
      };
  };
  var handler = function (et) {
      return function (f) {
          return Halogen_HTML_Core.handler(et)(function (ev) {
              return new Data_Maybe.Just(new Halogen_Query_Input.Action(f(ev)));
          });
      };
  };                                                       
  var onClick = (function () {
      var $1 = handler(Web_UIEvent_MouseEvent_EventTypes.click);
      return function ($2) {
          return $1(mouseHandler($2));
      };
  })();                                                      
  var onKeyDown = (function () {
      var $9 = handler(Web_UIEvent_KeyboardEvent_EventTypes.keydown);
      return function ($10) {
          return $9(keyHandler($10));
      };
  })();
  var addForeignPropHandler = function (key) {
      return function (prop) {
          return function (reader) {
              return function (f) {
                  var go = function (a) {
                      return Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(reader)(Foreign_Index.readProp(Data_Identity.monadIdentity)(prop))(Foreign.unsafeToForeign(a));
                  };
                  return handler$prime(key)(Control_Bind.composeKleisli(Data_Maybe.bindMaybe)(Web_Event_Event.currentTarget)(function (e) {
                      return Data_Either.either(Data_Function["const"](Data_Maybe.Nothing.value))(function ($71) {
                          return Data_Maybe.Just.create(f($71));
                      })(Control_Monad_Except.runExcept(go(e)));
                  }));
              };
          };
      };
  };
  var onChecked = addForeignPropHandler(Web_HTML_Event_EventTypes.change)("checked")(Foreign.readBoolean(Data_Identity.monadIdentity)); 
  var onValueInput = addForeignPropHandler(Web_HTML_Event_EventTypes.input)("value")(Foreign.readString(Data_Identity.monadIdentity));
  exports["handler"] = handler;
  exports["onClick"] = onClick;
  exports["onKeyDown"] = onKeyDown;
  exports["onValueInput"] = onValueInput;
  exports["onChecked"] = onChecked;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Util"] = $PS["Domination.UI.Util"] || {};
  var exports = $PS["Domination.UI.Util"];
  var Data_Array = $PS["Data.Array"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Show = $PS["Data.Show"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];                
  var incrementer = function (v) {
      return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("container") ])([ Halogen_HTML_Elements.label_([ Halogen_HTML_Core.text(v.label) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.incrementer) ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
          if (v.mbMin instanceof Data_Maybe.Just) {
              var $8 = v.value <= v.mbMin.value0;
              if ($8) {
                  return v.setValue(v.mbMin.value0);
              };
              return v.setValue(v.value - 1 | 0);
          };
          if (v.mbMin instanceof Data_Maybe.Nothing) {
              return v.setValue(v.value - 1 | 0);
          };
          throw new Error("Failed pattern match at Domination.UI.Util (line 63, column 26 - line 68, column 40): " + [ v.mbMin.constructor.name ]);
      }) ])([ Halogen_HTML_Core.text("-") ]), Halogen_HTML_Elements.input(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Properties.value(Data_Show.show(Data_Show.showInt)(v.value)), Halogen_HTML_Properties.required(true), Halogen_HTML_Properties.disabled(true) ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
          if (v.mbMin instanceof Data_Maybe.Just) {
              return [ Halogen_HTML_Properties.min(Data_Int.toNumber(v.mbMin.value0)) ];
          };
          if (v.mbMin instanceof Data_Maybe.Nothing) {
              return [  ];
          };
          throw new Error("Failed pattern match at Domination.UI.Util (line 75, column 10 - line 77, column 22): " + [ v.mbMin.constructor.name ]);
      })())((function () {
          if (v.mbMin instanceof Data_Maybe.Just) {
              return [ Halogen_HTML_Properties.max(Data_Int.toNumber(v.mbMin.value0)) ];
          };
          if (v.mbMin instanceof Data_Maybe.Nothing) {
              return [  ];
          };
          throw new Error("Failed pattern match at Domination.UI.Util (line 78, column 10 - line 80, column 22): " + [ v.mbMin.constructor.name ]);
      })()))), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
          if (v.mbMax instanceof Data_Maybe.Just) {
              var $15 = v.value >= v.mbMax.value0;
              if ($15) {
                  return v.setValue(v.mbMax.value0);
              };
              return v.setValue(v.value + 1 | 0);
          };
          if (v.mbMax instanceof Data_Maybe.Nothing) {
              return v.setValue(v.value + 1 | 0);
          };
          throw new Error("Failed pattern match at Domination.UI.Util (line 82, column 28 - line 87, column 40): " + [ v.mbMax.constructor.name ]);
      }) ])([ Halogen_HTML_Core.text("+") ]) ]) ]);
  };
  var h2__ = function (text) {
      return Halogen_HTML_Elements.h2_([ Halogen_HTML_Core.text(text) ]);
  };
  var h1__ = function (text) {
      return Halogen_HTML_Elements.h1_([ Halogen_HTML_Core.text(text) ]);
  };
  var chooseOne = function (title) {
      return function (buttons) {
          var makeButton = function (v) {
              return Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return v.clickEvent;
              }) ])([ v.text ]);
          };
          return Halogen_HTML_Elements.div_(Data_Array.cons(title)(Data_Functor.map(Data_Functor.functorArray)(makeButton)(buttons)));
      };
  };
  var acknowledge = function (message) {
      return function (clickEvent) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.dialogue) ])([ Halogen_HTML_Elements.div_([ message ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v) {
              return clickEvent;
          }) ])([ Halogen_HTML_Core.text("OK") ]) ]);
      };
  };
  exports["chooseOne"] = chooseOne;
  exports["acknowledge"] = acknowledge;
  exports["incrementer"] = incrementer;
  exports["h1__"] = h1__;
  exports["h2__"] = h2__;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.RenderText"] = $PS["Domination.UI.RenderText"] || {};
  var exports = $PS["Domination.UI.RenderText"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Array = $PS["Data.Array"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Index = $PS["Data.Lens.Index"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Show = $PS["Data.Show"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Condition = $PS["Domination.Data.Condition"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Filter = $PS["Domination.Data.Filter"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Result = $PS["Domination.Data.Result"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Domination_UI_Icons = $PS["Domination.UI.Icons"];
  var Domination_UI_Util = $PS["Domination.UI.Util"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Util = $PS["Util"];                
  var RenderTextInContext = function (renderTextInContext) {
      this.renderTextInContext = renderTextInContext;
  };
  var RenderText = function (renderText) {
      this.renderText = renderText;
  };
  var victoryPointsRenderText = new RenderText(function (points) {
      return Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(Data_Lens_Getter.viewOn(points)(Domination_Data_Points["_int"](Data_Lens_Internal_Forget.profunctorForget)))), Domination_UI_Icons.points ]);
  });
  var versionRenderText = new RenderText(function (v) {
      return Halogen_HTML_Core.text("v" + Data_Array.intercalate(Data_Monoid.monoidString)(".")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(Data_Show.showInt))([ v.value0, v.value1, v.value2 ])));
  });
  var resultRenderText = new RenderText(function (result) {
      return Domination_UI_Util.h2__((function () {
          if (result instanceof Domination_Data_Result.Victory) {
              return "Victory: Player " + Data_Show.show(Data_Show.showInt)(result.value0 + 1 | 0);
          };
          if (result instanceof Domination_Data_Result.Tie) {
              return "Tie: Players " + Data_Array.intercalate(Data_Monoid.monoidString)(", ")(Data_Functor.map(Data_Functor.functorArray)((function () {
                  var $126 = Data_Show.show(Data_Show.showInt);
                  return function ($127) {
                      return $126((function (v) {
                          return v + 1 | 0;
                      })($127));
                  };
              })())(result.value0));
          };
          throw new Error("Failed pattern match at Domination.UI.RenderText (line 59, column 28 - line 63, column 83): " + [ result.constructor.name ]);
      })());
  });
  var renderTextInContext = function (dict) {
      return dict.renderTextInContext;
  };
  var renderText = function (dict) {
      return dict.renderText;
  };
  var reactionRenderText = new RenderText(function (v) {
      return Halogen_HTML_Core.text("When another player plays an Attack card" + ", you may first reveal this from your hand, to be unaffected by it.");
  });
  var phaseRenderText = new RenderText(function (v) {
      if (v instanceof Domination_Data_Phase.ActionPhase) {
          return Domination_UI_Icons.actions;
      };
      if (v instanceof Domination_Data_Phase.BuyPhase) {
          return Domination_UI_Icons.buys;
      };
      if (v instanceof Domination_Data_Phase.CleanupPhase) {
          return Domination_UI_Icons.cards;
      };
      throw new Error("Failed pattern match at Domination.UI.RenderText (line 70, column 17 - line 73, column 32): " + [ v.constructor.name ]);
  });
  var parenthesize = function (s) {
      return [ Halogen_HTML_Core.text("("), s, Halogen_HTML_Core.text(")") ];
  };
  var getCardName = function (source) {
      return function (playerIndex) {
          return function (state) {
              return function (cardIndex) {
                  return Halogen_HTML_Core.text(Data_Maybe.fromMaybe("???")(Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
                      return v.name;
                  })(Data_Lens_Fold.previewOn(state)((function () {
                      var $128 = Domination_Data_Game["_pile"](source)(playerIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
                      var $129 = Domination_Data_Stack["_stacksToCardsIso"](Data_Lens_Internal_Forget.profunctorForget);
                      var $130 = Data_Lens_Index.ix(Data_Lens_Index.indexArray)(cardIndex)(Data_Lens_Internal_Forget.strongForget)(Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
                      return function ($131) {
                          return $128($129($130($131)));
                      };
                  })()))));
              };
          };
      };
  };
  var conditionRenderText = new RenderText(function (condition) {
      return Halogen_HTML_Core.text((function () {
          if (condition instanceof Domination_Data_Condition.HasCard) {
              return "hand contains " + condition.value0;
          };
          if (condition instanceof Domination_Data_Condition.HasCardType) {
              return "hand contains a card of type " + Data_Show.show(Domination_Data_CardType.showCardType)(condition.value0);
          };
          if (condition instanceof Domination_Data_Condition.HasDiscard) {
              return "discard pile is not empty";
          };
          if (condition instanceof Domination_Data_Condition.DiscardContains) {
              return "discard contains " + condition.value0;
          };
          if (condition instanceof Domination_Data_Condition.DiscardContainsCardType) {
              return "discard contains a card of type " + Data_Show.show(Domination_Data_CardType.showCardType)(condition.value0);
          };
          if (condition instanceof Domination_Data_Condition.TrashContainsCardType) {
              return "trash contains a card of type " + Data_Show.show(Domination_Data_CardType.showCardType)(condition.value0);
          };
          if (condition instanceof Domination_Data_Condition.Randomly) {
              var percentString = Data_Show.show(Data_Show.showInt)(Util.reviewOn(condition.value0)(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor)));
              return "randomly (" + (percentString + "% chance)");
          };
          throw new Error("Failed pattern match at Domination.UI.RenderText (line 107, column 36 - line 119, column 54): " + [ condition.constructor.name ]);
      })());
  });
  var buysRenderText = new RenderText(function (buy) {
      return Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(Data_Lens_Getter.viewOn(buy)(Domination_Data_Buys["_int"](Data_Lens_Internal_Forget.profunctorForget)))), Domination_UI_Icons.buys ]);
  });
  var bonusRenderText = new RenderText(function (bonus) {
      return Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text("+" + Data_Show.show(Data_Show.showInt)(bonus.value0)), Domination_UI_Icons.money ]);
  });
  var actionsRenderText = new RenderText(function (actions) {
      return Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(Data_Lens_Getter.viewOn(actions)(Domination_Data_Actions["_int"](Data_Lens_Internal_Forget.profunctorForget)))), Domination_UI_Icons.actions ]);
  });
  var choiceRenderText = new RenderText(function (choice) {
      return Halogen_HTML_Elements.span_((function () {
          if (choice instanceof Domination_Data_Choice.StackChoice) {
              return [ Halogen_HTML_Core.text(choice.value0.description) ];
          };
          if (choice instanceof Domination_Data_Choice.If) {
              return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("If ("), renderText(conditionRenderText)(choice.value0.condition), Halogen_HTML_Core.text(") then ("), renderText(choiceRenderText)(choice.value0.choice), Halogen_HTML_Core.text(")") ])((function () {
                  if (choice.value0.otherwise instanceof Data_Maybe.Nothing) {
                      return [  ];
                  };
                  if (choice.value0.otherwise instanceof Data_Maybe.Just) {
                      return [ Halogen_HTML_Core.text(" otherwise ("), renderText(choiceRenderText)(choice.value0.otherwise.value0), Halogen_HTML_Core.text(")") ];
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 218, column 12 - line 221, column 64): " + [ choice.value0.otherwise.constructor.name ]);
              })());
          };
          if (choice instanceof Domination_Data_Choice.And) {
              return Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(" and ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                  var $132 = renderText(choiceRenderText);
                  return function ($133) {
                      return parenthesize($132($133));
                  };
              })())(choice.value0.choices));
          };
          if (choice instanceof Domination_Data_Choice.Or) {
              return Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(" or ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                  var $134 = renderText(choiceRenderText);
                  return function ($135) {
                      return parenthesize($134($135));
                  };
              })())(choice.value0.choices));
          };
          if (choice instanceof Domination_Data_Choice.PickN) {
              return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(choice.value0.n) + " of: ") ])(Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(" or ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                  var $136 = Control_Applicative.pure(Control_Applicative.applicativeArray);
                  var $137 = renderText(choiceRenderText);
                  return function ($138) {
                      return $136($137($138));
                  };
              })())(choice.value0.choices)));
          };
          if (choice instanceof Domination_Data_Choice.Option) {
              return [ Halogen_HTML_Core.text("optionally "), renderText(choiceRenderText)(choice.value0.choice) ];
          };
          if (choice instanceof Domination_Data_Choice.MoveFromTo) {
              var verb = (function () {
                  if (choice.value0.destination instanceof Domination_Data_Pile.AtPlay) {
                      return "Play";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Hand) {
                      return "Gain to your hand";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Discard) {
                      return "Discard";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Buying) {
                      return "Buy";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Discarding) {
                      return "Discard";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Deck) {
                      return "Put onto your deck";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Trash) {
                      return "Trash";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Supply) {
                      return "Put into the supply";
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 262, column 16 - line 270, column 47): " + [ choice.value0.destination.constructor.name ]);
              })();
              var suffix = (function () {
                  if (choice.value0.source instanceof Domination_Data_Pile.AtPlay) {
                      return "from at play";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Hand) {
                      return "from your hand";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Discard) {
                      return "from your discard pile";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Buying) {
                      return "from your buying pile";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Discarding) {
                      return "from your to-discard pile";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Deck) {
                      return "from your deck";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Trash) {
                      return "from the trash";
                  };
                  if (choice.value0.source instanceof Domination_Data_Pile.Supply) {
                      return "from the supply";
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 253, column 18 - line 261, column 43): " + [ choice.value0.source.constructor.name ]);
              })();
              var description = function (v) {
                  if (v instanceof Domination_Data_Filter.HasName) {
                      return v.value0;
                  };
                  if (v instanceof Domination_Data_Filter.HasType) {
                      return Data_Show.show(Domination_Data_CardType.showCardType)(v.value0);
                  };
                  if (v instanceof Domination_Data_Filter.CostUpTo) {
                      return "cards costing up to " + Data_Show.show(Data_Show.showInt)(v.value0);
                  };
                  if (v instanceof Domination_Data_Filter.Any) {
                      return "card(s)";
                  };
                  if (v instanceof Domination_Data_Filter.And) {
                      return description(v.value0) + (" and " + description(v.value1));
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 247, column 23 - line 252, column 74): " + [ v.constructor.name ]);
              };
              var makeText = function (condition) {
                  return Halogen_HTML_Core.text(Data_Array.intercalate(Data_Monoid.monoidString)(" ")([ verb, condition, description(choice.value0.filter), suffix ]));
              };
              if (choice.value0.n instanceof Domination_Data_Constraint.UpTo) {
                  return [ makeText("up to " + Data_Show.show(Data_Show.showInt)(choice.value0.n.value0)) ];
              };
              if (choice.value0.n instanceof Domination_Data_Constraint.Exactly) {
                  return [ makeText("exactly " + Data_Show.show(Data_Show.showInt)(choice.value0.n.value0)) ];
              };
              if (choice.value0.n instanceof Domination_Data_Constraint.DownTo) {
                  return [ makeText("down to " + Data_Show.show(Data_Show.showInt)(choice.value0.n.value0)) ];
              };
              if (choice.value0.n instanceof Domination_Data_Constraint.Unlimited) {
                  return [ makeText("any number of") ];
              };
              throw new Error("Failed pattern match at Domination.UI.RenderText (line 239, column 54 - line 243, column 48): " + [ choice.value0.n.constructor.name ]);
          };
          if (choice instanceof Domination_Data_Choice.GainCards) {
              return [ Halogen_HTML_Core.text("Gain " + (choice.value0.cardName + (" x" + Data_Show.show(Data_Show.showInt)(choice.value0.n)))) ];
          };
          if (choice instanceof Domination_Data_Choice.GainCard) {
              var verb = (function () {
                  if (choice.value0.destination instanceof Domination_Data_Pile.AtPlay) {
                      return "Play";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Hand) {
                      return "Gain to your hand";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Discard) {
                      return "Gain";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Buying) {
                      return "Buy";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Discarding) {
                      return "Gain";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Deck) {
                      return "Gain onto your deck";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Trash) {
                      return "Trash";
                  };
                  if (choice.value0.destination instanceof Domination_Data_Pile.Supply) {
                      return "Put into the supply";
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 277, column 16 - line 285, column 47): " + [ choice.value0.destination.constructor.name ]);
              })();
              var card = function (v) {
                  if (v instanceof Domination_Data_Filter.HasName) {
                      return "1 " + v.value0;
                  };
                  if (v instanceof Domination_Data_Filter.HasType) {
                      return "a card of type " + Data_Show.show(Domination_Data_CardType.showCardType)(v.value0);
                  };
                  if (v instanceof Domination_Data_Filter.CostUpTo) {
                      return "cards costing up to " + Data_Show.show(Data_Show.showInt)(v.value0);
                  };
                  if (v instanceof Domination_Data_Filter.Any) {
                      return "a card";
                  };
                  if (v instanceof Domination_Data_Filter.And) {
                      return card(v.value0) + (" and " + card(v.value1));
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 286, column 16 - line 291, column 60): " + [ v.constructor.name ]);
              };
              return [ Halogen_HTML_Core.text(verb + (" " + (card(choice.value0.filter) + " from the supply"))) ];
          };
          if (choice instanceof Domination_Data_Choice.GainActions) {
              return [ Halogen_HTML_Core.text("+"), renderText(actionsRenderText)(choice.value0.n) ];
          };
          if (choice instanceof Domination_Data_Choice.GainBuys) {
              return [ Halogen_HTML_Core.text("+"), renderText(buysRenderText)(choice.value0.n) ];
          };
          if (choice instanceof Domination_Data_Choice.GainBonus) {
              return [ renderText(bonusRenderText)(choice.value0.bonus) ];
          };
          if (choice instanceof Domination_Data_Choice.Discard) {
              return [ Halogen_HTML_Core.text("Discard your hand") ];
          };
          if (choice instanceof Domination_Data_Choice.Draw) {
              return [ Halogen_HTML_Core.text("+" + Data_Show.show(Data_Show.showInt)(choice.value0.n)), Domination_UI_Icons.cards ];
          };
          throw new Error("Failed pattern match at Domination.UI.RenderText (line 209, column 32 - line 303, column 59): " + [ choice.constructor.name ]);
      })());
  });
  var choiceRenderTextInContext = new RenderTextInContext(function (playerIndex) {
      return function (state) {
          return function (c) {
              var unresolved = Halogen_HTML_Core.text("unresolved choice? (" + (Data_Show.show(Domination_Data_Choice.showChoice)(c) + ")"));
              return Halogen_HTML_Elements.span_((function () {
                  if (c instanceof Domination_Data_Choice.StackChoice) {
                      return [ Halogen_HTML_Core.text(c.value0.description) ];
                  };
                  if (c instanceof Domination_Data_Choice.If) {
                      return [ Halogen_HTML_Core.text("if "), renderText(conditionRenderText)(c.value0.condition), Halogen_HTML_Core.text(" then "), renderText(choiceRenderText)(c.value0.choice) ];
                  };
                  if (c instanceof Domination_Data_Choice.And) {
                      return Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(" and ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                          var $139 = Control_Applicative.pure(Control_Applicative.applicativeArray);
                          var $140 = renderText(choiceRenderText);
                          return function ($141) {
                              return $139($140($141));
                          };
                      })())(c.value0.choices));
                  };
                  if (c instanceof Domination_Data_Choice.Or) {
                      return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("chose one of: ") ])(Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(", ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                          var $142 = Control_Applicative.pure(Control_Applicative.applicativeArray);
                          var $143 = renderText(choiceRenderText);
                          return function ($144) {
                              return $142($143($144));
                          };
                      })())(c.value0.choices)));
                  };
                  if (c instanceof Domination_Data_Choice.PickN) {
                      return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("chose " + (Data_Show.show(Data_Show.showInt)(c.value0.n) + " of: ")) ])(Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(", ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                          var $145 = Control_Applicative.pure(Control_Applicative.applicativeArray);
                          var $146 = renderText(choiceRenderText);
                          return function ($147) {
                              return $145($146($147));
                          };
                      })())(c.value0.choices)));
                  };
                  if (c instanceof Domination_Data_Choice.Option) {
                      return [ Halogen_HTML_Core.text("chose to optionally "), renderText(choiceRenderText)(c.value0.choice) ];
                  };
                  if (c instanceof Domination_Data_Choice.MoveFromTo && c.value0.resolution instanceof Data_Maybe.Just) {
                      var cards = Data_Array.intercalate(Data_Monoid.monoidArray)([ Halogen_HTML_Core.text(", ") ])(Data_Functor.map(Data_Functor.functorArray)((function () {
                          var $148 = Control_Applicative.pure(Control_Applicative.applicativeArray);
                          var $149 = getCardName(c.value0.source)(playerIndex)(state);
                          return function ($150) {
                              return $148($149($150));
                          };
                      })())(c.value0.resolution.value0));
                      var gainedCardsToTheir = function (pile) {
                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("gained: ") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(cards)([ Halogen_HTML_Core.text(" to their " + pile) ]));
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Supply) {
                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("returned to supply: ") ])(cards);
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Trash) {
                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("trashed: ") ])(cards);
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Discard) {
                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("discarded: ") ])(cards);
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Discarding) {
                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("will discard: ") ])(cards);
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Hand) {
                          return gainedCardsToTheir("hand");
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Deck) {
                          return gainedCardsToTheir("deck");
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.AtPlay) {
                          return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("played: ") ])(cards);
                      };
                      if (c.value0.destination instanceof Domination_Data_Pile.Buying) {
                          return gainedCardsToTheir("buying pile");
                      };
                      throw new Error("Failed pattern match at Domination.UI.RenderText (line 153, column 9 - line 161, column 58): " + [ c.value0.destination.constructor.name ]);
                  };
                  if (c instanceof Domination_Data_Choice.GainCards) {
                      return [ Halogen_HTML_Core.text("gain a card " + (Data_Show.show(Data_Show.showInt)(c.value0.n) + ("x " + c.value0.cardName))) ];
                  };
                  if (c instanceof Domination_Data_Choice.GainCard && c.value0.resolution instanceof Data_Maybe.Just) {
                      var suffix = (function () {
                          if (c.value0.destination instanceof Domination_Data_Pile.AtPlay) {
                              return " to play";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Hand) {
                              return " to their hand";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Discard) {
                              return " to their discard pile";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Discarding) {
                              return " to their discarding pile";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Buying) {
                              return " to their buying pile";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Deck) {
                              return " onto their deck";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Trash) {
                              return " into the trash for some reason";
                          };
                          if (c.value0.destination instanceof Domination_Data_Pile.Supply) {
                              return " into the supply for some reason";
                          };
                          throw new Error("Failed pattern match at Domination.UI.RenderText (line 176, column 20 - line 184, column 62): " + [ c.value0.destination.constructor.name ]);
                      })();
                      return [ Halogen_HTML_Core.text("gained a " + (c.value0.resolution.value0 + (" " + suffix))) ];
                  };
                  if (c instanceof Domination_Data_Choice.GainActions) {
                      return [ Halogen_HTML_Core.text("+"), renderText(actionsRenderText)(c.value0.n) ];
                  };
                  if (c instanceof Domination_Data_Choice.GainBuys) {
                      return [ Halogen_HTML_Core.text("gained +"), renderText(buysRenderText)(c.value0.n) ];
                  };
                  if (c instanceof Domination_Data_Choice.GainBonus) {
                      return [ Halogen_HTML_Core.text("gained"), renderText(bonusRenderText)(c.value0.bonus) ];
                  };
                  if (c instanceof Domination_Data_Choice.Discard) {
                      return [ Halogen_HTML_Core.text("discarded their hand") ];
                  };
                  if (c instanceof Domination_Data_Choice.Draw) {
                      return [ Halogen_HTML_Core.text("+" + Data_Show.show(Data_Show.showInt)(c.value0.n)), Domination_UI_Icons.cards ];
                  };
                  if (c instanceof Domination_Data_Choice.MoveFromTo && c.value0.resolution instanceof Data_Maybe.Nothing) {
                      return [ unresolved ];
                  };
                  if (c instanceof Domination_Data_Choice.GainCard && c.value0.resolution instanceof Data_Maybe.Nothing) {
                      return [ unresolved ];
                  };
                  throw new Error("Failed pattern match at Domination.UI.RenderText (line 124, column 14 - line 203, column 57): " + [ c.constructor.name ]);
              })());
          };
      };
  });
  exports["renderText"] = renderText;
  exports["renderTextInContext"] = renderTextInContext;
  exports["resultRenderText"] = resultRenderText;
  exports["versionRenderText"] = versionRenderText;
  exports["phaseRenderText"] = phaseRenderText;
  exports["reactionRenderText"] = reactionRenderText;
  exports["actionsRenderText"] = actionsRenderText;
  exports["buysRenderText"] = buysRenderText;
  exports["victoryPointsRenderText"] = victoryPointsRenderText;
  exports["choiceRenderTextInContext"] = choiceRenderTextInContext;
  exports["choiceRenderText"] = choiceRenderText;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Query.HalogenQ"] = $PS["Halogen.Query.HalogenQ"] || {};
  var exports = $PS["Halogen.Query.HalogenQ"];           
  var Initialize = (function () {
      function Initialize(value0) {
          this.value0 = value0;
      };
      Initialize.create = function (value0) {
          return new Initialize(value0);
      };
      return Initialize;
  })();
  var Finalize = (function () {
      function Finalize(value0) {
          this.value0 = value0;
      };
      Finalize.create = function (value0) {
          return new Finalize(value0);
      };
      return Finalize;
  })();
  var Receive = (function () {
      function Receive(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Receive.create = function (value0) {
          return function (value1) {
              return new Receive(value0, value1);
          };
      };
      return Receive;
  })();
  var Action = (function () {
      function Action(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Action.create = function (value0) {
          return function (value1) {
              return new Action(value0, value1);
          };
      };
      return Action;
  })();
  var Query = (function () {
      function Query(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Query.create = function (value0) {
          return function (value1) {
              return new Query(value0, value1);
          };
      };
      return Query;
  })();
  exports["Initialize"] = Initialize;
  exports["Finalize"] = Finalize;
  exports["Receive"] = Receive;
  exports["Action"] = Action;
  exports["Query"] = Query;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.DOM.Element"] = $PS["Web.DOM.Element"] || {};
  var exports = $PS["Web.DOM.Element"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                   
  var toNode = Unsafe_Coerce.unsafeCoerce;
  exports["toNode"] = toNode;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.DOM"] = $PS["Halogen.VDom.DOM"] || {};
  var exports = $PS["Halogen.VDom.DOM"];
  var Data_Array = $PS["Data.Array"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Types = $PS["Halogen.VDom.Types"];
  var Halogen_VDom_Util = $PS["Halogen.VDom.Util"];
  var Web_DOM_Element = $PS["Web.DOM.Element"];
  var haltWidget = function (v) {
      return Halogen_VDom_Machine.halt(v.widget);
  };
  var patchWidget = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchWidget(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Widget) {
          var res = Halogen_VDom_Machine.step(state.widget, vdom.value0);
          var res$prime = Halogen_VDom_Machine.unStep(function (v) {
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(v.value0, {
                  build: state.build,
                  widget: res
              }, patchWidget, haltWidget));
          })(res);
          return res$prime;
      };
      haltWidget(state);
      return state.build(vdom);
  };
  var haltText = function (v) {
      var parent = Halogen_VDom_Util.parentNode(v.node);
      return Halogen_VDom_Util.removeChild(v.node, parent);
  };
  var patchText = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchText(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Text) {
          if (state.value === vdom.value0) {
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, state, patchText, haltText));
          };
          if (Data_Boolean.otherwise) {
              var nextState = {
                  build: state.build,
                  node: state.node,
                  value: vdom.value0
              };
              Halogen_VDom_Util.setTextContent(vdom.value0, state.node);
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchText, haltText));
          };
      };
      haltText(state);
      return state.build(vdom);
  };
  var haltKeyed = function (v) {
      var parent = Halogen_VDom_Util.parentNode(v.node);
      Halogen_VDom_Util.removeChild(v.node, parent);
      Halogen_VDom_Util.forInE(v.children, function (v1, s) {
          return Halogen_VDom_Machine.halt(s);
      });
      return Halogen_VDom_Machine.halt(v.attrs);
  };
  var haltElem = function (v) {
      var parent = Halogen_VDom_Util.parentNode(v.node);
      Halogen_VDom_Util.removeChild(v.node, parent);
      Halogen_VDom_Util.forEachE(v.children, Halogen_VDom_Machine.halt);
      return Halogen_VDom_Machine.halt(v.attrs);
  };
  var eqElemSpec = function (ns1, v, ns2, v1) {
      var $58 = v === v1;
      if ($58) {
          if (ns1 instanceof Data_Maybe.Just && (ns2 instanceof Data_Maybe.Just && ns1.value0 === ns2.value0)) {
              return true;
          };
          if (ns1 instanceof Data_Maybe.Nothing && ns2 instanceof Data_Maybe.Nothing) {
              return true;
          };
          return false;
      };
      return false;
  };
  var patchElem = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchElem(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Elem && eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
          var v = Data_Array.length(vdom.value3);
          var v1 = Data_Array.length(state.children);
          if (v1 === 0 && v === 0) {
              var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
              var nextState = {
                  build: state.build,
                  node: state.node,
                  attrs: attrs2,
                  ns: vdom.value0,
                  name: vdom.value1,
                  children: state.children
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchElem, haltElem));
          };
          var onThis = function (v2, s) {
              return Halogen_VDom_Machine.halt(s);
          };
          var onThese = function (ix, s, v2) {
              var res = Halogen_VDom_Machine.step(s, v2);
              Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var onThat = function (ix, v2) {
              var res = state.build(v2);
              Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var children2 = Halogen_VDom_Util.diffWithIxE(state.children, vdom.value3, onThese, onThis, onThat);
          var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
          var nextState = {
              build: state.build,
              node: state.node,
              attrs: attrs2,
              ns: vdom.value0,
              name: vdom.value1,
              children: children2
          };
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchElem, haltElem));
      };
      haltElem(state);
      return state.build(vdom);
  };
  var patchKeyed = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchKeyed(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Keyed && eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
          var v = Data_Array.length(vdom.value3);
          if (state.length === 0 && v === 0) {
              var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
              var nextState = {
                  build: state.build,
                  node: state.node,
                  attrs: attrs2,
                  ns: vdom.value0,
                  name: vdom.value1,
                  children: state.children,
                  length: 0
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchKeyed, haltKeyed));
          };
          var onThis = function (v2, s) {
              return Halogen_VDom_Machine.halt(s);
          };
          var onThese = function (v2, ix$prime, s, v3) {
              var res = Halogen_VDom_Machine.step(s, v3.value1);
              Halogen_VDom_Util.insertChildIx(ix$prime, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var onThat = function (v2, ix, v3) {
              var res = state.build(v3.value1);
              Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var children2 = Halogen_VDom_Util.diffWithKeyAndIxE(state.children, vdom.value3, Data_Tuple.fst, onThese, onThis, onThat);
          var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
          var nextState = {
              build: state.build,
              node: state.node,
              attrs: attrs2,
              ns: vdom.value0,
              name: vdom.value1,
              children: children2,
              length: v
          };
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchKeyed, haltKeyed));
      };
      haltKeyed(state);
      return state.build(vdom);
  };
  var buildWidget = function (v, build, w) {
      var res = v.buildWidget(v)(w);
      var res$prime = Halogen_VDom_Machine.unStep(function (v1) {
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(v1.value0, {
              build: build,
              widget: res
          }, patchWidget, haltWidget));
      })(res);
      return res$prime;
  };
  var buildText = function (v, build, s) {
      var node = Halogen_VDom_Util.createTextNode(s, v.document);
      var state = {
          build: build,
          node: node,
          value: s
      };
      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, state, patchText, haltText));
  };
  var buildKeyed = function (v, build, ns1, name1, as1, ch1) {
      var el = Halogen_VDom_Util.createElement(Data_Nullable.toNullable(ns1), name1, v.document);
      var node = Web_DOM_Element.toNode(el);
      var onChild = function (v1, ix, v2) {
          var res = build(v2.value1);
          Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), node);
          return res;
      };
      var children = Halogen_VDom_Util.strMapWithIxE(ch1, Data_Tuple.fst, onChild);
      var attrs = v.buildAttributes(el)(as1);
      var state = {
          build: build,
          node: node,
          attrs: attrs,
          ns: ns1,
          name: name1,
          children: children,
          length: Data_Array.length(ch1)
      };
      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, state, patchKeyed, haltKeyed));
  };
  var buildElem = function (v, build, ns1, name1, as1, ch1) {
      var el = Halogen_VDom_Util.createElement(Data_Nullable.toNullable(ns1), name1, v.document);
      var node = Web_DOM_Element.toNode(el);
      var onChild = function (ix, child) {
          var res = build(child);
          Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), node);
          return res;
      };
      var children = Halogen_VDom_Util.forE(ch1, onChild);
      var attrs = v.buildAttributes(el)(as1);
      var state = {
          build: build,
          node: node,
          attrs: attrs,
          ns: ns1,
          name: name1,
          children: children
      };
      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, state, patchElem, haltElem));
  };
  var buildVDom = function (spec) {
      var build = function (v) {
          if (v instanceof Halogen_VDom_Types.Text) {
              return buildText(spec, build, v.value0);
          };
          if (v instanceof Halogen_VDom_Types.Elem) {
              return buildElem(spec, build, v.value0, v.value1, v.value2, v.value3);
          };
          if (v instanceof Halogen_VDom_Types.Keyed) {
              return buildKeyed(spec, build, v.value0, v.value1, v.value2, v.value3);
          };
          if (v instanceof Halogen_VDom_Types.Widget) {
              return buildWidget(spec, build, v.value0);
          };
          if (v instanceof Halogen_VDom_Types.Grafted) {
              return build(Halogen_VDom_Types.runGraft(v.value0));
          };
          throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [ v.constructor.name ]);
      };
      return build;
  };
  exports["buildVDom"] = buildVDom;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.Thunk"] = $PS["Halogen.VDom.Thunk"] || {};
  var exports = $PS["Halogen.VDom.Thunk"];
  var Halogen_VDom_DOM = $PS["Halogen.VDom.DOM"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Util = $PS["Halogen.VDom.Util"];        
  var Thunk = (function () {
      function Thunk(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Thunk.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Thunk(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Thunk;
  })();                                          
  var unsafeEqThunk = function (v, v1) {
      return Halogen_VDom_Util.refEq(v.value0, v1.value0) && (Halogen_VDom_Util.refEq(v.value1, v1.value1) && v.value1(v.value3, v1.value3));
  };
  var thunk = function (tid, eqFn, f, a) {
      return new Thunk(tid, eqFn, f, a);
  };
  var runThunk = function (v) {
      return v.value2(v.value3);
  };
  var mapThunk = function (k) {
      return function (v) {
          return new Thunk(v.value0, v.value1, function ($46) {
              return k(v.value2($46));
          }, v.value3);
      };
  };
  var hoist = mapThunk;
  var buildThunk = function (toVDom) {
      var haltThunk = function (state) {
          return Halogen_VDom_Machine.halt(state.vdom);
      };
      var patchThunk = function (state, t2) {
          var $43 = unsafeEqThunk(state.thunk, t2);
          if ($43) {
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(state.vdom), state, patchThunk, haltThunk));
          };
          var vdom = Halogen_VDom_Machine.step(state.vdom, toVDom(runThunk(t2)));
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(vdom), {
              vdom: vdom,
              thunk: t2
          }, patchThunk, haltThunk));
      };
      var renderThunk = function (spec) {
          return function (t) {
              var vdom = Halogen_VDom_DOM.buildVDom(spec)(toVDom(runThunk(t)));
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(vdom), {
                  thunk: t,
                  vdom: vdom
              }, patchThunk, haltThunk));
          };
      };
      return renderThunk;
  };
  exports["buildThunk"] = buildThunk;
  exports["hoist"] = hoist;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Component"] = $PS["Halogen.Component"] || {};
  var exports = $PS["Halogen.Component"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Coyoneda = $PS["Data.Coyoneda"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Halogen_Query_HalogenQ = $PS["Halogen.Query.HalogenQ"];
  var Halogen_VDom_Thunk = $PS["Halogen.VDom.Thunk"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var ComponentSlot = (function () {
      function ComponentSlot(value0) {
          this.value0 = value0;
      };
      ComponentSlot.create = function (value0) {
          return new ComponentSlot(value0);
      };
      return ComponentSlot;
  })();
  var ThunkSlot = (function () {
      function ThunkSlot(value0) {
          this.value0 = value0;
      };
      ThunkSlot.create = function (value0) {
          return new ThunkSlot(value0);
      };
      return ThunkSlot;
  })();
  var unComponentSlot = Unsafe_Coerce.unsafeCoerce;
  var unComponent = Unsafe_Coerce.unsafeCoerce;
  var mkEval = function (args) {
      return function (v) {
          if (v instanceof Halogen_Query_HalogenQ.Initialize) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(args.handleAction)(args.initialize))(v.value0);
          };
          if (v instanceof Halogen_Query_HalogenQ.Finalize) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(args.handleAction)(args.finalize))(v.value0);
          };
          if (v instanceof Halogen_Query_HalogenQ.Receive) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(args.handleAction)(args.receive(v.value0)))(v.value1);
          };
          if (v instanceof Halogen_Query_HalogenQ.Action) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(args.handleAction(v.value0))(v.value1);
          };
          if (v instanceof Halogen_Query_HalogenQ.Query) {
              return Data_Coyoneda.unCoyoneda(function (g) {
                  var $25 = Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(Data_Maybe.maybe(v.value1(Data_Unit.unit))(g));
                  return function ($26) {
                      return $25(args.handleQuery($26));
                  };
              })(v.value0);
          };
          throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 70): " + [ v.constructor.name ]);
      };
  };
  var mkComponentSlot = Unsafe_Coerce.unsafeCoerce;
  var mkComponent = Unsafe_Coerce.unsafeCoerce;
  var hoistSlot = function (dictFunctor) {
      return function (nat) {
          return function (v) {
              if (v instanceof ComponentSlot) {
                  return unComponentSlot(function (slot) {
                      return ComponentSlot.create(mkComponentSlot({
                          get: slot.get,
                          pop: slot.pop,
                          set: slot.set,
                          component: hoist(dictFunctor)(nat)(slot.component),
                          input: slot.input,
                          output: slot.output
                      }));
                  })(v.value0);
              };
              if (v instanceof ThunkSlot) {
                  return ThunkSlot.create(Halogen_VDom_Thunk.hoist(Data_Bifunctor.lmap(Halogen_HTML_Core.bifunctorHTML)(hoistSlot(dictFunctor)(nat)))(v.value0));
              };
              throw new Error("Failed pattern match at Halogen.Component (line 279, column 17 - line 284, column 53): " + [ v.constructor.name ]);
          };
      };
  };
  var hoist = function (dictFunctor) {
      return function (nat) {
          return unComponent(function (c) {
              return mkComponent({
                  initialState: c.initialState,
                  render: (function () {
                      var $27 = Data_Bifunctor.lmap(Halogen_HTML_Core.bifunctorHTML)(hoistSlot(dictFunctor)(nat));
                      return function ($28) {
                          return $27(c.render($28));
                      };
                  })(),
                  "eval": (function () {
                      var $29 = Halogen_Query_HalogenM.hoist(dictFunctor)(nat);
                      return function ($30) {
                          return $29(c["eval"]($30));
                      };
                  })()
              });
          });
      };
  }; 
  var defaultEval = {
      handleAction: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit)),
      handleQuery: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Maybe.Nothing.value)),
      receive: Data_Function["const"](Data_Maybe.Nothing.value),
      initialize: Data_Maybe.Nothing.value,
      finalize: Data_Maybe.Nothing.value
  };
  var componentSlot = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (p) {
                      return function (comp) {
                          return function (input) {
                              return function (output) {
                                  return mkComponentSlot({
                                      get: Halogen_Data_Slot.lookup()(dictIsSymbol)(dictOrd)(label)(p),
                                      pop: Halogen_Data_Slot.pop()(dictIsSymbol)(dictOrd)(label)(p),
                                      set: Halogen_Data_Slot.insert()(dictIsSymbol)(dictOrd)(label)(p),
                                      component: comp,
                                      input: input,
                                      output: output
                                  });
                              };
                          };
                      };
                  };
              };
          };
      };
  };
  exports["mkComponent"] = mkComponent;
  exports["unComponent"] = unComponent;
  exports["hoist"] = hoist;
  exports["mkEval"] = mkEval;
  exports["defaultEval"] = defaultEval;
  exports["ComponentSlot"] = ComponentSlot;
  exports["ThunkSlot"] = ThunkSlot;
  exports["componentSlot"] = componentSlot;
  exports["unComponentSlot"] = unComponentSlot;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.HTML"] = $PS["Halogen.HTML"] || {};
  var exports = $PS["Halogen.HTML"];
  var Data_Function = $PS["Data.Function"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];        
  var slot_ = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (p) {
                      return function (component) {
                          return function (input) {
                              return Halogen_HTML_Core.widget(new Halogen_Component.ComponentSlot(Halogen_Component.componentSlot()(dictIsSymbol)(dictOrd)(label)(p)(component)(input)(Data_Function["const"](Data_Maybe.Nothing.value))));
                          };
                      };
                  };
              };
          };
      };
  };
  var slot = function (dictCons) {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (p) {
                      return function (component) {
                          return function (input) {
                              return function (outputQuery) {
                                  return Halogen_HTML_Core.widget(new Halogen_Component.ComponentSlot(Halogen_Component.componentSlot()(dictIsSymbol)(dictOrd)(label)(p)(component)(input)(function ($6) {
                                      return Data_Maybe.Just.create(outputQuery($6));
                                  })));
                              };
                          };
                      };
                  };
              };
          };
      };
  };
  exports["slot"] = slot;
  exports["slot_"] = slot_;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.UIEvent.MouseEvent"] = $PS["Web.UIEvent.MouseEvent"] || {};
  var exports = $PS["Web.UIEvent.MouseEvent"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];  
  var toEvent = Unsafe_Coerce.unsafeCoerce;
  exports["toEvent"] = toEvent;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Card"] = $PS["Domination.UI.Card"] || {};
  var exports = $PS["Domination.UI.Card"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Unit = $PS["Data.Unit"];
  var Domination_Capability_Dom = $PS["Domination.Capability.Dom"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_DomSlot = $PS["Domination.UI.DomSlot"];
  var Domination_UI_Icons = $PS["Domination.UI.Icons"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML = $PS["Halogen.HTML"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Type_Proxy = $PS["Type.Proxy"];
  var Web_UIEvent_MouseEvent = $PS["Web.UIEvent.MouseEvent"];                
  var descriptionComponent = function (dictDom) {
      return function (dictLog) {
          return function (card$prime) {
              var initialState = function (v) {
                  return {
                      card: card$prime,
                      visible: false
                  };
              };
              var $$eval = Halogen_Component.mkEval({
                  handleAction: function (v1) {
                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)((function () {
                          if (v1.event instanceof Data_Maybe.Nothing) {
                              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                          };
                          if (v1.event instanceof Data_Maybe.Just) {
                              return Domination_Capability_Dom.stopPropagation(Domination_Capability_Dom.domHalogenM(dictDom))(Web_UIEvent_MouseEvent.toEvent(v1.event.value0));
                          };
                          throw new Error("Failed pattern match at Domination.UI.Card (line 179, column 9 - line 181, column 48): " + [ v1.event.constructor.name ]);
                      })())(function () {
                          if (v1.reset) {
                              return Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)({
                                  card: v1.card,
                                  visible: false
                              });
                          };
                          return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                              return {
                                  visible: !v2.visible,
                                  card: v1.card
                              };
                          });
                      });
                  },
                  handleQuery: Halogen_Component.defaultEval.handleQuery,
                  receive: function (card) {
                      return new Data_Maybe.Just({
                          event: Data_Maybe.Nothing.value,
                          reset: true,
                          card: card
                      });
                  },
                  initialize: Halogen_Component.defaultEval.initialize,
                  finalize: Halogen_Component.defaultEval.finalize
              });
              var description = function (special) {
                  return Data_Maybe.fromMaybe("")(Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
                      return v.description;
                  })(special));
              };
              var render$prime = function (v) {
                  var $20 = !(Data_Maybe.isJust(v.card.special) || Data_Maybe.isJust(v.card.reaction));
                  if ($20) {
                      return Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardName ]) ])([ Halogen_HTML_Core.text(v.card.name) ]);
                  };
                  return Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.description ]) ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardName, Domination_UI_Css.toggle ]), Halogen_HTML_Events.onClick(function (event) {
                      return {
                          card: v.card,
                          event: new Data_Maybe.Just(event),
                          reset: false
                      };
                  }) ])([ Halogen_HTML_Core.text(v.card.name) ]) ])((function () {
                      if (v.visible) {
                          return [ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.toolTip), Halogen_HTML_Events.onClick(function (event) {
                              return {
                                  card: v.card,
                                  event: new Data_Maybe.Just(event),
                                  reset: false
                              };
                          }) ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text(description(v.card.special)) ])((function () {
                              if (v.card.reaction instanceof Data_Maybe.Nothing) {
                                  return [  ];
                              };
                              if (v.card.reaction instanceof Data_Maybe.Just) {
                                  return [ Halogen_HTML_Elements.hr_, Domination_UI_RenderText.renderText(Domination_UI_RenderText.reactionRenderText)(v.card.reaction.value0) ];
                              };
                              throw new Error("Failed pattern match at Domination.UI.Card (line 168, column 16 - line 173, column 18): " + [ v.card.reaction.constructor.name ]);
                          })())) ];
                      };
                      return [  ];
                  })()));
              };
              return Halogen_Component.mkComponent({
                  initialState: initialState,
                  render: render$prime,
                  "eval": $$eval
              });
          };
      };
  };
  var render = function (dictDom) {
      return function (dictLog) {
          return function (onClick) {
              return function (extraClasses) {
                  return function (card) {
                      return function (slot) {
                          var properties = [ Halogen_HTML_Events.onClick(onClick), Halogen_HTML_Properties.attr("aria-label")(card.name), Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Domination_UI_Css.card ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(extraClasses)(Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                              var $26 = Domination_Data_Card.hasType(Domination_Data_CardType.Treasure.value)(card);
                              if ($26) {
                                  return [ Domination_UI_Css.treasureCard ];
                              };
                              return [  ];
                          })())(Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                              var $27 = Domination_Data_Card.hasType(Domination_Data_CardType.Victory.value)(card);
                              if ($27) {
                                  return [ Domination_UI_Css.victoryCard ];
                              };
                              return [  ];
                          })())(Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                              var $28 = Domination_Data_Card.hasType(Domination_Data_CardType.Attack.value)(card);
                              if ($28) {
                                  return [ Domination_UI_Css.attackCard ];
                              };
                              return [  ];
                          })())(Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                              var $29 = Domination_Data_Card.hasType(Domination_Data_CardType.Reaction.value)(card);
                              if ($29) {
                                  return [ Domination_UI_Css.reactionCard ];
                              };
                              return [  ];
                          })())(Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                              var $30 = Domination_Data_Card.hasType(Domination_Data_CardType.Action.value)(card);
                              if ($30) {
                                  return [ Domination_UI_Css.actionCard ];
                              };
                              return [  ];
                          })())((function () {
                              var $31 = Domination_Data_Card.hasType(Domination_Data_CardType.Curse.value)(card);
                              if ($31) {
                                  return [ Domination_UI_Css.curseCard ];
                              };
                              return [  ];
                          })())))))))) ];
                          var children = [ Halogen_HTML_Elements.ul_([ Halogen_HTML.slot_()(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Domination_UI_DomSlot.ordDomSlot)(Type_Proxy["Proxy"].value)(slot)(descriptionComponent(dictDom)(dictLog)(card))(card), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardCards ]) ])((function () {
                              var $32 = card.cards > 0;
                              if ($32) {
                                  return [ Halogen_HTML_Core.text("+" + Data_Show.show(Data_Show.showInt)(card.cards)), Domination_UI_Icons.cards ];
                              };
                              return [  ];
                          })()), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardActions ]) ])((function () {
                              var $33 = Data_Ord.greaterThan(Domination_Data_Actions.ordActions)(card.actions)(Data_Semiring.zero(Domination_Data_Actions.ringActions));
                              if ($33) {
                                  return [ Halogen_HTML_Core.text("+"), Domination_UI_RenderText.renderText(Domination_UI_RenderText.actionsRenderText)(card.actions) ];
                              };
                              return [  ];
                          })()), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardBuys ]) ])((function () {
                              var $34 = Data_Ord.greaterThan(Domination_Data_Buys.ordBuys)(card.buys)(Data_Semiring.zero(Domination_Data_Buys.ringBuys));
                              if ($34) {
                                  return [ Halogen_HTML_Core.text("+"), Domination_UI_RenderText.renderText(Domination_UI_RenderText.buysRenderText)(card.buys) ];
                              };
                              return [  ];
                          })()), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardTreasure ]) ])((function () {
                              var $35 = card.treasure > 0;
                              if ($35) {
                                  return [ Halogen_HTML_Core.text("+" + Data_Show.show(Data_Show.showInt)(card.treasure)), Domination_UI_Icons.money ];
                              };
                              return [  ];
                          })()), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardVictoryPoints ]) ])((function () {
                              var $36 = Data_Eq.notEq(Domination_Data_Points.eqPoints)(card.victoryPoints)(Data_Semiring.zero(Domination_Data_Points.ringPoints));
                              if ($36) {
                                  return [ Halogen_HTML_Core.text((function () {
                                      var $37 = Data_Ord.greaterThan(Domination_Data_Points.ordPoints)(card.victoryPoints)(Data_Semiring.zero(Domination_Data_Points.ringPoints));
                                      if ($37) {
                                          return "+";
                                      };
                                      return "";
                                  })()), Domination_UI_RenderText.renderText(Domination_UI_RenderText.victoryPointsRenderText)(card.victoryPoints) ];
                              };
                              return [  ];
                          })()), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.cardText, Domination_UI_Css.cardCost ]) ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(card.cost)), Domination_UI_Icons.money ]) ]) ];
                          return Halogen_HTML_Elements.button(properties)(children);
                      };
                  };
              };
          };
      };
  };
  exports["render"] = render;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.CardChooser"] = $PS["Domination.UI.CardChooser"] || {};
  var exports = $PS["Domination.UI.CardChooser"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_UI_Card = $PS["Domination.UI.Card"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_Util = $PS["Domination.UI.Util"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var Toggle = (function () {
      function Toggle(value0) {
          this.value0 = value0;
      };
      Toggle.create = function (value0) {
          return new Toggle(value0);
      };
      return Toggle;
  })();
  var Done = (function () {
      function Done() {

      };
      Done.value = new Done();
      return Done;
  })();
  var component = function (dictOrd) {
      return function (dictDom) {
          return function (dictLog) {
              return function (v) {
                  var renderCardToTrash = function (cardIndex) {
                      return function (v1) {
                          var onClick = function (v2) {
                              return new Toggle(cardIndex);
                          };
                          var extraClasses = [ (function () {
                              if (v1.value1) {
                                  return Domination_UI_Css.toTrash;
                              };
                              return Domination_UI_Css.toKeep;
                          })() ];
                          return Domination_UI_Card.render(dictDom)(dictLog)(onClick)(extraClasses)(v1.value0)(v.baseSlotNumber(cardIndex));
                      };
                  };
                  var render = function (xs) {
                      var v1 = Control_Bind.bind(Data_Maybe.bindMaybe)(Domination_Data_Player.firstChoice(v.player))(v.renderChoice);
                      if (v1 instanceof Data_Maybe.Just) {
                          return Halogen_HTML_Elements.div_(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ v1.value0.title, Halogen_HTML_Elements.p_([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.resolveChoice), Halogen_HTML_Events.onClick(function (v2) {
                              return Done.value;
                          }) ])([ v1.value0.buttonText ]) ]) ])(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(renderCardToTrash)(xs)));
                      };
                      if (v1 instanceof Data_Maybe.Nothing) {
                          return Domination_UI_Util.h2__("Something has gone terribly wrong!");
                      };
                      throw new Error("Failed pattern match at Domination.UI.CardChooser (line 104, column 5 - line 117, column 59): " + [ v1.constructor.name ]);
                  };
                  var initialState = function (v1) {
                      var cards = (function () {
                          if (v.pile instanceof Domination_Data_Pile.AtPlay) {
                              return v.player.atPlay;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Hand) {
                              return v.player.hand;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Discard) {
                              return v.player.discard;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Buying) {
                              return v.player.buying;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Discarding) {
                              return v.player.toDiscard;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Deck) {
                              return v.player.deck;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Trash) {
                              return v.state.trash;
                          };
                          if (v.pile instanceof Domination_Data_Pile.Supply) {
                              return Domination_Data_Stack.stacksToCards(v.state.supply);
                          };
                          throw new Error("Failed pattern match at Domination.UI.CardChooser (line 93, column 15 - line 101, column 50): " + [ v.pile.constructor.name ]);
                      })();
                      return Data_Functor.map(Data_Functor.functorArray)(function (x) {
                          return new Data_Tuple.Tuple(x, false);
                      })(cards);
                  };
                  var $$eval = (function () {
                      var resolution = function (xs) {
                          return Data_Maybe.Just.create(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Array.filter(Data_Tuple.fst)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (i) {
                              return function (v1) {
                                  return new Data_Tuple.Tuple(v1.value1, i);
                              };
                          })(xs))));
                      };
                      return Halogen_Component.mkEval({
                          handleAction: function (v2) {
                              if (v2 instanceof Toggle) {
                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (xs) {
                                      var total = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(Data_Array.filter(Data_Tuple.snd)(xs));
                                      return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (j) {
                                          return function (v3) {
                                              return Data_Tuple.Tuple.create(v3.value0)((function () {
                                                  var $29 = v2.value0 === j && v.canToggle({
                                                      selected: v3.value1,
                                                      total: total
                                                  });
                                                  if ($29) {
                                                      return !v3.value1;
                                                  };
                                                  return v3.value1;
                                              })());
                                          };
                                      }));
                                  });
                              };
                              if (v2 instanceof Done) {
                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(function ($40) {
                                      return v.resolve(resolution($40));
                                  })(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM)))(Halogen_Query_HalogenM.raise);
                              };
                              throw new Error("Failed pattern match at Domination.UI.CardChooser (line 120, column 22 - line 132, column 63): " + [ v2.constructor.name ]);
                          },
                          handleQuery: Halogen_Component.defaultEval.handleQuery,
                          receive: Halogen_Component.defaultEval.receive,
                          initialize: Halogen_Component.defaultEval.initialize,
                          finalize: Halogen_Component.defaultEval.finalize
                      });
                  })();
                  return Halogen_Component.mkComponent({
                      initialState: initialState,
                      render: render,
                      "eval": $$eval
                  });
              };
          };
      };
  };
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Message"] = $PS["Message"] || {};
  var exports = $PS["Message"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Decode_Generic = $PS["Data.Argonaut.Decode.Generic"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Argonaut_Encode_Generic = $PS["Data.Argonaut.Encode.Generic"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Generic_Rep = $PS["Data.Generic.Rep"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Iso = $PS["Data.Lens.Iso"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Play = $PS["Domination.Data.Play"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Result = $PS["Domination.Data.Result"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Data_Wire_Game = $PS["Domination.Data.Wire.Game"];
  var Domination_Data_Wire_Int = $PS["Domination.Data.Wire.Int"];
  var Domination_Data_Wire_Play = $PS["Domination.Data.Wire.Play"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];                
  var ChatWireMessage = (function () {
      function ChatWireMessage(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      ChatWireMessage.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new ChatWireMessage(value0, value1, value2);
              };
          };
      };
      return ChatWireMessage;
  })();
  var UsernameWireMessage = (function () {
      function UsernameWireMessage(value0) {
          this.value0 = value0;
      };
      UsernameWireMessage.create = function (value0) {
          return new UsernameWireMessage(value0);
      };
      return UsernameWireMessage;
  })();
  var GameWireMessage = (function () {
      function GameWireMessage(value0) {
          this.value0 = value0;
      };
      GameWireMessage.create = function (value0) {
          return new GameWireMessage(value0);
      };
      return GameWireMessage;
  })();
  var PlayMadeWireMessage = (function () {
      function PlayMadeWireMessage(value0) {
          this.value0 = value0;
      };
      PlayMadeWireMessage.create = function (value0) {
          return new PlayMadeWireMessage(value0);
      };
      return PlayMadeWireMessage;
  })();
  var JoinWireMessage = (function () {
      function JoinWireMessage(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      JoinWireMessage.create = function (value0) {
          return function (value1) {
              return new JoinWireMessage(value0, value1);
          };
      };
      return JoinWireMessage;
  })();
  var HeartbeatWireMessage = (function () {
      function HeartbeatWireMessage(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      HeartbeatWireMessage.create = function (value0) {
          return function (value1) {
              return new HeartbeatWireMessage(value0, value1);
          };
      };
      return HeartbeatWireMessage;
  })();
  var LeaveWireMessage = (function () {
      function LeaveWireMessage(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      LeaveWireMessage.create = function (value0) {
          return function (value1) {
              return new LeaveWireMessage(value0, value1);
          };
      };
      return LeaveWireMessage;
  })();
  var ChatMessage = (function () {
      function ChatMessage(value0) {
          this.value0 = value0;
      };
      ChatMessage.create = function (value0) {
          return new ChatMessage(value0);
      };
      return ChatMessage;
  })();
  var UsernameMessage = (function () {
      function UsernameMessage(value0) {
          this.value0 = value0;
      };
      UsernameMessage.create = function (value0) {
          return new UsernameMessage(value0);
      };
      return UsernameMessage;
  })();
  var GameMessage = (function () {
      function GameMessage(value0) {
          this.value0 = value0;
      };
      GameMessage.create = function (value0) {
          return new GameMessage(value0);
      };
      return GameMessage;
  })();
  var PlayMadeMessage = (function () {
      function PlayMadeMessage(value0) {
          this.value0 = value0;
      };
      PlayMadeMessage.create = function (value0) {
          return new PlayMadeMessage(value0);
      };
      return PlayMadeMessage;
  })();
  var JoinMessage = (function () {
      function JoinMessage(value0) {
          this.value0 = value0;
      };
      JoinMessage.create = function (value0) {
          return new JoinMessage(value0);
      };
      return JoinMessage;
  })();
  var HeartbeatMessage = (function () {
      function HeartbeatMessage(value0) {
          this.value0 = value0;
      };
      HeartbeatMessage.create = function (value0) {
          return new HeartbeatMessage(value0);
      };
      return HeartbeatMessage;
  })();
  var LeaveMessage = (function () {
      function LeaveMessage(value0) {
          this.value0 = value0;
      };
      LeaveMessage.create = function (value0) {
          return new LeaveMessage(value0);
      };
      return LeaveMessage;
  })();
  var getPlayerCardName = function (playerIndex) {
      return function (state) {
          return function (cardIndex) {
              return Data_Maybe.fromMaybe("???")(Data_Lens_Fold.previewOn(state)((function () {
                  var $288 = Domination_Data_Game["_player"](playerIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
                  var $289 = Domination_Data_Player["_cardInHand"](cardIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
                  var $290 = Domination_Data_Card["_name"](Data_Lens_Internal_Forget.strongForget);
                  return function ($291) {
                      return $288($289($290($291)));
                  };
              })()));
          };
      };
  };
  var renderHtml = function (v) {
      if (v instanceof JoinMessage) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("join-message") ])([ Halogen_HTML_Core.text("(" + (v.value0.clientId + " has joined the game)")) ]);
      };
      if (v instanceof HeartbeatMessage) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("heartbeat-message") ])([ Halogen_HTML_Core.text("(" + (v.value0.clientId + " is alive ")) ]);
      };
      if (v instanceof LeaveMessage) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("leave-message") ])([ Halogen_HTML_Core.text("(" + (v.value0.clientId + " has left the game)")) ]);
      };
      if (v instanceof ChatMessage) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("chat-message") ])([ Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("username") ])([ Halogen_HTML_Core.text(v.value0.username) ]), Halogen_HTML_Core.text(": "), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("message") ])([ Halogen_HTML_Core.text(v.value0.message) ]) ]);
      };
      if (v instanceof GameMessage) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("game-state-message") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("game-state") ])([ Halogen_HTML_Core.text("(Game Data Received)") ]) ]);
      };
      if (v instanceof UsernameMessage) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("username-message") ])([ Halogen_HTML_Core.text("("), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("username") ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showString)(v.value0.username)) ]), Halogen_HTML_Core.text(" has ID: "), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("username") ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showString)(v.value0.id)) ]), Halogen_HTML_Core.text(")") ]);
      };
      if (v instanceof PlayMadeMessage) {
          var play$prime = (function () {
              if (v.value0.play instanceof Domination_Data_Play.NewGame) {
                  return Data_Maybe.Just.create(Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text("created a new " + (Data_Show.show(Data_Show.showInt)(v.value0.play.value0.playerCount) + " player game")) ]));
              };
              if (v.value0.play instanceof Domination_Data_Play.EndPhase) {
                  return Data_Maybe.Nothing.value;
              };
              if (v.value0.play instanceof Domination_Data_Play.PlayCard) {
                  return Data_Maybe.Just.create(Halogen_HTML_Core.text("played: " + getPlayerCardName(v.value0.play.value0.playerIndex)(v.value0.state)(v.value0.play.value0.cardIndex)));
              };
              if (v.value0.play instanceof Domination_Data_Play.Purchase) {
                  var text = (function () {
                      var v1 = Data_Lens_Fold.preview(Domination_Data_Game["_stack"](v.value0.play.value0.stackIndex)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(v.value0.state);
                      if (v1 instanceof Data_Maybe.Nothing) {
                          return "???";
                      };
                      if (v1 instanceof Data_Maybe.Just) {
                          return v1.value0.card.name;
                      };
                      throw new Error("Failed pattern match at Message (line 223, column 20 - line 225, column 41): " + [ v1.constructor.name ]);
                  })();
                  return Data_Maybe.Just.create(Halogen_HTML_Core.text("purchased: " + text));
              };
              if (v.value0.play instanceof Domination_Data_Play.ResolveChoice) {
                  return Data_Maybe.Just.create(Domination_UI_RenderText.renderTextInContext(Domination_UI_RenderText.choiceRenderTextInContext)(v.value0.play.value0.playerIndex)(v.value0.state)(v.value0.play.value0.choice));
              };
              if (v.value0.play instanceof Domination_Data_Play.React) {
                  return Data_Maybe.Just.create(Halogen_HTML_Core.text((function () {
                      if (v.value0.play.value0.reaction instanceof Data_Maybe.Nothing) {
                          return "did not react";
                      };
                      if (v.value0.play.value0.reaction instanceof Data_Maybe.Just) {
                          return "blocked an attack";
                      };
                      throw new Error("Failed pattern match at Message (line 229, column 21 - line 231, column 52): " + [ v.value0.play.value0.reaction.constructor.name ]);
                  })()));
              };
              throw new Error("Failed pattern match at Message (line 210, column 15 - line 231, column 52): " + [ v.value0.play.constructor.name ]);
          })();
          if (play$prime instanceof Data_Maybe.Nothing) {
              return Halogen_HTML_Elements.span([  ])([  ]);
          };
          if (play$prime instanceof Data_Maybe.Just) {
              return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("play-made-message") ])([ Halogen_HTML_Core.text("Player " + (Data_Show.show(Data_Show.showInt)(v.value0.playerIndex + 1 | 0) + ": ")), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("play-made") ])([ play$prime.value0 ]) ]);
          };
          throw new Error("Failed pattern match at Message (line 199, column 3 - line 207, column 8): " + [ play$prime.constructor.name ]);
      };
      throw new Error("Failed pattern match at Message (line 167, column 1 - line 167, column 52): " + [ v.constructor.name ]);
  };
  var genericWireMessage = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof ChatWireMessage) {
          return new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)));
      };
      if (x instanceof UsernameWireMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof GameWireMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof PlayMadeWireMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof JoinWireMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
      };
      if (x instanceof HeartbeatWireMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))))));
      };
      if (x instanceof LeaveWireMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1)))))));
      };
      throw new Error("Failed pattern match at Message (line 149, column 1 - line 149, column 60): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new ChatWireMessage(x.value0.value0, x.value0.value1.value0, x.value0.value1.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new UsernameWireMessage(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new GameWireMessage(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new PlayMadeWireMessage(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new JoinWireMessage(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return new HeartbeatWireMessage(x.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value1);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
          return new LeaveWireMessage(x.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value1);
      };
      throw new Error("Failed pattern match at Message (line 149, column 1 - line 149, column 60): " + [ x.constructor.name ]);
  });         
  var genericRemoteMessage = new Data_Generic_Rep.Generic(function (x) {
      if (x instanceof ChatMessage) {
          return new Data_Generic_Rep.Inl(x.value0);
      };
      if (x instanceof UsernameMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
      };
      if (x instanceof GameMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
      };
      if (x instanceof PlayMadeMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
      };
      if (x instanceof JoinMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
      };
      if (x instanceof HeartbeatMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
      };
      if (x instanceof LeaveMessage) {
          return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
      };
      throw new Error("Failed pattern match at Message (line 73, column 1 - line 73, column 64): " + [ x.constructor.name ]);
  }, function (x) {
      if (x instanceof Data_Generic_Rep.Inl) {
          return new ChatMessage(x.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
          return new UsernameMessage(x.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
          return new GameMessage(x.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
          return new PlayMadeMessage(x.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
          return new JoinMessage(x.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
          return new HeartbeatMessage(x.value0.value0.value0.value0.value0.value0);
      };
      if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
          return new LeaveMessage(x.value0.value0.value0.value0.value0.value0);
      };
      throw new Error("Failed pattern match at Message (line 73, column 1 - line 73, column 64): " + [ x.constructor.name ]);
  });                                                                                                                                                                                                                                                              
  var encodeJsonRemoteMessage = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic.genericEncodeJson(genericRemoteMessage)(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "ChatMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "username";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "message";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "chatNumber";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "UsernameMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "username";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "id";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "GameMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Play.encodeJsonPlay)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Phase.encodeJsonPhase)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Bonus.encodeJsonBonus))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Choice.encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "toDiscard";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "hand";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "discard";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "deck";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "choices";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buying";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "bonuses";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "atPlay";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Result.encodeJsonResult))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "count";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "card";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "turn";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "trash";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "result";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "players";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "phase";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "state";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "play";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Phase.encodeJsonPhase)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Bonus.encodeJsonBonus))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Choice.encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "toDiscard";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "hand";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "discard";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "deck";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "choices";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buying";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "bonuses";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "atPlay";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Result.encodeJsonResult))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "count";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "card";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "turn";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "trash";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "result";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "players";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "phase";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "state";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "playMade";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "i";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "PlayMadeMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Play.encodeJsonPlay)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Phase.encodeJsonPhase)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Bonus.encodeJsonBonus))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Choice.encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "toDiscard";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "hand";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "discard";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "deck";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "choices";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buying";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "bonuses";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "atPlay";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Result.encodeJsonResult))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "count";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "card";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "turn";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "trash";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "result";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "players";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "phase";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "state";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "play";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "JoinMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "timestamp";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "clientId";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepSum(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "HeartbeatMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "timestamp";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "clientId";
  }))())())))(Data_Argonaut_Encode_Generic.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
      return "LeaveMessage";
  }))(Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "timestamp";
  }))())(new Data_Symbol.IsSymbol(function () {
      return "clientId";
  }))())()))))))))));
  var encodeArrayBuffeWireMessage = new Data_ArrayBuffer_Class.EncodeArrayBuffer(Data_ArrayBuffer_Class.genericPutArrayBuffer(genericWireMessage)(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString))(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferString)(Data_ArrayBuffer_Class.encodeArrayBufferString))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Game.encodeArrayBuffeWireGame)(Data_ArrayBuffer_Class.encodeArrayBufferMaybe(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Play.encodeArrayBuffeWirePlay)(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Domination_Data_Wire_Game.encodeArrayBuffeWireGame))))))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Play.encodeArrayBuffeWirePlay)(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Domination_Data_Wire_Int.encodeArrayBufferWireInt)(Domination_Data_Wire_Game.encodeArrayBuffeWireGame)))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferSum(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt))))(Data_ArrayBuffer_Class.encodeArrayBufferConstructor(Data_ArrayBuffer_Class.encodeArrayBufferProduct(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Data_ArrayBuffer_Class.encodeArrayBufferString))(Data_ArrayBuffer_Class.encodeArrayBufferArgument(Domination_Data_Wire_Int.encodeArrayBufferWireInt)))))))))));
  var dynamicByteLengthWireMessage = new Data_ArrayBuffer_Class.DynamicByteLength(Data_ArrayBuffer_Class.genericByteLength(genericWireMessage)(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthString)(Data_ArrayBuffer_Class.dynamicByteLengthString))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Game.dynamicByteLengthWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))))));
  var decodeJsonRemoteMessage = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic.genericDecodeJson(genericRemoteMessage)(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "ChatMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "username";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "message";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "chatNumber";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "UsernameMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "username";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "id";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "GameMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Play.decodeJsonPlay))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Phase.decodeJsonPhase))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Bonus.decodeJsonBonus)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Choice.decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "toDiscard";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "hand";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "discard";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "deck";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "choices";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buying";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "bonuses";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "atPlay";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Result.decodeJsonResult))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "count";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "card";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "turn";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "trash";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "result";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "players";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "phase";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "state";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "play";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Phase.decodeJsonPhase))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Bonus.decodeJsonBonus)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Choice.decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "toDiscard";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "hand";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "discard";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "deck";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "choices";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buying";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "bonuses";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "atPlay";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Result.decodeJsonResult))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "count";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "card";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "turn";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "trash";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "result";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "players";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "phase";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "state";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "playMade";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "i";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "PlayMadeMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Play.decodeJsonPlay))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Phase.decodeJsonPhase))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Bonus.decodeJsonBonus)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Choice.decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "toDiscard";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "hand";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "discard";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "deck";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "choices";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buying";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "bonuses";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "atPlay";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Result.decodeJsonResult))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "count";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "card";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "target";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "description";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "command";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "victoryPoints";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "types";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "treasure";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "special";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "reaction";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "name";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cost";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "cards";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "buys";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "actions";
  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "turn";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "trash";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "supply";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "result";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "players";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "phase";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "longGame";
  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "state";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "playerIndex";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "play";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "JoinMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "timestamp";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "clientId";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepSum(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "HeartbeatMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "timestamp";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "clientId";
  }))()())()))(Data_Argonaut_Decode_Generic.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
      return "LeaveMessage";
  }))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
      return "timestamp";
  }))()())(new Data_Symbol.IsSymbol(function () {
      return "clientId";
  }))()())())))))))));
  var decodeArrayBuffeWireMessage = new Data_ArrayBuffer_Class.DecodeArrayBuffer(Data_ArrayBuffer_Class.genericReadArrayBuffer(genericWireMessage)(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferString)(Data_ArrayBuffer_Class.decodeArrayBufferString)(Data_ArrayBuffer_Class.dynamicByteLengthString)(Data_ArrayBuffer_Class.dynamicByteLengthString))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Game.decodeArrayBuffeWireGame)(Data_ArrayBuffer_Class.decodeArrayBufferMaybe(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Play.decodeArrayBuffeWirePlay)(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Game.decodeArrayBuffeWireGame)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))))(Domination_Data_Wire_Game.dynamicByteLengthWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Game.dynamicByteLengthWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))))))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Play.decodeArrayBuffeWirePlay)(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Domination_Data_Wire_Int.decodeArrayBufferWireInt)(Domination_Data_Wire_Game.decodeArrayBuffeWireGame)(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferSum(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.decodeArrayBufferConstructor(Data_ArrayBuffer_Class.decodeArrayBufferProduct(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Data_ArrayBuffer_Class.decodeArrayBufferString))(Data_ArrayBuffer_Class.decodeArrayBufferArgument(Domination_Data_Wire_Int.decodeArrayBufferWireInt))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Game.dynamicByteLengthWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthString)(Data_ArrayBuffer_Class.dynamicByteLengthString))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Game.dynamicByteLengthWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthString)(Data_ArrayBuffer_Class.dynamicByteLengthString))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Game.dynamicByteLengthWireGame)(Data_ArrayBuffer_Class.dynamicByteLengthMaybe(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame))))))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Play.dynamicByteLengthWirePlay)(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Domination_Data_Wire_Int.dynamicByteLengthWireInt)(Domination_Data_Wire_Game.dynamicByteLengthWireGame)))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthSum(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt))))(Data_ArrayBuffer_Class.dynamicByteLengthConstructor(Data_ArrayBuffer_Class.dynamicByteLengthProduct(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Data_ArrayBuffer_Class.dynamicByteLengthString))(Data_ArrayBuffer_Class.dynamicByteLengthArgument(Domination_Data_Wire_Int.dynamicByteLengthWireInt)))))))))));
  var _toWire = function (dictProfunctor) {
      var to = (function () {
          var pmm = function (v) {
              return Data_Tuple.Tuple.create(Data_Lens_Getter.view(Domination_Data_Wire_Play["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.play))(new Data_Tuple.Tuple(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.playerIndex), Data_Lens_Getter.view(Domination_Data_Wire_Game["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.state)));
          };
          return function (v) {
              if (v instanceof ChatMessage) {
                  return new ChatWireMessage(v.value0.username, v.value0.message, Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.chatNumber));
              };
              if (v instanceof UsernameMessage) {
                  return new UsernameWireMessage(new Data_Tuple.Tuple(v.value0.username, v.value0.id));
              };
              if (v instanceof GameMessage) {
                  return GameWireMessage.create(Data_Tuple.Tuple.create(Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.i))(new Data_Tuple.Tuple(Data_Lens_Getter.view(Domination_Data_Wire_Game["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.state), Data_Functor.map(Data_Maybe.functorMaybe)(pmm)(v.value0.playMade))));
              };
              if (v instanceof PlayMadeMessage) {
                  return PlayMadeWireMessage.create(pmm(v.value0));
              };
              if (v instanceof JoinMessage) {
                  return new JoinWireMessage(v.value0.clientId, Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.timestamp));
              };
              if (v instanceof HeartbeatMessage) {
                  return new HeartbeatWireMessage(v.value0.clientId, Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.timestamp));
              };
              if (v instanceof LeaveMessage) {
                  return new LeaveWireMessage(v.value0.clientId, Data_Lens_Getter.view(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(v.value0.timestamp));
              };
              throw new Error("Failed pattern match at Message (line 100, column 8 - line 116, column 61): " + [ v.constructor.name ]);
          };
      })();
      var from = (function () {
          var pmm = function (v) {
              return {
                  play: Data_Lens_Prism.review(Domination_Data_Wire_Play["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0),
                  playerIndex: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1.value0),
                  state: Data_Lens_Prism.review(Domination_Data_Wire_Game["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1.value1)
              };
          };
          return function (v) {
              if (v instanceof ChatWireMessage) {
                  return new ChatMessage({
                      username: v.value0,
                      message: v.value1,
                      chatNumber: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value2)
                  });
              };
              if (v instanceof UsernameWireMessage) {
                  return new UsernameMessage({
                      username: v.value0.value0,
                      id: v.value0.value1
                  });
              };
              if (v instanceof GameWireMessage) {
                  return new GameMessage({
                      i: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value0),
                      state: Data_Lens_Prism.review(Domination_Data_Wire_Game["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value0.value1.value0),
                      playMade: Data_Functor.map(Data_Maybe.functorMaybe)(pmm)(v.value0.value1.value1)
                  });
              };
              if (v instanceof PlayMadeWireMessage) {
                  return PlayMadeMessage.create(pmm(v.value0));
              };
              if (v instanceof JoinWireMessage) {
                  return new JoinMessage({
                      clientId: v.value0,
                      timestamp: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1)
                  });
              };
              if (v instanceof HeartbeatWireMessage) {
                  return new HeartbeatMessage({
                      clientId: v.value0,
                      timestamp: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1)
                  });
              };
              if (v instanceof LeaveWireMessage) {
                  return new LeaveMessage({
                      clientId: v.value0,
                      timestamp: Data_Lens_Prism.review(Domination_Data_Wire_Int["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))(v.value1)
                  });
              };
              throw new Error("Failed pattern match at Message (line 123, column 10 - line 141, column 73): " + [ v.constructor.name ]);
          };
      })();
      return Data_Lens_Iso.iso(to)(from)(dictProfunctor);
  };
  exports["ChatMessage"] = ChatMessage;
  exports["UsernameMessage"] = UsernameMessage;
  exports["GameMessage"] = GameMessage;
  exports["PlayMadeMessage"] = PlayMadeMessage;
  exports["JoinMessage"] = JoinMessage;
  exports["HeartbeatMessage"] = HeartbeatMessage;
  exports["LeaveMessage"] = LeaveMessage;
  exports["_toWire"] = _toWire;
  exports["renderHtml"] = renderHtml;
  exports["encodeJsonRemoteMessage"] = encodeJsonRemoteMessage;
  exports["decodeJsonRemoteMessage"] = decodeJsonRemoteMessage;
  exports["dynamicByteLengthWireMessage"] = dynamicByteLengthWireMessage;
  exports["encodeArrayBuffeWireMessage"] = encodeArrayBuffeWireMessage;
  exports["decodeArrayBuffeWireMessage"] = decodeArrayBuffeWireMessage;
})(PS);
(function(exports) {
  "use strict";

  exports.key = function (e) {
    return e.key;
  };
})(PS["Web.UIEvent.KeyboardEvent"] = PS["Web.UIEvent.KeyboardEvent"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.UIEvent.KeyboardEvent"] = $PS["Web.UIEvent.KeyboardEvent"] || {};
  var exports = $PS["Web.UIEvent.KeyboardEvent"];
  var $foreign = $PS["Web.UIEvent.KeyboardEvent"];
  exports["key"] = $foreign.key;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Chat"] = $PS["Domination.UI.Chat"] || {};
  var exports = $PS["Domination.UI.Chat"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HashMap = $PS["Data.HashMap"];
  var Data_Hashable = $PS["Data.Hashable"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Message = $PS["Message"];
  var Web_UIEvent_KeyboardEvent = $PS["Web.UIEvent.KeyboardEvent"];                
  var render = function (v) {
      return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("chat") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("chat-history") ])(Data_Functor.map(Data_Functor.functorArray)(function ($17) {
          return Message.renderHtml((function (v1) {
              if (v1 instanceof Message.ChatMessage) {
                  return new Message.ChatMessage({
                      username: Data_Maybe.fromMaybe(v1.value0.username)(Data_HashMap.lookup(Data_Hashable.hashableString)(v1.value0.username)(v.state.usernames)),
                      message: v1.value0.message,
                      chatNumber: v1.value0.chatNumber
                  });
              };
              return v1;
          })($17));
      })(v.state.messages)), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("chat-form") ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(Data_Function["const"](v.sendEvent)), Halogen_HTML_Properties.class_("send-chat") ])([ Halogen_HTML_Core.text("Send") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputText.value), Halogen_HTML_Properties.class_("chat-input"), Halogen_HTML_Properties.attr("aria-label")("Chat"), Halogen_HTML_Properties.value(v.state.message), Halogen_HTML_Properties.required(true), Halogen_HTML_Events.onValueInput(v.onInput), Halogen_HTML_Events.onKeyDown(function (e) {
          var $9 = Web_UIEvent_KeyboardEvent.key(e) === "Enter";
          if ($9) {
              return v.sendEvent;
          };
          return v.nothing;
      }) ]) ]) ]);
  };
  exports["render"] = render;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.ChoiceMoveFromTo"] = $PS["Domination.UI.ChoiceMoveFromTo"] || {};
  var exports = $PS["Domination.UI.ChoiceMoveFromTo"];
  var Data_Array = $PS["Data.Array"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_UI_CardChooser = $PS["Domination.UI.CardChooser"];
  var Domination_UI_DomSlot = $PS["Domination.UI.DomSlot"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];                
  var component = function (dictDom) {
      return function (dictLog) {
          return function (state) {
              return function (player) {
                  return function (choice) {
                      return function (baseSlotNumber) {
                          var resolve = function (resolution) {
                              if (choice instanceof Domination_Data_Choice.MoveFromTo) {
                                  return new Domination_Data_Choice.MoveFromTo({
                                      n: choice.value0.n,
                                      filter: choice.value0.filter,
                                      source: choice.value0.source,
                                      destination: choice.value0.destination,
                                      resolution: resolution,
                                      attack: choice.value0.attack
                                  });
                              };
                              return choice;
                          };
                          var renderChoice = function (v) {
                              if (v instanceof Domination_Data_Choice.MoveFromTo && v.value0.resolution instanceof Data_Maybe.Nothing) {
                                  return new Data_Maybe.Just({
                                      title: Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(v),
                                      buttonText: Halogen_HTML_Core.text("Done")
                                  });
                              };
                              return Data_Maybe.Nothing.value;
                          };
                          var pile = (function () {
                              if (choice instanceof Domination_Data_Choice.MoveFromTo) {
                                  return choice.value0.source;
                              };
                              return Domination_Data_Pile.Trash.value;
                          })();
                          var cards = (function () {
                              if (pile instanceof Domination_Data_Pile.Trash) {
                                  return state.trash;
                              };
                              if (pile instanceof Domination_Data_Pile.Supply) {
                                  return Domination_Data_Stack.stacksToCards(state.supply);
                              };
                              if (pile instanceof Domination_Data_Pile.AtPlay) {
                                  return player.atPlay;
                              };
                              if (pile instanceof Domination_Data_Pile.Hand) {
                                  return player.hand;
                              };
                              if (pile instanceof Domination_Data_Pile.Discard) {
                                  return player.discard;
                              };
                              if (pile instanceof Domination_Data_Pile.Buying) {
                                  return player.buying;
                              };
                              if (pile instanceof Domination_Data_Pile.Discarding) {
                                  return player.toDiscard;
                              };
                              if (pile instanceof Domination_Data_Pile.Deck) {
                                  return player.deck;
                              };
                              throw new Error("Failed pattern match at Domination.UI.ChoiceMoveFromTo (line 77, column 13 - line 85, column 31): " + [ pile.constructor.name ]);
                          })();
                          var maxSelected = (function () {
                              if (choice instanceof Domination_Data_Choice.MoveFromTo) {
                                  if (choice.value0.n instanceof Domination_Data_Constraint.UpTo) {
                                      return choice.value0.n.value0;
                                  };
                                  if (choice.value0.n instanceof Domination_Data_Constraint.Exactly) {
                                      return choice.value0.n.value0;
                                  };
                                  if (choice.value0.n instanceof Domination_Data_Constraint.DownTo) {
                                      return Data_Array.length(cards) - choice.value0.n.value0 | 0;
                                  };
                                  if (choice.value0.n instanceof Domination_Data_Constraint.Unlimited) {
                                      return Data_Array.length(cards);
                                  };
                                  throw new Error("Failed pattern match at Domination.UI.ChoiceMoveFromTo (line 62, column 31 - line 66, column 34): " + [ choice.value0.n.constructor.name ]);
                              };
                              return 0;
                          })();
                          var canToggle = function (v) {
                              return v.selected || v.total < maxSelected;
                          };
                          return Domination_UI_CardChooser.component(Domination_UI_DomSlot.ordDomSlot)(dictDom)(dictLog)({
                              renderChoice: renderChoice,
                              canToggle: canToggle,
                              resolve: resolve,
                              player: player,
                              state: state,
                              choice: choice,
                              pile: pile,
                              baseSlotNumber: baseSlotNumber
                          });
                      };
                  };
              };
          };
      };
  };
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.ChooseCards"] = $PS["Domination.UI.ChooseCards"] || {};
  var exports = $PS["Domination.UI.ChooseCards"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_Data_Constraint = $PS["Domination.Data.Constraint"];
  var Domination_Data_Pile = $PS["Domination.Data.Pile"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_UI_Card = $PS["Domination.UI.Card"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var Toggle = (function () {
      function Toggle(value0) {
          this.value0 = value0;
      };
      Toggle.create = function (value0) {
          return new Toggle(value0);
      };
      return Toggle;
  })();
  var Done = (function () {
      function Done() {

      };
      Done.value = new Done();
      return Done;
  })();
  var component = function (dictDom) {
      return function (dictLog) {
          return function (v) {
              var renderCard = function (cardIndex) {
                  return function (v1) {
                      var onClick = function (v2) {
                          return new Toggle(cardIndex);
                      };
                      var extraClasses = [ (function () {
                          if (v1.value1) {
                              return Domination_UI_Css.toTrash;
                          };
                          return Domination_UI_Css.toKeep;
                      })() ];
                      return Domination_UI_Card.render(dictDom)(dictLog)(onClick)(extraClasses)(v1.value0)(v.baseSlotNumber(cardIndex));
                  };
              };
              var render = function (xs) {
                  return Halogen_HTML_Elements.div_(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("Choose cards"), Halogen_HTML_Elements.p_([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.resolveChoice), Halogen_HTML_Events.onClick(function (v1) {
                      return Done.value;
                  }) ])([ Halogen_HTML_Core.text("Done") ]) ]) ])(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(renderCard)(xs)));
              };
              var cards = (function () {
                  if (v.pile instanceof Domination_Data_Pile.AtPlay) {
                      return v.player.atPlay;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Hand) {
                      return v.player.hand;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Discard) {
                      return v.player.discard;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Buying) {
                      return v.player.buying;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Discarding) {
                      return v.player.toDiscard;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Deck) {
                      return v.player.deck;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Trash) {
                      return v.state.trash;
                  };
                  if (v.pile instanceof Domination_Data_Pile.Supply) {
                      return Domination_Data_Stack.stacksToCards(v.state.supply);
                  };
                  throw new Error("Failed pattern match at Domination.UI.ChooseCards (line 120, column 13 - line 128, column 48): " + [ v.pile.constructor.name ]);
              })();
              var $$eval = (function () {
                  var resolution = function (xs) {
                      return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Array.filter(Data_Tuple.fst)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (i) {
                          return function (v1) {
                              return new Data_Tuple.Tuple(v1.value1, i);
                          };
                      })(xs)));
                  };
                  var maxSelected = (function () {
                      if (v.constraint instanceof Domination_Data_Constraint.UpTo) {
                          return v.constraint.value0;
                      };
                      if (v.constraint instanceof Domination_Data_Constraint.Exactly) {
                          return v.constraint.value0;
                      };
                      if (v.constraint instanceof Domination_Data_Constraint.DownTo) {
                          return Data_Array.length(cards) - v.constraint.value0 | 0;
                      };
                      if (v.constraint instanceof Domination_Data_Constraint.Unlimited) {
                          return Data_Array.length(cards);
                      };
                      throw new Error("Failed pattern match at Domination.UI.ChooseCards (line 99, column 23 - line 103, column 36): " + [ v.constraint.constructor.name ]);
                  })();
                  var canToggle = function (v1) {
                      return v1.selected || v1.total < maxSelected;
                  };
                  return Halogen_Component.mkEval({
                      handleAction: function (v2) {
                          if (v2 instanceof Toggle) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (xs) {
                                  var total = Data_Array.length(Data_Array.filter(Data_Tuple.snd)(xs));
                                  return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (j) {
                                      return function (v3) {
                                          return Data_Tuple.Tuple.create(v3.value0)((function () {
                                              var $31 = v2.value0 === j && canToggle({
                                                  selected: v3.value1,
                                                  total: total
                                              });
                                              if ($31) {
                                                  return !v3.value1;
                                              };
                                              return v3.value1;
                                          })());
                                      };
                                  }));
                              });
                          };
                          if (v2 instanceof Done) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(resolution)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM)))(Halogen_Query_HalogenM.raise);
                          };
                          throw new Error("Failed pattern match at Domination.UI.ChooseCards (line 82, column 24 - line 93, column 51): " + [ v2.constructor.name ]);
                      },
                      handleQuery: Halogen_Component.defaultEval.handleQuery,
                      receive: Halogen_Component.defaultEval.receive,
                      initialize: Halogen_Component.defaultEval.initialize,
                      finalize: Halogen_Component.defaultEval.finalize
                  });
              })();
              var initialState = function (v1) {
                  return Data_Functor.map(Data_Functor.functorArray)(function (x) {
                      return new Data_Tuple.Tuple(x, false);
                  })(cards);
              };
              return Halogen_Component.mkComponent({
                  initialState: initialState,
                  render: render,
                  "eval": $$eval
              });
          };
      };
  };
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.ChooseFromSupply"] = $PS["Domination.UI.ChooseFromSupply"] || {};
  var exports = $PS["Domination.UI.ChooseFromSupply"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Domination_UI_Card = $PS["Domination.UI.Card"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var Toggle = (function () {
      function Toggle(value0) {
          this.value0 = value0;
      };
      Toggle.create = function (value0) {
          return new Toggle(value0);
      };
      return Toggle;
  })();
  var Done = (function () {
      function Done() {

      };
      Done.value = new Done();
      return Done;
  })();
  var component = function (dictDom) {
      return function (dictLog) {
          return function (v) {
              var renderCard = function (cardIndex) {
                  return function (v1) {
                      var onClick = function (v2) {
                          return new Toggle(cardIndex);
                      };
                      var extraClasses = [ (function () {
                          if (v1.value1) {
                              return Domination_UI_Css.toTrash;
                          };
                          return Domination_UI_Css.toKeep;
                      })() ];
                      return Domination_UI_Card.render(dictDom)(dictLog)(onClick)(extraClasses)(v1.value0)(v.baseSlotNumber(cardIndex));
                  };
              };
              var render = function (xs) {
                  return Halogen_HTML_Elements.div_(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Core.text("Choose a card"), Halogen_HTML_Elements.p_([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.resolveChoice), Halogen_HTML_Events.onClick(function (v1) {
                      return Done.value;
                  }) ])([ Halogen_HTML_Core.text("Done") ]) ]) ])(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(renderCard)(xs)));
              };
              var initialState = function (v1) {
                  return Data_Functor.map(Data_Functor.functorArray)(function (x) {
                      return new Data_Tuple.Tuple(x, false);
                  })(v.cards);
              };
              var $$eval = (function () {
                  var resolution = function (xs) {
                      return Data_Functor.map(Data_Maybe.functorMaybe)(function ($25) {
                          return (function (v1) {
                              return v1.name;
                          })(Data_Tuple.fst($25));
                      })(Data_Array.find(Data_Tuple.snd)(xs));
                  };
                  return Halogen_Component.mkEval({
                      handleAction: function (v2) {
                          if (v2 instanceof Toggle) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (xs) {
                                  var total = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(Data_Array.filter(Data_Tuple.snd)(xs));
                                  return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (j) {
                                      return function (v3) {
                                          return Data_Tuple.Tuple.create(v3.value0)((function () {
                                              var $19 = v2.value0 === j && (v3.value1 || total === 0);
                                              if ($19) {
                                                  return !v3.value1;
                                              };
                                              return v3.value1;
                                          })());
                                      };
                                  }));
                              });
                          };
                          if (v2 instanceof Done) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(resolution)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM)))(Halogen_Query_HalogenM.raise);
                          };
                          throw new Error("Failed pattern match at Domination.UI.ChooseFromSupply (line 65, column 24 - line 75, column 51): " + [ v2.constructor.name ]);
                      },
                      handleQuery: Halogen_Component.defaultEval.handleQuery,
                      receive: Halogen_Component.defaultEval.receive,
                      initialize: Halogen_Component.defaultEval.initialize,
                      finalize: Halogen_Component.defaultEval.finalize
                  });
              })();
              return Halogen_Component.mkComponent({
                  initialState: initialState,
                  render: render,
                  "eval": $$eval
              });
          };
      };
  };
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Domination.Action"] = $PS["Domination.UI.Domination.Action"] || {};
  var exports = $PS["Domination.UI.Domination.Action"];
  var MakePlay = (function () {
      function MakePlay(value0) {
          this.value0 = value0;
      };
      MakePlay.create = function (value0) {
          return new MakePlay(value0);
      };
      return MakePlay;
  })();
  var UndoRequest = (function () {
      function UndoRequest(value0) {
          this.value0 = value0;
      };
      UndoRequest.create = function (value0) {
          return new UndoRequest(value0);
      };
      return UndoRequest;
  })();
  var ToggleSupply = (function () {
      function ToggleSupply() {

      };
      ToggleSupply.value = new ToggleSupply();
      return ToggleSupply;
  })();
  var DoNothing = (function () {
      function DoNothing() {

      };
      DoNothing.value = new DoNothing();
      return DoNothing;
  })();
  exports["MakePlay"] = MakePlay;
  exports["UndoRequest"] = UndoRequest;
  exports["ToggleSupply"] = ToggleSupply;
  exports["DoNothing"] = DoNothing;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Domination.ActiveState"] = $PS["Domination.UI.Domination.ActiveState"] || {};
  var exports = $PS["Domination.UI.Domination.ActiveState"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];                
  var _state = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "state";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var upgrade = Data_Lens_Setter.over(_state(Data_Profunctor_Strong.strongFn))(Domination_Data_Game.upgrade);
  var _showSupply = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "showSupply";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _playerIndex = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "playerIndex";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  var _i = function (dictStrong) {
      return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
          return "i";
      }))()()(Data_Symbol.SProxy.value)(dictStrong);
  };
  exports["_i"] = _i;
  exports["_playerIndex"] = _playerIndex;
  exports["_showSupply"] = _showSupply;
  exports["_state"] = _state;
  exports["upgrade"] = upgrade;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Domination.GameEvent"] = $PS["Domination.UI.Domination.GameEvent"] || {};
  var exports = $PS["Domination.UI.Domination.GameEvent"];
  var NewState = (function () {
      function NewState(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      NewState.create = function (value0) {
          return function (value1) {
              return new NewState(value0, value1);
          };
      };
      return NewState;
  })();
  var SaveGame = (function () {
      function SaveGame(value0) {
          this.value0 = value0;
      };
      SaveGame.create = function (value0) {
          return new SaveGame(value0);
      };
      return SaveGame;
  })();
  var Undo = (function () {
      function Undo(value0) {
          this.value0 = value0;
      };
      Undo.create = function (value0) {
          return new Undo(value0);
      };
      return Undo;
  })();
  exports["NewState"] = NewState;
  exports["SaveGame"] = SaveGame;
  exports["Undo"] = Undo;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Hud"] = $PS["Domination.UI.Hud"] || {};
  var exports = $PS["Domination.UI.Hud"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_Icons = $PS["Domination.UI.Icons"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];                
  var renderHandInfos = function (v) {
      var v1 = Data_Array_NonEmpty.index(v.state.players)(v.playerIndex);
      if (v1 instanceof Data_Maybe.Nothing) {
          return Halogen_HTML_Core.text("cannot find player " + (Data_Show.show(Data_Show.showInt)(v.playerIndex) + (" in players: " + Data_Show.show(Data_Array_NonEmpty_Internal.showNonEmptyArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "atPlay";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "bonuses";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buying";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "choices";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "deck";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "discard";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "hand";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "toDiscard";
          }))(Data_Show.showRecordFieldsNil)(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Domination_Data_Choice.showChoice)))(Domination_Data_Buys.showBuys))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Domination_Data_Bonus.showBonus)))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Domination_Data_Actions.showActions))))(v.state.players))));
      };
      if (v1 instanceof Data_Maybe.Just) {
          return Halogen_HTML_Elements.ul([ Halogen_HTML_Properties.class_(Domination_UI_Css.handInfos) ])([ Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.handInfo) ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(v1.value0.deck))), Domination_UI_Icons.cards ]) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Domination_UI_Css.handInfo ])((function () {
              var $7 = v.playerIndex === v.state.turn && Data_Eq.eq(Domination_Data_Phase.eqPhase)(v.state.phase)(Domination_Data_Phase.ActionPhase.value);
              if ($7) {
                  return [ Domination_UI_Css.drawAttention ];
              };
              return [  ];
          })())) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.actionsRenderText)(v1.value0.actions) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Domination_UI_Css.handInfo ])((function () {
              var $8 = v.playerIndex === v.state.turn && Data_Eq.eq(Domination_Data_Phase.eqPhase)(v.state.phase)(Domination_Data_Phase.BuyPhase.value);
              if ($8) {
                  return [ Domination_UI_Css.drawAttention ];
              };
              return [  ];
          })())) ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(Domination_Data_Player.cash(v1.value0))), Domination_UI_Icons.money ]) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Domination_UI_Css.handInfo ])((function () {
              var $9 = v.playerIndex === v.state.turn && Data_Eq.eq(Domination_Data_Phase.eqPhase)(v.state.phase)(Domination_Data_Phase.BuyPhase.value);
              if ($9) {
                  return [ Domination_UI_Css.drawAttention ];
              };
              return [  ];
          })())) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.buysRenderText)(v1.value0.buys) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.handInfo) ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(v1.value0.discard))), Domination_UI_Icons.cards ]) ]) ]);
      };
      throw new Error("Failed pattern match at Domination.UI.Hud (line 61, column 3 - line 118, column 8): " + [ v1.constructor.name ]);
  };
  var playerStats = function (v) {
      return function (playerIndex) {
          return function (player) {
              return Halogen_HTML_Elements.ul([ Halogen_HTML_Properties.class_(Domination_UI_Css.stats) ])([ Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.currentPlayer) ])([ Halogen_HTML_Elements.span_([ (function () {
                  var $16 = v.state.turn === playerIndex;
                  if ($16) {
                      if (v.state.phase instanceof Domination_Data_Phase.ActionPhase) {
                          return Domination_UI_Icons.actions;
                      };
                      if (v.state.phase instanceof Domination_Data_Phase.BuyPhase) {
                          return Domination_UI_Icons.buys;
                      };
                      if (v.state.phase instanceof Domination_Data_Phase.CleanupPhase) {
                          return Domination_UI_Icons.cards;
                      };
                      throw new Error("Failed pattern match at Domination.UI.Hud (line 139, column 16 - line 142, column 40): " + [ v.state.phase.constructor.name ]);
                  };
                  return Domination_UI_Icons.empty;
              })(), Halogen_HTML_Core.text("Player " + Data_Show.show(Data_Show.showInt)(playerIndex + 1 | 0)) ]) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stat) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.actionsRenderText)(player.actions) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stat) ])([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text((function () {
                  if (v.state.phase instanceof Domination_Data_Phase.ActionPhase && playerIndex === v.state.turn) {
                      return Data_Show.show(Data_Show.showInt)(Domination_Data_Card.value(player.atPlay));
                  };
                  if (v.state.phase instanceof Domination_Data_Phase.BuyPhase && playerIndex === v.state.turn) {
                      return Data_Show.show(Data_Show.showInt)(Domination_Data_Player.cash(player));
                  };
                  return "_";
              })()), Domination_UI_Icons.money ]) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stat) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.buysRenderText)(player.buys) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stat) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.victoryPointsRenderText)(Domination_Data_Player.score(player)) ]) ]);
          };
      };
  };
  var renderStats = function (cs) {
      return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.statsContainer) ])(Data_Array_NonEmpty.toArray(Data_Array_NonEmpty.mapWithIndex(playerStats(cs))(cs.state.players)));
  };
  var render = function (v) {
      var v1 = Data_Array_NonEmpty.index(v.state.players)(v.playerIndex);
      if (v1 instanceof Data_Maybe.Nothing) {
          return Halogen_HTML_Core.text("cannot find player " + (Data_Show.show(Data_Show.showInt)(v.playerIndex) + (" in players: " + Data_Show.show(Data_Array_NonEmpty_Internal.showNonEmptyArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "atPlay";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "bonuses";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buying";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "choices";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "deck";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "discard";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "hand";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "toDiscard";
          }))(Data_Show.showRecordFieldsNil)(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Domination_Data_Choice.showChoice)))(Domination_Data_Buys.showBuys))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Domination_Data_Bonus.showBonus)))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "actions";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "buys";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cards";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "cost";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "name";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "reaction";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "special";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "treasure";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "types";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "victoryPoints";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "command";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "description";
          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
              return "target";
          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Domination_Data_Actions.showActions))))(v.state.players))));
      };
      if (v1 instanceof Data_Maybe.Just) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("hud") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("title-bar") ])([ Halogen_HTML_Elements.h1([ Halogen_HTML_Properties.class_(Domination_UI_Css.title) ])([ Halogen_HTML_Core.text("Domination") ]), Halogen_HTML_Elements.h1([ Halogen_HTML_Properties.class_(Domination_UI_Css.playerName) ])([ Halogen_HTML_Core.text("Player " + Data_Show.show(Data_Show.showInt)(v.playerIndex + 1 | 0)) ]), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_(Domination_UI_Css.iteration) ])([ Halogen_HTML_Core.text("(" + (Data_Show.show(Data_Show.showInt)(v.i) + ")")) ]) ]), renderStats(v) ]);
      };
      throw new Error("Failed pattern match at Domination.UI.Hud (line 41, column 3 - line 57, column 10): " + [ v1.constructor.name ]);
  };
  exports["render"] = render;
  exports["renderHandInfos"] = renderHandInfos;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.PickN"] = $PS["Domination.UI.PickN"] || {};
  var exports = $PS["Domination.UI.PickN"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Domination_UI_Util = $PS["Domination.UI.Util"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var Toggle = (function () {
      function Toggle(value0) {
          this.value0 = value0;
      };
      Toggle.create = function (value0) {
          return new Toggle(value0);
      };
      return Toggle;
  })();
  var Done = (function () {
      function Done() {

      };
      Done.value = new Done();
      return Done;
  })();
  var component = function (v) {
      var render = function (xs) {
          var f = function (v1) {
              return Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v2) {
                  return new Toggle(v1.i);
              }), Halogen_HTML_Properties.class_((function () {
                  if (v1.selected) {
                      return Domination_UI_Css.toTrash;
                  };
                  return Domination_UI_Css.toKeep;
              })()) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(v1.choice) ]);
          };
          return Halogen_HTML_Elements.div_(Data_Array.cons(Domination_UI_Util.h2__(v.title))(Data_Array.cons(Halogen_HTML_Elements.p_([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
              return Done.value;
          }) ])([ Halogen_HTML_Core.text("Done choosing") ]) ]))(Data_Functor.mapFlipped(Data_Functor.functorArray)(xs)(f))));
      };
      var initialState = function (v1) {
          return Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (i) {
              return function (choice) {
                  return {
                      choice: choice,
                      i: i,
                      selected: false
                  };
              };
          })(v.choices);
      };
      var $$eval = Halogen_Component.mkEval({
          handleAction: function (v2) {
              if (v2 instanceof Toggle) {
                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (xs) {
                      var total = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(Data_Array.filter(function (v3) {
                          return v3.selected;
                      })(xs));
                      return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Functor.map(Data_Functor.functorArray)(function (v3) {
                          var $19 = v3.i === v2.value0 && v3.selected;
                          if ($19) {
                              return {
                                  i: v3.i,
                                  selected: false,
                                  choice: v3.choice
                              };
                          };
                          var $20 = v3.i === v2.value0 && (!v3.selected && total < v.n);
                          if ($20) {
                              return {
                                  i: v3.i,
                                  selected: true,
                                  choice: v3.choice
                              };
                          };
                          return {
                              i: v3.i,
                              selected: v3.selected,
                              choice: v3.choice
                          };
                      }));
                  });
              };
              if (v2 instanceof Done) {
                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)((function () {
                      var $28 = Data_Functor.map(Data_Functor.functorArray)(function (v3) {
                          return v3.choice;
                      });
                      var $29 = Data_Array.filter(function (v3) {
                          return v3.selected;
                      });
                      return function ($30) {
                          return $28($29($30));
                      };
                  })())(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM)))(Halogen_Query_HalogenM.raise);
              };
              throw new Error("Failed pattern match at Domination.UI.PickN (line 71, column 24 - line 81, column 79): " + [ v2.constructor.name ]);
          },
          handleQuery: Halogen_Component.defaultEval.handleQuery,
          receive: Halogen_Component.defaultEval.receive,
          initialize: Halogen_Component.defaultEval.initialize,
          finalize: Halogen_Component.defaultEval.finalize
      });
      return Halogen_Component.mkComponent({
          initialState: initialState,
          render: render,
          "eval": $$eval
      });
  };
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Domination"] = $PS["Domination.UI.Domination"] || {};
  var exports = $PS["Domination.UI.Domination"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Array_NonEmpty = $PS["Data.Array.NonEmpty"];
  var Data_Array_NonEmpty_Internal = $PS["Data.Array.NonEmpty.Internal"];
  var Data_Either = $PS["Data.Either"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_FunctorWithIndex = $PS["Data.FunctorWithIndex"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Fold = $PS["Data.Lens.Fold"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Maybe_First = $PS["Data.Maybe.First"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Unit = $PS["Data.Unit"];
  var Domination_Capability_Audio = $PS["Domination.Capability.Audio"];
  var Domination_Capability_Log = $PS["Domination.Capability.Log"];
  var Domination_Capability_Random = $PS["Domination.Capability.Random"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Game = $PS["Domination.Data.Game"];
  var Domination_Data_Game_Engine = $PS["Domination.Data.Game.Engine"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Play = $PS["Domination.Data.Play"];
  var Domination_Data_Player = $PS["Domination.Data.Player"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Stack = $PS["Domination.Data.Stack"];
  var Domination_Data_StackEvaluation = $PS["Domination.Data.StackEvaluation"];
  var Domination_Data_Supply = $PS["Domination.Data.Supply"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Data_Var = $PS["Domination.Data.Var"];
  var Domination_UI_Card = $PS["Domination.UI.Card"];
  var Domination_UI_ChoiceMoveFromTo = $PS["Domination.UI.ChoiceMoveFromTo"];
  var Domination_UI_ChooseCards = $PS["Domination.UI.ChooseCards"];
  var Domination_UI_ChooseFromSupply = $PS["Domination.UI.ChooseFromSupply"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_DomSlot = $PS["Domination.UI.DomSlot"];
  var Domination_UI_Domination_Action = $PS["Domination.UI.Domination.Action"];
  var Domination_UI_Domination_ActiveState = $PS["Domination.UI.Domination.ActiveState"];
  var Domination_UI_Domination_GameEvent = $PS["Domination.UI.Domination.GameEvent"];
  var Domination_UI_Hud = $PS["Domination.UI.Hud"];
  var Domination_UI_Icons = $PS["Domination.UI.Icons"];
  var Domination_UI_PickN = $PS["Domination.UI.PickN"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Domination_UI_Util = $PS["Domination.UI.Util"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML = $PS["Halogen.HTML"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var LoadActiveState = (function () {
      function LoadActiveState(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      LoadActiveState.create = function (value0) {
          return function (value1) {
              return new LoadActiveState(value0, value1);
          };
      };
      return LoadActiveState;
  })();
  var ReceiveGame = (function () {
      function ReceiveGame(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      ReceiveGame.create = function (value0) {
          return function (value1) {
              return new ReceiveGame(value0, value1);
          };
      };
      return ReceiveGame;
  })();
  var StartNewGameRequest = (function () {
      function StartNewGameRequest(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      StartNewGameRequest.create = function (value0) {
          return function (value1) {
              return new StartNewGameRequest(value0, value1);
          };
      };
      return StartNewGameRequest;
  })();
  var updateShowSupply = function (activeState) {
      return function (v) {
          if (v.phase instanceof Domination_Data_Phase.BuyPhase) {
              if (activeState.playerIndex === activeState.state.turn && activeState.playerIndex !== v.turn) {
                  return false;
              };
              if (activeState.playerIndex === v.turn) {
                  return true;
              };
          };
          if (v.phase instanceof Domination_Data_Phase.ActionPhase && activeState.playerIndex === v.turn) {
              return false;
          };
          return activeState.showSupply;
      };
  };
  var renderNextPhaseButton = function (v) {
      var waitingForYouToChoose = [ Halogen_HTML_Core.text("Waiting for you to Choose") ];
      var waitingForPlayerTurn = [ Halogen_HTML_Core.text("Waiting for Player " + (Data_Show.show(Data_Show.showInt)(v.state.turn + 1 | 0) + " | ")), Domination_UI_RenderText.renderText(Domination_UI_RenderText.phaseRenderText)(v.state.phase) ];
      var waitingForPlayerToChoose = [ Halogen_HTML_Core.text("Waiting for Player " + (Data_Show.show(Data_Show.showInt)(Domination_Data_Game_Engine.choiceTurn(v.state) + 1 | 0) + " to Choose")) ];
      var completeTurn = Control_Applicative.pure(Control_Applicative.applicativeArray)(Halogen_HTML_Core.text("Complete Turn"));
      var completeActionPhase = [ Halogen_HTML_Core.text("Complete "), Domination_UI_Icons.actions, Halogen_HTML_Core.text(" Phase") ];
      var competeBuyPhase = [ Halogen_HTML_Core.text("Complete "), Domination_UI_Icons.buys, Halogen_HTML_Core.text(" Phase") ];
      return Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.nextPhase), Halogen_HTML_Events.onClick(Data_Function["const"](Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.EndPhase({
          playerIndex: v.playerIndex
      })))) ])([ Halogen_HTML_Elements.span_((function () {
          var $107 = Domination_Data_Game.choicesOutstanding(v.state);
          if ($107) {
              var $108 = Domination_Data_Game_Engine.choiceTurn(v.state) === v.playerIndex;
              if ($108) {
                  return waitingForYouToChoose;
              };
              return waitingForPlayerToChoose;
          };
          var $109 = v.state.turn === v.playerIndex;
          if ($109) {
              if (v.state.phase instanceof Domination_Data_Phase.ActionPhase) {
                  return completeActionPhase;
              };
              if (v.state.phase instanceof Domination_Data_Phase.BuyPhase) {
                  return competeBuyPhase;
              };
              if (v.state.phase instanceof Domination_Data_Phase.CleanupPhase) {
                  return completeTurn;
              };
              throw new Error("Failed pattern match at Domination.UI.Domination (line 698, column 11 - line 701, column 41): " + [ v.state.phase.constructor.name ]);
          };
          return waitingForPlayerTurn;
      })()) ]);
  };
  var renderCard = function (dictDom) {
      return function (dictLog) {
          return function (onClick) {
              return function (player) {
                  return function (card) {
                      return function (slotNumber) {
                          var extraClasses = [ (function () {
                              var $113 = Data_Ord.greaterThan(Domination_Data_Actions.ordActions)(player.actions)(Data_Semiring.zero(Domination_Data_Actions.ringActions)) && Domination_Data_Card.isAction(card);
                              if ($113) {
                                  return Domination_UI_Css.canPlay;
                              };
                              return Domination_UI_Css.cantPlay;
                          })() ];
                          return Domination_UI_Card.render(dictDom)(dictLog)(onClick)(extraClasses)(card)(slotNumber);
                      };
                  };
              };
          };
      };
  };
  var renderStack = function (dictDom) {
      return function (dictLog) {
          return function (onClick) {
              return function (player) {
                  return function (slotNumber) {
                      return function (stack) {
                          return Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stack) ])([ Halogen_HTML_Elements.ul_([ Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stackCount) ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(stack.count)) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.classes([ Domination_UI_Css.stackCard, (function () {
                              var $114 = Data_Ord.greaterThan(Domination_Data_Buys.ordBuys)(player.buys)(Data_Semiring.zero(Domination_Data_Buys.ringBuys)) && (Domination_Data_Player.cash(player) >= stack.card.cost && stack.count > 0);
                              if ($114) {
                                  return Domination_UI_Css.canBuy;
                              };
                              return Domination_UI_Css.cantBuy;
                          })() ]) ])([ renderCard(dictDom)(dictLog)(onClick)(player)(stack.card)(slotNumber) ]) ]) ]);
                      };
                  };
              };
          };
      };
  };
  var renderHand = function (dictDom) {
      return function (dictLog) {
          return function (player) {
              return function (v) {
                  var title = Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.handTitle) ])([ Halogen_HTML_Core.text("Hand") ]);
                  var onClick = function (stack) {
                      return function (hand) {
                          var cardIndex = Data_Maybe.fromMaybe(-1 | 0)(Data_Array.findIndex(function ($273) {
                              return (function (v1) {
                                  return v1 === stack.card.name;
                              })((function (v1) {
                                  return v1.name;
                              })($273));
                          })(hand));
                          return Data_Function["const"](Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.PlayCard({
                              playerIndex: v.playerIndex,
                              cardIndex: cardIndex
                          })));
                      };
                  };
                  return Halogen_HTML_Elements.ul([ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Domination_UI_Css.hand, (function () {
                      var $117 = v.state.turn === v.playerIndex && Data_Eq.eq(Domination_Data_Phase.eqPhase)(v.state.phase)(Domination_Data_Phase.ActionPhase.value);
                      if ($117) {
                          return Domination_UI_Css.active;
                      };
                      return Domination_UI_Css.inactive;
                  })() ])((function () {
                      var $118 = Data_Ord.lessThan(Domination_Data_Actions.ordActions)(player.actions)(Data_Semiring.one(Domination_Data_Actions.ringActions)) || Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(Data_Array.filter(Domination_Data_Card.isAction)(player.hand)) < 1;
                      if ($118) {
                          return [ Domination_UI_Css.waiting ];
                      };
                      return [  ];
                  })())) ])(Data_Array.cons(title)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (i) {
                      return function (s) {
                          return renderStack(dictDom)(dictLog)(onClick(s)(player.hand))(player)(new Domination_UI_DomSlot.CardSlot(Domination_UI_DomSlot.HandArea.value, i))(s);
                      };
                  })(Domination_Data_Stack.stackCards(player.hand))));
              };
          };
      };
  };
  var renderSupply = function (dictDom) {
      return function (dictLog) {
          return function (player) {
              return function (v) {
                  var renderStackI = function (stackIndex) {
                      var onClick = function (v1) {
                          return Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.Purchase({
                              playerIndex: v.playerIndex,
                              stackIndex: stackIndex
                          }));
                      };
                      return renderStack(dictDom)(dictLog)(onClick)(player)(new Domination_UI_DomSlot.CardSlot(Domination_UI_DomSlot.SupplyArea.value, stackIndex));
                  };
                  return Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(renderStackI)(v.state.supply);
              };
          };
      };
  };
  var renderSupply$prime = function (dictDom) {
      return function (dictLog) {
          return function (v) {
              return function (player) {
                  var activity = (function () {
                      var $127 = v.state.turn === v.playerIndex && Data_Eq.eq(Domination_Data_Phase.eqPhase)(v.state.phase)(Domination_Data_Phase.BuyPhase.value);
                      if ($127) {
                          return Domination_UI_Css.active;
                      };
                      return Domination_UI_Css.inactive;
                  })();
                  var $128 = !v.showSupply;
                  if ($128) {
                      return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.classes([ Domination_UI_Css.supply, Domination_UI_Css.collapsed, activity ]) ])([  ]);
                  };
                  return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Domination_UI_Css.supply, Domination_UI_Css.showing, activity ])((function () {
                      var $129 = Data_Ord.lessThan(Domination_Data_Buys.ordBuys)(player.buys)(Data_Semiring.one(Domination_Data_Buys.ringBuys));
                      if ($129) {
                          return [ Domination_UI_Css.waiting ];
                      };
                      return [  ];
                  })())) ])([ Halogen_HTML_Elements.ul([ Halogen_HTML_Properties.class_(Domination_UI_Css.stats) ])([ Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stat) ])([ Halogen_HTML_Core.text("+"), Domination_UI_RenderText.renderText(Domination_UI_RenderText.victoryPointsRenderText)(Domination_Data_Supply.positivePoints(v.state.supply)) ]), Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.stat) ])([ Domination_UI_RenderText.renderText(Domination_UI_RenderText.victoryPointsRenderText)(Domination_Data_Supply.negativePoints(v.state.supply)) ]) ]), Halogen_HTML_Elements.ul_(renderSupply(dictDom)(dictLog)(player)(v)) ]);
              };
          };
      };
  };
  var renderBuying = function (dictDom) {
      return function (dictLog) {
          return function (currentPlayer) {
              var title = Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.buyingTitle) ])([ Halogen_HTML_Core.text("Buying") ]);
              var stacks = Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)((function () {
                  var $274 = renderStack(dictDom)(dictLog)(Data_Function["const"](Domination_UI_Domination_Action.DoNothing.value))(currentPlayer);
                  var $275 = Domination_UI_DomSlot.CardSlot.create(Domination_UI_DomSlot.BuyingArea.value);
                  return function ($276) {
                      return $274($275($276));
                  };
              })())(Domination_Data_Stack.stackCards(currentPlayer.buying));
              return Halogen_HTML_Elements.ul([ Halogen_HTML_Properties.class_(Domination_UI_Css.buying) ])(Data_Array.cons(title)(stacks));
          };
      };
  };
  var renderAtPlay = function (dictDom) {
      return function (dictLog) {
          return function (currentPlayer) {
              var title = Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_(Domination_UI_Css.playTitle) ])([ Halogen_HTML_Core.text("At Play") ]);
              var stacks = Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)((function () {
                  var $277 = renderStack(dictDom)(dictLog)(Data_Function["const"](Domination_UI_Domination_Action.DoNothing.value))(currentPlayer);
                  var $278 = Domination_UI_DomSlot.CardSlot.create(Domination_UI_DomSlot.AtPlayArea.value);
                  return function ($279) {
                      return $277($278($279));
                  };
              })())(Domination_Data_Stack.stackCards(currentPlayer.atPlay));
              return Halogen_HTML_Elements.ul([ Halogen_HTML_Properties.class_(Domination_UI_Css.play) ])(Data_Array.cons(title)(stacks));
          };
      };
  };
  var renderPlayer = function (dictDom) {
      return function (dictLog) {
          return function (v) {
              return function (player) {
                  var renderReaction = Data_Maybe.Just.create(Domination_UI_Util.chooseOne(Halogen_HTML_Core.text("Block attack?"))([ {
                      clickEvent: Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.React({
                          playerIndex: v.playerIndex,
                          reaction: new Data_Maybe.Just(Domination_Data_Reaction.BlockAttack.value)
                      })),
                      text: Halogen_HTML_Core.text("Yes")
                  }, {
                      clickEvent: Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.React({
                          playerIndex: v.playerIndex,
                          reaction: Data_Maybe.Nothing.value
                      })),
                      text: Halogen_HTML_Core.text("No")
                  } ]));
                  var renderChoice = function (baseSlotNumber) {
                      var playEvent = function (mk) {
                          return function (x) {
                              return function (r) {
                                  return Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.ResolveChoice({
                                      playerIndex: v.playerIndex,
                                      choice: mk((function () {
                                          var $135 = {};
                                          for (var $136 in x) {
                                              if ({}.hasOwnProperty.call(x, $136)) {
                                                  $135[$136] = x[$136];
                                              };
                                          };
                                          $135.resolution = new Data_Maybe.Just(r);
                                          return $135;
                                      })())
                                  }));
                              };
                          };
                      };
                      return Data_Functor.map(Data_Maybe.functorMaybe)(function (choice) {
                          if (choice instanceof Domination_Data_Choice.StackChoice) {
                              var v1 = Data_Array.uncons(choice.value0.expression);
                              if (v1 instanceof Data_Maybe.Nothing) {
                                  return Domination_UI_Util.h1__("Something has gone terribly wrong!!!");
                              };
                              if (v1 instanceof Data_Maybe.Just && (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && (v1.value0.head.value0.cards instanceof Domination_Data_Var.Unbound && (v1.value0.head.value0.filter instanceof Domination_Data_Var.Bound && (v1.value0.head.value0.from instanceof Domination_Data_Var.Bound && v1.value0.head.value0.n instanceof Domination_Data_Var.Bound))))) {
                                  return Halogen_HTML_Elements.div_([ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                      return "ChooseCards";
                                  }))(Domination_UI_DomSlot.ordDomSlot)(Type_Proxy["Proxy"].value)(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.ChoiceArea.value))(Domination_UI_ChooseCards.component(dictDom)(dictLog)({
                                      state: v.state,
                                      player: player,
                                      baseSlotNumber: baseSlotNumber,
                                      pile: v1.value0.head.value0.from.value0,
                                      constraint: v1.value0.head.value0.n.value0,
                                      filter: v1.value0.head.value0.filter.value0
                                  }))(Data_Unit.unit)(function ($280) {
                                      return Domination_UI_Domination_Action.MakePlay.create(Domination_Data_Play.ResolveChoice.create((function (v2) {
                                          return {
                                              playerIndex: v.playerIndex,
                                              choice: v2
                                          };
                                      })(Domination_Data_Choice.StackChoice.create((function (v2) {
                                          return {
                                              expression: v2,
                                              attack: choice.value0.attack,
                                              description: choice.value0.description,
                                              stack: choice.value0.stack
                                          };
                                      })((function (v2) {
                                          return Data_Array.cons(v2)(v1.value0.tail);
                                      })(Domination_Data_StackEvaluation.StackChooseCards.create((function (v2) {
                                          return {
                                              cards: v2,
                                              filter: v1.value0.head.value0.filter,
                                              from: v1.value0.head.value0.from,
                                              n: v1.value0.head.value0.n
                                          };
                                      })(Domination_Data_Var.Bound.create($280)))))))));
                                  }) ]);
                              };
                              if (v1 instanceof Data_Maybe.Just && (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCards && v1.value0.head.value0.cards instanceof Domination_Data_Var.Bound)) {
                                  return Domination_UI_Util.h1__("Domination: StackChooseCards:" + (" cards already chosen: " + Data_Show.show(Data_Show.showArray(Data_Show.showInt))(v1.value0.head.value0.cards.value0)));
                              };
                              if (v1 instanceof Data_Maybe.Just && (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply && v1.value0.head.value0.cardName instanceof Domination_Data_Var.Bound)) {
                                  return Domination_UI_Util.h1__("Domination: StackChooseCardFromSupply:" + (" card already chosen: " + Data_Show.show(Data_Show.showString)(v1.value0.head.value0.cardName.value0)));
                              };
                              if (v1 instanceof Data_Maybe.Just && (v1.value0.head instanceof Domination_Data_StackEvaluation.StackChooseCardFromSupply && (v1.value0.head.value0.cardName instanceof Domination_Data_Var.Unbound && v1.value0.head.value0.filter instanceof Domination_Data_Var.Bound))) {
                                  var unfiltered = Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                                      return v2.card;
                                  })(Domination_Data_Supply.nonEmptyStacks(v.state.supply));
                                  var predicate = Domination_Data_Card.passFilter(v1.value0.head.value0.filter.value0);
                                  var cards = Data_Array.filter(predicate)(unfiltered);
                                  return Halogen_HTML_Elements.div_([ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                      return "ChooseFromSupply";
                                  }))(Domination_UI_DomSlot.ordDomSlot)(Type_Proxy["Proxy"].value)(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.ChoiceArea.value))(Domination_UI_ChooseFromSupply.component(dictDom)(dictLog)({
                                      cards: cards,
                                      baseSlotNumber: baseSlotNumber
                                  }))(Data_Unit.unit)((function () {
                                      var $281 = Data_Maybe.fromMaybe("couldn't find card in supply");
                                      return function ($282) {
                                          return Domination_UI_Domination_Action.MakePlay.create(Domination_Data_Play.ResolveChoice.create((function (v2) {
                                              return {
                                                  playerIndex: v.playerIndex,
                                                  choice: v2
                                              };
                                          })(Domination_Data_Choice.StackChoice.create((function (v2) {
                                              return {
                                                  expression: v2,
                                                  attack: choice.value0.attack,
                                                  description: choice.value0.description,
                                                  stack: choice.value0.stack
                                              };
                                          })((function (v2) {
                                              return Data_Array.cons(v2)(v1.value0.tail);
                                          })(Domination_Data_StackEvaluation.StackChooseCardFromSupply.create((function (v2) {
                                              return {
                                                  cardName: v2,
                                                  filter: v1.value0.head.value0.filter
                                              };
                                          })(Domination_Data_Var.Bound.create($281($282))))))))));
                                      };
                                  })()) ]);
                              };
                              if (v1 instanceof Data_Maybe.Just && (v1.value0.head instanceof Domination_Data_StackEvaluation.StackOption && v1.value0.head.value0 instanceof Domination_Data_Var.Bound)) {
                                  return Domination_UI_Util.h1__("Domination: StackOption:" + (" decision already made: " + Data_Show.show(Data_Show.showBoolean)(v1.value0.head.value0.value0)));
                              };
                              if (v1 instanceof Data_Maybe.Just && (v1.value0.head instanceof Domination_Data_StackEvaluation.StackOption && v1.value0.head.value0 instanceof Domination_Data_Var.Unbound)) {
                                  return Domination_UI_Util.chooseOne(Halogen_HTML_Core.text(choice.value0.description))([ {
                                      clickEvent: Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.ResolveChoice({
                                          playerIndex: v.playerIndex,
                                          choice: new Domination_Data_Choice.StackChoice({
                                              expression: Data_Array.cons(Domination_Data_StackEvaluation.StackOption.create(Domination_Data_Var.Bound.create(true)))(v1.value0.tail),
                                              stack: choice.value0.stack,
                                              attack: choice.value0.attack,
                                              description: choice.value0.description
                                          })
                                      })),
                                      text: Halogen_HTML_Core.text("Yes")
                                  }, {
                                      clickEvent: Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.ResolveChoice({
                                          playerIndex: v.playerIndex,
                                          choice: new Domination_Data_Choice.StackChoice({
                                              expression: Data_Array.cons(Domination_Data_StackEvaluation.StackOption.create(Domination_Data_Var.Bound.create(false)))(v1.value0.tail),
                                              stack: choice.value0.stack,
                                              attack: choice.value0.attack,
                                              description: choice.value0.description
                                          })
                                      })),
                                      text: Halogen_HTML_Core.text("No")
                                  } ]);
                              };
                              if (v1 instanceof Data_Maybe.Just) {
                                  return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.ResolveChoice({
                                      playerIndex: v.playerIndex,
                                      choice: new Domination_Data_Choice.StackChoice(choice.value0)
                                  })));
                              };
                              throw new Error("Failed pattern match at Domination.UI.Domination (line 445, column 13 - line 562, column 20): " + [ v1.constructor.name ]);
                          };
                          if (choice instanceof Domination_Data_Choice.If) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.If.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.And) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.And.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.Or) {
                              return Domination_UI_Util.chooseOne(Halogen_HTML_Core.text("Choose one"))(Data_Functor.mapFlipped(Data_Functor.functorArray)(choice.value0.choices)(function (choice$prime) {
                                  return {
                                      clickEvent: playEvent(Domination_Data_Choice.Or.create)(choice.value0)(choice$prime),
                                      text: Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice$prime)
                                  };
                              }));
                          };
                          if (choice instanceof Domination_Data_Choice.PickN) {
                              return Halogen_HTML_Elements.div_([ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                  return "PickN";
                              }))(Domination_UI_DomSlot.ordDomSlot)(Type_Proxy["Proxy"].value)(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.ChoiceArea.value))(Domination_UI_PickN.component({
                                  title: "Choose " + Data_Show.show(Data_Show.showInt)(choice.value0.n),
                                  n: choice.value0.n,
                                  choices: choice.value0.choices
                              }))(Data_Unit.unit)(function ($283) {
                                  return Domination_UI_Domination_Action.MakePlay.create(Domination_Data_Play.ResolveChoice.create((function (v1) {
                                      return {
                                          playerIndex: v.playerIndex,
                                          choice: v1
                                      };
                                  })(Domination_Data_Choice.PickN.create((function (v1) {
                                      return {
                                          resolution: v1,
                                          attack: choice.value0.attack,
                                          choices: choice.value0.choices,
                                          n: choice.value0.n
                                      };
                                  })(Data_Maybe.Just.create($283))))));
                              }) ]);
                          };
                          if (choice instanceof Domination_Data_Choice.Option) {
                              return Domination_UI_Util.chooseOne(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice.value0.choice))([ {
                                  clickEvent: Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.ResolveChoice({
                                      playerIndex: v.playerIndex,
                                      choice: new Domination_Data_Choice.Option({
                                          choice: choice.value0.choice,
                                          resolution: new Data_Maybe.Just(true),
                                          attack: choice.value0.attack
                                      })
                                  })),
                                  text: Halogen_HTML_Core.text("Yes")
                              }, {
                                  clickEvent: Domination_UI_Domination_Action.MakePlay.create(new Domination_Data_Play.ResolveChoice({
                                      playerIndex: v.playerIndex,
                                      choice: new Domination_Data_Choice.Option({
                                          choice: choice.value0.choice,
                                          resolution: new Data_Maybe.Just(false),
                                          attack: choice.value0.attack
                                      })
                                  })),
                                  text: Halogen_HTML_Core.text("No")
                              } ]);
                          };
                          if (choice instanceof Domination_Data_Choice.MoveFromTo) {
                              return Halogen_HTML_Elements.div_([ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                  return "MoveFromTo";
                              }))(Domination_UI_DomSlot.ordDomSlot)(Type_Proxy["Proxy"].value)(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.ChoiceArea.value))(Domination_UI_ChoiceMoveFromTo.component(dictDom)(dictLog)(v.state)(player)(choice)(baseSlotNumber))(Data_Unit.unit)(function ($284) {
                                  return Domination_UI_Domination_Action.MakePlay.create(Domination_Data_Play.ResolveChoice.create((function (v1) {
                                      return {
                                          playerIndex: v.playerIndex,
                                          choice: v1
                                      };
                                  })($284)));
                              }) ]);
                          };
                          if (choice instanceof Domination_Data_Choice.GainCards) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.GainCards.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.GainCard) {
                              var unfiltered = Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                                  return v1.card;
                              })(Domination_Data_Supply.nonEmptyStacks(v.state.supply));
                              var predicate = Domination_Data_Card.passFilter(choice.value0.filter);
                              var cards = Data_Array.filter(predicate)(unfiltered);
                              return Halogen_HTML_Elements.div_([ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                  return "ChooseFromSupply";
                              }))(Domination_UI_DomSlot.ordDomSlot)(Type_Proxy["Proxy"].value)(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.ChoiceArea.value))(Domination_UI_ChooseFromSupply.component(dictDom)(dictLog)({
                                  cards: cards,
                                  baseSlotNumber: baseSlotNumber
                              }))(Data_Unit.unit)(function ($285) {
                                  return Domination_UI_Domination_Action.MakePlay.create(Domination_Data_Play.ResolveChoice.create((function (v1) {
                                      return {
                                          playerIndex: v.playerIndex,
                                          choice: v1
                                      };
                                  })(Domination_Data_Choice.GainCard.create((function (v1) {
                                      return {
                                          attack: choice.value0.attack,
                                          filter: choice.value0.filter,
                                          destination: choice.value0.destination,
                                          resolution: v1
                                      };
                                  })($285)))));
                              }) ]);
                          };
                          if (choice instanceof Domination_Data_Choice.GainActions) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.GainActions.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.GainBuys) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.GainBuys.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.Discard) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.Discard.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.Draw) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.Draw.create)(choice.value0)(Data_Unit.unit));
                          };
                          if (choice instanceof Domination_Data_Choice.GainBonus) {
                              return Domination_UI_Util.acknowledge(Domination_UI_RenderText.renderText(Domination_UI_RenderText.choiceRenderText)(choice))(playEvent(Domination_Data_Choice.GainBonus.create)(choice.value0)(Data_Unit.unit));
                          };
                          throw new Error("Failed pattern match at Domination.UI.Domination (line 443, column 52 - line 668, column 41): " + [ choice.constructor.name ]);
                      });
                  };
                  return [ Domination_UI_Hud.render(v), (function () {
                      var $197 = Domination_Data_Player.hasChoices(player) && v.playerIndex === Domination_Data_Game_Engine.choiceTurn(v.state);
                      if ($197) {
                          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.dialogue) ])(Data_Maybe.fromMaybe([  ])((function () {
                              var isAttacked = Domination_Data_Game.isAttacked(v.playerIndex)(v.state);
                              var hasReaction = Domination_Data_Game.hasReaction(v.playerIndex)(v.state);
                              var choice = Domination_Data_Player.firstChoice(player);
                              var $198 = isAttacked && hasReaction;
                              if ($198) {
                                  return Data_Functor.map(Data_Maybe.functorMaybe)(Control_Applicative.pure(Control_Applicative.applicativeArray))(renderReaction);
                              };
                              return Data_Functor.map(Data_Maybe.functorMaybe)(Control_Applicative.pure(Control_Applicative.applicativeArray))(renderChoice(Domination_UI_DomSlot.CardSlot.create(Domination_UI_DomSlot.ChoiceArea.value))(choice));
                          })()));
                      };
                      return Halogen_HTML_Elements.div_([  ]);
                  })(), (function () {
                      var v1 = Data_Array_NonEmpty.index(v.state.players)(v.state.turn);
                      if (v1 instanceof Data_Maybe.Nothing) {
                          return Domination_UI_Util.h1__("No player (" + (Data_Show.show(Data_Show.showInt)(v.state.turn) + (") in " + Data_Show.show(Data_Array_NonEmpty_Internal.showNonEmptyArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "atPlay";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "bonuses";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buying";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "choices";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "deck";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "discard";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "hand";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "toDiscard";
                          }))(Data_Show.showRecordFieldsNil)(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Domination_Data_Choice.showChoice)))(Domination_Data_Buys.showBuys))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Data_Show.showArray(Domination_Data_Bonus.showBonus)))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "actions";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "buys";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cards";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "cost";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "name";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "reaction";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "special";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "treasure";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "types";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "victoryPoints";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Points.showPoints))(Data_Show.showArray(Domination_Data_CardType.showCardType)))(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "command";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "description";
                          }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
                              return "target";
                          }))(Data_Show.showRecordFieldsNil)(Domination_Data_Target.showTarget))(Data_Show.showString))(Domination_Data_Card.showCommand)))))(Data_Maybe.showMaybe(Domination_Data_Reaction.showReaction)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Domination_Data_Buys.showBuys))(Domination_Data_Actions.showActions)))))(Domination_Data_Actions.showActions))))(v.state.players))));
                      };
                      if (v1 instanceof Data_Maybe.Just) {
                          return Halogen_HTML_Elements.div((function () {
                              var $200 = v.state.turn !== v.playerIndex || Domination_Data_Game.choicesOutstanding(v.state);
                              if ($200) {
                                  return [ Halogen_HTML_Properties.class_(Domination_UI_Css.waiting) ];
                              };
                              return [  ];
                          })())([ renderSupply$prime(dictDom)(dictLog)(v)(player), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.table) ])([ renderAtPlay(dictDom)(dictLog)(v1.value0), renderBuying(dictDom)(dictLog)(v1.value0) ]), renderHand(dictDom)(dictLog)(player)(v), Domination_UI_Hud.renderHandInfos(v), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.controls) ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.undo), Halogen_HTML_Events.onClick(function (v2) {
                              return new Domination_UI_Domination_Action.UndoRequest(v);
                          }) ])([ Halogen_HTML_Core.text("Undo") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.supplyToggle), Halogen_HTML_Events.onClick(function (v2) {
                              return Domination_UI_Domination_Action.ToggleSupply.value;
                          }) ])([ Halogen_HTML_Core.text("Supply") ]), renderNextPhaseButton(v) ]) ]);
                      };
                      throw new Error("Failed pattern match at Domination.UI.Domination (line 390, column 5 - line 421, column 10): " + [ v1.constructor.name ]);
                  })() ];
              };
          };
      };
  };
  var renderPlayers = function (dictDom) {
      return function (dictLog) {
          return function (v) {
              var v1 = Data_Array_NonEmpty.index(v.state.players)(v.playerIndex);
              if (v1 instanceof Data_Maybe.Nothing) {
                  return [ Halogen_HTML_Core.text("You cannot be player " + (Data_Show.show(Data_Show.showInt)(v.playerIndex + 1 | 0) + (" in a " + (Data_Show.show(Data_Show.showInt)(Data_Foldable.length(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringInt)(v.state.players)) + " player game.")))) ];
              };
              if (v1 instanceof Data_Maybe.Just) {
                  return renderPlayer(dictDom)(dictLog)(v)(v1.value0);
              };
              throw new Error("Failed pattern match at Domination.UI.Domination (line 361, column 3 - line 367, column 42): " + [ v1.constructor.name ]);
          };
      };
  };
  var renderPlayerN = function (dictDom) {
      return function (dictLog) {
          return function (activeState) {
              return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.domination) ])((function () {
                  if (activeState.state.result instanceof Data_Maybe.Nothing) {
                      return renderPlayers(dictDom)(dictLog)(activeState);
                  };
                  if (activeState.state.result instanceof Data_Maybe.Just) {
                      return [ Domination_UI_Hud.render(activeState), Domination_UI_RenderText.renderText(Domination_UI_RenderText.resultRenderText)(activeState.state.result.value0) ];
                  };
                  throw new Error("Failed pattern match at Domination.UI.Domination (line 221, column 3 - line 226, column 8): " + [ activeState.state.result.constructor.name ]);
              })());
          };
      };
  };
  var playAndReport = function (dictLog) {
      return function (dictRandom) {
          return function (dictAudio) {
              return function (playerIndex) {
                  return function (play) {
                      return function (audioContext) {
                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Data_Game_Engine.makeAutoPlay(Domination_Capability_Random.randomHalogenM(dictRandom))(Domination_Capability_Log.logHalogenM(dictLog))(play)(v.state))(function (result) {
                                  if (result instanceof Data_Either.Left) {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Audio.beep(Domination_Capability_Audio.audioHalogenM(dictAudio))(audioContext)(Domination_Capability_Audio["Error"].value))(function () {
                                          return Domination_Capability_Log.error(Domination_Capability_Log.logHalogenM(dictLog))(result.value0);
                                      });
                                  };
                                  if (result instanceof Data_Either.Right) {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                          if (play instanceof Domination_Data_Play.Purchase) {
                                              return Domination_Capability_Audio.beep(Domination_Capability_Audio.audioHalogenM(dictAudio))(audioContext)(Domination_Capability_Audio.Purchase.value);
                                          };
                                          return Domination_Capability_Audio.beep(Domination_Capability_Audio.audioHalogenM(dictAudio))(audioContext)(Domination_Capability_Audio.Acknowledge.value);
                                      })())(function () {
                                          var playMade = (function () {
                                              if (play instanceof Domination_Data_Play.EndPhase) {
                                                  return Data_Maybe.Nothing.value;
                                              };
                                              return new Data_Maybe.Just({
                                                  play: play,
                                                  playerIndex: playerIndex,
                                                  state: v.state
                                              });
                                          })();
                                          var newShowSupply = (function () {
                                              if (play instanceof Domination_Data_Play.NewGame && playerIndex === result.value0.turn) {
                                                  return true;
                                              };
                                              if (v.state.phase instanceof Domination_Data_Phase.BuyPhase && (playerIndex === v.state.turn && playerIndex !== result.value0.turn)) {
                                                  return false;
                                              };
                                              if (result.value0.phase instanceof Domination_Data_Phase.ActionPhase && playerIndex === result.value0.turn) {
                                                  return false;
                                              };
                                              return v.showSupply;
                                          })();
                                          var newI = (function () {
                                              if (play instanceof Domination_Data_Play.NewGame) {
                                                  return 0;
                                              };
                                              return v.i + 1 | 0;
                                          })();
                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                              var $286 = Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_showSupply"](Data_Profunctor_Strong.strongFn))(newShowSupply);
                                              var $287 = Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_i"](Data_Profunctor_Strong.strongFn))(newI);
                                              var $288 = Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_playerIndex"](Data_Profunctor_Strong.strongFn))(v.playerIndex);
                                              return function ($289) {
                                                  return $286($287($288($289)));
                                              };
                                          })()))(function () {
                                              return Halogen_Query_HalogenM.raise(new Domination_UI_Domination_GameEvent.NewState(Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_state"](Data_Profunctor_Strong.strongFn))(result.value0)(Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_i"](Data_Profunctor_Strong.strongFn))(newI)(v)), playMade));
                                          });
                                      });
                                  };
                                  throw new Error("Failed pattern match at Domination.UI.Domination (line 829, column 3 - line 864, column 17): " + [ result.constructor.name ]);
                              });
                          });
                      };
                  };
              };
          };
      };
  };
  var handleQuery = function (dictLog) {
      return function (dictStorage) {
          return function (dictAudio) {
              return function (dictRandom) {
                  return function (audioContext) {
                      return function (v) {
                          if (v instanceof ReceiveGame) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (activeGame) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                      var $231 = Domination_Data_Game.isAttacked(activeGame.playerIndex)(v.value0.state);
                                      if ($231) {
                                          return Domination_Capability_Audio.beep(Domination_Capability_Audio.audioHalogenM(dictAudio))(audioContext)(Domination_Capability_Audio.Attacked.value);
                                      };
                                      var $232 = Domination_Data_Game.isBenefitted(activeGame.playerIndex)(v.value0.state);
                                      if ($232) {
                                          return Domination_Capability_Audio.beep(Domination_Capability_Audio.audioHalogenM(dictAudio))(audioContext)(Domination_Capability_Audio.Benefitted.value);
                                      };
                                      var $233 = activeGame.state.turn !== activeGame.playerIndex && v.value0.state.turn === activeGame.playerIndex;
                                      if ($233) {
                                          return Domination_Capability_Audio.beep(Domination_Capability_Audio.audioHalogenM(dictAudio))(audioContext)(Domination_Capability_Audio.YourTurn.value);
                                      };
                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                  })())(function () {
                                      var expectedI = activeGame.i + 1 | 0;
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Expected i = " + (Data_Show.show(Data_Show.showInt)(expectedI) + (". Received i = " + Data_Show.show(Data_Show.showInt)(v.value0.i)))))(function () {
                                          var newShowSupply = updateShowSupply(activeGame)(v.value0.state);
                                          var newActiveState = {
                                              playerIndex: activeGame.playerIndex,
                                              playerCount: Data_Foldable.length(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringInt)(v.value0.state.players),
                                              state: v.value0.state,
                                              i: v.value0.i,
                                              showSupply: newShowSupply
                                          };
                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(newActiveState))(function () {
                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.raise(new Domination_UI_Domination_GameEvent.SaveGame(newActiveState)))(function () {
                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                                              });
                                          });
                                      });
                                  });
                              });
                          };
                          if (v instanceof LoadActiveState) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (activeGame) {
                                  var newShowSupply = updateShowSupply(activeGame)(v.value0.state);
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_showSupply"](Data_Profunctor_Strong.strongFn))(newShowSupply)(v.value0)))(function () {
                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                                  });
                              });
                          };
                          if (v instanceof StartNewGameRequest) {
                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_playerIndex"](Data_Profunctor_Strong.strongFn))(v.value0.nextPlayerIndex)))(function () {
                                  var v1 = Data_Array.filter(function (v2) {
                                      return v2.selected;
                                  })(v.value0.kingdom);
                                  var v2 = function ($290) {
                                      return Domination_Data_Card["_card"]((function (v3) {
                                          return v3.cardSpec;
                                      })($290));
                                  };
                                  var v3 = Data_Functor.map(Data_Functor.functorArray)(v2)(v1);
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(playAndReport(dictLog)(dictRandom)(dictAudio)(v.value0.nextPlayerIndex)(new Domination_Data_Play.NewGame({
                                      playerCount: v.value0.nextPlayerCount,
                                      supply: v3,
                                      longGame: v.value0.longGame
                                  }))(audioContext))(function () {
                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                                  });
                              });
                          };
                          throw new Error("Failed pattern match at Domination.UI.Domination (line 142, column 28 - line 199, column 18): " + [ v.constructor.name ]);
                      };
                  };
              };
          };
      };
  };
  var handleAction = function (dictLog) {
      return function (dictRandom) {
          return function (dictAudio) {
              return function (audioContext) {
                  return function (v) {
                      if (v instanceof Domination_UI_Domination_Action.MakePlay) {
                          var playerIndex = Data_Maybe.fromMaybe(0)(Data_Lens_Fold.previewOn(v.value0)(Domination_Data_Play["_playerIndex"](Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst))));
                          return playAndReport(dictLog)(dictRandom)(dictAudio)(playerIndex)(v.value0)(audioContext);
                      };
                      if (v instanceof Domination_UI_Domination_Action.UndoRequest) {
                          return Halogen_Query_HalogenM.raise(new Domination_UI_Domination_GameEvent.Undo(v.value0));
                      };
                      if (v instanceof Domination_UI_Domination_Action.ToggleSupply) {
                          return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over(Domination_UI_Domination_ActiveState["_showSupply"](Data_Profunctor_Strong.strongFn))(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean)));
                      };
                      if (v instanceof Domination_UI_Domination_Action.DoNothing) {
                          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                      };
                      throw new Error("Failed pattern match at Domination.UI.Domination (line 806, column 29 - line 812, column 25): " + [ v.constructor.name ]);
                  };
              };
          };
      };
  }; 
  var component = function (dictLog) {
      return function (dictStorage) {
          return function (dictDom) {
              return function (dictRandom) {
                  return function (dictAudio) {
                      return function (config) {
                          return function (audioContext) {
                              var kingdom = Data_Functor.map(Data_Functor.functorArray)(function ($291) {
                                  return Domination_Data_Card["_card"]((function (v) {
                                      return v.cardSpec;
                                  })($291));
                              })(Data_Array.filter(function (v) {
                                  return v.selected;
                              })(config.kingdom));
                              var initialState = function (v) {
                                  return {
                                      i: 0,
                                      playerIndex: config.nextPlayerIndex,
                                      playerCount: config.nextPlayerCount,
                                      state: Domination_Data_Game["new"](1)(kingdom)(config.longGame),
                                      showSupply: true
                                  };
                              };
                              var $$eval = Halogen_Component.mkEval({
                                  handleAction: handleAction(dictLog)(dictRandom)(dictAudio)(audioContext),
                                  handleQuery: handleQuery(dictLog)(dictStorage)(dictAudio)(dictRandom)(audioContext),
                                  receive: Halogen_Component.defaultEval.receive,
                                  initialize: Halogen_Component.defaultEval.initialize,
                                  finalize: Halogen_Component.defaultEval.finalize
                              });
                              return Halogen_Component.mkComponent({
                                  initialState: initialState,
                                  render: renderPlayerN(dictDom)(dictLog),
                                  "eval": $$eval
                              });
                          };
                      };
                  };
              };
          };
      };
  };
  var _component = Type_Proxy["Proxy"].value;
  exports["LoadActiveState"] = LoadActiveState;
  exports["ReceiveGame"] = ReceiveGame;
  exports["StartNewGameRequest"] = StartNewGameRequest;
  exports["_component"] = _component;
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.ServerUrlInput"] = $PS["Domination.UI.ServerUrlInput"] || {};
  var exports = $PS["Domination.UI.ServerUrlInput"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];                
  var render = function (v) {
      return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.serverUrlInput) ])([ Halogen_HTML_Elements.label_([ Halogen_HTML_Core.text("Server URL: ") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputText.value), Halogen_HTML_Properties.value(v.state.serverUrl), Halogen_HTML_Properties.placeholder("e.g. wss://purescript-wip.onrender.com"), Halogen_HTML_Properties.required(true), Halogen_HTML_Events.onValueInput(v.onInput) ]) ]);
  };
  exports["render"] = render;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.UsernameInput"] = $PS["Domination.UI.UsernameInput"] || {};
  var exports = $PS["Domination.UI.UsernameInput"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];                
  var render = function (v) {
      return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.usernameInput) ])([ Halogen_HTML_Elements.label_([ Halogen_HTML_Core.text("Username: ") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputText.value), Halogen_HTML_Properties.value(v.state.username), Halogen_HTML_Properties.placeholder("Username"), Halogen_HTML_Properties.required(true), Halogen_HTML_Events.onValueInput(v.onInput) ]) ]);
  };
  exports["render"] = render;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Version"] = $PS["Version"] || {};
  var exports = $PS["Version"];
  var Version = (function () {
      function Version(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      Version.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new Version(value0, value1, value2);
              };
          };
      };
      return Version;
  })();
  var version = new Version(0, 34, 0);
  exports["version"] = version;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Domination.UI.Settings"] = $PS["Domination.UI.Settings"] || {};
  var exports = $PS["Domination.UI.Settings"];
  var AppAction = $PS["AppAction"];
  var AppState = $PS["AppState"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Index = $PS["Data.Lens.Index"];
  var Data_Lens_Record = $PS["Data.Lens.Record"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Profunctor_Choice = $PS["Data.Profunctor.Choice"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_UI_Card = $PS["Domination.UI.Card"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_DomSlot = $PS["Domination.UI.DomSlot"];
  var Domination_UI_RenderText = $PS["Domination.UI.RenderText"];
  var Domination_UI_ServerUrlInput = $PS["Domination.UI.ServerUrlInput"];
  var Domination_UI_UsernameInput = $PS["Domination.UI.UsernameInput"];
  var Domination_UI_Util = $PS["Domination.UI.Util"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Type_Proxy = $PS["Type.Proxy"];
  var Version = $PS["Version"];                
  var renderKingdom = function (dictDom) {
      return function (dictLog) {
          return function (kingdom) {
              var slot = Domination_UI_DomSlot.CardSlot.create(Domination_UI_DomSlot.KingdomConfigArea.value);
              var onClick = function (i) {
                  return function (cardSpec) {
                      return function (selected) {
                          return function (v) {
                              var toggleSelected = Data_Lens_Setter.over((function () {
                                  var $36 = Data_Lens_Index.ix(Data_Lens_Index.indexArray)(i)(Data_Profunctor_Strong.strongFn)(Data_Profunctor_Choice.choiceFn);
                                  var $37 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
                                      return "selected";
                                  }))()()(Type_Proxy["Proxy"].value)(Data_Profunctor_Strong.strongFn);
                                  return function ($38) {
                                      return $36($37($38));
                                  };
                              })())(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean));
                              var requirements = Domination_Data_Card["_requirements"](cardSpec);
                              var selectRequirement = function (v1) {
                                  return {
                                      cardSpec: v1.cardSpec,
                                      selected: v1.selected || !selected && Data_Array.elem(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                                          return "victoryPoints";
                                      }))(Domination_Data_Points.eqPoints))()(new Data_Symbol.IsSymbol(function () {
                                          return "types";
                                      }))(Data_Eq.eqArray(Domination_Data_CardType.eqCardType)))()(new Data_Symbol.IsSymbol(function () {
                                          return "treasure";
                                      }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                                          return "special";
                                      }))(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                                          return "target";
                                      }))(Domination_Data_Target.eqTarget))()(new Data_Symbol.IsSymbol(function () {
                                          return "description";
                                      }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                                          return "command";
                                      }))(Domination_Data_Card.eqCommand)))))()(new Data_Symbol.IsSymbol(function () {
                                          return "reaction";
                                      }))(Data_Maybe.eqMaybe(Domination_Data_Reaction.eqReaction)))()(new Data_Symbol.IsSymbol(function () {
                                          return "name";
                                      }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                                          return "cost";
                                      }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                                          return "cards";
                                      }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                                          return "buys";
                                      }))(Domination_Data_Buys.eqBuys))()(new Data_Symbol.IsSymbol(function () {
                                          return "actions";
                                      }))(Domination_Data_Actions.eqActions)))(Domination_Data_Card["_card"](v1.cardSpec))(requirements)
                                  };
                              };
                              var selectRequirements = function (selections) {
                                  return Data_Functor.map(Data_Functor.functorArray)(selectRequirement)(selections);
                              };
                              var newKingdom = selectRequirements(toggleSelected(kingdom));
                              return new AppAction.ChooseKingdom(newKingdom);
                          };
                      };
                  };
              };
              var extraClasses = function (selected) {
                  return [ (function () {
                      if (selected) {
                          return Domination_UI_Css.active;
                      };
                      return Domination_UI_Css.inactive;
                  })() ];
              };
              var renderCard = function (i) {
                  return function (v) {
                      return Domination_UI_Card.render(dictDom)(dictLog)(onClick(i)(v.cardSpec)(v.selected))(extraClasses(v.selected))(Domination_Data_Card["_card"](v.cardSpec))(slot(i));
                  };
              };
              return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.kingdom) ])(Data_Array.mapWithIndex(renderCard)(kingdom));
          };
      };
  };
  var renderEmpty = function (dictDom) {
      return function (dictLog) {
          return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.classes([ Domination_UI_Css.settingsMenu, Domination_UI_Css.collapsed ]) ])([  ]);
      };
  };
  var render = function (dictDom) {
      return function (dictLog) {
          return function (v) {
              return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.classes([ Domination_UI_Css.settingsMenu, (function () {
                  if (v.showMenu) {
                      return Domination_UI_Css.showing;
                  };
                  return Domination_UI_Css.collapsed;
              })() ]) ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Domination_UI_Css.backButtonContainer) ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return AppAction.ToggleMenu.value;
              }), Halogen_HTML_Properties.class_(Domination_UI_Css.backButton) ])([ Halogen_HTML_Core.text("Back") ]) ]), Domination_UI_RenderText.renderText(Domination_UI_RenderText.versionRenderText)(Version.version), Domination_UI_ServerUrlInput.render({
                  onInput: AppAction.WriteServerUrl.create,
                  state: v
              }), Domination_UI_UsernameInput.render({
                  onInput: AppAction.WriteUsername.create,
                  state: v
              }), Domination_UI_Util.incrementer({
                  label: "Players: ",
                  mbMin: new Data_Maybe.Just(1),
                  mbMax: Data_Maybe.Nothing.value,
                  value: v.dominationConfig.nextPlayerCount,
                  setValue: AppAction.WritePlayerCount.create
              }), Domination_UI_Util.incrementer({
                  label: "Player #: ",
                  mbMin: new Data_Maybe.Just(1),
                  mbMax: Data_Maybe.Nothing.value,
                  value: v.dominationConfig.nextPlayerIndex + 1 | 0,
                  setValue: function ($39) {
                      return AppAction.WritePlayerIndex.create((function (v1) {
                          return v1 - 1 | 0;
                      })($39));
                  }
              }), Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return AppAction.StartNewGame.value;
              }), Halogen_HTML_Properties.class_(Domination_UI_Css.newGameButton) ])([ Halogen_HTML_Core.text("Start " + ((function () {
                  if (v.dominationConfig.longGame) {
                      return "Long ";
                  };
                  return "Short ";
              })() + (Data_Show.show(Data_Show.showInt)(v.dominationConfig.nextPlayerCount) + (" Player Game as Player " + Data_Show.show(Data_Show.showInt)(v.dominationConfig.nextPlayerIndex + 1 | 0))))) ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return AppAction.LoadGameRequest.value;
              }), Halogen_HTML_Properties.class_(Domination_UI_Css.loadGameButton) ])([ Halogen_HTML_Core.text("Load Game") ]) ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.label([ Halogen_HTML_Properties.class_(Domination_UI_Css.toggleLongGame) ])([ Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(v.dominationConfig.longGame), Halogen_HTML_Events.onChecked(function (v1) {
                  return AppAction.ToggleLongGame.value;
              }) ]), Halogen_HTML_Core.text("Don't end the game until the leader can't be beaten") ]) ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return new AppAction.ChooseKingdom(Data_Functor.map(Data_Functor.functorArray)(Data_Lens_Setter.over(Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
                      return "selected";
                  }))()()(Type_Proxy["Proxy"].value)(Data_Profunctor_Strong.strongFn))(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean)))(AppState.defaultKingdom));
              }) ])([ Halogen_HTML_Core.text("Select None") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return AppAction.RandomizeKingdom.value;
              }) ])([ Halogen_HTML_Core.text("Randomize Kingdom") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v1) {
                  return new AppAction.ChooseKingdom(AppState.defaultKingdom);
              }) ])([ Halogen_HTML_Core.text("Select All") ]), renderKingdom(dictDom)(dictLog)(v.dominationConfig.kingdom) ]);
          };
      };
  };
  exports["renderEmpty"] = renderEmpty;
  exports["render"] = render;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Emojis"] = $PS["Emojis"] || {};
  var exports = $PS["Emojis"];
  var emojis = [ "\ud83d\ude04", "\ud83d\ude03", "\ud83d\ude00", "\ud83d\ude0a", "\u263a", "\ud83d\ude09", "\ud83d\ude0d", "\ud83d\ude18", "\ud83d\ude1a", "\ud83d\ude17", "\ud83d\ude19", "\ud83d\ude1c", "\ud83d\ude1d", "\ud83d\ude1b", "\ud83d\ude33", "\ud83d\ude01", "\ud83d\ude14", "\ud83d\ude0c", "\ud83d\ude12", "\ud83d\ude1e", "\ud83d\ude23", "\ud83d\ude22", "\ud83d\ude02", "\ud83d\ude2d", "\ud83d\ude2a", "\ud83d\ude25", "\ud83d\ude30", "\ud83d\ude05", "\ud83d\ude13", "\ud83d\ude29", "\ud83d\ude2b", "\ud83d\ude28", "\ud83d\ude31", "\ud83d\ude20", "\ud83d\ude21", "\ud83d\ude24", "\ud83d\ude16", "\ud83d\ude06", "\ud83d\ude0b", "\ud83d\ude37", "\ud83d\ude0e", "\ud83d\ude34", "\ud83d\ude35", "\ud83d\ude32", "\ud83d\ude1f", "\ud83d\ude26", "\ud83d\ude27", "\ud83d\ude08", "\ud83d\udc7f", "\ud83d\ude2e", "\ud83d\ude2c", "\ud83d\ude10", "\ud83d\ude15", "\ud83d\ude2f", "\ud83d\ude36", "\ud83d\ude07", "\ud83d\ude0f", "\ud83d\ude11", "\ud83d\udc72", "\ud83d\udc73", "\ud83d\udc6e", "\ud83d\udc77", "\ud83d\udc82", "\ud83d\udc76", "\ud83d\udc66", "\ud83d\udc67", "\ud83d\udc68", "\ud83d\udc69", "\ud83d\udc74", "\ud83d\udc75", "\ud83d\udc71", "\ud83d\udc7c", "\ud83d\udc78", "\ud83d\ude3a", "\ud83d\ude38", "\ud83d\ude3b", "\ud83d\ude3d", "\ud83d\ude3c", "\ud83d\ude40", "\ud83d\ude3f", "\ud83d\ude39", "\ud83d\ude3e" ];
  exports["emojis"] = emojis;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Aff.Driver.State"] = $PS["Halogen.Aff.Driver.State"] || {};
  var exports = $PS["Halogen.Aff.Driver.State"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var unRenderStateX = Unsafe_Coerce.unsafeCoerce;
  var unDriverStateX = Unsafe_Coerce.unsafeCoerce;
  var renderStateX_ = function (dictApplicative) {
      return function (f) {
          return unDriverStateX(function (st) {
              return Data_Foldable.traverse_(dictApplicative)(Data_Foldable.foldableMaybe)(f)(st.rendering);
          });
      };
  };
  var mkRenderStateX = Unsafe_Coerce.unsafeCoerce;
  var renderStateX = function (dictFunctor) {
      return function (f) {
          return unDriverStateX(function (st) {
              return mkRenderStateX(f(st.rendering));
          });
      };
  };
  var mkDriverStateXRef = Unsafe_Coerce.unsafeCoerce;
  var mapDriverState = function (f) {
      return function (v) {
          return f(v);
      };
  };
  var initDriverState = function (component) {
      return function (input) {
          return function (handler) {
              return function (lchs) {
                  return function __do() {
                      var selfRef = Effect_Ref["new"]({})();
                      var childrenIn = Effect_Ref["new"](Halogen_Data_Slot.empty)();
                      var childrenOut = Effect_Ref["new"](Halogen_Data_Slot.empty)();
                      var handlerRef = Effect_Ref["new"](handler)();
                      var pendingQueries = Effect_Ref["new"](new Data_Maybe.Just(Data_List_Types.Nil.value))();
                      var pendingOuts = Effect_Ref["new"](new Data_Maybe.Just(Data_List_Types.Nil.value))();
                      var pendingHandlers = Effect_Ref["new"](Data_Maybe.Nothing.value)();
                      var fresh = Effect_Ref["new"](1)();
                      var subscriptions = Effect_Ref["new"](new Data_Maybe.Just(Data_Map_Internal.empty))();
                      var forks = Effect_Ref["new"](Data_Map_Internal.empty)();
                      var ds = {
                          component: component,
                          state: component.initialState(input),
                          refs: Data_Map_Internal.empty,
                          children: Halogen_Data_Slot.empty,
                          childrenIn: childrenIn,
                          childrenOut: childrenOut,
                          selfRef: selfRef,
                          handlerRef: handlerRef,
                          pendingQueries: pendingQueries,
                          pendingOuts: pendingOuts,
                          pendingHandlers: pendingHandlers,
                          rendering: Data_Maybe.Nothing.value,
                          fresh: fresh,
                          subscriptions: subscriptions,
                          forks: forks,
                          lifecycleHandlers: lchs
                      };
                      Effect_Ref.write(ds)(selfRef)();
                      return mkDriverStateXRef(selfRef);
                  };
              };
          };
      };
  };
  exports["mapDriverState"] = mapDriverState;
  exports["unDriverStateX"] = unDriverStateX;
  exports["renderStateX"] = renderStateX;
  exports["renderStateX_"] = renderStateX_;
  exports["unRenderStateX"] = unRenderStateX;
  exports["initDriverState"] = initDriverState;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Aff.Driver.Eval"] = $PS["Halogen.Aff.Driver.Eval"] || {};
  var exports = $PS["Halogen.Aff.Driver.Eval"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Applicative_Free = $PS["Control.Applicative.Free"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Fork_Class = $PS["Control.Monad.Fork.Class"];
  var Control_Monad_Free = $PS["Control.Monad.Free"];
  var Control_Parallel = $PS["Control.Parallel"];
  var Control_Parallel_Class = $PS["Control.Parallel.Class"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Coyoneda = $PS["Data.Coyoneda"];
  var Data_Either = $PS["Data.Either"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Aff_Driver_State = $PS["Halogen.Aff.Driver.State"];
  var Halogen_Query_ChildQuery = $PS["Halogen.Query.ChildQuery"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Halogen_Query_HalogenQ = $PS["Halogen.Query.HalogenQ"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Halogen_Subscription = $PS["Halogen.Subscription"];
  var Unsafe_Reference = $PS["Unsafe.Reference"];                
  var unsubscribe = function (sid) {
      return function (ref) {
          return function __do() {
              var v = Effect_Ref.read(ref)();
              var subs = Effect_Ref.read(v.subscriptions)();
              return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Halogen_Subscription.unsubscribe)(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Halogen_Query_HalogenM.ordSubscriptionId)(sid))(subs))();
          };
      };
  };
  var queueOrRun = function (ref) {
      return function (au) {
          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v) {
              if (v instanceof Data_Maybe.Nothing) {
                  return au;
              };
              if (v instanceof Data_Maybe.Just) {
                  return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write(new Data_Maybe.Just(new Data_List_Types.Cons(au, v.value0)))(ref));
              };
              throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 182, column 33 - line 184, column 57): " + [ v.constructor.name ]);
          });
      };
  };
  var handleLifecycle = function (lchs) {
      return function (f) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write({
              initializers: Data_List_Types.Nil.value,
              finalizers: Data_List_Types.Nil.value
          })(lchs)))(function () {
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(f))(function (result) {
                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(lchs)))(function (v) {
                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_List_Types.foldableList)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff))(v.finalizers))(function () {
                          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Control_Parallel.parSequence_(Effect_Aff.parallelAff)(Data_List_Types.foldableList)(v.initializers))(function () {
                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(result);
                          });
                      });
                  });
              });
          });
      };
  };
  var handleAff = Effect_Aff.runAff_(Data_Either.either(Effect_Exception.throwException)(Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit))));
  var fresh = function (f) {
      return function (ref) {
          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v) {
              return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["modify'"](function (i) {
                  return {
                      state: i + 1 | 0,
                      value: f(i)
                  };
              })(v.fresh));
          });
      };
  };
  var evalQ = function (render) {
      return function (ref) {
          return function (q) {
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v) {
                  return evalM(render)(ref)(v["component"]["eval"](new Halogen_Query_HalogenQ.Query(Data_Functor.map(Data_Coyoneda.functorCoyoneda)(Data_Maybe.Just.create)(Data_Coyoneda.liftCoyoneda(q)), Data_Function["const"](Data_Maybe.Nothing.value))));
              });
          };
      };
  };
  var evalM = function (render) {
      return function (initRef) {
          return function (v) {
              var evalChildQuery = function (ref) {
                  return function (cqb) {
                      return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v1) {
                          return Halogen_Query_ChildQuery.unChildQueryBox(function (v2) {
                              var evalChild = function (v3) {
                                  return Control_Parallel_Class.parallel(Effect_Aff.parallelAff)(Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v3)))(function (dsx) {
                                      return Halogen_Aff_Driver_State.unDriverStateX(function (ds) {
                                          return evalQ(render)(ds.selfRef)(v2.value1);
                                      })(dsx);
                                  }));
                              };
                              return Data_Functor.map(Effect_Aff.functorAff)(v2.value2)(Control_Parallel_Class.sequential(Effect_Aff.parallelAff)(v2.value0(Effect_Aff.applicativeParAff)(evalChild)(v1.children)));
                          })(cqb);
                      });
                  };
              };
              var go = function (ref) {
                  return function (v1) {
                      if (v1 instanceof Halogen_Query_HalogenM.State) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              var v3 = v1.value0(v2.state);
                              if (Unsafe_Reference.unsafeRefEq(v2.state)(v3.value1)) {
                                  return Control_Applicative.pure(Effect_Aff.applicativeAff)(v3.value0);
                              };
                              if (Data_Boolean.otherwise) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write({
                                      component: v2.component,
                                      state: v3.value1,
                                      refs: v2.refs,
                                      children: v2.children,
                                      childrenIn: v2.childrenIn,
                                      childrenOut: v2.childrenOut,
                                      selfRef: v2.selfRef,
                                      handlerRef: v2.handlerRef,
                                      pendingQueries: v2.pendingQueries,
                                      pendingOuts: v2.pendingOuts,
                                      pendingHandlers: v2.pendingHandlers,
                                      rendering: v2.rendering,
                                      fresh: v2.fresh,
                                      subscriptions: v2.subscriptions,
                                      forks: v2.forks,
                                      lifecycleHandlers: v2.lifecycleHandlers
                                  })(ref)))(function () {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(handleLifecycle(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(ref)))(function () {
                                          return Control_Applicative.pure(Effect_Aff.applicativeAff)(v3.value0);
                                      });
                                  });
                              };
                              throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [ v3.constructor.name ]);
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Subscribe) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(fresh(Halogen_Query_HalogenM.SubscriptionId)(ref))(function (sid) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Halogen_Subscription.subscribe(v1.value0(sid))(function (act) {
                                  return handleAff(evalF(render)(ref)(new Halogen_Query_Input.Action(act)));
                              })))(function (finalize) {
                                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.modify_(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Map_Internal.insert(Halogen_Query_HalogenM.ordSubscriptionId)(sid)(finalize)))(v2.subscriptions)))(function () {
                                          return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1(sid));
                                      });
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Unsubscribe) {
                          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(unsubscribe(v1.value0)(ref)))(function () {
                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1);
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Lift) {
                          return v1.value0;
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.ChildQuery) {
                          return evalChildQuery(ref)(v1.value0);
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Raise) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v2.handlerRef)))(function (handler) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(queueOrRun(v2.pendingOuts)(handler(v1.value0)))(function () {
                                      return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1);
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Par) {
                          return Control_Parallel_Class.sequential(Effect_Aff.parallelAff)(Control_Applicative_Free.retractFreeAp(Effect_Aff.applicativeParAff)(Control_Applicative_Free.hoistFreeAp((function () {
                              var $78 = Control_Parallel_Class.parallel(Effect_Aff.parallelAff);
                              var $79 = evalM(render)(ref);
                              return function ($80) {
                                  return $78($79($80));
                              };
                          })())(v1.value0)));
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Fork) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(fresh(Halogen_Query_HalogenM.ForkId)(ref))(function (fid) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["new"](false)))(function (doneRef) {
                                      return Control_Bind.bind(Effect_Aff.bindAff)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff)(Effect_Aff["finally"](Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(function __do() {
                                          Effect_Ref.modify_(Data_Map_Internal["delete"](Halogen_Query_HalogenM.ordForkId)(fid))(v2.forks)();
                                          return Effect_Ref.write(true)(doneRef)();
                                      }))(evalM(render)(ref)(v1.value0))))(function (fiber) {
                                          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Control_Monad.unlessM(Effect.monadEffect)(Effect_Ref.read(doneRef))(Effect_Ref.modify_(Data_Map_Internal.insert(Halogen_Query_HalogenM.ordForkId)(fid)(fiber))(v2.forks))))(function () {
                                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1(fid));
                                          });
                                      });
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Kill) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v2.forks)))(function (forkMap) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_Foldable.foldableMaybe)(Effect_Aff.killFiber(Effect_Exception.error("Cancelled")))(Data_Map_Internal.lookup(Halogen_Query_HalogenM.ordForkId)(v1.value0)(forkMap)))(function () {
                                      return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1);
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.GetRef) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1(Data_Map_Internal.lookup(Data_Ord.ordString)(v1.value0)(v2.refs)));
                          });
                      };
                      throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 133, column 33): " + [ v1.constructor.name ]);
                  };
              };
              return Control_Monad_Free.foldFree(Effect_Aff.monadRecAff)(go(initRef))(v);
          };
      };
  };
  var evalF = function (render) {
      return function (ref) {
          return function (v) {
              if (v instanceof Halogen_Query_Input.RefUpdate) {
                  return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Data_Function.flip(Effect_Ref.modify_)(ref)(Halogen_Aff_Driver_State.mapDriverState(function (st) {
                      return {
                          component: st.component,
                          state: st.state,
                          refs: Data_Map_Internal.alter(Data_Ord.ordString)(Data_Function["const"](v.value1))(v.value0)(st.refs),
                          children: st.children,
                          childrenIn: st.childrenIn,
                          childrenOut: st.childrenOut,
                          selfRef: st.selfRef,
                          handlerRef: st.handlerRef,
                          pendingQueries: st.pendingQueries,
                          pendingOuts: st.pendingOuts,
                          pendingHandlers: st.pendingHandlers,
                          rendering: st.rendering,
                          fresh: st.fresh,
                          subscriptions: st.subscriptions,
                          forks: st.forks,
                          lifecycleHandlers: st.lifecycleHandlers
                      };
                  })));
              };
              if (v instanceof Halogen_Query_Input.Action) {
                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v1) {
                      return evalM(render)(ref)(v1["component"]["eval"](new Halogen_Query_HalogenQ.Action(v.value0, Data_Unit.unit)));
                  });
              };
              throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [ v.constructor.name ]);
          };
      };
  };
  exports["evalF"] = evalF;
  exports["evalQ"] = evalQ;
  exports["evalM"] = evalM;
  exports["handleLifecycle"] = handleLifecycle;
  exports["queueOrRun"] = queueOrRun;
  exports["handleAff"] = handleAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Aff.Driver"] = $PS["Halogen.Aff.Driver"] || {};
  var exports = $PS["Halogen.Aff.Driver"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_Fork_Class = $PS["Control.Monad.Fork.Class"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Control_Parallel = $PS["Control.Parallel"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List = $PS["Data.List"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Console = $PS["Effect.Console"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Aff_Driver_Eval = $PS["Halogen.Aff.Driver.Eval"];
  var Halogen_Aff_Driver_State = $PS["Halogen.Aff.Driver.State"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Halogen_Query_HalogenQ = $PS["Halogen.Query.HalogenQ"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Halogen_Subscription = $PS["Halogen.Subscription"];                
  var newLifecycleHandlers = Effect_Ref["new"]({
      initializers: Data_List_Types.Nil.value,
      finalizers: Data_List_Types.Nil.value
  });
  var handlePending = function (ref) {
      return function __do() {
          var queue = Effect_Ref.read(ref)();
          Effect_Ref.write(Data_Maybe.Nothing.value)(ref)();
          return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(queue)((function () {
              var $28 = Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_List_Types.foldableList)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff));
              return function ($29) {
                  return Halogen_Aff_Driver_Eval.handleAff($28(Data_List.reverse($29)));
              };
          })())();
      };
  };
  var cleanupSubscriptionsAndForks = function (v) {
      return function __do() {
          Control_Bind.bindFlipped(Effect.bindEffect)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)(Halogen_Subscription.unsubscribe)))(Effect_Ref.read(v.subscriptions))();
          Effect_Ref.write(Data_Maybe.Nothing.value)(v.subscriptions)();
          Control_Bind.bindFlipped(Effect.bindEffect)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)((function () {
              var $30 = Effect_Aff.killFiber(Effect_Exception.error("finalized"));
              return function ($31) {
                  return Halogen_Aff_Driver_Eval.handleAff($30($31));
              };
          })()))(Effect_Ref.read(v.forks))();
          return Effect_Ref.write(Data_Map_Internal.empty)(v.forks)();
      };
  };
  var runUI = function (renderSpec) {
      return function (component) {
          return function (i) {
              var squashChildInitializers = function (lchs) {
                  return function (preInits) {
                      return Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                          var parentInitializer = Halogen_Aff_Driver_Eval.evalM(render)(st.selfRef)(st["component"]["eval"](new Halogen_Query_HalogenQ.Initialize(Data_Unit.unit)));
                          return Effect_Ref.modify_(function (handlers) {
                              return {
                                  initializers: new Data_List_Types.Cons(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Control_Parallel.parSequence_(Effect_Aff.parallelAff)(Data_List_Types.foldableList)(Data_List.reverse(handlers.initializers)))(function () {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(parentInitializer)(function () {
                                          return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(function __do() {
                                              handlePending(st.pendingQueries)();
                                              return handlePending(st.pendingOuts)();
                                          });
                                      });
                                  }), preInits),
                                  finalizers: handlers.finalizers
                              };
                          })(lchs);
                      });
                  };
              };
              var runComponent = function (lchs) {
                  return function (handler) {
                      return function (j) {
                          return Halogen_Component.unComponent(function (c) {
                              return function __do() {
                                  var lchs$prime = newLifecycleHandlers();
                                  var $$var = Halogen_Aff_Driver_State.initDriverState(c)(j)(handler)(lchs$prime)();
                                  var pre = Effect_Ref.read(lchs)();
                                  Effect_Ref.write({
                                      initializers: Data_List_Types.Nil.value,
                                      finalizers: pre.finalizers
                                  })(lchs)();
                                  Control_Bind.bindFlipped(Effect.bindEffect)(Halogen_Aff_Driver_State.unDriverStateX((function () {
                                      var $32 = render(lchs);
                                      return function ($33) {
                                          return $32((function (v) {
                                              return v.selfRef;
                                          })($33));
                                      };
                                  })()))(Effect_Ref.read($$var))();
                                  Control_Bind.bindFlipped(Effect.bindEffect)(squashChildInitializers(lchs)(pre.initializers))(Effect_Ref.read($$var))();
                                  return $$var;
                              };
                          });
                      };
                  };
              };
              var renderChild = function (lchs) {
                  return function (handler) {
                      return function (childrenInRef) {
                          return function (childrenOutRef) {
                              return Halogen_Component.unComponentSlot(function (slot) {
                                  return function __do() {
                                      var childrenIn = Data_Functor.map(Effect.functorEffect)(slot.pop)(Effect_Ref.read(childrenInRef))();
                                      var $$var = (function () {
                                          if (childrenIn instanceof Data_Maybe.Just) {
                                              Effect_Ref.write(childrenIn.value0.value1)(childrenInRef)();
                                              var dsx = Effect_Ref.read(childrenIn.value0.value0)();
                                              Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                                                  return function __do() {
                                                      Data_Function.flip(Effect_Ref.write)(st.handlerRef)((function () {
                                                          var $34 = Data_Maybe.maybe(Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit))(handler);
                                                          return function ($35) {
                                                              return $34(slot.output($35));
                                                          };
                                                      })())();
                                                      return Halogen_Aff_Driver_Eval.handleAff(Halogen_Aff_Driver_Eval.evalM(render)(st.selfRef)(st["component"]["eval"](new Halogen_Query_HalogenQ.Receive(slot.input, Data_Unit.unit))))();
                                                  };
                                              })(dsx)();
                                              return childrenIn.value0.value0;
                                          };
                                          if (childrenIn instanceof Data_Maybe.Nothing) {
                                              return runComponent(lchs)((function () {
                                                  var $36 = Data_Maybe.maybe(Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit))(handler);
                                                  return function ($37) {
                                                      return $36(slot.output($37));
                                                  };
                                              })())(slot.input)(slot.component)();
                                          };
                                          throw new Error("Failed pattern match at Halogen.Aff.Driver (line 210, column 14 - line 219, column 98): " + [ childrenIn.constructor.name ]);
                                      })();
                                      var isDuplicate = Data_Functor.map(Effect.functorEffect)(function ($38) {
                                          return Data_Maybe.isJust(slot.get($38));
                                      })(Effect_Ref.read(childrenOutRef))();
                                      Control_Applicative.when(Effect.applicativeEffect)(isDuplicate)(Effect_Console.warn("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                      Effect_Ref.modify_(slot.set($$var))(childrenOutRef)();
                                      return Control_Bind.bind(Effect.bindEffect)(Effect_Ref.read($$var))(Halogen_Aff_Driver_State.renderStateX(Effect.functorEffect)(function (v) {
                                          if (v instanceof Data_Maybe.Nothing) {
                                              return Effect_Exception["throw"]("Halogen internal error: child was not initialized in renderChild");
                                          };
                                          if (v instanceof Data_Maybe.Just) {
                                              return Control_Applicative.pure(Effect.applicativeEffect)(renderSpec.renderChild(v.value0));
                                          };
                                          throw new Error("Failed pattern match at Halogen.Aff.Driver (line 224, column 37 - line 226, column 50): " + [ v.constructor.name ]);
                                      }))();
                                  };
                              });
                          };
                      };
                  };
              };
              var render = function (lchs) {
                  return function ($$var) {
                      return function __do() {
                          var v = Effect_Ref.read($$var)();
                          var shouldProcessHandlers = Data_Functor.map(Effect.functorEffect)(Data_Maybe.isNothing)(Effect_Ref.read(v.pendingHandlers))();
                          Control_Applicative.when(Effect.applicativeEffect)(shouldProcessHandlers)(Effect_Ref.write(new Data_Maybe.Just(Data_List_Types.Nil.value))(v.pendingHandlers))();
                          Effect_Ref.write(Halogen_Data_Slot.empty)(v.childrenOut)();
                          Effect_Ref.write(v.children)(v.childrenIn)();
                          var selfRef = Control_Category.identity(Control_Category.categoryFn)(v.selfRef);
                          var pendingQueries = Control_Category.identity(Control_Category.categoryFn)(v.pendingQueries);
                          var pendingHandlers = Control_Category.identity(Control_Category.categoryFn)(v.pendingHandlers);
                          var handler = (function () {
                              var $39 = Halogen_Aff_Driver_Eval.queueOrRun(pendingHandlers);
                              var $40 = Data_Functor["void"](Effect_Aff.functorAff);
                              var $41 = Halogen_Aff_Driver_Eval.evalF(render)(selfRef);
                              return function ($42) {
                                  return $39($40($41($42)));
                              };
                          })();
                          var childHandler = (function () {
                              var $43 = Halogen_Aff_Driver_Eval.queueOrRun(pendingQueries);
                              return function ($44) {
                                  return $43(handler(Halogen_Query_Input.Action.create($44)));
                              };
                          })();
                          var rendering = renderSpec.render(function ($45) {
                              return Halogen_Aff_Driver_Eval.handleAff(handler($45));
                          })(renderChild(lchs)(childHandler)(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
                          var children = Effect_Ref.read(v.childrenOut)();
                          var childrenIn = Effect_Ref.read(v.childrenIn)();
                          Halogen_Data_Slot.foreachSlot(Effect.applicativeEffect)(childrenIn)(function (v1) {
                              return function __do() {
                                  var childDS = Effect_Ref.read(v1)();
                                  Halogen_Aff_Driver_State.renderStateX_(Effect.applicativeEffect)(renderSpec.removeChild)(childDS)();
                                  return finalize(lchs)(childDS)();
                              };
                          })();
                          Data_Function.flip(Effect_Ref.modify_)(v.selfRef)(Halogen_Aff_Driver_State.mapDriverState(function (ds$prime) {
                              return {
                                  component: ds$prime.component,
                                  state: ds$prime.state,
                                  refs: ds$prime.refs,
                                  children: children,
                                  childrenIn: ds$prime.childrenIn,
                                  childrenOut: ds$prime.childrenOut,
                                  selfRef: ds$prime.selfRef,
                                  handlerRef: ds$prime.handlerRef,
                                  pendingQueries: ds$prime.pendingQueries,
                                  pendingOuts: ds$prime.pendingOuts,
                                  pendingHandlers: ds$prime.pendingHandlers,
                                  rendering: new Data_Maybe.Just(rendering),
                                  fresh: ds$prime.fresh,
                                  subscriptions: ds$prime.subscriptions,
                                  forks: ds$prime.forks,
                                  lifecycleHandlers: ds$prime.lifecycleHandlers
                              };
                          }))();
                          return Control_Applicative.when(Effect.applicativeEffect)(shouldProcessHandlers)(Data_Function.flip(Control_Monad_Rec_Class.tailRecM(Control_Monad_Rec_Class.monadRecEffect))(Data_Unit.unit)(function (v1) {
                              return function __do() {
                                  var handlers = Effect_Ref.read(pendingHandlers)();
                                  Effect_Ref.write(new Data_Maybe.Just(Data_List_Types.Nil.value))(pendingHandlers)();
                                  Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)((function () {
                                      var $46 = Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_List_Types.foldableList)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff));
                                      return function ($47) {
                                          return Halogen_Aff_Driver_Eval.handleAff($46(Data_List.reverse($47)));
                                      };
                                  })())(handlers)();
                                  var mmore = Effect_Ref.read(pendingHandlers)();
                                  var $21 = Data_Maybe.maybe(false)(Data_List["null"])(mmore);
                                  if ($21) {
                                      return Data_Functor.voidLeft(Effect.functorEffect)(Effect_Ref.write(Data_Maybe.Nothing.value)(pendingHandlers))(new Control_Monad_Rec_Class.Done(Data_Unit.unit))();
                                  };
                                  return new Control_Monad_Rec_Class.Loop(Data_Unit.unit);
                              };
                          }))();
                      };
                  };
              };
              var finalize = function (lchs) {
                  return Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                      return function __do() {
                          cleanupSubscriptionsAndForks(st)();
                          var f = Halogen_Aff_Driver_Eval.evalM(render)(st.selfRef)(st["component"]["eval"](new Halogen_Query_HalogenQ.Finalize(Data_Unit.unit)));
                          Effect_Ref.modify_(function (handlers) {
                              return {
                                  initializers: handlers.initializers,
                                  finalizers: new Data_List_Types.Cons(f, handlers.finalizers)
                              };
                          })(lchs)();
                          return Halogen_Data_Slot.foreachSlot(Effect.applicativeEffect)(st.children)(function (v) {
                              return function __do() {
                                  var dsx = Effect_Ref.read(v)();
                                  return finalize(lchs)(dsx)();
                              };
                          })();
                      };
                  });
              };
              var evalDriver = function (disposed) {
                  return function (ref) {
                      return function (q) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(disposed)))(function (v) {
                              if (v) {
                                  return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Maybe.Nothing.value);
                              };
                              return Halogen_Aff_Driver_Eval.evalQ(render)(ref)(q);
                          });
                      };
                  };
              };
              var dispose = function (disposed) {
                  return function (lchs) {
                      return function (dsx) {
                          return Halogen_Aff_Driver_Eval.handleLifecycle(lchs)(function __do() {
                              var v = Effect_Ref.read(disposed)();
                              if (v) {
                                  return Data_Unit.unit;
                              };
                              Effect_Ref.write(true)(disposed)();
                              finalize(lchs)(dsx)();
                              return Halogen_Aff_Driver_State.unDriverStateX(function (v1) {
                                  return function __do() {
                                      var v2 = Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Effect_Ref.read(v1.selfRef))();
                                      return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(v2.rendering)(renderSpec.dispose)();
                                  };
                              })(dsx)();
                          });
                      };
                  };
              };
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(newLifecycleHandlers))(function (lchs) {
                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["new"](false)))(function (disposed) {
                      return Halogen_Aff_Driver_Eval.handleLifecycle(lchs)(function __do() {
                          var sio = Halogen_Subscription.create();
                          var dsx = Control_Bind.bindFlipped(Effect.bindEffect)(Effect_Ref.read)(runComponent(lchs)((function () {
                              var $48 = Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
                              var $49 = Halogen_Subscription.notify(sio.listener);
                              return function ($50) {
                                  return $48($49($50));
                              };
                          })())(i)(component))();
                          return Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                              return Control_Applicative.pure(Effect.applicativeEffect)({
                                  query: evalDriver(disposed)(st.selfRef),
                                  messages: sio.emitter,
                                  dispose: dispose(disposed)(lchs)(dsx)
                              });
                          })(dsx)();
                      });
                  });
              });
          };
      };
  };
  exports["runUI"] = runUI;
})(PS);
(function(exports) {
  "use strict";                                               

  exports._querySelector = function (selector) {
    return function (node) {
      return function () {
        return node.querySelector(selector);
      };
    };
  };
})(PS["Web.DOM.ParentNode"] = PS["Web.DOM.ParentNode"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.DOM.ParentNode"] = $PS["Web.DOM.ParentNode"] || {};
  var exports = $PS["Web.DOM.ParentNode"];
  var $foreign = $PS["Web.DOM.ParentNode"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Effect = $PS["Effect"];
  var querySelector = function (qs) {
      var $0 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      var $1 = $foreign["_querySelector"](qs);
      return function ($2) {
          return $0($1($2));
      };
  };
  exports["querySelector"] = querySelector;
})(PS);
(function(exports) {
  "use strict";

  exports._readyState = function (doc) {
    return function () {
      return doc.readyState;
    };
  };
})(PS["Web.HTML.HTMLDocument"] = PS["Web.HTML.HTMLDocument"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML.HTMLDocument.ReadyState"] = $PS["Web.HTML.HTMLDocument.ReadyState"] || {};
  var exports = $PS["Web.HTML.HTMLDocument.ReadyState"];
  var Data_Maybe = $PS["Data.Maybe"];              
  var Loading = (function () {
      function Loading() {

      };
      Loading.value = new Loading();
      return Loading;
  })();
  var Interactive = (function () {
      function Interactive() {

      };
      Interactive.value = new Interactive();
      return Interactive;
  })();
  var Complete = (function () {
      function Complete() {

      };
      Complete.value = new Complete();
      return Complete;
  })();
  var parse = function (v) {
      if (v === "loading") {
          return new Data_Maybe.Just(Loading.value);
      };
      if (v === "interactive") {
          return new Data_Maybe.Just(Interactive.value);
      };
      if (v === "complete") {
          return new Data_Maybe.Just(Complete.value);
      };
      return Data_Maybe.Nothing.value;
  };
  exports["Loading"] = Loading;
  exports["parse"] = parse;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML.HTMLDocument"] = $PS["Web.HTML.HTMLDocument"] || {};
  var exports = $PS["Web.HTML.HTMLDocument"];
  var $foreign = $PS["Web.HTML.HTMLDocument"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Effect = $PS["Effect"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Web_HTML_HTMLDocument_ReadyState = $PS["Web.HTML.HTMLDocument.ReadyState"];
  var toParentNode = Unsafe_Coerce.unsafeCoerce; 
  var toDocument = Unsafe_Coerce.unsafeCoerce;
  var readyState = (function () {
      var $0 = Data_Functor.map(Effect.functorEffect)((function () {
          var $2 = Data_Maybe.fromMaybe(Web_HTML_HTMLDocument_ReadyState.Loading.value);
          return function ($3) {
              return $2(Web_HTML_HTMLDocument_ReadyState.parse($3));
          };
      })());
      return function ($1) {
          return $0($foreign["_readyState"]($1));
      };
  })();
  exports["toDocument"] = toDocument;
  exports["toParentNode"] = toParentNode;
  exports["readyState"] = readyState;
})(PS);
(function(exports) {
  "use strict";

  exports._read = function (nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) {
      return just(value);
    } else {
      return nothing;
    }
  };
})(PS["Web.HTML.HTMLElement"] = PS["Web.HTML.HTMLElement"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML.HTMLElement"] = $PS["Web.HTML.HTMLElement"] || {};
  var exports = $PS["Web.HTML.HTMLElement"];
  var $foreign = $PS["Web.HTML.HTMLElement"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                   
  var toNode = Unsafe_Coerce.unsafeCoerce;
  var fromElement = function (x) {
      return $foreign["_read"](Data_Maybe.Nothing.value, Data_Maybe.Just.create, x);
  };
  exports["fromElement"] = fromElement;
  exports["toNode"] = toNode;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Aff.Util"] = $PS["Halogen.Aff.Util"] || {};
  var exports = $PS["Halogen.Aff.Util"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Web_DOM_ParentNode = $PS["Web.DOM.ParentNode"];
  var Web_Event_EventTarget = $PS["Web.Event.EventTarget"];
  var Web_HTML = $PS["Web.HTML"];
  var Web_HTML_Event_EventTypes = $PS["Web.HTML.Event.EventTypes"];
  var Web_HTML_HTMLDocument = $PS["Web.HTML.HTMLDocument"];
  var Web_HTML_HTMLDocument_ReadyState = $PS["Web.HTML.HTMLDocument.ReadyState"];
  var Web_HTML_HTMLElement = $PS["Web.HTML.HTMLElement"];
  var Web_HTML_Window = $PS["Web.HTML.Window"];                
  var selectElement = function (query) {
      return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Control_Bind.bindFlipped(Effect.bindEffect)(Control_Bind.composeKleisliFlipped(Effect.bindEffect)((function () {
          var $2 = Web_DOM_ParentNode.querySelector(query);
          return function ($3) {
              return $2(Web_HTML_HTMLDocument.toParentNode($3));
          };
      })())(Web_HTML_Window.document))(Web_HTML.window)))(function (mel) {
          return Control_Applicative.pure(Effect_Aff.applicativeAff)(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Web_HTML_HTMLElement.fromElement)(mel));
      });
  };                                                                                                                                                                                      
  var awaitLoad = Effect_Aff.makeAff(function (callback) {
      return function __do() {
          var rs = Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_HTMLDocument.readyState)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window))();
          if (rs instanceof Web_HTML_HTMLDocument_ReadyState.Loading) {
              var et = Data_Functor.map(Effect.functorEffect)(Web_HTML_Window.toEventTarget)(Web_HTML.window)();
              var listener = Web_Event_EventTarget.eventListener(function (v) {
                  return callback(new Data_Either.Right(Data_Unit.unit));
              })();
              Web_Event_EventTarget.addEventListener(Web_HTML_Event_EventTypes.domcontentloaded)(listener)(false)(et)();
              return Effect_Aff.effectCanceler(Web_Event_EventTarget.removeEventListener(Web_HTML_Event_EventTypes.domcontentloaded)(listener)(false)(et));
          };
          callback(new Data_Either.Right(Data_Unit.unit))();
          return Effect_Aff.nonCanceler;
      };
  });
  var awaitBody = Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(awaitLoad)(function () {
      return Control_Bind.bind(Effect_Aff.bindAff)(selectElement("body"))(function (body) {
          return Data_Maybe.maybe(Control_Monad_Error_Class.throwError(Effect_Aff.monadThrowAff)(Effect_Exception.error("Could not find body")))(Control_Applicative.pure(Effect_Aff.applicativeAff))(body);
      });
  });
  exports["awaitLoad"] = awaitLoad;
  exports["awaitBody"] = awaitBody;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.Query.Event"] = $PS["Halogen.Query.Event"] || {};
  var exports = $PS["Halogen.Query.Event"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Effect = $PS["Effect"];
  var Halogen_Subscription = $PS["Halogen.Subscription"];
  var Web_Event_EventTarget = $PS["Web.Event.EventTarget"];                
  var eventListener = function (eventType) {
      return function (target) {
          return function (f) {
              return Halogen_Subscription.makeEmitter(function (push) {
                  return function __do() {
                      var listener = Web_Event_EventTarget.eventListener(function (ev) {
                          return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(push)(f(ev));
                      })();
                      Web_Event_EventTarget.addEventListener(eventType)(listener)(false)(target)();
                      return Web_Event_EventTarget.removeEventListener(eventType)(listener)(false)(target);
                  };
              });
          };
      };
  };
  exports["eventListener"] = eventListener;
})(PS);
(function(exports) {
  "use strict";

  var getEffProp = function (name) {
    return function (node) {
      return function () {
        return node[name];
      };
    };
  };                                                   

  exports._parentNode = getEffProp("parentNode");          

  exports._nextSibling = getEffProp("nextSibling");

  exports.insertBefore = function (node1) {
    return function (node2) {
      return function (parent) {
        return function () {
          parent.insertBefore(node1, node2);
        };
      };
    };
  };

  exports.appendChild = function (node) {
    return function (parent) {
      return function () {
        parent.appendChild(node);
      };
    };
  };

  exports.removeChild = function (node) {
    return function (parent) {
      return function () {
        parent.removeChild(node);
      };
    };
  };
})(PS["Web.DOM.Node"] = PS["Web.DOM.Node"] || {});
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.DOM.Node"] = $PS["Web.DOM.Node"] || {};
  var exports = $PS["Web.DOM.Node"];
  var $foreign = $PS["Web.DOM.Node"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Effect = $PS["Effect"];
  var parentNode = (function () {
      var $3 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      return function ($4) {
          return $3($foreign["_parentNode"]($4));
      };
  })();
  var nextSibling = (function () {
      var $14 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      return function ($15) {
          return $14($foreign["_nextSibling"]($15));
      };
  })();
  exports["parentNode"] = parentNode;
  exports["nextSibling"] = nextSibling;
  exports["insertBefore"] = $foreign.insertBefore;
  exports["appendChild"] = $foreign.appendChild;
  exports["removeChild"] = $foreign.removeChild;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Halogen.VDom.Driver"] = $PS["Halogen.VDom.Driver"] || {};
  var exports = $PS["Halogen.VDom.Driver"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Aff_Driver = $PS["Halogen.Aff.Driver"];
  var Halogen_Aff_Driver_State = $PS["Halogen.Aff.Driver.State"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_VDom_DOM = $PS["Halogen.VDom.DOM"];
  var Halogen_VDom_DOM_Prop = $PS["Halogen.VDom.DOM.Prop"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Thunk = $PS["Halogen.VDom.Thunk"];
  var Unsafe_Reference = $PS["Unsafe.Reference"];
  var Web_DOM_Node = $PS["Web.DOM.Node"];
  var Web_HTML = $PS["Web.HTML"];
  var Web_HTML_HTMLDocument = $PS["Web.HTML.HTMLDocument"];
  var Web_HTML_HTMLElement = $PS["Web.HTML.HTMLElement"];
  var Web_HTML_Window = $PS["Web.HTML.Window"];
  var substInParent = function (v) {
      return function (v1) {
          return function (v2) {
              if (v1 instanceof Data_Maybe.Just && v2 instanceof Data_Maybe.Just) {
                  return Data_Functor["void"](Effect.functorEffect)(Web_DOM_Node.insertBefore(v)(v1.value0)(v2.value0));
              };
              if (v1 instanceof Data_Maybe.Nothing && v2 instanceof Data_Maybe.Just) {
                  return Data_Functor["void"](Effect.functorEffect)(Web_DOM_Node.appendChild(v)(v2.value0));
              };
              return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
          };
      };
  };
  var removeChild = function (v) {
      return function __do() {
          var npn = Web_DOM_Node.parentNode(v.node)();
          return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(function (pn) {
              return Web_DOM_Node.removeChild(v.node)(pn);
          })(npn)();
      };
  };
  var mkSpec = function (handler) {
      return function (renderChildRef) {
          return function (document) {
              var getNode = Halogen_Aff_Driver_State.unRenderStateX(function (v) {
                  return v.node;
              });
              var done = function (st) {
                  if (st instanceof Data_Maybe.Just) {
                      return Halogen_VDom_Machine.halt(st.value0);
                  };
                  return Data_Unit.unit;
              };
              var buildWidget = function (spec) {
                  var buildThunk = Halogen_VDom_Thunk.buildThunk(Data_Newtype.unwrap())(spec);
                  var renderComponentSlot = function (cs) {
                      var renderChild = Effect_Ref.read(renderChildRef)();
                      var rsx = renderChild(cs)();
                      var node = getNode(rsx);
                      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, Data_Maybe.Nothing.value, patch, done));
                  };
                  var render = function (slot) {
                      if (slot instanceof Halogen_Component.ComponentSlot) {
                          return renderComponentSlot(slot.value0);
                      };
                      if (slot instanceof Halogen_Component.ThunkSlot) {
                          var step = buildThunk(slot.value0);
                          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(step), new Data_Maybe.Just(step), patch, done));
                      };
                      throw new Error("Failed pattern match at Halogen.VDom.Driver (line 85, column 7 - line 90, column 75): " + [ slot.constructor.name ]);
                  };
                  var patch = function (st, slot) {
                      if (st instanceof Data_Maybe.Just) {
                          if (slot instanceof Halogen_Component.ComponentSlot) {
                              Halogen_VDom_Machine.halt(st.value0);
                              return renderComponentSlot(slot.value0);
                          };
                          if (slot instanceof Halogen_Component.ThunkSlot) {
                              var step$prime = Halogen_VDom_Machine.step(st.value0, slot.value0);
                              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(step$prime), new Data_Maybe.Just(step$prime), patch, done));
                          };
                          throw new Error("Failed pattern match at Halogen.VDom.Driver (line 98, column 22 - line 104, column 79): " + [ slot.constructor.name ]);
                      };
                      return render(slot);
                  };
                  return render;
              };
              var buildAttributes = Halogen_VDom_DOM_Prop.buildProp(handler);
              return {
                  buildWidget: buildWidget,
                  buildAttributes: buildAttributes,
                  document: document
              };
          };
      };
  };
  var renderSpec = function (document) {
      return function (container) {
          var render = function (handler) {
              return function (child) {
                  return function (v) {
                      return function (v1) {
                          if (v1 instanceof Data_Maybe.Nothing) {
                              return function __do() {
                                  var renderChildRef = Effect_Ref["new"](child)();
                                  var spec = mkSpec(handler)(renderChildRef)(document);
                                  var machine = Halogen_VDom_DOM.buildVDom(spec)(v);
                                  var node = Halogen_VDom_Machine.extract(machine);
                                  Data_Functor["void"](Effect.functorEffect)(Web_DOM_Node.appendChild(node)(Web_HTML_HTMLElement.toNode(container)))();
                                  return {
                                      machine: machine,
                                      node: node,
                                      renderChildRef: renderChildRef
                                  };
                              };
                          };
                          if (v1 instanceof Data_Maybe.Just) {
                              return function __do() {
                                  Effect_Ref.write(child)(v1.value0.renderChildRef)();
                                  var parent = Web_DOM_Node.parentNode(v1.value0.node)();
                                  var nextSib = Web_DOM_Node.nextSibling(v1.value0.node)();
                                  var machine$prime = Halogen_VDom_Machine.step(v1.value0.machine, v);
                                  var newNode = Halogen_VDom_Machine.extract(machine$prime);
                                  Control_Applicative.when(Effect.applicativeEffect)(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean)))(Unsafe_Reference.unsafeRefEq)(v1.value0.node)(newNode))(substInParent(newNode)(nextSib)(parent))();
                                  return {
                                      machine: machine$prime,
                                      node: newNode,
                                      renderChildRef: v1.value0.renderChildRef
                                  };
                              };
                          };
                          throw new Error("Failed pattern match at Halogen.VDom.Driver (line 159, column 5 - line 175, column 80): " + [ v1.constructor.name ]);
                      };
                  };
              };
          };
          return {
              render: render,
              renderChild: Control_Category.identity(Control_Category.categoryFn),
              removeChild: removeChild,
              dispose: removeChild
          };
      };
  };
  var runUI = function (component) {
      return function (i) {
          return function (element) {
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Data_Functor.map(Effect.functorEffect)(Web_HTML_HTMLDocument.toDocument)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window))))(function (document) {
                  return Halogen_Aff_Driver.runUI(renderSpec(document)(element))(component)(i);
              });
          };
      };
  };
  exports["runUI"] = runUI;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Web.HTML.Event.BeforeUnloadEvent.EventTypes"] = $PS["Web.HTML.Event.BeforeUnloadEvent.EventTypes"] || {};
  var exports = $PS["Web.HTML.Event.BeforeUnloadEvent.EventTypes"];
  var beforeunload = "beforeunload";
  exports["beforeunload"] = beforeunload;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.1
  "use strict";
  $PS["Main"] = $PS["Main"] || {};
  var exports = $PS["Main"];
  var AppAction = $PS["AppAction"];
  var AppState = $PS["AppState"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Argonaut_Decode_Class = $PS["Data.Argonaut.Decode.Class"];
  var Data_Argonaut_Encode_Class = $PS["Data.Argonaut.Encode.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_ArrayBuffer_Class = $PS["Data.ArrayBuffer.Class"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Either = $PS["Data.Either"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_EuclideanRing = $PS["Data.EuclideanRing"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HashMap = $PS["Data.HashMap"];
  var Data_Hashable = $PS["Data.Hashable"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Lens_Getter = $PS["Data.Lens.Getter"];
  var Data_Lens_Internal_Forget = $PS["Data.Lens.Internal.Forget"];
  var Data_Lens_Internal_Tagged = $PS["Data.Lens.Internal.Tagged"];
  var Data_Lens_Prism = $PS["Data.Lens.Prism"];
  var Data_Lens_Setter = $PS["Data.Lens.Setter"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Profunctor_Strong = $PS["Data.Profunctor.Strong"];
  var Data_Show = $PS["Data.Show"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unit = $PS["Data.Unit"];
  var Domination_AppM = $PS["Domination.AppM"];
  var Domination_Capability_Audio = $PS["Domination.Capability.Audio"];
  var Domination_Capability_Broadcast = $PS["Domination.Capability.Broadcast"];
  var Domination_Capability_Broadcast_WebSocket = $PS["Domination.Capability.Broadcast.WebSocket"];
  var Domination_Capability_Clock = $PS["Domination.Capability.Clock"];
  var Domination_Capability_Dom = $PS["Domination.Capability.Dom"];
  var Domination_Capability_GenUuid = $PS["Domination.Capability.GenUuid"];
  var Domination_Capability_Log = $PS["Domination.Capability.Log"];
  var Domination_Capability_Random = $PS["Domination.Capability.Random"];
  var Domination_Capability_Storage = $PS["Domination.Capability.Storage"];
  var Domination_Capability_Timer = $PS["Domination.Capability.Timer"];
  var Domination_Capability_WireCodec = $PS["Domination.Capability.WireCodec"];
  var Domination_Data_Actions = $PS["Domination.Data.Actions"];
  var Domination_Data_Bonus = $PS["Domination.Data.Bonus"];
  var Domination_Data_Buys = $PS["Domination.Data.Buys"];
  var Domination_Data_Card = $PS["Domination.Data.Card"];
  var Domination_Data_CardType = $PS["Domination.Data.CardType"];
  var Domination_Data_Choice = $PS["Domination.Data.Choice"];
  var Domination_Data_Phase = $PS["Domination.Data.Phase"];
  var Domination_Data_Points = $PS["Domination.Data.Points"];
  var Domination_Data_Reaction = $PS["Domination.Data.Reaction"];
  var Domination_Data_Result = $PS["Domination.Data.Result"];
  var Domination_Data_Target = $PS["Domination.Data.Target"];
  var Domination_Env = $PS["Domination.Env"];
  var Domination_UI_Chat = $PS["Domination.UI.Chat"];
  var Domination_UI_Css = $PS["Domination.UI.Css"];
  var Domination_UI_DomSlot = $PS["Domination.UI.DomSlot"];
  var Domination_UI_Domination = $PS["Domination.UI.Domination"];
  var Domination_UI_Domination_ActiveState = $PS["Domination.UI.Domination.ActiveState"];
  var Domination_UI_Domination_GameEvent = $PS["Domination.UI.Domination.GameEvent"];
  var Domination_UI_Icons = $PS["Domination.UI.Icons"];
  var Domination_UI_Settings = $PS["Domination.UI.Settings"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Emojis = $PS["Emojis"];
  var FFI = $PS["FFI"];
  var Halogen_Aff_Util = $PS["Halogen.Aff.Util"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML = $PS["Halogen.HTML"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_Event = $PS["Halogen.Query.Event"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Halogen_VDom_Driver = $PS["Halogen.VDom.Driver"];
  var Message = $PS["Message"];
  var Util = $PS["Util"];
  var Web_HTML_Event_BeforeUnloadEvent_EventTypes = $PS["Web.HTML.Event.BeforeUnloadEvent.EventTypes"];
  var Web_HTML_Window = $PS["Web.HTML.Window"];                
  var uuidKey = "player-id";
  var usernameKey = "username";
  var serverUrlKey = "server-url";
  var renderSettingsButton = Halogen_HTML_Elements.button([ Halogen_HTML_Properties.class_(Domination_UI_Css.settingsButton), Halogen_HTML_Properties.attr("aria-label")("Settings"), Halogen_HTML_Events.onClick(function (v) {
      return AppAction.ToggleMenu.value;
  }) ])([ Domination_UI_Icons.settings ]);
  var remoteMessageTarget = "remote-message-target";
  var render = function (dictLog) {
      return function (dictAudio) {
          return function (dictStorage) {
              return function (dictDom) {
                  return function (dictRandom) {
                      return function (audioContext) {
                          return function (state) {
                              return Halogen_HTML_Elements.main_([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id(remoteMessageTarget), Halogen_HTML_Events.handler("purescript")(AppAction.ReceiveRemoteMessage.create) ])([  ]), (function () {
                                  if (state.showMenu) {
                                      return Domination_UI_Settings.render(dictDom)(dictLog)(state);
                                  };
                                  return Domination_UI_Settings.renderEmpty(dictDom)(dictLog);
                              })(), renderSettingsButton, Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                  return "Domination";
                              }))(Domination_UI_DomSlot.ordDomSlot)(Domination_UI_Domination["_component"])(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.GameArea.value))(Domination_UI_Domination.component(dictLog)(dictStorage)(dictDom)(dictRandom)(dictAudio)(state.dominationConfig)(audioContext))(Data_Unit.unit)(AppAction.HandleGameEvent.create), Domination_UI_Chat.render({
                                  sendEvent: AppAction.SendMessage.value,
                                  onInput: AppAction.Write.create(function (dictStrong) {
                                      return AppState["_message"](dictStrong);
                                  }),
                                  nothing: AppAction.DoNothing.value,
                                  state: state
                              }), Halogen_HTML_Elements.i([ Halogen_HTML_Properties.class_(Domination_UI_Css.connections) ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(state.connectionCount)) ]) ]);
                          };
                      };
                  };
              };
          };
      };
  };
  var sendMessage = function (dictLog) {
      return function (dictBroadcast) {
          return function (dictWireCodec) {
              return function (message$prime) {
                  var message = Data_Lens_Getter.view(Message["_toWire"](Data_Lens_Internal_Forget.profunctorForget))(message$prime);
                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v) {
                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("maybeBroadcaster: " + Data_Show.show(Data_Maybe.showMaybe(Domination_Capability_Broadcast_WebSocket.showWebSocketBroadcaster))(v.maybeBroadcaster)))(function () {
                          var wireEnvelope = new Data_Tuple.Tuple(v.id, message);
                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                              return v1.serverUrl;
                          }))(function (serverUrl) {
                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                  if (v.maybeBroadcaster instanceof Data_Maybe.Nothing) {
                                      return Domination_Capability_Broadcast.maybeCreateBroadcaster(Domination_Capability_Log.logHalogenM(dictLog))(Domination_Capability_Broadcast.broadcastHalogenM(dictBroadcast))(v.roomCode)(remoteMessageTarget)(serverUrl);
                                  };
                                  if (v.maybeBroadcaster instanceof Data_Maybe.Just) {
                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.maybeBroadcaster.value0));
                                  };
                                  throw new Error("Failed pattern match at Main (line 567, column 24 - line 570, column 28): " + [ v.maybeBroadcaster.constructor.name ]);
                              })())(function (maybeBroadcaster$prime) {
                                  if (maybeBroadcaster$prime instanceof Data_Maybe.Nothing) {
                                      return Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("no broadcaster to send message");
                                  };
                                  if (maybeBroadcaster$prime instanceof Data_Maybe.Just) {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_maybeBroadcaster"](Data_Profunctor_Strong.strongFn))(maybeBroadcaster$prime)))(function () {
                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_WireCodec.writeWire(Domination_Capability_WireCodec.wireCodecHalogenM(dictWireCodec))(Data_ArrayBuffer_Class.encodeArrayBufferTuple(Data_ArrayBuffer_Class.encodeArrayBufferString)(Message.encodeArrayBuffeWireMessage))(Data_ArrayBuffer_Class.dynamicByteLengthTuple(Data_ArrayBuffer_Class.dynamicByteLengthString)(Message.dynamicByteLengthWireMessage))(wireEnvelope))(function (eString) {
                                              if (eString instanceof Data_Either.Left) {
                                                  return Domination_Capability_Log.error(Domination_Capability_Log.logHalogenM(dictLog))(eString.value0);
                                              };
                                              if (eString instanceof Data_Either.Right) {
                                                  return Domination_Capability_Broadcast.broadcast(Domination_Capability_Broadcast.broadcastHalogenM(dictBroadcast))(maybeBroadcaster$prime.value0)(eString.value0);
                                              };
                                              throw new Error("Failed pattern match at Main (line 578, column 7 - line 581, column 39): " + [ eString.constructor.name ]);
                                          });
                                      });
                                  };
                                  throw new Error("Failed pattern match at Main (line 572, column 3 - line 581, column 39): " + [ maybeBroadcaster$prime.constructor.name ]);
                              });
                          });
                      });
                  });
              };
          };
      };
  };
  var chatKey = "chat";
  var saveChat = function (dictMonad) {
      return function (dictMonadState) {
          return function (dictStorage) {
              return function (dictEncodeJson) {
                  return function (dictDecodeJson) {
                      return function (dictLog) {
                          return Control_Bind.bind((dictLog.Monad0()).Bind1())(Control_Monad_State_Class.gets(dictMonadState)(function (v) {
                              return v.messages;
                          }))(function (messages) {
                              return Control_Bind.bind((dictLog.Monad0()).Bind1())(Domination_Capability_Storage.save(dictStorage)(dictEncodeJson)(dictDecodeJson)(chatKey)(messages))(function (result) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)((dictLog.Monad0()).Bind1())(Domination_Capability_Log.log(dictLog)("saved chat messages"))(function () {
                                      return Control_Applicative.pure((dictLog.Monad0()).Applicative0())(result);
                                  });
                              });
                          });
                      };
                  };
              };
          };
      };
  };
  var handleAction = function (dictAudio) {
      return function (dictStorage) {
          return function (dictLog) {
              return function (dictGenUuid) {
                  return function (dictRandom) {
                      return function (dictClock) {
                          return function (dictBroadcast) {
                              return function (dictWireCodec) {
                                  return function (dictTimer) {
                                      return function (dictDom) {
                                          return function (audioContext) {
                                              var sendChatMessage = Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v) {
                                                  var chatNumber = v.chatNumber + 1 | 0;
                                                  var chat = new Message.ChatMessage({
                                                      username: v.id,
                                                      message: v.message,
                                                      chatNumber: chatNumber
                                                  });
                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                                      var $181 = Data_Lens_Setter.set(AppState["_message"](Data_Profunctor_Strong.strongFn))("");
                                                      var $182 = Util.prependOver(function (dictStrong) {
                                                          return AppState["_messages"](dictStrong);
                                                      })(chat);
                                                      var $183 = Data_Lens_Setter.set(AppState["_chatNumber"](Data_Profunctor_Strong.strongFn))(chatNumber);
                                                      return function ($184) {
                                                          return $181($182($183($184)));
                                                      };
                                                  })()))(function () {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(saveChat(Halogen_Query_HalogenM.monadHalogenM)(Halogen_Query_HalogenM.monadStateHalogenM)(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonArray(Message.encodeJsonRemoteMessage))(Data_Argonaut_Decode_Class.decodeArray(Message.decodeJsonRemoteMessage))(Domination_Capability_Log.logHalogenM(dictLog)))(function (errorOrUnit) {
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                              if (errorOrUnit instanceof Data_Either.Left) {
                                                                  return Domination_Capability_Log.error(Domination_Capability_Log.logHalogenM(dictLog))(errorOrUnit.value0);
                                                              };
                                                              if (errorOrUnit instanceof Data_Either.Right) {
                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                              };
                                                              throw new Error("Failed pattern match at Main (line 541, column 7 - line 543, column 29): " + [ errorOrUnit.constructor.name ]);
                                                          })())(function () {
                                                              return sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(chat);
                                                          });
                                                      });
                                                  });
                                              });
                                              var queryGame = function (state) {
                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                                      return "Domination";
                                                  }))(Domination_UI_DomSlot.ordDomSlot)(Domination_UI_Domination["_component"])(new Domination_UI_DomSlot.AreaSlot(Domination_UI_DomSlot.GameArea.value))(state(Data_Unit.unit)))(function () {
                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                  });
                                              };
                                              var logErrorToChat = function (result) {
                                                  if (result instanceof Data_Either.Left) {
                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_message"](Data_Profunctor_Strong.strongFn))("ERROR: " + result.value0)))(function () {
                                                          return sendChatMessage;
                                                      });
                                                  };
                                                  if (result instanceof Data_Either.Right) {
                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                  };
                                                  throw new Error("Failed pattern match at Main (line 545, column 29 - line 549, column 27): " + [ result.constructor.name ]);
                                              };
                                              var saveGame = function (activeState) {
                                                  var saveNumber = Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(activeState.i)(10);
                                                  var key = "game_state_" + Data_Show.show(Data_Show.showInt)(saveNumber);
                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Phase.encodeJsonPhase)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Bonus.encodeJsonBonus))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Choice.encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "toDiscard";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "hand";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "discard";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "deck";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "choices";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buying";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "bonuses";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "atPlay";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Result.encodeJsonResult))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "count";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "card";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "turn";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "trash";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "supply";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "result";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "players";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "phase";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "longGame";
                                                  }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "state";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "showSupply";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "playerIndex";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "playerCount";
                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                      return "i";
                                                  }))())())(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Phase.decodeJsonPhase))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Bonus.decodeJsonBonus)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Choice.decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "toDiscard";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "hand";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "discard";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "deck";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "choices";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buying";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "bonuses";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "atPlay";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Result.decodeJsonResult))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "count";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "card";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "target";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "description";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "command";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "victoryPoints";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "types";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "treasure";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "special";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "reaction";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "name";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cost";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "cards";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "buys";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "actions";
                                                  }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "turn";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "trash";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "supply";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "result";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "players";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "phase";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "longGame";
                                                  }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                      return "state";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "showSupply";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "playerIndex";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "playerCount";
                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                      return "i";
                                                  }))()())())(key)(activeState))(logErrorToChat))(function () {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Phase.encodeJsonPhase)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Bonus.encodeJsonBonus))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Choice.encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "toDiscard";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "hand";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "discard";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "deck";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "choices";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buying";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "bonuses";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "atPlay";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Result.encodeJsonResult))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "count";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "card";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "turn";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "trash";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "supply";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "result";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "players";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "phase";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "longGame";
                                                      }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "state";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "showSupply";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerIndex";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerCount";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "i";
                                                      }))())())(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Phase.decodeJsonPhase))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Bonus.decodeJsonBonus)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Choice.decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "toDiscard";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "hand";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "discard";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "deck";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "choices";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buying";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "bonuses";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "atPlay";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Result.decodeJsonResult))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "count";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "card";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "turn";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "trash";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "supply";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "result";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "players";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "phase";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "longGame";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "state";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "showSupply";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerIndex";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerCount";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "i";
                                                      }))()())())("game_state")(activeState))(logErrorToChat);
                                                  });
                                              };
                                              var loadGame = function (key) {
                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                                                      return v.dominationConfig;
                                                  }))(function (v) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Phase.encodeJsonPhase)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Bonus.encodeJsonBonus))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_Choice.encodeJsonChoice))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "toDiscard";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "hand";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "discard";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "deck";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "choices";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buying";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "bonuses";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "atPlay";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Result.encodeJsonResult))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "count";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "card";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Actions.encodeJsonActions)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Buys.encodeJsonBuys)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Domination_Data_Reaction.encodeJsonReaction))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCommand)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Target.encodeJsonTarget)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Domination_Data_CardType.encodeJsonCardType))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Points.encodeJsonPoints)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "turn";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "trash";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "supply";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "result";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "players";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "phase";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "longGame";
                                                      }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "state";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "showSupply";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerIndex";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerCount";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "i";
                                                      }))())())(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Phase.decodeJsonPhase))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Bonus.decodeJsonBonus)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_Choice.decodeJsonChoice)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "toDiscard";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "hand";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "discard";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "deck";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "choices";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buying";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "bonuses";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "atPlay";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Result.decodeJsonResult))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "count";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "card";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Actions.decodeJsonActions))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Buys.decodeJsonBuys))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Domination_Data_Reaction.decodeJsonReaction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCommand))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Target.decodeJsonTarget))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "target";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "description";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "command";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Domination_Data_CardType.decodeJsonCardType)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Points.decodeJsonPoints))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "victoryPoints";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "types";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "treasure";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "special";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "reaction";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "name";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cost";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cards";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "buys";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "actions";
                                                      }))()())())))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "turn";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "trash";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "supply";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "result";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "players";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "phase";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "longGame";
                                                      }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "state";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "showSupply";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerIndex";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "playerCount";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "i";
                                                      }))()())())(key))(function (mbGame) {
                                                          if (mbGame instanceof Data_Either.Left) {
                                                              return Domination_Capability_Log.error(Domination_Capability_Log.logHalogenM(dictLog))(mbGame.value0);
                                                          };
                                                          if (mbGame instanceof Data_Either.Right) {
                                                              var newActiveState = Domination_UI_Domination_ActiveState.upgrade(Data_Lens_Setter.set(Domination_UI_Domination_ActiveState["_playerIndex"](Data_Profunctor_Strong.strongFn))(v.nextPlayerIndex)(mbGame.value0));
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(queryGame(Domination_UI_Domination.LoadActiveState.create(newActiveState)))(function () {
                                                                  return sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.GameMessage({
                                                                      state: mbGame.value0.state,
                                                                      i: mbGame.value0.i,
                                                                      playMade: Data_Maybe.Nothing.value
                                                                  }));
                                                              });
                                                          };
                                                          throw new Error("Failed pattern match at Main (line 508, column 7 - line 519, column 14): " + [ mbGame.constructor.name ]);
                                                      });
                                                  });
                                              };
                                              return function (v) {
                                                  if (v instanceof AppAction.Initialize) {
                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize"))(function () {
                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString)(uuidKey))(function (eUuid) {
                                                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                  if (eUuid instanceof Data_Either.Left) {
                                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: no existing uuid found, generating a new one." + (" error: " + eUuid.value0)))(function () {
                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_GenUuid.genUuid(Domination_Capability_GenUuid.genUuidHalogenM(dictGenUuid)))(function (uuid) {
                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString)(uuidKey)(uuid))(logErrorToChat))(function () {
                                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Show.show(Data_Show.showString)(uuid));
                                                                              });
                                                                          });
                                                                      });
                                                                  };
                                                                  if (eUuid instanceof Data_Either.Right) {
                                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(eUuid.value0);
                                                                  };
                                                                  throw new Error("Failed pattern match at Main (line 211, column 13 - line 218, column 30): " + [ eUuid.constructor.name ]);
                                                              })())(function (uuid) {
                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString)(usernameKey))(function (eUsername) {
                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                          if (eUsername instanceof Data_Either.Left) {
                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: no existing username found, using default." + (" error: " + eUsername.value0)))(function () {
                                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(Data_Maybe.fromMaybe(":)"))(Domination_Capability_Random.randomElement(Domination_Capability_Random.randomHalogenM(dictRandom))(Emojis.emojis)))(function (emoji) {
                                                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(emoji + ("lurker" + emoji));
                                                                                  });
                                                                              });
                                                                          };
                                                                          if (eUsername instanceof Data_Either.Right) {
                                                                              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(eUsername.value0);
                                                                          };
                                                                          throw new Error("Failed pattern match at Main (line 221, column 17 - line 227, column 24): " + [ eUsername.constructor.name ]);
                                                                      })())(function (username) {
                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                                              return v1.roomCode;
                                                                          }))(function (roomCode) {
                                                                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCardSpec)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                                                  return "selected";
                                                                              }))())(new Data_Symbol.IsSymbol(function () {
                                                                                  return "cardSpec";
                                                                              }))())()))(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCardSpec))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                                                  return "selected";
                                                                              }))()())(new Data_Symbol.IsSymbol(function () {
                                                                                  return "cardSpec";
                                                                              }))()())()))("kingdom"))(function (eKingdom) {
                                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                                      if (eKingdom instanceof Data_Either.Left) {
                                                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: Failed to load kingdom. Falling back to default." + ("Error: " + eKingdom.value0)))(function () {
                                                                                              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(AppState.defaultKingdom);
                                                                                          });
                                                                                      };
                                                                                      if (eKingdom instanceof Data_Either.Right) {
                                                                                          var $109 = Data_Array.length(eKingdom.value0) === Data_Array.length(AppState.defaultKingdom);
                                                                                          if ($109) {
                                                                                              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Functor.map(Data_Functor.functorArray)(AppState.upgradeSelection)(eKingdom.value0));
                                                                                          };
                                                                                          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(AppState.defaultKingdom);
                                                                                      };
                                                                                      throw new Error("Failed pattern match at Main (line 232, column 16 - line 240, column 33): " + [ eKingdom.constructor.name ]);
                                                                                  })())(function (kingdom) {
                                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Decode_Class.decodeJsonInt)("player_index"))(function (ePlayerIndex) {
                                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                                              if (ePlayerIndex instanceof Data_Either.Left) {
                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: Failed to load playerIndex. Falling back to default." + ("Error: " + ePlayerIndex.value0)))(function () {
                                                                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(0);
                                                                                                  });
                                                                                              };
                                                                                              if (ePlayerIndex instanceof Data_Either.Right) {
                                                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(ePlayerIndex.value0);
                                                                                              };
                                                                                              throw new Error("Failed pattern match at Main (line 243, column 24 - line 248, column 24): " + [ ePlayerIndex.constructor.name ]);
                                                                                          })())(function (nextPlayerIndex) {
                                                                                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Decode_Class.decodeJsonInt)("player_count"))(function (ePlayerCount) {
                                                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                                                      if (ePlayerCount instanceof Data_Either.Left) {
                                                                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: Failed to load playerCount. Falling back to default." + ("Error: " + ePlayerCount.value0)))(function () {
                                                                                                              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(1);
                                                                                                          });
                                                                                                      };
                                                                                                      if (ePlayerCount instanceof Data_Either.Right) {
                                                                                                          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(ePlayerCount.value0);
                                                                                                      };
                                                                                                      throw new Error("Failed pattern match at Main (line 251, column 24 - line 256, column 24): " + [ ePlayerCount.constructor.name ]);
                                                                                                  })())(function (nextPlayerCount) {
                                                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonArray(Message.encodeJsonRemoteMessage))(Data_Argonaut_Decode_Class.decodeArray(Message.decodeJsonRemoteMessage))(chatKey))(function (eMessages) {
                                                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                                                              if (eMessages instanceof Data_Either.Left) {
                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: Failed to load messages. Error: " + eMessages.value0))(function () {
                                                                                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)([  ]);
                                                                                                                  });
                                                                                                              };
                                                                                                              if (eMessages instanceof Data_Either.Right) {
                                                                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(eMessages.value0);
                                                                                                              };
                                                                                                              throw new Error("Failed pattern match at Main (line 259, column 17 - line 263, column 24): " + [ eMessages.constructor.name ]);
                                                                                                          })())(function (messages) {
                                                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: modify a bunch of stuff..."))(function () {
                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                                                                                                      var $185 = Data_Lens_Setter.set(AppState["_messages"](Data_Profunctor_Strong.strongFn))(messages);
                                                                                                                      var $186 = Data_Lens_Setter.set(AppState["_maybeAudioContext"](Data_Profunctor_Strong.strongFn))(new Data_Maybe.Just(audioContext));
                                                                                                                      var $187 = Data_Lens_Setter.set((function () {
                                                                                                                          var $194 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                                                                          var $195 = AppState["_nextPlayerCount"](Data_Profunctor_Strong.strongFn);
                                                                                                                          return function ($196) {
                                                                                                                              return $194($195($196));
                                                                                                                          };
                                                                                                                      })())(nextPlayerCount);
                                                                                                                      var $188 = Data_Lens_Setter.set((function () {
                                                                                                                          var $197 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                                                                          var $198 = AppState["_nextPlayerIndex"](Data_Profunctor_Strong.strongFn);
                                                                                                                          return function ($199) {
                                                                                                                              return $197($198($199));
                                                                                                                          };
                                                                                                                      })())(nextPlayerIndex);
                                                                                                                      var $189 = Data_Lens_Setter.set((function () {
                                                                                                                          var $200 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                                                                          var $201 = AppState["_kingdom"](Data_Profunctor_Strong.strongFn);
                                                                                                                          return function ($202) {
                                                                                                                              return $200($201($202));
                                                                                                                          };
                                                                                                                      })())(kingdom);
                                                                                                                      var $190 = Data_Lens_Setter.over(AppState["_usernames"](Data_Profunctor_Strong.strongFn))(Data_HashMap.insert(Data_Hashable.hashableString)(uuid)(username));
                                                                                                                      var $191 = Data_Lens_Setter.set(AppState["_username"](Data_Profunctor_Strong.strongFn))(username);
                                                                                                                      var $192 = Data_Lens_Setter.set(AppState["_id"](Data_Profunctor_Strong.strongFn))(uuid);
                                                                                                                      return function ($193) {
                                                                                                                          return $185($186($187($188($189($190($191($192($193))))))));
                                                                                                                      };
                                                                                                                  })()))(function () {
                                                                                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: done modifying a bunch of stuff..."))(function () {
                                                                                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: load game..."))(function () {
                                                                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(loadGame("game_state"))(function () {
                                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: done loading game..."))(function () {
                                                                                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.load(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString)(serverUrlKey))(function (eServerUrl) {
                                                                                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                                                                                                              if (eServerUrl instanceof Data_Either.Left) {
                                                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: no existing server URL found, using default." + (" error: " + eServerUrl.value0)))(function () {
                                                                                                                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(AppState.defaultServerUrl);
                                                                                                                                                  });
                                                                                                                                              };
                                                                                                                                              if (eServerUrl instanceof Data_Either.Right) {
                                                                                                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(eServerUrl.value0);
                                                                                                                                              };
                                                                                                                                              throw new Error("Failed pattern match at Main (line 281, column 18 - line 286, column 24): " + [ eServerUrl.constructor.name ]);
                                                                                                                                          })())(function (serverUrl) {
                                                                                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: server URL: " + serverUrl))(function () {
                                                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_serverUrl"](Data_Profunctor_Strong.strongFn))(serverUrl)))(function () {
                                                                                                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Broadcast.maybeCreateBroadcaster(Domination_Capability_Log.logHalogenM(dictLog))(Domination_Capability_Broadcast.broadcastHalogenM(dictBroadcast))(roomCode)(remoteMessageTarget)(serverUrl))(function (maybeBroadcaster) {
                                                                                                                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: broadcaster: " + Data_Show.show(Data_Maybe.showMaybe(Domination_Capability_Broadcast_WebSocket.showWebSocketBroadcaster))(maybeBroadcaster)))(function () {
                                                                                                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_maybeBroadcaster"](Data_Profunctor_Strong.strongFn))(maybeBroadcaster)))(function () {
                                                                                                                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                                                                                                                                      return v1.maybeBroadcaster;
                                                                                                                                                                  }))(function (broadcaster) {
                                                                                                                                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Initialize: broadcaster: " + Data_Show.show(Data_Maybe.showMaybe(Domination_Capability_Broadcast_WebSocket.showWebSocketBroadcaster))(broadcaster)))(function () {
                                                                                                                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Clock.now(Domination_Capability_Clock.clockHalogenM(dictClock)))(function (timestamp) {
                                                                                                                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.JoinMessage({
                                                                                                                                                                                  clientId: uuid,
                                                                                                                                                                                  timestamp: timestamp
                                                                                                                                                                              })))(function () {
                                                                                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.UsernameMessage({
                                                                                                                                                                                      username: username,
                                                                                                                                                                                      id: uuid
                                                                                                                                                                                  })))(function () {
                                                                                                                                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                                                                                                                                                          return v1.heartbeatInterval;
                                                                                                                                                                                      }))(function (interval) {
                                                                                                                                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bindFlipped(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.subscribe)(Domination_Capability_Timer.createTimer(Domination_Capability_Timer.timerHalogenM(dictTimer))({
                                                                                                                                                                                              interval: interval
                                                                                                                                                                                          })(AppAction.HeartbeatTick.value)))(function () {
                                                                                                                                                                                              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Dom.window(Domination_Capability_Dom.domHalogenM(dictDom)))(function (w) {
                                                                                                                                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM["subscribe'"](function (v1) {
                                                                                                                                                                                                      return Halogen_Query_Event.eventListener(Web_HTML_Event_BeforeUnloadEvent_EventTypes.beforeunload)(Web_HTML_Window.toEventTarget(w))(function (v2) {
                                                                                                                                                                                                          return new Data_Maybe.Just(AppAction.Finalize.value);
                                                                                                                                                                                                      });
                                                                                                                                                                                                  }))(function () {
                                                                                                                                                                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM["subscribe'"](function (v1) {
                                                                                                                                                                                                          return Halogen_Query_Event.eventListener("unload")(Web_HTML_Window.toEventTarget(w))(function (v2) {
                                                                                                                                                                                                              return new Data_Maybe.Just(AppAction.Finalize.value);
                                                                                                                                                                                                          });
                                                                                                                                                                                                      }))(function () {
                                                                                                                                                                                                          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                                                                                                                                                                      });
                                                                                                                                                                                                  });
                                                                                                                                                                                              });
                                                                                                                                                                                          });
                                                                                                                                                                                      });
                                                                                                                                                                                  });
                                                                                                                                                                              });
                                                                                                                                                                          });
                                                                                                                                                                      });
                                                                                                                                                                  });
                                                                                                                                                              });
                                                                                                                                                          });
                                                                                                                                                      });
                                                                                                                                                  });
                                                                                                                                              });
                                                                                                                                          });
                                                                                                                                      });
                                                                                                                                  });
                                                                                                                              });
                                                                                                                          });
                                                                                                                      });
                                                                                                                  });
                                                                                                              });
                                                                                                          });
                                                                                                      });
                                                                                                  });
                                                                                              });
                                                                                          });
                                                                                      });
                                                                                  });
                                                                              });
                                                                          });
                                                                      });
                                                                  });
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.Finalize) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                          return v1.id;
                                                      }))(function (clientId) {
                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Clock.now(Domination_Capability_Clock.clockHalogenM(dictClock)))(function (timestamp) {
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.LeaveMessage({
                                                                  clientId: clientId,
                                                                  timestamp: timestamp
                                                              })))(function () {
                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.ToggleMenu) {
                                                      return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over(AppState["_showMenu"](Data_Profunctor_Strong.strongFn))(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean)));
                                                  };
                                                  if (v instanceof AppAction.WritePlayerIndex) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                                                          var newPlayerIndex = Data_Ord.max(Data_Ord.ordInt)(v.value0)(0);
                                                          var newPlayerCount = Data_Ord.max(Data_Ord.ordInt)(v.value0 + 1 | 0)(v1.dominationConfig.nextPlayerCount);
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                                              var $203 = Data_Lens_Setter.set((function () {
                                                                  var $206 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                  var $207 = AppState["_nextPlayerCount"](Data_Profunctor_Strong.strongFn);
                                                                  return function ($208) {
                                                                      return $206($207($208));
                                                                  };
                                                              })())(newPlayerCount);
                                                              var $204 = Data_Lens_Setter.set((function () {
                                                                  var $209 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                  var $210 = AppState["_nextPlayerIndex"](Data_Profunctor_Strong.strongFn);
                                                                  return function ($211) {
                                                                      return $209($210($211));
                                                                  };
                                                              })())(newPlayerIndex);
                                                              return function ($205) {
                                                                  return $203($204($205));
                                                              };
                                                          })()))(function () {
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Decode_Class.decodeJsonInt)("player_index")(newPlayerIndex))(logErrorToChat))(function () {
                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Decode_Class.decodeJsonInt)("player_count")(newPlayerCount))(logErrorToChat);
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.WritePlayerCount) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                          return v1.dominationConfig;
                                                      }))(function (v1) {
                                                          var newPlayerIndex = Data_Ord.min(Data_Ord.ordInt)(v.value0 - 1 | 0)(v1.nextPlayerIndex);
                                                          var newPlayerCount = Data_Ord.max(Data_Ord.ordInt)(v.value0)(1);
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                                              var $212 = Data_Lens_Setter.set((function () {
                                                                  var $215 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                  var $216 = AppState["_nextPlayerIndex"](Data_Profunctor_Strong.strongFn);
                                                                  return function ($217) {
                                                                      return $215($216($217));
                                                                  };
                                                              })())(newPlayerIndex);
                                                              var $213 = Data_Lens_Setter.set((function () {
                                                                  var $218 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                  var $219 = AppState["_nextPlayerCount"](Data_Profunctor_Strong.strongFn);
                                                                  return function ($220) {
                                                                      return $218($219($220));
                                                                  };
                                                              })())(newPlayerCount);
                                                              return function ($214) {
                                                                  return $212($213($214));
                                                              };
                                                          })()))(function () {
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Decode_Class.decodeJsonInt)("player_index")(newPlayerIndex))(logErrorToChat))(function () {
                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Decode_Class.decodeJsonInt)("player_count")(newPlayerCount))(logErrorToChat);
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.RandomizeKingdom) {
                                                      var selectIfElement = function (keepers) {
                                                          return function (v1) {
                                                              return {
                                                                  cardSpec: v1.cardSpec,
                                                                  selected: Data_Array.elem(Domination_Data_Card.eqCardSpec)(v1.cardSpec)(keepers)
                                                              };
                                                          };
                                                      };
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                          return v1.dominationConfig;
                                                      }))(function (v1) {
                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Random.shuffle(Domination_Capability_Random.randomHalogenM(dictRandom))(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                                                              return "selected";
                                                          }))(Data_Eq.eqBoolean))()(new Data_Symbol.IsSymbol(function () {
                                                              return "cardSpec";
                                                          }))(Domination_Data_Card.eqCardSpec)))(v1.kingdom))(function (shuffledKingdom) {
                                                              var cardsToKeep = Data_Array.take(16)(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                                                                  return v2.cardSpec;
                                                              })(shuffledKingdom));
                                                              var newKingdom = Data_Functor.map(Data_Functor.functorArray)(selectIfElement(cardsToKeep))(v1.kingdom);
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set((function () {
                                                                  var $221 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                                  var $222 = AppState["_kingdom"](Data_Profunctor_Strong.strongFn);
                                                                  return function ($223) {
                                                                      return $221($222($223));
                                                                  };
                                                              })())(newKingdom)))(function () {
                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCardSpec)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                                      return "selected";
                                                                  }))())(new Data_Symbol.IsSymbol(function () {
                                                                      return "cardSpec";
                                                                  }))())()))(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCardSpec))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                                      return "selected";
                                                                  }))()())(new Data_Symbol.IsSymbol(function () {
                                                                      return "cardSpec";
                                                                  }))()())()))("kingdom")(newKingdom))(logErrorToChat);
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.ChooseKingdom) {
                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Domination_Data_Card.encodeJsonCardSpec)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "selected";
                                                      }))())(new Data_Symbol.IsSymbol(function () {
                                                          return "cardSpec";
                                                      }))())()))(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Domination_Data_Card.decodeJsonCardSpec))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                                                          return "selected";
                                                      }))()())(new Data_Symbol.IsSymbol(function () {
                                                          return "cardSpec";
                                                      }))()())()))("kingdom")(v.value0))(logErrorToChat))(function () {
                                                          return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set((function () {
                                                              var $224 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                              var $225 = AppState["_kingdom"](Data_Profunctor_Strong.strongFn);
                                                              return function ($226) {
                                                                  return $224($225($226));
                                                              };
                                                          })())(v.value0));
                                                      });
                                                  };
                                                  if (v instanceof AppAction.ToggleLongGame) {
                                                      return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over((function () {
                                                          var $227 = AppState["_dominationConfig"](Data_Profunctor_Strong.strongFn);
                                                          var $228 = AppState["_longGame"](Data_Profunctor_Strong.strongFn);
                                                          return function ($229) {
                                                              return $227($228($229));
                                                          };
                                                      })())(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean)));
                                                  };
                                                  if (v instanceof AppAction.DoNothing) {
                                                      return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                  };
                                                  if (v instanceof AppAction.StartNewGame) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                          return v1.dominationConfig;
                                                      }))(function (config) {
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(queryGame(Domination_UI_Domination.StartNewGameRequest.create(config)))(function () {
                                                              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_showMenu"](Data_Profunctor_Strong.strongFn))(false));
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.LoadGameRequest) {
                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(loadGame("game_state"))(function () {
                                                          return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_showMenu"](Data_Profunctor_Strong.strongFn))(false));
                                                      });
                                                  };
                                                  if (v instanceof AppAction.WriteServerUrl) {
                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString)(serverUrlKey)(v.value0))(logErrorToChat))(function () {
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("saving server URL: " + v.value0))(function () {
                                                              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_serverUrl"](Data_Profunctor_Strong.strongFn))(v.value0));
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.WriteUsername) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Storage.save(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString)(usernameKey)(v.value0))(logErrorToChat))(function () {
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                                                  var $230 = Data_Lens_Setter.set(AppState["_username"](Data_Profunctor_Strong.strongFn))(v.value0);
                                                                  var $231 = Data_Lens_Setter.over(AppState["_usernames"](Data_Profunctor_Strong.strongFn))(Data_HashMap.insert(Data_Hashable.hashableString)(v1.id)(v.value0));
                                                                  return function ($232) {
                                                                      return $230($231($232));
                                                                  };
                                                              })()))(function () {
                                                                  return sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.UsernameMessage({
                                                                      username: v.value0,
                                                                      id: v1.id
                                                                  }));
                                                              });
                                                          });
                                                      });
                                                  };
                                                  if (v instanceof AppAction.Write) {
                                                      return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(v.value0(Data_Profunctor_Strong.strongFn))(v.value1));
                                                  };
                                                  if (v instanceof AppAction.SendMessage) {
                                                      return sendChatMessage;
                                                  };
                                                  if (v instanceof AppAction.ReceiveRemoteMessage) {
                                                      var detail = FFI.detail(v.value0);
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_WireCodec.readWire(Domination_Capability_WireCodec.wireCodecHalogenM(dictWireCodec))(Data_ArrayBuffer_Class.decodeArrayBufferTuple(Data_ArrayBuffer_Class.decodeArrayBufferString)(Message.decodeArrayBuffeWireMessage)(Data_ArrayBuffer_Class.dynamicByteLengthString)(Message.dynamicByteLengthWireMessage))(detail))(function (v1) {
                                                          var eMessage = Data_Functor.map(Data_Either.functorEither)(Data_Bifunctor.rmap(Data_Bifunctor.bifunctorTuple)(Data_Lens_Prism.review(Message["_toWire"](Data_Lens_Internal_Tagged.taggedProfunctor))))(v1);
                                                          if (eMessage instanceof Data_Either.Left) {
                                                              return Domination_Capability_Log.error(Domination_Capability_Log.logHalogenM(dictLog))("problem receiving message: " + eMessage.value0);
                                                          };
                                                          if (eMessage instanceof Data_Either.Right) {
                                                              if (eMessage.value0.value1 instanceof Message.UsernameMessage) {
                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("username incoming: " + eMessage.value0.value1.value0.username))(function () {
                                                                      return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over(AppState["_usernames"](Data_Profunctor_Strong.strongFn))(Data_HashMap.insert(Data_Hashable.hashableString)(eMessage.value0.value1.value0.id)(eMessage.value0.value1.value0.username)));
                                                                  });
                                                              };
                                                              if (eMessage.value0.value1 instanceof Message.ChatMessage) {
                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                                                      var $233 = Data_Lens_Setter.over(AppState["_messages"](Data_Profunctor_Strong.strongFn))(Data_Array.take(250));
                                                                      var $234 = Util.prependOver(function (dictStrong) {
                                                                          return AppState["_messages"](dictStrong);
                                                                      })(eMessage.value0.value1);
                                                                      return function ($235) {
                                                                          return $233($234($235));
                                                                      };
                                                                  })()))(function () {
                                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(saveChat(Halogen_Query_HalogenM.monadHalogenM)(Halogen_Query_HalogenM.monadStateHalogenM)(Domination_Capability_Storage.storageHalogenM(dictStorage))(Data_Argonaut_Encode_Class.encodeJsonArray(Message.encodeJsonRemoteMessage))(Data_Argonaut_Decode_Class.decodeArray(Message.decodeJsonRemoteMessage))(Domination_Capability_Log.logHalogenM(dictLog)))(logErrorToChat))(function () {
                                                                          var $149 = eMessage.value0.value1.value0.message === "PING";
                                                                          if ($149) {
                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_message"](Data_Profunctor_Strong.strongFn))("PONG")))(function () {
                                                                                  return sendChatMessage;
                                                                              });
                                                                          };
                                                                          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                                      });
                                                                  });
                                                              };
                                                              if (eMessage.value0.value1 instanceof Message.GameMessage) {
                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(queryGame(Domination_UI_Domination.ReceiveGame.create({
                                                                      i: eMessage.value0.value1.value0.i,
                                                                      state: eMessage.value0.value1.value0.state
                                                                  })))(function () {
                                                                      if (eMessage.value0.value1.value0.playMade instanceof Data_Maybe.Just) {
                                                                          return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Util.prependOver(function (dictStrong) {
                                                                              return AppState["_messages"](dictStrong);
                                                                          })(new Message.PlayMadeMessage(eMessage.value0.value1.value0.playMade.value0)));
                                                                      };
                                                                      if (eMessage.value0.value1.value0.playMade instanceof Data_Maybe.Nothing) {
                                                                          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                                      };
                                                                      throw new Error("Failed pattern match at Main (line 430, column 13 - line 433, column 35): " + [ eMessage.value0.value1.value0.playMade.constructor.name ]);
                                                                  });
                                                              };
                                                              if (eMessage.value0.value1 instanceof Message.PlayMadeMessage) {
                                                                  return Domination_Capability_Log.error(Domination_Capability_Log.logHalogenM(dictLog))("PlayMadeMessage should not be called");
                                                              };
                                                              if (eMessage.value0.value1 instanceof Message.JoinMessage) {
                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Clock.now(Domination_Capability_Clock.clockHalogenM(dictClock)))(function (timestamp) {
                                                                      var clientInfo = {
                                                                          timestamp: timestamp,
                                                                          clientId: eMessage.value0.value1.value0.clientId
                                                                      };
                                                                      return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over(AppState["_connectedClients"](Data_Profunctor_Strong.strongFn))(Data_HashMap.insert(Data_Hashable.hashableString)(eMessage.value0.value1.value0.clientId)(clientInfo))))(function () {
                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                                                              return v2.connectedClients;
                                                                          }))(function (clients) {
                                                                              var count = Data_HashMap.size(clients);
                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_connectionCount"](Data_Profunctor_Strong.strongFn))(count)))(function () {
                                                                                  return Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Client joined: " + (eMessage.value0.value1.value0.clientId + (", total clients: " + Data_Show.show(Data_Show.showInt)(count))));
                                                                              });
                                                                          });
                                                                      });
                                                                  });
                                                              };
                                                              if (eMessage.value0.value1 instanceof Message.LeaveMessage) {
                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over(AppState["_connectedClients"](Data_Profunctor_Strong.strongFn))(Data_HashMap["delete"](Data_Hashable.hashableString)(eMessage.value0.value1.value0.clientId))))(function () {
                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                                                          return v2.connectedClients;
                                                                      }))(function (clients) {
                                                                          var count = Data_HashMap.size(clients);
                                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_connectionCount"](Data_Profunctor_Strong.strongFn))(count)))(function () {
                                                                              return Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Client left: " + (eMessage.value0.value1.value0.clientId + (", total clients: " + Data_Show.show(Data_Show.showInt)(count))));
                                                                          });
                                                                      });
                                                                  });
                                                              };
                                                              if (eMessage.value0.value1 instanceof Message.HeartbeatMessage) {
                                                                  return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Clock.now(Domination_Capability_Clock.clockHalogenM(dictClock)))(function (timestamp) {
                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                                                          return v2.connectedClients;
                                                                      }))(function (clients) {
                                                                          var originalClientCount = Data_HashMap.size(clients);
                                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                                                              return v2.heartbeatTimeout;
                                                                          }))(function (timeout) {
                                                                              var activeClients = Data_HashMap.filter(function (info) {
                                                                                  return !((timestamp - info.timestamp | 0) > timeout);
                                                                              })(clients);
                                                                              var activeClientCount = Data_HashMap.size(activeClients);
                                                                              var updatedClients = Data_HashMap.insert(Data_Hashable.hashableString)(eMessage.value0.value1.value0.clientId)({
                                                                                  timestamp: timestamp,
                                                                                  clientId: eMessage.value0.value1.value0.clientId
                                                                              })(activeClients);
                                                                              var updatedClientCount = Data_HashMap.size(updatedClients);
                                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_connectedClients"](Data_Profunctor_Strong.strongFn))(updatedClients)))(function () {
                                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(AppState["_connectionCount"](Data_Profunctor_Strong.strongFn))(updatedClientCount)))(function () {
                                                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v2) {
                                                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.UsernameMessage({
                                                                                              username: v2.username,
                                                                                              id: v2.id
                                                                                          })))(function () {
                                                                                              return Domination_Capability_Log.log(Domination_Capability_Log.logHalogenM(dictLog))("Heartbeat from clientId(" + (eMessage.value0.value1.value0.clientId + (")" + ("; Clients before cleanup: " + (Data_Show.show(Data_Show.showInt)(originalClientCount) + ("; Clients after cleanup: " + (Data_Show.show(Data_Show.showInt)(activeClientCount) + ("; Clients after new heartbeat: " + Data_Show.show(Data_Show.showInt)(updatedClientCount)))))))));
                                                                                          });
                                                                                      });
                                                                                  });
                                                                              });
                                                                          });
                                                                      });
                                                                  });
                                                              };
                                                              throw new Error("Failed pattern match at Main (line 410, column 9 - line 480, column 78): " + [ eMessage.value0.value1.constructor.name ]);
                                                          };
                                                          throw new Error("Failed pattern match at Main (line 407, column 5 - line 480, column 78): " + [ eMessage.constructor.name ]);
                                                      });
                                                  };
                                                  if (v instanceof AppAction.HandleGameEvent) {
                                                      if (v.value0 instanceof Domination_UI_Domination_GameEvent.NewState) {
                                                          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                              if (v.value0.value1 instanceof Data_Maybe.Just) {
                                                                  return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Util.prependOver(function (dictStrong) {
                                                                      return AppState["_messages"](dictStrong);
                                                                  })(new Message.PlayMadeMessage(v.value0.value1.value0)));
                                                              };
                                                              if (v.value0.value1 instanceof Data_Maybe.Nothing) {
                                                                  return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                                              };
                                                              throw new Error("Failed pattern match at Main (line 483, column 7 - line 486, column 29): " + [ v.value0.value1.constructor.name ]);
                                                          })())(function () {
                                                              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(queryGame(Domination_UI_Domination.LoadActiveState.create(v.value0.value0)))(function () {
                                                                  return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.GameMessage({
                                                                      state: v.value0.value0.state,
                                                                      i: v.value0.value0.i,
                                                                      playMade: v.value0.value1
                                                                  })))(function () {
                                                                      return saveGame(v.value0.value0);
                                                                  });
                                                              });
                                                          });
                                                      };
                                                      if (v.value0 instanceof Domination_UI_Domination_GameEvent.SaveGame) {
                                                          return saveGame(v.value0.value0);
                                                      };
                                                      if (v.value0 instanceof Domination_UI_Domination_GameEvent.Undo) {
                                                          var saveNumber = Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v.value0.value0.i - 1 | 0)(10);
                                                          var key = "game_state_" + Data_Show.show(Data_Show.showInt)(saveNumber);
                                                          return loadGame(key);
                                                      };
                                                      throw new Error("Failed pattern match at Main (line 481, column 32 - line 499, column 19): " + [ v.value0.constructor.name ]);
                                                  };
                                                  if (v instanceof AppAction.HeartbeatTick) {
                                                      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                          return v1.id;
                                                      }))(function (clientId) {
                                                          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Domination_Capability_Clock.now(Domination_Capability_Clock.clockHalogenM(dictClock)))(function (timestamp) {
                                                              return sendMessage(dictLog)(dictBroadcast)(dictWireCodec)(new Message.HeartbeatMessage({
                                                                  clientId: clientId,
                                                                  timestamp: timestamp
                                                              }));
                                                          });
                                                      });
                                                  };
                                                  throw new Error("Failed pattern match at Main (line 207, column 29 - line 503, column 59): " + [ v.constructor.name ]);
                                              };
                                          };
                                      };
                                  };
                              };
                          };
                      };
                  };
              };
          };
      };
  };
  var component = function (dictStorage) {
      return function (dictDom) {
          return function (dictLog) {
              return function (dictRandom) {
                  return function (dictClock) {
                      return function (dictGenUuid) {
                          return function (dictBroadcast) {
                              return function (dictWireCodec) {
                                  return function (dictAudio) {
                                      return function (dictTimer) {
                                          return function (audioContext) {
                                              var initialState = function (v) {
                                                  return AppState.newApp;
                                              };
                                              var $$eval = Halogen_Component.mkEval({
                                                  handleAction: handleAction(dictAudio)(dictStorage)(dictLog)(dictGenUuid)(dictRandom)(dictClock)(dictBroadcast)(dictWireCodec)(dictTimer)(dictDom)(audioContext),
                                                  handleQuery: Halogen_Component.defaultEval.handleQuery,
                                                  receive: Halogen_Component.defaultEval.receive,
                                                  initialize: new Data_Maybe.Just(AppAction.Initialize.value),
                                                  finalize: new Data_Maybe.Just(AppAction.Finalize.value)
                                              });
                                              return Halogen_Component.mkComponent({
                                                  "eval": $$eval,
                                                  initialState: initialState,
                                                  render: render(dictLog)(dictAudio)(dictStorage)(dictDom)(dictRandom)(audioContext)
                                              });
                                          };
                                      };
                                  };
                              };
                          };
                      };
                  };
              };
          };
      };
  };
  var root = function (audioContext) {
      return Halogen_Component.hoist(Effect_Aff.functorAff)(Domination_AppM.runAppM(Domination_Env.env))(component(Domination_Capability_Storage.storageAppM)(Domination_Capability_Dom.domAppM)(Domination_Capability_Log.logAppM)(Domination_Capability_Random.randomAppM)(Domination_Capability_Clock.clockAppM)(Domination_Capability_GenUuid.genUuidAppM)(Domination_Capability_Broadcast.webSocketBroadcasterAppM)(Domination_Capability_WireCodec.wireCodecAppM)(Domination_Capability_Audio.audioAppM)(Domination_Capability_Timer.timerAppM)(audioContext));
  };
  var main = Effect_Aff.launchAff_(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(FFI.registerServiceWorker))(function () {
      return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Domination_Capability_Audio.runAudioM(Domination_Capability_Audio.newAudioContext(Domination_Capability_Audio.audioAudioM))))(function (audioContext) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitLoad)(function () {
              return Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (body) {
                  return Halogen_VDom_Driver.runUI(root(audioContext))(Data_Unit.unit)(body);
              });
          });
      });
  }));
  exports["remoteMessageTarget"] = remoteMessageTarget;
  exports["uuidKey"] = uuidKey;
  exports["serverUrlKey"] = serverUrlKey;
  exports["usernameKey"] = usernameKey;
  exports["chatKey"] = chatKey;
  exports["main"] = main;
  exports["root"] = root;
  exports["component"] = component;
  exports["render"] = render;
  exports["renderSettingsButton"] = renderSettingsButton;
  exports["saveChat"] = saveChat;
  exports["handleAction"] = handleAction;
  exports["sendMessage"] = sendMessage;
})(PS);
PS["Main"].main();